(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[210],{

/***/ 3066:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(8764)["lW"];
/* provided dependency */ var process = __webpack_require__(3454);
(function (global, factory) {
     true ? factory(exports, __webpack_require__(7294), __webpack_require__(3935)) :
    0;
})(this, (function (exports, React, reactDom) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) {
            Object.keys(e).forEach(function (k) {
                if (k !== 'default') {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function () { return e[k]; }
                    });
                }
            });
        }
        n["default"] = e;
        return Object.freeze(n);
    }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var React__namespace = /*#__PURE__*/_interopNamespace(React);

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
      }
      return t;
    }

    function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) {return value instanceof P ? value : new P(function (resolve) {resolve(value);});}
      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {try {step(generator.next(value));} catch (e) {reject(e);}}
        function rejected(value) {try {step(generator["throw"](value));} catch (e) {reject(e);}}
        function step(result) {result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);}
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    }

    function __generator(thisArg, body) {
      var _ = { label: 0, sent: function () {if (t[0] & 1) throw t[1];return t[1];}, trys: [], ops: [] },f,y,t,g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {return this;}), g;
      function verb(n) {return function (v) {return step([n, v]);};}
      function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:case 1:t = op;break;
            case 4:_.label++;return { value: op[1], done: false };
            case 5:_.label++;y = op[1];op = [0];continue;
            case 7:op = _.ops.pop();_.trys.pop();continue;
            default:
              if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {_ = 0;continue;}
              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {_.label = op[1];break;}
              if (op[0] === 6 && _.label < t[1]) {_.label = t[1];t = op;break;}
              if (t && _.label < t[2]) {_.label = t[2];_.ops.push(op);break;}
              if (t[2]) _.ops.pop();
              _.trys.pop();continue;}

          op = body.call(thisArg, _);
        } catch (e) {op = [6, e];y = 0;} finally {f = t = 0;}
        if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
      }
    }

    function __spreadArray(to, from, pack) {
      if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
        }
      }
      return to.concat(ar || Array.prototype.slice.call(from));
    }

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

    function getDefaultExportFromCjs (x) {
    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }

    function getAugmentedNamespace(n) {
      var f = n.default;
    	if (typeof f == "function") {
    		var a = function () {
    			return f.apply(this, arguments);
    		};
    		a.prototype = f.prototype;
      } else a = {};
      Object.defineProperty(a, '__esModule', {value: true});
    	Object.keys(n).forEach(function (k) {
    		var d = Object.getOwnPropertyDescriptor(n, k);
    		Object.defineProperty(a, k, d.get ? d : {
    			enumerable: true,
    			get: function () {
    				return n[k];
    			}
    		});
    	});
    	return a;
    }

    var jsxRuntime = {exports: {}};

    var reactJsxRuntime_production_min = {};

    /**
     * @license React
     * react-jsx-runtime.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var hasRequiredReactJsxRuntime_production_min;

    function requireReactJsxRuntime_production_min() {
      if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
      hasRequiredReactJsxRuntime_production_min = 1;
    var f = React__default["default"],k = Symbol.for("react.element"),l = Symbol.for("react.fragment"),m = Object.prototype.hasOwnProperty,n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p = { key: !0, ref: !0, __self: !0, __source: !0 };
      function q(c, a, g) {var b,d = {},e = null,h = null;void 0 !== g && (e = "" + g);void 0 !== a.key && (e = "" + a.key);void 0 !== a.ref && (h = a.ref);for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };}reactJsxRuntime_production_min.Fragment = l;reactJsxRuntime_production_min.jsx = q;reactJsxRuntime_production_min.jsxs = q;
      return reactJsxRuntime_production_min;
    }

    var reactJsxRuntime_development = {};

    /**
     * @license React
     * react-jsx-runtime.development.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var hasRequiredReactJsxRuntime_development;

    function requireReactJsxRuntime_development() {
      if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
      hasRequiredReactJsxRuntime_development = 1;

      if (false) {}
      return reactJsxRuntime_development;
    }

    (function (module) {

      if (true) {
        module.exports = requireReactJsxRuntime_production_min();
      } else {}
    })(jsxRuntime);

    var classes$u = {"awell_button":"awell__button_awell_button","w_full":"awell__button_w_full","primary":"awell__button_primary","secondary":"awell__button_secondary","tertiary":"awell__button_tertiary"};

    var Button = /*#__PURE__*/React.forwardRef(function (_a, ref) {
      var children = _a.children,onClick = _a.onClick,_b = _a.fullWidth,fullWidth = _b === void 0 ? false : _b,_c = _a.variant,variant = _c === void 0 ? 'primary' : _c,props = __rest(_a, ["children", "onClick", "fullWidth", "variant"]);
      return jsxRuntime.exports.jsx("button", __assign({}, props, { className: "".concat(classes$u.awell_button, " ").concat(classes$u[variant], " ").concat(fullWidth ? classes$u['w_full'] : ''), onClick: onClick, ref: ref }, { children: children }));
    });
    Button.displayName = 'Button';

    const fr = "https://app.cal.com/embed/embed.js";
    function X(g = fr) {
      (function (d, h, _) {
        let R = function (c, v) {
          c.q.push(v);
        },T = d.document;
        d.Cal = d.Cal || function () {
          let c = d.Cal,v = arguments;
          if (c.loaded || (c.ns = {}, c.q = c.q || [], T.head.appendChild(T.createElement("script")).src = h, c.loaded = !0), v[0] === _) {
            const s = function () {
              R(s, arguments);
            },m = v[1];
            s.q = s.q || [], typeof m == "string" ? (c.ns[m] = s) && R(s, v) : R(c, v);
            return;
          }
          R(c, v);
        };
      })(
      window,
      //! Replace it with "https://cal.com/embed.js" or the URL where you have embed.js installed
      g,
      "init");

      /*!  Copying ends here. */
      return window.Cal;
    }
    X.toString();
    function cr(g) {
      const [d, h] = React.useState();
      return React.useEffect(() => {
        h(() => X(g));
      }, []), d;
    }
    var H = {},dr = {
      get exports() {
        return H;
      },
      set exports(g) {
        H = g;
      } },
    A = {};
    /**
     * @license React
     * react-jsx-runtime.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var Te;
    function vr() {
      if (Te)
      return A;
      Te = 1;
      var g = React__default["default"],d = Symbol.for("react.element"),h = Symbol.for("react.fragment"),_ = Object.prototype.hasOwnProperty,R = g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,T = { key: !0, ref: !0, __self: !0, __source: !0 };
      function c(v, s, m) {
        var p,C = {},S = null,$ = null;
        m !== void 0 && (S = "" + m), s.key !== void 0 && (S = "" + s.key), s.ref !== void 0 && ($ = s.ref);
        for (p in s)
        _.call(s, p) && !T.hasOwnProperty(p) && (C[p] = s[p]);
        if (v && v.defaultProps)
        for (p in s = v.defaultProps, s)
        C[p] === void 0 && (C[p] = s[p]);
        return { $$typeof: d, type: v, key: S, ref: $, props: C, _owner: R.current };
      }
      return A.Fragment = h, A.jsx = c, A.jsxs = c, A;
    }
    var I = {};
    /**
     * @license React
     * react-jsx-runtime.development.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var we;
    function pr() {
      return we || (we = 1,  false && 0), I;
    }
    (function (g) {
       true ? g.exports = vr() : 0;
    })(dr);
    const gr = H.jsx,mr = function (d) {
      const {
        calLink: h,
        calOrigin: _,
        config: R,
        initConfig: T = {},
        embedJsUrl: c,
        ...v } =
      d;
      if (!h)
      throw new Error("calLink is required");
      const s = React.useRef(!1),m = cr(c),p = React.useRef(null);
      return React.useEffect(() => {
        if (!m || s.current)
        return;
        s.current = !0;
        const C = p.current;
        m("init", {
          ...T,
          origin: _ }),
        m("inline", {
          elementOrSelector: C,
          calLink: h,
          config: R });

      }, [m, h, R, _, T]), m ? /* @__PURE__ */gr("div", {
        ref: p,
        ...v }) :
      null;
    },Er = mr,hr = () => new Promise(function g(d) {
      X();
      const h = window.Cal;
      if (!h) {
        setTimeout(() => {
          g(d);
        }, 50);
        return;
      }
      d(h);
    });

    var DEFAULT_ACCENT_COLOR = '#004ac2';
    var useAccentColor = function () {
      var _a = React.useState(DEFAULT_ACCENT_COLOR),accentColor = _a[0],setAccentColor = _a[1];
      React.useEffect(function () {
        var newAccentColor = window.
        getComputedStyle(document.documentElement).
        getPropertyValue('--awell-accent-color');
        if (newAccentColor) {
          setAccentColor(newAccentColor);
        }
      }, []);
      return {
        accentColor: accentColor };

    };

    var CalDotComScheduling = function (_a) {
      var calLink = _a.calLink,_b = _a.hideEventTypeDetails,hideEventTypeDetails = _b === void 0 ? false : _b,onBookingSuccessful = _a.onBookingSuccessful,metadata = _a.metadata;
      var accentColor = useAccentColor().accentColor;
      var initComponent = function () {return __awaiter(void 0, void 0, void 0, function () {
          var cal;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:return [4, hr()];
              case 1:
                cal = _a.sent();
                if (cal) {
                  cal('ui', {
                    theme: 'light',
                    styles: { branding: { brandColor: accentColor } },
                    hideEventTypeDetails: hideEventTypeDetails });

                  cal('on', {
                    action: 'bookingSuccessful',
                    callback: function (e) {
                      var data = e.detail.data;
                      var confirmed = data.confirmed,eventType = data.eventType,date = data.date,booking = data.booking;
                      onBookingSuccessful({
                        confirmed: confirmed,
                        eventType: eventType,
                        date: date,
                        booking: booking });

                    } });

                }
                return [2];}

          });
        });};
      React.useEffect(function () {
        initComponent();
      }, []);
      var metadataString = '';
      if (metadata) {
        metadataString = Object.entries(metadata).
        map(function (_a) {
          var key = _a[0],value = _a[1];
          return "metadata[".concat(key, "]=").concat(value);
        }).
        join('&');
      }
      var composedCalLink = "".concat(calLink).concat(metadata ? "?".concat(metadataString) : '');
      return jsxRuntime.exports.jsx(Er, { calLink: composedCalLink, style: { width: '100%', height: '100%', overflow: 'hidden' } });
    };

    var classes$t = {"input_wrapper":"awell__checkboxButton_input_wrapper","checkbox_wrapper":"awell__checkboxButton_checkbox_wrapper","label_wrapper":"awell__checkboxButton_label_wrapper"};

    var CheckboxButton = function (_a) {
      var onChange = _a.onChange,label = _a.label,name = _a.name,props = __rest(_a, ["onChange", "label", "name"]);
      return jsxRuntime.exports.jsxs("div", __assign({ className: classes$t.input_wrapper }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: classes$t.checkbox_wrapper }, { children: jsxRuntime.exports.jsx("input", __assign({}, props, { name: name, type: "checkbox", onChange: onChange })) })), jsxRuntime.exports.jsx("div", __assign({ className: classes$t.label_wrapper }, { children: jsxRuntime.exports.jsx("label", __assign({ htmlFor: props.id, id: "awell__question_checkbox" }, { children: label })) }))] }));
    };

    var classes$s = {"awell_circular_spinner":"awell__spinner_awell_circular_spinner","size-base":"awell__spinner_size-base","size-sm":"awell__spinner_size-sm","awell_horizontal_spinner":"awell__spinner_awell_horizontal_spinner","awell_horizontal_spinner1":"awell__spinner_awell_horizontal_spinner1","awell_horizontal_spinner2":"awell__spinner_awell_horizontal_spinner2","awell_horizontal_spinner3":"awell__spinner_awell_horizontal_spinner3"};

    var CircularSpinner = function (_a) {
      var _b = _a.size,size = _b === void 0 ? 'base' : _b;
      return jsxRuntime.exports.jsxs("div", __assign({ className: "".concat(classes$s.awell_circular_spinner, " ").concat(classes$s["size-".concat(size)]) }, { children: [jsxRuntime.exports.jsx("div", {}), jsxRuntime.exports.jsx("div", {}), jsxRuntime.exports.jsx("div", {}), jsxRuntime.exports.jsx("div", {})] }));
    };
    var HorizontalSpinner = function () {
      return jsxRuntime.exports.jsxs("div", __assign({ className: classes$s.awell_horizontal_spinner }, { children: [jsxRuntime.exports.jsx("div", {}), jsxRuntime.exports.jsx("div", {}), jsxRuntime.exports.jsx("div", {}), jsxRuntime.exports.jsx("div", {})] }));
    };

    var entry_nostyle = {};

    var DatePicker$1 = {};

    var propTypes$1 = {exports: {}};

    var reactIs = {exports: {}};

    var reactIs_production_min = {};

    /** @license React v16.13.1
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var hasRequiredReactIs_production_min;

    function requireReactIs_production_min() {
      if (hasRequiredReactIs_production_min) return reactIs_production_min;
      hasRequiredReactIs_production_min = 1;
    var b = "function" === typeof Symbol && Symbol.for,c = b ? Symbol.for("react.element") : 60103,d = b ? Symbol.for("react.portal") : 60106,e = b ? Symbol.for("react.fragment") : 60107,f = b ? Symbol.for("react.strict_mode") : 60108,g = b ? Symbol.for("react.profiler") : 60114,h = b ? Symbol.for("react.provider") : 60109,k = b ? Symbol.for("react.context") : 60110,l = b ? Symbol.for("react.async_mode") : 60111,m = b ? Symbol.for("react.concurrent_mode") : 60111,n = b ? Symbol.for("react.forward_ref") : 60112,p = b ? Symbol.for("react.suspense") : 60113,q = b ?
      Symbol.for("react.suspense_list") : 60120,r = b ? Symbol.for("react.memo") : 60115,t = b ? Symbol.for("react.lazy") : 60116,v = b ? Symbol.for("react.block") : 60121,w = b ? Symbol.for("react.fundamental") : 60117,x = b ? Symbol.for("react.responder") : 60118,y = b ? Symbol.for("react.scope") : 60119;
      function z(a) {if ("object" === typeof a && null !== a) {var u = a.$$typeof;switch (u) {case c:switch (a = a.type, a) {case l:case m:case e:case g:case f:case p:return a;default:switch (a = a && a.$$typeof, a) {case k:case n:case t:case r:case h:return a;default:return u;}}case d:return u;}}}function A(a) {return z(a) === m;}reactIs_production_min.AsyncMode = l;reactIs_production_min.ConcurrentMode = m;reactIs_production_min.ContextConsumer = k;reactIs_production_min.ContextProvider = h;reactIs_production_min.Element = c;reactIs_production_min.ForwardRef = n;reactIs_production_min.Fragment = e;reactIs_production_min.Lazy = t;reactIs_production_min.Memo = r;reactIs_production_min.Portal = d;
      reactIs_production_min.Profiler = g;reactIs_production_min.StrictMode = f;reactIs_production_min.Suspense = p;reactIs_production_min.isAsyncMode = function (a) {return A(a) || z(a) === l;};reactIs_production_min.isConcurrentMode = A;reactIs_production_min.isContextConsumer = function (a) {return z(a) === k;};reactIs_production_min.isContextProvider = function (a) {return z(a) === h;};reactIs_production_min.isElement = function (a) {return "object" === typeof a && null !== a && a.$$typeof === c;};reactIs_production_min.isForwardRef = function (a) {return z(a) === n;};reactIs_production_min.isFragment = function (a) {return z(a) === e;};reactIs_production_min.isLazy = function (a) {return z(a) === t;};
      reactIs_production_min.isMemo = function (a) {return z(a) === r;};reactIs_production_min.isPortal = function (a) {return z(a) === d;};reactIs_production_min.isProfiler = function (a) {return z(a) === g;};reactIs_production_min.isStrictMode = function (a) {return z(a) === f;};reactIs_production_min.isSuspense = function (a) {return z(a) === p;};
      reactIs_production_min.isValidElementType = function (a) {return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);};reactIs_production_min.typeOf = z;
      return reactIs_production_min;
    }

    var reactIs_development = {};

    /** @license React v16.13.1
     * react-is.development.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var hasRequiredReactIs_development;

    function requireReactIs_development() {
      if (hasRequiredReactIs_development) return reactIs_development;
      hasRequiredReactIs_development = 1;



      if (false) {}
      return reactIs_development;
    }

    var hasRequiredReactIs;

    function requireReactIs() {
      if (hasRequiredReactIs) return reactIs.exports;
      hasRequiredReactIs = 1;
      (function (module) {

        if (true) {
          module.exports = requireReactIs_production_min();
        } else {}
      })(reactIs);
      return reactIs.exports;
    }

    function _extends$d() {
      _extends$d = Object.assign ? Object.assign.bind() : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };
      return _extends$d.apply(this, arguments);
    }

    var objectAssign;
    var hasRequiredObjectAssign;

    function requireObjectAssign() {
      if (hasRequiredObjectAssign) return objectAssign;
      hasRequiredObjectAssign = 1;
      /* eslint-disable no-unused-vars */
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var propIsEnumerable = Object.prototype.propertyIsEnumerable;

      function toObject(val) {
        if (val === null || val === undefined) {
          throw new TypeError('Object.assign cannot be called with null or undefined');
        }

        return Object(val);
      }

      function shouldUseNative() {
        try {
          if (!Object.assign) {
            return false;
          }

          // Detect buggy property enumeration order in older V8 versions.

          // https://bugs.chromium.org/p/v8/issues/detail?id=4118
          var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
          test1[5] = 'de';
          if (Object.getOwnPropertyNames(test1)[0] === '5') {
            return false;
          }

          // https://bugs.chromium.org/p/v8/issues/detail?id=3056
          var test2 = {};
          for (var i = 0; i < 10; i++) {
            test2['_' + String.fromCharCode(i)] = i;
          }
          var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
          });
          if (order2.join('') !== '0123456789') {
            return false;
          }

          // https://bugs.chromium.org/p/v8/issues/detail?id=3056
          var test3 = {};
          'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
            test3[letter] = letter;
          });
          if (Object.keys(_extends$d({}, test3)).join('') !==
          'abcdefghijklmnopqrst') {
            return false;
          }

          return true;
        } catch (err) {
          // We don't expect any of the above to throw, but better to be safe.
          return false;
        }
      }

      objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
        var from;
        var to = toObject(target);
        var symbols;

        for (var s = 1; s < arguments.length; s++) {
          from = Object(arguments[s]);

          for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
              to[key] = from[key];
            }
          }

          if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
              if (propIsEnumerable.call(from, symbols[i])) {
                to[symbols[i]] = from[symbols[i]];
              }
            }
          }
        }

        return to;
      };
      return objectAssign;
    }

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;

    function requireReactPropTypesSecret() {
      if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
      hasRequiredReactPropTypesSecret = 1;

      var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

      ReactPropTypesSecret_1 = ReactPropTypesSecret;
      return ReactPropTypesSecret_1;
    }

    var has;
    var hasRequiredHas;

    function requireHas() {
      if (hasRequiredHas) return has;
      hasRequiredHas = 1;
      has = Function.call.bind(Object.prototype.hasOwnProperty);
      return has;
    }

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var checkPropTypes_1;
    var hasRequiredCheckPropTypes;

    function requireCheckPropTypes() {
      if (hasRequiredCheckPropTypes) return checkPropTypes_1;
      hasRequiredCheckPropTypes = 1;

      var printWarning = function () {};

      if (false) { var has, loggedTypeFailures, ReactPropTypesSecret; }

      /**
       * Assert that the values match with the type specs.
       * Error messages are memorized and will only be shown once.
       *
       * @param {object} typeSpecs Map of name to a ReactPropType
       * @param {object} values Runtime values that need to be type-checked
       * @param {string} location e.g. "prop", "context", "child context"
       * @param {string} componentName Name of the component for error messages.
       * @param {?Function} getStack Returns the component stack.
       * @private
       */
      function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
        if (false) { var stack, err, error, typeSpecName; }
      }

      /**
       * Resets warning cache when testing.
       *
       * @private
       */
      checkPropTypes.resetWarningCache = function () {
        if (false) {}
      };

      checkPropTypes_1 = checkPropTypes;
      return checkPropTypes_1;
    }

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var factoryWithTypeCheckers;
    var hasRequiredFactoryWithTypeCheckers;

    function requireFactoryWithTypeCheckers() {
      if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
      hasRequiredFactoryWithTypeCheckers = 1;

      var ReactIs = requireReactIs();
      var assign = requireObjectAssign();

      var ReactPropTypesSecret = requireReactPropTypesSecret();
      var has = requireHas();
      var checkPropTypes = requireCheckPropTypes();

      var printWarning = function () {};

      if (false) {}

      function emptyFunctionThatReturnsNull() {
        return null;
      }

      factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
        /* global Symbol */
        var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

        /**
         * Returns the iterator method function contained on the iterable object.
         *
         * Be sure to invoke the function with the iterable as context:
         *
         *     var iteratorFn = getIteratorFn(myIterable);
         *     if (iteratorFn) {
         *       var iterator = iteratorFn.call(myIterable);
         *       ...
         *     }
         *
         * @param {?object} maybeIterable
         * @return {?function}
         */
        function getIteratorFn(maybeIterable) {
          var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
          if (typeof iteratorFn === 'function') {
            return iteratorFn;
          }
        }

        /**
         * Collection of methods that allow declaration and validation of props that are
         * supplied to React components. Example usage:
         *
         *   var Props = require('ReactPropTypes');
         *   var MyArticle = React.createClass({
         *     propTypes: {
         *       // An optional string prop named "description".
         *       description: Props.string,
         *
         *       // A required enum prop named "category".
         *       category: Props.oneOf(['News','Photos']).isRequired,
         *
         *       // A prop named "dialog" that requires an instance of Dialog.
         *       dialog: Props.instanceOf(Dialog).isRequired
         *     },
         *     render: function() { ... }
         *   });
         *
         * A more formal specification of how these methods are used:
         *
         *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
         *   decl := ReactPropTypes.{type}(.isRequired)?
         *
         * Each and every declaration produces a function with the same signature. This
         * allows the creation of custom validation functions. For example:
         *
         *  var MyLink = React.createClass({
         *    propTypes: {
         *      // An optional string or URI prop named "href".
         *      href: function(props, propName, componentName) {
         *        var propValue = props[propName];
         *        if (propValue != null && typeof propValue !== 'string' &&
         *            !(propValue instanceof URI)) {
         *          return new Error(
         *            'Expected a string or an URI for ' + propName + ' in ' +
         *            componentName
         *          );
         *        }
         *      }
         *    },
         *    render: function() {...}
         *  });
         *
         * @internal
         */

        var ANONYMOUS = '<<anonymous>>';

        // Important!
        // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
        var ReactPropTypes = {
          array: createPrimitiveTypeChecker('array'),
          bigint: createPrimitiveTypeChecker('bigint'),
          bool: createPrimitiveTypeChecker('boolean'),
          func: createPrimitiveTypeChecker('function'),
          number: createPrimitiveTypeChecker('number'),
          object: createPrimitiveTypeChecker('object'),
          string: createPrimitiveTypeChecker('string'),
          symbol: createPrimitiveTypeChecker('symbol'),

          any: createAnyTypeChecker(),
          arrayOf: createArrayOfTypeChecker,
          element: createElementTypeChecker(),
          elementType: createElementTypeTypeChecker(),
          instanceOf: createInstanceTypeChecker,
          node: createNodeChecker(),
          objectOf: createObjectOfTypeChecker,
          oneOf: createEnumTypeChecker,
          oneOfType: createUnionTypeChecker,
          shape: createShapeTypeChecker,
          exact: createStrictShapeTypeChecker };


        /**
         * inlined Object.is polyfill to avoid requiring consumers ship their own
         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
         */
        /*eslint-disable no-self-compare*/
        function is(x, y) {
          // SameValue algorithm
          if (x === y) {
            // Steps 1-5, 7-10
            // Steps 6.b-6.e: +0 != -0
            return x !== 0 || 1 / x === 1 / y;
          } else {
            // Step 6.a: NaN == NaN
            return x !== x && y !== y;
          }
        }
        /*eslint-enable no-self-compare*/

        /**
         * We use an Error-like object for backward compatibility as people may call
         * PropTypes directly and inspect their output. However, we don't use real
         * Errors anymore. We don't inspect their stack anyway, and creating them
         * is prohibitively expensive if they are created too often, such as what
         * happens in oneOfType() for any type before the one that matched.
         */
        function PropTypeError(message, data) {
          this.message = message;
          this.data = data && typeof data === 'object' ? data : {};
          this.stack = '';
        }
        // Make `instanceof Error` still work for returned errors.
        PropTypeError.prototype = Error.prototype;

        function createChainableTypeChecker(validate) {
          if (false) { var manualPropTypeWarningCount, manualPropTypeCallCache; }
          function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;

            if (secret !== ReactPropTypesSecret) {
              if (throwOnDirectAccess) {
                // New behavior only for users of `prop-types` package
                var err = new Error(
                'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
                'Use `PropTypes.checkPropTypes()` to call them. ' +
                'Read more at http://fb.me/use-check-prop-types');

                err.name = 'Invariant Violation';
                throw err;
              } else if (false) { var cacheKey; }
            }
            if (props[propName] == null) {
              if (isRequired) {
                if (props[propName] === null) {
                  return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                }
                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
              }
              return null;
            } else {
              return validate(props, propName, componentName, location, propFullName);
            }
          }

          var chainedCheckType = checkType.bind(null, false);
          chainedCheckType.isRequired = checkType.bind(null, true);

          return chainedCheckType;
        }

        function createPrimitiveTypeChecker(expectedType) {
          function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
              // `propValue` being instance of, say, date/regexp, pass the 'object'
              // check, but we can offer a more precise error message here rather than
              // 'of type `object`'.
              var preciseType = getPreciseType(propValue);

              return new PropTypeError(
              'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
              { expectedType: expectedType });

            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }

        function createAnyTypeChecker() {
          return createChainableTypeChecker(emptyFunctionThatReturnsNull);
        }

        function createArrayOfTypeChecker(typeChecker) {
          function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') {
              return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            }
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
              var propType = getPropType(propValue);
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for (var i = 0; i < propValue.length; i++) {
              var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }

        function createElementTypeChecker() {
          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
              var propType = getPropType(propValue);
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }

        function createElementTypeTypeChecker() {
          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!ReactIs.isValidElementType(propValue)) {
              var propType = getPropType(propValue);
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }

        function createInstanceTypeChecker(expectedClass) {
          function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
              var expectedClassName = expectedClass.name || ANONYMOUS;
              var actualClassName = getClassName(props[propName]);
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }

        function createEnumTypeChecker(expectedValues) {
          if (!Array.isArray(expectedValues)) {
            if (false) {}
            return emptyFunctionThatReturnsNull;
          }

          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for (var i = 0; i < expectedValues.length; i++) {
              if (is(propValue, expectedValues[i])) {
                return null;
              }
            }

            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
              var type = getPreciseType(value);
              if (type === 'symbol') {
                return String(value);
              }
              return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
          }
          return createChainableTypeChecker(validate);
        }

        function createObjectOfTypeChecker(typeChecker) {
          function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') {
              return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            }
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            }
            for (var key in propValue) {
              if (has(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                if (error instanceof Error) {
                  return error;
                }
              }
            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }

        function createUnionTypeChecker(arrayOfTypeCheckers) {
          if (!Array.isArray(arrayOfTypeCheckers)) {
             false ? 0 : void 0;
            return emptyFunctionThatReturnsNull;
          }

          for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
              printWarning(
              'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
              'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');

              return emptyFunctionThatReturnsNull;
            }
          }

          function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
              var checker = arrayOfTypeCheckers[i];
              var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
              if (checkerResult == null) {
                return null;
              }
              if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
                expectedTypes.push(checkerResult.data.expectedType);
              }
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
          }
          return createChainableTypeChecker(validate);
        }

        function createNodeChecker() {
          function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }

        function invalidValidatorError(componentName, location, propFullName, key, type) {
          return new PropTypeError(
          (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
          'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');

        }

        function createShapeTypeChecker(shapeTypes) {
          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            }
            for (var key in shapeTypes) {
              var checker = shapeTypes[key];
              if (typeof checker !== 'function') {
                return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
              }
              var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
              if (error) {
                return error;
              }
            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }

        function createStrictShapeTypeChecker(shapeTypes) {
          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            }
            // We need to check all keys in case some are required but missing from props.
            var allKeys = assign({}, props[propName], shapeTypes);
            for (var key in allKeys) {
              var checker = shapeTypes[key];
              if (has(shapeTypes, key) && typeof checker !== 'function') {
                return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
              }
              if (!checker) {
                return new PropTypeError(
                'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
                '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
                '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));

              }
              var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
              if (error) {
                return error;
              }
            }
            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function isNode(propValue) {
          switch (typeof propValue) {
            case 'number':
            case 'string':
            case 'undefined':
              return true;
            case 'boolean':
              return !propValue;
            case 'object':
              if (Array.isArray(propValue)) {
                return propValue.every(isNode);
              }
              if (propValue === null || isValidElement(propValue)) {
                return true;
              }

              var iteratorFn = getIteratorFn(propValue);
              if (iteratorFn) {
                var iterator = iteratorFn.call(propValue);
                var step;
                if (iteratorFn !== propValue.entries) {
                  while (!(step = iterator.next()).done) {
                    if (!isNode(step.value)) {
                      return false;
                    }
                  }
                } else {
                  // Iterator will provide entry [k,v] tuples rather than values.
                  while (!(step = iterator.next()).done) {
                    var entry = step.value;
                    if (entry) {
                      if (!isNode(entry[1])) {
                        return false;
                      }
                    }
                  }
                }
              } else {
                return false;
              }

              return true;
            default:
              return false;}

        }

        function isSymbol(propType, propValue) {
          // Native Symbol.
          if (propType === 'symbol') {
            return true;
          }

          // falsy value can't be a Symbol
          if (!propValue) {
            return false;
          }

          // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
          if (propValue['@@toStringTag'] === 'Symbol') {
            return true;
          }

          // Fallback for non-spec compliant Symbols which are polyfilled.
          if (typeof Symbol === 'function' && propValue instanceof Symbol) {
            return true;
          }

          return false;
        }

        // Equivalent of `typeof` but with special handling for array and regexp.
        function getPropType(propValue) {
          var propType = typeof propValue;
          if (Array.isArray(propValue)) {
            return 'array';
          }
          if (propValue instanceof RegExp) {
            // Old webkits (at least until Android 4.0) return 'function' rather than
            // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
            // passes PropTypes.object.
            return 'object';
          }
          if (isSymbol(propType, propValue)) {
            return 'symbol';
          }
          return propType;
        }

        // This handles more types than `getPropType`. Only used for error messages.
        // See `createPrimitiveTypeChecker`.
        function getPreciseType(propValue) {
          if (typeof propValue === 'undefined' || propValue === null) {
            return '' + propValue;
          }
          var propType = getPropType(propValue);
          if (propType === 'object') {
            if (propValue instanceof Date) {
              return 'date';
            } else if (propValue instanceof RegExp) {
              return 'regexp';
            }
          }
          return propType;
        }

        // Returns a string that is postfixed to a warning about an invalid type.
        // For example, "undefined" or "of type array"
        function getPostfixForTypeWarning(value) {
          var type = getPreciseType(value);
          switch (type) {
            case 'array':
            case 'object':
              return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
              return 'a ' + type;
            default:
              return type;}

        }

        // Returns class name of the object, if any.
        function getClassName(propValue) {
          if (!propValue.constructor || !propValue.constructor.name) {
            return ANONYMOUS;
          }
          return propValue.constructor.name;
        }

        ReactPropTypes.checkPropTypes = checkPropTypes;
        ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
        ReactPropTypes.PropTypes = ReactPropTypes;

        return ReactPropTypes;
      };
      return factoryWithTypeCheckers;
    }

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;

    function requireFactoryWithThrowingShims() {
      if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
      hasRequiredFactoryWithThrowingShims = 1;

      var ReactPropTypesSecret = requireReactPropTypesSecret();

      function emptyFunction() {}
      function emptyFunctionWithReset() {}
      emptyFunctionWithReset.resetWarningCache = emptyFunction;

      factoryWithThrowingShims = function () {
        function shim(props, propName, componentName, location, propFullName, secret) {
          if (secret === ReactPropTypesSecret) {
            // It is still safe when called from React.
            return;
          }
          var err = new Error(
          'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
          'Use PropTypes.checkPropTypes() to call them. ' +
          'Read more at http://fb.me/use-check-prop-types');

          err.name = 'Invariant Violation';
          throw err;
        }    shim.isRequired = shim;
        function getShim() {
          return shim;
        }    // Important!
        // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
        var ReactPropTypes = {
          array: shim,
          bigint: shim,
          bool: shim,
          func: shim,
          number: shim,
          object: shim,
          string: shim,
          symbol: shim,

          any: shim,
          arrayOf: getShim,
          element: shim,
          elementType: shim,
          instanceOf: getShim,
          node: shim,
          objectOf: getShim,
          oneOf: getShim,
          oneOfType: getShim,
          shape: getShim,
          exact: getShim,

          checkPropTypes: emptyFunctionWithReset,
          resetWarningCache: emptyFunction };


        ReactPropTypes.PropTypes = ReactPropTypes;

        return ReactPropTypes;
      };
      return factoryWithThrowingShims;
    }

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    if (false) { var throwOnDirectAccess, ReactIs; } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      propTypes$1.exports = requireFactoryWithThrowingShims()();
    }

    // As defined on the list of supported events: https://reactjs.org/docs/events.html
    var clipboardEvents = ['onCopy', 'onCut', 'onPaste'];
    var compositionEvents = ['onCompositionEnd', 'onCompositionStart', 'onCompositionUpdate'];
    var keyboardEvents = ['onKeyDown', 'onKeyPress', 'onKeyUp'];
    var focusEvents = ['onFocus', 'onBlur'];
    var formEvents = ['onChange', 'onInput', 'onInvalid', 'onReset', 'onSubmit'];
    var genericEvents = ['onError', 'onLoad'];
    var mouseEvents = ['onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp'];
    var pointerEvents = ['onPointerDown', 'onPointerMove', 'onPointerUp', 'onPointerCancel', 'onGotPointerCapture', 'onLostPointerCapture', 'onPointerEnter', 'onPointerLeave', 'onPointerOver', 'onPointerOut'];
    var selectionEvents = ['onSelect'];
    var touchEvents = ['onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];
    var uiEvents = ['onScroll'];
    var wheelEvents = ['onWheel'];
    var mediaEvents = ['onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting'];
    var imageEvents = ['onLoad', 'onError'];
    var animationEvents = ['onAnimationStart', 'onAnimationEnd', 'onAnimationIteration'];
    var transitionEvents = ['onTransitionEnd'];
    var otherEvents = ['onToggle'];
    var allEvents = [].concat(clipboardEvents, compositionEvents, keyboardEvents, focusEvents, formEvents, genericEvents, mouseEvents, pointerEvents, selectionEvents, touchEvents, uiEvents, wheelEvents, mediaEvents, imageEvents, animationEvents, transitionEvents, otherEvents);
    /**
     * Returns an object with on-event callback props curried with provided args.
     * @param {Object} props Props passed to a component.
     * @param {Function=} getArgs A function that returns argument(s) on-event callbacks
     *   shall be curried with.
     */

    var makeEventProps = function makeEventProps(props, getArgs) {
      var eventProps = {};
      allEvents.forEach(function (eventName) {
        if (!(eventName in props)) {
          return;
        }

        if (!getArgs) {
          eventProps[eventName] = props[eventName];
          return;
        }

        eventProps[eventName] = function (event) {
          return props[eventName](event, getArgs(eventName));
        };
      });
      return eventProps;
    };

    var esm$6 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        clipboardEvents: clipboardEvents,
        compositionEvents: compositionEvents,
        keyboardEvents: keyboardEvents,
        focusEvents: focusEvents,
        formEvents: formEvents,
        genericEvents: genericEvents,
        mouseEvents: mouseEvents,
        pointerEvents: pointerEvents,
        selectionEvents: selectionEvents,
        touchEvents: touchEvents,
        uiEvents: uiEvents,
        wheelEvents: wheelEvents,
        mediaEvents: mediaEvents,
        imageEvents: imageEvents,
        animationEvents: animationEvents,
        transitionEvents: transitionEvents,
        otherEvents: otherEvents,
        allEvents: allEvents,
        'default': makeEventProps
    });

    var require$$2$1 = /*@__PURE__*/getAugmentedNamespace(esm$6);

    function mergeClassNames() {
      return Array.prototype.slice.call(arguments).reduce(function (classList, arg) {
        return classList.concat(arg);
      }, []).filter(function (arg) {
        return typeof arg === 'string';
      }).join(' ');
    }

    var esm$5 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        'default': mergeClassNames
    });

    var require$$3$1 = /*@__PURE__*/getAugmentedNamespace(esm$5);

    /**
     * lodash (Custom Build) <https://lodash.com/>
     * Build: `lodash modularize exports="npm" -o ./`
     * Copyright jQuery Foundation and other contributors <https://jquery.org/>
     * Released under MIT license <https://lodash.com/license>
     * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
     * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
     */

    /** Used as the `TypeError` message for "Functions" methods. */
    var FUNC_ERROR_TEXT = 'Expected a function';

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /** `Object#toString` result references. */
    var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;

    /** Detect free variable `global` from Node.js. */
    var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

    /** Detect free variable `self`. */
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function('return this')();

    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue$3(object, key) {
      return object == null ? undefined : object[key];
    }

    /**
     * Checks if `value` is a host object in IE < 9.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
     */
    function isHostObject(value) {
      // Many host objects are `Object` objects that can coerce to strings
      // despite having improperly defined `toString` methods.
      var result = false;
      if (value != null && typeof value.toString != 'function') {
        try {
          result = !!(value + '');
        } catch (e) {}
      }
      return result;
    }

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = root['__core-js_shared__'];

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objectToString = objectProto.toString;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
    funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').
    replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');


    /** Built-in value references. */
    var splice = arrayProto.splice;

    /* Built-in method references that are verified to be native. */
    var Map$1 = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
      length = entries ? entries.length : 0;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
      length = entries ? entries.length : 0;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
      index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
      index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
      index = assocIndexOf(data, key);

      if (index < 0) {
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
      length = entries ? entries.length : 0;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.__data__ = {
        'hash': new Hash(),
        'map': new (Map$1 || ListCache)(),
        'string': new Hash() };

    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      return getMapData(this, key)['delete'](key);
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      getMapData(this, key).set(key, value);
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject$1(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction$1(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ?
      data[typeof key == 'string' ? 'string' : 'hash'] :
      data.map;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue$3(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ?
      value !== '__proto__' :
      value === null;
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to process.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return func + '';
        } catch (e) {}
      }
      return '';
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || resolver && typeof resolver != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function () {
        var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache)();
      return memoized;
    }

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction$1(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 8-9 which returns 'object' for typed array and other constructors.
      var tag = isObject$1(value) ? objectToString.call(value) : '';
      return tag == funcTag || tag == genTag;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject$1(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    var lodash_memoize = memoize;

    var memoize$1 = lodash_memoize;

    function resolver(options) {
      return JSON.stringify(options);
    }

    function uniqDefined(arr) {
      return arr.filter(function (el, index) {
        return el && arr.indexOf(el) === index;
      });
    }

    function normalizeLocales(arr) {
      return arr.map(function (el) {
        if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) {
          return el;
        }

        var splitEl = el.split('-');
        return splitEl[0] + "-" + splitEl[1].toUpperCase();
      });
    }

    function getUserLocalesInternal(_temp) {
      var _ref = _temp === void 0 ? {} : _temp,
      _ref$useFallbackLocal = _ref.useFallbackLocale,
      useFallbackLocale = _ref$useFallbackLocal === void 0 ? true : _ref$useFallbackLocal,
      _ref$fallbackLocale = _ref.fallbackLocale,
      fallbackLocale = _ref$fallbackLocale === void 0 ? 'en-US' : _ref$fallbackLocale;

      var languageList = [];

      if (typeof window !== 'undefined') {
        var _window = window,
        navigator = _window.navigator;
        languageList = languageList.concat(navigator.languages, navigator.language, navigator.userLanguage, navigator.browserLanguage, navigator.systemLanguage);
      }

      if (useFallbackLocale) {
        languageList.push(fallbackLocale);
      }

      return normalizeLocales(uniqDefined(languageList));
    }

    var getUserLocales = memoize$1(getUserLocalesInternal, resolver);

    function getUserLocaleInternal(options) {
      return getUserLocales(options)[0] || null;
    }

    var getUserLocale = memoize$1(getUserLocaleInternal, resolver);

    var esm$4 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getUserLocales: getUserLocales,
        getUserLocale: getUserLocale,
        'default': getUserLocale
    });

    /**
     * Utils
     */
    function makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
      return function makeGetEdgeOfNeighborInternal(date) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
        var previousPeriod = getPeriod(date) + offset;
        return getEdgeOfPeriod(previousPeriod);
      };
    }

    function makeGetEnd(getBeginOfNextPeriod) {
      return function makeGetEndInternal(date) {
        return new Date(getBeginOfNextPeriod(date).getTime() - 1);
      };
    }

    function makeGetRange(functions) {
      return function makeGetRangeInternal(date) {
        return functions.map(function (fn) {
          return fn(date);
        });
      };
    }
    /**
     * Simple getters - getting a property of a given point in time
     */

    /**
     * Gets year from date.
     *
     * @param {Date|number|string} date Date to get year from.
     */


    function getYear(date) {
      if (date instanceof Date) {
        return date.getFullYear();
      }

      if (typeof date === 'number') {
        return date;
      }

      var year = parseInt(date, 10);

      if (typeof date === 'string' && !isNaN(year)) {
        return year;
      }

      throw new Error("Failed to get year from date: ".concat(date, "."));
    }
    /**
     * Gets month from date.
     *
     * @param {Date} date Date to get month from.
     */

    function getMonth(date) {
      if (date instanceof Date) {
        return date.getMonth();
      }

      throw new Error("Failed to get month from date: ".concat(date, "."));
    }
    /**
     * Gets human-readable month from date.
     *
     * @param {Date} date Date to get human-readable month from.
     */

    function getMonthHuman(date) {
      if (date instanceof Date) {
        return date.getMonth() + 1;
      }

      throw new Error("Failed to get human-readable month from date: ".concat(date, "."));
    }
    /**
     * Gets human-readable day of the month from date.
     *
     * @param {Date} date Date to get day of the month from.
     */

    function getDate(date) {
      if (date instanceof Date) {
        return date.getDate();
      }

      throw new Error("Failed to get year from date: ".concat(date, "."));
    }
    /**
     * Gets hours from date.
     *
     * @param {Date|string} date Date to get hours from.
     */

    function getHours(date) {
      if (date instanceof Date) {
        return date.getHours();
      }

      if (typeof date === 'string') {
        var datePieces = date.split(':');

        if (datePieces.length >= 2) {
          var hoursString = datePieces[0];
          var hours = parseInt(hoursString, 10);

          if (!isNaN(hours)) {
            return hours;
          }
        }
      }

      throw new Error("Failed to get hours from date: ".concat(date, "."));
    }
    /**
     * Gets minutes from date.
     *
     * @param {Date|string} date Date to get minutes from.
     */

    function getMinutes(date) {
      if (date instanceof Date) {
        return date.getMinutes();
      }

      if (typeof date === 'string') {
        var datePieces = date.split(':');

        if (datePieces.length >= 2) {
          var minutesString = datePieces[1] || 0;
          var minutes = parseInt(minutesString, 10);

          if (!isNaN(minutes)) {
            return minutes;
          }
        }
      }

      throw new Error("Failed to get minutes from date: ".concat(date, "."));
    }
    /**
     * Gets seconds from date.
     *
     * @param {Date|string} date Date to get seconds from.
     */

    function getSeconds(date) {
      if (date instanceof Date) {
        return date.getSeconds();
      }

      if (typeof date === 'string') {
        var datePieces = date.split(':');

        if (datePieces.length >= 2) {
          var secondsString = datePieces[2] || 0;
          var seconds = parseInt(secondsString, 10);

          if (!isNaN(seconds)) {
            return seconds;
          }
        }
      }

      throw new Error("Failed to get seconds from date: ".concat(date, "."));
    }
    /**
     * Century
     */

    function getCenturyStart(date) {
      var year = getYear(date);
      var centuryStartYear = year + (-year + 1) % 100;
      var centuryStartDate = new Date();
      centuryStartDate.setFullYear(centuryStartYear, 0, 1);
      centuryStartDate.setHours(0, 0, 0, 0);
      return centuryStartDate;
    }
    var getPreviousCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, -100);
    var getNextCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, 100);
    var getCenturyEnd = makeGetEnd(getNextCenturyStart);
    var getPreviousCenturyEnd = makeGetEdgeOfNeighbor(getYear, getCenturyEnd, -100);
    var getNextCenturyEnd = makeGetEdgeOfNeighbor(getYear, getCenturyEnd, 100);
    var getCenturyRange = makeGetRange([getCenturyStart, getCenturyEnd]);
    /**
     * Decade
     */

    function getDecadeStart(date) {
      var year = getYear(date);
      var decadeStartYear = year + (-year + 1) % 10;
      var decadeStartDate = new Date();
      decadeStartDate.setFullYear(decadeStartYear, 0, 1);
      decadeStartDate.setHours(0, 0, 0, 0);
      return decadeStartDate;
    }
    var getPreviousDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, -10);
    var getNextDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, 10);
    var getDecadeEnd = makeGetEnd(getNextDecadeStart);
    var getPreviousDecadeEnd = makeGetEdgeOfNeighbor(getYear, getDecadeEnd, -10);
    var getNextDecadeEnd = makeGetEdgeOfNeighbor(getYear, getDecadeEnd, 10);
    var getDecadeRange = makeGetRange([getDecadeStart, getDecadeEnd]);
    /**
     * Year
     */

    function getYearStart(date) {
      var year = getYear(date);
      var yearStartDate = new Date();
      yearStartDate.setFullYear(year, 0, 1);
      yearStartDate.setHours(0, 0, 0, 0);
      return yearStartDate;
    }
    var getPreviousYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, -1);
    var getNextYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, 1);
    var getYearEnd = makeGetEnd(getNextYearStart);
    var getPreviousYearEnd = makeGetEdgeOfNeighbor(getYear, getYearEnd, -1);
    var getNextYearEnd = makeGetEdgeOfNeighbor(getYear, getYearEnd, 1);
    var getYearRange = makeGetRange([getYearStart, getYearEnd]);
    /**
     * Month
     */

    function makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
      return function makeGetEdgeOfNeighborMonthInternal(date) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
        var year = getYear(date);
        var month = getMonth(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, 1);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
      };
    }

    function getMonthStart(date) {
      var year = getYear(date);
      var month = getMonth(date);
      var monthStartDate = new Date();
      monthStartDate.setFullYear(year, month, 1);
      monthStartDate.setHours(0, 0, 0, 0);
      return monthStartDate;
    }
    var getPreviousMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, -1);
    var getNextMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, 1);
    var getMonthEnd = makeGetEnd(getNextMonthStart);
    var getPreviousMonthEnd = makeGetEdgeOfNeighborMonth(getMonthEnd, -1);
    var getNextMonthEnd = makeGetEdgeOfNeighborMonth(getMonthEnd, 1);
    var getMonthRange = makeGetRange([getMonthStart, getMonthEnd]);
    /**
     * Day
     */

    function makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
      return function makeGetEdgeOfNeighborDayInternal(date) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
        var year = getYear(date);
        var month = getMonth(date);
        var day = getDate(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, day);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
      };
    }

    function getDayStart(date) {
      var year = getYear(date);
      var month = getMonth(date);
      var day = getDate(date);
      var dayStartDate = new Date();
      dayStartDate.setFullYear(year, month, day);
      dayStartDate.setHours(0, 0, 0, 0);
      return dayStartDate;
    }
    var getPreviousDayStart = makeGetEdgeOfNeighborDay(getDayStart, -1);
    var getNextDayStart = makeGetEdgeOfNeighborDay(getDayStart, 1);
    var getDayEnd = makeGetEnd(getNextDayStart);
    var getPreviousDayEnd = makeGetEdgeOfNeighborDay(getDayEnd, -1);
    var getNextDayEnd = makeGetEdgeOfNeighborDay(getDayEnd, 1);
    var getDayRange = makeGetRange([getDayStart, getDayEnd]);
    /**
     * Other
     */

    /**
     * Returns a number of days in a month of a given date.
     *
     * @param {Date} date Date.
     */

    function getDaysInMonth(date) {
      return getDate(getMonthEnd(date));
    }

    function padStart(num) {
      var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var numStr = "".concat(num);

      if (numStr.length >= val) {
        return num;
      }

      return "0000".concat(numStr).slice(-val);
    }
    /**
     * Returns local hours and minutes (hh:mm).
     */


    function getHoursMinutes(date) {
      var hours = padStart(getHours(date));
      var minutes = padStart(getMinutes(date));
      return "".concat(hours, ":").concat(minutes);
    }
    /**
     * Returns local hours, minutes and seconds (hh:mm:ss).
     */

    function getHoursMinutesSeconds(date) {
      var hours = padStart(getHours(date));
      var minutes = padStart(getMinutes(date));
      var seconds = padStart(getSeconds(date));
      return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
    /**
     * Returns local month in ISO-like format (YYYY-MM).
     */

    function getISOLocalMonth(date) {
      var year = padStart(getYear(date), 4);
      var month = padStart(getMonthHuman(date));
      return "".concat(year, "-").concat(month);
    }
    /**
     * Returns local date in ISO-like format (YYYY-MM-DD).
     */

    function getISOLocalDate(date) {
      var year = padStart(getYear(date), 4);
      var month = padStart(getMonthHuman(date));
      var day = padStart(getDate(date));
      return "".concat(year, "-").concat(month, "-").concat(day);
    }
    /**
     * Returns local date & time in ISO-like format (YYYY-MM-DDThh:mm:ss).
     */

    function getISOLocalDateTime(date) {
      return "".concat(getISOLocalDate(date), "T").concat(getHoursMinutesSeconds(date));
    }

    var esm$3 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getYear: getYear,
        getMonth: getMonth,
        getMonthHuman: getMonthHuman,
        getDate: getDate,
        getHours: getHours,
        getMinutes: getMinutes,
        getSeconds: getSeconds,
        getCenturyStart: getCenturyStart,
        getPreviousCenturyStart: getPreviousCenturyStart,
        getNextCenturyStart: getNextCenturyStart,
        getCenturyEnd: getCenturyEnd,
        getPreviousCenturyEnd: getPreviousCenturyEnd,
        getNextCenturyEnd: getNextCenturyEnd,
        getCenturyRange: getCenturyRange,
        getDecadeStart: getDecadeStart,
        getPreviousDecadeStart: getPreviousDecadeStart,
        getNextDecadeStart: getNextDecadeStart,
        getDecadeEnd: getDecadeEnd,
        getPreviousDecadeEnd: getPreviousDecadeEnd,
        getNextDecadeEnd: getNextDecadeEnd,
        getDecadeRange: getDecadeRange,
        getYearStart: getYearStart,
        getPreviousYearStart: getPreviousYearStart,
        getNextYearStart: getNextYearStart,
        getYearEnd: getYearEnd,
        getPreviousYearEnd: getPreviousYearEnd,
        getNextYearEnd: getNextYearEnd,
        getYearRange: getYearRange,
        getMonthStart: getMonthStart,
        getPreviousMonthStart: getPreviousMonthStart,
        getNextMonthStart: getNextMonthStart,
        getMonthEnd: getMonthEnd,
        getPreviousMonthEnd: getPreviousMonthEnd,
        getNextMonthEnd: getNextMonthEnd,
        getMonthRange: getMonthRange,
        getDayStart: getDayStart,
        getPreviousDayStart: getPreviousDayStart,
        getNextDayStart: getNextDayStart,
        getDayEnd: getDayEnd,
        getPreviousDayEnd: getPreviousDayEnd,
        getNextDayEnd: getNextDayEnd,
        getDayRange: getDayRange,
        getDaysInMonth: getDaysInMonth,
        getHoursMinutes: getHoursMinutes,
        getHoursMinutesSeconds: getHoursMinutesSeconds,
        getISOLocalMonth: getISOLocalMonth,
        getISOLocalDate: getISOLocalDate,
        getISOLocalDateTime: getISOLocalDateTime
    });

    var _CALENDAR_TYPE_LOCALE;

    function _toConsumableArray$4(arr) {return _arrayWithoutHoles$4(arr) || _iterableToArray$4(arr) || _unsupportedIterableToArray$4(arr) || _nonIterableSpread$4();}

    function _nonIterableSpread$4() {throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

    function _unsupportedIterableToArray$4(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray$4(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen);}

    function _iterableToArray$4(iter) {if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);}

    function _arrayWithoutHoles$4(arr) {if (Array.isArray(arr)) return _arrayLikeToArray$4(arr);}

    function _arrayLikeToArray$4(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}

    function _defineProperty$M(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    var CALENDAR_TYPES = {
      ARABIC: 'Arabic',
      HEBREW: 'Hebrew',
      ISO_8601: 'ISO 8601',
      US: 'US' };

    var CALENDAR_TYPE_LOCALES = (_CALENDAR_TYPE_LOCALE = {}, _defineProperty$M(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.US, ['en-CA', 'en-US', 'es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-CR', 'es-DO', 'es-EC', 'es-GT', 'es-HN', 'es-MX', 'es-NI', 'es-PA', 'es-PE', 'es-PR', 'es-SV', 'es-VE', 'pt-BR']), _defineProperty$M(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.ARABIC, [// ar-LB, ar-MA intentionally missing
    'ar', 'ar-AE', 'ar-BH', 'ar-DZ', 'ar-EG', 'ar-IQ', 'ar-JO', 'ar-KW', 'ar-LY', 'ar-OM', 'ar-QA', 'ar-SA', 'ar-SD', 'ar-SY', 'ar-YE', 'dv', 'dv-MV', 'ps', 'ps-AR']), _defineProperty$M(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.HEBREW, ['he', 'he-IL']), _CALENDAR_TYPE_LOCALE);
    var WEEKDAYS = _toConsumableArray$4(Array(7)).map(function (el, index) {
      return index;
    });

    var formatterCache$1 = new Map();

    function getFormatter$1(options) {
      return function (locale, date) {
        var localeWithDefault = locale || getUserLocale();

        if (!formatterCache$1.has(localeWithDefault)) {
          formatterCache$1.set(localeWithDefault, new Map());
        }

        var formatterCacheLocale = formatterCache$1.get(localeWithDefault);

        if (!formatterCacheLocale.has(options)) {
          formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault, options).format);
        }

        return formatterCacheLocale.get(options)(date);
      };
    }
    /**
     * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
     * Workaround for bug in WebKit and Firefox with historical dates.
     * For more details, see:
     * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
     * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
     *
     * @param {Date} date Date.
     */


    function toSafeHour$1(date) {
      var safeDate = new Date(date);
      return new Date(safeDate.setHours(12));
    }

    function getSafeFormatter$1(options) {
      return function (locale, date) {
        return getFormatter$1(options)(locale, toSafeHour$1(date));
      };
    }

    var formatDayOptions = {
      day: 'numeric' };

    var formatLongDateOptions = {
      day: 'numeric',
      month: 'long',
      year: 'numeric' };

    var formatMonthOptions$1 = {
      month: 'long' };

    var formatMonthYearOptions = {
      month: 'long',
      year: 'numeric' };

    var formatShortWeekdayOptions = {
      weekday: 'short' };

    var formatWeekdayOptions = {
      weekday: 'long' };

    var formatYearOptions = {
      year: 'numeric' };
    var formatDay = getSafeFormatter$1(formatDayOptions);
    var formatLongDate = getSafeFormatter$1(formatLongDateOptions);
    var formatMonth$1 = getSafeFormatter$1(formatMonthOptions$1);
    var formatMonthYear = getSafeFormatter$1(formatMonthYearOptions);
    var formatShortWeekday = getSafeFormatter$1(formatShortWeekdayOptions);
    var formatWeekday = getSafeFormatter$1(formatWeekdayOptions);
    var formatYear = getSafeFormatter$1(formatYearOptions);

    var SUNDAY = WEEKDAYS[0];
    var FRIDAY = WEEKDAYS[5];
    var SATURDAY = WEEKDAYS[6];
    /* Simple getters - getting a property of a given point in time */

    function getDayOfWeek(date) {
      var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
      var weekday = date.getDay();

      switch (calendarType) {
        case CALENDAR_TYPES.ISO_8601:
          // Shifts days of the week so that Monday is 0, Sunday is 6
          return (weekday + 6) % 7;

        case CALENDAR_TYPES.ARABIC:
          return (weekday + 1) % 7;

        case CALENDAR_TYPES.HEBREW:
        case CALENDAR_TYPES.US:
          return weekday;

        default:
          throw new Error('Unsupported calendar type.');}

    }
    /**
     * Century
     */

    function getBeginOfCenturyYear(date) {
      var beginOfCentury = getCenturyStart(date);
      return getYear(beginOfCentury);
    }
    /**
     * Decade
     */

    function getBeginOfDecadeYear(date) {
      var beginOfDecade = getDecadeStart(date);
      return getYear(beginOfDecade);
    }
    /**
     * Week
     */

    /**
     * Returns the beginning of a given week.
     *
     * @param {Date} date Date.
     * @param {string} calendarType Calendar type. Can be ISO 8601 or US.
     */

    function getBeginOfWeek(date) {
      var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
      var year = getYear(date);
      var monthIndex = getMonth(date);
      var day = date.getDate() - getDayOfWeek(date, calendarType);
      return new Date(year, monthIndex, day);
    }
    /**
     * Gets week number according to ISO 8601 or US standard.
     * In ISO 8601, Arabic and Hebrew week 1 is the one with January 4.
     * In US calendar week 1 is the one with January 1.
     *
     * @param {Date} date Date.
     * @param {string} calendarType Calendar type. Can be ISO 8601 or US.
     */

    function getWeekNumber(date) {
      var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
      var calendarTypeForWeekNumber = calendarType === CALENDAR_TYPES.US ? CALENDAR_TYPES.US : CALENDAR_TYPES.ISO_8601;
      var beginOfWeek = getBeginOfWeek(date, calendarType);
      var year = getYear(date) + 1;
      var dayInWeekOne;
      var beginOfFirstWeek; // Look for the first week one that does not come after a given date

      do {
        dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === CALENDAR_TYPES.ISO_8601 ? 4 : 1);
        beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarType);
        year -= 1;
      } while (date < beginOfFirstWeek);

      return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
    }
    /**
     * Others
     */

    /**
     * Returns the beginning of a given range.
     *
     * @param {string} rangeType Range type (e.g. 'day')
     * @param {Date} date Date.
     */

    function getBegin$1(rangeType, date) {
      switch (rangeType) {
        case 'century':
          return getCenturyStart(date);

        case 'decade':
          return getDecadeStart(date);

        case 'year':
          return getYearStart(date);

        case 'month':
          return getMonthStart(date);

        case 'day':
          return getDayStart(date);

        default:
          throw new Error("Invalid rangeType: ".concat(rangeType));}

    }
    function getBeginPrevious(rangeType, date) {
      switch (rangeType) {
        case 'century':
          return getPreviousCenturyStart(date);

        case 'decade':
          return getPreviousDecadeStart(date);

        case 'year':
          return getPreviousYearStart(date);

        case 'month':
          return getPreviousMonthStart(date);

        default:
          throw new Error("Invalid rangeType: ".concat(rangeType));}

    }
    function getBeginNext(rangeType, date) {
      switch (rangeType) {
        case 'century':
          return getNextCenturyStart(date);

        case 'decade':
          return getNextDecadeStart(date);

        case 'year':
          return getNextYearStart(date);

        case 'month':
          return getNextMonthStart(date);

        default:
          throw new Error("Invalid rangeType: ".concat(rangeType));}

    }
    var getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
      switch (rangeType) {
        case 'decade':
          return getPreviousDecadeStart(date, -100);

        case 'year':
          return getPreviousYearStart(date, -10);

        case 'month':
          return getPreviousMonthStart(date, -12);

        default:
          throw new Error("Invalid rangeType: ".concat(rangeType));}

    };
    var getBeginNext2 = function getBeginNext2(rangeType, date) {
      switch (rangeType) {
        case 'decade':
          return getNextDecadeStart(date, 100);

        case 'year':
          return getNextYearStart(date, 10);

        case 'month':
          return getNextMonthStart(date, 12);

        default:
          throw new Error("Invalid rangeType: ".concat(rangeType));}

    };
    /**
     * Returns the end of a given range.
     *
     * @param {string} rangeType Range type (e.g. 'day')
     * @param {Date} date Date.
     */

    function getEnd$1(rangeType, date) {
      switch (rangeType) {
        case 'century':
          return getCenturyEnd(date);

        case 'decade':
          return getDecadeEnd(date);

        case 'year':
          return getYearEnd(date);

        case 'month':
          return getMonthEnd(date);

        case 'day':
          return getDayEnd(date);

        default:
          throw new Error("Invalid rangeType: ".concat(rangeType));}

    }
    function getEndPrevious(rangeType, date) {
      switch (rangeType) {
        case 'century':
          return getPreviousCenturyEnd(date);

        case 'decade':
          return getPreviousDecadeEnd(date);

        case 'year':
          return getPreviousYearEnd(date);

        case 'month':
          return getPreviousMonthEnd(date);

        default:
          throw new Error("Invalid rangeType: ".concat(rangeType));}

    }
    var getEndPrevious2 = function getEndPrevious2(rangeType, date) {
      switch (rangeType) {
        case 'decade':
          return getPreviousDecadeEnd(date, -100);

        case 'year':
          return getPreviousYearEnd(date, -10);

        case 'month':
          return getPreviousMonthEnd(date, -12);

        default:
          throw new Error("Invalid rangeType: ".concat(rangeType));}

    };
    /**
     * Returns an array with the beginning and the end of a given range.
     *
     * @param {string} rangeType Range type (e.g. 'day')
     * @param {Date} date Date.
     */

    function getRange(rangeType, date) {
      switch (rangeType) {
        case 'century':
          return getCenturyRange(date);

        case 'decade':
          return getDecadeRange(date);

        case 'year':
          return getYearRange(date);

        case 'month':
          return getMonthRange(date);

        case 'day':
          return getDayRange(date);

        default:
          throw new Error("Invalid rangeType: ".concat(rangeType));}

    }
    /**
     * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
     *
     * @param {string} rangeType Range type (e.g. 'day')
     * @param {Date} date1 First date.
     * @param {Date} date2 Second date.
     */

    function getValueRange(rangeType, date1, date2) {
      var rawNextValue = [date1, date2].sort(function (a, b) {
        return a - b;
      });
      return [getBegin$1(rangeType, rawNextValue[0]), getEnd$1(rangeType, rawNextValue[1])];
    }

    function toYearLabel(locale) {
      var formatYear$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : formatYear;
      var dates = arguments.length > 2 ? arguments[2] : undefined;
      return dates.map(function (date) {
        return formatYear$1(locale, date);
      }).join(' – ');
    }
    /**
     * Returns a string labelling a century of a given date.
     * For example, for 2017 it will return 2001-2100.
     *
     * @param {Date|String|Number} date Date or a year as a string or as a number.
     */


    function getCenturyLabel(locale, formatYear, date) {
      return toYearLabel(locale, formatYear, getCenturyRange(date));
    }
    /**
     * Returns a string labelling a century of a given date.
     * For example, for 2017 it will return 2011-2020.
     *
     * @param {Date|String|Number} date Date or a year as a string or as a number.
     */

    function getDecadeLabel(locale, formatYear, date) {
      return toYearLabel(locale, formatYear, getDecadeRange(date));
    }
    /**
     * Returns a boolean determining whether a given date is on Saturday or Sunday.
     *
     * @param {Date} date Date.
     */

    function isWeekend(date) {
      var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
      var weekday = date.getDay();

      switch (calendarType) {
        case CALENDAR_TYPES.ARABIC:
        case CALENDAR_TYPES.HEBREW:
          return weekday === FRIDAY || weekday === SATURDAY;

        case CALENDAR_TYPES.ISO_8601:
        case CALENDAR_TYPES.US:
          return weekday === SATURDAY || weekday === SUNDAY;

        default:
          throw new Error('Unsupported calendar type.');}

    }

    function _typeof$4(obj) {"@babel/helpers - typeof";return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof$4(obj);}
    var calendarTypes = Object.values(CALENDAR_TYPES);
    var allViews$2 = ['century', 'decade', 'year', 'month'];
    var isCalendarType = propTypes$1.exports.oneOf(calendarTypes);
    var isClassName = propTypes$1.exports.oneOfType([propTypes$1.exports.string, propTypes$1.exports.arrayOf(propTypes$1.exports.string)]);
    var isMinDate$1 = function isMinDate(props, propName, componentName) {
      var minDate = props[propName];

      if (!minDate) {
        return null;
      }

      if (!(minDate instanceof Date)) {
        return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$4(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
      }

      var maxDate = props.maxDate;

      if (maxDate && minDate > maxDate) {
        return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$4(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
      }

      return null;
    };
    var isMaxDate$1 = function isMaxDate(props, propName, componentName) {
      var maxDate = props[propName];

      if (!maxDate) {
        return null;
      }

      if (!(maxDate instanceof Date)) {
        return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$4(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
      }

      var minDate = props.minDate;

      if (minDate && maxDate < minDate) {
        return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$4(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
      }

      return null;
    };
    var isRef$1 = propTypes$1.exports.oneOfType([propTypes$1.exports.func, propTypes$1.exports.shape({
      current: propTypes$1.exports.any })]);

    var isValue = propTypes$1.exports.oneOfType([propTypes$1.exports.instanceOf(Date), propTypes$1.exports.arrayOf(propTypes$1.exports.instanceOf(Date))]);
    var isViews = propTypes$1.exports.arrayOf(propTypes$1.exports.oneOf(allViews$2));
    var isView = function isView(props, propName, componentName) {
      var view = props[propName];
      var views = props.views;
      var allowedViews = views || allViews$2;

      if (view !== undefined && allowedViews.indexOf(view) === -1) {
        return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function (a) {
          return "\"".concat(a, "\"");
        }).join(', '), "]."));
      } // Everything is fine


      return null;
    };

    isView.isRequired = function (props, propName, componentName) {
      var view = props[propName];

      if (!view) {
        return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
      }

      return isView(props, propName, componentName);
    };

    var tileGroupProps = {
      activeStartDate: propTypes$1.exports.instanceOf(Date).isRequired,
      hover: propTypes$1.exports.instanceOf(Date),
      locale: propTypes$1.exports.string,
      maxDate: isMaxDate$1,
      minDate: isMinDate$1,
      onClick: propTypes$1.exports.func,
      onMouseOver: propTypes$1.exports.func,
      tileClassName: propTypes$1.exports.oneOfType([propTypes$1.exports.func, isClassName]),
      tileContent: propTypes$1.exports.oneOfType([propTypes$1.exports.func, propTypes$1.exports.node]),
      value: isValue,
      valueType: propTypes$1.exports.string };

    var tileProps = {
      activeStartDate: propTypes$1.exports.instanceOf(Date).isRequired,
      classes: propTypes$1.exports.arrayOf(propTypes$1.exports.string).isRequired,
      date: propTypes$1.exports.instanceOf(Date).isRequired,
      locale: propTypes$1.exports.string,
      maxDate: isMaxDate$1,
      minDate: isMinDate$1,
      onClick: propTypes$1.exports.func,
      onMouseOver: propTypes$1.exports.func,
      style: propTypes$1.exports.objectOf(propTypes$1.exports.oneOfType([propTypes$1.exports.string, propTypes$1.exports.number])),
      tileClassName: propTypes$1.exports.oneOfType([propTypes$1.exports.func, isClassName]),
      tileContent: propTypes$1.exports.oneOfType([propTypes$1.exports.func, propTypes$1.exports.node]),
      tileDisabled: propTypes$1.exports.func };

    var className$6 = 'react-calendar__navigation';
    function Navigation(_ref) {
      var activeStartDate = _ref.activeStartDate,
      drillUp = _ref.drillUp,
      _ref$formatMonthYear = _ref.formatMonthYear,
      formatMonthYear$1 = _ref$formatMonthYear === void 0 ? formatMonthYear : _ref$formatMonthYear,
      _ref$formatYear = _ref.formatYear,
      formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear,
      locale = _ref.locale,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      _ref$navigationAriaLa = _ref.navigationAriaLabel,
      navigationAriaLabel = _ref$navigationAriaLa === void 0 ? '' : _ref$navigationAriaLa,
      navigationAriaLive = _ref.navigationAriaLive,
      navigationLabel = _ref.navigationLabel,
      _ref$next2AriaLabel = _ref.next2AriaLabel,
      next2AriaLabel = _ref$next2AriaLabel === void 0 ? '' : _ref$next2AriaLabel,
      _ref$next2Label = _ref.next2Label,
      next2Label = _ref$next2Label === void 0 ? '»' : _ref$next2Label,
      _ref$nextAriaLabel = _ref.nextAriaLabel,
      nextAriaLabel = _ref$nextAriaLabel === void 0 ? '' : _ref$nextAriaLabel,
      _ref$nextLabel = _ref.nextLabel,
      nextLabel = _ref$nextLabel === void 0 ? '›' : _ref$nextLabel,
      _ref$prev2AriaLabel = _ref.prev2AriaLabel,
      prev2AriaLabel = _ref$prev2AriaLabel === void 0 ? '' : _ref$prev2AriaLabel,
      _ref$prev2Label = _ref.prev2Label,
      prev2Label = _ref$prev2Label === void 0 ? '«' : _ref$prev2Label,
      _ref$prevAriaLabel = _ref.prevAriaLabel,
      prevAriaLabel = _ref$prevAriaLabel === void 0 ? '' : _ref$prevAriaLabel,
      _ref$prevLabel = _ref.prevLabel,
      prevLabel = _ref$prevLabel === void 0 ? '‹' : _ref$prevLabel,
      setActiveStartDate = _ref.setActiveStartDate,
      showDoubleView = _ref.showDoubleView,
      view = _ref.view,
      views = _ref.views;
      var drillUpAvailable = views.indexOf(view) > 0;
      var shouldShowPrevNext2Buttons = view !== 'century';
      var previousActiveStartDate = getBeginPrevious(view, activeStartDate);
      var previousActiveStartDate2 = shouldShowPrevNext2Buttons && getBeginPrevious2(view, activeStartDate);
      var nextActiveStartDate = getBeginNext(view, activeStartDate);
      var nextActiveStartDate2 = shouldShowPrevNext2Buttons && getBeginNext2(view, activeStartDate);

      var prevButtonDisabled = function () {
        if (previousActiveStartDate.getFullYear() < 0) {
          return true;
        }

        var previousActiveEndDate = getEndPrevious(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
      }();

      var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function () {
        if (previousActiveStartDate2.getFullYear() < 0) {
          return true;
        }

        var previousActiveEndDate = getEndPrevious2(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
      }();

      var nextButtonDisabled = maxDate && maxDate < nextActiveStartDate;
      var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate < nextActiveStartDate2;

      function onClickPrevious() {
        setActiveStartDate(previousActiveStartDate, 'prev');
      }

      function onClickPrevious2() {
        setActiveStartDate(previousActiveStartDate2, 'prev2');
      }

      function onClickNext() {
        setActiveStartDate(nextActiveStartDate, 'next');
      }

      function onClickNext2() {
        setActiveStartDate(nextActiveStartDate2, 'next2');
      }

      function renderLabel(date) {
        var label = function () {
          switch (view) {
            case 'century':
              return getCenturyLabel(locale, formatYear$1, date);

            case 'decade':
              return getDecadeLabel(locale, formatYear$1, date);

            case 'year':
              return formatYear$1(locale, date);

            case 'month':
              return formatMonthYear$1(locale, date);

            default:
              throw new Error("Invalid view: ".concat(view, "."));}

        }();

        return navigationLabel ? navigationLabel({
          date: date,
          label: label,
          locale: locale || getUserLocale(),
          view: view }) :
        label;
      }

      function renderButton() {
        var labelClassName = "".concat(className$6, "__label");
        return /*#__PURE__*/React__default["default"].createElement("button", {
          "aria-label": navigationAriaLabel,
          "aria-live": navigationAriaLive,
          className: labelClassName,
          disabled: !drillUpAvailable,
          onClick: drillUp,
          style: {
            flexGrow: 1 },

          type: "button" },
        /*#__PURE__*/React__default["default"].createElement("span", {
          className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--from") },
        renderLabel(activeStartDate)), showDoubleView && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
          className: "".concat(labelClassName, "__divider") },
        " \u2013 "), /*#__PURE__*/React__default["default"].createElement("span", {
          className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--to") },
        renderLabel(nextActiveStartDate))));
      }

      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: className$6 },
      prev2Label !== null && shouldShowPrevNext2Buttons && /*#__PURE__*/React__default["default"].createElement("button", {
        "aria-label": prev2AriaLabel,
        className: "".concat(className$6, "__arrow ").concat(className$6, "__prev2-button"),
        disabled: prev2ButtonDisabled,
        onClick: onClickPrevious2,
        type: "button" },
      prev2Label), prevLabel !== null && /*#__PURE__*/React__default["default"].createElement("button", {
        "aria-label": prevAriaLabel,
        className: "".concat(className$6, "__arrow ").concat(className$6, "__prev-button"),
        disabled: prevButtonDisabled,
        onClick: onClickPrevious,
        type: "button" },
      prevLabel), renderButton(), nextLabel !== null && /*#__PURE__*/React__default["default"].createElement("button", {
        "aria-label": nextAriaLabel,
        className: "".concat(className$6, "__arrow ").concat(className$6, "__next-button"),
        disabled: nextButtonDisabled,
        onClick: onClickNext,
        type: "button" },
      nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && /*#__PURE__*/React__default["default"].createElement("button", {
        "aria-label": next2AriaLabel,
        className: "".concat(className$6, "__arrow ").concat(className$6, "__next2-button"),
        disabled: next2ButtonDisabled,
        onClick: onClickNext2,
        type: "button" },
      next2Label));
    }
    Navigation.propTypes = {
      activeStartDate: propTypes$1.exports.instanceOf(Date).isRequired,
      drillUp: propTypes$1.exports.func.isRequired,
      formatMonthYear: propTypes$1.exports.func,
      formatYear: propTypes$1.exports.func,
      locale: propTypes$1.exports.string,
      maxDate: propTypes$1.exports.instanceOf(Date),
      minDate: propTypes$1.exports.instanceOf(Date),
      navigationAriaLabel: propTypes$1.exports.string,
      navigationAriaLive: propTypes$1.exports.string,
      navigationLabel: propTypes$1.exports.func,
      next2AriaLabel: propTypes$1.exports.string,
      next2Label: propTypes$1.exports.node,
      nextAriaLabel: propTypes$1.exports.string,
      nextLabel: propTypes$1.exports.node,
      prev2AriaLabel: propTypes$1.exports.string,
      prev2Label: propTypes$1.exports.node,
      prevAriaLabel: propTypes$1.exports.string,
      prevLabel: propTypes$1.exports.node,
      setActiveStartDate: propTypes$1.exports.func.isRequired,
      showDoubleView: propTypes$1.exports.bool,
      view: isView.isRequired,
      views: isViews.isRequired };

    var _excluded$a = ["children", "className", "direction", "count", "offset", "style", "wrap"];

    function _extends$c() {_extends$c = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$c.apply(this, arguments);}

    function ownKeys$d(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$d(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) {_defineProperty$L(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$L(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _objectWithoutProperties$a(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose$a(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

    function _objectWithoutPropertiesLoose$a(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}

    function toPercent(num) {
      return "".concat(num, "%");
    }

    function Flex(_ref) {
      var children = _ref.children,
      className = _ref.className,
      direction = _ref.direction,
      count = _ref.count,
      offset = _ref.offset,
      style = _ref.style,
      wrap = _ref.wrap,
      otherProps = _objectWithoutProperties$a(_ref, _excluded$a);

      return /*#__PURE__*/React__default["default"].createElement("div", _extends$c({
        className: className,
        style: _objectSpread$d({
          display: 'flex',
          flexDirection: direction,
          flexWrap: wrap ? 'wrap' : 'no-wrap' },
        style) },
      otherProps), React__default["default"].Children.map(children, function (child, index) {
        return /*#__PURE__*/React__default["default"].cloneElement(child, _objectSpread$d(_objectSpread$d({}, child.props), {}, {
          style: {
            flexBasis: toPercent(100 / count),
            flexShrink: 0,
            flexGrow: 0,
            overflow: 'hidden',
            marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null } }));


      }));
    }
    Flex.propTypes = {
      children: propTypes$1.exports.node,
      className: propTypes$1.exports.string,
      count: propTypes$1.exports.number.isRequired,
      direction: propTypes$1.exports.string,
      offset: propTypes$1.exports.number,
      style: propTypes$1.exports.objectOf(propTypes$1.exports.oneOfType([propTypes$1.exports.string, propTypes$1.exports.number])),
      wrap: propTypes$1.exports.bool };

    function _toConsumableArray$3(arr) {return _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread$3();}

    function _nonIterableSpread$3() {throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

    function _unsupportedIterableToArray$3(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);}

    function _iterableToArray$3(iter) {if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);}

    function _arrayWithoutHoles$3(arr) {if (Array.isArray(arr)) return _arrayLikeToArray$3(arr);}

    function _arrayLikeToArray$3(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}
    /**
     * Returns a value no smaller than min and no larger than max.
     *
     * @param {*} value Value to return.
     * @param {*} min Minimum return value.
     * @param {*} max Maximum return value.
     */

    function between$1(value, min, max) {
      if (min && min > value) {
        return min;
      }

      if (max && max < value) {
        return max;
      }

      return value;
    }
    function isValueWithinRange(value, range) {
      return range[0] <= value && range[1] >= value;
    }
    function isRangeWithinRange(greaterRange, smallerRange) {
      return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
    }
    function doRangesOverlap(range1, range2) {
      return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
    }

    function getRangeClassNames(valueRange, dateRange, baseClassName) {
      var isRange = doRangesOverlap(dateRange, valueRange);
      var classes = [];

      if (isRange) {
        classes.push(baseClassName);
        var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
        var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);

        if (isRangeStart) {
          classes.push("".concat(baseClassName, "Start"));
        }

        if (isRangeEnd) {
          classes.push("".concat(baseClassName, "End"));
        }

        if (isRangeStart && isRangeEnd) {
          classes.push("".concat(baseClassName, "BothEnds"));
        }
      }

      return classes;
    }

    function getTileClasses() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      value = _ref.value,
      valueType = _ref.valueType,
      date = _ref.date,
      dateType = _ref.dateType,
      hover = _ref.hover;

      var className = 'react-calendar__tile';
      var classes = [className];

      if (!date) {
        return classes;
      }

      if (!Array.isArray(date) && !dateType) {
        throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
      }

      var now = new Date();
      var dateRange = Array.isArray(date) ? date : getRange(dateType, date);

      if (isValueWithinRange(now, dateRange)) {
        classes.push("".concat(className, "--now"));
      }

      if (!value) {
        return classes;
      }

      if (!Array.isArray(value) && !valueType) {
        throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
      }

      var valueRange = Array.isArray(value) ? value : getRange(valueType, value);

      if (isRangeWithinRange(valueRange, dateRange)) {
        classes.push("".concat(className, "--active"));
      } else if (doRangesOverlap(valueRange, dateRange)) {
        classes.push("".concat(className, "--hasActive"));
      }

      var valueRangeClassNames = getRangeClassNames(valueRange, dateRange, "".concat(className, "--range"));
      classes.push.apply(classes, _toConsumableArray$3(valueRangeClassNames));
      var valueArray = [].concat(value);

      if (hover && valueArray.length === 1) {
        var hoverRange = hover > valueRange[0] ? [valueRange[0], hover] : [hover, valueRange[0]];
        var hoverRangeClassNames = getRangeClassNames(hoverRange, dateRange, "".concat(className, "--hover"));
        classes.push.apply(classes, _toConsumableArray$3(hoverRangeClassNames));
      }

      return classes;
    }

    var _excluded$9 = ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"];

    function ownKeys$c(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$c(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) {_defineProperty$K(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$K(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _extends$b() {_extends$b = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$b.apply(this, arguments);}

    function _objectWithoutProperties$9(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose$9(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

    function _objectWithoutPropertiesLoose$9(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}
    function TileGroup(_ref) {
      var className = _ref.className,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 3 : _ref$count,
      dateTransform = _ref.dateTransform,
      dateType = _ref.dateType,
      end = _ref.end,
      hover = _ref.hover,
      offset = _ref.offset,
      start = _ref.start,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      Tile = _ref.tile,
      value = _ref.value,
      valueType = _ref.valueType,
      tileProps = _objectWithoutProperties$9(_ref, _excluded$9);

      var tiles = [];

      for (var point = start; point <= end; point += step) {
        var date = dateTransform(point);
        tiles.push( /*#__PURE__*/React__default["default"].createElement(Tile, _extends$b({
          key: date.getTime(),
          classes: getTileClasses({
            value: value,
            valueType: valueType,
            date: date,
            dateType: dateType,
            hover: hover }),

          date: date,
          point: point },
        tileProps)));
      }

      return /*#__PURE__*/React__default["default"].createElement(Flex, {
        className: className,
        count: count,
        offset: offset,
        wrap: true },
      tiles);
    }
    TileGroup.propTypes = _objectSpread$c(_objectSpread$c({}, tileGroupProps), {}, {
      activeStartDate: propTypes$1.exports.instanceOf(Date),
      count: propTypes$1.exports.number,
      dateTransform: propTypes$1.exports.func.isRequired,
      dateType: propTypes$1.exports.string,
      offset: propTypes$1.exports.number,
      step: propTypes$1.exports.number,
      tile: propTypes$1.exports.func.isRequired });

    function _typeof$3(obj) {"@babel/helpers - typeof";return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof$3(obj);}

    function ownKeys$b(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$b(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) {_defineProperty$J(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _classCallCheck$2(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

    function _defineProperties$2(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

    function _createClass$2(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);if (staticProps) _defineProperties$2(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

    function _inherits$2(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) _setPrototypeOf$2(subClass, superClass);}

    function _setPrototypeOf$2(o, p) {_setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return _setPrototypeOf$2(o, p);}

    function _createSuper$2(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct$2();return function _createSuperInternal() {var Super = _getPrototypeOf$2(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = _getPrototypeOf$2(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return _possibleConstructorReturn$2(this, result);};}

    function _possibleConstructorReturn$2(self, call) {if (call && (_typeof$3(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized$2(self);}

    function _assertThisInitialized$2(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

    function _isNativeReflectConstruct$2() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

    function _getPrototypeOf$2(o) {_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return _getPrototypeOf$2(o);}

    function _defineProperty$J(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function datesAreDifferent(date1, date2) {
      return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
    }

    function getValue$2(nextProps, prop) {
      var activeStartDate = nextProps.activeStartDate,
      date = nextProps.date,
      view = nextProps.view;
      return typeof prop === 'function' ? prop({
        activeStartDate: activeStartDate,
        date: date,
        view: view }) :
      prop;
    }

    var Tile = /*#__PURE__*/function (_Component) {
      _inherits$2(Tile, _Component);

      var _super = _createSuper$2(Tile);

      function Tile() {
        var _this;

        _classCallCheck$2(this, Tile);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty$J(_assertThisInitialized$2(_this), "state", {});

        return _this;
      }

      _createClass$2(Tile, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
          activeStartDate = _this$props.activeStartDate,
          children = _this$props.children,
          classes = _this$props.classes,
          date = _this$props.date,
          formatAbbr = _this$props.formatAbbr,
          locale = _this$props.locale,
          maxDate = _this$props.maxDate,
          maxDateTransform = _this$props.maxDateTransform,
          minDate = _this$props.minDate,
          minDateTransform = _this$props.minDateTransform,
          onClick = _this$props.onClick,
          onMouseOver = _this$props.onMouseOver,
          style = _this$props.style,
          tileDisabled = _this$props.tileDisabled,
          view = _this$props.view;
          var _this$state = this.state,
          tileClassName = _this$state.tileClassName,
          tileContent = _this$state.tileContent;
          return /*#__PURE__*/React__default["default"].createElement("button", {
            className: mergeClassNames(classes, tileClassName),
            disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
              activeStartDate: activeStartDate,
              date: date,
              view: view }),

            onClick: onClick && function (event) {
              return onClick(date, event);
            },
            onFocus: onMouseOver && function () {
              return onMouseOver(date);
            },
            onMouseOver: onMouseOver && function () {
              return onMouseOver(date);
            },
            style: style,
            type: "button" },
          formatAbbr ? /*#__PURE__*/React__default["default"].createElement("abbr", {
            "aria-label": formatAbbr(locale, date) },
          children) : children, tileContent);
        } }],
      [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(nextProps, prevState) {
          var activeStartDate = nextProps.activeStartDate,
          tileClassName = nextProps.tileClassName,
          tileContent = nextProps.tileContent;
          var nextState = {};

          if (tileClassName !== prevState.tileClassNameProps || datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
            nextState.tileClassName = getValue$2(nextProps, tileClassName);
            nextState.tileClassNameProps = tileClassName;
          }

          if (tileContent !== prevState.tileContentProps || datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
            nextState.tileContent = getValue$2(nextProps, tileContent);
            nextState.tileContentProps = tileContent;
          }

          nextState.activeStartDateProps = activeStartDate;
          return nextState;
        } }]);


      return Tile;
    }(React.Component);
    Tile.propTypes = _objectSpread$b(_objectSpread$b({}, tileProps), {}, {
      children: propTypes$1.exports.node.isRequired,
      formatAbbr: propTypes$1.exports.func,
      maxDateTransform: propTypes$1.exports.func.isRequired,
      minDateTransform: propTypes$1.exports.func.isRequired });

    var _excluded$8 = ["classes", "formatYear"];

    function ownKeys$a(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$a(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) {_defineProperty$I(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$I(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _extends$a() {_extends$a = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$a.apply(this, arguments);}

    function _objectWithoutProperties$8(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose$8(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

    function _objectWithoutPropertiesLoose$8(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}
    var className$5 = 'react-calendar__century-view__decades__decade';
    function Decade(_ref) {
      var classes = _ref.classes,
      _ref$formatYear = _ref.formatYear,
      formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear,
      otherProps = _objectWithoutProperties$8(_ref, _excluded$8);

      var date = otherProps.date,
      locale = otherProps.locale;
      return /*#__PURE__*/React__default["default"].createElement(Tile, _extends$a({}, otherProps, {
        classes: [].concat(classes, className$5),
        maxDateTransform: getDecadeEnd,
        minDateTransform: getDecadeStart,
        view: "century" }),
      getDecadeLabel(locale, formatYear$1, date));
    }
    Decade.propTypes = _objectSpread$a(_objectSpread$a({}, tileProps), {}, {
      formatYear: propTypes$1.exports.func });

    function ownKeys$9(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$9(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) {_defineProperty$H(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$H(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _extends$9() {_extends$9 = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$9.apply(this, arguments);}
    function Decades(props) {
      var activeStartDate = props.activeStartDate;
      var start = getBeginOfCenturyYear(activeStartDate);
      var end = start + 99;
      return /*#__PURE__*/React__default["default"].createElement(TileGroup, _extends$9({}, props, {
        className: "react-calendar__century-view__decades",
        dateTransform: getDecadeStart,
        dateType: "decade",
        end: end,
        start: start,
        step: 10,
        tile: Decade }));

    }
    Decades.propTypes = _objectSpread$9({}, tileGroupProps);

    function CenturyView(props) {
      function renderDecades() {
        return /*#__PURE__*/React__default["default"].createElement(Decades, props);
      }

      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: "react-calendar__century-view" },
      renderDecades());
    }

    var _excluded$7 = ["classes", "formatYear"];

    function ownKeys$8(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$8(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) {_defineProperty$G(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$G(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _extends$8() {_extends$8 = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$8.apply(this, arguments);}

    function _objectWithoutProperties$7(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose$7(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

    function _objectWithoutPropertiesLoose$7(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}
    var className$4 = 'react-calendar__decade-view__years__year';
    function Year(_ref) {
      var classes = _ref.classes,
      _ref$formatYear = _ref.formatYear,
      formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear,
      otherProps = _objectWithoutProperties$7(_ref, _excluded$7);

      var date = otherProps.date,
      locale = otherProps.locale;
      return /*#__PURE__*/React__default["default"].createElement(Tile, _extends$8({}, otherProps, {
        classes: [].concat(classes, className$4),
        maxDateTransform: getYearEnd,
        minDateTransform: getYearStart,
        view: "decade" }),
      formatYear$1(locale, date));
    }
    Year.propTypes = _objectSpread$8(_objectSpread$8({}, tileProps), {}, {
      formatYear: propTypes$1.exports.func });

    function ownKeys$7(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$7(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) {_defineProperty$F(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$F(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _extends$7() {_extends$7 = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$7.apply(this, arguments);}
    function Years(props) {
      var activeStartDate = props.activeStartDate;
      var start = getBeginOfDecadeYear(activeStartDate);
      var end = start + 9;
      return /*#__PURE__*/React__default["default"].createElement(TileGroup, _extends$7({}, props, {
        className: "react-calendar__decade-view__years",
        dateTransform: function dateTransform(year) {
          var date = new Date();
          date.setFullYear(year, 0, 1);
          date.setHours(0, 0, 0, 0);
          return date;
        },
        dateType: "year",
        end: end,
        start: start,
        tile: Year }));

    }
    Years.propTypes = _objectSpread$7({}, tileGroupProps);

    function DecadeView(props) {
      function renderYears() {
        return /*#__PURE__*/React__default["default"].createElement(Years, props);
      }

      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: "react-calendar__decade-view" },
      renderYears());
    }

    var _excluded$6 = ["classes", "formatMonth", "formatMonthYear"];

    function ownKeys$6(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$6(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) {_defineProperty$E(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$E(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _extends$6() {_extends$6 = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$6.apply(this, arguments);}

    function _objectWithoutProperties$6(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose$6(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

    function _objectWithoutPropertiesLoose$6(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}
    var className$3 = 'react-calendar__year-view__months__month';
    function Month(_ref) {
      var classes = _ref.classes,
      _ref$formatMonth = _ref.formatMonth,
      formatMonth = _ref$formatMonth === void 0 ? formatMonth$1 : _ref$formatMonth,
      _ref$formatMonthYear = _ref.formatMonthYear,
      formatMonthYear$1 = _ref$formatMonthYear === void 0 ? formatMonthYear : _ref$formatMonthYear,
      otherProps = _objectWithoutProperties$6(_ref, _excluded$6);

      var date = otherProps.date,
      locale = otherProps.locale;
      return /*#__PURE__*/React__default["default"].createElement(Tile, _extends$6({}, otherProps, {
        classes: [].concat(classes, className$3),
        formatAbbr: formatMonthYear$1,
        maxDateTransform: getMonthEnd,
        minDateTransform: getMonthStart,
        view: "year" }),
      formatMonth(locale, date));
    }
    Month.propTypes = _objectSpread$6(_objectSpread$6({}, tileProps), {}, {
      formatMonth: propTypes$1.exports.func,
      formatMonthYear: propTypes$1.exports.func });

    function ownKeys$5(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$5(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) {_defineProperty$D(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$D(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _extends$5() {_extends$5 = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$5.apply(this, arguments);}
    function Months(props) {
      var activeStartDate = props.activeStartDate;
      var start = 0;
      var end = 11;
      var year = getYear(activeStartDate);
      return /*#__PURE__*/React__default["default"].createElement(TileGroup, _extends$5({}, props, {
        className: "react-calendar__year-view__months",
        dateTransform: function dateTransform(monthIndex) {
          var date = new Date();
          date.setFullYear(year, monthIndex, 1);
          date.setHours(0, 0, 0, 0);
          return date;
        },
        dateType: "month",
        end: end,
        start: start,
        tile: Month }));

    }
    Months.propTypes = _objectSpread$5(_objectSpread$5({}, tileGroupProps), {}, {
      locale: propTypes$1.exports.string });

    function YearView(props) {
      function renderMonths() {
        return /*#__PURE__*/React__default["default"].createElement(Months, props);
      }

      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: "react-calendar__year-view" },
      renderMonths());
    }

    var _excluded$5 = ["formatDay", "formatLongDate", "calendarType", "classes", "currentMonthIndex"];

    function ownKeys$4(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$4(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) {_defineProperty$C(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$C(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _extends$4() {_extends$4 = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$4.apply(this, arguments);}

    function _objectWithoutProperties$5(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose$5(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

    function _objectWithoutPropertiesLoose$5(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}
    var className$2 = 'react-calendar__month-view__days__day';
    function Day(_ref) {
      var _ref$formatDay = _ref.formatDay,
      formatDay$1 = _ref$formatDay === void 0 ? formatDay : _ref$formatDay,
      _ref$formatLongDate = _ref.formatLongDate,
      formatLongDate$1 = _ref$formatLongDate === void 0 ? formatLongDate : _ref$formatLongDate,
      calendarType = _ref.calendarType,
      classes = _ref.classes,
      currentMonthIndex = _ref.currentMonthIndex,
      otherProps = _objectWithoutProperties$5(_ref, _excluded$5);

      var date = otherProps.date,
      locale = otherProps.locale;
      return /*#__PURE__*/React__default["default"].createElement(Tile, _extends$4({}, otherProps, {
        classes: [].concat(classes, className$2, isWeekend(date, calendarType) ? "".concat(className$2, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(className$2, "--neighboringMonth") : null),
        formatAbbr: formatLongDate$1,
        maxDateTransform: getDayEnd,
        minDateTransform: getDayStart,
        view: "month" }),
      formatDay$1(locale, date));
    }
    Day.propTypes = _objectSpread$4(_objectSpread$4({}, tileProps), {}, {
      currentMonthIndex: propTypes$1.exports.number.isRequired,
      formatDay: propTypes$1.exports.func,
      formatLongDate: propTypes$1.exports.func });

    var _excluded$4 = ["showFixedNumberOfWeeks", "showNeighboringMonth"];

    function ownKeys$3(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$3(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) {_defineProperty$B(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$B(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _extends$3() {_extends$3 = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$3.apply(this, arguments);}

    function _objectWithoutProperties$4(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose$4(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

    function _objectWithoutPropertiesLoose$4(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}
    function Days(props) {
      var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType;

      var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks,
      showNeighboringMonth = props.showNeighboringMonth,
      otherProps = _objectWithoutProperties$4(props, _excluded$4);

      var year = getYear(activeStartDate);
      var monthIndex = getMonth(activeStartDate);
      var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
      var dayOfWeek = getDayOfWeek(activeStartDate, calendarType);
      var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
      /**
       * Defines on which day of the month the grid shall start. If we simply show current
       * month, we obviously start on day one, but if showNeighboringMonth is set to
       * true, we need to find the beginning of the week the first day of the month is in.
       */

      var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
      /**
       * Defines on which day of the month the grid shall end. If we simply show current
       * month, we need to stop on the last day of the month, but if showNeighboringMonth
       * is set to true, we need to find the end of the week the last day of the month is in.
       */

      var end = function () {
        if (showFixedNumberOfWeeks) {
          // Always show 6 weeks
          return start + 6 * 7 - 1;
        }

        var daysInMonth = getDaysInMonth(activeStartDate);

        if (showNeighboringMonth) {
          var activeEndDate = new Date();
          activeEndDate.setFullYear(year, monthIndex, daysInMonth);
          activeEndDate.setHours(0, 0, 0, 0);
          var daysUntilEndOfTheWeek = 7 - getDayOfWeek(activeEndDate, calendarType) - 1;
          return daysInMonth + daysUntilEndOfTheWeek;
        }

        return daysInMonth;
      }();

      return /*#__PURE__*/React__default["default"].createElement(TileGroup, _extends$3({}, otherProps, {
        className: "react-calendar__month-view__days",
        count: 7,
        currentMonthIndex: monthIndex,
        dateTransform: function dateTransform(day) {
          var date = new Date();
          date.setFullYear(year, monthIndex, day);
          date.setHours(0, 0, 0, 0);
          return date;
        },
        dateType: "day",
        end: end,
        offset: offset,
        start: start,
        tile: Day }));

    }
    Days.propTypes = _objectSpread$3({
      calendarType: isCalendarType.isRequired,
      showFixedNumberOfWeeks: propTypes$1.exports.bool,
      showNeighboringMonth: propTypes$1.exports.bool },
    tileGroupProps);

    var className$1 = 'react-calendar__month-view__weekdays';
    function Weekdays(props) {
      var calendarType = props.calendarType,
      _props$formatShortWee = props.formatShortWeekday,
      formatShortWeekday$1 = _props$formatShortWee === void 0 ? formatShortWeekday : _props$formatShortWee,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave;
      var anyDate = new Date();
      var beginOfMonth = getMonthStart(anyDate);
      var year = getYear(beginOfMonth);
      var monthIndex = getMonth(beginOfMonth);
      var weekdays = [];

      for (var weekday = 1; weekday <= 7; weekday += 1) {
        var weekdayDate = new Date(year, monthIndex, weekday - getDayOfWeek(beginOfMonth, calendarType));
        var abbr = formatWeekday(locale, weekdayDate);
        weekdays.push( /*#__PURE__*/React__default["default"].createElement("div", {
          key: weekday,
          className: "".concat(className$1, "__weekday") },
        /*#__PURE__*/React__default["default"].createElement("abbr", {
          "aria-label": abbr,
          title: abbr },
        formatShortWeekday$1(locale, weekdayDate).replace('.', ''))));
      }

      return /*#__PURE__*/React__default["default"].createElement(Flex, {
        className: className$1,
        count: 7,
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave },
      weekdays);
    }
    Weekdays.propTypes = {
      calendarType: isCalendarType.isRequired,
      formatShortWeekday: propTypes$1.exports.func,
      locale: propTypes$1.exports.string,
      onMouseLeave: propTypes$1.exports.func };

    var _excluded$3 = ["date", "onClickWeekNumber", "weekNumber"];

    function _extends$2() {_extends$2 = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$2.apply(this, arguments);}

    function ownKeys$2(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$2(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) {_defineProperty$A(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$A(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _objectWithoutProperties$3(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose$3(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

    function _objectWithoutPropertiesLoose$3(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}
    var className = 'react-calendar__tile';
    function WeekNumber(_ref) {
      var date = _ref.date,
      onClickWeekNumber = _ref.onClickWeekNumber,
      weekNumber = _ref.weekNumber,
      otherProps = _objectWithoutProperties$3(_ref, _excluded$3);

      var props = _objectSpread$2({
        className: className },
      otherProps);

      var children = /*#__PURE__*/React__default["default"].createElement("span", null, weekNumber);
      return onClickWeekNumber ? /*#__PURE__*/React__default["default"].createElement("button", _extends$2({}, props, {
        onClick: function onClick(event) {
          return onClickWeekNumber(weekNumber, date, event);
        },
        type: "button" }),
      children) : /*#__PURE__*/React__default["default"].createElement("div", props, children);
    }
    WeekNumber.propTypes = {
      date: propTypes$1.exports.instanceOf(Date).isRequired,
      onClickWeekNumber: propTypes$1.exports.func,
      weekNumber: propTypes$1.exports.node.isRequired };

    function WeekNumbers(props) {
      var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType,
      onClickWeekNumber = props.onClickWeekNumber,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

      var numberOfWeeks = function () {
        if (showFixedNumberOfWeeks) {
          return 6;
        }

        var numberOfDays = getDaysInMonth(activeStartDate);
        var startWeekday = getDayOfWeek(activeStartDate, calendarType);
        var days = numberOfDays - (7 - startWeekday);
        return 1 + Math.ceil(days / 7);
      }();

      var dates = function () {
        var year = getYear(activeStartDate);
        var monthIndex = getMonth(activeStartDate);
        var day = getDate(activeStartDate);
        var result = [];

        for (var index = 0; index < numberOfWeeks; index += 1) {
          result.push(getBeginOfWeek(new Date(year, monthIndex, day + index * 7), calendarType));
        }

        return result;
      }();

      var weekNumbers = dates.map(function (date) {
        return getWeekNumber(date, calendarType);
      });
      return /*#__PURE__*/React__default["default"].createElement(Flex, {
        className: "react-calendar__month-view__weekNumbers",
        count: numberOfWeeks,
        direction: "column",
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave,
        style: {
          flexBasis: 'calc(100% * (1 / 8)',
          flexShrink: 0 } },

      weekNumbers.map(function (weekNumber, weekIndex) {
        return /*#__PURE__*/React__default["default"].createElement(WeekNumber, {
          key: weekNumber,
          date: dates[weekIndex],
          onClickWeekNumber: onClickWeekNumber,
          weekNumber: weekNumber });

      }));
    }
    WeekNumbers.propTypes = {
      activeStartDate: propTypes$1.exports.instanceOf(Date).isRequired,
      calendarType: isCalendarType.isRequired,
      onClickWeekNumber: propTypes$1.exports.func,
      onMouseLeave: propTypes$1.exports.func,
      showFixedNumberOfWeeks: propTypes$1.exports.bool };

    var _excluded$2 = ["calendarType", "formatShortWeekday", "onClickWeekNumber", "showWeekNumbers"];

    function _extends$1() {_extends$1 = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends$1.apply(this, arguments);}

    function _objectWithoutProperties$2(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose$2(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

    function _objectWithoutPropertiesLoose$2(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}

    function getCalendarTypeFromLocale(locale) {
      return Object.keys(CALENDAR_TYPE_LOCALES).find(function (calendarType) {
        return CALENDAR_TYPE_LOCALES[calendarType].includes(locale);
      }) || CALENDAR_TYPES.ISO_8601;
    }

    function MonthView(props) {
      var activeStartDate = props.activeStartDate,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

      var _props$calendarType = props.calendarType,
      calendarType = _props$calendarType === void 0 ? getCalendarTypeFromLocale(locale) : _props$calendarType,
      formatShortWeekday = props.formatShortWeekday,
      onClickWeekNumber = props.onClickWeekNumber,
      showWeekNumbers = props.showWeekNumbers,
      childProps = _objectWithoutProperties$2(props, _excluded$2);

      function renderWeekdays() {
        return /*#__PURE__*/React__default["default"].createElement(Weekdays, {
          calendarType: calendarType,
          formatShortWeekday: formatShortWeekday,
          locale: locale,
          onMouseLeave: onMouseLeave });

      }

      function renderWeekNumbers() {
        if (!showWeekNumbers) {
          return null;
        }

        return /*#__PURE__*/React__default["default"].createElement(WeekNumbers, {
          activeStartDate: activeStartDate,
          calendarType: calendarType,
          onClickWeekNumber: onClickWeekNumber,
          onMouseLeave: onMouseLeave,
          showFixedNumberOfWeeks: showFixedNumberOfWeeks });

      }

      function renderDays() {
        return /*#__PURE__*/React__default["default"].createElement(Days, _extends$1({
          calendarType: calendarType },
        childProps));
      }

      var className = 'react-calendar__month-view';
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: mergeClassNames(className, showWeekNumbers ? "".concat(className, "--weekNumbers") : '') },
      /*#__PURE__*/React__default["default"].createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'flex-end' } },

      renderWeekNumbers(), /*#__PURE__*/React__default["default"].createElement("div", {
        style: {
          flexGrow: 1,
          width: '100%' } },

      renderWeekdays(), renderDays())));
    }
    MonthView.propTypes = {
      activeStartDate: propTypes$1.exports.instanceOf(Date).isRequired,
      calendarType: isCalendarType,
      formatShortWeekday: propTypes$1.exports.func,
      locale: propTypes$1.exports.string,
      onClickWeekNumber: propTypes$1.exports.func,
      onMouseLeave: propTypes$1.exports.func,
      showFixedNumberOfWeeks: propTypes$1.exports.bool,
      showWeekNumbers: propTypes$1.exports.bool };

    var _excluded$1 = ["activeStartDate", "defaultActiveStartDate", "defaultValue", "defaultView", "maxDetail", "minDetail", "value", "view"];

    function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}

    function _typeof$2(obj) {"@babel/helpers - typeof";return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof$2(obj);}

    function _classCallCheck$1(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

    function _defineProperties$1(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

    function _createClass$1(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);if (staticProps) _defineProperties$1(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

    function _inherits$1(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) _setPrototypeOf$1(subClass, superClass);}

    function _setPrototypeOf$1(o, p) {_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return _setPrototypeOf$1(o, p);}

    function _createSuper$1(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct$1();return function _createSuperInternal() {var Super = _getPrototypeOf$1(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = _getPrototypeOf$1(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return _possibleConstructorReturn$1(this, result);};}

    function _possibleConstructorReturn$1(self, call) {if (call && (_typeof$2(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized$1(self);}

    function _assertThisInitialized$1(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

    function _isNativeReflectConstruct$1() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

    function _getPrototypeOf$1(o) {_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return _getPrototypeOf$1(o);}

    function ownKeys$1(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread$1(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {_defineProperty$z(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

    function _defineProperty$z(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _objectWithoutProperties$1(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose$1(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

    function _objectWithoutPropertiesLoose$1(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}

    function _toConsumableArray$2(arr) {return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$2();}

    function _nonIterableSpread$2() {throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

    function _unsupportedIterableToArray$2(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);}

    function _iterableToArray$2(iter) {if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);}

    function _arrayWithoutHoles$2(arr) {if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);}

    function _arrayLikeToArray$2(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}
    var defaultMinDate = new Date();
    defaultMinDate.setFullYear(1, 0, 1);
    defaultMinDate.setHours(0, 0, 0, 0);
    var defaultMaxDate = new Date(8.64e15);
    var baseClassName = 'react-calendar';
    var allViews$1 = ['century', 'decade', 'year', 'month'];
    var allValueTypes$1 = [].concat(_toConsumableArray$2(allViews$1.slice(1)), ['day']);

    function toDate$1(value) {
      if (value instanceof Date) {
        return value;
      }

      return new Date(value);
    }
    /**
     * Returns views array with disallowed values cut off.
     */


    function getLimitedViews(minDetail, maxDetail) {
      return allViews$1.slice(allViews$1.indexOf(minDetail), allViews$1.indexOf(maxDetail) + 1);
    }
    /**
     * Determines whether a given view is allowed with currently applied settings.
     */


    function isViewAllowed(view, minDetail, maxDetail) {
      var views = getLimitedViews(minDetail, maxDetail);
      return views.indexOf(view) !== -1;
    }
    /**
     * Gets either provided view if allowed by minDetail and maxDetail, or gets
     * the default view if not allowed.
     */


    function getView(view, minDetail, maxDetail) {
      if (isViewAllowed(view, minDetail, maxDetail)) {
        return view;
      }

      return maxDetail;
    }
    /**
     * Returns value type that can be returned with currently applied settings.
     */


    function getValueType(maxDetail) {
      return allValueTypes$1[allViews$1.indexOf(maxDetail)];
    }

    function getValue$1(value, index) {
      if (!value) {
        return null;
      }

      var rawValue = Array.isArray(value) && value.length === 2 ? value[index] : value;

      if (!rawValue) {
        return null;
      }

      var valueDate = toDate$1(rawValue);

      if (isNaN(valueDate.getTime())) {
        throw new Error("Invalid date: ".concat(value));
      }

      return valueDate;
    }

    function getDetailValue(_ref, index) {
      var value = _ref.value,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      maxDetail = _ref.maxDetail;
      var valuePiece = getValue$1(value, index);

      if (!valuePiece) {
        return null;
      }

      var valueType = getValueType(maxDetail);
      var detailValueFrom = [getBegin$1, getEnd$1][index](valueType, valuePiece);
      return between$1(detailValueFrom, minDate, maxDate);
    }

    var getDetailValueFrom = function getDetailValueFrom(args) {
      return getDetailValue(args, 0);
    };

    var getDetailValueTo = function getDetailValueTo(args) {
      return getDetailValue(args, 1);
    };

    var getDetailValueArray = function getDetailValueArray(args) {
      var value = args.value;

      if (Array.isArray(value)) {
        return value;
      }

      return [getDetailValueFrom, getDetailValueTo].map(function (fn) {
        return fn(args);
      });
    };

    function getActiveStartDate(props) {
      var maxDate = props.maxDate,
      maxDetail = props.maxDetail,
      minDate = props.minDate,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view;
      var rangeType = getView(view, minDetail, maxDetail);
      var valueFrom = getDetailValueFrom({
        value: value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail }) ||
      new Date();
      return getBegin$1(rangeType, valueFrom);
    }

    function getInitialActiveStartDate(props) {
      var activeStartDate = props.activeStartDate,
      defaultActiveStartDate = props.defaultActiveStartDate,
      defaultValue = props.defaultValue,
      defaultView = props.defaultView,
      maxDetail = props.maxDetail,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view,
      otherProps = _objectWithoutProperties$1(props, _excluded$1);

      var rangeType = getView(view, minDetail, maxDetail);
      var valueFrom = activeStartDate || defaultActiveStartDate;

      if (valueFrom) {
        return getBegin$1(rangeType, valueFrom);
      }

      return getActiveStartDate(_objectSpread$1({
        maxDetail: maxDetail,
        minDetail: minDetail,
        value: value || defaultValue,
        view: view || defaultView },
      otherProps));
    }

    var getIsSingleValue = function getIsSingleValue(value) {
      return value && [].concat(value).length === 1;
    };

    var Calendar = /*#__PURE__*/function (_Component) {
      _inherits$1(Calendar, _Component);

      var _super = _createSuper$1(Calendar);

      function Calendar() {
        var _this;

        _classCallCheck$1(this, Calendar);

        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
          _args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(_args));

        _defineProperty$z(_assertThisInitialized$1(_this), "state", {
          activeStartDate: _this.props.defaultActiveStartDate,
          value: _this.props.defaultValue,
          view: _this.props.defaultView });


        _defineProperty$z(_assertThisInitialized$1(_this), "setStateAndCallCallbacks", function (nextState, event, callback) {
          var _assertThisInitialize = _assertThisInitialized$1(_this),
          previousActiveStartDate = _assertThisInitialize.activeStartDate,
          previousView = _assertThisInitialize.view;

          var _this$props = _this.props,
          allowPartialRange = _this$props.allowPartialRange,
          onActiveStartDateChange = _this$props.onActiveStartDateChange,
          onChange = _this$props.onChange,
          onViewChange = _this$props.onViewChange,
          selectRange = _this$props.selectRange;
          var prevArgs = {
            activeStartDate: previousActiveStartDate,
            view: previousView };


          _this.setState(nextState, function () {
            var args = {
              action: nextState.action,
              activeStartDate: nextState.activeStartDate || _this.activeStartDate,
              value: nextState.value || _this.value,
              view: nextState.view || _this.view };


            function shouldUpdate(key) {
              return (// Key must exist, and…
                key in nextState && ( // …key changed from undefined to defined or the other way around, or…
                _typeof$2(nextState[key]) !== _typeof$2(prevArgs[key]) || ( // …value changed.
                nextState[key] instanceof Date ? nextState[key].getTime() !== prevArgs[key].getTime() : nextState[key] !== prevArgs[key])));

            }

            if (shouldUpdate('activeStartDate')) {
              if (onActiveStartDateChange) onActiveStartDateChange(args);
            }

            if (shouldUpdate('view')) {
              if (onViewChange) onViewChange(args);
            }

            if (shouldUpdate('value')) {
              if (onChange) {
                if (selectRange) {
                  var isSingleValue = getIsSingleValue(nextState.value);

                  if (!isSingleValue) {
                    onChange(nextState.value, event);
                  } else if (allowPartialRange) {
                    onChange([nextState.value], event);
                  }
                } else {
                  onChange(nextState.value, event);
                }
              }
            }

            if (callback) callback(args);
          });
        });

        _defineProperty$z(_assertThisInitialized$1(_this), "setActiveStartDate", function (nextActiveStartDate, action) {
          _this.setStateAndCallCallbacks({
            action: action,
            activeStartDate: nextActiveStartDate });

        });

        _defineProperty$z(_assertThisInitialized$1(_this), "drillDown", function (nextActiveStartDate, event) {
          if (!_this.drillDownAvailable) {
            return;
          }

          _this.onClickTile(nextActiveStartDate, event);

          var _assertThisInitialize2 = _assertThisInitialized$1(_this),
          view = _assertThisInitialize2.view,
          views = _assertThisInitialize2.views;

          var onDrillDown = _this.props.onDrillDown;
          var nextView = views[views.indexOf(view) + 1];

          _this.setStateAndCallCallbacks({
            action: 'drillDown',
            activeStartDate: nextActiveStartDate,
            view: nextView },
          undefined, onDrillDown);
        });

        _defineProperty$z(_assertThisInitialized$1(_this), "drillUp", function () {
          if (!_this.drillUpAvailable) {
            return;
          }

          var _assertThisInitialize3 = _assertThisInitialized$1(_this),
          activeStartDate = _assertThisInitialize3.activeStartDate,
          view = _assertThisInitialize3.view,
          views = _assertThisInitialize3.views;

          var onDrillUp = _this.props.onDrillUp;
          var nextView = views[views.indexOf(view) - 1];
          var nextActiveStartDate = getBegin$1(nextView, activeStartDate);

          _this.setStateAndCallCallbacks({
            action: 'drillUp',
            activeStartDate: nextActiveStartDate,
            view: nextView },
          undefined, onDrillUp);
        });

        _defineProperty$z(_assertThisInitialized$1(_this), "onChange", function (value, event) {
          var selectRange = _this.props.selectRange;

          _this.onClickTile(value, event);

          var nextValue;

          if (selectRange) {
            // Range selection turned on
            var _assertThisInitialize4 = _assertThisInitialized$1(_this),
            previousValue = _assertThisInitialize4.value,
            valueType = _assertThisInitialize4.valueType;

            if (!getIsSingleValue(previousValue)) {
              // Value has 0 or 2 elements - either way we're starting a new array
              // First value
              nextValue = getBegin$1(valueType, value);
            } else {
              // Second value
              nextValue = getValueRange(valueType, previousValue, value);
            }
          } else {
            // Range selection turned off
            nextValue = _this.getProcessedValue(value);
          }

          var nextActiveStartDate = getActiveStartDate(_objectSpread$1(_objectSpread$1({}, _this.props), {}, {
            value: nextValue }));

          event.persist();

          _this.setStateAndCallCallbacks({
            action: 'onChange',
            activeStartDate: nextActiveStartDate,
            value: nextValue },
          event);
        });

        _defineProperty$z(_assertThisInitialized$1(_this), "onClickTile", function (value, event) {
          var _assertThisInitialize5 = _assertThisInitialized$1(_this),
          view = _assertThisInitialize5.view;

          var _this$props2 = _this.props,
          onClickDay = _this$props2.onClickDay,
          onClickDecade = _this$props2.onClickDecade,
          onClickMonth = _this$props2.onClickMonth,
          onClickYear = _this$props2.onClickYear;

          var callback = function () {
            switch (view) {
              case 'century':
                return onClickDecade;

              case 'decade':
                return onClickYear;

              case 'year':
                return onClickMonth;

              case 'month':
                return onClickDay;

              default:
                throw new Error("Invalid view: ".concat(view, "."));}

          }();

          if (callback) callback(value, event);
        });

        _defineProperty$z(_assertThisInitialized$1(_this), "onMouseOver", function (value) {
          _this.setState(function (prevState) {
            if (prevState.hover && prevState.hover.getTime() === value.getTime()) {
              return null;
            }

            return {
              hover: value };

          });
        });

        _defineProperty$z(_assertThisInitialized$1(_this), "onMouseLeave", function () {
          _this.setState({
            hover: null });

        });

        return _this;
      }

      _createClass$1(Calendar, [{
        key: "activeStartDate",
        get: function get() {
          var activeStartDateProps = this.props.activeStartDate;
          var activeStartDateState = this.state.activeStartDate;
          return activeStartDateProps || activeStartDateState || getInitialActiveStartDate(this.props);
        } },
      {
        key: "value",
        get: function get() {
          var _this$props3 = this.props,
          selectRange = _this$props3.selectRange,
          valueProps = _this$props3.value;
          var valueState = this.state.value; // In the middle of range selection, use value from state

          if (selectRange && getIsSingleValue(valueState)) {
            return valueState;
          }

          return valueProps !== undefined ? valueProps : valueState;
        } },
      {
        key: "valueType",
        get: function get() {
          var maxDetail = this.props.maxDetail;
          return getValueType(maxDetail);
        } },
      {
        key: "view",
        get: function get() {
          var _this$props4 = this.props,
          minDetail = _this$props4.minDetail,
          maxDetail = _this$props4.maxDetail,
          viewProps = _this$props4.view;
          var viewState = this.state.view;
          return getView(viewProps || viewState, minDetail, maxDetail);
        } },
      {
        key: "views",
        get: function get() {
          var _this$props5 = this.props,
          minDetail = _this$props5.minDetail,
          maxDetail = _this$props5.maxDetail;
          return getLimitedViews(minDetail, maxDetail);
        } },
      {
        key: "hover",
        get: function get() {
          var selectRange = this.props.selectRange;
          var hover = this.state.hover;
          return selectRange ? hover : null;
        } },
      {
        key: "drillDownAvailable",
        get: function get() {
          var view = this.view,
          views = this.views;
          return views.indexOf(view) < views.length - 1;
        } },
      {
        key: "drillUpAvailable",
        get: function get() {
          var view = this.view,
          views = this.views;
          return views.indexOf(view) > 0;
        }
        /**
         * Gets current value in a desired format.
         */ },

      {
        key: "getProcessedValue",
        value: function getProcessedValue(value) {
          var _this$props6 = this.props,
          minDate = _this$props6.minDate,
          maxDate = _this$props6.maxDate,
          maxDetail = _this$props6.maxDetail,
          returnValue = _this$props6.returnValue;

          var processFunction = function () {
            switch (returnValue) {
              case 'start':
                return getDetailValueFrom;

              case 'end':
                return getDetailValueTo;

              case 'range':
                return getDetailValueArray;

              default:
                throw new Error('Invalid returnValue.');}

          }();

          return processFunction({
            value: value,
            minDate: minDate,
            maxDate: maxDate,
            maxDetail: maxDetail });

        } },
      {
        key: "renderContent",
        value: function renderContent(next) {
          var currentActiveStartDate = this.activeStartDate,
          onMouseOver = this.onMouseOver,
          valueType = this.valueType,
          value = this.value,
          view = this.view;
          var _this$props7 = this.props,
          calendarType = _this$props7.calendarType,
          locale = _this$props7.locale,
          maxDate = _this$props7.maxDate,
          minDate = _this$props7.minDate,
          selectRange = _this$props7.selectRange,
          tileClassName = _this$props7.tileClassName,
          tileContent = _this$props7.tileContent,
          tileDisabled = _this$props7.tileDisabled;
          var hover = this.hover;
          var activeStartDate = next ? getBeginNext(view, currentActiveStartDate) : getBegin$1(view, currentActiveStartDate);
          var onClick = this.drillDownAvailable ? this.drillDown : this.onChange;
          var commonProps = {
            activeStartDate: activeStartDate,
            hover: hover,
            locale: locale,
            maxDate: maxDate,
            minDate: minDate,
            onClick: onClick,
            onMouseOver: selectRange ? onMouseOver : null,
            tileClassName: tileClassName,
            tileContent: tileContent,
            tileDisabled: tileDisabled,
            value: value,
            valueType: valueType };


          switch (view) {
            case 'century':
              {
                var formatYear = this.props.formatYear;
                return /*#__PURE__*/React__default["default"].createElement(CenturyView, _extends({
                  formatYear: formatYear },
                commonProps));
              }

            case 'decade':
              {
                var _formatYear = this.props.formatYear;
                return /*#__PURE__*/React__default["default"].createElement(DecadeView, _extends({
                  formatYear: _formatYear },
                commonProps));
              }

            case 'year':
              {
                var _this$props8 = this.props,
                formatMonth = _this$props8.formatMonth,
                formatMonthYear = _this$props8.formatMonthYear;
                return /*#__PURE__*/React__default["default"].createElement(YearView, _extends({
                  formatMonth: formatMonth,
                  formatMonthYear: formatMonthYear },
                commonProps));
              }

            case 'month':
              {
                var _this$props9 = this.props,
                formatDay = _this$props9.formatDay,
                formatLongDate = _this$props9.formatLongDate,
                formatShortWeekday = _this$props9.formatShortWeekday,
                onClickWeekNumber = _this$props9.onClickWeekNumber,
                showDoubleView = _this$props9.showDoubleView,
                showFixedNumberOfWeeks = _this$props9.showFixedNumberOfWeeks,
                showNeighboringMonth = _this$props9.showNeighboringMonth,
                showWeekNumbers = _this$props9.showWeekNumbers;
                var onMouseLeave = this.onMouseLeave;
                return /*#__PURE__*/React__default["default"].createElement(MonthView, _extends({
                  calendarType: calendarType,
                  formatDay: formatDay,
                  formatLongDate: formatLongDate,
                  formatShortWeekday: formatShortWeekday,
                  onClickWeekNumber: onClickWeekNumber,
                  onMouseLeave: selectRange ? onMouseLeave : null,
                  showFixedNumberOfWeeks: typeof showFixedNumberOfWeeks !== 'undefined' ? showFixedNumberOfWeeks : showDoubleView,
                  showNeighboringMonth: showNeighboringMonth,
                  showWeekNumbers: showWeekNumbers },
                commonProps));
              }

            default:
              throw new Error("Invalid view: ".concat(view, "."));}

        } },
      {
        key: "renderNavigation",
        value: function renderNavigation() {
          var showNavigation = this.props.showNavigation;

          if (!showNavigation) {
            return null;
          }

          var activeStartDate = this.activeStartDate,
          view = this.view,
          views = this.views;
          var _this$props10 = this.props,
          formatMonthYear = _this$props10.formatMonthYear,
          formatYear = _this$props10.formatYear,
          locale = _this$props10.locale,
          maxDate = _this$props10.maxDate,
          minDate = _this$props10.minDate,
          navigationAriaLabel = _this$props10.navigationAriaLabel,
          navigationAriaLive = _this$props10.navigationAriaLive,
          navigationLabel = _this$props10.navigationLabel,
          next2AriaLabel = _this$props10.next2AriaLabel,
          next2Label = _this$props10.next2Label,
          nextAriaLabel = _this$props10.nextAriaLabel,
          nextLabel = _this$props10.nextLabel,
          prev2AriaLabel = _this$props10.prev2AriaLabel,
          prev2Label = _this$props10.prev2Label,
          prevAriaLabel = _this$props10.prevAriaLabel,
          prevLabel = _this$props10.prevLabel,
          showDoubleView = _this$props10.showDoubleView;
          return /*#__PURE__*/React__default["default"].createElement(Navigation, {
            activeStartDate: activeStartDate,
            drillUp: this.drillUp,
            formatMonthYear: formatMonthYear,
            formatYear: formatYear,
            locale: locale,
            maxDate: maxDate,
            minDate: minDate,
            navigationAriaLabel: navigationAriaLabel,
            navigationAriaLive: navigationAriaLive,
            navigationLabel: navigationLabel,
            next2AriaLabel: next2AriaLabel,
            next2Label: next2Label,
            nextAriaLabel: nextAriaLabel,
            nextLabel: nextLabel,
            prev2AriaLabel: prev2AriaLabel,
            prev2Label: prev2Label,
            prevAriaLabel: prevAriaLabel,
            prevLabel: prevLabel,
            setActiveStartDate: this.setActiveStartDate,
            showDoubleView: showDoubleView,
            view: view,
            views: views });

        } },
      {
        key: "render",
        value: function render() {
          var _this$props11 = this.props,
          className = _this$props11.className,
          inputRef = _this$props11.inputRef,
          selectRange = _this$props11.selectRange,
          showDoubleView = _this$props11.showDoubleView;
          var onMouseLeave = this.onMouseLeave,
          value = this.value;
          var valueArray = [].concat(value);
          return /*#__PURE__*/React__default["default"].createElement("div", {
            className: mergeClassNames(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), showDoubleView && "".concat(baseClassName, "--doubleView"), className),
            ref: inputRef },
          this.renderNavigation(), /*#__PURE__*/React__default["default"].createElement("div", {
            className: "".concat(baseClassName, "__viewContainer"),
            onBlur: selectRange ? onMouseLeave : null,
            onMouseLeave: selectRange ? onMouseLeave : null },
          this.renderContent(), showDoubleView && this.renderContent(true)));
        } }]);


      return Calendar;
    }(React.Component);
    Calendar.defaultProps = {
      maxDate: defaultMaxDate,
      maxDetail: 'month',
      minDate: defaultMinDate,
      minDetail: 'century',
      returnValue: 'start',
      showNavigation: true,
      showNeighboringMonth: true };

    var isActiveStartDate = propTypes$1.exports.instanceOf(Date);
    var isLooseValue = propTypes$1.exports.oneOfType([propTypes$1.exports.string, isValue]);
    Calendar.propTypes = {
      activeStartDate: isActiveStartDate,
      allowPartialRange: propTypes$1.exports.bool,
      calendarType: isCalendarType,
      className: isClassName,
      defaultActiveStartDate: isActiveStartDate,
      defaultValue: isLooseValue,
      defaultView: isView,
      formatDay: propTypes$1.exports.func,
      formatLongDate: propTypes$1.exports.func,
      formatMonth: propTypes$1.exports.func,
      formatMonthYear: propTypes$1.exports.func,
      formatShortWeekday: propTypes$1.exports.func,
      formatYear: propTypes$1.exports.func,
      inputRef: isRef$1,
      locale: propTypes$1.exports.string,
      maxDate: isMaxDate$1,
      maxDetail: propTypes$1.exports.oneOf(allViews$1),
      minDate: isMinDate$1,
      minDetail: propTypes$1.exports.oneOf(allViews$1),
      navigationAriaLabel: propTypes$1.exports.string,
      navigationAriaLive: propTypes$1.exports.oneOf(['off', 'polite', 'assertive']),
      navigationLabel: propTypes$1.exports.func,
      next2AriaLabel: propTypes$1.exports.string,
      next2Label: propTypes$1.exports.node,
      nextAriaLabel: propTypes$1.exports.string,
      nextLabel: propTypes$1.exports.node,
      onActiveStartDateChange: propTypes$1.exports.func,
      onChange: propTypes$1.exports.func,
      onClickDay: propTypes$1.exports.func,
      onClickDecade: propTypes$1.exports.func,
      onClickMonth: propTypes$1.exports.func,
      onClickWeekNumber: propTypes$1.exports.func,
      onClickYear: propTypes$1.exports.func,
      onDrillDown: propTypes$1.exports.func,
      onDrillUp: propTypes$1.exports.func,
      onViewChange: propTypes$1.exports.func,
      prev2AriaLabel: propTypes$1.exports.string,
      prev2Label: propTypes$1.exports.node,
      prevAriaLabel: propTypes$1.exports.string,
      prevLabel: propTypes$1.exports.node,
      returnValue: propTypes$1.exports.oneOf(['start', 'end', 'range']),
      selectRange: propTypes$1.exports.bool,
      showDoubleView: propTypes$1.exports.bool,
      showFixedNumberOfWeeks: propTypes$1.exports.bool,
      showNavigation: propTypes$1.exports.bool,
      showNeighboringMonth: propTypes$1.exports.bool,
      showWeekNumbers: propTypes$1.exports.bool,
      tileClassName: propTypes$1.exports.oneOfType([propTypes$1.exports.func, isClassName]),
      tileContent: propTypes$1.exports.oneOfType([propTypes$1.exports.func, propTypes$1.exports.node]),
      tileDisabled: propTypes$1.exports.func,
      value: isLooseValue,
      view: isView };

    var esm$2 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        'default': Calendar,
        Calendar: Calendar,
        CenturyView: CenturyView,
        DecadeView: DecadeView,
        YearView: YearView,
        MonthView: MonthView
    });

    var require$$4$1 = /*@__PURE__*/getAugmentedNamespace(esm$2);

    var getRect = function getRect(element) {
      return element.getBoundingClientRect();
    };

    var detectElementOverflow = function detectElementOverflow(element, container) {
      return {
        get collidedTop() {
          return getRect(element).top < getRect(container).top;
        },

        get collidedBottom() {
          return getRect(element).bottom > getRect(container).bottom;
        },

        get collidedLeft() {
          return getRect(element).left < getRect(container).left;
        },

        get collidedRight() {
          return getRect(element).right > getRect(container).right;
        },

        get overflowTop() {
          return getRect(container).top - getRect(element).top;
        },

        get overflowBottom() {
          return getRect(element).bottom - getRect(container).bottom;
        },

        get overflowLeft() {
          return getRect(container).left - getRect(element).left;
        },

        get overflowRight() {
          return getRect(element).right - getRect(container).right;
        } };


    };

    var isProduction = "production" === 'production';
    function warning(condition, message) {
      if (!isProduction) {
        if (condition) {
          return;
        }

        var text = "Warning: " + message;

        if (typeof console !== 'undefined') {
          console.warn(text);
        }

        try {
          throw Error(text);
        } catch (x) {}
      }
    }

    var _excluded = ["invertAxis", "invertSecondaryAxis"];

    function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

    function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

    function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}

    function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);}

    function _setPrototypeOf(o, p) {_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return _setPrototypeOf(o, p);}

    function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = _getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return _possibleConstructorReturn(this, result);};}

    function _possibleConstructorReturn(self, call) {if (call && (_typeof$1(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}

    function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

    function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

    function _getPrototypeOf(o) {_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return _getPrototypeOf(o);}

    function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

    function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}

    function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) {symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;});}keys.push.apply(keys, symbols);}return keys;}

    function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {ownKeys(Object(source), true).forEach(function (key) {_defineProperty$y(target, key, source[key]);});} else if (Object.getOwnPropertyDescriptors) {Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));} else {ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}}return target;}

    function _defineProperty$y(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    function _typeof$1(obj) {"@babel/helpers - typeof";if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {_typeof$1 = function _typeof(obj) {return typeof obj;};} else {_typeof$1 = function _typeof(obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};}return _typeof$1(obj);}
    var isBrowser = typeof window !== 'undefined';
    var isDisplayContentsSupported = isBrowser && 'CSS' in window && 'supports' in window.CSS && CSS.supports('display', 'contents');
    var isMutationObserverSupported = isBrowser && 'MutationObserver' in window;

    function capitalize(a) {
      return a[0].toUpperCase() + a.slice(1);
    }

    function findScrollContainer(element) {
      if (!element) {
        return undefined;
      }

      var parent = element.parentElement;

      while (parent) {
        var _window$getComputedSt = window.getComputedStyle(parent),
        overflow = _window$getComputedSt.overflow;

        if (overflow.split(' ').every(function (o) {
          return o === 'auto' || o === 'scroll';
        })) {
          return parent;
        }

        parent = parent.parentElement;
      }

      return document.documentElement;
    }

    function alignAxis(_ref) {
      var axis = _ref.axis,
      container = _ref.container,
      element = _ref.element,
      invertAxis = _ref.invertAxis,
      secondary = _ref.secondary,
      scrollContainer = _ref.scrollContainer,
      spacing = _ref.spacing;
      var style = window.getComputedStyle(element);
      var parent = container.parentElement;
      var scrollContainerCollisions = detectElementOverflow(parent, scrollContainer);
      var documentCollisions = detectElementOverflow(parent, document.documentElement);
      var isX = axis === 'x';
      var startProperty = isX ? 'left' : 'top';
      var endProperty = isX ? 'right' : 'bottom';
      var sizeProperty = isX ? 'width' : 'height';
      var overflowStartProperty = "overflow".concat(capitalize(startProperty));
      var overflowEndProperty = "overflow".concat(capitalize(endProperty));
      var scrollProperty = "scroll".concat(capitalize(startProperty));
      var uppercasedSizeProperty = capitalize(sizeProperty);
      var offsetSizeProperty = "offset".concat(uppercasedSizeProperty);
      var clientSizeProperty = "client".concat(uppercasedSizeProperty);
      var minSizeProperty = "min-".concat(sizeProperty);
      var scrollbarWidth = scrollContainer[offsetSizeProperty] - scrollContainer[clientSizeProperty];
      var startSpacing = _typeof$1(spacing) === 'object' ? spacing[startProperty] : spacing;
      var availableStartSpace = -Math.max(scrollContainerCollisions[overflowStartProperty], documentCollisions[overflowStartProperty] + document.documentElement[scrollProperty]) - startSpacing;
      var endSpacing = _typeof$1(spacing) === 'object' ? spacing[endProperty] : spacing;
      var availableEndSpace = -Math.max(scrollContainerCollisions[overflowEndProperty], documentCollisions[overflowEndProperty] - document.documentElement[scrollProperty]) - endSpacing - scrollbarWidth;

      if (secondary) {
        availableStartSpace += parent[clientSizeProperty];
        availableEndSpace += parent[clientSizeProperty];
      }

      var offsetSize = element[offsetSizeProperty];

      function displayStart() {
        element.style[startProperty] = 'auto';
        element.style[endProperty] = secondary ? '0' : '100%';
      }

      function displayEnd() {
        element.style[startProperty] = secondary ? '0' : '100%';
        element.style[endProperty] = 'auto';
      }

      function displayIfFits(availableSpace, display) {
        var fits = offsetSize <= availableSpace;

        if (fits) {
          display();
        }

        return fits;
      }

      function displayStartIfFits() {
        return displayIfFits(availableStartSpace, displayStart);
      }

      function displayEndIfFits() {
        return displayIfFits(availableEndSpace, displayEnd);
      }

      function displayWhereverShrinkedFits() {
        var moreSpaceStart = availableStartSpace > availableEndSpace;
        var minSize = style[minSizeProperty] && parseInt(style[minSizeProperty], 10);

        function shrinkToSize(size) {
          warning(!minSize || size >= minSize, "<Fit />'s child will not fit anywhere with its current ".concat(minSizeProperty, " of ").concat(minSize, "px."));
          var newSize = Math.max(size, minSize || 0);
          warning(false, "<Fit />'s child needed to have its ".concat(sizeProperty, " decreased to ").concat(newSize, "px."));
          element.style[sizeProperty] = "".concat(newSize, "px");
        }

        if (moreSpaceStart) {
          shrinkToSize(availableStartSpace);
          displayStart();
        } else {
          shrinkToSize(availableEndSpace);
          displayEnd();
        }
      }

      var fits;

      if (invertAxis) {
        fits = displayStartIfFits() || displayEndIfFits();
      } else {
        fits = displayEndIfFits() || displayStartIfFits();
      }

      if (!fits) {
        displayWhereverShrinkedFits();
      }
    }

    function alignMainAxis(args) {
      alignAxis(args);
    }

    function alignSecondaryAxis(args) {
      alignAxis(_objectSpread(_objectSpread({}, args), {}, {
        axis: args.axis === 'x' ? 'y' : 'x',
        secondary: true }));

    }

    function alignBothAxis(args) {
      var invertAxis = args.invertAxis,
      invertSecondaryAxis = args.invertSecondaryAxis,
      commonArgs = _objectWithoutProperties(args, _excluded);

      alignMainAxis(_objectSpread(_objectSpread({}, commonArgs), {}, {
        invertAxis: invertAxis }));

      alignSecondaryAxis(_objectSpread(_objectSpread({}, commonArgs), {}, {
        invertAxis: invertSecondaryAxis }));

    }

    var Fit = /*#__PURE__*/function (_Component) {
      _inherits(Fit, _Component);

      var _super = _createSuper(Fit);

      function Fit() {
        var _this;

        _classCallCheck(this, Fit);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty$y(_assertThisInitialized(_this), "onMutation", function () {
          _this.fit();
        });

        _defineProperty$y(_assertThisInitialized(_this), "mutationObserver", isMutationObserverSupported && new MutationObserver(_this.onMutation));

        _defineProperty$y(_assertThisInitialized(_this), "fit", function () {
          var _assertThisInitialize = _assertThisInitialized(_this),
          scrollContainer = _assertThisInitialize.scrollContainer,
          container = _assertThisInitialize.container,
          element = _assertThisInitialize.element;

          if (!element) {
            return;
          }

          var elementWidth = element.clientWidth;
          var elementHeight = element.clientHeight; // No need to recalculate - already did that for current dimensions

          if (_this.elementWidth === elementWidth && _this.elementHeight === elementHeight) {
            return;
          } // Save the dimensions so that we know we don't need to repeat the function if unchanged


          _this.elementWidth = elementWidth;
          _this.elementHeight = elementHeight;
          var parent = container.parentElement; // Container was unmounted

          if (!parent) {
            return;
          }
          /**
           * We need to ensure that <Fit />'s child has a absolute position. Otherwise,
           * we wouldn't be able to place the child in the correct position.
           */


          var style = window.getComputedStyle(element);
          var position = style.position;

          if (position !== 'absolute') {
            warning(false, '<Fit />\'s child does not have absolute position. You should apply `position: absolute` to it.');
            element.style.position = 'absolute';
          }
          /**
           * We need to ensure that <Fit />'s parent has a relative position. Otherwise,
           * we wouldn't be able to place the child in the correct position.
           */


          var parentStyle = window.getComputedStyle(parent);
          var parentPosition = parentStyle.position;

          if (parentPosition !== 'relative' && parentPosition !== 'absolute') {
            warning(false, '<Fit />\'s parent does not have relative position. You should apply `position: relative` to it.');
            parent.style.position = 'relative';
          }

          var _this$props = _this.props,
          invertAxis = _this$props.invertAxis,
          invertSecondaryAxis = _this$props.invertSecondaryAxis,
          mainAxis = _this$props.mainAxis,
          spacing = _this$props.spacing;
          alignBothAxis({
            container: container,
            element: element,
            invertAxis: invertAxis,
            invertSecondaryAxis: invertSecondaryAxis,
            axis: mainAxis,
            scrollContainer: scrollContainer,
            spacing: spacing });

        });

        return _this;
      }

      _createClass(Fit, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (!isDisplayContentsSupported) {
            // eslint-disable-next-line react/no-find-dom-node
            var element = reactDom.findDOMNode(this);
            this.container = element;
            this.element = element;
            this.scrollContainer = findScrollContainer(element);
          }

          this.fit();

          if (isMutationObserverSupported) {
            this.mutationObserver.observe(this.element, {
              attributes: true,
              attributeFilter: ['class', 'style'] });

          }
        } },
      {
        key: "render",
        value: function render() {
          var _this2 = this;

          var children = this.props.children;
          var child = React__default["default"].Children.only(children);

          if (isDisplayContentsSupported) {
            return /*#__PURE__*/React__default["default"].createElement("span", {
              ref: function ref(container) {
                _this2.container = container;
                var element = container && container.firstChild;
                _this2.element = element;
                _this2.scrollContainer = findScrollContainer(element);
              },
              style: {
                display: 'contents' } },

            child);
          }

          return child;
        } }]);


      return Fit;
    }(React.Component);
    Fit.propTypes = {
      children: propTypes$1.exports.node,
      invertAxis: propTypes$1.exports.bool,
      invertSecondaryAxis: propTypes$1.exports.bool,
      mainAxis: propTypes$1.exports.oneOf(['x', 'y']),
      spacing: propTypes$1.exports.oneOfType([propTypes$1.exports.number, propTypes$1.exports.shape({
        bottom: propTypes$1.exports.number.isRequired,
        left: propTypes$1.exports.number.isRequired,
        right: propTypes$1.exports.number.isRequired,
        top: propTypes$1.exports.number.isRequired })]) };


    Fit.defaultProps = {
      mainAxis: 'y',
      spacing: 8 };

    var Fit$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        'default': Fit
    });

    var require$$5 = /*@__PURE__*/getAugmentedNamespace(Fit$1);

    var DateInput = {};

    var require$$2 = /*@__PURE__*/getAugmentedNamespace(esm$3);

    var Divider = {};

    (function (exports) {

      Object.defineProperty(exports, "__esModule", {
        value: true });

      exports["default"] = Divider;

      var _react = _interopRequireDefault(React__default["default"]);

      var _propTypes = _interopRequireDefault(propTypes$1.exports);

      function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

      function Divider(_ref) {
        var children = _ref.children;
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "react-date-picker__inputGroup__divider" },
        children);
      }

      Divider.propTypes = {
        children: _propTypes["default"].node };

    })(Divider);

    var DayInput = {};

    var Input = {};

    /**
     * A function that merges React refs into one.
     * Supports both functions and ref objects created using createRef() and useRef().
     *
     * Usage:
     * ```jsx
     * <div ref={mergeRefs(ref1, ref2, ref3)} />
     * ```
     *
     * @param {...Array<Function|object>} inputRefs Array of refs
     * @returns {Function} Merged refs
     */
    function mergeRefs() {
      for (var _len = arguments.length, inputRefs = new Array(_len), _key = 0; _key < _len; _key++) {
        inputRefs[_key] = arguments[_key];
      }

      var filteredInputRefs = inputRefs.filter(Boolean);

      if (filteredInputRefs.length <= 1) {
        return filteredInputRefs[0];
      }

      return function mergedRefs(ref) {
        filteredInputRefs.forEach(function (inputRef) {
          if (typeof inputRef === 'function') {
            inputRef(ref);
          } else {
            // eslint-disable-next-line no-param-reassign
            inputRef.current = ref;
          }
        });
      };
    }

    var esm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        'default': mergeRefs
    });

    var require$$3 = /*@__PURE__*/getAugmentedNamespace(esm$1);

    var allowedVariants = ['normal', 'small-caps'];
    /**
     * Gets font CSS shorthand property given element.
     *
     * @param {HTMLElement} element Element to get font CSS shorthand property from
     */

    function getFontShorthand(element) {
      if (!element) {
        return '';
      }

      var style = window.getComputedStyle(element);

      if (style.font) {
        return style.font;
      }

      var isFontDefined = style['font-family'] !== '';

      if (!isFontDefined) {
        return '';
      }

      var fontVariant = allowedVariants.includes(style['font-variant']) ? style['font-variant'] : 'normal';
      return "".concat(style['font-style'], " ").concat(fontVariant, " ").concat(style['font-weight'], " ").concat(style['font-size'], " / ").concat(style['line-height'], " ").concat(style['font-family']);
    }
    /**
     * Measures text width given text and font CSS shorthand.
     *
     * @param {string} text Text to measure
     * @param {string} font Font to use when measuring the text
     */

    function measureText(text, font) {
      var canvas = measureText.canvas || (measureText.canvas = document.createElement('canvas'));
      var context = canvas.getContext('2d'); // Context type not supported

      if (!context) {
        return null;
      }

      context.font = font;

      var _context$measureText = context.measureText(text),
      width = _context$measureText.width;

      return Math.ceil(width);
    }
    /**
     * Updates input element width to fit its content given input element
     * @param {HTMLInputElement} element
     */

    function updateInputWidth(element) {
      if (typeof window === 'undefined' || !element) {
        return null;
      }

      var font = getFontShorthand(element);
      var text = element.value || element.placeholder;
      var width = measureText(text, font);

      if (width === null) {
        return null;
      }

      element.style.width = "".concat(width, "px");
      return width;
    }

    var esm = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getFontShorthand: getFontShorthand,
        measureText: measureText,
        updateInputWidth: updateInputWidth,
        'default': updateInputWidth
    });

    var require$$4 = /*@__PURE__*/getAugmentedNamespace(esm);

    var propTypes = {};

    Object.defineProperty(propTypes, "__esModule", {
      value: true });

    propTypes.isValueType = propTypes.isRef = propTypes.isMinDate = propTypes.isMaxDate = void 0;

    var _propTypes = _interopRequireDefault$1(propTypes$1.exports);

    function _interopRequireDefault$1(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

    function _typeof(obj) {"@babel/helpers - typeof";return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof(obj);}

    function _toConsumableArray$1(arr) {return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();}

    function _nonIterableSpread$1() {throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

    function _unsupportedIterableToArray$1(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);}

    function _iterableToArray$1(iter) {if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);}

    function _arrayWithoutHoles$1(arr) {if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);}

    function _arrayLikeToArray$1(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}

    var allViews = ['century', 'decade', 'year', 'month'];
    var allValueTypes = [].concat(_toConsumableArray$1(allViews.slice(1)), ['day']);

    var isValueType = _propTypes["default"].oneOf(allValueTypes);

    propTypes.isValueType = isValueType;

    var isMinDate = function isMinDate(props, propName, componentName) {
      var minDate = props[propName];

      if (!minDate) {
        return null;
      }

      if (!(minDate instanceof Date)) {
        return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
      }

      var maxDate = props.maxDate;

      if (maxDate && minDate > maxDate) {
        return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
      }

      return null;
    };

    propTypes.isMinDate = isMinDate;

    var isMaxDate = function isMaxDate(props, propName, componentName) {
      var maxDate = props[propName];

      if (!maxDate) {
        return null;
      }

      if (!(maxDate instanceof Date)) {
        return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
      }

      var minDate = props.minDate;

      if (minDate && maxDate < minDate) {
        return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
      }

      return null;
    };

    propTypes.isMaxDate = isMaxDate;

    var isRef = _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
      current: _propTypes["default"].any })]);


    propTypes.isRef = isRef;

    (function (exports) {

      function _typeof(obj) {"@babel/helpers - typeof";return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof(obj);}

      Object.defineProperty(exports, "__esModule", {
        value: true });

      exports["default"] = Input;

      var _react = _interopRequireDefault(React__default["default"]);

      var _propTypes = _interopRequireDefault(propTypes$1.exports);

      var _mergeClassNames = _interopRequireDefault(require$$3$1);

      var _mergeRefs = _interopRequireDefault(require$$3);

      var _updateInputWidth = _interopRequireWildcard(require$$4);

      var _propTypes2 = propTypes;

      function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}

      function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {return { "default": obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj["default"] = obj;if (cache) {cache.set(obj, newObj);}return newObj;}

      function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

      /* eslint-disable jsx-a11y/no-autofocus */
      var isIEOrEdgeLegacy = typeof window !== 'undefined' && /(MSIE|Trident\/|Edge\/)/.test(window.navigator.userAgent);
      var isFirefox = typeof window !== 'undefined' && /Firefox/.test(window.navigator.userAgent);

      function onFocus(event) {
        var target = event.target;

        if (isIEOrEdgeLegacy) {
          requestAnimationFrame(function () {
            return target.select();
          });
        } else {
          target.select();
        }
      }

      function updateInputWidthOnFontLoad(element) {
        if (!document.fonts) {
          return;
        }

        var font = (0, _updateInputWidth.getFontShorthand)(element);

        if (!font) {
          return;
        }

        var isFontLoaded = document.fonts.check(font);

        if (isFontLoaded) {
          return;
        }

        function onLoadingDone() {
          (0, _updateInputWidth["default"])(element);
        }

        document.fonts.addEventListener('loadingdone', onLoadingDone);
      }

      function getSelectionString(input) {
        /**
         * window.getSelection().toString() returns empty string in IE11 and Firefox,
         * so alternatives come first.
         */
        if (input && 'selectionStart' in input && input.selectionStart !== null) {
          return input.value.slice(input.selectionStart, input.selectionEnd);
        }

        if ('getSelection' in window) {
          return window.getSelection().toString();
        }

        return null;
      }

      function makeOnKeyPress(maxLength) {
        /**
         * Prevents keystrokes that would not produce a number or when value after keystroke would
         * exceed maxLength.
         */
        return function onKeyPress(event) {
          if (isFirefox) {
            // See https://github.com/wojtekmaj/react-time-picker/issues/92
            return;
          }

          var key = event.key,
          input = event.target;
          var value = input.value;
          var isNumberKey = key.length === 1 && /\d/.test(key);
          var selection = getSelectionString(input);

          if (!isNumberKey || !(selection || value.length < maxLength)) {
            event.preventDefault();
          }
        };
      }

      function Input(_ref) {
        var ariaLabel = _ref.ariaLabel,
        autoFocus = _ref.autoFocus,
        className = _ref.className,
        disabled = _ref.disabled,
        inputRef = _ref.inputRef,
        max = _ref.max,
        min = _ref.min,
        name = _ref.name,
        nameForClass = _ref.nameForClass,
        onChange = _ref.onChange,
        onKeyDown = _ref.onKeyDown,
        _onKeyUp = _ref.onKeyUp,
        _ref$placeholder = _ref.placeholder,
        placeholder = _ref$placeholder === void 0 ? '--' : _ref$placeholder,
        required = _ref.required,
        showLeadingZeros = _ref.showLeadingZeros,
        step = _ref.step,
        value = _ref.value;
        var hasLeadingZero = showLeadingZeros && value && value < 10 && (value === '0' || !value.toString().startsWith('0'));
        var maxLength = max ? max.toString().length : null;
        return [hasLeadingZero && /*#__PURE__*/_react["default"].createElement("span", {
          key: "leadingZero",
          className: "".concat(className, "__leadingZero") },
        "0"), /*#__PURE__*/_react["default"].createElement("input", {
          key: "input",
          "aria-label": ariaLabel,
          autoComplete: "off",
          autoFocus: autoFocus,
          className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(nameForClass || name), hasLeadingZero && "".concat(className, "__input--hasLeadingZero")),
          "data-input": "true",
          disabled: disabled,
          inputMode: "numeric",
          max: max,
          min: min,
          name: name,
          onChange: onChange,
          onFocus: onFocus,
          onKeyDown: onKeyDown,
          onKeyPress: makeOnKeyPress(maxLength),
          onKeyUp: function onKeyUp(event) {
            (0, _updateInputWidth["default"])(event.target);

            if (_onKeyUp) {
              _onKeyUp(event);
            }
          },
          placeholder: placeholder,
          ref: (0, _mergeRefs["default"])(_updateInputWidth["default"], updateInputWidthOnFontLoad, inputRef),
          required: required,
          step: step,
          type: "number",
          value: value !== null ? value : '' })];

      }

      Input.propTypes = {
        ariaLabel: _propTypes["default"].string,
        autoFocus: _propTypes["default"].bool,
        className: _propTypes["default"].string.isRequired,
        disabled: _propTypes["default"].bool,
        inputRef: _propTypes2.isRef,
        max: _propTypes["default"].number,
        min: _propTypes["default"].number,
        name: _propTypes["default"].string,
        nameForClass: _propTypes["default"].string,
        onChange: _propTypes["default"].func,
        onKeyDown: _propTypes["default"].func,
        onKeyUp: _propTypes["default"].func,
        placeholder: _propTypes["default"].string,
        required: _propTypes["default"].bool,
        showLeadingZeros: _propTypes["default"].bool,
        step: _propTypes["default"].number,
        value: _propTypes["default"].string };

    })(Input);

    var utils = {};

    Object.defineProperty(utils, "__esModule", {
      value: true });

    utils.between = between;
    utils.safeMax = safeMax;
    utils.safeMin = safeMin;

    function _toConsumableArray(arr) {return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();}

    function _nonIterableSpread() {throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

    function _unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);}

    function _iterableToArray(iter) {if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);}

    function _arrayWithoutHoles(arr) {if (Array.isArray(arr)) return _arrayLikeToArray(arr);}

    function _arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}

    /**
     * Returns a value no smaller than min and no larger than max.
     *
     * @param {*} value Value to return.
     * @param {*} min Minimum return value.
     * @param {*} max Maximum return value.
     */
    function between(value, min, max) {
      if (min && min > value) {
        return min;
      }

      if (max && max < value) {
        return max;
      }

      return value;
    }

    function isValidNumber(num) {
      return num !== null && num !== false && !Number.isNaN(Number(num));
    }

    function safeMin() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return Math.min.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
    }

    function safeMax() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return Math.max.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
    }

    (function (exports) {

      Object.defineProperty(exports, "__esModule", {
        value: true });

      exports["default"] = DayInput;

      var _react = _interopRequireDefault(React__default["default"]);

      var _propTypes = _interopRequireDefault(propTypes$1.exports);

      var _dateUtils = require$$2;

      var _Input = _interopRequireDefault(Input);

      var _propTypes2 = propTypes;

      var _utils = utils;

      var _excluded = ["maxDate", "minDate", "month", "year"];

      function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

      function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}

      function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

      function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}

      function DayInput(_ref) {
        var maxDate = _ref.maxDate,
        minDate = _ref.minDate,
        month = _ref.month,
        year = _ref.year,
        otherProps = _objectWithoutProperties(_ref, _excluded);

        var currentMonthMaxDays = function () {
          if (!month) {
            return 31;
          }

          return (0, _dateUtils.getDaysInMonth)(new Date(year, month - 1, 1));
        }();

        function isSameMonth(date) {
          return date && year === (0, _dateUtils.getYear)(date).toString() && month === (0, _dateUtils.getMonthHuman)(date).toString();
        }

        var maxDay = (0, _utils.safeMin)(currentMonthMaxDays, isSameMonth(maxDate) && (0, _dateUtils.getDate)(maxDate));
        var minDay = (0, _utils.safeMax)(1, isSameMonth(minDate) && (0, _dateUtils.getDate)(minDate));
        return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
          max: maxDay,
          min: minDay,
          name: "day" },
        otherProps));
      }

      DayInput.propTypes = {
        ariaLabel: _propTypes["default"].string,
        className: _propTypes["default"].string.isRequired,
        disabled: _propTypes["default"].bool,
        inputRef: _propTypes2.isRef,
        maxDate: _propTypes2.isMaxDate,
        minDate: _propTypes2.isMinDate,
        month: _propTypes["default"].string,
        onChange: _propTypes["default"].func,
        onKeyDown: _propTypes["default"].func,
        onKeyUp: _propTypes["default"].func,
        placeholder: _propTypes["default"].string,
        required: _propTypes["default"].bool,
        showLeadingZeros: _propTypes["default"].bool,
        value: _propTypes["default"].string,
        year: _propTypes["default"].string };

    })(DayInput);

    var MonthInput = {};

    (function (exports) {

      Object.defineProperty(exports, "__esModule", {
        value: true });

      exports["default"] = MonthInput;

      var _react = _interopRequireDefault(React__default["default"]);

      var _propTypes = _interopRequireDefault(propTypes$1.exports);

      var _dateUtils = require$$2;

      var _Input = _interopRequireDefault(Input);

      var _propTypes2 = propTypes;

      var _utils = utils;

      var _excluded = ["maxDate", "minDate", "year"];

      function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

      function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}

      function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

      function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}

      function MonthInput(_ref) {
        var maxDate = _ref.maxDate,
        minDate = _ref.minDate,
        year = _ref.year,
        otherProps = _objectWithoutProperties(_ref, _excluded);

        function isSameYear(date) {
          return date && year === (0, _dateUtils.getYear)(date).toString();
        }

        var maxMonth = (0, _utils.safeMin)(12, isSameYear(maxDate) && (0, _dateUtils.getMonthHuman)(maxDate));
        var minMonth = (0, _utils.safeMax)(1, isSameYear(minDate) && (0, _dateUtils.getMonthHuman)(minDate));
        return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
          max: maxMonth,
          min: minMonth,
          name: "month" },
        otherProps));
      }

      MonthInput.propTypes = {
        ariaLabel: _propTypes["default"].string,
        className: _propTypes["default"].string.isRequired,
        disabled: _propTypes["default"].bool,
        inputRef: _propTypes2.isRef,
        maxDate: _propTypes2.isMaxDate,
        minDate: _propTypes2.isMinDate,
        onChange: _propTypes["default"].func,
        onKeyDown: _propTypes["default"].func,
        onKeyUp: _propTypes["default"].func,
        placeholder: _propTypes["default"].string,
        required: _propTypes["default"].bool,
        showLeadingZeros: _propTypes["default"].bool,
        value: _propTypes["default"].string,
        year: _propTypes["default"].string };

    })(MonthInput);

    var MonthSelect = {};

    var dateFormatter = {};

    var require$$0 = /*@__PURE__*/getAugmentedNamespace(esm$4);

    Object.defineProperty(dateFormatter, "__esModule", {
      value: true });

    dateFormatter.formatShortMonth = dateFormatter.formatMonth = void 0;
    dateFormatter.getFormatter = getFormatter;

    var _getUserLocale = _interopRequireDefault(require$$0);

    function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

    var formatterCache = new Map();

    function getFormatter(options) {
      return function (locale, date) {
        var localeWithDefault = locale || (0, _getUserLocale["default"])();

        if (!formatterCache.has(localeWithDefault)) {
          formatterCache.set(localeWithDefault, new Map());
        }

        var formatterCacheLocale = formatterCache.get(localeWithDefault);

        if (!formatterCacheLocale.has(options)) {
          formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault, options).format);
        }

        return formatterCacheLocale.get(options)(date);
      };
    }
    /**
     * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
     * Workaround for bug in WebKit and Firefox with historical dates.
     * For more details, see:
     * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
     * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
     *
     * @param {Date} date Date.
     */


    function toSafeHour(date) {
      var safeDate = new Date(date);
      return new Date(safeDate.setHours(12));
    }

    function getSafeFormatter(options) {
      return function (locale, date) {
        return getFormatter(options)(locale, toSafeHour(date));
      };
    }

    var formatMonthOptions = {
      month: 'long' };

    var formatShortMonthOptions = {
      month: 'short' };

    var formatMonth = getSafeFormatter(formatMonthOptions);
    dateFormatter.formatMonth = formatMonth;
    var formatShortMonth = getSafeFormatter(formatShortMonthOptions);
    dateFormatter.formatShortMonth = formatShortMonth;

    (function (exports) {

      Object.defineProperty(exports, "__esModule", {
        value: true });

      exports["default"] = MonthSelect;

      var _react = _interopRequireDefault(React__default["default"]);

      var _propTypes = _interopRequireDefault(propTypes$1.exports);

      var _mergeClassNames = _interopRequireDefault(require$$3$1);

      var _dateUtils = require$$2;

      var _dateFormatter = dateFormatter;

      var _propTypes2 = propTypes;

      var _utils = utils;

      var _excluded = ["ariaLabel", "className", "inputRef", "locale", "maxDate", "minDate", "placeholder", "short", "value", "year"];

      function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

      function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}

      function _toConsumableArray(arr) {return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();}

      function _nonIterableSpread() {throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

      function _unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);}

      function _iterableToArray(iter) {if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);}

      function _arrayWithoutHoles(arr) {if (Array.isArray(arr)) return _arrayLikeToArray(arr);}

      function _arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}

      function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

      function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}

      function MonthSelect(_ref) {
        var ariaLabel = _ref.ariaLabel,
        className = _ref.className,
        inputRef = _ref.inputRef,
        locale = _ref.locale,
        maxDate = _ref.maxDate,
        minDate = _ref.minDate,
        _ref$placeholder = _ref.placeholder,
        placeholder = _ref$placeholder === void 0 ? '--' : _ref$placeholder,
        _short = _ref["short"],
        value = _ref.value,
        year = _ref.year,
        otherProps = _objectWithoutProperties(_ref, _excluded);

        function isSameYear(date) {
          return date && year === (0, _dateUtils.getYear)(date).toString();
        }

        var maxMonth = (0, _utils.safeMin)(12, isSameYear(maxDate) && (0, _dateUtils.getMonthHuman)(maxDate));
        var minMonth = (0, _utils.safeMax)(1, isSameYear(minDate) && (0, _dateUtils.getMonthHuman)(minDate));

        var dates = _toConsumableArray(Array(12)).map(function (el, index) {
          return new Date(2019, index, 1);
        });

        var name = 'month';
        var formatter = _short ? _dateFormatter.formatShortMonth : _dateFormatter.formatMonth;
        return /*#__PURE__*/_react["default"].createElement("select", _extends({
          "aria-label": ariaLabel,
          className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(name)),
          "data-input": "true",
          "data-select": "true",
          name: name,
          ref: inputRef,
          value: value !== null ? value : '' },
        otherProps), !value && /*#__PURE__*/_react["default"].createElement("option", {
          value: "" },
        placeholder), dates.map(function (date) {
          var month = (0, _dateUtils.getMonthHuman)(date);
          var disabled = month < minMonth || month > maxMonth;
          return /*#__PURE__*/_react["default"].createElement("option", {
            key: month,
            disabled: disabled,
            value: month },
          formatter(locale, date));
        }));
      }

      MonthSelect.propTypes = {
        ariaLabel: _propTypes["default"].string,
        className: _propTypes["default"].string.isRequired,
        disabled: _propTypes["default"].bool,
        inputRef: _propTypes2.isRef,
        locale: _propTypes["default"].string,
        maxDate: _propTypes2.isMaxDate,
        minDate: _propTypes2.isMinDate,
        onChange: _propTypes["default"].func,
        onKeyDown: _propTypes["default"].func,
        onKeyUp: _propTypes["default"].func,
        placeholder: _propTypes["default"].string,
        required: _propTypes["default"].bool,
        "short": _propTypes["default"].bool,
        value: _propTypes["default"].string,
        year: _propTypes["default"].string };

    })(MonthSelect);

    var YearInput = {};

    (function (exports) {

      Object.defineProperty(exports, "__esModule", {
        value: true });

      exports["default"] = YearInput;

      var _react = _interopRequireDefault(React__default["default"]);

      var _propTypes = _interopRequireDefault(propTypes$1.exports);

      var _dateUtils = require$$2;

      var _Input = _interopRequireDefault(Input);

      var _propTypes2 = propTypes;

      var _utils = utils;

      var _excluded = ["maxDate", "minDate", "placeholder", "valueType"];

      function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

      function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}

      function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

      function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}

      function YearInput(_ref) {
        var maxDate = _ref.maxDate,
        minDate = _ref.minDate,
        _ref$placeholder = _ref.placeholder,
        placeholder = _ref$placeholder === void 0 ? '----' : _ref$placeholder,
        valueType = _ref.valueType,
        otherProps = _objectWithoutProperties(_ref, _excluded);

        var maxYear = (0, _utils.safeMin)(275760, maxDate && (0, _dateUtils.getYear)(maxDate));
        var minYear = (0, _utils.safeMax)(1, minDate && (0, _dateUtils.getYear)(minDate));

        var yearStep = function () {
          if (valueType === 'century') {
            return 10;
          }

          return 1;
        }();

        return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
          max: maxYear,
          min: minYear,
          name: "year",
          placeholder: placeholder,
          step: yearStep },
        otherProps));
      }

      YearInput.propTypes = {
        ariaLabel: _propTypes["default"].string,
        className: _propTypes["default"].string.isRequired,
        disabled: _propTypes["default"].bool,
        inputRef: _propTypes2.isRef,
        maxDate: _propTypes2.isMaxDate,
        minDate: _propTypes2.isMinDate,
        onChange: _propTypes["default"].func,
        onKeyDown: _propTypes["default"].func,
        onKeyUp: _propTypes["default"].func,
        placeholder: _propTypes["default"].string,
        required: _propTypes["default"].bool,
        value: _propTypes["default"].string,
        valueType: _propTypes2.isValueType };

    })(YearInput);

    var NativeInput = {};

    (function (exports) {

      Object.defineProperty(exports, "__esModule", {
        value: true });

      exports["default"] = NativeInput;

      var _react = _interopRequireDefault(React__default["default"]);

      var _propTypes = _interopRequireDefault(propTypes$1.exports);

      var _dateUtils = require$$2;

      var _propTypes2 = propTypes;

      function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

      function NativeInput(_ref) {
        var ariaLabel = _ref.ariaLabel,
        disabled = _ref.disabled,
        maxDate = _ref.maxDate,
        minDate = _ref.minDate,
        name = _ref.name,
        onChange = _ref.onChange,
        required = _ref.required,
        value = _ref.value,
        valueType = _ref.valueType;

        var nativeInputType = function () {
          switch (valueType) {
            case 'decade':
            case 'year':
              return 'number';

            case 'month':
              return 'month';

            case 'day':
              return 'date';

            default:
              throw new Error('Invalid valueType.');}

        }();

        var nativeValueParser = function () {
          switch (valueType) {
            case 'century':
            case 'decade':
            case 'year':
              return _dateUtils.getYear;

            case 'month':
              return _dateUtils.getISOLocalMonth;

            case 'day':
              return _dateUtils.getISOLocalDate;

            default:
              throw new Error('Invalid valueType.');}

        }();

        function stopPropagation(event) {
          event.stopPropagation();
        }

        return /*#__PURE__*/_react["default"].createElement("input", {
          "aria-label": ariaLabel,
          disabled: disabled,
          max: maxDate ? nativeValueParser(maxDate) : null,
          min: minDate ? nativeValueParser(minDate) : null,
          name: name,
          onChange: onChange,
          onFocus: stopPropagation,
          required: required,
          style: {
            visibility: 'hidden',
            position: 'absolute',
            zIndex: '-999' },

          type: nativeInputType,
          value: value ? nativeValueParser(value) : '' });

      }

      NativeInput.propTypes = {
        ariaLabel: _propTypes["default"].string,
        disabled: _propTypes["default"].bool,
        maxDate: _propTypes2.isMaxDate,
        minDate: _propTypes2.isMinDate,
        name: _propTypes["default"].string,
        onChange: _propTypes["default"].func,
        required: _propTypes["default"].bool,
        value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
        valueType: _propTypes2.isValueType };

    })(NativeInput);

    var dates = {};

    Object.defineProperty(dates, "__esModule", {
      value: true });

    dates.getBegin = getBegin;
    dates.getEnd = getEnd;

    var _dateUtils = require$$2;

    /**
     * Returns the beginning of a given range.
     *
     * @param {string} rangeType Range type (e.g. 'day')
     * @param {Date} date Date.
     */
    function getBegin(rangeType, date) {
      switch (rangeType) {
        case 'century':
          return (0, _dateUtils.getCenturyStart)(date);

        case 'decade':
          return (0, _dateUtils.getDecadeStart)(date);

        case 'year':
          return (0, _dateUtils.getYearStart)(date);

        case 'month':
          return (0, _dateUtils.getMonthStart)(date);

        case 'day':
          return (0, _dateUtils.getDayStart)(date);

        default:
          throw new Error("Invalid rangeType: ".concat(rangeType));}

    }
    /**
     * Returns the end of a given range.
     *
     * @param {string} rangeType Range type (e.g. 'day')
     * @param {Date} date Date.
     */


    function getEnd(rangeType, date) {
      switch (rangeType) {
        case 'century':
          return (0, _dateUtils.getCenturyEnd)(date);

        case 'decade':
          return (0, _dateUtils.getDecadeEnd)(date);

        case 'year':
          return (0, _dateUtils.getYearEnd)(date);

        case 'month':
          return (0, _dateUtils.getMonthEnd)(date);

        case 'day':
          return (0, _dateUtils.getDayEnd)(date);

        default:
          throw new Error("Invalid rangeType: ".concat(rangeType));}

    }

    (function (exports) {

      function _typeof(obj) {"@babel/helpers - typeof";return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof(obj);}

      Object.defineProperty(exports, "__esModule", {
        value: true });

      exports["default"] = void 0;

      var _react = _interopRequireWildcard(React__default["default"]);

      var _propTypes = _interopRequireDefault(propTypes$1.exports);

      var _dateUtils = require$$2;

      var _Divider = _interopRequireDefault(Divider);

      var _DayInput = _interopRequireDefault(DayInput);

      var _MonthInput = _interopRequireDefault(MonthInput);

      var _MonthSelect = _interopRequireDefault(MonthSelect);

      var _YearInput = _interopRequireDefault(YearInput);

      var _NativeInput = _interopRequireDefault(NativeInput);

      var _dateFormatter = dateFormatter;

      var _dates = dates;

      var _propTypes2 = propTypes;

      var _utils = utils;

      function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

      function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}

      function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {return { "default": obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj["default"] = obj;if (cache) {cache.set(obj, newObj);}return newObj;}

      function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}

      function _slicedToArray(arr, i) {return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();}

      function _nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

      function _iterableToArrayLimit(arr, i) {var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];if (_i == null) return;var _arr = [];var _n = true;var _d = false;var _s, _e;try {for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}

      function _arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}

      function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

      function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

      function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

      function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) _setPrototypeOf(subClass, superClass);}

      function _setPrototypeOf(o, p) {_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return _setPrototypeOf(o, p);}

      function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = _getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return _possibleConstructorReturn(this, result);};}

      function _possibleConstructorReturn(self, call) {if (call && (_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}

      function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

      function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

      function _getPrototypeOf(o) {_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return _getPrototypeOf(o);}

      function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

      function _toConsumableArray(arr) {return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();}

      function _nonIterableSpread() {throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

      function _unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);}

      function _iterableToArray(iter) {if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);}

      function _arrayWithoutHoles(arr) {if (Array.isArray(arr)) return _arrayLikeToArray(arr);}

      function _arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}

      var defaultMinDate = new Date();
      defaultMinDate.setFullYear(1, 0, 1);
      defaultMinDate.setHours(0, 0, 0, 0);
      var defaultMaxDate = new Date(8.64e15);
      var allViews = ['century', 'decade', 'year', 'month'];
      var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);

      function toDate(value) {
        if (value instanceof Date) {
          return value;
        }

        return new Date(value);
      }

      function datesAreDifferent(date1, date2) {
        return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
      }
      /**
       * Returns value type that can be returned with currently applied settings.
       */


      function getValueType(maxDetail) {
        return allValueTypes[allViews.indexOf(maxDetail)];
      }

      function getValue(value, index) {
        if (!value) {
          return null;
        }

        var rawValue = Array.isArray(value) && value.length === 2 ? value[index] : value;

        if (!rawValue) {
          return null;
        }

        var valueDate = toDate(rawValue);

        if (isNaN(valueDate.getTime())) {
          throw new Error("Invalid date: ".concat(value));
        }

        return valueDate;
      }

      function getDetailValue(_ref, index) {
        var value = _ref.value,
        minDate = _ref.minDate,
        maxDate = _ref.maxDate,
        maxDetail = _ref.maxDetail;
        var valuePiece = getValue(value, index);

        if (!valuePiece) {
          return null;
        }

        var valueType = getValueType(maxDetail);
        var detailValueFrom = [_dates.getBegin, _dates.getEnd][index](valueType, valuePiece);
        return (0, _utils.between)(detailValueFrom, minDate, maxDate);
      }

      var getDetailValueFrom = function getDetailValueFrom(args) {
        return getDetailValue(args, 0);
      };

      var getDetailValueTo = function getDetailValueTo(args) {
        return getDetailValue(args, 1);
      };

      var getDetailValueArray = function getDetailValueArray(args) {
        var value = args.value;

        if (Array.isArray(value)) {
          return value;
        }

        return [getDetailValueFrom, getDetailValueTo].map(function (fn) {
          return fn(args);
        });
      };

      function isInternalInput(element) {
        return element.getAttribute('data-input') === 'true';
      }

      function findInput(element, property) {
        var nextElement = element;

        do {
          nextElement = nextElement[property];
        } while (nextElement && !isInternalInput(nextElement));

        return nextElement;
      }

      function focus(element) {
        if (element) {
          element.focus();
        }
      }

      function _renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances) {
        var usedFunctions = [];
        var pattern = new RegExp(Object.keys(elementFunctions).map(function (el) {
          return "".concat(el, "+");
        }).join('|'), 'g');
        var matches = placeholder.match(pattern);
        return placeholder.split(pattern).reduce(function (arr, element, index) {
          var divider = element &&
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          _react["default"].createElement(_Divider["default"], {
            key: "separator_".concat(index) },
          element);

          var res = [].concat(_toConsumableArray(arr), [divider]);
          var currentMatch = matches && matches[index];

          if (currentMatch) {
            var renderFunction = elementFunctions[currentMatch] || elementFunctions[Object.keys(elementFunctions).find(function (elementFunction) {
              return currentMatch.match(elementFunction);
            })];

            if (!allowMultipleInstances && usedFunctions.includes(renderFunction)) {
              res.push(currentMatch);
            } else {
              res.push(renderFunction(currentMatch, index));
              usedFunctions.push(renderFunction);
            }
          }

          return res;
        }, []);
      }

      var DateInput = /*#__PURE__*/function (_PureComponent) {
        _inherits(DateInput, _PureComponent);

        var _super = _createSuper(DateInput);

        function DateInput() {
          var _this;

          _classCallCheck(this, DateInput);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = _super.call.apply(_super, [this].concat(args));

          _defineProperty(_assertThisInitialized(_this), "state", {
            year: null,
            month: null,
            day: null });


          _defineProperty(_assertThisInitialized(_this), "dayInput", /*#__PURE__*/(0, _react.createRef)());

          _defineProperty(_assertThisInitialized(_this), "monthInput", /*#__PURE__*/(0, _react.createRef)());

          _defineProperty(_assertThisInitialized(_this), "yearInput", /*#__PURE__*/(0, _react.createRef)());

          _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
            if (event.target === event.currentTarget) {
              // Wrapper was directly clicked
              var firstInput = event.target.children[1];
              focus(firstInput);
            }
          });

          _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
            switch (event.key) {
              case 'ArrowLeft':
              case 'ArrowRight':
              case _this.divider:
                {
                  event.preventDefault();
                  var input = event.target;
                  var property = event.key === 'ArrowLeft' ? 'previousElementSibling' : 'nextElementSibling';
                  var nextInput = findInput(input, property);
                  focus(nextInput);
                  break;
                }
    }

          });

          _defineProperty(_assertThisInitialized(_this), "onKeyUp", function (event) {
            var key = event.key,
            input = event.target;
            var isNumberKey = !isNaN(parseInt(key, 10));

            if (!isNumberKey) {
              return;
            }

            var value = input.value;
            var max = input.getAttribute('max');
            /**
             * Given 1, the smallest possible number the user could type by adding another digit is 10.
             * 10 would be a valid value given max = 12, so we won't jump to the next input.
             * However, given 2, smallers possible number would be 20, and thus keeping the focus in
             * this field doesn't make sense.
             */

            if (value * 10 > max || value.length >= max.length) {
              var property = 'nextElementSibling';
              var nextInput = findInput(input, property);
              focus(nextInput);
            }
          });

          _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
            var _event$target = event.target,
            name = _event$target.name,
            value = _event$target.value;

            _this.setState(_defineProperty({}, name, value), _this.onChangeExternal);
          });

          _defineProperty(_assertThisInitialized(_this), "onChangeNative", function (event) {
            var onChange = _this.props.onChange;
            var value = event.target.value;

            if (!onChange) {
              return;
            }

            var processedValue = function () {
              if (!value) {
                return null;
              }

              var _value$split = value.split('-'),
              _value$split2 = _slicedToArray(_value$split, 3),
              yearString = _value$split2[0],
              monthString = _value$split2[1],
              dayString = _value$split2[2];

              var year = parseInt(yearString, 10);
              var monthIndex = parseInt(monthString, 10) - 1 || 0;
              var day = parseInt(dayString, 10) || 1;
              var proposedValue = new Date();
              proposedValue.setFullYear(year, monthIndex, day);
              proposedValue.setHours(0, 0, 0, 0);
              return proposedValue;
            }();

            onChange(processedValue, false);
          });

          _defineProperty(_assertThisInitialized(_this), "onChangeExternal", function () {
            var onChange = _this.props.onChange;

            if (!onChange) {
              return;
            }

            var formElements = [_this.dayInput.current, _this.monthInput.current, _this.yearInput.current].filter(Boolean);
            var values = {};
            formElements.forEach(function (formElement) {
              values[formElement.name] = formElement.value;
            });

            if (formElements.every(function (formElement) {
              return !formElement.value;
            })) {
              onChange(null, false);
            } else if (formElements.every(function (formElement) {
              return formElement.value && formElement.validity.valid;
            })) {
              var year = parseInt(values.year, 10) || new Date().getFullYear();
              var monthIndex = parseInt(values.month || 1, 10) - 1;
              var day = parseInt(values.day || 1, 10);
              var proposedValue = new Date();
              proposedValue.setFullYear(year, monthIndex, day);
              proposedValue.setHours(0, 0, 0, 0);

              var processedValue = _this.getProcessedValue(proposedValue);

              onChange(processedValue, false);
            }
          });

          _defineProperty(_assertThisInitialized(_this), "renderDay", function (currentMatch, index) {
            var _this$props = _this.props,
            autoFocus = _this$props.autoFocus,
            dayAriaLabel = _this$props.dayAriaLabel,
            dayPlaceholder = _this$props.dayPlaceholder,
            showLeadingZeros = _this$props.showLeadingZeros;
            var _this$state = _this.state,
            day = _this$state.day,
            month = _this$state.month,
            year = _this$state.year;

            if (currentMatch && currentMatch.length > 2) {
              throw new Error("Unsupported token: ".concat(currentMatch));
            }

            var showLeadingZerosFromFormat = currentMatch && currentMatch.length === 2;
            return /*#__PURE__*/_react["default"].createElement(_DayInput["default"], _extends({
              key: "day" },
            _this.commonInputProps, {
              ariaLabel: dayAriaLabel // eslint-disable-next-line jsx-a11y/no-autofocus
              ,
              autoFocus: index === 0 && autoFocus,
              inputRef: _this.dayInput,
              month: month,
              placeholder: dayPlaceholder,
              showLeadingZeros: showLeadingZerosFromFormat || showLeadingZeros,
              value: day,
              year: year }));

          });

          _defineProperty(_assertThisInitialized(_this), "renderMonth", function (currentMatch, index) {
            var _this$props2 = _this.props,
            autoFocus = _this$props2.autoFocus,
            locale = _this$props2.locale,
            monthAriaLabel = _this$props2.monthAriaLabel,
            monthPlaceholder = _this$props2.monthPlaceholder,
            showLeadingZeros = _this$props2.showLeadingZeros;
            var _this$state2 = _this.state,
            month = _this$state2.month,
            year = _this$state2.year;

            if (currentMatch && currentMatch.length > 4) {
              throw new Error("Unsupported token: ".concat(currentMatch));
            }

            if (currentMatch.length > 2) {
              return /*#__PURE__*/_react["default"].createElement(_MonthSelect["default"], _extends({
                key: "month" },
              _this.commonInputProps, {
                ariaLabel: monthAriaLabel // eslint-disable-next-line jsx-a11y/no-autofocus
                ,
                autoFocus: index === 0 && autoFocus,
                inputRef: _this.monthInput,
                locale: locale,
                placeholder: monthPlaceholder,
                "short": currentMatch.length === 3,
                value: month,
                year: year }));

            }

            var showLeadingZerosFromFormat = currentMatch && currentMatch.length === 2;
            return /*#__PURE__*/_react["default"].createElement(_MonthInput["default"], _extends({
              key: "month" },
            _this.commonInputProps, {
              ariaLabel: monthAriaLabel // eslint-disable-next-line jsx-a11y/no-autofocus
              ,
              autoFocus: index === 0 && autoFocus,
              inputRef: _this.monthInput,
              placeholder: monthPlaceholder,
              showLeadingZeros: showLeadingZerosFromFormat || showLeadingZeros,
              value: month,
              year: year }));

          });

          _defineProperty(_assertThisInitialized(_this), "renderYear", function (currentMatch, index) {
            var _this$props3 = _this.props,
            autoFocus = _this$props3.autoFocus,
            yearAriaLabel = _this$props3.yearAriaLabel,
            yearPlaceholder = _this$props3.yearPlaceholder;
            var year = _this.state.year;
            return /*#__PURE__*/_react["default"].createElement(_YearInput["default"], _extends({
              key: "year" },
            _this.commonInputProps, {
              ariaLabel: yearAriaLabel // eslint-disable-next-line jsx-a11y/no-autofocus
              ,
              autoFocus: index === 0 && autoFocus,
              inputRef: _this.yearInput,
              placeholder: yearPlaceholder,
              value: year,
              valueType: _this.valueType }));

          });

          return _this;
        }

        _createClass(DateInput, [{
          key: "formatDate",
          get: function get() {
            var maxDetail = this.props.maxDetail;
            var options = {
              year: 'numeric' };

            var level = allViews.indexOf(maxDetail);

            if (level >= 2) {
              options.month = 'numeric';
            }

            if (level >= 3) {
              options.day = 'numeric';
            }

            return (0, _dateFormatter.getFormatter)(options);
          }
          /**
           * Gets current value in a desired format.
           */ },

        {
          key: "getProcessedValue",
          value: function getProcessedValue(value) {
            var _this$props4 = this.props,
            minDate = _this$props4.minDate,
            maxDate = _this$props4.maxDate,
            maxDetail = _this$props4.maxDetail,
            returnValue = _this$props4.returnValue;

            var processFunction = function () {
              switch (returnValue) {
                case 'start':
                  return getDetailValueFrom;

                case 'end':
                  return getDetailValueTo;

                case 'range':
                  return getDetailValueArray;

                default:
                  throw new Error('Invalid returnValue.');}

            }();

            return processFunction({
              value: value,
              minDate: minDate,
              maxDate: maxDate,
              maxDetail: maxDetail });

          } },
        {
          key: "divider",
          get: function get() {
            var dividers = this.placeholder.match(/[^0-9a-z]/i);
            return dividers ? dividers[0] : null;
          } },
        {
          key: "placeholder",
          get: function get() {
            var _this$props5 = this.props,
            format = _this$props5.format,
            locale = _this$props5.locale;

            if (format) {
              return format;
            }

            var year = 2017;
            var monthIndex = 11;
            var day = 11;
            var date = new Date(year, monthIndex, day);
            var formattedDate = this.formatDate(locale, date);
            var datePieces = ['year', 'month', 'day'];
            var datePieceReplacements = ['y', 'M', 'd'];

            function formatDatePiece(name, dateToFormat) {
              return (0, _dateFormatter.getFormatter)(_defineProperty({
                useGrouping: false },
              name, 'numeric'))(locale, dateToFormat).match(/\d{1,}/);
            }

            var placeholder = formattedDate;
            datePieces.forEach(function (datePiece, index) {
              var formattedDatePiece = formatDatePiece(datePiece, date);
              var datePieceReplacement = datePieceReplacements[index];
              placeholder = placeholder.replace(formattedDatePiece, datePieceReplacement);
            }); // See: https://github.com/wojtekmaj/react-date-picker/issues/396

            placeholder = placeholder.replace('17', 'y');
            return placeholder;
          } },
        {
          key: "commonInputProps",
          get: function get() {
            var _this$props6 = this.props,
            className = _this$props6.className,
            disabled = _this$props6.disabled,
            isCalendarOpen = _this$props6.isCalendarOpen,
            maxDate = _this$props6.maxDate,
            minDate = _this$props6.minDate,
            required = _this$props6.required;
            return {
              className: className,
              disabled: disabled,
              maxDate: maxDate || defaultMaxDate,
              minDate: minDate || defaultMinDate,
              onChange: this.onChange,
              onKeyDown: this.onKeyDown,
              onKeyUp: this.onKeyUp,
              // This is only for showing validity when editing
              required: required || isCalendarOpen };

          } },
        {
          key: "valueType",
          get: function get() {
            var maxDetail = this.props.maxDetail;
            return getValueType(maxDetail);
          } },
        {
          key: "renderCustomInputs",
          value: function renderCustomInputs() {
            var placeholder = this.placeholder;
            var format = this.props.format;
            var elementFunctions = {
              d: this.renderDay,
              M: this.renderMonth,
              y: this.renderYear };

            var allowMultipleInstances = typeof format !== 'undefined';
            return _renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances);
          } },
        {
          key: "renderNativeInput",
          value: function renderNativeInput() {
            var _this$props7 = this.props,
            disabled = _this$props7.disabled,
            maxDate = _this$props7.maxDate,
            minDate = _this$props7.minDate,
            name = _this$props7.name,
            nativeInputAriaLabel = _this$props7.nativeInputAriaLabel,
            required = _this$props7.required;
            var value = this.state.value;
            return /*#__PURE__*/_react["default"].createElement(_NativeInput["default"], {
              key: "date",
              ariaLabel: nativeInputAriaLabel,
              disabled: disabled,
              maxDate: maxDate || defaultMaxDate,
              minDate: minDate || defaultMinDate,
              name: name,
              onChange: this.onChangeNative,
              required: required,
              value: value,
              valueType: this.valueType });

          } },
        {
          key: "render",
          value: function render() {
            var className = this.props.className;
            return (
              /*#__PURE__*/
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
              _react["default"].createElement("div", {
                className: className,
                onClick: this.onClick },
              this.renderNativeInput(), this.renderCustomInputs()));

          } }],
        [{
          key: "getDerivedStateFromProps",
          value: function getDerivedStateFromProps(nextProps, prevState) {
            var minDate = nextProps.minDate,
            maxDate = nextProps.maxDate,
            maxDetail = nextProps.maxDetail;
            var nextState = {};
            /**
             * If isCalendarOpen flag has changed, we have to update it.
             * It's saved in state purely for use in getDerivedStateFromProps.
             */

            if (nextProps.isCalendarOpen !== prevState.isCalendarOpen) {
              nextState.isCalendarOpen = nextProps.isCalendarOpen;
            }
            /**
             * If the next value is different from the current one  (with an exception of situation in
             * which values provided are limited by minDate and maxDate so that the dates are the same),
             * get a new one.
             */


            var nextValue = getDetailValueFrom({
              value: nextProps.value,
              minDate: minDate,
              maxDate: maxDate,
              maxDetail: maxDetail });

            var values = [nextValue, prevState.value];

            if ( // Toggling calendar visibility resets values
            nextState.isCalendarOpen || // Flag was toggled
            datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
              return getDetailValueFrom({
                value: value,
                minDate: minDate,
                maxDate: maxDate,
                maxDetail: maxDetail });

            }))) || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
              return getDetailValueTo({
                value: value,
                minDate: minDate,
                maxDate: maxDate,
                maxDetail: maxDetail });

            })))) {
              if (nextValue) {
                nextState.year = (0, _dateUtils.getYear)(nextValue).toString();
                nextState.month = (0, _dateUtils.getMonthHuman)(nextValue).toString();
                nextState.day = (0, _dateUtils.getDate)(nextValue).toString();
              } else {
                nextState.year = null;
                nextState.month = null;
                nextState.day = null;
              }

              nextState.value = nextValue;
            }

            return nextState;
          } }]);


        return DateInput;
      }(_react.PureComponent);

      exports["default"] = DateInput;
      DateInput.defaultProps = {
        maxDetail: 'month',
        name: 'date',
        returnValue: 'start' };


      var isValue = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]);

      DateInput.propTypes = {
        autoFocus: _propTypes["default"].bool,
        className: _propTypes["default"].string.isRequired,
        dayAriaLabel: _propTypes["default"].string,
        dayPlaceholder: _propTypes["default"].string,
        disabled: _propTypes["default"].bool,
        format: _propTypes["default"].string,
        isCalendarOpen: _propTypes["default"].bool,
        locale: _propTypes["default"].string,
        maxDate: _propTypes2.isMaxDate,
        maxDetail: _propTypes["default"].oneOf(allViews),
        minDate: _propTypes2.isMinDate,
        monthAriaLabel: _propTypes["default"].string,
        monthPlaceholder: _propTypes["default"].string,
        name: _propTypes["default"].string,
        nativeInputAriaLabel: _propTypes["default"].string,
        onChange: _propTypes["default"].func,
        required: _propTypes["default"].bool,
        returnValue: _propTypes["default"].oneOf(['start', 'end', 'range']),
        showLeadingZeros: _propTypes["default"].bool,
        value: _propTypes["default"].oneOfType([isValue, _propTypes["default"].arrayOf(isValue)]),
        yearAriaLabel: _propTypes["default"].string,
        yearPlaceholder: _propTypes["default"].string };

    })(DateInput);

    (function (exports) {

      function _typeof(obj) {"@babel/helpers - typeof";return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof(obj);}

      Object.defineProperty(exports, "__esModule", {
        value: true });

      exports["default"] = void 0;

      var _react = _interopRequireWildcard(React__default["default"]);

      var _propTypes = _interopRequireDefault(propTypes$1.exports);

      var _makeEventProps = _interopRequireDefault(require$$2$1);

      var _mergeClassNames = _interopRequireDefault(require$$3$1);

      var _reactCalendar = _interopRequireDefault(require$$4$1);

      var _reactFit = _interopRequireDefault(require$$5);

      var _DateInput = _interopRequireDefault(DateInput);

      var _propTypes2 = propTypes;

      var _excluded = ["calendarClassName", "className", "onChange", "value"],
      _excluded2 = ["onChange"];

      function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

      function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}

      function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {return { "default": obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj["default"] = obj;if (cache) {cache.set(obj, newObj);}return newObj;}

      function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

      function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}

      function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}

      function _slicedToArray(arr, i) {return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();}

      function _nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

      function _unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);}

      function _arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}

      function _iterableToArrayLimit(arr, i) {var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];if (_i == null) return;var _arr = [];var _n = true;var _d = false;var _s, _e;try {for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}

      function _arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}

      function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

      function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

      function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

      function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) _setPrototypeOf(subClass, superClass);}

      function _setPrototypeOf(o, p) {_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return _setPrototypeOf(o, p);}

      function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = _getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return _possibleConstructorReturn(this, result);};}

      function _possibleConstructorReturn(self, call) {if (call && (_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}

      function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

      function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

      function _getPrototypeOf(o) {_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return _getPrototypeOf(o);}

      function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

      var baseClassName = 'react-date-picker';
      var outsideActionEvents = ['mousedown', 'focusin', 'touchstart'];
      var allViews = ['century', 'decade', 'year', 'month'];

      var DatePicker = /*#__PURE__*/function (_PureComponent) {
        _inherits(DatePicker, _PureComponent);

        var _super = _createSuper(DatePicker);

        function DatePicker() {
          var _this;

          _classCallCheck(this, DatePicker);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = _super.call.apply(_super, [this].concat(args));

          _defineProperty(_assertThisInitialized(_this), "state", {});

          _defineProperty(_assertThisInitialized(_this), "onOutsideAction", function (event) {
            // Try event.composedPath first to handle clicks inside a Shadow DOM.
            var target = 'composedPath' in event ? event.composedPath()[0] : event.target;

            if (_this.wrapper && !_this.wrapper.contains(target)) {
              _this.closeCalendar();
            }
          });

          _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
            var closeCalendar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.closeCalendar;
            var onChange = _this.props.onChange;

            if (closeCalendar) {
              _this.closeCalendar();
            }

            if (onChange) {
              onChange(value);
            }
          });

          _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
            var _this$props = _this.props,
            disabled = _this$props.disabled,
            onFocus = _this$props.onFocus,
            openCalendarOnFocus = _this$props.openCalendarOnFocus;

            if (onFocus) {
              onFocus(event);
            } // Internet Explorer still fires onFocus on disabled elements


            if (disabled) {
              return;
            }

            if (openCalendarOnFocus) {
              if (event.target.getAttribute('data-select') === 'true') {
                return;
              }

              _this.openCalendar();
            }
          });

          _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
            if (event.key === 'Escape') {
              _this.closeCalendar();
            }
          });

          _defineProperty(_assertThisInitialized(_this), "openCalendar", function () {
            _this.setState({
              isOpen: true });

          });

          _defineProperty(_assertThisInitialized(_this), "closeCalendar", function () {
            _this.setState(function (prevState) {
              if (!prevState.isOpen) {
                return null;
              }

              return {
                isOpen: false };

            });
          });

          _defineProperty(_assertThisInitialized(_this), "toggleCalendar", function () {
            _this.setState(function (prevState) {
              return {
                isOpen: !prevState.isOpen };

            });
          });

          _defineProperty(_assertThisInitialized(_this), "stopPropagation", function (event) {
            return event.stopPropagation();
          });

          _defineProperty(_assertThisInitialized(_this), "clear", function () {
            return _this.onChange(null);
          });

          return _this;
        }

        _createClass(DatePicker, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.handleOutsideActionListeners();
          } },
        {
          key: "componentDidUpdate",
          value: function componentDidUpdate(prevProps, prevState) {
            var isOpen = this.state.isOpen;
            var _this$props2 = this.props,
            onCalendarClose = _this$props2.onCalendarClose,
            onCalendarOpen = _this$props2.onCalendarOpen;

            if (isOpen !== prevState.isOpen) {
              this.handleOutsideActionListeners();
              var callback = isOpen ? onCalendarOpen : onCalendarClose;
              if (callback) callback();
            }
          } },
        {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.handleOutsideActionListeners(false);
          } },
        {
          key: "eventProps",
          get: function get() {
            return (0, _makeEventProps["default"])(this.props);
          } },
        {
          key: "handleOutsideActionListeners",
          value: function handleOutsideActionListeners(shouldListen) {
            var _this2 = this;

            var isOpen = this.state.isOpen;
            var shouldListenWithFallback = typeof shouldListen !== 'undefined' ? shouldListen : isOpen;
            var fnName = shouldListenWithFallback ? 'addEventListener' : 'removeEventListener';
            outsideActionEvents.forEach(function (eventName) {
              return document[fnName](eventName, _this2.onOutsideAction);
            });
            document[fnName]('keydown', this.onKeyDown);
          } },
        {
          key: "renderInputs",
          value: function renderInputs() {
            var _this$props3 = this.props,
            autoFocus = _this$props3.autoFocus,
            calendarAriaLabel = _this$props3.calendarAriaLabel,
            calendarIcon = _this$props3.calendarIcon,
            clearAriaLabel = _this$props3.clearAriaLabel,
            clearIcon = _this$props3.clearIcon,
            dayAriaLabel = _this$props3.dayAriaLabel,
            dayPlaceholder = _this$props3.dayPlaceholder,
            disableCalendar = _this$props3.disableCalendar,
            disabled = _this$props3.disabled,
            format = _this$props3.format,
            locale = _this$props3.locale,
            maxDate = _this$props3.maxDate,
            maxDetail = _this$props3.maxDetail,
            minDate = _this$props3.minDate,
            monthAriaLabel = _this$props3.monthAriaLabel,
            monthPlaceholder = _this$props3.monthPlaceholder,
            name = _this$props3.name,
            nativeInputAriaLabel = _this$props3.nativeInputAriaLabel,
            required = _this$props3.required,
            returnValue = _this$props3.returnValue,
            showLeadingZeros = _this$props3.showLeadingZeros,
            value = _this$props3.value,
            yearAriaLabel = _this$props3.yearAriaLabel,
            yearPlaceholder = _this$props3.yearPlaceholder;
            var isOpen = this.state.isOpen;

            var _concat = [].concat(value),
            _concat2 = _slicedToArray(_concat, 1),
            valueFrom = _concat2[0];

            var ariaLabelProps = {
              dayAriaLabel: dayAriaLabel,
              monthAriaLabel: monthAriaLabel,
              nativeInputAriaLabel: nativeInputAriaLabel,
              yearAriaLabel: yearAriaLabel };

            var placeholderProps = {
              dayPlaceholder: dayPlaceholder,
              monthPlaceholder: monthPlaceholder,
              yearPlaceholder: yearPlaceholder };

            return /*#__PURE__*/_react["default"].createElement("div", {
              className: "".concat(baseClassName, "__wrapper") },
            /*#__PURE__*/_react["default"].createElement(_DateInput["default"], _extends({}, ariaLabelProps, placeholderProps, {
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus: autoFocus,
              className: "".concat(baseClassName, "__inputGroup"),
              disabled: disabled,
              format: format,
              isCalendarOpen: isOpen,
              locale: locale,
              maxDate: maxDate,
              maxDetail: maxDetail,
              minDate: minDate,
              name: name,
              onChange: this.onChange,
              required: required,
              returnValue: returnValue,
              showLeadingZeros: showLeadingZeros,
              value: valueFrom })),
            clearIcon !== null && /*#__PURE__*/_react["default"].createElement("button", {
              "aria-label": clearAriaLabel,
              className: "".concat(baseClassName, "__clear-button ").concat(baseClassName, "__button"),
              disabled: disabled,
              onClick: this.clear,
              onFocus: this.stopPropagation,
              type: "button" },
            clearIcon), calendarIcon !== null && !disableCalendar && /*#__PURE__*/_react["default"].createElement("button", {
              "aria-label": calendarAriaLabel,
              className: "".concat(baseClassName, "__calendar-button ").concat(baseClassName, "__button"),
              disabled: disabled,
              onBlur: this.resetValue,
              onClick: this.toggleCalendar,
              onFocus: this.stopPropagation,
              type: "button" },
            calendarIcon));
          } },
        {
          key: "renderCalendar",
          value: function renderCalendar() {
            var disableCalendar = this.props.disableCalendar;
            var isOpen = this.state.isOpen;

            if (isOpen === null || disableCalendar) {
              return null;
            }

            var _this$props4 = this.props,
            calendarClassName = _this$props4.calendarClassName;
            _this$props4.className;
            _this$props4.onChange;
            var value = _this$props4.value,
            calendarProps = _objectWithoutProperties(_this$props4, _excluded);

            var className = "".concat(baseClassName, "__calendar");
            return /*#__PURE__*/_react["default"].createElement(_reactFit["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
              ref: function ref(_ref) {
                if (_ref && !isOpen) {
                  _ref.removeAttribute('style');
                }
              },
              className: (0, _mergeClassNames["default"])(className, "".concat(className, "--").concat(isOpen ? 'open' : 'closed')),
              style: isOpen ? undefined : {} },
            /*#__PURE__*/_react["default"].createElement(_reactCalendar["default"], _extends({
              className: calendarClassName,
              onChange: this.onChange,
              value: value || null },
            calendarProps))));
          } },
        {
          key: "render",
          value: function render() {
            var _this3 = this;

            var eventProps = this.eventProps;
            var _this$props5 = this.props,
            className = _this$props5.className,
            disabled = _this$props5.disabled;
            var isOpen = this.state.isOpen;

            eventProps.onChange;
            var eventPropsWithoutOnChange = _objectWithoutProperties(eventProps, _excluded2);

            return /*#__PURE__*/_react["default"].createElement("div", _extends({
              className: (0, _mergeClassNames["default"])(baseClassName, "".concat(baseClassName, "--").concat(isOpen ? 'open' : 'closed'), "".concat(baseClassName, "--").concat(disabled ? 'disabled' : 'enabled'), className) },
            eventPropsWithoutOnChange, {
              onFocus: this.onFocus,
              ref: function ref(_ref2) {
                if (!_ref2) {
                  return;
                }

                _this3.wrapper = _ref2;
              } }),
            this.renderInputs(), this.renderCalendar());
          } }],
        [{
          key: "getDerivedStateFromProps",
          value: function getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.isOpen !== prevState.isOpenProps) {
              return {
                isOpen: nextProps.isOpen,
                isOpenProps: nextProps.isOpen };

            }

            return null;
          } }]);


        return DatePicker;
      }(_react.PureComponent);

      exports["default"] = DatePicker;
      var iconProps = {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 19,
        height: 19,
        viewBox: '0 0 19 19',
        stroke: 'black',
        strokeWidth: 2 };


      var CalendarIcon = /*#__PURE__*/_react["default"].createElement("svg", _extends({}, iconProps, {
        className: "".concat(baseClassName, "__calendar-button__icon ").concat(baseClassName, "__button__icon") }),
      /*#__PURE__*/_react["default"].createElement("rect", {
        fill: "none",
        height: "15",
        width: "15",
        x: "2",
        y: "2" }),
      /*#__PURE__*/_react["default"].createElement("line", {
        x1: "6",
        x2: "6",
        y1: "0",
        y2: "4" }),
      /*#__PURE__*/_react["default"].createElement("line", {
        x1: "13",
        x2: "13",
        y1: "0",
        y2: "4" }));


      var ClearIcon = /*#__PURE__*/_react["default"].createElement("svg", _extends({}, iconProps, {
        className: "".concat(baseClassName, "__clear-button__icon ").concat(baseClassName, "__button__icon") }),
      /*#__PURE__*/_react["default"].createElement("line", {
        x1: "4",
        x2: "15",
        y1: "4",
        y2: "15" }),
      /*#__PURE__*/_react["default"].createElement("line", {
        x1: "15",
        x2: "4",
        y1: "4",
        y2: "15" }));


      DatePicker.defaultProps = {
        calendarIcon: CalendarIcon,
        clearIcon: ClearIcon,
        closeCalendar: true,
        isOpen: null,
        openCalendarOnFocus: true,
        returnValue: 'start' };


      var isValue = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]);

      DatePicker.propTypes = {
        autoFocus: _propTypes["default"].bool,
        calendarAriaLabel: _propTypes["default"].string,
        calendarClassName: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
        calendarIcon: _propTypes["default"].node,
        className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
        clearAriaLabel: _propTypes["default"].string,
        clearIcon: _propTypes["default"].node,
        closeCalendar: _propTypes["default"].bool,
        dayAriaLabel: _propTypes["default"].string,
        dayPlaceholder: _propTypes["default"].string,
        disableCalendar: _propTypes["default"].bool,
        disabled: _propTypes["default"].bool,
        format: _propTypes["default"].string,
        isOpen: _propTypes["default"].bool,
        locale: _propTypes["default"].string,
        maxDate: _propTypes2.isMaxDate,
        maxDetail: _propTypes["default"].oneOf(allViews),
        minDate: _propTypes2.isMinDate,
        monthAriaLabel: _propTypes["default"].string,
        monthPlaceholder: _propTypes["default"].string,
        name: _propTypes["default"].string,
        nativeInputAriaLabel: _propTypes["default"].string,
        onCalendarClose: _propTypes["default"].func,
        onCalendarOpen: _propTypes["default"].func,
        onChange: _propTypes["default"].func,
        onFocus: _propTypes["default"].func,
        openCalendarOnFocus: _propTypes["default"].bool,
        required: _propTypes["default"].bool,
        returnValue: _propTypes["default"].oneOf(['start', 'end', 'range']),
        showLeadingZeros: _propTypes["default"].bool,
        value: _propTypes["default"].oneOfType([isValue, _propTypes["default"].arrayOf(isValue)]),
        yearAriaLabel: _propTypes["default"].string,
        yearPlaceholder: _propTypes["default"].string };

    })(DatePicker$1);

    (function (exports) {

      Object.defineProperty(exports, "__esModule", {
        value: true });

      exports["default"] = void 0;

      var _DatePicker = _interopRequireDefault(DatePicker$1);

      function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { "default": obj };}

      var _default = _DatePicker["default"];
      exports["default"] = _default;
    })(entry_nostyle);

    var DatePickerComponent = /*@__PURE__*/getDefaultExportFromCjs(entry_nostyle);

    var classes$r = {"label":"awell__questionLabel_label","asterix":"awell__questionLabel_asterix"};

    var QuestionLabel = function (_a) {
      var label = _a.label,_b = _a.mandatory,mandatory = _b === void 0 ? false : _b,props = __rest(_a, ["label", "mandatory"]);
      return jsxRuntime.exports.jsxs("label", __assign({}, props, { className: "".concat(classes$r.label, " awell__question_label"), id: "awell__question_label" }, { children: [jsxRuntime.exports.jsx("span", { children: label }), ' ', mandatory && jsxRuntime.exports.jsx("span", __assign({ className: classes$r.asterix }, { children: "*" }))] }));
    };

    function toInteger(dirtyNumber) {
      if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
        return NaN;
      }

      var number = Number(dirtyNumber);

      if (isNaN(number)) {
        return number;
      }

      return number < 0 ? Math.ceil(number) : Math.floor(number);
    }

    function requiredArgs(required, args) {
      if (args.length < required) {
        throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
      }
    }

    /**
     * @name toDate
     * @category Common Helpers
     * @summary Convert the given argument to an instance of Date.
     *
     * @description
     * Convert the given argument to an instance of Date.
     *
     * If the argument is an instance of Date, the function returns its clone.
     *
     * If the argument is a number, it is treated as a timestamp.
     *
     * If the argument is none of the above, the function returns Invalid Date.
     *
     * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
     *
     * @param {Date|Number} argument - the value to convert
     * @returns {Date} the parsed date in the local time zone
     * @throws {TypeError} 1 argument required
     *
     * @example
     * // Clone the date:
     * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
     * //=> Tue Feb 11 2014 11:30:30
     *
     * @example
     * // Convert the timestamp to date:
     * const result = toDate(1392098430000)
     * //=> Tue Feb 11 2014 11:30:30
     */

    function toDate(argument) {
      requiredArgs(1, arguments);
      var argStr = Object.prototype.toString.call(argument); // Clone the date

      if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
        // Prevent the date to lose the milliseconds when passed to new Date() in IE10
        return new Date(argument.getTime());
      } else if (typeof argument === 'number' || argStr === '[object Number]') {
        return new Date(argument);
      } else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
          // eslint-disable-next-line no-console
          console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

          console.warn(new Error().stack);
        }

        return new Date(NaN);
      }
    }

    /**
     * @name addMilliseconds
     * @category Millisecond Helpers
     * @summary Add the specified number of milliseconds to the given date.
     *
     * @description
     * Add the specified number of milliseconds to the given date.
     *
     * @param {Date|Number} date - the date to be changed
     * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
     * @returns {Date} the new date with the milliseconds added
     * @throws {TypeError} 2 arguments required
     *
     * @example
     * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
     * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
     * //=> Thu Jul 10 2014 12:45:30.750
     */

    function addMilliseconds(dirtyDate, dirtyAmount) {
      requiredArgs(2, arguments);
      var timestamp = toDate(dirtyDate).getTime();
      var amount = toInteger(dirtyAmount);
      return new Date(timestamp + amount);
    }

    var defaultOptions$1 = {};
    function getDefaultOptions() {
      return defaultOptions$1;
    }

    /**
     * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
     * They usually appear for dates that denote time before the timezones were introduced
     * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
     * and GMT+01:00:00 after that date)
     *
     * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
     * which would lead to incorrect calculations.
     *
     * This function returns the timezone offset in milliseconds that takes seconds in account.
     */
    function getTimezoneOffsetInMilliseconds(date) {
      var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
      utcDate.setUTCFullYear(date.getFullYear());
      return date.getTime() - utcDate.getTime();
    }

    /**
     * Days in 1 week.
     *
     * @name daysInWeek
     * @constant
     * @type {number}
     * @default
     */
    /**
     * Milliseconds in 1 minute
     *
     * @name millisecondsInMinute
     * @constant
     * @type {number}
     * @default
     */

    var millisecondsInMinute = 60000;
    /**
     * Milliseconds in 1 hour
     *
     * @name millisecondsInHour
     * @constant
     * @type {number}
     * @default
     */

    var millisecondsInHour = 3600000;
    /**
     * Milliseconds in 1 second
     *
     * @name millisecondsInSecond
     * @constant
     * @type {number}
     * @default
     */

    var millisecondsInSecond = 1000;

    /**
     * @name isDate
     * @category Common Helpers
     * @summary Is the given value a date?
     *
     * @description
     * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
     *
     * @param {*} value - the value to check
     * @returns {boolean} true if the given value is a date
     * @throws {TypeError} 1 arguments required
     *
     * @example
     * // For a valid date:
     * const result = isDate(new Date())
     * //=> true
     *
     * @example
     * // For an invalid date:
     * const result = isDate(new Date(NaN))
     * //=> true
     *
     * @example
     * // For some value:
     * const result = isDate('2014-02-31')
     * //=> false
     *
     * @example
     * // For an object:
     * const result = isDate({})
     * //=> false
     */

    function isDate(value) {
      requiredArgs(1, arguments);
      return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
    }

    /**
     * @name isValid
     * @category Common Helpers
     * @summary Is the given date valid?
     *
     * @description
     * Returns false if argument is Invalid Date and true otherwise.
     * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
     * Invalid Date is a Date, whose time value is NaN.
     *
     * Time value of Date: http://es5.github.io/#x15.9.1.1
     *
     * @param {*} date - the date to check
     * @returns {Boolean} the date is valid
     * @throws {TypeError} 1 argument required
     *
     * @example
     * // For the valid date:
     * const result = isValid(new Date(2014, 1, 31))
     * //=> true
     *
     * @example
     * // For the value, convertable into a date:
     * const result = isValid(1393804800000)
     * //=> true
     *
     * @example
     * // For the invalid date:
     * const result = isValid(new Date(''))
     * //=> false
     */

    function isValid(dirtyDate) {
      requiredArgs(1, arguments);

      if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
        return false;
      }

      var date = toDate(dirtyDate);
      return !isNaN(Number(date));
    }

    /**
     * @name subMilliseconds
     * @category Millisecond Helpers
     * @summary Subtract the specified number of milliseconds from the given date.
     *
     * @description
     * Subtract the specified number of milliseconds from the given date.
     *
     * @param {Date|Number} date - the date to be changed
     * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
     * @returns {Date} the new date with the milliseconds subtracted
     * @throws {TypeError} 2 arguments required
     *
     * @example
     * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
     * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
     * //=> Thu Jul 10 2014 12:45:29.250
     */

    function subMilliseconds(dirtyDate, dirtyAmount) {
      requiredArgs(2, arguments);
      var amount = toInteger(dirtyAmount);
      return addMilliseconds(dirtyDate, -amount);
    }

    var MILLISECONDS_IN_DAY = 86400000;
    function getUTCDayOfYear(dirtyDate) {
      requiredArgs(1, arguments);
      var date = toDate(dirtyDate);
      var timestamp = date.getTime();
      date.setUTCMonth(0, 1);
      date.setUTCHours(0, 0, 0, 0);
      var startOfYearTimestamp = date.getTime();
      var difference = timestamp - startOfYearTimestamp;
      return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
    }

    function startOfUTCISOWeek(dirtyDate) {
      requiredArgs(1, arguments);
      var weekStartsOn = 1;
      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
      date.setUTCDate(date.getUTCDate() - diff);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }

    function getUTCISOWeekYear(dirtyDate) {
      requiredArgs(1, arguments);
      var date = toDate(dirtyDate);
      var year = date.getUTCFullYear();
      var fourthOfJanuaryOfNextYear = new Date(0);
      fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
      fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
      var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
      var fourthOfJanuaryOfThisYear = new Date(0);
      fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
      fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
      var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

      if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
      } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
      } else {
        return year - 1;
      }
    }

    function startOfUTCISOWeekYear(dirtyDate) {
      requiredArgs(1, arguments);
      var year = getUTCISOWeekYear(dirtyDate);
      var fourthOfJanuary = new Date(0);
      fourthOfJanuary.setUTCFullYear(year, 0, 4);
      fourthOfJanuary.setUTCHours(0, 0, 0, 0);
      var date = startOfUTCISOWeek(fourthOfJanuary);
      return date;
    }

    var MILLISECONDS_IN_WEEK$1 = 604800000;
    function getUTCISOWeek(dirtyDate) {
      requiredArgs(1, arguments);
      var date = toDate(dirtyDate);
      var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
      // because the number of milliseconds in a week is not constant
      // (e.g. it's different in the week of the daylight saving time clock shift)

      return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
    }

    function startOfUTCWeek(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

      requiredArgs(1, arguments);
      var defaultOptions = getDefaultOptions();
      var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

      if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
      }

      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
      date.setUTCDate(date.getUTCDate() - diff);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }

    function getUTCWeekYear(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

      requiredArgs(1, arguments);
      var date = toDate(dirtyDate);
      var year = date.getUTCFullYear();
      var defaultOptions = getDefaultOptions();
      var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

      if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
      }

      var firstWeekOfNextYear = new Date(0);
      firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
      firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
      var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
      var firstWeekOfThisYear = new Date(0);
      firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
      firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
      var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);

      if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
      } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
      } else {
        return year - 1;
      }
    }

    function startOfUTCWeekYear(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

      requiredArgs(1, arguments);
      var defaultOptions = getDefaultOptions();
      var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
      var year = getUTCWeekYear(dirtyDate, options);
      var firstWeek = new Date(0);
      firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
      firstWeek.setUTCHours(0, 0, 0, 0);
      var date = startOfUTCWeek(firstWeek, options);
      return date;
    }

    var MILLISECONDS_IN_WEEK = 604800000;
    function getUTCWeek(dirtyDate, options) {
      requiredArgs(1, arguments);
      var date = toDate(dirtyDate);
      var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
      // because the number of milliseconds in a week is not constant
      // (e.g. it's different in the week of the daylight saving time clock shift)

      return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
    }

    function addLeadingZeros(number, targetLength) {
      var sign = number < 0 ? '-' : '';
      var output = Math.abs(number).toString();

      while (output.length < targetLength) {
        output = '0' + output;
      }

      return sign + output;
    }

    /*
     * |     | Unit                           |     | Unit                           |
     * |-----|--------------------------------|-----|--------------------------------|
     * |  a  | AM, PM                         |  A* |                                |
     * |  d  | Day of month                   |  D  |                                |
     * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
     * |  m  | Minute                         |  M  | Month                          |
     * |  s  | Second                         |  S  | Fraction of second             |
     * |  y  | Year (abs)                     |  Y  |                                |
     *
     * Letters marked by * are not implemented but reserved by Unicode standard.
     */

    var formatters$1 = {
      // Year
      y: function (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
      },
      // Month
      M: function (date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
      },
      // Day of the month
      d: function (date, token) {
        return addLeadingZeros(date.getUTCDate(), token.length);
      },
      // AM or PM
      a: function (date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

        switch (token) {
          case 'a':
          case 'aa':
            return dayPeriodEnumValue.toUpperCase();

          case 'aaa':
            return dayPeriodEnumValue;

          case 'aaaaa':
            return dayPeriodEnumValue[0];

          case 'aaaa':
          default:
            return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';}

      },
      // Hour [1-12]
      h: function (date, token) {
        return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
      },
      // Hour [0-23]
      H: function (date, token) {
        return addLeadingZeros(date.getUTCHours(), token.length);
      },
      // Minute
      m: function (date, token) {
        return addLeadingZeros(date.getUTCMinutes(), token.length);
      },
      // Second
      s: function (date, token) {
        return addLeadingZeros(date.getUTCSeconds(), token.length);
      },
      // Fraction of second
      S: function (date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return addLeadingZeros(fractionalSeconds, token.length);
      } };

    var dayPeriodEnum = {
      am: 'am',
      pm: 'pm',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night' };


    /*
     * |     | Unit                           |     | Unit                           |
     * |-----|--------------------------------|-----|--------------------------------|
     * |  a  | AM, PM                         |  A* | Milliseconds in day            |
     * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
     * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
     * |  d  | Day of month                   |  D  | Day of year                    |
     * |  e  | Local day of week              |  E  | Day of week                    |
     * |  f  |                                |  F* | Day of week in month           |
     * |  g* | Modified Julian day            |  G  | Era                            |
     * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
     * |  i! | ISO day of week                |  I! | ISO week of year               |
     * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
     * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
     * |  l* | (deprecated)                   |  L  | Stand-alone month              |
     * |  m  | Minute                         |  M  | Month                          |
     * |  n  |                                |  N  |                                |
     * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
     * |  p! | Long localized time            |  P! | Long localized date            |
     * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
     * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
     * |  s  | Second                         |  S  | Fraction of second             |
     * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
     * |  u  | Extended year                  |  U* | Cyclic year                    |
     * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
     * |  w  | Local week of year             |  W* | Week of month                  |
     * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
     * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
     * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
     *
     * Letters marked by * are not implemented but reserved by Unicode standard.
     *
     * Letters marked by ! are non-standard, but implemented by date-fns:
     * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
     * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
     *   i.e. 7 for Sunday, 1 for Monday, etc.
     * - `I` is ISO week of year, as opposed to `w` which is local week of year.
     * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
     *   `R` is supposed to be used in conjunction with `I` and `i`
     *   for universal ISO week-numbering date, whereas
     *   `Y` is supposed to be used in conjunction with `w` and `e`
     *   for week-numbering date specific to the locale.
     * - `P` is long localized date format
     * - `p` is long localized time format
     */
    var formatters = {
      // Era
      G: function (date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;

        switch (token) {
          // AD, BC
          case 'G':
          case 'GG':
          case 'GGG':
            return localize.era(era, {
              width: 'abbreviated' });

          // A, B

          case 'GGGGG':
            return localize.era(era, {
              width: 'narrow' });

          // Anno Domini, Before Christ

          case 'GGGG':
          default:
            return localize.era(era, {
              width: 'wide' });}


      },
      // Year
      y: function (date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
          var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

          var year = signedYear > 0 ? signedYear : 1 - signedYear;
          return localize.ordinalNumber(year, {
            unit: 'year' });

        }

        return formatters$1.y(date, token);
      },
      // Local week-numbering year
      Y: function (date, token, localize, options) {
        var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

        if (token === 'YY') {
          var twoDigitYear = weekYear % 100;
          return addLeadingZeros(twoDigitYear, 2);
        } // Ordinal number


        if (token === 'Yo') {
          return localize.ordinalNumber(weekYear, {
            unit: 'year' });

        } // Padding


        return addLeadingZeros(weekYear, token.length);
      },
      // ISO week-numbering year
      R: function (date, token) {
        var isoWeekYear = getUTCISOWeekYear(date); // Padding

        return addLeadingZeros(isoWeekYear, token.length);
      },
      // Extended year. This is a single number designating the year of this calendar system.
      // The main difference between `y` and `u` localizers are B.C. years:
      // | Year | `y` | `u` |
      // |------|-----|-----|
      // | AC 1 |   1 |   1 |
      // | BC 1 |   1 |   0 |
      // | BC 2 |   2 |  -1 |
      // Also `yy` always returns the last two digits of a year,
      // while `uu` pads single digit years to 2 characters and returns other years unchanged.
      u: function (date, token) {
        var year = date.getUTCFullYear();
        return addLeadingZeros(year, token.length);
      },
      // Quarter
      Q: function (date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

        switch (token) {
          // 1, 2, 3, 4
          case 'Q':
            return String(quarter);
          // 01, 02, 03, 04

          case 'QQ':
            return addLeadingZeros(quarter, 2);
          // 1st, 2nd, 3rd, 4th

          case 'Qo':
            return localize.ordinalNumber(quarter, {
              unit: 'quarter' });

          // Q1, Q2, Q3, Q4

          case 'QQQ':
            return localize.quarter(quarter, {
              width: 'abbreviated',
              context: 'formatting' });

          // 1, 2, 3, 4 (narrow quarter; could be not numerical)

          case 'QQQQQ':
            return localize.quarter(quarter, {
              width: 'narrow',
              context: 'formatting' });

          // 1st quarter, 2nd quarter, ...

          case 'QQQQ':
          default:
            return localize.quarter(quarter, {
              width: 'wide',
              context: 'formatting' });}


      },
      // Stand-alone quarter
      q: function (date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

        switch (token) {
          // 1, 2, 3, 4
          case 'q':
            return String(quarter);
          // 01, 02, 03, 04

          case 'qq':
            return addLeadingZeros(quarter, 2);
          // 1st, 2nd, 3rd, 4th

          case 'qo':
            return localize.ordinalNumber(quarter, {
              unit: 'quarter' });

          // Q1, Q2, Q3, Q4

          case 'qqq':
            return localize.quarter(quarter, {
              width: 'abbreviated',
              context: 'standalone' });

          // 1, 2, 3, 4 (narrow quarter; could be not numerical)

          case 'qqqqq':
            return localize.quarter(quarter, {
              width: 'narrow',
              context: 'standalone' });

          // 1st quarter, 2nd quarter, ...

          case 'qqqq':
          default:
            return localize.quarter(quarter, {
              width: 'wide',
              context: 'standalone' });}


      },
      // Month
      M: function (date, token, localize) {
        var month = date.getUTCMonth();

        switch (token) {
          case 'M':
          case 'MM':
            return formatters$1.M(date, token);
          // 1st, 2nd, ..., 12th

          case 'Mo':
            return localize.ordinalNumber(month + 1, {
              unit: 'month' });

          // Jan, Feb, ..., Dec

          case 'MMM':
            return localize.month(month, {
              width: 'abbreviated',
              context: 'formatting' });

          // J, F, ..., D

          case 'MMMMM':
            return localize.month(month, {
              width: 'narrow',
              context: 'formatting' });

          // January, February, ..., December

          case 'MMMM':
          default:
            return localize.month(month, {
              width: 'wide',
              context: 'formatting' });}


      },
      // Stand-alone month
      L: function (date, token, localize) {
        var month = date.getUTCMonth();

        switch (token) {
          // 1, 2, ..., 12
          case 'L':
            return String(month + 1);
          // 01, 02, ..., 12

          case 'LL':
            return addLeadingZeros(month + 1, 2);
          // 1st, 2nd, ..., 12th

          case 'Lo':
            return localize.ordinalNumber(month + 1, {
              unit: 'month' });

          // Jan, Feb, ..., Dec

          case 'LLL':
            return localize.month(month, {
              width: 'abbreviated',
              context: 'standalone' });

          // J, F, ..., D

          case 'LLLLL':
            return localize.month(month, {
              width: 'narrow',
              context: 'standalone' });

          // January, February, ..., December

          case 'LLLL':
          default:
            return localize.month(month, {
              width: 'wide',
              context: 'standalone' });}


      },
      // Local week of year
      w: function (date, token, localize, options) {
        var week = getUTCWeek(date, options);

        if (token === 'wo') {
          return localize.ordinalNumber(week, {
            unit: 'week' });

        }

        return addLeadingZeros(week, token.length);
      },
      // ISO week of year
      I: function (date, token, localize) {
        var isoWeek = getUTCISOWeek(date);

        if (token === 'Io') {
          return localize.ordinalNumber(isoWeek, {
            unit: 'week' });

        }

        return addLeadingZeros(isoWeek, token.length);
      },
      // Day of the month
      d: function (date, token, localize) {
        if (token === 'do') {
          return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date' });

        }

        return formatters$1.d(date, token);
      },
      // Day of year
      D: function (date, token, localize) {
        var dayOfYear = getUTCDayOfYear(date);

        if (token === 'Do') {
          return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear' });

        }

        return addLeadingZeros(dayOfYear, token.length);
      },
      // Day of week
      E: function (date, token, localize) {
        var dayOfWeek = date.getUTCDay();

        switch (token) {
          // Tue
          case 'E':
          case 'EE':
          case 'EEE':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'formatting' });

          // T

          case 'EEEEE':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'formatting' });

          // Tu

          case 'EEEEEE':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'formatting' });

          // Tuesday

          case 'EEEE':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'formatting' });}


      },
      // Local day of week
      e: function (date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

        switch (token) {
          // Numerical value (Nth day of week with current locale or weekStartsOn)
          case 'e':
            return String(localDayOfWeek);
          // Padded numerical value

          case 'ee':
            return addLeadingZeros(localDayOfWeek, 2);
          // 1st, 2nd, ..., 7th

          case 'eo':
            return localize.ordinalNumber(localDayOfWeek, {
              unit: 'day' });


          case 'eee':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'formatting' });

          // T

          case 'eeeee':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'formatting' });

          // Tu

          case 'eeeeee':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'formatting' });

          // Tuesday

          case 'eeee':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'formatting' });}


      },
      // Stand-alone local day of week
      c: function (date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

        switch (token) {
          // Numerical value (same as in `e`)
          case 'c':
            return String(localDayOfWeek);
          // Padded numerical value

          case 'cc':
            return addLeadingZeros(localDayOfWeek, token.length);
          // 1st, 2nd, ..., 7th

          case 'co':
            return localize.ordinalNumber(localDayOfWeek, {
              unit: 'day' });


          case 'ccc':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'standalone' });

          // T

          case 'ccccc':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'standalone' });

          // Tu

          case 'cccccc':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'standalone' });

          // Tuesday

          case 'cccc':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'standalone' });}


      },
      // ISO day of week
      i: function (date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

        switch (token) {
          // 2
          case 'i':
            return String(isoDayOfWeek);
          // 02

          case 'ii':
            return addLeadingZeros(isoDayOfWeek, token.length);
          // 2nd

          case 'io':
            return localize.ordinalNumber(isoDayOfWeek, {
              unit: 'day' });

          // Tue

          case 'iii':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'formatting' });

          // T

          case 'iiiii':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'formatting' });

          // Tu

          case 'iiiiii':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'formatting' });

          // Tuesday

          case 'iiii':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'formatting' });}


      },
      // AM or PM
      a: function (date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

        switch (token) {
          case 'a':
          case 'aa':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting' });


          case 'aaa':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting' }).
            toLowerCase();

          case 'aaaaa':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'narrow',
              context: 'formatting' });


          case 'aaaa':
          default:
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'wide',
              context: 'formatting' });}


      },
      // AM, PM, midnight, noon
      b: function (date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;

        if (hours === 12) {
          dayPeriodEnumValue = dayPeriodEnum.noon;
        } else if (hours === 0) {
          dayPeriodEnumValue = dayPeriodEnum.midnight;
        } else {
          dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        }

        switch (token) {
          case 'b':
          case 'bb':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting' });


          case 'bbb':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting' }).
            toLowerCase();

          case 'bbbbb':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'narrow',
              context: 'formatting' });


          case 'bbbb':
          default:
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'wide',
              context: 'formatting' });}


      },
      // in the morning, in the afternoon, in the evening, at night
      B: function (date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;

        if (hours >= 17) {
          dayPeriodEnumValue = dayPeriodEnum.evening;
        } else if (hours >= 12) {
          dayPeriodEnumValue = dayPeriodEnum.afternoon;
        } else if (hours >= 4) {
          dayPeriodEnumValue = dayPeriodEnum.morning;
        } else {
          dayPeriodEnumValue = dayPeriodEnum.night;
        }

        switch (token) {
          case 'B':
          case 'BB':
          case 'BBB':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting' });


          case 'BBBBB':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'narrow',
              context: 'formatting' });


          case 'BBBB':
          default:
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'wide',
              context: 'formatting' });}


      },
      // Hour [1-12]
      h: function (date, token, localize) {
        if (token === 'ho') {
          var hours = date.getUTCHours() % 12;
          if (hours === 0) hours = 12;
          return localize.ordinalNumber(hours, {
            unit: 'hour' });

        }

        return formatters$1.h(date, token);
      },
      // Hour [0-23]
      H: function (date, token, localize) {
        if (token === 'Ho') {
          return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour' });

        }

        return formatters$1.H(date, token);
      },
      // Hour [0-11]
      K: function (date, token, localize) {
        var hours = date.getUTCHours() % 12;

        if (token === 'Ko') {
          return localize.ordinalNumber(hours, {
            unit: 'hour' });

        }

        return addLeadingZeros(hours, token.length);
      },
      // Hour [1-24]
      k: function (date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;

        if (token === 'ko') {
          return localize.ordinalNumber(hours, {
            unit: 'hour' });

        }

        return addLeadingZeros(hours, token.length);
      },
      // Minute
      m: function (date, token, localize) {
        if (token === 'mo') {
          return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute' });

        }

        return formatters$1.m(date, token);
      },
      // Second
      s: function (date, token, localize) {
        if (token === 'so') {
          return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second' });

        }

        return formatters$1.s(date, token);
      },
      // Fraction of second
      S: function (date, token) {
        return formatters$1.S(date, token);
      },
      // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
      X: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();

        if (timezoneOffset === 0) {
          return 'Z';
        }

        switch (token) {
          // Hours and optional minutes
          case 'X':
            return formatTimezoneWithOptionalMinutes(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XX`

          case 'XXXX':
          case 'XX':
            // Hours and minutes without `:` delimiter
            return formatTimezone(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XXX`

          case 'XXXXX':
          case 'XXX': // Hours and minutes with `:` delimiter

          default:
            return formatTimezone(timezoneOffset, ':');}

      },
      // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
      x: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();

        switch (token) {
          // Hours and optional minutes
          case 'x':
            return formatTimezoneWithOptionalMinutes(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xx`

          case 'xxxx':
          case 'xx':
            // Hours and minutes without `:` delimiter
            return formatTimezone(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xxx`

          case 'xxxxx':
          case 'xxx': // Hours and minutes with `:` delimiter

          default:
            return formatTimezone(timezoneOffset, ':');}

      },
      // Timezone (GMT)
      O: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();

        switch (token) {
          // Short
          case 'O':
          case 'OO':
          case 'OOO':
            return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
          // Long

          case 'OOOO':
          default:
            return 'GMT' + formatTimezone(timezoneOffset, ':');}

      },
      // Timezone (specific non-location)
      z: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();

        switch (token) {
          // Short
          case 'z':
          case 'zz':
          case 'zzz':
            return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
          // Long

          case 'zzzz':
          default:
            return 'GMT' + formatTimezone(timezoneOffset, ':');}

      },
      // Seconds timestamp
      t: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return addLeadingZeros(timestamp, token.length);
      },
      // Milliseconds timestamp
      T: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return addLeadingZeros(timestamp, token.length);
      } };


    function formatTimezoneShort(offset, dirtyDelimiter) {
      var sign = offset > 0 ? '-' : '+';
      var absOffset = Math.abs(offset);
      var hours = Math.floor(absOffset / 60);
      var minutes = absOffset % 60;

      if (minutes === 0) {
        return sign + String(hours);
      }

      var delimiter = dirtyDelimiter || '';
      return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
    }

    function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
      if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
      }

      return formatTimezone(offset, dirtyDelimiter);
    }

    function formatTimezone(offset, dirtyDelimiter) {
      var delimiter = dirtyDelimiter || '';
      var sign = offset > 0 ? '-' : '+';
      var absOffset = Math.abs(offset);
      var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
      var minutes = addLeadingZeros(absOffset % 60, 2);
      return sign + hours + delimiter + minutes;
    }

    var dateLongFormatter = function (pattern, formatLong) {
      switch (pattern) {
        case 'P':
          return formatLong.date({
            width: 'short' });


        case 'PP':
          return formatLong.date({
            width: 'medium' });


        case 'PPP':
          return formatLong.date({
            width: 'long' });


        case 'PPPP':
        default:
          return formatLong.date({
            width: 'full' });}


    };

    var timeLongFormatter = function (pattern, formatLong) {
      switch (pattern) {
        case 'p':
          return formatLong.time({
            width: 'short' });


        case 'pp':
          return formatLong.time({
            width: 'medium' });


        case 'ppp':
          return formatLong.time({
            width: 'long' });


        case 'pppp':
        default:
          return formatLong.time({
            width: 'full' });}


    };

    var dateTimeLongFormatter = function (pattern, formatLong) {
      var matchResult = pattern.match(/(P+)(p+)?/) || [];
      var datePattern = matchResult[1];
      var timePattern = matchResult[2];

      if (!timePattern) {
        return dateLongFormatter(pattern, formatLong);
      }

      var dateTimeFormat;

      switch (datePattern) {
        case 'P':
          dateTimeFormat = formatLong.dateTime({
            width: 'short' });

          break;

        case 'PP':
          dateTimeFormat = formatLong.dateTime({
            width: 'medium' });

          break;

        case 'PPP':
          dateTimeFormat = formatLong.dateTime({
            width: 'long' });

          break;

        case 'PPPP':
        default:
          dateTimeFormat = formatLong.dateTime({
            width: 'full' });

          break;}


      return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
    };

    var longFormatters = {
      p: timeLongFormatter,
      P: dateTimeLongFormatter };

    var protectedDayOfYearTokens = ['D', 'DD'];
    var protectedWeekYearTokens = ['YY', 'YYYY'];
    function isProtectedDayOfYearToken(token) {
      return protectedDayOfYearTokens.indexOf(token) !== -1;
    }
    function isProtectedWeekYearToken(token) {
      return protectedWeekYearTokens.indexOf(token) !== -1;
    }
    function throwProtectedError(token, format, input) {
      if (token === 'YYYY') {
        throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      } else if (token === 'YY') {
        throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      } else if (token === 'D') {
        throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      } else if (token === 'DD') {
        throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      }
    }

    var formatDistanceLocale = {
      lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds' },

      xSeconds: {
        one: '1 second',
        other: '{{count}} seconds' },

      halfAMinute: 'half a minute',
      lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes' },

      xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes' },

      aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours' },

      xHours: {
        one: '1 hour',
        other: '{{count}} hours' },

      xDays: {
        one: '1 day',
        other: '{{count}} days' },

      aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks' },

      xWeeks: {
        one: '1 week',
        other: '{{count}} weeks' },

      aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months' },

      xMonths: {
        one: '1 month',
        other: '{{count}} months' },

      aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years' },

      xYears: {
        one: '1 year',
        other: '{{count}} years' },

      overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years' },

      almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years' } };



    var formatDistance = function (token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale[token];

      if (typeof tokenValue === 'string') {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace('{{count}}', count.toString());
      }

      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return 'in ' + result;
        } else {
          return result + ' ago';
        }
      }

      return result;
    };

    function buildFormatLongFn(args) {
      return function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
      };
    }

    var dateFormats = {
      full: 'EEEE, MMMM do, y',
      long: 'MMMM do, y',
      medium: 'MMM d, y',
      short: 'MM/dd/yyyy' };

    var timeFormats = {
      full: 'h:mm:ss a zzzz',
      long: 'h:mm:ss a z',
      medium: 'h:mm:ss a',
      short: 'h:mm a' };

    var dateTimeFormats = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: '{{date}}, {{time}}',
      short: '{{date}}, {{time}}' };

    var formatLong = {
      date: buildFormatLongFn({
        formats: dateFormats,
        defaultWidth: 'full' }),

      time: buildFormatLongFn({
        formats: timeFormats,
        defaultWidth: 'full' }),

      dateTime: buildFormatLongFn({
        formats: dateTimeFormats,
        defaultWidth: 'full' }) };

    var formatRelativeLocale = {
      lastWeek: "'last' eeee 'at' p",
      yesterday: "'yesterday at' p",
      today: "'today at' p",
      tomorrow: "'tomorrow at' p",
      nextWeek: "eeee 'at' p",
      other: 'P' };


    var formatRelative = function (token, _date, _baseDate, _options) {
      return formatRelativeLocale[token];
    };

    function buildLocalizeFn(args) {
      return function (dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;

        if (context === 'formatting' && args.formattingValues) {
          var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
          var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
          valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
          var _defaultWidth = args.defaultWidth;

          var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

          valuesArray = args.values[_width] || args.values[_defaultWidth];
        }

        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

        return valuesArray[index];
      };
    }

    var eraValues = {
      narrow: ['B', 'A'],
      abbreviated: ['BC', 'AD'],
      wide: ['Before Christ', 'Anno Domini'] };

    var quarterValues = {
      narrow: ['1', '2', '3', '4'],
      abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
      wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] };
    // Note: in English, the names of days of the week and months are capitalized.
    // If you are making a new locale based on this one, check if the same is true for the language you're working on.
    // Generally, formatted dates should look like they are in the middle of a sentence,
    // e.g. in Spanish language the weekdays and months should be in the lowercase.

    var monthValues = {
      narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
      abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'] };

    var dayValues = {
      narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] };

    var dayPeriodValues = {
      narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night' },

      abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night' },

      wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night' } };


    var formattingDayPeriodValues = {
      narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night' },

      abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night' },

      wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night' } };



    var ordinalNumber = function (dirtyNumber, _options) {
      var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
      // if they are different for different grammatical genders,
      // use `options.unit`.
      //
      // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
      // 'day', 'hour', 'minute', 'second'.

      var rem100 = number % 100;

      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
            return number + 'st';

          case 2:
            return number + 'nd';

          case 3:
            return number + 'rd';}

      }

      return number + 'th';
    };

    var localize = {
      ordinalNumber: ordinalNumber,
      era: buildLocalizeFn({
        values: eraValues,
        defaultWidth: 'wide' }),

      quarter: buildLocalizeFn({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function (quarter) {
          return quarter - 1;
        } }),

      month: buildLocalizeFn({
        values: monthValues,
        defaultWidth: 'wide' }),

      day: buildLocalizeFn({
        values: dayValues,
        defaultWidth: 'wide' }),

      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide' }) };

    function buildMatchFn(args) {
      return function (string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);

        if (!matchResult) {
          return null;
        }

        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
          return pattern.test(matchedString);
        }) : findKey(parsePatterns, function (pattern) {
          return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
          value: value,
          rest: rest };

      };
    }

    function findKey(object, predicate) {
      for (var key in object) {
        if (object.hasOwnProperty(key) && predicate(object[key])) {
          return key;
        }
      }

      return undefined;
    }

    function findIndex(array, predicate) {
      for (var key = 0; key < array.length; key++) {
        if (predicate(array[key])) {
          return key;
        }
      }

      return undefined;
    }

    function buildMatchPatternFn(args) {
      return function (string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
          value: value,
          rest: rest };

      };
    }

    var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
    var parseOrdinalNumberPattern = /\d+/i;
    var matchEraPatterns = {
      narrow: /^(b|a)/i,
      abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
      wide: /^(before christ|before common era|anno domini|common era)/i };

    var parseEraPatterns = {
      any: [/^b/i, /^(a|c)/i] };

    var matchQuarterPatterns = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](th|st|nd|rd)? quarter/i };

    var parseQuarterPatterns = {
      any: [/1/i, /2/i, /3/i, /4/i] };

    var matchMonthPatterns = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
      wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i };

    var parseMonthPatterns = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i] };

    var matchDayPatterns = {
      narrow: /^[smtwf]/i,
      short: /^(su|mo|tu|we|th|fr|sa)/i,
      abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
      wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i };

    var parseDayPatterns = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i] };

    var matchDayPeriodPatterns = {
      narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
      any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i };

    var parseDayPeriodPatterns = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i } };


    var match = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function (value) {
          return parseInt(value, 10);
        } }),

      era: buildMatchFn({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any' }),

      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function (index) {
          return index + 1;
        } }),

      month: buildMatchFn({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any' }),

      day: buildMatchFn({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any' }),

      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any' }) };

    /**
     * @type {Locale}
     * @category Locales
     * @summary English locale (United States).
     * @language English
     * @iso-639-2 eng
     * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
     * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
     */
    var locale = {
      code: 'en-US',
      formatDistance: formatDistance,
      formatLong: formatLong,
      formatRelative: formatRelative,
      localize: localize,
      match: match,
      options: {
        weekStartsOn: 0
        /* Sunday */,

        firstWeekContainsDate: 1 } };

    // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
    //   (one of the certain letters followed by `o`)
    // - (\w)\1* matches any sequences of the same letter
    // - '' matches two quote characters in a row
    // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
    //   except a single quote symbol, which ends the sequence.
    //   Two quote characters do not end the sequence.
    //   If there is no matching single quote
    //   then the sequence will continue until the end of the string.
    // - . matches any single character unmatched by previous parts of the RegExps

    var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
    // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

    var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    var escapedStringRegExp = /^'([^]*?)'?$/;
    var doubleQuoteRegExp = /''/g;
    var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
    /**
     * @name format
     * @category Common Helpers
     * @summary Format the date.
     *
     * @description
     * Return the formatted date string in the given format. The result may vary by locale.
     *
     * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
     * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     *
     * The characters wrapped between two single quotes characters (') are escaped.
     * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
     * (see the last example)
     *
     * Format of the string is based on Unicode Technical Standard #35:
     * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
     * with a few additions (see note 7 below the table).
     *
     * Accepted patterns:
     * | Unit                            | Pattern | Result examples                   | Notes |
     * |---------------------------------|---------|-----------------------------------|-------|
     * | Era                             | G..GGG  | AD, BC                            |       |
     * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
     * |                                 | GGGGG   | A, B                              |       |
     * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
     * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
     * |                                 | yy      | 44, 01, 00, 17                    | 5     |
     * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
     * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
     * |                                 | yyyyy   | ...                               | 3,5   |
     * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
     * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
     * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
     * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
     * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
     * |                                 | YYYYY   | ...                               | 3,5   |
     * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
     * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
     * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
     * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
     * |                                 | RRRRR   | ...                               | 3,5,7 |
     * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
     * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
     * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
     * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
     * |                                 | uuuuu   | ...                               | 3,5   |
     * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
     * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
     * |                                 | QQ      | 01, 02, 03, 04                    |       |
     * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
     * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
     * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
     * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
     * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
     * |                                 | qq      | 01, 02, 03, 04                    |       |
     * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
     * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
     * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
     * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
     * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
     * |                                 | MM      | 01, 02, ..., 12                   |       |
     * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
     * |                                 | MMMM    | January, February, ..., December  | 2     |
     * |                                 | MMMMM   | J, F, ..., D                      |       |
     * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
     * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
     * |                                 | LL      | 01, 02, ..., 12                   |       |
     * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
     * |                                 | LLLL    | January, February, ..., December  | 2     |
     * |                                 | LLLLL   | J, F, ..., D                      |       |
     * | Local week of year              | w       | 1, 2, ..., 53                     |       |
     * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
     * |                                 | ww      | 01, 02, ..., 53                   |       |
     * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
     * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
     * |                                 | II      | 01, 02, ..., 53                   | 7     |
     * | Day of month                    | d       | 1, 2, ..., 31                     |       |
     * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
     * |                                 | dd      | 01, 02, ..., 31                   |       |
     * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
     * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
     * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
     * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
     * |                                 | DDDD    | ...                               | 3     |
     * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
     * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
     * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
     * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
     * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
     * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
     * |                                 | ii      | 01, 02, ..., 07                   | 7     |
     * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
     * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
     * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
     * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
     * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
     * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
     * |                                 | ee      | 02, 03, ..., 01                   |       |
     * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
     * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
     * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
     * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
     * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
     * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
     * |                                 | cc      | 02, 03, ..., 01                   |       |
     * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
     * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
     * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
     * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
     * | AM, PM                          | a..aa   | AM, PM                            |       |
     * |                                 | aaa     | am, pm                            |       |
     * |                                 | aaaa    | a.m., p.m.                        | 2     |
     * |                                 | aaaaa   | a, p                              |       |
     * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
     * |                                 | bbb     | am, pm, noon, midnight            |       |
     * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
     * |                                 | bbbbb   | a, p, n, mi                       |       |
     * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
     * |                                 | BBBB    | at night, in the morning, ...     | 2     |
     * |                                 | BBBBB   | at night, in the morning, ...     |       |
     * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
     * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
     * |                                 | hh      | 01, 02, ..., 11, 12               |       |
     * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
     * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
     * |                                 | HH      | 00, 01, 02, ..., 23               |       |
     * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
     * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
     * |                                 | KK      | 01, 02, ..., 11, 00               |       |
     * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
     * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
     * |                                 | kk      | 24, 01, 02, ..., 23               |       |
     * | Minute                          | m       | 0, 1, ..., 59                     |       |
     * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
     * |                                 | mm      | 00, 01, ..., 59                   |       |
     * | Second                          | s       | 0, 1, ..., 59                     |       |
     * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
     * |                                 | ss      | 00, 01, ..., 59                   |       |
     * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
     * |                                 | SS      | 00, 01, ..., 99                   |       |
     * |                                 | SSS     | 000, 001, ..., 999                |       |
     * |                                 | SSSS    | ...                               | 3     |
     * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
     * |                                 | XX      | -0800, +0530, Z                   |       |
     * |                                 | XXX     | -08:00, +05:30, Z                 |       |
     * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
     * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
     * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
     * |                                 | xx      | -0800, +0530, +0000               |       |
     * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
     * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
     * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
     * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
     * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
     * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
     * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
     * | Seconds timestamp               | t       | 512969520                         | 7     |
     * |                                 | tt      | ...                               | 3,7   |
     * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
     * |                                 | TT      | ...                               | 3,7   |
     * | Long localized date             | P       | 04/29/1453                        | 7     |
     * |                                 | PP      | Apr 29, 1453                      | 7     |
     * |                                 | PPP     | April 29th, 1453                  | 7     |
     * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
     * | Long localized time             | p       | 12:00 AM                          | 7     |
     * |                                 | pp      | 12:00:00 AM                       | 7     |
     * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
     * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
     * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
     * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
     * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
     * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
     * Notes:
     * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
     *    are the same as "stand-alone" units, but are different in some languages.
     *    "Formatting" units are declined according to the rules of the language
     *    in the context of a date. "Stand-alone" units are always nominative singular:
     *
     *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
     *
     *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
     *
     * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
     *    the single quote characters (see below).
     *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
     *    the output will be the same as default pattern for this unit, usually
     *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
     *    are marked with "2" in the last column of the table.
     *
     *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
     *
     * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
     *    The output will be padded with zeros to match the length of the pattern.
     *
     *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
     *
     * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
     *    These tokens represent the shortest form of the quarter.
     *
     * 5. The main difference between `y` and `u` patterns are B.C. years:
     *
     *    | Year | `y` | `u` |
     *    |------|-----|-----|
     *    | AC 1 |   1 |   1 |
     *    | BC 1 |   1 |   0 |
     *    | BC 2 |   2 |  -1 |
     *
     *    Also `yy` always returns the last two digits of a year,
     *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
     *
     *    | Year | `yy` | `uu` |
     *    |------|------|------|
     *    | 1    |   01 |   01 |
     *    | 14   |   14 |   14 |
     *    | 376  |   76 |  376 |
     *    | 1453 |   53 | 1453 |
     *
     *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
     *    except local week-numbering years are dependent on `options.weekStartsOn`
     *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
     *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
     *
     * 6. Specific non-location timezones are currently unavailable in `date-fns`,
     *    so right now these tokens fall back to GMT timezones.
     *
     * 7. These patterns are not in the Unicode Technical Standard #35:
     *    - `i`: ISO day of week
     *    - `I`: ISO week of year
     *    - `R`: ISO week-numbering year
     *    - `t`: seconds timestamp
     *    - `T`: milliseconds timestamp
     *    - `o`: ordinal number modifier
     *    - `P`: long localized date
     *    - `p`: long localized time
     *
     * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
     *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     *
     * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
     *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     *
     * @param {Date|Number} date - the original date
     * @param {String} format - the string of tokens
     * @param {Object} [options] - an object with options.
     * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
     * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
     * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
     * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
     *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
     *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @returns {String} the formatted date string
     * @throws {TypeError} 2 arguments required
     * @throws {RangeError} `date` must not be Invalid Date
     * @throws {RangeError} `options.locale` must contain `localize` property
     * @throws {RangeError} `options.locale` must contain `formatLong` property
     * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
     * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
     * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @throws {RangeError} format string contains an unescaped latin alphabet character
     *
     * @example
     * // Represent 11 February 2014 in middle-endian format:
     * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
     * //=> '02/11/2014'
     *
     * @example
     * // Represent 2 July 2014 in Esperanto:
     * import { eoLocale } from 'date-fns/locale/eo'
     * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
     *   locale: eoLocale
     * })
     * //=> '2-a de julio 2014'
     *
     * @example
     * // Escape string by single quote characters:
     * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
     * //=> "3 o'clock"
     */

    function format(dirtyDate, dirtyFormatStr, options) {
      var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

      requiredArgs(2, arguments);
      var formatStr = String(dirtyFormatStr);
      var defaultOptions = getDefaultOptions();
      var locale$1 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : locale;
      var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

      if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
      }

      var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

      if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
      }

      if (!locale$1.localize) {
        throw new RangeError('locale must contain localize property');
      }

      if (!locale$1.formatLong) {
        throw new RangeError('locale must contain formatLong property');
      }

      var originalDate = toDate(dirtyDate);

      if (!isValid(originalDate)) {
        throw new RangeError('Invalid time value');
      } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
      // This ensures that when UTC functions will be implemented, locales will be compatible with them.
      // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


      var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
      var utcDate = subMilliseconds(originalDate, timezoneOffset);
      var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale$1,
        _originalDate: originalDate };

      var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
        var firstCharacter = substring[0];

        if (firstCharacter === 'p' || firstCharacter === 'P') {
          var longFormatter = longFormatters[firstCharacter];
          return longFormatter(substring, locale$1.formatLong);
        }

        return substring;
      }).join('').match(formattingTokensRegExp).map(function (substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") {
          return "'";
        }

        var firstCharacter = substring[0];

        if (firstCharacter === "'") {
          return cleanEscapedString(substring);
        }

        var formatter = formatters[firstCharacter];

        if (formatter) {
          if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
            throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
          }

          if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
            throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
          }

          return formatter(utcDate, substring, locale$1.localize, formatterOptions);
        }

        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        }

        return substring;
      }).join('');
      return result;
    }

    function cleanEscapedString(input) {
      var matched = input.match(escapedStringRegExp);

      if (!matched) {
        return input;
      }

      return matched[1].replace(doubleQuoteRegExp, "'");
    }

    function _defineProperty$x(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class Setter {
      constructor() {
        _defineProperty$x(this, "priority", void 0);

        _defineProperty$x(this, "subPriority", 0);
      }

      validate(_utcDate, _options) {
        return true;
      }}


    class ValueSetter extends Setter {
      constructor(value, validateValue, setValue, priority, subPriority) {
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;

        if (subPriority) {
          this.subPriority = subPriority;
        }
      }

      validate(utcDate, options) {
        return this.validateValue(utcDate, this.value, options);
      }

      set(utcDate, flags, options) {
        return this.setValue(utcDate, flags, this.value, options);
      }}

    function _defineProperty$w(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class Parser {
      constructor() {
        _defineProperty$w(this, "incompatibleTokens", void 0);

        _defineProperty$w(this, "priority", void 0);

        _defineProperty$w(this, "subPriority", void 0);
      }

      run(dateString, token, match, options) {
        var result = this.parse(dateString, token, match, options);

        if (!result) {
          return null;
        }

        return {
          setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
          rest: result.rest };

      }

      validate(_utcDate, _value, _options) {
        return true;
      }}

    function _defineProperty$v(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class EraParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$v(this, "priority", 140);

        _defineProperty$v(this, "incompatibleTokens", ['R', 'u', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          // AD, BC
          case 'G':
          case 'GG':
          case 'GGG':
            return match.era(dateString, {
              width: 'abbreviated' }) ||
            match.era(dateString, {
              width: 'narrow' });

          // A, B

          case 'GGGGG':
            return match.era(dateString, {
              width: 'narrow' });

          // Anno Domini, Before Christ

          case 'GGGG':
          default:
            return match.era(dateString, {
              width: 'wide' }) ||
            match.era(dateString, {
              width: 'abbreviated' }) ||
            match.era(dateString, {
              width: 'narrow' });}


      }

      set(date, flags, value) {
        flags.era = value;
        date.setUTCFullYear(value, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    var numericPatterns = {
      month: /^(1[0-2]|0?\d)/,
      // 0 to 12
      date: /^(3[0-1]|[0-2]?\d)/,
      // 0 to 31
      dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
      // 0 to 366
      week: /^(5[0-3]|[0-4]?\d)/,
      // 0 to 53
      hour23h: /^(2[0-3]|[0-1]?\d)/,
      // 0 to 23
      hour24h: /^(2[0-4]|[0-1]?\d)/,
      // 0 to 24
      hour11h: /^(1[0-1]|0?\d)/,
      // 0 to 11
      hour12h: /^(1[0-2]|0?\d)/,
      // 0 to 12
      minute: /^[0-5]?\d/,
      // 0 to 59
      second: /^[0-5]?\d/,
      // 0 to 59
      singleDigit: /^\d/,
      // 0 to 9
      twoDigits: /^\d{1,2}/,
      // 0 to 99
      threeDigits: /^\d{1,3}/,
      // 0 to 999
      fourDigits: /^\d{1,4}/,
      // 0 to 9999
      anyDigitsSigned: /^-?\d+/,
      singleDigitSigned: /^-?\d/,
      // 0 to 9, -0 to -9
      twoDigitsSigned: /^-?\d{1,2}/,
      // 0 to 99, -0 to -99
      threeDigitsSigned: /^-?\d{1,3}/,
      // 0 to 999, -0 to -999
      fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
    };

    var timezonePatterns = {
      basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
      basic: /^([+-])(\d{2})(\d{2})|Z/,
      basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
      extended: /^([+-])(\d{2}):(\d{2})|Z/,
      extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/ };

    function mapValue(parseFnResult, mapFn) {
      if (!parseFnResult) {
        return parseFnResult;
      }

      return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest };

    }
    function parseNumericPattern(pattern, dateString) {
      var matchResult = dateString.match(pattern);

      if (!matchResult) {
        return null;
      }

      return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length) };

    }
    function parseTimezonePattern(pattern, dateString) {
      var matchResult = dateString.match(pattern);

      if (!matchResult) {
        return null;
      } // Input is 'Z'


      if (matchResult[0] === 'Z') {
        return {
          value: 0,
          rest: dateString.slice(1) };

      }

      var sign = matchResult[1] === '+' ? 1 : -1;
      var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
      var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
      var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
      return {
        value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length) };

    }
    function parseAnyDigitsSigned(dateString) {
      return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
    }
    function parseNDigits(n, dateString) {
      switch (n) {
        case 1:
          return parseNumericPattern(numericPatterns.singleDigit, dateString);

        case 2:
          return parseNumericPattern(numericPatterns.twoDigits, dateString);

        case 3:
          return parseNumericPattern(numericPatterns.threeDigits, dateString);

        case 4:
          return parseNumericPattern(numericPatterns.fourDigits, dateString);

        default:
          return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);}

    }
    function parseNDigitsSigned(n, dateString) {
      switch (n) {
        case 1:
          return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);

        case 2:
          return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);

        case 3:
          return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);

        case 4:
          return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);

        default:
          return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);}

    }
    function dayPeriodEnumToHours(dayPeriod) {
      switch (dayPeriod) {
        case 'morning':
          return 4;

        case 'evening':
          return 17;

        case 'pm':
        case 'noon':
        case 'afternoon':
          return 12;

        case 'am':
        case 'midnight':
        case 'night':
        default:
          return 0;}

    }
    function normalizeTwoDigitYear(twoDigitYear, currentYear) {
      var isCommonEra = currentYear > 0; // Absolute number of the current year:
      // 1 -> 1 AC
      // 0 -> 1 BC
      // -1 -> 2 BC

      var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
      var result;

      if (absCurrentYear <= 50) {
        result = twoDigitYear || 100;
      } else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
      }

      return isCommonEra ? result : 1 - result;
    }
    function isLeapYearIndex(year) {
      return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }

    function _defineProperty$u(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    class YearParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$u(this, "priority", 130);

        _defineProperty$u(this, "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
      }

      parse(dateString, token, match) {
        var valueCallback = function (year) {
          return {
            year: year,
            isTwoDigitYear: token === 'yy' };

        };

        switch (token) {
          case 'y':
            return mapValue(parseNDigits(4, dateString), valueCallback);

          case 'yo':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'year' }),
            valueCallback);

          default:
            return mapValue(parseNDigits(token.length, dateString), valueCallback);}

      }

      validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
      }

      set(date, flags, value) {
        var currentYear = date.getUTCFullYear();

        if (value.isTwoDigitYear) {
          var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
          date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }

        var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setUTCFullYear(year, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function _defineProperty$t(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    // Local week-numbering year
    class LocalWeekYearParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$t(this, "priority", 130);

        _defineProperty$t(this, "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
      }

      parse(dateString, token, match) {
        var valueCallback = function (year) {
          return {
            year: year,
            isTwoDigitYear: token === 'YY' };

        };

        switch (token) {
          case 'Y':
            return mapValue(parseNDigits(4, dateString), valueCallback);

          case 'Yo':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'year' }),
            valueCallback);

          default:
            return mapValue(parseNDigits(token.length, dateString), valueCallback);}

      }

      validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
      }

      set(date, flags, value, options) {
        var currentYear = getUTCWeekYear(date, options);

        if (value.isTwoDigitYear) {
          var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
          date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
          date.setUTCHours(0, 0, 0, 0);
          return startOfUTCWeek(date, options);
        }

        var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }}

    function _defineProperty$s(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    class ISOWeekYearParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$s(this, "priority", 130);

        _defineProperty$s(this, "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
      }

      parse(dateString, token) {
        if (token === 'R') {
          return parseNDigitsSigned(4, dateString);
        }

        return parseNDigitsSigned(token.length, dateString);
      }

      set(_date, _flags, value) {
        var firstWeekOfYear = new Date(0);
        firstWeekOfYear.setUTCFullYear(value, 0, 4);
        firstWeekOfYear.setUTCHours(0, 0, 0, 0);
        return startOfUTCISOWeek(firstWeekOfYear);
      }}

    function _defineProperty$r(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class ExtendedYearParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$r(this, "priority", 130);

        _defineProperty$r(this, "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
      }

      parse(dateString, token) {
        if (token === 'u') {
          return parseNDigitsSigned(4, dateString);
        }

        return parseNDigitsSigned(token.length, dateString);
      }

      set(date, _flags, value) {
        date.setUTCFullYear(value, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function _defineProperty$q(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class QuarterParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$q(this, "priority", 120);

        _defineProperty$q(this, "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          // 1, 2, 3, 4
          case 'Q':
          case 'QQ':
            // 01, 02, 03, 04
            return parseNDigits(token.length, dateString);
          // 1st, 2nd, 3rd, 4th

          case 'Qo':
            return match.ordinalNumber(dateString, {
              unit: 'quarter' });

          // Q1, Q2, Q3, Q4

          case 'QQQ':
            return match.quarter(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.quarter(dateString, {
              width: 'narrow',
              context: 'formatting' });

          // 1, 2, 3, 4 (narrow quarter; could be not numerical)

          case 'QQQQQ':
            return match.quarter(dateString, {
              width: 'narrow',
              context: 'formatting' });

          // 1st quarter, 2nd quarter, ...

          case 'QQQQ':
          default:
            return match.quarter(dateString, {
              width: 'wide',
              context: 'formatting' }) ||
            match.quarter(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.quarter(dateString, {
              width: 'narrow',
              context: 'formatting' });}


      }

      validate(_date, value) {
        return value >= 1 && value <= 4;
      }

      set(date, _flags, value) {
        date.setUTCMonth((value - 1) * 3, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function _defineProperty$p(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class StandAloneQuarterParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$p(this, "priority", 120);

        _defineProperty$p(this, "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          // 1, 2, 3, 4
          case 'q':
          case 'qq':
            // 01, 02, 03, 04
            return parseNDigits(token.length, dateString);
          // 1st, 2nd, 3rd, 4th

          case 'qo':
            return match.ordinalNumber(dateString, {
              unit: 'quarter' });

          // Q1, Q2, Q3, Q4

          case 'qqq':
            return match.quarter(dateString, {
              width: 'abbreviated',
              context: 'standalone' }) ||
            match.quarter(dateString, {
              width: 'narrow',
              context: 'standalone' });

          // 1, 2, 3, 4 (narrow quarter; could be not numerical)

          case 'qqqqq':
            return match.quarter(dateString, {
              width: 'narrow',
              context: 'standalone' });

          // 1st quarter, 2nd quarter, ...

          case 'qqqq':
          default:
            return match.quarter(dateString, {
              width: 'wide',
              context: 'standalone' }) ||
            match.quarter(dateString, {
              width: 'abbreviated',
              context: 'standalone' }) ||
            match.quarter(dateString, {
              width: 'narrow',
              context: 'standalone' });}


      }

      validate(_date, value) {
        return value >= 1 && value <= 4;
      }

      set(date, _flags, value) {
        date.setUTCMonth((value - 1) * 3, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function _defineProperty$o(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class MonthParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$o(this, "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

        _defineProperty$o(this, "priority", 110);
      }

      parse(dateString, token, match) {
        var valueCallback = function (value) {
          return value - 1;
        };

        switch (token) {
          // 1, 2, ..., 12
          case 'M':
            return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
          // 01, 02, ..., 12

          case 'MM':
            return mapValue(parseNDigits(2, dateString), valueCallback);
          // 1st, 2nd, ..., 12th

          case 'Mo':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'month' }),
            valueCallback);
          // Jan, Feb, ..., Dec

          case 'MMM':
            return match.month(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.month(dateString, {
              width: 'narrow',
              context: 'formatting' });

          // J, F, ..., D

          case 'MMMMM':
            return match.month(dateString, {
              width: 'narrow',
              context: 'formatting' });

          // January, February, ..., December

          case 'MMMM':
          default:
            return match.month(dateString, {
              width: 'wide',
              context: 'formatting' }) ||
            match.month(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.month(dateString, {
              width: 'narrow',
              context: 'formatting' });}


      }

      validate(_date, value) {
        return value >= 0 && value <= 11;
      }

      set(date, _flags, value) {
        date.setUTCMonth(value, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function _defineProperty$n(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class StandAloneMonthParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$n(this, "priority", 110);

        _defineProperty$n(this, "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
      }

      parse(dateString, token, match) {
        var valueCallback = function (value) {
          return value - 1;
        };

        switch (token) {
          // 1, 2, ..., 12
          case 'L':
            return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
          // 01, 02, ..., 12

          case 'LL':
            return mapValue(parseNDigits(2, dateString), valueCallback);
          // 1st, 2nd, ..., 12th

          case 'Lo':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'month' }),
            valueCallback);
          // Jan, Feb, ..., Dec

          case 'LLL':
            return match.month(dateString, {
              width: 'abbreviated',
              context: 'standalone' }) ||
            match.month(dateString, {
              width: 'narrow',
              context: 'standalone' });

          // J, F, ..., D

          case 'LLLLL':
            return match.month(dateString, {
              width: 'narrow',
              context: 'standalone' });

          // January, February, ..., December

          case 'LLLL':
          default:
            return match.month(dateString, {
              width: 'wide',
              context: 'standalone' }) ||
            match.month(dateString, {
              width: 'abbreviated',
              context: 'standalone' }) ||
            match.month(dateString, {
              width: 'narrow',
              context: 'standalone' });}


      }

      validate(_date, value) {
        return value >= 0 && value <= 11;
      }

      set(date, _flags, value) {
        date.setUTCMonth(value, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function setUTCWeek(dirtyDate, dirtyWeek, options) {
      requiredArgs(2, arguments);
      var date = toDate(dirtyDate);
      var week = toInteger(dirtyWeek);
      var diff = getUTCWeek(date, options) - week;
      date.setUTCDate(date.getUTCDate() - diff * 7);
      return date;
    }

    function _defineProperty$m(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    class LocalWeekParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$m(this, "priority", 100);

        _defineProperty$m(this, "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'w':
            return parseNumericPattern(numericPatterns.week, dateString);

          case 'wo':
            return match.ordinalNumber(dateString, {
              unit: 'week' });


          default:
            return parseNDigits(token.length, dateString);}

      }

      validate(_date, value) {
        return value >= 1 && value <= 53;
      }

      set(date, _flags, value, options) {
        return startOfUTCWeek(setUTCWeek(date, value, options), options);
      }}

    function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
      requiredArgs(2, arguments);
      var date = toDate(dirtyDate);
      var isoWeek = toInteger(dirtyISOWeek);
      var diff = getUTCISOWeek(date) - isoWeek;
      date.setUTCDate(date.getUTCDate() - diff * 7);
      return date;
    }

    function _defineProperty$l(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    class ISOWeekParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$l(this, "priority", 100);

        _defineProperty$l(this, "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'I':
            return parseNumericPattern(numericPatterns.week, dateString);

          case 'Io':
            return match.ordinalNumber(dateString, {
              unit: 'week' });


          default:
            return parseNDigits(token.length, dateString);}

      }

      validate(_date, value) {
        return value >= 1 && value <= 53;
      }

      set(date, _flags, value) {
        return startOfUTCISOWeek(setUTCISOWeek(date, value));
      }}

    function _defineProperty$k(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Day of the month

    class DateParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$k(this, "priority", 90);

        _defineProperty$k(this, "subPriority", 1);

        _defineProperty$k(this, "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'd':
            return parseNumericPattern(numericPatterns.date, dateString);

          case 'do':
            return match.ordinalNumber(dateString, {
              unit: 'date' });


          default:
            return parseNDigits(token.length, dateString);}

      }

      validate(date, value) {
        var year = date.getUTCFullYear();
        var isLeapYear = isLeapYearIndex(year);
        var month = date.getUTCMonth();

        if (isLeapYear) {
          return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
        } else {
          return value >= 1 && value <= DAYS_IN_MONTH[month];
        }
      }

      set(date, _flags, value) {
        date.setUTCDate(value);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function _defineProperty$j(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class DayOfYearParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$j(this, "priority", 90);

        _defineProperty$j(this, "subpriority", 1);

        _defineProperty$j(this, "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'D':
          case 'DD':
            return parseNumericPattern(numericPatterns.dayOfYear, dateString);

          case 'Do':
            return match.ordinalNumber(dateString, {
              unit: 'date' });


          default:
            return parseNDigits(token.length, dateString);}

      }

      validate(date, value) {
        var year = date.getUTCFullYear();
        var isLeapYear = isLeapYearIndex(year);

        if (isLeapYear) {
          return value >= 1 && value <= 366;
        } else {
          return value >= 1 && value <= 365;
        }
      }

      set(date, _flags, value) {
        date.setUTCMonth(0, value);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function setUTCDay(dirtyDate, dirtyDay, options) {
      var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

      requiredArgs(2, arguments);
      var defaultOptions = getDefaultOptions();
      var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

      if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
      }

      var date = toDate(dirtyDate);
      var day = toInteger(dirtyDay);
      var currentDay = date.getUTCDay();
      var remainder = day % 7;
      var dayIndex = (remainder + 7) % 7;
      var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
      date.setUTCDate(date.getUTCDate() + diff);
      return date;
    }

    function _defineProperty$i(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    class DayParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$i(this, "priority", 90);

        _defineProperty$i(this, "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          // Tue
          case 'E':
          case 'EE':
          case 'EEE':
            return match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'short',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'formatting' });

          // T

          case 'EEEEE':
            return match.day(dateString, {
              width: 'narrow',
              context: 'formatting' });

          // Tu

          case 'EEEEEE':
            return match.day(dateString, {
              width: 'short',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'formatting' });

          // Tuesday

          case 'EEEE':
          default:
            return match.day(dateString, {
              width: 'wide',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'short',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'formatting' });}


      }

      validate(_date, value) {
        return value >= 0 && value <= 6;
      }

      set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function _defineProperty$h(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    class LocalDayParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$h(this, "priority", 90);

        _defineProperty$h(this, "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
      }

      parse(dateString, token, match, options) {
        var valueCallback = function (value) {
          var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
          return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };

        switch (token) {
          // 3
          case 'e':
          case 'ee':
            // 03
            return mapValue(parseNDigits(token.length, dateString), valueCallback);
          // 3rd

          case 'eo':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'day' }),
            valueCallback);
          // Tue

          case 'eee':
            return match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'short',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'formatting' });

          // T

          case 'eeeee':
            return match.day(dateString, {
              width: 'narrow',
              context: 'formatting' });

          // Tu

          case 'eeeeee':
            return match.day(dateString, {
              width: 'short',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'formatting' });

          // Tuesday

          case 'eeee':
          default:
            return match.day(dateString, {
              width: 'wide',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'short',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'formatting' });}


      }

      validate(_date, value) {
        return value >= 0 && value <= 6;
      }

      set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function _defineProperty$g(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    class StandAloneLocalDayParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$g(this, "priority", 90);

        _defineProperty$g(this, "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
      }

      parse(dateString, token, match, options) {
        var valueCallback = function (value) {
          var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
          return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };

        switch (token) {
          // 3
          case 'c':
          case 'cc':
            // 03
            return mapValue(parseNDigits(token.length, dateString), valueCallback);
          // 3rd

          case 'co':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'day' }),
            valueCallback);
          // Tue

          case 'ccc':
            return match.day(dateString, {
              width: 'abbreviated',
              context: 'standalone' }) ||
            match.day(dateString, {
              width: 'short',
              context: 'standalone' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'standalone' });

          // T

          case 'ccccc':
            return match.day(dateString, {
              width: 'narrow',
              context: 'standalone' });

          // Tu

          case 'cccccc':
            return match.day(dateString, {
              width: 'short',
              context: 'standalone' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'standalone' });

          // Tuesday

          case 'cccc':
          default:
            return match.day(dateString, {
              width: 'wide',
              context: 'standalone' }) ||
            match.day(dateString, {
              width: 'abbreviated',
              context: 'standalone' }) ||
            match.day(dateString, {
              width: 'short',
              context: 'standalone' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'standalone' });}


      }

      validate(_date, value) {
        return value >= 0 && value <= 6;
      }

      set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function setUTCISODay(dirtyDate, dirtyDay) {
      requiredArgs(2, arguments);
      var day = toInteger(dirtyDay);

      if (day % 7 === 0) {
        day = day - 7;
      }

      var weekStartsOn = 1;
      var date = toDate(dirtyDate);
      var currentDay = date.getUTCDay();
      var remainder = day % 7;
      var dayIndex = (remainder + 7) % 7;
      var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
      date.setUTCDate(date.getUTCDate() + diff);
      return date;
    }

    function _defineProperty$f(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    class ISODayParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$f(this, "priority", 90);

        _defineProperty$f(this, "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
      }

      parse(dateString, token, match) {
        var valueCallback = function (value) {
          if (value === 0) {
            return 7;
          }

          return value;
        };

        switch (token) {
          // 2
          case 'i':
          case 'ii':
            // 02
            return parseNDigits(token.length, dateString);
          // 2nd

          case 'io':
            return match.ordinalNumber(dateString, {
              unit: 'day' });

          // Tue

          case 'iii':
            return mapValue(match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'short',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'formatting' }),
            valueCallback);
          // T

          case 'iiiii':
            return mapValue(match.day(dateString, {
              width: 'narrow',
              context: 'formatting' }),
            valueCallback);
          // Tu

          case 'iiiiii':
            return mapValue(match.day(dateString, {
              width: 'short',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'formatting' }),
            valueCallback);
          // Tuesday

          case 'iiii':
          default:
            return mapValue(match.day(dateString, {
              width: 'wide',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'short',
              context: 'formatting' }) ||
            match.day(dateString, {
              width: 'narrow',
              context: 'formatting' }),
            valueCallback);}

      }

      validate(_date, value) {
        return value >= 1 && value <= 7;
      }

      set(date, _flags, value) {
        date = setUTCISODay(date, value);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }}

    function _defineProperty$e(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class AMPMParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$e(this, "priority", 80);

        _defineProperty$e(this, "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'a':
          case 'aa':
          case 'aaa':
            return match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting' });


          case 'aaaaa':
            return match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting' });


          case 'aaaa':
          default:
            return match.dayPeriod(dateString, {
              width: 'wide',
              context: 'formatting' }) ||
            match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting' });}


      }

      set(date, _flags, value) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      }}

    function _defineProperty$d(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class AMPMMidnightParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$d(this, "priority", 80);

        _defineProperty$d(this, "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'b':
          case 'bb':
          case 'bbb':
            return match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting' });


          case 'bbbbb':
            return match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting' });


          case 'bbbb':
          default:
            return match.dayPeriod(dateString, {
              width: 'wide',
              context: 'formatting' }) ||
            match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting' });}


      }

      set(date, _flags, value) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      }}

    function _defineProperty$c(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    class DayPeriodParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$c(this, "priority", 80);

        _defineProperty$c(this, "incompatibleTokens", ['a', 'b', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'B':
          case 'BB':
          case 'BBB':
            return match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting' });


          case 'BBBBB':
            return match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting' });


          case 'BBBB':
          default:
            return match.dayPeriod(dateString, {
              width: 'wide',
              context: 'formatting' }) ||
            match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting' }) ||
            match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting' });}


      }

      set(date, _flags, value) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      }}

    function _defineProperty$b(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class Hour1to12Parser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$b(this, "priority", 70);

        _defineProperty$b(this, "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'h':
            return parseNumericPattern(numericPatterns.hour12h, dateString);

          case 'ho':
            return match.ordinalNumber(dateString, {
              unit: 'hour' });


          default:
            return parseNDigits(token.length, dateString);}

      }

      validate(_date, value) {
        return value >= 1 && value <= 12;
      }

      set(date, _flags, value) {
        var isPM = date.getUTCHours() >= 12;

        if (isPM && value < 12) {
          date.setUTCHours(value + 12, 0, 0, 0);
        } else if (!isPM && value === 12) {
          date.setUTCHours(0, 0, 0, 0);
        } else {
          date.setUTCHours(value, 0, 0, 0);
        }

        return date;
      }}

    function _defineProperty$a(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class Hour0to23Parser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$a(this, "priority", 70);

        _defineProperty$a(this, "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'H':
            return parseNumericPattern(numericPatterns.hour23h, dateString);

          case 'Ho':
            return match.ordinalNumber(dateString, {
              unit: 'hour' });


          default:
            return parseNDigits(token.length, dateString);}

      }

      validate(_date, value) {
        return value >= 0 && value <= 23;
      }

      set(date, _flags, value) {
        date.setUTCHours(value, 0, 0, 0);
        return date;
      }}

    function _defineProperty$9(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class Hour0To11Parser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$9(this, "priority", 70);

        _defineProperty$9(this, "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'K':
            return parseNumericPattern(numericPatterns.hour11h, dateString);

          case 'Ko':
            return match.ordinalNumber(dateString, {
              unit: 'hour' });


          default:
            return parseNDigits(token.length, dateString);}

      }

      validate(_date, value) {
        return value >= 0 && value <= 11;
      }

      set(date, _flags, value) {
        var isPM = date.getUTCHours() >= 12;

        if (isPM && value < 12) {
          date.setUTCHours(value + 12, 0, 0, 0);
        } else {
          date.setUTCHours(value, 0, 0, 0);
        }

        return date;
      }}

    function _defineProperty$8(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class Hour1To24Parser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$8(this, "priority", 70);

        _defineProperty$8(this, "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'k':
            return parseNumericPattern(numericPatterns.hour24h, dateString);

          case 'ko':
            return match.ordinalNumber(dateString, {
              unit: 'hour' });


          default:
            return parseNDigits(token.length, dateString);}

      }

      validate(_date, value) {
        return value >= 1 && value <= 24;
      }

      set(date, _flags, value) {
        var hours = value <= 24 ? value % 24 : value;
        date.setUTCHours(hours, 0, 0, 0);
        return date;
      }}

    function _defineProperty$7(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class MinuteParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$7(this, "priority", 60);

        _defineProperty$7(this, "incompatibleTokens", ['t', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 'm':
            return parseNumericPattern(numericPatterns.minute, dateString);

          case 'mo':
            return match.ordinalNumber(dateString, {
              unit: 'minute' });


          default:
            return parseNDigits(token.length, dateString);}

      }

      validate(_date, value) {
        return value >= 0 && value <= 59;
      }

      set(date, _flags, value) {
        date.setUTCMinutes(value, 0, 0);
        return date;
      }}

    function _defineProperty$6(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class SecondParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$6(this, "priority", 50);

        _defineProperty$6(this, "incompatibleTokens", ['t', 'T']);
      }

      parse(dateString, token, match) {
        switch (token) {
          case 's':
            return parseNumericPattern(numericPatterns.second, dateString);

          case 'so':
            return match.ordinalNumber(dateString, {
              unit: 'second' });


          default:
            return parseNDigits(token.length, dateString);}

      }

      validate(_date, value) {
        return value >= 0 && value <= 59;
      }

      set(date, _flags, value) {
        date.setUTCSeconds(value, 0);
        return date;
      }}

    function _defineProperty$5(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class FractionOfSecondParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$5(this, "priority", 30);

        _defineProperty$5(this, "incompatibleTokens", ['t', 'T']);
      }

      parse(dateString, token) {
        var valueCallback = function (value) {
          return Math.floor(value * Math.pow(10, -token.length + 3));
        };

        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }

      set(date, _flags, value) {
        date.setUTCMilliseconds(value);
        return date;
      }}

    function _defineProperty$4(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    class ISOTimezoneWithZParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$4(this, "priority", 10);

        _defineProperty$4(this, "incompatibleTokens", ['t', 'T', 'x']);
      }

      parse(dateString, token) {
        switch (token) {
          case 'X':
            return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

          case 'XX':
            return parseTimezonePattern(timezonePatterns.basic, dateString);

          case 'XXXX':
            return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

          case 'XXXXX':
            return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

          case 'XXX':
          default:
            return parseTimezonePattern(timezonePatterns.extended, dateString);}

      }

      set(date, flags, value) {
        if (flags.timestampIsSet) {
          return date;
        }

        return new Date(date.getTime() - value);
      }}

    function _defineProperty$3(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

    class ISOTimezoneParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$3(this, "priority", 10);

        _defineProperty$3(this, "incompatibleTokens", ['t', 'T', 'X']);
      }

      parse(dateString, token) {
        switch (token) {
          case 'x':
            return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

          case 'xx':
            return parseTimezonePattern(timezonePatterns.basic, dateString);

          case 'xxxx':
            return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

          case 'xxxxx':
            return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

          case 'xxx':
          default:
            return parseTimezonePattern(timezonePatterns.extended, dateString);}

      }

      set(date, flags, value) {
        if (flags.timestampIsSet) {
          return date;
        }

        return new Date(date.getTime() - value);
      }}

    function _defineProperty$2(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class TimestampSecondsParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$2(this, "priority", 40);

        _defineProperty$2(this, "incompatibleTokens", '*');
      }

      parse(dateString) {
        return parseAnyDigitsSigned(dateString);
      }

      set(_date, _flags, value) {
        return [new Date(value * 1000), {
          timestampIsSet: true }];

      }}

    function _defineProperty$1(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
    class TimestampMillisecondsParser extends Parser {
      constructor() {
        super(...arguments);

        _defineProperty$1(this, "priority", 20);

        _defineProperty$1(this, "incompatibleTokens", '*');
      }

      parse(dateString) {
        return parseAnyDigitsSigned(dateString);
      }

      set(_date, _flags, value) {
        return [new Date(value), {
          timestampIsSet: true }];

      }}

    /*
     * |     | Unit                           |     | Unit                           |
     * |-----|--------------------------------|-----|--------------------------------|
     * |  a  | AM, PM                         |  A* | Milliseconds in day            |
     * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
     * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
     * |  d  | Day of month                   |  D  | Day of year                    |
     * |  e  | Local day of week              |  E  | Day of week                    |
     * |  f  |                                |  F* | Day of week in month           |
     * |  g* | Modified Julian day            |  G  | Era                            |
     * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
     * |  i! | ISO day of week                |  I! | ISO week of year               |
     * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
     * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
     * |  l* | (deprecated)                   |  L  | Stand-alone month              |
     * |  m  | Minute                         |  M  | Month                          |
     * |  n  |                                |  N  |                                |
     * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
     * |  p  |                                |  P  |                                |
     * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
     * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
     * |  s  | Second                         |  S  | Fraction of second             |
     * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
     * |  u  | Extended year                  |  U* | Cyclic year                    |
     * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
     * |  w  | Local week of year             |  W* | Week of month                  |
     * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
     * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
     * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
     *
     * Letters marked by * are not implemented but reserved by Unicode standard.
     *
     * Letters marked by ! are non-standard, but implemented by date-fns:
     * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
     * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
     *   i.e. 7 for Sunday, 1 for Monday, etc.
     * - `I` is ISO week of year, as opposed to `w` which is local week of year.
     * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
     *   `R` is supposed to be used in conjunction with `I` and `i`
     *   for universal ISO week-numbering date, whereas
     *   `Y` is supposed to be used in conjunction with `w` and `e`
     *   for week-numbering date specific to the locale.
     */

    ({
      G: new EraParser(),
      y: new YearParser(),
      Y: new LocalWeekYearParser(),
      R: new ISOWeekYearParser(),
      u: new ExtendedYearParser(),
      Q: new QuarterParser(),
      q: new StandAloneQuarterParser(),
      M: new MonthParser(),
      L: new StandAloneMonthParser(),
      w: new LocalWeekParser(),
      I: new ISOWeekParser(),
      d: new DateParser(),
      D: new DayOfYearParser(),
      E: new DayParser(),
      e: new LocalDayParser(),
      c: new StandAloneLocalDayParser(),
      i: new ISODayParser(),
      a: new AMPMParser(),
      b: new AMPMMidnightParser(),
      B: new DayPeriodParser(),
      h: new Hour1to12Parser(),
      H: new Hour0to23Parser(),
      K: new Hour0To11Parser(),
      k: new Hour1To24Parser(),
      m: new MinuteParser(),
      s: new SecondParser(),
      S: new FractionOfSecondParser(),
      X: new ISOTimezoneWithZParser(),
      x: new ISOTimezoneParser(),
      t: new TimestampSecondsParser(),
      T: new TimestampMillisecondsParser() });

    var DatePicker = function (_a) {
      var id = _a.id,label = _a.label,onChange = _a.onChange,value = _a.value,mandatory = _a.mandatory;
      var wrapperRef = /*#__PURE__*/React.createRef();
      var _b = React.useState(value),dateValue = _b[0],setDateValue = _b[1];
      var handleDateChange = function (date) {
        setDateValue(date);
        var formattedDate = date ? format(date, 'yyyy-MM-dd') : null;
        onChange(formattedDate);
      };
      console.warn('DatePicker is deprecated and will be removed in a future release. Please use InputField instead');
      return jsxRuntime.exports.jsxs("div", __assign({ className: 'awell_date_picker', ref: wrapperRef }, { children: [jsxRuntime.exports.jsx(QuestionLabel, { htmlFor: id, label: label, mandatory: mandatory }), jsxRuntime.exports.jsx(DatePickerComponent, { value: dateValue, dayPlaceholder: "dd", monthPlaceholder: "mm", yearPlaceholder: "yyyy", format: 'dd/MM/yyyy', openCalendarOnFocus: true, onChange: handleDateChange, clearIcon: null })] }));
    };

    var classes$q = {"awell_description_wrapper":"awell__description_awell_description_wrapper","slate-MediaEmbedElement-input":"awell__description_slate-MediaEmbedElement-input","slate-MediaEmbedElement-iframe":"awell__description_slate-MediaEmbedElement-iframe"};

    var richTextClasses = {"content":"awell__richTextViewer_content","bold":"awell__richTextViewer_bold","slate-bold":"awell__richTextViewer_slate-bold","strikethrough":"awell__richTextViewer_strikethrough","slate-strikethrough":"awell__richTextViewer_slate-strikethrough","underline":"awell__richTextViewer_underline","slate-underline":"awell__richTextViewer_slate-underline","italic":"awell__richTextViewer_italic","slate-italic":"awell__richTextViewer_slate-italic"};

    var RichTextViewer = function (_a) {
      var content = _a.content;
      return jsxRuntime.exports.jsx("div", { className: richTextClasses.content, dangerouslySetInnerHTML: { __html: content } });
    };

    var purify = {exports: {}};

    /*! @license DOMPurify 2.4.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.0/LICENSE */

    (function (module, exports) {
      (function (global, factory) {
        module.exports = factory() ;
      })(commonjsGlobal, function () {
        function _typeof(obj) {
          "@babel/helpers - typeof";

          return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
            return typeof obj;
          } : function (obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          }, _typeof(obj);
        }

        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };

          return _setPrototypeOf(o, p);
        }

        function _isNativeReflectConstruct() {
          if (typeof Reflect === "undefined" || !Reflect.construct) return false;
          if (Reflect.construct.sham) return false;
          if (typeof Proxy === "function") return true;

          try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
            return true;
          } catch (e) {
            return false;
          }
        }

        function _construct(Parent, args, Class) {
          if (_isNativeReflectConstruct()) {
            _construct = Reflect.construct;
          } else {
            _construct = function _construct(Parent, args, Class) {
              var a = [null];
              a.push.apply(a, args);
              var Constructor = Function.bind.apply(Parent, a);
              var instance = new Constructor();
              if (Class) _setPrototypeOf(instance, Class.prototype);
              return instance;
            };
          }

          return _construct.apply(null, arguments);
        }

        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
        }

        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) return _arrayLikeToArray(arr);
        }

        function _iterableToArray(iter) {
          if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
        }

        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
        }

        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;

          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

          return arr2;
        }

        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }

        var hasOwnProperty = Object.hasOwnProperty,
        setPrototypeOf = Object.setPrototypeOf,
        isFrozen = Object.isFrozen,
        getPrototypeOf = Object.getPrototypeOf,
        getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var freeze = Object.freeze,
        seal = Object.seal,
        create = Object.create; // eslint-disable-line import/no-mutable-exports

        var _ref = typeof Reflect !== 'undefined' && Reflect,
        apply = _ref.apply,
        construct = _ref.construct;

        if (!apply) {
          apply = function apply(fun, thisValue, args) {
            return fun.apply(thisValue, args);
          };
        }

        if (!freeze) {
          freeze = function freeze(x) {
            return x;
          };
        }

        if (!seal) {
          seal = function seal(x) {
            return x;
          };
        }

        if (!construct) {
          construct = function construct(Func, args) {
            return _construct(Func, _toConsumableArray(args));
          };
        }

        var arrayForEach = unapply(Array.prototype.forEach);
        var arrayPop = unapply(Array.prototype.pop);
        var arrayPush = unapply(Array.prototype.push);
        var stringToLowerCase = unapply(String.prototype.toLowerCase);
        var stringMatch = unapply(String.prototype.match);
        var stringReplace = unapply(String.prototype.replace);
        var stringIndexOf = unapply(String.prototype.indexOf);
        var stringTrim = unapply(String.prototype.trim);
        var regExpTest = unapply(RegExp.prototype.test);
        var typeErrorCreate = unconstruct(TypeError);
        function unapply(func) {
          return function (thisArg) {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            return apply(func, thisArg, args);
          };
        }
        function unconstruct(func) {
          return function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            return construct(func, args);
          };
        }
        /* Add properties to a lookup table */

        function addToSet(set, array, transformCaseFunc) {
          transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;

          if (setPrototypeOf) {
            // Make 'in' and truthy checks like Boolean(set.constructor)
            // independent of any properties defined on Object.prototype.
            // Prevent prototype setters from intercepting set as a this value.
            setPrototypeOf(set, null);
          }

          var l = array.length;

          while (l--) {
            var element = array[l];

            if (typeof element === 'string') {
              var lcElement = transformCaseFunc(element);

              if (lcElement !== element) {
                // Config presets (e.g. tags.js, attrs.js) are immutable.
                if (!isFrozen(array)) {
                  array[l] = lcElement;
                }

                element = lcElement;
              }
            }

            set[element] = true;
          }

          return set;
        }
        /* Shallow clone an object */

        function clone(object) {
          var newObject = create(null);
          var property;

          for (property in object) {
            if (apply(hasOwnProperty, object, [property])) {
              newObject[property] = object[property];
            }
          }

          return newObject;
        }
        /* IE10 doesn't support __lookupGetter__ so lets'
         * simulate it. It also automatically checks
         * if the prop is function or getter and behaves
         * accordingly. */

        function lookupGetter(object, prop) {
          while (object !== null) {
            var desc = getOwnPropertyDescriptor(object, prop);

            if (desc) {
              if (desc.get) {
                return unapply(desc.get);
              }

              if (typeof desc.value === 'function') {
                return unapply(desc.value);
              }
            }

            object = getPrototypeOf(object);
          }

          function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
          }

          return fallbackValue;
        }

        var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

        var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
        var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
        // We still need to know them so that we can do namespace
        // checks properly in case one wants to add them to
        // allow-list.

        var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
        var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
        // even those that we disallow by default.

        var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
        var text = freeze(['#text']);

        var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
        var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
        var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
        var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

        var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

        var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
        var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

        var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

        var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
        );
        var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
        var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
        );
        var DOCTYPE_NAME = seal(/^html$/i);

        var getGlobal = function getGlobal() {
          return typeof window === 'undefined' ? null : window;
        };
        /**
         * Creates a no-op policy for internal use only.
         * Don't export this function outside this module!
         * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
         * @param {Document} document The document object (to determine policy name suffix)
         * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
         * are not supported).
         */


        var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
          if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
            return null;
          } // Allow the callers to control the unique policy name
          // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
          // Policy creation with duplicate names throws in Trusted Types.


          var suffix = null;
          var ATTR_NAME = 'data-tt-policy-suffix';

          if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
            suffix = document.currentScript.getAttribute(ATTR_NAME);
          }

          var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

          try {
            return trustedTypes.createPolicy(policyName, {
              createHTML: function createHTML(html) {
                return html;
              },
              createScriptURL: function createScriptURL(scriptUrl) {
                return scriptUrl;
              } });

          } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
          }
        };

        function createDOMPurify() {
          var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

          var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
          };
          /**
           * Version label, exposed for easier checks
           * if DOMPurify is up to date or not
           */


          DOMPurify.version = '2.4.0';
          /**
           * Array of elements that DOMPurify removed during sanitation.
           * Empty if nothing was removed.
           */

          DOMPurify.removed = [];

          if (!window || !window.document || window.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
          }

          var originalDocument = window.document;
          var document = window.document;
          var DocumentFragment = window.DocumentFragment,
          HTMLTemplateElement = window.HTMLTemplateElement,
          Node = window.Node,
          Element = window.Element,
          NodeFilter = window.NodeFilter,
          _window$NamedNodeMap = window.NamedNodeMap,
          NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
          HTMLFormElement = window.HTMLFormElement,
          DOMParser = window.DOMParser,
          trustedTypes = window.trustedTypes;
          var ElementPrototype = Element.prototype;
          var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
          var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
          var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
          var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
          // new document created via createHTMLDocument. As per the spec
          // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
          // a new empty registry is used when creating a template contents owner
          // document, so we use that as our parent document to ensure nothing
          // is inherited.

          if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');

            if (template.content && template.content.ownerDocument) {
              document = template.content.ownerDocument;
            }
          }

          var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

          var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
          var _document = document,
          implementation = _document.implementation,
          createNodeIterator = _document.createNodeIterator,
          createDocumentFragment = _document.createDocumentFragment,
          getElementsByTagName = _document.getElementsByTagName;
          var importNode = originalDocument.importNode;
          var documentMode = {};

          try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
          } catch (_) {}

          var hooks = {};
          /**
           * Expose whether this browser supports running the full DOMPurify.
           */

          DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
          var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
          ERB_EXPR$1 = ERB_EXPR,
          DATA_ATTR$1 = DATA_ATTR,
          ARIA_ATTR$1 = ARIA_ATTR,
          IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
          ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
          var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
          /**
           * We consider the elements and attributes below to be safe. Ideally
           * don't add any new ones but feel free to remove unwanted ones.
           */

          /* allowed element names */

          var ALLOWED_TAGS = null;
          var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
          /* Allowed attribute names */

          var ALLOWED_ATTR = null;
          var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
          /*
           * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
           * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
           * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
           * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
           */

          var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
              writable: true,
              configurable: false,
              enumerable: true,
              value: null },

            attributeNameCheck: {
              writable: true,
              configurable: false,
              enumerable: true,
              value: null },

            allowCustomizedBuiltInElements: {
              writable: true,
              configurable: false,
              enumerable: true,
              value: false } }));


          /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

          var FORBID_TAGS = null;
          /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

          var FORBID_ATTR = null;
          /* Decide if ARIA attributes are okay */

          var ALLOW_ARIA_ATTR = true;
          /* Decide if custom data attributes are okay */

          var ALLOW_DATA_ATTR = true;
          /* Decide if unknown protocols are okay */

          var ALLOW_UNKNOWN_PROTOCOLS = false;
          /* Output should be safe for common template engines.
           * This means, DOMPurify removes data attributes, mustaches and ERB
           */

          var SAFE_FOR_TEMPLATES = false;
          /* Decide if document with <html>... should be returned */

          var WHOLE_DOCUMENT = false;
          /* Track whether config is already set on this instance of DOMPurify. */

          var SET_CONFIG = false;
          /* Decide if all elements (e.g. style, script) must be children of
           * document.body. By default, browsers might move them to document.head */

          var FORCE_BODY = false;
          /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
           * string (or a TrustedHTML object if Trusted Types are supported).
           * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
           */

          var RETURN_DOM = false;
          /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
           * string  (or a TrustedHTML object if Trusted Types are supported) */

          var RETURN_DOM_FRAGMENT = false;
          /* Try to return a Trusted Type object instead of a string, return a string in
           * case Trusted Types are not supported  */

          var RETURN_TRUSTED_TYPE = false;
          /* Output should be free from DOM clobbering attacks?
           * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
           */

          var SANITIZE_DOM = true;
          /* Achieve full DOM Clobbering protection by isolating the namespace of named
           * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
           *
           * HTML/DOM spec rules that enable DOM Clobbering:
           *   - Named Access on Window (§7.3.3)
           *   - DOM Tree Accessors (§3.1.5)
           *   - Form Element Parent-Child Relations (§4.10.3)
           *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
           *   - HTMLCollection (§4.2.10.2)
           *
           * Namespace isolation is implemented by prefixing `id` and `name` attributes
           * with a constant string, i.e., `user-content-`
           */

          var SANITIZE_NAMED_PROPS = false;
          var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
          /* Keep element content when removing element? */

          var KEEP_CONTENT = true;
          /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
           * of importing it into a new Document and returning a sanitized copy */

          var IN_PLACE = false;
          /* Allow usage of profiles like html, svg and mathMl */

          var USE_PROFILES = {};
          /* Tags to ignore content of when KEEP_CONTENT is true */

          var FORBID_CONTENTS = null;
          var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
          /* Tags that are safe for data: URIs */

          var DATA_URI_TAGS = null;
          var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
          /* Attributes safe for values like "javascript:" */

          var URI_SAFE_ATTRIBUTES = null;
          var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
          var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
          var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
          var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
          /* Document namespace */

          var NAMESPACE = HTML_NAMESPACE;
          var IS_EMPTY_INPUT = false;
          /* Parsing of strict XHTML documents */

          var PARSER_MEDIA_TYPE;
          var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
          var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
          var transformCaseFunc;
          /* Keep a reference to config to pass to hooks */

          var CONFIG = null;
          /* Ideally, do not touch anything below this line */

          /* ______________________________________________ */

          var formElement = document.createElement('form');

          var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
          };
          /**
           * _parseConfig
           *
           * @param  {Object} cfg optional config literal
           */
          // eslint-disable-next-line complexity


          var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) {
              return;
            }
            /* Shield configuration object from tampering */


            if (!cfg || _typeof(cfg) !== 'object') {
              cfg = {};
            }
            /* Shield configuration object from prototype pollution */


            cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? function (x) {
              return x;
            } : stringToLowerCase;
            /* Set configuration parameters */

            ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
            : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
            : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

            RETURN_DOM = cfg.RETURN_DOM || false; // Default false

            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

            FORCE_BODY = cfg.FORCE_BODY || false; // Default false

            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

            IN_PLACE = cfg.IN_PLACE || false; // Default false

            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;

            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
              CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            }

            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
              CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            }

            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
              CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            }

            if (SAFE_FOR_TEMPLATES) {
              ALLOW_DATA_ATTR = false;
            }

            if (RETURN_DOM_FRAGMENT) {
              RETURN_DOM = true;
            }
            /* Parse profile info */


            if (USE_PROFILES) {
              ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
              ALLOWED_ATTR = [];

              if (USE_PROFILES.html === true) {
                addToSet(ALLOWED_TAGS, html$1);
                addToSet(ALLOWED_ATTR, html);
              }

              if (USE_PROFILES.svg === true) {
                addToSet(ALLOWED_TAGS, svg$1);
                addToSet(ALLOWED_ATTR, svg);
                addToSet(ALLOWED_ATTR, xml);
              }

              if (USE_PROFILES.svgFilters === true) {
                addToSet(ALLOWED_TAGS, svgFilters);
                addToSet(ALLOWED_ATTR, svg);
                addToSet(ALLOWED_ATTR, xml);
              }

              if (USE_PROFILES.mathMl === true) {
                addToSet(ALLOWED_TAGS, mathMl$1);
                addToSet(ALLOWED_ATTR, mathMl);
                addToSet(ALLOWED_ATTR, xml);
              }
            }
            /* Merge configuration parameters */


            if (cfg.ADD_TAGS) {
              if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
                ALLOWED_TAGS = clone(ALLOWED_TAGS);
              }

              addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }

            if (cfg.ADD_ATTR) {
              if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
                ALLOWED_ATTR = clone(ALLOWED_ATTR);
              }

              addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }

            if (cfg.ADD_URI_SAFE_ATTR) {
              addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            }

            if (cfg.FORBID_CONTENTS) {
              if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
                FORBID_CONTENTS = clone(FORBID_CONTENTS);
              }

              addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */


            if (KEEP_CONTENT) {
              ALLOWED_TAGS['#text'] = true;
            }
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


            if (WHOLE_DOCUMENT) {
              addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
            }
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


            if (ALLOWED_TAGS.table) {
              addToSet(ALLOWED_TAGS, ['tbody']);
              delete FORBID_TAGS.tbody;
            } // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.


            if (freeze) {
              freeze(cfg);
            }

            CONFIG = cfg;
          };

          var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
          var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
          // namespace. We need to specify them explicitly
          // so that they don't get erroneously deleted from
          // HTML namespace.

          var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
          /* Keep track of all possible SVG and MathML tags
           * so that we can perform the namespace checks
           * correctly. */

          var ALL_SVG_TAGS = addToSet({}, svg$1);
          addToSet(ALL_SVG_TAGS, svgFilters);
          addToSet(ALL_SVG_TAGS, svgDisallowed);
          var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
          addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
          /**
           *
           *
           * @param  {Element} element a DOM element whose namespace is being checked
           * @returns {boolean} Return false if the element has a
           *  namespace that a spec-compliant parser would never
           *  return. Return true otherwise.
           */

          var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.

            if (!parent || !parent.tagName) {
              parent = {
                namespaceURI: HTML_NAMESPACE,
                tagName: 'template' };

            }

            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);

            if (element.namespaceURI === SVG_NAMESPACE) {
              // The only way to switch from HTML namespace to SVG
              // is via <svg>. If it happens via any other tag, then
              // it should be killed.
              if (parent.namespaceURI === HTML_NAMESPACE) {
                return tagName === 'svg';
              } // The only way to switch from MathML to SVG is via
              // svg if parent is either <annotation-xml> or MathML
              // text integration points.


              if (parent.namespaceURI === MATHML_NAMESPACE) {
                return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
              } // We only allow elements that are defined in SVG
              // spec. All others are disallowed in SVG namespace.


              return Boolean(ALL_SVG_TAGS[tagName]);
            }

            if (element.namespaceURI === MATHML_NAMESPACE) {
              // The only way to switch from HTML namespace to MathML
              // is via <math>. If it happens via any other tag, then
              // it should be killed.
              if (parent.namespaceURI === HTML_NAMESPACE) {
                return tagName === 'math';
              } // The only way to switch from SVG to MathML is via
              // <math> and HTML integration points


              if (parent.namespaceURI === SVG_NAMESPACE) {
                return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
              } // We only allow elements that are defined in MathML
              // spec. All others are disallowed in MathML namespace.


              return Boolean(ALL_MATHML_TAGS[tagName]);
            }

            if (element.namespaceURI === HTML_NAMESPACE) {
              // The only way to switch from SVG to HTML is via
              // HTML integration points, and from MathML to HTML
              // is via MathML text integration points
              if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
                return false;
              }

              if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
                return false;
              } // We disallow tags that are specific for MathML
              // or SVG and should never appear in HTML namespace


              return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            } // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG or MathML). Return false just in case.


            return false;
          };
          /**
           * _forceRemove
           *
           * @param  {Node} node a DOM node
           */


          var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
              element: node });


            try {
              // eslint-disable-next-line unicorn/prefer-dom-node-remove
              node.parentNode.removeChild(node);
            } catch (_) {
              try {
                node.outerHTML = emptyHTML;
              } catch (_) {
                node.remove();
              }
            }
          };
          /**
           * _removeAttribute
           *
           * @param  {String} name an Attribute name
           * @param  {Node} node a DOM node
           */


          var _removeAttribute = function _removeAttribute(name, node) {
            try {
              arrayPush(DOMPurify.removed, {
                attribute: node.getAttributeNode(name),
                from: node });

            } catch (_) {
              arrayPush(DOMPurify.removed, {
                attribute: null,
                from: node });

            }

            node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

            if (name === 'is' && !ALLOWED_ATTR[name]) {
              if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
                try {
                  _forceRemove(node);
                } catch (_) {}
              } else {
                try {
                  node.setAttribute(name, '');
                } catch (_) {}
              }
            }
          };
          /**
           * _initDocument
           *
           * @param  {String} dirty a string of dirty markup
           * @return {Document} a DOM, filled with the dirty markup
           */


          var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */
            var doc;
            var leadingWhitespace;

            if (FORCE_BODY) {
              dirty = '<remove></remove>' + dirty;
            } else {
              /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
              var matches = stringMatch(dirty, /^[\r\n\t ]+/);
              leadingWhitespace = matches && matches[0];
            }

            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml') {
              // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
              dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            }

            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
             * Use the DOMParser API by default, fallback later if needs be
             * DOMParser not work for svg when has multiple root element.
             */

            if (NAMESPACE === HTML_NAMESPACE) {
              try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
              } catch (_) {}
            }
            /* Use createHTMLDocument in case DOMParser is not available */


            if (!doc || !doc.documentElement) {
              doc = implementation.createDocument(NAMESPACE, 'template', null);

              try {
                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? '' : dirtyPayload;
              } catch (_) {// Syntax error if dirtyPayload is invalid xml
              }
            }

            var body = doc.body || doc.documentElement;

            if (dirty && leadingWhitespace) {
              body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            }
            /* Work on whole document or just its body */


            if (NAMESPACE === HTML_NAMESPACE) {
              return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            }

            return WHOLE_DOCUMENT ? doc.documentElement : body;
          };
          /**
           * _createIterator
           *
           * @param  {Document} root document/fragment to create iterator for
           * @return {Iterator} iterator instance
           */


          var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
          };
          /**
           * _isClobbered
           *
           * @param  {Node} elm element to check for clobbering attacks
           * @return {Boolean} true if clobbered, false if safe
           */


          var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function');
          };
          /**
           * _isNode
           *
           * @param  {Node} obj object to check whether it's a DOM node
           * @return {Boolean} true is object is a DOM node
           */


          var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
          };
          /**
           * _executeHook
           * Execute user configurable hooks
           *
           * @param  {String} entryPoint  Name of the hook's entry point
           * @param  {Node} currentNode node to work on with the hook
           * @param  {Object} data additional hook parameters
           */


          var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) {
              return;
            }

            arrayForEach(hooks[entryPoint], function (hook) {
              hook.call(DOMPurify, currentNode, data, CONFIG);
            });
          };
          /**
           * _sanitizeElements
           *
           * @protect nodeName
           * @protect textContent
           * @protect removeChild
           *
           * @param   {Node} currentNode to check for permission to exist
           * @return  {Boolean} true if node was killed, false if left alive
           */


          var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */

            _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */


            if (_isClobbered(currentNode)) {
              _forceRemove(currentNode);

              return true;
            }
            /* Check if tagname contains Unicode */


            if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
              _forceRemove(currentNode);

              return true;
            }
            /* Now let's check the element's type and name */


            var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */

            _executeHook('uponSanitizeElement', currentNode, {
              tagName: tagName,
              allowedTags: ALLOWED_TAGS });

            /* Detect mXSS attempts abusing namespace confusion */


            if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
              _forceRemove(currentNode);

              return true;
            }
            /* Mitigate a problem with templates inside select */


            if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
              _forceRemove(currentNode);

              return true;
            }
            /* Remove element if anything forbids its presence */


            if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
              /* Check if we have a custom element to handle */
              if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
              }
              /* Keep content except for bad-listed elements */


              if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

                if (childNodes && parentNode) {
                  var childCount = childNodes.length;

                  for (var i = childCount - 1; i >= 0; --i) {
                    parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
                  }
                }
              }

              _forceRemove(currentNode);

              return true;
            }
            /* Check whether element has a valid namespace */


            if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
              _forceRemove(currentNode);

              return true;
            }

            if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
              _forceRemove(currentNode);

              return true;
            }
            /* Sanitize element content to be template-safe */


            if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
              /* Get the element's text content */
              content = currentNode.textContent;
              content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
              content = stringReplace(content, ERB_EXPR$1, ' ');

              if (currentNode.textContent !== content) {
                arrayPush(DOMPurify.removed, {
                  element: currentNode.cloneNode() });

                currentNode.textContent = content;
              }
            }
            /* Execute a hook if present */


            _executeHook('afterSanitizeElements', currentNode, null);

            return false;
          };
          /**
           * _isValidAttribute
           *
           * @param  {string} lcTag Lowercase tag name of containing element.
           * @param  {string} lcName Lowercase attribute name.
           * @param  {string} value Attribute value.
           * @return {Boolean} Returns true if `value` is valid, otherwise false.
           */
          // eslint-disable-next-line complexity


          var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */
            if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
              return false;
            }
            /* Allow valid data-* attributes: At least one character after "-"
                (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
                XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
                We don't need to check the value; it's always URI safe. */


            if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
              if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
              // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
              _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
              // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;else {
                return false;
              }
              /* Check value is safe. First, is attr inert? If so, is safe */

            } else if (URI_SAFE_ATTRIBUTES[lcName]) ;else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;else if (!value) ;else {
              return false;
            }

            return true;
          };
          /**
           * _basicCustomElementCheck
           * checks if at least one dash is included in tagName, and it's not the first char
           * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
           * @param {string} tagName name of the tag of the node to sanitize
           */


          var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName.indexOf('-') > 0;
          };
          /**
           * _sanitizeAttributes
           *
           * @protect attributes
           * @protect nodeName
           * @protect removeAttribute
           * @protect setAttribute
           *
           * @param  {Node} currentNode to sanitize
           */


          var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */

            _executeHook('beforeSanitizeAttributes', currentNode, null);

            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */

            if (!attributes) {
              return;
            }

            var hookEvent = {
              attrName: '',
              attrValue: '',
              keepAttr: true,
              allowedAttributes: ALLOWED_ATTR };

            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */

            while (l--) {
              attr = attributes[l];
              var _attr = attr,
              name = _attr.name,
              namespaceURI = _attr.namespaceURI;
              value = name === 'value' ? attr.value : stringTrim(attr.value);
              lcName = transformCaseFunc(name);
              /* Execute a hook if present */

              hookEvent.attrName = lcName;
              hookEvent.attrValue = value;
              hookEvent.keepAttr = true;
              hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

              _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

              value = hookEvent.attrValue;
              /* Did the hooks approve of the attribute? */

              if (hookEvent.forceKeepAttr) {
                continue;
              }
              /* Remove attribute */


              _removeAttribute(name, currentNode);
              /* Did the hooks approve of the attribute? */


              if (!hookEvent.keepAttr) {
                continue;
              }
              /* Work around a security issue in jQuery 3.0 */


              if (regExpTest(/\/>/i, value)) {
                _removeAttribute(name, currentNode);

                continue;
              }
              /* Sanitize attribute content to be template-safe */


              if (SAFE_FOR_TEMPLATES) {
                value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                value = stringReplace(value, ERB_EXPR$1, ' ');
              }
              /* Is `value` valid for this attribute? */


              var lcTag = transformCaseFunc(currentNode.nodeName);

              if (!_isValidAttribute(lcTag, lcName, value)) {
                continue;
              }
              /* Full DOM Clobbering protection via namespace isolation,
               * Prefix id and name attributes with `user-content-`
               */


              if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                // Remove the attribute with this value
                _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


                value = SANITIZE_NAMED_PROPS_PREFIX + value;
              }
              /* Handle attributes that require Trusted Types */


              if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                if (namespaceURI) ;else {
                  switch (trustedTypes.getAttributeType(lcTag, lcName)) {
                    case 'TrustedHTML':
                      value = trustedTypesPolicy.createHTML(value);
                      break;

                    case 'TrustedScriptURL':
                      value = trustedTypesPolicy.createScriptURL(value);
                      break;}

                }
              }
              /* Handle invalid data-* attribute set by try-catching it */


              try {
                if (namespaceURI) {
                  currentNode.setAttributeNS(namespaceURI, name, value);
                } else {
                  /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
                  currentNode.setAttribute(name, value);
                }

                arrayPop(DOMPurify.removed);
              } catch (_) {}
            }
            /* Execute a hook if present */


            _executeHook('afterSanitizeAttributes', currentNode, null);
          };
          /**
           * _sanitizeShadowDOM
           *
           * @param  {DocumentFragment} fragment to iterate over recursively
           */


          var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;

            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */


            _executeHook('beforeSanitizeShadowDOM', fragment, null);

            while (shadowNode = shadowIterator.nextNode()) {
              /* Execute a hook if present */
              _executeHook('uponSanitizeShadowNode', shadowNode, null);
              /* Sanitize tags and elements */


              if (_sanitizeElements(shadowNode)) {
                continue;
              }
              /* Deep shadow DOM detected */


              if (shadowNode.content instanceof DocumentFragment) {
                _sanitizeShadowDOM(shadowNode.content);
              }
              /* Check attributes, sanitize if necessary */


              _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */


            _executeHook('afterSanitizeShadowDOM', fragment, null);
          };
          /**
           * Sanitize
           * Public method providing core sanitation functionality
           *
           * @param {String|Node} dirty string or DOM node
           * @param {Object} configuration object
           */
          // eslint-disable-next-line complexity


          DOMPurify.sanitize = function (dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
              DO NOT return early, as this will return the wrong type if
              the user has requested a DOM object rather than a string */

            IS_EMPTY_INPUT = !dirty;

            if (IS_EMPTY_INPUT) {
              dirty = '<!-->';
            }
            /* Stringify, in case dirty is an object */


            if (typeof dirty !== 'string' && !_isNode(dirty)) {
              // eslint-disable-next-line no-negated-condition
              if (typeof dirty.toString !== 'function') {
                throw typeErrorCreate('toString is not a function');
              } else {
                dirty = dirty.toString();

                if (typeof dirty !== 'string') {
                  throw typeErrorCreate('dirty is not a string, aborting');
                }
              }
            }
            /* Check we can run. Otherwise fall back or ignore */


            if (!DOMPurify.isSupported) {
              if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
                if (typeof dirty === 'string') {
                  return window.toStaticHTML(dirty);
                }

                if (_isNode(dirty)) {
                  return window.toStaticHTML(dirty.outerHTML);
                }
              }

              return dirty;
            }
            /* Assign config vars */


            if (!SET_CONFIG) {
              _parseConfig(cfg);
            }
            /* Clean up removed elements */


            DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */

            if (typeof dirty === 'string') {
              IN_PLACE = false;
            }

            if (IN_PLACE) {
              /* Do some early pre-sanitization to avoid unsafe root nodes */
              if (dirty.nodeName) {
                var tagName = transformCaseFunc(dirty.nodeName);

                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                  throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
              }
            } else if (dirty instanceof Node) {
              /* If dirty is a DOM element, append to an empty document to avoid
                 elements being stripped by the parser */
              body = _initDocument('<!---->');
              importedNode = body.ownerDocument.importNode(dirty, true);

              if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
                /* Node is already a body, use as is */
                body = importedNode;
              } else if (importedNode.nodeName === 'HTML') {
                body = importedNode;
              } else {
                // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
              }
            } else {
              /* Exit directly if we have nothing to do */
              if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
              dirty.indexOf('<') === -1) {
                return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
              }
              /* Initialize the document to work on */


              body = _initDocument(dirty);
              /* Check we have a DOM node from the data */

              if (!body) {
                return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
              }
            }
            /* Remove first element node (ours) if FORCE_BODY is set */


            if (body && FORCE_BODY) {
              _forceRemove(body.firstChild);
            }
            /* Get node iterator */


            var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */


            while (currentNode = nodeIterator.nextNode()) {
              /* Fix IE's strange behavior with manipulated textNodes #89 */
              if (currentNode.nodeType === 3 && currentNode === oldNode) {
                continue;
              }
              /* Sanitize tags and elements */


              if (_sanitizeElements(currentNode)) {
                continue;
              }
              /* Shadow DOM detected, sanitize it */


              if (currentNode.content instanceof DocumentFragment) {
                _sanitizeShadowDOM(currentNode.content);
              }
              /* Check attributes, sanitize if necessary */


              _sanitizeAttributes(currentNode);

              oldNode = currentNode;
            }

            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */

            if (IN_PLACE) {
              return dirty;
            }
            /* Return sanitized string or DOM */


            if (RETURN_DOM) {
              if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);

                while (body.firstChild) {
                  // eslint-disable-next-line unicorn/prefer-dom-node-append
                  returnNode.appendChild(body.firstChild);
                }
              } else {
                returnNode = body;
              }

              if (ALLOWED_ATTR.shadowroot) {
                /*
                  AdoptNode() is not used because internal state is not reset
                  (e.g. the past names map of a HTMLFormElement), this is safe
                  in theory but we would rather not risk another attack vector.
                  The state that is cloned by importNode() is explicitly defined
                  by the specs.
                */
                returnNode = importNode.call(originalDocument, returnNode, true);
              }

              return returnNode;
            }

            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */

            if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
              serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            }
            /* Sanitize final string template-safe */


            if (SAFE_FOR_TEMPLATES) {
              serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
              serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
            }

            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
          };
          /**
           * Public method to set the configuration once
           * setConfig
           *
           * @param {Object} cfg configuration object
           */


          DOMPurify.setConfig = function (cfg) {
            _parseConfig(cfg);

            SET_CONFIG = true;
          };
          /**
           * Public method to remove the configuration
           * clearConfig
           *
           */


          DOMPurify.clearConfig = function () {
            CONFIG = null;
            SET_CONFIG = false;
          };
          /**
           * Public method to check if an attribute value is valid.
           * Uses last set config, if any. Otherwise, uses config defaults.
           * isValidAttribute
           *
           * @param  {string} tag Tag name of containing element.
           * @param  {string} attr Attribute name.
           * @param  {string} value Attribute value.
           * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
           */


          DOMPurify.isValidAttribute = function (tag, attr, value) {
            /* Initialize shared config vars if necessary. */
            if (!CONFIG) {
              _parseConfig({});
            }

            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
          };
          /**
           * AddHook
           * Public method to add DOMPurify hooks
           *
           * @param {String} entryPoint entry point for the hook to add
           * @param {Function} hookFunction function to execute
           */


          DOMPurify.addHook = function (entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') {
              return;
            }

            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
          };
          /**
           * RemoveHook
           * Public method to remove a DOMPurify hook at a given entryPoint
           * (pops it from the stack of hooks if more are present)
           *
           * @param {String} entryPoint entry point for the hook to remove
           * @return {Function} removed(popped) hook
           */


          DOMPurify.removeHook = function (entryPoint) {
            if (hooks[entryPoint]) {
              return arrayPop(hooks[entryPoint]);
            }
          };
          /**
           * RemoveHooks
           * Public method to remove all DOMPurify hooks at a given entryPoint
           *
           * @param  {String} entryPoint entry point for the hooks to remove
           */


          DOMPurify.removeHooks = function (entryPoint) {
            if (hooks[entryPoint]) {
              hooks[entryPoint] = [];
            }
          };
          /**
           * RemoveAllHooks
           * Public method to remove all DOMPurify hooks
           *
           */


          DOMPurify.removeAllHooks = function () {
            hooks = {};
          };

          return DOMPurify;
        }

        var purify = createDOMPurify();

        return purify;

      });

    })(purify);

    var DOMPurify = purify.exports;

    /*!
     * escape-html
     * Copyright(c) 2012-2013 TJ Holowaychuk
     * Copyright(c) 2015 Andreas Lubbe
     * Copyright(c) 2015 Tiancheng "Timothy" Gu
     * MIT Licensed
     */

    /**
     * Module variables.
     * @private
     */

    var matchHtmlRegExp = /["'&<>]/;

    /**
     * Module exports.
     * @public
     */

    var escapeHtml_1 = escapeHtml;

    /**
     * Escape special characters in the given string of html.
     *
     * @param  {string} string The string to escape for inserting into HTML
     * @return {string}
     * @public
     */

    function escapeHtml(string) {
      var str = '' + string;
      var match = matchHtmlRegExp.exec(str);

      if (!match) {
        return str;
      }

      var escape;
      var html = '';
      var index = 0;
      var lastIndex = 0;

      for (index = match.index; index < str.length; index++) {
        switch (str.charCodeAt(index)) {
          case 34: // "
            escape = '&quot;';
            break;
          case 38: // &
            escape = '&amp;';
            break;
          case 39: // '
            escape = '&#39;';
            break;
          case 60: // <
            escape = '&lt;';
            break;
          case 62: // >
            escape = '&gt;';
            break;
          default:
            continue;}


        if (lastIndex !== index) {
          html += str.substring(lastIndex, index);
        }

        lastIndex = index + 1;
        html += escape;
      }

      return lastIndex !== index ?
      html + str.substring(lastIndex, index) :
      html;
    }

    exports.ActionType = void 0;
    (function (ActionType) {
      ActionType["ApiCall"] = "API_CALL";
      ActionType["ApiCallGraphql"] = "API_CALL_GRAPHQL";
      ActionType["Calculation"] = "CALCULATION";
      ActionType["Checklist"] = "CHECKLIST";
      ActionType["ClinicalNote"] = "CLINICAL_NOTE";
      ActionType["Form"] = "FORM";
      ActionType["Message"] = "MESSAGE";
      ActionType["Plugin"] = "PLUGIN";
      ActionType["PushToEmr"] = "PUSH_TO_EMR";
    })(exports.ActionType || (exports.ActionType = {}));
    exports.ActivityAction = void 0;
    (function (ActivityAction) {
      ActivityAction["Activate"] = "ACTIVATE";
      ActivityAction["Added"] = "ADDED";
      ActivityAction["Assigned"] = "ASSIGNED";
      ActivityAction["Complete"] = "COMPLETE";
      ActivityAction["Computed"] = "COMPUTED";
      ActivityAction["Delegated"] = "DELEGATED";
      ActivityAction["Deliver"] = "DELIVER";
      ActivityAction["Discarded"] = "DISCARDED";
      ActivityAction["Failed"] = "FAILED";
      ActivityAction["FailedToSend"] = "FAILED_TO_SEND";
      ActivityAction["Generated"] = "GENERATED";
      ActivityAction["IsWaitingOn"] = "IS_WAITING_ON";
      ActivityAction["Postponed"] = "POSTPONED";
      ActivityAction["Processed"] = "PROCESSED";
      ActivityAction["Read"] = "READ";
      ActivityAction["Remind"] = "REMIND";
      ActivityAction["Reported"] = "REPORTED";
      ActivityAction["Scheduled"] = "SCHEDULED";
      ActivityAction["Send"] = "SEND";
      ActivityAction["Skipped"] = "SKIPPED";
      ActivityAction["Stopped"] = "STOPPED";
      ActivityAction["Submitted"] = "SUBMITTED";
    })(exports.ActivityAction || (exports.ActivityAction = {}));
    exports.ActivityObjectType = void 0;
    (function (ActivityObjectType) {
      ActivityObjectType["Action"] = "ACTION";
      ActivityObjectType["ApiCall"] = "API_CALL";
      ActivityObjectType["Calculation"] = "CALCULATION";
      ActivityObjectType["Checklist"] = "CHECKLIST";
      ActivityObjectType["ClinicalNote"] = "CLINICAL_NOTE";
      ActivityObjectType["EmrReport"] = "EMR_REPORT";
      ActivityObjectType["EmrRequest"] = "EMR_REQUEST";
      ActivityObjectType["EvaluatedRule"] = "EVALUATED_RULE";
      ActivityObjectType["Form"] = "FORM";
      ActivityObjectType["Message"] = "MESSAGE";
      ActivityObjectType["Pathway"] = "PATHWAY";
      ActivityObjectType["Patient"] = "PATIENT";
      ActivityObjectType["Plugin"] = "PLUGIN";
      ActivityObjectType["PluginAction"] = "PLUGIN_ACTION";
      ActivityObjectType["Reminder"] = "REMINDER";
      ActivityObjectType["Stakeholder"] = "STAKEHOLDER";
      ActivityObjectType["Step"] = "STEP";
      ActivityObjectType["Track"] = "TRACK";
      ActivityObjectType["User"] = "USER";
    })(exports.ActivityObjectType || (exports.ActivityObjectType = {}));
    exports.ActivityResolution = void 0;
    (function (ActivityResolution) {
      ActivityResolution["Failure"] = "FAILURE";
      ActivityResolution["Success"] = "SUCCESS";
    })(exports.ActivityResolution || (exports.ActivityResolution = {}));
    exports.ActivityStatus = void 0;
    (function (ActivityStatus) {
      ActivityStatus["Active"] = "ACTIVE";
      ActivityStatus["Canceled"] = "CANCELED";
      ActivityStatus["Done"] = "DONE";
      ActivityStatus["Failed"] = "FAILED";
    })(exports.ActivityStatus || (exports.ActivityStatus = {}));
    exports.ActivitySubjectType = void 0;
    (function (ActivitySubjectType) {
      ActivitySubjectType["ApiCall"] = "API_CALL";
      ActivitySubjectType["Awell"] = "AWELL";
      ActivitySubjectType["Plugin"] = "PLUGIN";
      ActivitySubjectType["Stakeholder"] = "STAKEHOLDER";
      ActivitySubjectType["User"] = "USER";
    })(exports.ActivitySubjectType || (exports.ActivitySubjectType = {}));
    exports.ApiCallRequestMethod = void 0;
    (function (ApiCallRequestMethod) {
      ApiCallRequestMethod["Get"] = "GET";
      ApiCallRequestMethod["Post"] = "POST";
    })(exports.ApiCallRequestMethod || (exports.ApiCallRequestMethod = {}));
    exports.ApiCallStatus = void 0;
    (function (ApiCallStatus) {
      ApiCallStatus["Failed"] = "Failed";
      ApiCallStatus["InProgress"] = "InProgress";
      ApiCallStatus["Pending"] = "Pending";
      ApiCallStatus["PermanentlyFailed"] = "PermanentlyFailed";
      ApiCallStatus["Skipped"] = "Skipped";
      ApiCallStatus["Success"] = "Success";
    })(exports.ApiCallStatus || (exports.ApiCallStatus = {}));
    exports.BooleanOperator = void 0;
    (function (BooleanOperator) {
      BooleanOperator["And"] = "AND";
      BooleanOperator["Or"] = "OR";
    })(exports.BooleanOperator || (exports.BooleanOperator = {}));
    exports.ConditionOperandType = void 0;
    (function (ConditionOperandType) {
      ConditionOperandType["Boolean"] = "BOOLEAN";
      ConditionOperandType["DataPoint"] = "DATA_POINT";
      ConditionOperandType["DataSource"] = "DATA_SOURCE";
      ConditionOperandType["Number"] = "NUMBER";
      ConditionOperandType["NumbersArray"] = "NUMBERS_ARRAY";
      ConditionOperandType["String"] = "STRING";
    })(exports.ConditionOperandType || (exports.ConditionOperandType = {}));
    exports.ConditionOperator = void 0;
    (function (ConditionOperator) {
      ConditionOperator["Contains"] = "CONTAINS";
      ConditionOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
      ConditionOperator["IsAnyOf"] = "IS_ANY_OF";
      ConditionOperator["IsEmpty"] = "IS_EMPTY";
      ConditionOperator["IsEqualTo"] = "IS_EQUAL_TO";
      ConditionOperator["IsGreaterThan"] = "IS_GREATER_THAN";
      ConditionOperator["IsGreaterThanOrEqualTo"] = "IS_GREATER_THAN_OR_EQUAL_TO";
      ConditionOperator["IsInRange"] = "IS_IN_RANGE";
      ConditionOperator["IsLessThan"] = "IS_LESS_THAN";
      ConditionOperator["IsLessThanOrEqualTo"] = "IS_LESS_THAN_OR_EQUAL_TO";
      ConditionOperator["IsNoneOf"] = "IS_NONE_OF";
      ConditionOperator["IsNotEmpty"] = "IS_NOT_EMPTY";
      ConditionOperator["IsNotEqualTo"] = "IS_NOT_EQUAL_TO";
      ConditionOperator["IsNotTrue"] = "IS_NOT_TRUE";
      ConditionOperator["IsToday"] = "IS_TODAY";
      ConditionOperator["IsTrue"] = "IS_TRUE";
    })(exports.ConditionOperator || (exports.ConditionOperator = {}));
    exports.DataPointSourceType = void 0;
    (function (DataPointSourceType) {
      DataPointSourceType["ApiCall"] = "API_CALL";
      DataPointSourceType["ApiCallStatus"] = "API_CALL_STATUS";
      DataPointSourceType["Calculation"] = "CALCULATION";
      DataPointSourceType["ExtensionAction"] = "EXTENSION_ACTION";
      DataPointSourceType["ExtensionWebhook"] = "EXTENSION_WEBHOOK";
      DataPointSourceType["Form"] = "FORM";
      DataPointSourceType["Pathway"] = "PATHWAY";
      DataPointSourceType["PatientProfile"] = "PATIENT_PROFILE";
      DataPointSourceType["Step"] = "STEP";
      DataPointSourceType["Track"] = "TRACK";
    })(exports.DataPointSourceType || (exports.DataPointSourceType = {}));
    exports.DataPointValueType = void 0;
    (function (DataPointValueType) {
      DataPointValueType["Boolean"] = "BOOLEAN";
      DataPointValueType["Date"] = "DATE";
      DataPointValueType["Number"] = "NUMBER";
      DataPointValueType["NumbersArray"] = "NUMBERS_ARRAY";
      DataPointValueType["String"] = "STRING";
      DataPointValueType["Telephone"] = "TELEPHONE";
    })(exports.DataPointValueType || (exports.DataPointValueType = {}));
    exports.ElementStatus = void 0;
    (function (ElementStatus) {
      ElementStatus["Active"] = "ACTIVE";
      ElementStatus["Discarded"] = "DISCARDED";
      ElementStatus["Done"] = "DONE";
      ElementStatus["Postponed"] = "POSTPONED";
      ElementStatus["Scheduled"] = "SCHEDULED";
      ElementStatus["Stopped"] = "STOPPED";
    })(exports.ElementStatus || (exports.ElementStatus = {}));
    exports.ElementType = void 0;
    (function (ElementType) {
      ElementType["Action"] = "ACTION";
      ElementType["Pathway"] = "PATHWAY";
      ElementType["Step"] = "STEP";
      ElementType["Track"] = "TRACK";
      ElementType["Trigger"] = "TRIGGER";
    })(exports.ElementType || (exports.ElementType = {}));
    exports.ExtensionActionFieldType = void 0;
    (function (ExtensionActionFieldType) {
      ExtensionActionFieldType["Boolean"] = "BOOLEAN";
      ExtensionActionFieldType["Date"] = "DATE";
      ExtensionActionFieldType["Html"] = "HTML";
      ExtensionActionFieldType["Json"] = "JSON";
      ExtensionActionFieldType["Numeric"] = "NUMERIC";
      ExtensionActionFieldType["String"] = "STRING";
      ExtensionActionFieldType["Text"] = "TEXT";
    })(exports.ExtensionActionFieldType || (exports.ExtensionActionFieldType = {}));
    exports.FormDisplayMode = void 0;
    (function (FormDisplayMode) {
      FormDisplayMode["Conversational"] = "CONVERSATIONAL";
      FormDisplayMode["Regular"] = "REGULAR";
    })(exports.FormDisplayMode || (exports.FormDisplayMode = {}));
    exports.HostedSessionStakeholderType = void 0;
    (function (HostedSessionStakeholderType) {
      HostedSessionStakeholderType["Patient"] = "PATIENT";
      HostedSessionStakeholderType["Stakeholder"] = "STAKEHOLDER";
    })(exports.HostedSessionStakeholderType || (exports.HostedSessionStakeholderType = {}));
    exports.HostedSessionStatus = void 0;
    (function (HostedSessionStatus) {
      HostedSessionStatus["Active"] = "ACTIVE";
      HostedSessionStatus["Completed"] = "COMPLETED";
      HostedSessionStatus["Expired"] = "EXPIRED";
    })(exports.HostedSessionStatus || (exports.HostedSessionStatus = {}));
    exports.MessageAttachmentType = void 0;
    (function (MessageAttachmentType) {
      MessageAttachmentType["File"] = "FILE";
      MessageAttachmentType["Link"] = "LINK";
      MessageAttachmentType["Video"] = "VIDEO";
    })(exports.MessageAttachmentType || (exports.MessageAttachmentType = {}));
    exports.MessageFormat = void 0;
    (function (MessageFormat) {
      MessageFormat["Html"] = "HTML";
      MessageFormat["Slate"] = "SLATE";
    })(exports.MessageFormat || (exports.MessageFormat = {}));
    exports.PathwayStatus = void 0;
    (function (PathwayStatus) {
      PathwayStatus["Active"] = "active";
      PathwayStatus["Completed"] = "completed";
      PathwayStatus["MissingBaselineInfo"] = "missing_baseline_info";
      PathwayStatus["Starting"] = "starting";
      PathwayStatus["Stopped"] = "stopped";
    })(exports.PathwayStatus || (exports.PathwayStatus = {}));
    exports.QuestionType = void 0;
    (function (QuestionType) {
      QuestionType["Input"] = "INPUT";
      QuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
      QuestionType["NoInput"] = "NO_INPUT";
    })(exports.QuestionType || (exports.QuestionType = {}));
    exports.Sex = void 0;
    (function (Sex) {
      Sex["Female"] = "FEMALE";
      Sex["Male"] = "MALE";
      Sex["NotKnown"] = "NOT_KNOWN";
    })(exports.Sex || (exports.Sex = {}));
    exports.StakeholderClinicalAppRole = void 0;
    (function (StakeholderClinicalAppRole) {
      StakeholderClinicalAppRole["Caregiver"] = "CAREGIVER";
      StakeholderClinicalAppRole["Patient"] = "PATIENT";
      StakeholderClinicalAppRole["Physician"] = "PHYSICIAN";
    })(exports.StakeholderClinicalAppRole || (exports.StakeholderClinicalAppRole = {}));
    exports.SwimlaneItemCategory = void 0;
    (function (SwimlaneItemCategory) {
      SwimlaneItemCategory["Action"] = "ACTION";
      SwimlaneItemCategory["PathwayEnd"] = "PATHWAY_END";
      SwimlaneItemCategory["PathwayStart"] = "PATHWAY_START";
      SwimlaneItemCategory["Step"] = "STEP";
      SwimlaneItemCategory["Track"] = "TRACK";
      SwimlaneItemCategory["TrackEnd"] = "TRACK_END";
      SwimlaneItemCategory["TrackStart"] = "TRACK_START";
    })(exports.SwimlaneItemCategory || (exports.SwimlaneItemCategory = {}));
    exports.SwimlaneItemType = void 0;
    (function (SwimlaneItemType) {
      SwimlaneItemType["Active"] = "active";
      SwimlaneItemType["Completed"] = "completed";
      SwimlaneItemType["Pending"] = "pending";
      SwimlaneItemType["Possible"] = "possible";
    })(exports.SwimlaneItemType || (exports.SwimlaneItemType = {}));
    exports.UserQuestionType = void 0;
    (function (UserQuestionType) {
      UserQuestionType["Date"] = "DATE";
      UserQuestionType["Description"] = "DESCRIPTION";
      UserQuestionType["LongText"] = "LONG_TEXT";
      UserQuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
      UserQuestionType["MultipleChoiceGrid"] = "MULTIPLE_CHOICE_GRID";
      UserQuestionType["MultipleSelect"] = "MULTIPLE_SELECT";
      UserQuestionType["Number"] = "NUMBER";
      UserQuestionType["ShortText"] = "SHORT_TEXT";
      UserQuestionType["Signature"] = "SIGNATURE";
      UserQuestionType["Slider"] = "SLIDER";
      UserQuestionType["Telephone"] = "TELEPHONE";
      UserQuestionType["YesNo"] = "YES_NO";
    })(exports.UserQuestionType || (exports.UserQuestionType = {}));

    var isText = function (node) {
      return node.text;
    };
    var isElement = function (node) {
      return node.children;
    };

    var generateClassAttribute = function (node) {
      var classes = Object.entries(node).
      map(function (_a) {
        var prop = _a[0];
        switch (prop) {
          case 'bold':
          case 'italic':
          case 'underline':
          case 'strikethrough':
            return richTextClasses[prop];
          default:
            return undefined;}

      }).
      filter(function (c) {return c;});
      if (classes.length > 0) {
        return "class=\"".concat(classes.join(' '), "\"");
      }
      return undefined;
    };
    var serializeNode = function (node) {
      if (isText(node)) {
        var classAttribute = generateClassAttribute(node);
        if (classAttribute === undefined) {
          return escapeHtml_1(node.text);
        } else
        {
          return "<span ".concat(classAttribute, ">").concat(escapeHtml_1(node.text), "</span>");
        }
      } else
      if (isElement(node)) {
        var type = node.type || 'div';
        if (node.type === 'a') {
          return "<".concat(type, " href=\"").concat(node === null || node === void 0 ? void 0 : node.url, "\" target=\"_blank\" rel=\"noopener noreferrer\">").concat(serializeHtml(node.children), "</").concat(type, ">");
        }
        return "<".concat(type, ">").concat(serializeHtml(node.children), "</").concat(type, ">");
      }
      return '';
    };
    var serializeHtml = function (nodes) {
      var nodesArray = Array.isArray(nodes) ? nodes : JSON.parse(nodes);
      return nodesArray.map(function (node) {return serializeNode(node);}).join('');
    };
    var generatePureHtml = function (content) {
      var isSlate = true;
      try {
        Array.isArray(content) ? content : JSON.parse(content);
      }
      catch (e) {
        isSlate = false;
      }
      DOMPurify.addHook('uponSanitizeElement', function (node, data) {
        var _a, _b;
        if (data.tagName === 'iframe') {
          var src = (_a = node.getAttribute('src')) !== null && _a !== void 0 ? _a : '';
          var isYoutube = src.startsWith('https://www.youtube.com/embed/');
          var isVimeo = src.startsWith('https://player.vimeo.com/video/');
          if (!isYoutube && !isVimeo) {
            return (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(node);
          }
        }
      });
      var purifiedMessage = purify.exports.sanitize(isSlate ? serializeHtml(content) : content, {
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'scrolling'] });

      return purifiedMessage;
    };

    var Description = function (_a) {
      var content = _a.content;
      var cleanContent = generatePureHtml(content);
      return jsxRuntime.exports.jsx("div", __assign({ className: "".concat(classes$q.awell_description_wrapper, " ").concat(classes$q.content) }, { children: jsxRuntime.exports.jsx(RichTextViewer, { content: cleanContent }) }));
    };

    var classes$p = {"hugeHeadline":"awell__typography_hugeHeadline","bigHeadline":"awell__typography_bigHeadline","headline":"awell__typography_headline","subHeadline":"awell__typography_subHeadline","smallHeadline":"awell__typography_smallHeadline","tinyHeadline":"awell__typography_tinyHeadline","tinyHeadlineCaps":"awell__typography_tinyHeadlineCaps","discreetHeadline":"awell__typography_discreetHeadline","undersizeHeadline":"awell__typography_undersizeHeadline","textRegular":"awell__typography_textRegular","textMedium":"awell__typography_textMedium","textSmall":"awell__typography_textSmall","textSmallMedium":"awell__typography_textSmallMedium","textSmallBold":"awell__typography_textSmallBold","textTinyHint":"awell__typography_textTinyHint","inputPlaceholder":"awell__typography_inputPlaceholder","link":"awell__typography_link","linkBold":"awell__typography_linkBold"};

    var HeadingMain = function (_a) {
      var _b = _a.variant,variant = _b === void 0 ? 'hugeHeadline' : _b,color = _a.color;_a.spacing;var children = _a.children;
      var style = { '--awell-typography-color': color };
      return jsxRuntime.exports.jsx("h1", __assign({ style: style, className: classes$p[variant] }, { children: children }));
    };
    HeadingMain.displayName = 'HeadingMain';
    var HeadingSecondary = function (_a) {
      var _b = _a.variant,variant = _b === void 0 ? 'bigHeadline' : _b,color = _a.color,children = _a.children;
      var style = { '--awell-typography-color': color };
      return jsxRuntime.exports.jsx("h2", __assign({ style: style, className: classes$p[variant] }, { children: children }));
    };
    HeadingSecondary.displayName = 'HeadingSecondary';
    var HeadingTertiary = function (_a) {
      var _b = _a.variant,variant = _b === void 0 ? 'headline' : _b,color = _a.color,children = _a.children;
      var style = { '--awell-typography-color': color };
      return jsxRuntime.exports.jsx("h3", __assign({ style: style, className: classes$p[variant] }, { children: children }));
    };
    HeadingTertiary.displayName = 'HeadingTertiary';
    var SubHeading = function (_a) {
      var _b = _a.variant,variant = _b === void 0 ? 'subHeadline' : _b,color = _a.color;_a.spacing;var children = _a.children;
      var style = { '--awell-typography-color': color };
      return jsxRuntime.exports.jsx("h4", __assign({ style: style, className: classes$p[variant] }, { children: children }));
    };
    SubHeading.displayName = 'SubHeading';
    var Heading5 = function (_a) {
      var _b = _a.variant,variant = _b === void 0 ? 'smallHeadline' : _b,color = _a.color;_a.spacing;var children = _a.children;
      var style = { '--awell-typography-color': color };
      return jsxRuntime.exports.jsx("h5", __assign({ style: style, className: classes$p[variant] }, { children: children }));
    };
    Heading5.displayName = 'Heading5';
    var Heading6 = function (_a) {
      var _b = _a.variant,variant = _b === void 0 ? 'tinyHeadline' : _b,color = _a.color;_a.spacing;var children = _a.children;
      var style = { '--awell-typography-color': color };
      return jsxRuntime.exports.jsx("h6", __assign({ style: style, className: classes$p[variant] }, { children: children }));
    };
    Heading6.displayName = 'Heading6';
    var Text = function (_a) {
      var _b = _a.variant,variant = _b === void 0 ? 'textRegular' : _b,color = _a.color;_a.spacing;var children = _a.children;
      var style = { '--awell-typography-color': color };
      return jsxRuntime.exports.jsx("p", __assign({ style: style, className: classes$p[variant] }, { children: children }));
    };
    Text.displayName = 'Text';
    var InlineText = function (_a) {
      var _b = _a.variant,variant = _b === void 0 ? 'textRegular' : _b,color = _a.color;_a.spacing;var children = _a.children;
      var style = { '--awell-typography-color': color };
      return jsxRuntime.exports.jsx("span", __assign({ style: style, className: classes$p[variant] }, { children: children }));
    };
    InlineText.displayName = 'InlineText';
    var ExternalLink = function (_a) {
      var color = _a.color,href = _a.href,rel = _a.rel,children = _a.children;__rest(_a, ["color", "href", "rel", "children"]);
      var style = { '--awell-typography-color': color };
      return jsxRuntime.exports.jsx("a", __assign({ style: style, className: classes$p.link, href: href, rel: rel }, { children: children }));
    };
    ExternalLink.displayName = 'ExternalLink';
    var InnerText = function (_a) {
      var _b = _a.variant,variant = _b === void 0 ? 'textRegular' : _b,color = _a.color;_a.spacing;var children = _a.children;
      var style = { '--awell-typography-color': color };
      return jsxRuntime.exports.jsx("span", __assign({ style: style, className: classes$p[variant] }, { children: children }));
    };
    InnerText.displayName = 'InnerText';

    var classes$o = {"awell_input_field_wrapper":"awell__inputField_awell_input_field_wrapper","input_wrapper_with_error":"awell__inputField_input_wrapper_with_error","has_error":"awell__inputField_has_error","error_message":"awell__inputField_error_message","error_icon":"awell__inputField_error_icon","awell_input_field":"awell__inputField_awell_input_field"};

    var InputField = function (_a) {
      var onChange = _a.onChange,id = _a.id,label = _a.label,type = _a.type,mandatory = _a.mandatory,props = __rest(_a, ["onChange", "id", "label", "type", "mandatory"]);
      return jsxRuntime.exports.jsxs("div", __assign({ className: classes$o.awell_input_field_wrapper }, { children: [jsxRuntime.exports.jsx(QuestionLabel, { htmlFor: id, label: label, mandatory: mandatory }), jsxRuntime.exports.jsx("input", __assign({}, props, { type: type, id: id, "data-1p-ignore": true, className: classes$o.awell_input_field, onChange: onChange, "data-testid": "input-".concat(id), dir: "ltr" }))] }));
    };

    var classes$n = {"awell_logo":"awell__logo_awell_logo"};

    var awellLogo = "<svg width=\"190\" height=\"50.4\" xmlns=\"http://www.w3.org/2000/svg\">\n\n <g>\n  <title>background</title>\n  <rect fill=\"none\" id=\"canvas_background\" height=\"402\" width=\"582\" y=\"-1\" x=\"-1\"/>\n </g>\n <g>\n  <title>Layer 1</title>\n  <path id=\"svg_1\" d=\"m169.7,0l6.8,0l0,38.7l-6.8,0l0,-38.7zm13.3,0l6.8,0l0,38.7l-6.8,0l0,-38.7zm-38.5,24.5l12.4,-5.2c-0.6,-0.7 -1.4,-1.3 -2.3,-1.7c-0.9,-0.4 -1.9,-0.6 -3,-0.6c-1,0 -1.9,0.2 -2.8,0.6c-0.9,0.4 -1.6,0.9 -2.2,1.6c-0.6,0.7 -1.1,1.5 -1.5,2.4c-0.4,0.8 -0.6,1.8 -0.6,2.9m-6.4,0.4c0,-1.9 0.4,-3.7 1.1,-5.4s1.7,-3.1 2.9,-4.4s2.7,-2.2 4.3,-3c1.6,-0.7 3.4,-1.1 5.3,-1.1c1.6,0 3.1,0.2 4.5,0.7s2.7,1.2 3.9,2.1c1.1,0.9 2.1,2.1 2.9,3.5c0.8,1.4 1.4,2.9 1.6,4.7l-18.6,7.8c0.7,0.9 1.5,1.6 2.5,2.1c0.9,0.5 2,0.8 3.2,0.8c1.1,0 2.2,-0.2 3.2,-0.7c1,-0.5 1.8,-1.3 2.4,-2.3l7.2,0c-0.8,2.7 -2.3,4.9 -4.5,6.5c-2.2,1.7 -5,2.5 -8.3,2.5c-1.9,0 -3.6,-0.4 -5.3,-1.1c-1.6,-0.7 -3.1,-1.7 -4.3,-2.9c-1.2,-1.2 -2.2,-2.7 -2.9,-4.4c-0.8,-1.7 -1.1,-3.5 -1.1,-5.4m-44.9,2l0,-15.2l6.8,0l0,15.4c0,0.4 0.1,0.9 0.2,1.4c0.1,0.6 0.3,1.1 0.7,1.6c0.3,0.5 0.8,1 1.5,1.4c0.7,0.4 1.5,0.6 2.6,0.6c1.5,0 2.8,-0.5 3.7,-1.4c0.9,-0.9 1.4,-2.1 1.4,-3.6l0,-15.4l6.8,0l0,15.4c0,0.4 0.1,0.9 0.2,1.4s0.3,1.1 0.7,1.6c0.3,0.5 0.8,1 1.5,1.4c0.7,0.4 1.5,0.6 2.7,0.6c1.5,0 2.7,-0.5 3.7,-1.4c1,-0.9 1.4,-2.1 1.4,-3.6l0,-15.4l6.8,0l0,15.2c0,1.7 -0.3,3.2 -0.9,4.7c-0.6,1.4 -1.4,2.7 -2.4,3.8c-1,1.1 -2.3,1.9 -3.8,2.5c-1.5,0.6 -3.1,0.9 -4.9,0.9c-1.8,0 -3.4,-0.3 -4.8,-1s-2.6,-1.6 -3.6,-2.7c-1,1.2 -2.2,2.1 -3.6,2.7c-1.4,0.7 -3,1 -4.8,1c-1.8,0 -3.5,-0.3 -4.9,-0.9c-1.4,-0.6 -2.7,-1.4 -3.7,-2.4s-1.8,-2.3 -2.3,-3.7c-0.7,-1.6 -1,-3.2 -1,-4.9m-25.4,-2c0,1 0.2,2 0.5,2.9c0.4,0.9 0.8,1.7 1.5,2.4c0.6,0.7 1.3,1.2 2.2,1.6c0.8,0.4 1.7,0.6 2.6,0.6s1.8,-0.2 2.6,-0.6c0.8,-0.4 1.6,-0.9 2.2,-1.6c0.6,-0.7 1.1,-1.5 1.5,-2.4c0.4,-0.9 0.5,-1.9 0.5,-2.9s-0.2,-2 -0.5,-3c-0.4,-0.9 -0.8,-1.7 -1.5,-2.4c-0.6,-0.7 -1.3,-1.2 -2.2,-1.6c-0.8,-0.4 -1.7,-0.6 -2.6,-0.6c-0.9,0 -1.8,0.2 -2.6,0.6c-0.8,0.4 -1.5,0.9 -2.2,1.6c-0.6,0.7 -1.1,1.5 -1.5,2.4c-0.3,0.9 -0.5,1.9 -0.5,3m-6.8,0c0,-1.9 0.3,-3.7 1,-5.4c0.7,-1.7 1.6,-3.1 2.8,-4.4c1.2,-1.2 2.6,-2.2 4.3,-2.9c1.7,-0.7 3.5,-1.1 5.5,-1.1s3.8,0.4 5.5,1.1c1.7,0.7 3.1,1.7 4.3,3c1.2,1.2 2.1,2.7 2.8,4.4c0.7,1.7 1,3.5 1,5.4l0,13.8l-6.4,0l0,-3.5c-1,1.1 -2.2,1.9 -3.6,2.5c-1.4,0.6 -2.9,0.8 -4.5,0.8c-1.7,0 -3.4,-0.4 -4.9,-1.1c-1.5,-0.7 -2.9,-1.7 -4,-3c-1.2,-1.2 -2.1,-2.7 -2.7,-4.4c-0.8,-1.5 -1.1,-3.3 -1.1,-5.2\" fill=\"#004ac2\"/>\n  <path id=\"svg_2\" fill=\"#004ac2\" d=\"m7.3,21.7c1.4,-7.4 7.2,-13.2 14.6,-14.6l0,-6.8c-11.1,1.4 -20,10.2 -21.6,21.4l7,0zm21.4,-14.6c8.5,1.6 14.9,9 14.9,18c0,3.8 -1.2,7.4 -3.2,10.3l4.9,4.9c3.2,-4.2 5,-9.4 5,-15.1c0.1,-12.7 -9.3,-23.2 -21.6,-24.9l0,6.8zm7,33.1c-2.9,2 -6.5,3.2 -10.3,3.2c-9,0 -16.4,-6.4 -18,-14.9l-7,0c1.6,12.4 12.2,21.9 25,21.9c5.8,0 11.1,-2 15.4,-5.2l-5.1,-5z\"/>\n </g>\n</svg>";

    var Logo = function (_a) {
      var _b = _a.companyName,companyName = _b === void 0 ? 'Awell Health' : _b,_c = _a.logo,logo = _c === void 0 ? awellLogo : _c;
      return logo && typeof logo !== 'string' ? jsxRuntime.exports.jsx("span", __assign({ id: "awell__header_logo" }, { children: logo })) : jsxRuntime.exports.jsx("img", { className: classes$n.awell_logo, id: "awell__header_logo", alt: companyName, src: logo });
    };

    var classes$m = {"awell_long_text_field_wrapper":"awell__longTextField_awell_long_text_field_wrapper","awell_long_text_field":"awell__longTextField_awell_long_text_field"};

    var LongTextField = function (_a) {
      var onChange = _a.onChange,id = _a.id,label = _a.label,mandatory = _a.mandatory,props = __rest(_a, ["onChange", "id", "label", "mandatory"]);
      var DEFAULT_ROWS = 4;
      return jsxRuntime.exports.jsxs("div", __assign({ className: classes$m.awell_long_text_field_wrapper }, { children: [jsxRuntime.exports.jsx(QuestionLabel, { htmlFor: id, label: label, mandatory: mandatory }), jsxRuntime.exports.jsx("textarea", __assign({}, props, { id: id, rows: DEFAULT_ROWS, className: classes$m.awell_long_text_field, onChange: onChange, dir: "ltr" }))] }));
    };

    var classes$l = {"awell_message_container":"awell__messageAttachment_awell_message_container","awell_message_link_button":"awell__messageAttachment_awell_message_link_button","awell_message_name_container":"awell__messageAttachment_awell_message_name_container"};

    var MessageAttachment = function (_a) {
      var url = _a.url,name = _a.name,label = _a.label,children = _a.children;
      return jsxRuntime.exports.jsxs("div", __assign({ className: classes$l.awell_message_container }, { children: [jsxRuntime.exports.jsxs("div", __assign({ className: classes$l.awell_message_name_container }, { children: [children, name] })), jsxRuntime.exports.jsx("a", __assign({ className: classes$l.awell_message_link_button, href: url, target: "_blank", rel: "noopener noreferrer" }, { children: label }))] }));
    };

    function CheckIcon({
      title,
      titleId,
      ...props },
    svgRef) {
      return /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId },
      props), title ? /*#__PURE__*/React__namespace.createElement("title", {
        id: titleId },
      title) : null, /*#__PURE__*/React__namespace.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 12.75l6 6 9-13.5" }));

    }

    const ForwardRef$2 = /*#__PURE__*/React__namespace.forwardRef(CheckIcon);

    function ExclamationTriangleIcon({
      title,
      titleId,
      ...props },
    svgRef) {
      return /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId },
      props), title ? /*#__PURE__*/React__namespace.createElement("title", {
        id: titleId },
      title) : null, /*#__PURE__*/React__namespace.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" }));

    }

    const ForwardRef$1 = /*#__PURE__*/React__namespace.forwardRef(ExclamationTriangleIcon);

    function XMarkIcon({
      title,
      titleId,
      ...props },
    svgRef) {
      return /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId },
      props), title ? /*#__PURE__*/React__namespace.createElement("title", {
        id: titleId },
      title) : null, /*#__PURE__*/React__namespace.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18L18 6M6 6l12 12" }));

    }

    const ForwardRef = /*#__PURE__*/React__namespace.forwardRef(XMarkIcon);

    var classes$k = {"dialog":"awell__Modal_dialog","screen_overlay":"awell__Modal_screen_overlay","modal_overlay":"awell__Modal_modal_overlay","modal_wrapper":"awell__Modal_modal_wrapper","dialog_panel":"awell__Modal_dialog_panel","close_button_wrapper":"awell__Modal_close_button_wrapper","close_button":"awell__Modal_close_button","close_icon":"awell__Modal_close_icon","sr_only":"awell__Modal_sr_only","modal_body":"awell__Modal_modal_body","icon_wrapper":"awell__Modal_icon_wrapper","warning":"awell__Modal_warning","success":"awell__Modal_success","modal_icon":"awell__Modal_modal_icon","modal_content":"awell__Modal_modal_content","modal_title":"awell__Modal_modal_title","modal_content_text":"awell__Modal_modal_content_text","modal_actions":"awell__Modal_modal_actions"};

    var Modal = function (_a) {
      var isOpen = _a.isOpen,title = _a.title,description = _a.description,onCloseModal = _a.onCloseModal,icon = _a.icon,buttons = _a.buttons;
      var _b = React.useState(window.innerWidth < 640),isMobile = _b[0],setIsMobile = _b[1];
      var updateMedia = function () {
        setIsMobile(window.innerWidth < 640);
      };
      React.useEffect(function () {
        window.addEventListener('resize', updateMedia);
        return function () {return window.removeEventListener('resize', updateMedia);};
      });
      if (isOpen) {
        return jsxRuntime.exports.jsxs("div", __assign({ className: classes$k.dialog }, { children: [jsxRuntime.exports.jsx("div", { className: classes$k.screen_overlay }), jsxRuntime.exports.jsx("div", __assign({ className: classes$k.modal_overlay }, { children: jsxRuntime.exports.jsx("div", __assign({ className: classes$k.modal_wrapper }, { children: jsxRuntime.exports.jsxs("div", __assign({ className: classes$k.dialog_panel }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: classes$k.close_button_wrapper }, { children: jsxRuntime.exports.jsxs("button", __assign({ type: "button", className: classes$k.close_button, onClick: onCloseModal }, { children: [jsxRuntime.exports.jsx("span", __assign({ className: classes$k.sr_only }, { children: "Close" })), jsxRuntime.exports.jsx(ForwardRef, { className: classes$k.close_icon, "aria-hidden": "true" })] })) })), jsxRuntime.exports.jsxs("div", __assign({ className: classes$k.modal_body }, { children: [icon && jsxRuntime.exports.jsxs("div", __assign({ className: "".concat(classes$k.icon_wrapper, " ").concat(classes$k[icon]) }, { children: [icon === 'warning' && jsxRuntime.exports.jsx(ForwardRef$1, { className: "".concat(classes$k.modal_icon, " ").concat(classes$k.warning), "aria-hidden": "true" }), icon === 'success' && jsxRuntime.exports.jsx(ForwardRef$2, { className: "".concat(classes$k.modal_icon, " ").concat(classes$k.success), "aria-hidden": "true" })] })), jsxRuntime.exports.jsxs("div", __assign({ className: classes$k.modal_content }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: classes$k.modal_title }, { children: title })), jsxRuntime.exports.jsx("div", __assign({ className: classes$k.modal_content_text }, { children: description }))] }))] })), jsxRuntime.exports.jsx("div", __assign({ className: classes$k.modal_actions }, { children: buttons.map(function (button, index) {return jsxRuntime.exports.jsx(React__default["default"].Fragment, { children: /*#__PURE__*/React.cloneElement(button, { fullWidth: isMobile }) }, index);}) }))] })) })) }))] }));
      }
      return null;
    };

    var classes$j = {"progressBar":"awell__progressIndicator_progressBar","progressBar_completed":"awell__progressIndicator_progressBar_completed"};

    var ProgressIndicator = function (_a) {
      var percentageCompleted = _a.percentageCompleted,_b = _a.showPercentage,showPercentage = _b === void 0 ? false : _b;
      var percentageCompletedNormalized = percentageCompleted < 0 ?
      0 :
      percentageCompleted > 100 ?
      100 :
      percentageCompleted;
      var style = {
        '--awell-progress-bar-width': "".concat(percentageCompletedNormalized + '%') };

      return jsxRuntime.exports.jsx("div", __assign({ className: "".concat(classes$j.progressBar, " awell_progress_bar"), id: "awell__form_progress" }, { children: percentageCompletedNormalized !== 0 && jsxRuntime.exports.jsx("div", __assign({ className: classes$j.progressBar_completed, style: style }, { children: showPercentage && jsxRuntime.exports.jsxs("span", __assign({ id: "awell_progress_percentage" }, { children: [percentageCompletedNormalized, "%"] })) })) }));
    };

    var classes$i = {"input_wrapper":"awell__radioButton_input_wrapper","radio_wrapper":"awell__radioButton_radio_wrapper","label_wrapper":"awell__radioButton_label_wrapper"};

    var RadioButton = function (_a) {
      var onChange = _a.onChange,label = _a.label,name = _a.name,customWrapperClass = _a.customWrapperClass,props = __rest(_a, ["onChange", "label", "name", "customWrapperClass"]);
      return jsxRuntime.exports.jsxs("div", __assign({ className: "".concat(classes$i.input_wrapper, " ").concat(customWrapperClass) }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: classes$i.radio_wrapper }, { children: jsxRuntime.exports.jsx("input", __assign({}, props, { name: name, type: "radio", onChange: onChange })) })), jsxRuntime.exports.jsx("div", __assign({ className: classes$i.label_wrapper }, { children: jsxRuntime.exports.jsx("label", __assign({ htmlFor: props.id }, { children: label })) }))] }));
    };

    var classes$h = {"awell_range_input_wrapper":"awell__rangeInput_awell_range_input_wrapper","with_tooltip":"awell__rangeInput_with_tooltip","with_marks":"awell__rangeInput_with_marks","awell_range_input_datalist":"awell__rangeInput_awell_range_input_datalist","with_min_max_labels":"awell__rangeInput_with_min_max_labels","minLabel":"awell__rangeInput_minLabel","maxLabel":"awell__rangeInput_maxLabel","awell_range_input":"awell__rangeInput_awell_range_input","awell_range_input_labels":"awell__rangeInput_awell_range_input_labels","tooltip":"awell__rangeInput_tooltip"};

    var RangeInput = function (_a) {
      var label = _a.label,onChange = _a.onChange,id = _a.id,sliderConfig = _a.sliderConfig,mandatory = _a.mandatory,props = __rest(_a, ["label", "onChange", "id", "sliderConfig", "mandatory"]);
      var style = {
        '--awell-step': sliderConfig.step_value,
        '--awell-min': sliderConfig.min,
        '--awell-max': sliderConfig.max,
        '--awell-min-max-value': sliderConfig.show_min_max_values ?
        'counter(x)' :
        '',
        '--awell-thick-color': sliderConfig.display_marks ?
        'var(--awell-neutralLight50)' :
        'transparent',
        position: 'relative' };

      var hasInitialValue = props.value !== undefined;
      var _b = React__default["default"].useState(hasInitialValue ? props.value : ''),internalValue = _b[0],setInternalValue = _b[1];
      var _c = React__default["default"].useState(hasInitialValue),touched = _c[0],setTouched = _c[1];
      var _d = React__default["default"].useState({
        left: 0,
        top: 0 }),
      tooltipPosition = _d[0],setTooltipPosition = _d[1];
      var tooltipRef = React__default["default"].useRef(null);
      var renderValueTooltip = function (value, left, top, touched) {
        if (touched === void 0) {touched = false;}
        return jsxRuntime.exports.jsx("div", __assign({ ref: tooltipRef, id: "awell__slider_tooltip", className: classes$h.tooltip, style: { left: left, top: top, display: touched ? 'block' : 'none' } }, { children: value }));
      };
      var handleValueChange = function (event) {
        setTouched(true);
        setInternalValue(event.target.value);
        onChange(event);
      };
      React__default["default"].useEffect(function () {
        var MIDPOINT_PERECENTAGE = 0.5;
        var THUMB_WIDTH = 16;
        var TOP_POSITION_ADJUSTMENT = -28;
        if (touched === true &&
        sliderConfig.is_value_tooltip_on &&
        tooltipRef.current) {
          var input = tooltipRef.current.closest(".".concat(classes$h.awell_range_input_wrapper));
          if (input) {
            var inputWidth = input.clientWidth;
            var range = sliderConfig.max - sliderConfig.min;
            var percentage = (parseInt(internalValue) - sliderConfig.min) / range;
            var thumbPosition = (isNaN(percentage) ? MIDPOINT_PERECENTAGE : percentage) * (
            inputWidth - THUMB_WIDTH);
            var tooltipLeft = thumbPosition + THUMB_WIDTH / 2;
            var tooltipTop = TOP_POSITION_ADJUSTMENT;
            setTooltipPosition({
              left: tooltipLeft,
              top: tooltipTop });

          }
        }
      }, [
      internalValue,
      sliderConfig.is_value_tooltip_on,
      sliderConfig.max,
      sliderConfig.min,
      touched]);

      return jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(QuestionLabel, { htmlFor: id, label: label, mandatory: mandatory, id: "".concat(id, "-label") }), jsxRuntime.exports.jsxs("div", __assign({ className: "".concat(classes$h.awell_range_input_wrapper, " ").concat(sliderConfig.display_marks ? classes$h.with_marks : '', " ").concat(sliderConfig.is_value_tooltip_on ? classes$h.with_tooltip : ''), style: style }, { children: [jsxRuntime.exports.jsx("input", __assign({}, props, { "data-testid": id, type: "range", id: "awell__slider_input", min: sliderConfig.min, max: sliderConfig.max, step: sliderConfig.step_value, className: classes$h.awell_range_input, onChange: handleValueChange, onFocus: function () {return setTouched(true);}, "aria-valuemin": sliderConfig.min, "aria-valuemax": sliderConfig.max, "aria-valuenow": props.value || sliderConfig.min, "aria-labelledby": "".concat(id, "-label") })), jsxRuntime.exports.jsxs("div", __assign({ className: "".concat(classes$h.awell_range_input_datalist, " ").concat(sliderConfig.show_min_max_values ? classes$h.with_min_max_labels : ''), "data-testid": "".concat(id, "-datalist") }, { children: [jsxRuntime.exports.jsx("span", __assign({ className: classes$h.minLabel, "aria-label": "Minimum value" }, { children: sliderConfig.min_label })), jsxRuntime.exports.jsx("span", __assign({ className: classes$h.maxLabel, "aria-label": "Maximum value" }, { children: sliderConfig.max_label }))] })), sliderConfig.is_value_tooltip_on &&
          renderValueTooltip(internalValue, tooltipPosition.left, tooltipPosition.top, touched)] }))] });
    };

    var classes$g = {"scroll_indicator_container":"awell__ScrollIndicator_scroll_indicator_container","scroll_indicator_svg":"awell__ScrollIndicator_scroll_indicator_svg"};

    var ScrollIndicator = function () {
      return jsxRuntime.exports.jsx("div", __assign({ className: classes$g.scroll_indicator_container }, { children: jsxRuntime.exports.jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: classes$g.scroll_indicator_svg }, { children: jsxRuntime.exports.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75" }) })) }));
    };

    var classes$f = {"select_wrapper":"awell__select_select_wrapper","select_input_wrapper":"awell__select_select_input_wrapper","select_input":"awell__select_select_input","pointer":"awell__select_pointer","dropdown":"awell__select_dropdown","dropdown_open":"awell__select_dropdown_open","dropdown_scroll":"awell__select_dropdown_scroll","option":"awell__select_option","checkbox":"awell__select_checkbox","no_options":"awell__select_no_options","error":"awell__select_error","badge":"awell__select_badge","chevron":"awell__select_chevron","open":"awell__select_open"};

    var truncateLabel = function (label, maxLength) {
      if (maxLength === void 0) {maxLength = 15;}
      if (maxLength === null) {
        return label;
      }
      if (label.length > maxLength) {
        return "".concat(label.slice(0, maxLength), "...");
      }
      return label;
    };
    var Select = function (_a) {
      var _b;
      var onChange = _a.onChange,id = _a.id,labels = _a.labels,type = _a.type,mandatory = _a.mandatory,options = _a.options,_c = _a.optionsShown,optionsShown = _c === void 0 ? 4 : _c,_d = _a.showCount,showCount = _d === void 0 ? false : _d,_e = _a.displayMaxLength,displayMaxLength = _e === void 0 ? 15 : _e,value = _a.value,_f = _a.filtering,filtering = _f === void 0 ? false : _f,props = __rest(_a, ["onChange", "id", "labels", "type", "mandatory", "options", "optionsShown", "showCount", "displayMaxLength", "value", "filtering"]);
      var _g = React.useState(false),isOpen = _g[0],setIsOpen = _g[1];
      var _h = React.useState(options),filteredOptions = _h[0],setFilteredOptions = _h[1];
      var _j = React.useState(''),searchValue = _j[0],setSearchValue = _j[1];
      var getInitialValue = function () {
        var _a;
        if (value === undefined) {
          return [];
        }
        if (type === 'multiple') {
          return value;
        }
        if (type === 'single') {
          return [
          (_a = options.find(function (option) {return value === option.value;})) !== null && _a !== void 0 ? _a : undefined].
          filter(function (option) {return option !== undefined;});
        }
        return [];
      };
      var _k = React.useState(getInitialValue()),selected = _k[0],setSelected = _k[1];
      var selectWrapperRef = React.useRef(null);
      var handleInputChange = function (event) {
        var inputText = event.target.value.toLowerCase();
        if (inputText === '') {
          setSearchValue('');
          setFilteredOptions(options);
          return;
        }
        setSearchValue(inputText);
        var updatedFilteredOptions = options.filter(function (option) {
          return option.label.toLowerCase().includes(inputText);
        });
        setFilteredOptions(updatedFilteredOptions);
      };
      var handleClickOutside = React.useCallback(function (event) {
        if (selectWrapperRef.current &&
        !selectWrapperRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      }, [selectWrapperRef]);
      React.useEffect(function () {
        if (isOpen) {
          document.addEventListener('mousedown', handleClickOutside);
        } else
        {
          document.removeEventListener('mousedown', handleClickOutside);
        }
        return function () {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [isOpen, handleClickOutside]);
      var toggleDropdown = React.useCallback(function () {
        setIsOpen(!isOpen);
      }, [isOpen]);
      var handleSelect = React.useCallback(function (event, option) {
        if (type === 'single') {
          setSelected([option]);
          onChange(option.value);
          setIsOpen(false);
        } else
        {
          event.stopPropagation();
          var isSelected = selected.some(function (item) {return item.value === option.value;});
          var updatedSelected = void 0;
          if (isSelected) {
            updatedSelected = selected.
            filter(function (item) {return item.value !== option.value;}).
            sort(function (a, b) {return a.value - b.value;});
          } else
          {
            updatedSelected = __spreadArray(__spreadArray([], selected, true), [option], false).sort(function (a, b) {return a.value - b.value;});
          }
          setSelected(updatedSelected);
          onChange(updatedSelected);
        }
      }, [selected, type, onChange]);
      var getDisplayValue = function () {
        var _a, _b;
        if (isOpen) {
          return searchValue;
        }
        if (type === 'single') {
          return (_b = (_a = selected[0]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '';
        }
        if (type === 'multiple') {
          return selected.length > 0 ?
          selected.
          map(function (option) {return truncateLabel(option.label, displayMaxLength);}).
          join(', ') :
          '';
        }
        return '';
      };
      var handleKeyDownOnOption = React.useCallback(function (event, option) {
        if (event.code === 'Space') {
          event.preventDefault();
          handleSelect(event, option);
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          var index = filteredOptions.findIndex(function (item) {return item.value === option.value;});
          if (index > 0) {
            var previousOption = filteredOptions[index - 1];
            var previousOptionElement = document.getElementById("option-".concat(previousOption.value));
            if (previousOptionElement) {
              previousOptionElement.focus();
            }
          }
        }
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          var index = filteredOptions.findIndex(function (item) {return item.value === option.value;});
          if (index < filteredOptions.length - 1) {
            var nextOption = filteredOptions[index + 1];
            var nextOptionElement = document.getElementById("option-".concat(nextOption.value));
            if (nextOptionElement) {
              nextOptionElement.focus();
            }
          }
        }
      }, [filteredOptions, handleSelect]);
      var handleKeyUpOnOption = React.useCallback(function (event, option) {
        if (event.key === 'Enter') {
          handleSelect(event, option);
        }
        if (event.key === 'Escape') {
          setIsOpen(false);
        }
      }, [handleSelect]);
      var handleKeyUpOnInput = React.useCallback(function (event) {
        if (event.key === 'Enter') {
          toggleDropdown();
        }
        if (event.key === 'Escape') {
          setIsOpen(false);
        }
      }, [toggleDropdown]);
      var handleResetSearch = React.useCallback(function () {
        setSearchValue('');
        setFilteredOptions(options);
      }, [options]);
      return jsxRuntime.exports.jsxs("div", __assign({ className: classes$f.select_wrapper, ref: selectWrapperRef }, { children: [(labels === null || labels === void 0 ? void 0 : labels.questionLabel) !== undefined && jsxRuntime.exports.jsx(QuestionLabel, { htmlFor: id, label: labels.questionLabel, mandatory: mandatory }), jsxRuntime.exports.jsxs("div", __assign({ className: classes$f.select_input_wrapper, onClick: toggleDropdown }, { children: [jsxRuntime.exports.jsx("input", __assign({}, props, { type: "text", id: id, value: getDisplayValue(), placeholder: filtering ? (_b = labels === null || labels === void 0 ? void 0 : labels.searchPlaceholder) !== null && _b !== void 0 ? _b : '' : '', className: "".concat(classes$f.select_input, " ").concat(filtering ? '' : classes$f.pointer), "data-testid": "input-".concat(id), onChange: filtering ? handleInputChange : function () {return null;}, onClick: filtering ? handleResetSearch : function () {return null;}, readOnly: !filtering, onKeyUp: handleKeyUpOnInput, dir: "ltr" })), type === 'multiple' && selected.length > 0 && showCount && jsxRuntime.exports.jsx("div", __assign({ className: classes$f.badge }, { children: selected.length })), jsxRuntime.exports.jsx("div", { className: "".concat(classes$f.chevron, " ").concat(isOpen ? "".concat(classes$f.open) : '') }), jsxRuntime.exports.jsxs("div", __assign({ className: "".concat(isOpen ? classes$f.dropdown_open : classes$f.dropdown, " ").concat(options.length > optionsShown ? classes$f.dropdown_scroll : ''), style: { maxHeight: "".concat(optionsShown * 50, "px") }, role: "listbox" }, { children: [filteredOptions.length === 0 && jsxRuntime.exports.jsx("div", __assign({ className: classes$f.no_options }, { children: "No options found" })), filteredOptions.map(function (option) {return jsxRuntime.exports.jsxs("div", __assign({ className: classes$f.option, id: "option-".concat(option.value), onClick: function (event) {return handleSelect(event, option);}, onKeyUp: function (e) {return handleKeyUpOnOption(e, option);}, onKeyDown: function (e) {return handleKeyDownOnOption(e, option);}, role: "button", tabIndex: 0 }, { children: [option.label, type === 'multiple' && jsxRuntime.exports.jsx("div", __assign({ className: classes$f.checkbox }, { children: jsxRuntime.exports.jsx("input", { type: "checkbox", id: "checkbox-".concat(option.value), checked: selected === null || selected === void 0 ? void 0 : selected.some(function (item) {return item.value === option.value;}), readOnly: true, tabIndex: -1 }) }))] }), option.value);})] }))] })), (labels === null || labels === void 0 ? void 0 : labels.customError) && jsxRuntime.exports.jsx("div", __assign({ className: classes$f.error }, { children: labels.customError }))] }));
    };

    var getHexColorFromString = function (string) {
      var regularExpression = /#(?:[0-9a-fA-F]{3}){1,2}/g;
      var extractedHexCodes = string.match(regularExpression);
      return (extractedHexCodes === null || extractedHexCodes === void 0 ? void 0 : extractedHexCodes[0]) || '';
    };
    var getTextColor = function (colorString) {
      var hexColor = getHexColorFromString(colorString);
      var r = parseInt(hexColor.substring(1, 3), 16);
      var g = parseInt(hexColor.substring(3, 5), 16);
      var b = parseInt(hexColor.substring(5, 7), 16);
      var yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq >= 128 ? '#444' : '#fff';
    };
    var opacityColor = function (colorString, opacity) {
      var hexColor = getHexColorFromString(colorString);
      var R = parseInt(hexColor.substring(1, 3), 16);
      var G = parseInt(hexColor.substring(3, 5), 16);
      var B = parseInt(hexColor.substring(5, 7), 16);
      return "rgba(".concat(R, ", ").concat(G, ", ").concat(B, ", ").concat(opacity, ")");
    };

    var classes$e = {"awell_themeProvider":"awell__themeProvider_awell_themeProvider","bold":"awell__themeProvider_bold","strikethrough":"awell__themeProvider_strikethrough","underline":"awell__themeProvider_underline","italic":"awell__themeProvider_italic"};

    var ThemeProvider = function (_a) {
      var children = _a.children,_b = _a.accentColor,accentColor = _b === void 0 ? 'var(--awell-brand100, #004ac2)' : _b;
      var style = {
        '--awell-accent-color': accentColor,
        '--awell-accent-text-color': getTextColor(accentColor),
        '--awell-accent-hover-color': opacityColor(accentColor, 0.9),
        '--awell-accent-ring-color-inputs': accentColor,
        '--awell-accent-ring-color-buttons': opacityColor(accentColor, 0.4),
        '--awell-secondary-color': opacityColor(accentColor, 0.2),
        '--awell-secondary-text-color': accentColor,
        '--awell-secondary-hover-color': opacityColor(accentColor, 0.3),
        '--awell-secondary-ring-color-inputs': accentColor,
        '--awell-secondary-ring-color-buttons': accentColor,
        height: '100%' };

      return jsxRuntime.exports.jsx("div", __assign({ className: classes$e.awell_themeProvider, style: style }, { children: children }));
    };

    var classes$d = {"caret":"awell__typingCaret_caret"};

    var TypingCaret = function () {
      return jsxRuntime.exports.jsx("span", { "data-selector": "typingCarret", className: classes$d.caret });
    };
    var WithTypingCaret = function (_a) {
      var Component = _a.Component,children = _a.children,rest = __rest(_a, ["Component", "children"]);
      if (Component === 'code' && (rest === null || rest === void 0 ? void 0 : rest.inline)) {
        rest = __assign(__assign({}, rest), { inline: 'true' });
      }
      return jsxRuntime.exports.jsxs(Component, __assign({}, rest, { className: "markdown-node" }, { children: [children, jsxRuntime.exports.jsx(TypingCaret, {})] }));
    };

    var classes$c = {"awell_multiple_choice_question":"awell__multipleChoiceQuestion_awell_multiple_choice_question"};

    var MultipleChoiceQuestion = function (_a) {
      var questionId = _a.questionId,label = _a.label,_b = _a.options,options = _b === void 0 ? [] : _b,onChange = _a.onChange,_c = _a.values,values = _c === void 0 ? [] : _c,mandatory = _a.mandatory;
      var _d = React.useState(values),checkedOptions = _d[0],setCheckedOptions = _d[1];
      React.useEffect(function () {
        onChange(checkedOptions);
      }, [checkedOptions]);
      var handleSelectOption = function (event, option) {
        var newCheckedOptions = [];
        if (event.target.checked) {
          newCheckedOptions = __spreadArray(__spreadArray([], checkedOptions, true), [option], false);
        } else
        {
          newCheckedOptions = checkedOptions.filter(function (opt) {return option.id !== opt.id;});
        }
        setCheckedOptions(newCheckedOptions);
      };
      return jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(QuestionLabel, { label: label, mandatory: mandatory }), jsxRuntime.exports.jsx("fieldset", __assign({ className: classes$c.awell_multiple_choice_question }, { children: options.map(function (option) {return jsxRuntime.exports.jsx(CheckboxButton, { onChange: function (event) {return handleSelectOption(event, option);}, label: option.label, id: option.id, checked: checkedOptions.map(function (c) {return c.value;}).includes(option.value), name: questionId }, option.id);}) }))] });
    };

    var classes$b = {"awell_navbar":"awell__navbar_awell_navbar","awell_navbar_keyboard_open":"awell__navbar_awell_navbar_keyboard_open"};

    var Navbar = function (_a) {
      var companyName = _a.companyName,logo = _a.logo;
      var _b = React__default["default"].useState(window.innerWidth),innerHeight = _b[0],setInnerHeight = _b[1];
      var originalHeight = React.useRef(window.innerHeight);
      var isHeightReduced = innerHeight < originalHeight.current * 0.8;
      React__default["default"].useEffect(function () {
        var handleResize = function () {
          if (window.innerHeight === innerHeight)
          return;
          setInnerHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        return function () {return window.removeEventListener('resize', handleResize);};
      }, []);
      return jsxRuntime.exports.jsx("div", __assign({ className: "".concat(classes$b.awell_navbar, " ").concat(isHeightReduced ? classes$b.awell_navbar_keyboard_open : '') }, { children: isHeightReduced ? jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {}) : jsxRuntime.exports.jsx(Logo, { logo: logo, companyName: companyName }) }));
    };

    var isCheckBoxInput = (element) => element.type === 'checkbox';

    var isDateObject = (value) => value instanceof Date;

    var isNullOrUndefined = (value) => value == null;

    const isObjectType = (value) => typeof value === 'object';
    var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

    var getEventValue = (event) => isObject(event) && event.target ?
    isCheckBoxInput(event.target) ?
    event.target.checked :
    event.target.value :
    event;

    var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

    var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

    var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

    var isUndefined = (val) => val === undefined;

    var get = (obj, path, defaultValue) => {
      if (!path || !isObject(obj)) {
        return defaultValue;
      }
      const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
      return isUndefined(result) || result === obj ?
      isUndefined(obj[path]) ?
      defaultValue :
      obj[path] :
      result;
    };

    const EVENTS = {
      BLUR: 'blur',
      FOCUS_OUT: 'focusout',
      CHANGE: 'change' };

    const VALIDATION_MODE = {
      onBlur: 'onBlur',
      onChange: 'onChange',
      onSubmit: 'onSubmit',
      onTouched: 'onTouched',
      all: 'all' };

    const INPUT_VALIDATION_RULES = {
      max: 'max',
      min: 'min',
      maxLength: 'maxLength',
      minLength: 'minLength',
      pattern: 'pattern',
      required: 'required',
      validate: 'validate' };


    const HookFormContext = /*#__PURE__*/React__default["default"].createContext(null);
    /**
     * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
     *
     * @remarks
     * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
     *
     * @returns return all useForm methods
     *
     * @example
     * ```tsx
     * function App() {
     *   const methods = useForm();
     *   const onSubmit = data => console.log(data);
     *
     *   return (
     *     <FormProvider {...methods} >
     *       <form onSubmit={methods.handleSubmit(onSubmit)}>
     *         <NestedInput />
     *         <input type="submit" />
     *       </form>
     *     </FormProvider>
     *   );
     * }
     *
     *  function NestedInput() {
     *   const { register } = useFormContext(); // retrieve all hook methods
     *   return <input {...register("test")} />;
     * }
     * ```
     */
    const useFormContext = () => React__default["default"].useContext(HookFormContext);

    var getProxyFormState = (formState, _proxyFormState, localProxyFormState, isRoot = true) => {
      const result = {};
      for (const key in formState) {
        Object.defineProperty(result, key, {
          get: () => {
            const _key = key;
            if (_proxyFormState[_key] !== VALIDATION_MODE.all) {
              _proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
            }
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
          } });

      }
      return result;
    };

    var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

    var shouldRenderFormState = (formStateData, _proxyFormState, isRoot) => {
      const { name, ...formState } = formStateData;
      return isEmptyObject(formState) ||
      Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
      Object.keys(formState).find((key) => _proxyFormState[key] === (
      !isRoot || VALIDATION_MODE.all));
    };

    var convertToArrayPayload = (value) => Array.isArray(value) ? value : [value];

    var shouldSubscribeByName = (name, signalName, exact) => exact && signalName ?
    name === signalName :
    !name ||
    !signalName ||
    name === signalName ||
    convertToArrayPayload(name).some((currentName) => currentName && (
    currentName.startsWith(signalName) ||
    signalName.startsWith(currentName)));

    function useSubscribe(props) {
      const _props = React__default["default"].useRef(props);
      _props.current = props;
      React__default["default"].useEffect(() => {
        const tearDown = (subscription) => {
          if (subscription) {
            subscription.unsubscribe();
          }
        };
        const subscription = !props.disabled &&
        _props.current.subject.subscribe({
          next: _props.current.callback });

        return () => tearDown(subscription);
      }, [props.disabled]);
    }

    /**
     * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
     *
     * @remarks
     * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
     *
     * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
     *
     * @example
     * ```tsx
     * function App() {
     *   const { register, handleSubmit, control } = useForm({
     *     defaultValues: {
     *     firstName: "firstName"
     *   }});
     *   const { dirtyFields } = useFormState({
     *     control
     *   });
     *   const onSubmit = (data) => console.log(data);
     *
     *   return (
     *     <form onSubmit={handleSubmit(onSubmit)}>
     *       <input {...register("firstName")} placeholder="First Name" />
     *       {dirtyFields.firstName && <p>Field is dirty.</p>}
     *       <input type="submit" />
     *     </form>
     *   );
     * }
     * ```
     */
    function useFormState(props) {
      const methods = useFormContext();
      const { control = methods.control, disabled, name, exact } = props || {};
      const [formState, updateFormState] = React__default["default"].useState(control._formState);
      const _localProxyFormState = React__default["default"].useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false });

      const _name = React__default["default"].useRef(name);
      const _mounted = React__default["default"].useRef(true);
      _name.current = name;
      const callback = React__default["default"].useCallback((value) => _mounted.current &&
      shouldSubscribeByName(_name.current, value.name, exact) &&
      shouldRenderFormState(value, _localProxyFormState.current) &&
      updateFormState({
        ...control._formState,
        ...value }),
      [control, exact]);
      useSubscribe({
        disabled,
        callback,
        subject: control._subjects.state });

      React__default["default"].useEffect(() => {
        _mounted.current = true;
        return () => {
          _mounted.current = false;
        };
      }, []);
      return getProxyFormState(formState, control._proxyFormState, _localProxyFormState.current, false);
    }

    var isString = (value) => typeof value === 'string';

    var generateWatchOutput = (names, _names, formValues, isGlobal) => {
      const isArray = Array.isArray(names);
      if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names);
      }
      if (isArray) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName),
        get(formValues, fieldName)));
      }
      isGlobal && (_names.watchAll = true);
      return formValues;
    };

    var isFunction = (value) => typeof value === 'function';

    var objectHasFunction = (data) => {
      for (const key in data) {
        if (isFunction(data[key])) {
          return true;
        }
      }
      return false;
    };

    /**
     * Custom hook to subscribe to field change and isolate re-rendering at the component level.
     *
     * @remarks
     *
     * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
     *
     * @example
     * ```tsx
     * const { watch } = useForm();
     * const values = useWatch({
     *   name: "fieldName"
     *   control,
     * })
     * ```
     */
    function useWatch(props) {
      const methods = useFormContext();
      const { control = methods.control, name, defaultValue, disabled, exact } = props || {};
      const _name = React__default["default"].useRef(name);
      _name.current = name;
      const callback = React__default["default"].useCallback((formState) => {
        if (shouldSubscribeByName(_name.current, formState.name, exact)) {
          const fieldValues = generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
          updateValue(isUndefined(_name.current) ||
          isObject(fieldValues) && !objectHasFunction(fieldValues) ?
          { ...fieldValues } :
          Array.isArray(fieldValues) ?
          [...fieldValues] :
          isUndefined(fieldValues) ?
          defaultValue :
          fieldValues);
        }
      }, [control, exact, defaultValue]);
      useSubscribe({
        disabled,
        subject: control._subjects.watch,
        callback });

      const [value, updateValue] = React__default["default"].useState(isUndefined(defaultValue) ?
      control._getWatch(name) :
      defaultValue);
      React__default["default"].useEffect(() => {
        control._removeUnmounted();
      });
      return value;
    }

    /**
     * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
     *
     * @remarks
     * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
     *
     * @param props - the path name to the form field value, and validation rules.
     *
     * @returns field properties, field and form state. {@link UseControllerReturn}
     *
     * @example
     * ```tsx
     * function Input(props) {
     *   const { field, fieldState, formState } = useController(props);
     *   return (
     *     <div>
     *       <input {...field} placeholder={props.name} />
     *       <p>{fieldState.isTouched && "Touched"}</p>
     *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
     *     </div>
     *   );
     * }
     * ```
     */
    function useController(props) {
      const methods = useFormContext();
      const { name, control = methods.control, shouldUnregister } = props;
      const isArrayField = isNameInFieldArray(control._names.array, name);
      const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true });

      const formState = useFormState({
        control,
        name });

      const _registerProps = React__default["default"].useRef(control.register(name, {
        ...props.rules,
        value }));

      React__default["default"].useEffect(() => {
        const updateMounted = (name, value) => {
          const field = get(control._fields, name);
          if (field) {
            field._f.mount = value;
          }
        };
        updateMounted(name, true);
        return () => {
          const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
          (isArrayField ?
          _shouldUnregisterField && !control._stateFlags.action :
          _shouldUnregisterField) ?
          control.unregister(name) :
          updateMounted(name, false);
        };
      }, [name, control, isArrayField, shouldUnregister]);
      return {
        field: {
          name,
          value,
          onChange: React__default["default"].useCallback((event) => {
            _registerProps.current.onChange({
              target: {
                value: getEventValue(event),
                name: name },

              type: EVENTS.CHANGE });

          }, [name]),
          onBlur: React__default["default"].useCallback(() => {
            _registerProps.current.onBlur({
              target: {
                value: get(control._formValues, name),
                name: name },

              type: EVENTS.BLUR });

          }, [name, control]),
          ref: React__default["default"].useCallback((elm) => {
            const field = get(control._fields, name);
            if (elm && field && elm.focus) {
              field._f.ref = {
                focus: () => elm.focus(),
                select: () => elm.select(),
                setCustomValidity: (message) => elm.setCustomValidity(message),
                reportValidity: () => elm.reportValidity() };

            }
          }, [name, control._fields]) },

        formState,
        fieldState: Object.defineProperties({}, {
          invalid: {
            get: () => !!get(formState.errors, name) },

          isDirty: {
            get: () => !!get(formState.dirtyFields, name) },

          isTouched: {
            get: () => !!get(formState.touchedFields, name) },

          error: {
            get: () => get(formState.errors, name) } }) };



    }

    /**
     * Component based on `useController` hook to work with controlled component.
     *
     * @remarks
     * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
     *
     * @param props - the path name to the form field value, and validation rules.
     *
     * @returns provide field handler functions, field and form state.
     *
     * @example
     * ```tsx
     * function App() {
     *   const { control } = useForm<FormValues>({
     *     defaultValues: {
     *       test: ""
     *     }
     *   });
     *
     *   return (
     *     <form>
     *       <Controller
     *         control={control}
     *         name="test"
     *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
     *           <>
     *             <input
     *               onChange={onChange} // send value to hook form
     *               onBlur={onBlur} // notify when input is touched
     *               value={value} // return updated value
     *               ref={ref} // set ref for focus management
     *             />
     *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
     *             <p>{fieldState.isTouched ? "touched" : ""}</p>
     *           </>
     *         )}
     *       />
     *     </form>
     *   );
     * }
     * ```
     */
    const Controller = (props) => props.render(useController(props));

    var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria ?
    {
      ...errors[name],
      types: {
        ...(errors[name] && errors[name].types ? errors[name].types : {}),
        [type]: message || true } } :


    {};

    var isKey = (value) => /^\w*$/.test(value);

    var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

    function set(object, path, value) {
      let index = -1;
      const tempPath = isKey(path) ? [path] : stringToPath(path);
      const length = tempPath.length;
      const lastIndex = length - 1;
      while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
          const objValue = object[key];
          newValue =
          isObject(objValue) || Array.isArray(objValue) ?
          objValue :
          !isNaN(+tempPath[index + 1]) ?
          [] :
          {};
        }
        object[key] = newValue;
        object = object[key];
      }
      return object;
    }

    const focusFieldBy = (fields, callback, fieldsNames) => {
      for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
          const { _f, ...currentField } = field;
          if (_f && callback(_f.name)) {
            if (_f.ref.focus && isUndefined(_f.ref.focus())) {
              break;
            } else
            if (_f.refs) {
              _f.refs[0].focus();
              break;
            }
          } else
          if (isObject(currentField)) {
            focusFieldBy(currentField, callback);
          }
        }
      }
    };

    var isWatched = (name, _names, isBlurEvent) => !isBlurEvent && (
    _names.watchAll ||
    _names.watch.has(name) ||
    [..._names.watch].some((watchName) => name.startsWith(watchName) &&
    /^\.\w+/.test(name.slice(watchName.length))));

    var updateFieldArrayRootError = (errors, error, name) => {
      const fieldArrayErrors = compact(get(errors, name));
      set(fieldArrayErrors, 'root', error[name]);
      set(errors, name, fieldArrayErrors);
      return errors;
    };

    var isBoolean = (value) => typeof value === 'boolean';

    var isFileInput = (element) => element.type === 'file';

    var isMessage = (value) => isString(value) || /*#__PURE__*/React__default["default"].isValidElement(value);

    var isRadioInput = (element) => element.type === 'radio';

    var isRegex = (value) => value instanceof RegExp;

    const defaultResult = {
      value: false,
      isValid: false };

    const validResult = { value: true, isValid: true };
    var getCheckboxValue = (options) => {
      if (Array.isArray(options)) {
        if (options.length > 1) {
          const values = options.
          filter((option) => option && option.checked && !option.disabled).
          map((option) => option.value);
          return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled ?
        // @ts-expect-error expected to work in the browser
        options[0].attributes && !isUndefined(options[0].attributes.value) ?
        isUndefined(options[0].value) || options[0].value === '' ?
        validResult :
        { value: options[0].value, isValid: true } :
        validResult :
        defaultResult;
      }
      return defaultResult;
    };

    const defaultReturn = {
      isValid: false,
      value: null };

    var getRadioValue = (options) => Array.isArray(options) ?
    options.reduce((previous, option) => option && option.checked && !option.disabled ?
    {
      isValid: true,
      value: option.value } :

    previous, defaultReturn) :
    defaultReturn;

    function getValidateError(result, ref, type = 'validate') {
      if (isMessage(result) ||
      Array.isArray(result) && result.every(isMessage) ||
      isBoolean(result) && !result) {
        return {
          type,
          message: isMessage(result) ? result : '',
          ref };

      }
    }

    var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData) ?
    validationData :
    {
      value: validationData,
      message: '' };


    var validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
      const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled } = field._f;
      if (!mount || disabled) {
        return {};
      }
      const inputRef = refs ? refs[0] : ref;
      const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
          inputRef.setCustomValidity(isBoolean(message) ? '' : message || ' ');
          inputRef.reportValidity();
        }
      };
      const error = {};
      const isRadio = isRadioInput(ref);
      const isCheckBox = isCheckBoxInput(ref);
      const isRadioOrCheckbox = isRadio || isCheckBox;
      const isEmpty = (valueAsNumber || isFileInput(ref)) && !ref.value ||
      inputValue === '' ||
      Array.isArray(inputValue) && !inputValue.length;
      const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
      const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
          type: exceedMax ? maxType : minType,
          message,
          ref,
          ...appendErrorsCurry(exceedMax ? maxType : minType, message) };

      };
      if (isFieldArray ?
      !Array.isArray(inputValue) || !inputValue.length :
      required && (
      !isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue)) ||
      isBoolean(inputValue) && !inputValue ||
      isCheckBox && !getCheckboxValue(refs).isValid ||
      isRadio && !getRadioValue(refs).isValid)) {
        const { value, message } = isMessage(required) ?
        { value: !!required, message: required } :
        getValueAndMessage(required);
        if (value) {
          error[name] = {
            type: INPUT_VALIDATION_RULES.required,
            message,
            ref: inputRef,
            ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message) };

          if (!validateAllFieldCriteria) {
            setCustomValidity(message);
            return error;
          }
        }
      }
      if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
          const valueNumber = ref.valueAsNumber || +inputValue;
          if (!isNullOrUndefined(maxOutput.value)) {
            exceedMax = valueNumber > maxOutput.value;
          }
          if (!isNullOrUndefined(minOutput.value)) {
            exceedMin = valueNumber < minOutput.value;
          }
        } else
        {
          const valueDate = ref.valueAsDate || new Date(inputValue);
          if (isString(maxOutput.value)) {
            exceedMax = valueDate > new Date(maxOutput.value);
          }
          if (isString(minOutput.value)) {
            exceedMin = valueDate < new Date(minOutput.value);
          }
        }
        if (exceedMax || exceedMin) {
          getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
          if (!validateAllFieldCriteria) {
            setCustomValidity(error[name].message);
            return error;
          }
        }
      }
      if ((maxLength || minLength) &&
      !isEmpty && (
      isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
        inputValue.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
        inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
          getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
          if (!validateAllFieldCriteria) {
            setCustomValidity(error[name].message);
            return error;
          }
        }
      }
      if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
          error[name] = {
            type: INPUT_VALIDATION_RULES.pattern,
            message,
            ref,
            ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message) };

          if (!validateAllFieldCriteria) {
            setCustomValidity(message);
            return error;
          }
        }
      }
      if (validate) {
        if (isFunction(validate)) {
          const result = await validate(inputValue);
          const validateError = getValidateError(result, inputRef);
          if (validateError) {
            error[name] = {
              ...validateError,
              ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message) };

            if (!validateAllFieldCriteria) {
              setCustomValidity(validateError.message);
              return error;
            }
          }
        } else
        if (isObject(validate)) {
          let validationResult = {};
          for (const key in validate) {
            if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
              break;
            }
            const validateError = getValidateError(await validate[key](inputValue), inputRef, key);
            if (validateError) {
              validationResult = {
                ...validateError,
                ...appendErrorsCurry(key, validateError.message) };

              setCustomValidity(validateError.message);
              if (validateAllFieldCriteria) {
                error[name] = validationResult;
              }
            }
          }
          if (!isEmptyObject(validationResult)) {
            error[name] = {
              ref: inputRef,
              ...validationResult };

            if (!validateAllFieldCriteria) {
              return error;
            }
          }
        }
      }
      setCustomValidity(true);
      return error;
    };

    var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

    function cloneObject(data) {
      let copy;
      const isArray = Array.isArray(data);
      if (data instanceof Date) {
        copy = new Date(data);
      } else
      if (data instanceof Set) {
        copy = new Set(data);
      } else
      if (!(isWeb && (data instanceof Blob || data instanceof FileList)) && (
      isArray || isObject(data))) {
        copy = isArray ? [] : {};
        for (const key in data) {
          if (isFunction(data[key])) {
            copy = data;
            break;
          }
          copy[key] = cloneObject(data[key]);
        }
      } else
      {
        return data;
      }
      return copy;
    }

    var getValidationModes = (mode) => ({
      isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
      isOnBlur: mode === VALIDATION_MODE.onBlur,
      isOnChange: mode === VALIDATION_MODE.onChange,
      isOnAll: mode === VALIDATION_MODE.all,
      isOnTouch: mode === VALIDATION_MODE.onTouched });

    function baseGet(object, updatePath) {
      const length = updatePath.slice(0, -1).length;
      let index = 0;
      while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
      }
      return object;
    }
    function isEmptyArray(obj) {
      for (const key in obj) {
        if (!isUndefined(obj[key])) {
          return false;
        }
      }
      return true;
    }
    function unset(object, path) {
      const updatePath = isKey(path) ? [path] : stringToPath(path);
      const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
      const key = updatePath[updatePath.length - 1];
      let previousObjRef;
      if (childObject) {
        delete childObject[key];
      }
      for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
          previousObjRef = object;
        }
        while (++index < currentPaths.length) {
          const item = currentPaths[index];
          objectRef = objectRef ? objectRef[item] : object[item];
          if (currentPathsLength === index && (
          isObject(objectRef) && isEmptyObject(objectRef) ||
          Array.isArray(objectRef) && isEmptyArray(objectRef))) {
            previousObjRef ? delete previousObjRef[item] : delete object[item];
          }
          previousObjRef = objectRef;
        }
      }
      return object;
    }

    function createSubject() {
      let _observers = [];
      const next = (value) => {
        for (const observer of _observers) {
          observer.next(value);
        }
      };
      const subscribe = (observer) => {
        _observers.push(observer);
        return {
          unsubscribe: () => {
            _observers = _observers.filter((o) => o !== observer);
          } };

      };
      const unsubscribe = () => {
        _observers = [];
      };
      return {
        get observers() {
          return _observers;
        },
        next,
        subscribe,
        unsubscribe };

    }

    var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

    function deepEqual(object1, object2) {
      if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
      }
      if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
      }
      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);
      if (keys1.length !== keys2.length) {
        return false;
      }
      for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
          return false;
        }
        if (key !== 'ref') {
          const val2 = object2[key];
          if (isDateObject(val1) && isDateObject(val2) ||
          isObject(val1) && isObject(val2) ||
          Array.isArray(val1) && Array.isArray(val2) ?
          !deepEqual(val1, val2) :
          val1 !== val2) {
            return false;
          }
        }
      }
      return true;
    }

    var isHTMLElement = (value) => {
      const owner = value ? value.ownerDocument : 0;
      const ElementClass = owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement;
      return value instanceof ElementClass;
    };

    var isMultipleSelect = (element) => element.type === `select-multiple`;

    var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

    var live = (ref) => isHTMLElement(ref) && ref.isConnected;

    function markFieldsDirty(data, fields = {}) {
      const isParentNodeArray = Array.isArray(data);
      if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
          if (Array.isArray(data[key]) ||
          isObject(data[key]) && !objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            markFieldsDirty(data[key], fields[key]);
          } else
          if (!isNullOrUndefined(data[key])) {
            fields[key] = true;
          }
        }
      }
      return fields;
    }
    function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
      const isParentNodeArray = Array.isArray(data);
      if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
          if (Array.isArray(data[key]) ||
          isObject(data[key]) && !objectHasFunction(data[key])) {
            if (isUndefined(formValues) ||
            isPrimitive(dirtyFieldsFromValues[key])) {
              dirtyFieldsFromValues[key] = Array.isArray(data[key]) ?
              markFieldsDirty(data[key], []) :
              { ...markFieldsDirty(data[key]) };
            } else
            {
              getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
            }
          } else
          {
            dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
          }
        }
      }
      return dirtyFieldsFromValues;
    }
    var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

    var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value) ?
    value :
    valueAsNumber ?
    value === '' || isNullOrUndefined(value) ?
    NaN :
    +value :
    valueAsDate && isString(value) ?
    new Date(value) :
    setValueAs ?
    setValueAs(value) :
    value;

    function getFieldValue(_f) {
      const ref = _f.ref;
      if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
      }
      if (isFileInput(ref)) {
        return ref.files;
      }
      if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
      }
      if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
      }
      if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
      }
      return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
    }

    var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
      const fields = {};
      for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
      }
      return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation };

    };

    var getRuleValue = (rule) => isUndefined(rule) ?
    undefined :
    isRegex(rule) ?
    rule.source :
    isObject(rule) ?
    isRegex(rule.value) ?
    rule.value.source :
    rule.value :
    rule;

    var hasValidation = (options) => options.mount && (
    options.required ||
    options.min ||
    options.max ||
    options.maxLength ||
    options.minLength ||
    options.pattern ||
    options.validate);

    function schemaErrorLookup(errors, _fields, name) {
      const error = get(errors, name);
      if (error || isKey(name)) {
        return {
          error,
          name };

      }
      const names = name.split('.');
      while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
          return { name };
        }
        if (foundError && foundError.type) {
          return {
            name: fieldName,
            error: foundError };

        }
        names.pop();
      }
      return {
        name };

    }

    var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
      if (mode.isOnAll) {
        return false;
      } else
      if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
      } else
      if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
      } else
      if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
      }
      return true;
    };

    var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

    const defaultOptions = {
      mode: VALIDATION_MODE.onSubmit,
      reValidateMode: VALIDATION_MODE.onChange,
      shouldFocusError: true };

    function createFormControl(props = {}) {
      let _options = {
        ...defaultOptions,
        ...props };

      let _formState = {
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {} };

      let _fields = {};
      let _defaultValues = cloneObject(_options.defaultValues) || {};
      let _formValues = _options.shouldUnregister ?
      {} :
      cloneObject(_defaultValues);
      let _stateFlags = {
        action: false,
        mount: false,
        watch: false };

      let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set() };

      let delayErrorCallback;
      let timer = 0;
      let validateFields = {};
      const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false };

      const _subjects = {
        watch: createSubject(),
        array: createSubject(),
        state: createSubject() };

      const validationModeBeforeSubmit = getValidationModes(_options.mode);
      const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
      const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
      const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = window.setTimeout(callback, wait);
      };
      const _updateValid = async (shouldSkipRender) => {
        let isValid = false;
        if (_proxyFormState.isValid) {
          isValid = _options.resolver ?
          isEmptyObject((await _executeSchema()).errors) :
          await executeBuiltInValidation(_fields, true);
          if (!shouldSkipRender && isValid !== _formState.isValid) {
            _formState.isValid = isValid;
            _subjects.state.next({
              isValid });

          }
        }
        return isValid;
      };
      const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
          _stateFlags.action = true;
          if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
            const fieldValues = method(get(_fields, name), args.argA, args.argB);
            shouldSetValues && set(_fields, name, fieldValues);
          }
          if (_proxyFormState.errors &&
          shouldUpdateFieldsAndState &&
          Array.isArray(get(_formState.errors, name))) {
            const errors = method(get(_formState.errors, name), args.argA, args.argB);
            shouldSetValues && set(_formState.errors, name, errors);
            unsetEmptyArray(_formState.errors, name);
          }
          if (_proxyFormState.touchedFields &&
          shouldUpdateFieldsAndState &&
          Array.isArray(get(_formState.touchedFields, name))) {
            const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
            shouldSetValues && set(_formState.touchedFields, name, touchedFields);
          }
          if (_proxyFormState.dirtyFields) {
            _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
          }
          _subjects.state.next({
            isDirty: _getDirty(name, values),
            dirtyFields: _formState.dirtyFields,
            errors: _formState.errors,
            isValid: _formState.isValid });

        } else
        {
          set(_formValues, name, values);
        }
      };
      const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
          errors: _formState.errors });

      };
      const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
          const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
          isUndefined(defaultValue) ||
          ref && ref.defaultChecked ||
          shouldSkipSetValueAs ?
          set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) :
          setFieldValue(name, defaultValue);
          _stateFlags.mount && _updateValid();
        }
      };
      const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let isFieldDirty = false;
        const output = {
          name };

        const isPreviousFieldTouched = get(_formState.touchedFields, name);
        if (_proxyFormState.isDirty) {
          const isPreviousFormDirty = _formState.isDirty;
          _formState.isDirty = output.isDirty = _getDirty();
          isFieldDirty = isPreviousFormDirty !== output.isDirty;
        }
        if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
          const isPreviousFieldDirty = get(_formState.dirtyFields, name);
          const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
          isCurrentFieldPristine ?
          unset(_formState.dirtyFields, name) :
          set(_formState.dirtyFields, name, true);
          output.dirtyFields = _formState.dirtyFields;
          isFieldDirty =
          isFieldDirty ||
          isPreviousFieldDirty !== get(_formState.dirtyFields, name);
        }
        if (isBlurEvent && !isPreviousFieldTouched) {
          set(_formState.touchedFields, name, isBlurEvent);
          output.touchedFields = _formState.touchedFields;
          isFieldDirty =
          isFieldDirty ||
          _proxyFormState.touchedFields &&
          isPreviousFieldTouched !== isBlurEvent;
        }
        isFieldDirty && shouldRender && _subjects.state.next(output);
        return isFieldDirty ? output : {};
      };
      const shouldRenderByError = async (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid;
        if (props.delayError && error) {
          delayErrorCallback = debounce(() => updateErrors(name, error));
          delayErrorCallback(props.delayError);
        } else
        {
          clearTimeout(timer);
          delayErrorCallback = null;
          error ?
          set(_formState.errors, name, error) :
          unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
        !isEmptyObject(fieldState) ||
        shouldUpdateValid) {
          const updatedFormState = {
            ...fieldState,
            ...(shouldUpdateValid ? { isValid } : {}),
            errors: _formState.errors,
            name };

          _formState = {
            ..._formState,
            ...updatedFormState };

          _subjects.state.next(updatedFormState);
        }
        validateFields[name]--;
        if (_proxyFormState.isValidating &&
        !Object.values(validateFields).some((v) => v)) {
          _subjects.state.next({
            isValidating: false });

          validateFields = {};
        }
      };
      const _executeSchema = async (name) => _options.resolver ?
      await _options.resolver({ ..._formValues }, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation)) :
      {};
      const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema();
        if (names) {
          for (const name of names) {
            const error = get(errors, name);
            error ?
            set(_formState.errors, name, error) :
            unset(_formState.errors, name);
          }
        } else
        {
          _formState.errors = errors;
        }
        return errors;
      };
      const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true }) =>
      {
        for (const name in fields) {
          const field = fields[name];
          if (field) {
            const { _f, ...fieldValue } = field;
            if (_f) {
              const isFieldArrayRoot = _names.array.has(_f.name);
              const fieldError = await validateField(field, get(_formValues, _f.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation, isFieldArrayRoot);
              if (fieldError[_f.name]) {
                context.valid = false;
                if (shouldOnlyCheckValid) {
                  break;
                }
              }
              !shouldOnlyCheckValid && (
              get(fieldError, _f.name) ?
              isFieldArrayRoot ?
              updateFieldArrayRootError(_formState.errors, fieldError, _f.name) :
              set(_formState.errors, _f.name, fieldError[_f.name]) :
              unset(_formState.errors, _f.name));
            }
            fieldValue && (
            await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
          }
        }
        return context.valid;
      };
      const _removeUnmounted = () => {
        for (const name of _names.unMount) {
          const field = get(_fields, name);
          field && (
          field._f.refs ?
          field._f.refs.every((ref) => !live(ref)) :
          !live(field._f.ref)) &&
          unregister(name);
        }
        _names.unMount = new Set();
      };
      const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
      !deepEqual(getValues(), _defaultValues));
      const _getWatch = (names, defaultValue, isGlobal) => {
        const fieldValues = {
          ...(_stateFlags.mount ?
          _formValues :
          isUndefined(defaultValue) ?
          _defaultValues :
          isString(names) ?
          { [names]: defaultValue } :
          defaultValue) };

        return generateWatchOutput(names, _names, fieldValues, isGlobal);
      };
      const _getFieldArray = (name) => compact(get(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
      const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
          const fieldReference = field._f;
          if (fieldReference) {
            !fieldReference.disabled &&
            set(_formValues, name, getFieldValueAs(value, fieldReference));
            fieldValue =
            isWeb && isHTMLElement(fieldReference.ref) && isNullOrUndefined(value) ?
            '' :
            value;
            if (isMultipleSelect(fieldReference.ref)) {
              [...fieldReference.ref.options].forEach((selectRef) => selectRef.selected = fieldValue.includes(selectRef.value));
            } else
            if (fieldReference.refs) {
              if (isCheckBoxInput(fieldReference.ref)) {
                fieldReference.refs.length > 1 ?
                fieldReference.refs.forEach((checkboxRef) => !checkboxRef.disabled && (
                checkboxRef.checked = Array.isArray(fieldValue) ?
                !!fieldValue.find((data) => data === checkboxRef.value) :
                fieldValue === checkboxRef.value)) :
                fieldReference.refs[0] && (
                fieldReference.refs[0].checked = !!fieldValue);
              } else
              {
                fieldReference.refs.forEach((radioRef) => radioRef.checked = radioRef.value === fieldValue);
              }
            } else
            if (isFileInput(fieldReference.ref)) {
              fieldReference.ref.value = '';
            } else
            {
              fieldReference.ref.value = fieldValue;
              if (!fieldReference.ref.type) {
                _subjects.watch.next({
                  name });

              }
            }
          }
        }
        (options.shouldDirty || options.shouldTouch) &&
        updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
      };
      const setValues = (name, value, options) => {
        for (const fieldKey in value) {
          const fieldValue = value[fieldKey];
          const fieldName = `${name}.${fieldKey}`;
          const field = get(_fields, fieldName);
          (_names.array.has(name) ||
          !isPrimitive(fieldValue) ||
          field && !field._f) &&
          !isDateObject(fieldValue) ?
          setValues(fieldName, fieldValue, options) :
          setFieldValue(fieldName, fieldValue, options);
        }
      };
      const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
          _subjects.array.next({
            name,
            values: _formValues });

          if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
          options.shouldDirty) {
            _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
              name,
              dirtyFields: _formState.dirtyFields,
              isDirty: _getDirty(name, cloneValue) });

          }
        } else
        {
          field && !field._f && !isNullOrUndefined(cloneValue) ?
          setValues(name, cloneValue, options) :
          setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
          name });

      };
      const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        const field = get(_fields, name);
        if (field) {
          let error;
          let isValid;
          const fieldValue = target.type ?
          getFieldValue(field._f) :
          getEventValue(event);
          const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
          const shouldSkipValidation = !hasValidation(field._f) &&
          !_options.resolver &&
          !get(_formState.errors, name) &&
          !field._f.deps ||
          skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
          const watched = isWatched(name, _names, isBlurEvent);
          set(_formValues, name, fieldValue);
          if (isBlurEvent) {
            field._f.onBlur && field._f.onBlur(event);
            delayErrorCallback && delayErrorCallback(0);
          } else
          if (field._f.onChange) {
            field._f.onChange(event);
          }
          const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
          const shouldRender = !isEmptyObject(fieldState) || watched;
          !isBlurEvent &&
          _subjects.watch.next({
            name,
            type: event.type });

          if (shouldSkipValidation) {
            return shouldRender &&
            _subjects.state.next({ name, ...(watched ? {} : fieldState) });
          }
          !isBlurEvent && watched && _subjects.state.next({});
          validateFields[name] = validateFields[name] ? +1 : 1;
          _subjects.state.next({
            isValidating: true });

          if (_options.resolver) {
            const { errors } = await _executeSchema([name]);
            const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
            const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
            error = errorLookupResult.error;
            name = errorLookupResult.name;
            isValid = isEmptyObject(errors);
          } else
          {
            error = (await validateField(field, get(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
            isValid = await _updateValid(true);
          }
          field._f.deps &&
          trigger(field._f.deps);
          shouldRenderByError(name, isValid, error, fieldState);
        }
      };
      const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _subjects.state.next({
          isValidating: true });

        if (_options.resolver) {
          const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
          isValid = isEmptyObject(errors);
          validationResult = name ?
          !fieldNames.some((name) => get(errors, name)) :
          isValid;
        } else
        if (name) {
          validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
            const field = get(_fields, fieldName);
            return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
          }))).every(Boolean);
          !(!validationResult && !_formState.isValid) && _updateValid();
        } else
        {
          validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
          ...(!isString(name) ||
          _proxyFormState.isValid && isValid !== _formState.isValid ?
          {} :
          { name }),
          ...(_options.resolver ? { isValid } : {}),
          errors: _formState.errors,
          isValidating: false });

        options.shouldFocus &&
        !validationResult &&
        focusFieldBy(_fields, (key) => get(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
      };
      const getValues = (fieldNames) => {
        const values = {
          ..._defaultValues,
          ...(_stateFlags.mount ? _formValues : {}) };

        return isUndefined(fieldNames) ?
        values :
        isString(fieldNames) ?
        get(values, fieldNames) :
        fieldNames.map((name) => get(values, name));
      };
      const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name) });

      const clearErrors = (name) => {
        name ?
        convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName)) :
        _formState.errors = {};
        _subjects.state.next({
          errors: _formState.errors });

      };
      const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
          ...error,
          ref });

        _subjects.state.next({
          name,
          errors: _formState.errors,
          isValid: false });

        options && options.shouldFocus && ref && ref.focus && ref.focus();
      };
      const watch = (name, defaultValue) => isFunction(name) ?
      _subjects.watch.subscribe({
        next: (info) => name(_getWatch(undefined, defaultValue), info) }) :

      _getWatch(name, defaultValue, true);
      const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
          _names.mount.delete(fieldName);
          _names.array.delete(fieldName);
          if (get(_fields, fieldName)) {
            if (!options.keepValue) {
              unset(_fields, fieldName);
              unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister &&
            !options.keepDefaultValue &&
            unset(_defaultValues, fieldName);
          }
        }
        _subjects.watch.next({});
        _subjects.state.next({
          ..._formState,
          ...(!options.keepDirty ? {} : { isDirty: _getDirty() }) });

        !options.keepIsValid && _updateValid();
      };
      const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
          _f: {
            ...(field && field._f ? field._f : { ref: { name } }),
            name,
            mount: true,
            ...options } });


        _names.mount.add(name);
        field ?
        disabledIsDefined &&
        set(_formValues, name, options.disabled ?
        undefined :
        get(_formValues, name, getFieldValue(field._f))) :
        updateValidAndValue(name, true, options.value);
        return {
          ...(disabledIsDefined ? { disabled: options.disabled } : {}),
          ...(_options.shouldUseNativeValidation ?
          {
            required: !!options.required,
            min: getRuleValue(options.min),
            max: getRuleValue(options.max),
            minLength: getRuleValue(options.minLength),
            maxLength: getRuleValue(options.maxLength),
            pattern: getRuleValue(options.pattern) } :

          {}),
          name,
          onChange,
          onBlur: onChange,
          ref: (ref) => {
            if (ref) {
              register(name, options);
              field = get(_fields, name);
              const fieldRef = isUndefined(ref.value) ?
              ref.querySelectorAll ?
              ref.querySelectorAll('input,select,textarea')[0] || ref :
              ref :
              ref;
              const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
              const refs = field._f.refs || [];
              if (radioOrCheckbox ?
              refs.find((option) => option === fieldRef) :
              fieldRef === field._f.ref) {
                return;
              }
              set(_fields, name, {
                _f: {
                  ...field._f,
                  ...(radioOrCheckbox ?
                  {
                    refs: [
                    ...refs.filter(live),
                    fieldRef,
                    ...(!!Array.isArray(get(_defaultValues, name)) ?
                    [{}] :
                    [])],

                    ref: { type: fieldRef.type, name } } :

                  { ref: fieldRef }) } });


              updateValidAndValue(name, false, undefined, fieldRef);
            } else
            {
              field = get(_fields, name, {});
              if (field._f) {
                field._f.mount = false;
              }
              (_options.shouldUnregister || options.shouldUnregister) &&
              !(isNameInFieldArray(_names.array, name) && _stateFlags.action) &&
              _names.unMount.add(name);
            }
          } };

      };
      const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
          e.preventDefault && e.preventDefault();
          e.persist && e.persist();
        }
        let hasNoPromiseError = true;
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
          isSubmitting: true });

        try {
          if (_options.resolver) {
            const { errors, values } = await _executeSchema();
            _formState.errors = errors;
            fieldValues = values;
          } else
          {
            await executeBuiltInValidation(_fields);
          }
          if (isEmptyObject(_formState.errors)) {
            _subjects.state.next({
              errors: {},
              isSubmitting: true });

            await onValid(fieldValues, e);
          } else
          {
            if (onInvalid) {
              await onInvalid({ ..._formState.errors }, e);
            }
            _options.shouldFocusError &&
            focusFieldBy(_fields, (key) => get(_formState.errors, key), _names.mount);
          }
        }
        catch (err) {
          hasNoPromiseError = false;
          throw err;
        } finally
        {
          _formState.isSubmitted = true;
          _subjects.state.next({
            isSubmitted: true,
            isSubmitting: false,
            isSubmitSuccessful: isEmptyObject(_formState.errors) && hasNoPromiseError,
            submitCount: _formState.submitCount + 1,
            errors: _formState.errors });

        }
      };
      const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
          if (isUndefined(options.defaultValue)) {
            setValue(name, get(_defaultValues, name));
          } else
          {
            setValue(name, options.defaultValue);
            set(_defaultValues, name, options.defaultValue);
          }
          if (!options.keepTouched) {
            unset(_formState.touchedFields, name);
          }
          if (!options.keepDirty) {
            unset(_formState.dirtyFields, name);
            _formState.isDirty = options.defaultValue ?
            _getDirty(name, get(_defaultValues, name)) :
            _getDirty();
          }
          if (!options.keepError) {
            unset(_formState.errors, name);
            _proxyFormState.isValid && _updateValid();
          }
          _subjects.state.next({ ..._formState });
        }
      };
      const reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues) ?
        cloneUpdatedValues :
        _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
          _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
          if (keepStateOptions.keepDirtyValues) {
            for (const fieldName of _names.mount) {
              get(_formState.dirtyFields, fieldName) ?
              set(values, fieldName, get(_formValues, fieldName)) :
              setValue(fieldName, get(values, fieldName));
            }
          } else
          {
            if (isWeb && isUndefined(formValues)) {
              for (const name of _names.mount) {
                const field = get(_fields, name);
                if (field && field._f) {
                  const fieldReference = Array.isArray(field._f.refs) ?
                  field._f.refs[0] :
                  field._f.ref;
                  try {
                    if (isHTMLElement(fieldReference)) {
                      fieldReference.closest('form').reset();
                      break;
                    }
                  }
                  catch (_a) {}
                }
              }
            }
            _fields = {};
          }
          _formValues = props.shouldUnregister ?
          keepStateOptions.keepDefaultValues ?
          cloneObject(_defaultValues) :
          {} :
          cloneUpdatedValues;
          _subjects.array.next({
            values });

          _subjects.watch.next({
            values });

        }
        _names = {
          mount: new Set(),
          unMount: new Set(),
          array: new Set(),
          watch: new Set(),
          watchAll: false,
          focus: '' };

        _stateFlags.mount =
        !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
          submitCount: keepStateOptions.keepSubmitCount ?
          _formState.submitCount :
          0,
          isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues ?
          _formState.isDirty :
          !!(keepStateOptions.keepDefaultValues &&
          !deepEqual(formValues, _defaultValues)),
          isSubmitted: keepStateOptions.keepIsSubmitted ?
          _formState.isSubmitted :
          false,
          dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues ?
          _formState.dirtyFields :
          keepStateOptions.keepDefaultValues && formValues ?
          getDirtyFields(_defaultValues, formValues) :
          {},
          touchedFields: keepStateOptions.keepTouched ?
          _formState.touchedFields :
          {},
          errors: keepStateOptions.keepErrors ?
          _formState.errors :
          {},
          isSubmitting: false,
          isSubmitSuccessful: false });

      };
      const setFocus = (name, options = {}) => {
        const field = get(_fields, name)._f;
        const fieldRef = field.refs ? field.refs[0] : field.ref;
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
      };
      return {
        control: {
          register,
          unregister,
          getFieldState,
          _executeSchema,
          _getWatch,
          _getDirty,
          _updateValid,
          _removeUnmounted,
          _updateFieldArray,
          _getFieldArray,
          _subjects,
          _proxyFormState,
          get _fields() {
            return _fields;
          },
          get _formValues() {
            return _formValues;
          },
          get _stateFlags() {
            return _stateFlags;
          },
          set _stateFlags(value) {
            _stateFlags = value;
          },
          get _defaultValues() {
            return _defaultValues;
          },
          get _names() {
            return _names;
          },
          set _names(value) {
            _names = value;
          },
          get _formState() {
            return _formState;
          },
          set _formState(value) {
            _formState = value;
          },
          get _options() {
            return _options;
          },
          set _options(value) {
            _options = {
              ..._options,
              ...value };

          } },

        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState };

    }

    /**
     * Custom hook to manage the entire form.
     *
     * @remarks
     * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
     *
     * @param props - form configuration and validation parameters.
     *
     * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
     *
     * @example
     * ```tsx
     * function App() {
     *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
     *   const onSubmit = data => console.log(data);
     *
     *   console.log(watch("example"));
     *
     *   return (
     *     <form onSubmit={handleSubmit(onSubmit)}>
     *       <input defaultValue="test" {...register("example")} />
     *       <input {...register("exampleRequired", { required: true })} />
     *       {errors.exampleRequired && <span>This field is required</span>}
     *       <input type="submit" />
     *     </form>
     *   );
     * }
     * ```
     */
    function useForm(props = {}) {
      const _formControl = React__default["default"].useRef();
      const [formState, updateFormState] = React__default["default"].useState({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {} });

      if (_formControl.current) {
        _formControl.current.control._options = props;
      } else
      {
        _formControl.current = {
          ...createFormControl(props),
          formState };

      }
      const control = _formControl.current.control;
      const callback = React__default["default"].useCallback((value) => {
        if (shouldRenderFormState(value, control._proxyFormState, true)) {
          control._formState = {
            ...control._formState,
            ...value };

          updateFormState({ ...control._formState });
        }
      }, [control]);
      useSubscribe({
        subject: control._subjects.state,
        callback });

      React__default["default"].useEffect(() => {
        if (!control._stateFlags.mount) {
          control._proxyFormState.isValid && control._updateValid();
          control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
          control._stateFlags.watch = false;
          control._subjects.state.next({});
        }
        control._removeUnmounted();
      });
      _formControl.current.formState = getProxyFormState(formState, control._proxyFormState);
      return _formControl.current;
    }

    var classes$a = {"awell_single_choice_question":"awell__singleChoiceQuestion_awell_single_choice_question","animate_flicker":"awell__singleChoiceQuestion_animate_flicker","flickerAnimation":"awell__singleChoiceQuestion_flickerAnimation"};

    var SingleChoiceQuestion = function (_a) {
      var questionId = _a.questionId,label = _a.label,options = _a.options,onChange = _a.onChange,value = _a.value,mandatory = _a.mandatory,_b = _a.showFlickerOnSelected,showFlickerOnSelected = _b === void 0 ? false : _b;
      var _c = React.useState(value),checkedOption = _c[0],setCheckedOption = _c[1];
      var _d = React.useState(false),flickerAnimation = _d[0],setFlickerAnimation = _d[1];
      React.useEffect(function () {
        onChange(checkedOption);
        if ((value === null || value === void 0 ? void 0 : value.id) !== (checkedOption === null || checkedOption === void 0 ? void 0 : checkedOption.id)) {
          setFlickerAnimation(true);
        }
        return function () {
          setFlickerAnimation(false);
        };
      }, [checkedOption]);
      var handleSelectOption = function (option) {
        setCheckedOption(option);
      };
      return jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(QuestionLabel, { label: label, mandatory: mandatory }), jsxRuntime.exports.jsx("fieldset", __assign({ className: classes$a.awell_single_choice_question }, { children: (options || []).map(function (option) {return jsxRuntime.exports.jsx(RadioButton, { onChange: function () {return handleSelectOption(option);}, label: option.label, id: option.id, checked: option.id === (checkedOption === null || checkedOption === void 0 ? void 0 : checkedOption.id), name: questionId, customWrapperClass: flickerAnimation &&
              option.id === (checkedOption === null || checkedOption === void 0 ? void 0 : checkedOption.id) &&
              showFlickerOnSelected ?
              classes$a.animate_flicker :
              '' }, option.id);}) }))] });
    };

    var classes$9 = {"awell_question":"awell__question_awell_question","error":"awell__question_error"};

    var classes$8 = {"awell_input_field_wrapper":"awell__phoneInputField_awell_input_field_wrapper","awell_phone_input_field_container":"awell__phoneInputField_awell_phone_input_field_container","input_wrapper_with_error":"awell__phoneInputField_input_wrapper_with_error","has_error":"awell__phoneInputField_has_error","error_message":"awell__phoneInputField_error_message","error_icon":"awell__phoneInputField_error_icon","awell_input_field":"awell__phoneInputField_awell_input_field"};

    var build = {exports: {}};

    (function (module, exports) {
      !function (e, a) {module.exports = a(React__default["default"]) ;}(commonjsGlobal, (e) => (() => {var a = { 0: (e, a, r) => {r.r(a);}, 374: (e, a, r) => {r.r(a);}, 840: (e, a, r) => {r.r(a);}, 481: (e, a, r) => {r.r(a);}, 549: (e, a, r) => {r.r(a);}, 153: function (e, a, r) {var t = this && this.__assign || function () {return t = Object.assign || function (e) {for (var a, r = 1, t = arguments.length; r < t; r++) for (var n in a = arguments[r]) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);return e;}, t.apply(this, arguments);},n = this && this.__createBinding || (Object.create ? function (e, a, r, t) {void 0 === t && (t = r);var n = Object.getOwnPropertyDescriptor(a, r);n && !("get" in n ? !a.__esModule : n.writable || n.configurable) || (n = { enumerable: !0, get: function () {return a[r];} }), Object.defineProperty(e, t, n);} : function (e, a, r, t) {void 0 === t && (t = r), e[t] = a[r];}),o = this && this.__setModuleDefault || (Object.create ? function (e, a) {Object.defineProperty(e, "default", { enumerable: !0, value: a });} : function (e, a) {e.default = a;}),i = this && this.__importStar || function (e) {if (e && e.__esModule) return e;var a = {};if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(a, e, r);return o(a, e), a;},u = this && this.__rest || function (e, a) {var r = {};for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && a.indexOf(t) < 0 && (r[t] = e[t]);if (null != e && "function" == typeof Object.getOwnPropertySymbols) {var n = 0;for (t = Object.getOwnPropertySymbols(e); n < t.length; n++) a.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[n]) && (r[t[n]] = e[t[n]]);}return r;};Object.defineProperty(a, "__esModule", { value: !0 }), a.CountrySelector = void 0, r(0);var l = i(r(156)),s = r(946),c = r(515),d = r(332),f = r(425),p = r(60);a.CountrySelector = function (e) {var a,r,n = e.selectedCountry,o = e.onSelect,i = e.disabled,y = e.hideDropdown,h = e.countries,v = void 0 === h ? s.defaultCountries : h,m = e.renderButtonWrapper,b = u(e, ["selectedCountry", "onSelect", "disabled", "hideDropdown", "countries", "renderButtonWrapper"]),C = (0, l.useState)(!1),g = C[0],P = C[1],_ = (0, l.useMemo)(function () {if (n) return (0, d.getCountry)({ value: n, field: "iso2", countries: v });}, [v, n]),O = (0, l.useRef)(null);return l.default.createElement("div", { className: (0, c.buildClassNames)({ addPrefix: ["country-selector"], rawClassNames: [b.className] }), style: b.style, ref: O }, (a = { title: null == _ ? void 0 : _.name, onClick: function () {return P(function (e) {return !e;});}, onMouseDown: function (e) {return e.preventDefault();}, onKeyDown: function (e) {e.key && ["ArrowUp", "ArrowDown"].includes(e.key) && (e.preventDefault(), P(!0));}, disabled: y || i, role: "combobox", "aria-label": "Country selector", "aria-haspopup": "listbox", "aria-expanded": g }, r = l.default.createElement("div", { className: (0, c.buildClassNames)({ addPrefix: ["country-selector-button__button-content"], rawClassNames: [b.buttonContentWrapperClassName] }), style: b.buttonContentWrapperStyle }, l.default.createElement(f.FlagEmoji, { iso2: n, className: (0, c.buildClassNames)({ addPrefix: ["country-selector-button__flag-emoji", i && "country-selector-button__flag-emoji--disabled"], rawClassNames: [b.flagClassName] }), style: t({ visibility: n ? "visible" : "hidden" }, b.flagStyle) }), !y && l.default.createElement("div", { className: (0, c.buildClassNames)({ addPrefix: ["country-selector-button__dropdown-arrow", i && "country-selector-button__dropdown-arrow--disabled", g && "country-selector-button__dropdown-arrow--active"], rawClassNames: [b.dropdownArrowClassName] }), style: b.dropdownArrowStyle })), m ? m({ children: r, rootProps: a }) : l.default.createElement("button", t({}, a, { type: "button", className: (0, c.buildClassNames)({ addPrefix: ["country-selector-button", g && "country-selector-button--active", i && "country-selector-button--disabled", y && "country-selector-button--hide-dropdown"], rawClassNames: [b.buttonClassName] }), "data-country": n, style: b.buttonStyle }), r)), l.default.createElement(p.CountrySelectorDropdown, t({ show: g, countries: v, onSelect: function (e) {P(!1), null == o || o(e);}, selectedCountry: n, onClose: function () {P(!1);} }, b.dropdownStyleProps)));};}, 60: function (e, a, r) {var t = this && this.__assign || function () {return t = Object.assign || function (e) {for (var a, r = 1, t = arguments.length; r < t; r++) for (var n in a = arguments[r]) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);return e;}, t.apply(this, arguments);},n = this && this.__createBinding || (Object.create ? function (e, a, r, t) {void 0 === t && (t = r);var n = Object.getOwnPropertyDescriptor(a, r);n && !("get" in n ? !a.__esModule : n.writable || n.configurable) || (n = { enumerable: !0, get: function () {return a[r];} }), Object.defineProperty(e, t, n);} : function (e, a, r, t) {void 0 === t && (t = r), e[t] = a[r];}),o = this && this.__setModuleDefault || (Object.create ? function (e, a) {Object.defineProperty(e, "default", { enumerable: !0, value: a });} : function (e, a) {e.default = a;}),i = this && this.__importStar || function (e) {if (e && e.__esModule) return e;var a = {};if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(a, e, r);return o(a, e), a;},u = this && this.__rest || function (e, a) {var r = {};for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && a.indexOf(t) < 0 && (r[t] = e[t]);if (null != e && "function" == typeof Object.getOwnPropertySymbols) {var n = 0;for (t = Object.getOwnPropertySymbols(e); n < t.length; n++) a.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[n]) && (r[t[n]] = e[t[n]]);}return r;};Object.defineProperty(a, "__esModule", { value: !0 }), a.CountrySelectorDropdown = void 0, r(374);var l = i(r(156)),s = r(946),c = r(515),d = r(332),f = r(425);a.CountrySelectorDropdown = function (e) {var a = e.show,r = e.dialCodePrefix,n = void 0 === r ? "+" : r,o = e.selectedCountry,i = e.countries,p = void 0 === i ? s.defaultCountries : i,y = e.onSelect,h = e.onClose,v = u(e, ["show", "dialCodePrefix", "selectedCountry", "countries", "onSelect", "onClose"]),m = (0, l.useRef)(null),b = (0, l.useRef)(),C = (0, l.useCallback)(function (e) {return p.findIndex(function (a) {return (0, d.parseCountry)(a).iso2 === e;});}, [p]),g = (0, l.useState)(C(o)),P = g[0],_ = g[1],O = function () {b.current !== o && _(C(o));},w = (0, l.useCallback)(function (e) {_(C(e.iso2)), null == y || y(e);}, [y, C]),j = function (e) {var a = p.length - 1;_(function (r) {var t,n = (t = r, "prev" === e ? t - 1 : "next" === e ? t + 1 : "last" === e ? a : 0);return n < 0 ? 0 : n > a ? a : n;});},D = (0, l.useCallback)(function () {if (m.current && void 0 !== P) {var e = (0, d.parseCountry)(p[P]).iso2;if (e !== b.current) {var a = m.current.querySelector('[data-country="'.concat(e, '"]'));a && ((0, d.scrollToChild)(m.current, a), b.current = e);}}}, [P, p]);return (0, l.useEffect)(function () {D();}, [P, D]), (0, l.useEffect)(function () {m.current && (a ? m.current.focus() : O());}, [a]), (0, l.useEffect)(function () {O();}, [o]), l.default.createElement("ul", { ref: m, role: "listbox", className: (0, c.buildClassNames)({ addPrefix: ["country-selector-dropdown"], rawClassNames: [v.className] }), style: t({ display: a ? "block" : "none" }, v.style), onKeyDown: function (e) {if ("Enter" !== e.key) {if ("Escape" !== e.key) return "ArrowUp" === e.key ? (e.preventDefault(), void j("prev")) : "ArrowDown" === e.key ? (e.preventDefault(), void j("next")) : "PageUp" === e.key ? (e.preventDefault(), void j("first")) : "PageDown" === e.key ? (e.preventDefault(), void j("last")) : void 0;null == h || h();} else {var a = (0, d.parseCountry)(p[P]);w(a);}}, onBlur: h, tabIndex: -1, "aria-activedescendant": "".concat((0, d.parseCountry)(p[P]).iso2, "-option") }, p.map(function (e, a) {var r = (0, d.parseCountry)(e),t = r.iso2 === o,i = a === P;return l.default.createElement("li", { key: r.iso2, "data-country": r.iso2, role: "option", "aria-selected": t, "aria-label": "".concat(r.name, " ").concat(n).concat(r.dialCode), id: "".concat(r.iso2, "-option"), className: (0, c.buildClassNames)({ addPrefix: ["country-selector-dropdown__list-item", t && "country-selector-dropdown__list-item--selected", i && "country-selector-dropdown__list-item--focused"], rawClassNames: [v.listItemClassName] }), onClick: function () {return w(r);}, style: v.listItemStyle }, l.default.createElement(f.FlagEmoji, { iso2: r.iso2, className: (0, c.buildClassNames)({ addPrefix: ["country-selector-dropdown__list-item-flag-emoji"], rawClassNames: [v.listItemFlagClassName] }), style: v.listItemFlagStyle }), l.default.createElement("span", { className: (0, c.buildClassNames)({ addPrefix: ["country-selector-dropdown__list-item-country-name"], rawClassNames: [v.listItemCountryNameClassName] }), style: v.listItemCountryNameStyle }, r.name), l.default.createElement("span", { className: (0, c.buildClassNames)({ addPrefix: ["country-selector-dropdown__list-item-dial-code"], rawClassNames: [v.listItemDialCodeClassName] }), style: v.listItemDialCodeStyle }, n, r.dialCode));}));};}, 7: function (e, a, r) {var t = this && this.__importDefault || function (e) {return e && e.__esModule ? e : { default: e };};Object.defineProperty(a, "__esModule", { value: !0 }), a.DialCodePreview = void 0, r(840);var n = t(r(156)),o = r(515);a.DialCodePreview = function (e) {var a = e.dialCode,r = e.prefix,t = e.disabled,i = e.style,u = e.className;return n.default.createElement("div", { className: (0, o.buildClassNames)({ addPrefix: ["dial-code-preview", t && "dial-code-preview--disabled"], rawClassNames: [u] }), style: i }, "".concat(r).concat(a));};}, 425: function (e, a, r) {var t = this && this.__assign || function () {return t = Object.assign || function (e) {for (var a, r = 1, t = arguments.length; r < t; r++) for (var n in a = arguments[r]) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);return e;}, t.apply(this, arguments);},n = this && this.__rest || function (e, a) {var r = {};for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && a.indexOf(t) < 0 && (r[t] = e[t]);if (null != e && "function" == typeof Object.getOwnPropertySymbols) {var n = 0;for (t = Object.getOwnPropertySymbols(e); n < t.length; n++) a.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[n]) && (r[t[n]] = e[t[n]]);}return r;},o = this && this.__importDefault || function (e) {return e && e.__esModule ? e : { default: e };};Object.defineProperty(a, "__esModule", { value: !0 }), a.FlagEmoji = void 0, r(481);var i = o(r(156)),u = r(515),l = "abcdefghijklmnopqrstuvwxyz".split("").reduce(function (e, a, r) {var n, o, i;return t(t({}, e), ((n = {})[a] = (o = r, i = parseInt("1f1e6", 16), Number(i + o).toString(16)), n));}, {});a.FlagEmoji = function (e) {var a = e.iso2,r = e.size,o = void 0 === r ? "24px" : r,s = e.protocol,c = void 0 === s ? "https" : s,d = e.disableLazyLoading,f = e.className,p = n(e, ["iso2", "size", "protocol", "disableLazyLoading", "className"]);if (!a) return i.default.createElement("img", t({ width: o, height: o }, p));var y = function (e) {return [l[e[0]], l[e[1]]].join("-");}(a),h = "".concat(c, "://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/").concat(y, ".svg");return i.default.createElement("img", t({ className: (0, u.buildClassNames)({ addPrefix: ["flag-emoji"], rawClassNames: [f] }), src: h, width: o, height: o, draggable: !1, "data-country": a, loading: d ? void 0 : "lazy" }, p));};}, 28: function (e, a, r) {var t = this && this.__assign || function () {return t = Object.assign || function (e) {for (var a, r = 1, t = arguments.length; r < t; r++) for (var n in a = arguments[r]) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);return e;}, t.apply(this, arguments);},n = this && this.__createBinding || (Object.create ? function (e, a, r, t) {void 0 === t && (t = r);var n = Object.getOwnPropertyDescriptor(a, r);n && !("get" in n ? !a.__esModule : n.writable || n.configurable) || (n = { enumerable: !0, get: function () {return a[r];} }), Object.defineProperty(e, t, n);} : function (e, a, r, t) {void 0 === t && (t = r), e[t] = a[r];}),o = this && this.__setModuleDefault || (Object.create ? function (e, a) {Object.defineProperty(e, "default", { enumerable: !0, value: a });} : function (e, a) {e.default = a;}),i = this && this.__importStar || function (e) {if (e && e.__esModule) return e;var a = {};if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(a, e, r);return o(a, e), a;},u = this && this.__rest || function (e, a) {var r = {};for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && a.indexOf(t) < 0 && (r[t] = e[t]);if (null != e && "function" == typeof Object.getOwnPropertySymbols) {var n = 0;for (t = Object.getOwnPropertySymbols(e); n < t.length; n++) a.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[n]) && (r[t[n]] = e[t[n]]);}return r;};Object.defineProperty(a, "__esModule", { value: !0 }), a.PhoneInput = void 0, r(549);var l = i(r(156)),s = r(946),c = r(882),d = r(515),f = r(332),p = r(153),y = r(7);a.PhoneInput = function (e) {var a,r = e.hideDropdown,n = e.placeholder,o = e.disabled,i = e.showDisabledDialCodeAndPrefix,h = e.inputProps,v = e.onChange,m = e.style,b = e.className,C = e.inputStyle,g = e.inputClassName,P = e.countrySelectorStyleProps,_ = e.dialCodePreviewStyleProps,O = e.countries,w = void 0 === O ? s.defaultCountries : O,j = u(e, ["hideDropdown", "placeholder", "disabled", "showDisabledDialCodeAndPrefix", "inputProps", "onChange", "style", "className", "inputStyle", "inputClassName", "countrySelectorStyleProps", "dialCodePreviewStyleProps", "countries"]),D = (0, c.usePhoneInput)(t(t({}, j), { countries: w, onCountryChange: function (e) {null == v || v(e);} })),S = D.phone,x = D.inputRef,M = D.country,N = D.setCountry,k = D.handlePhoneValueChange,A = (0, l.useMemo)(function () {if (M) return (0, f.getCountry)({ value: M, field: "iso2", countries: w });}, [w, M]),E = j.disableDialCodeAndPrefix && i && (null == A ? void 0 : A.dialCode);return l.default.createElement("div", { className: (0, d.buildClassNames)({ addPrefix: ["input-container"], rawClassNames: [b] }), style: m }, l.default.createElement(p.CountrySelector, t({ onSelect: function (e) {return N(e.iso2);}, selectedCountry: M, countries: w, disabled: o, hideDropdown: r }, P)), E && l.default.createElement(y.DialCodePreview, t({ dialCode: A.dialCode, prefix: null !== (a = j.prefix) && void 0 !== a ? a : "+", disabled: o }, _)), l.default.createElement("input", t({ onChange: function (e) {var a = k(e);null == v || v(a);}, value: S, type: "tel", ref: x, className: (0, d.buildClassNames)({ addPrefix: ["input", o && "input--disabled"], rawClassNames: [g] }), placeholder: n, disabled: o, style: C }, h)));};}, 946: (e, a) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.defaultCountries = void 0, a.defaultCountries = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "(..) ........", 0, ["11", "221", "223", "261", "264", "2652", "280", "2905", "291", "2920", "2966", "299", "341", "342", "343", "351", "376", "379", "381", "3833", "385", "387", "388"]], ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "(..) .... ....", 0, ["2", "3", "4", "7", "8", "02", "03", "04", "07", "08"]], ["Austria", ["europe", "eu-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."], ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "eu-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "(...) ...-....", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "... .... ...."], ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."], ["Côte d'Ivoire", ["africa"], "ci", "225", ".. .. .. .."], ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"], ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."], ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."], ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"], ["Ghana", ["africa"], "gh", "233"], ["Greece", ["europe", "eu-union"], "gr", "30"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", ".... ...."], ["Hungary", ["europe", "eu-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "... ...."], ["India", ["asia"], "in", "91", ".....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98", "... ... ...."], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."], ["Israel", ["middle-east"], "il", "972", "... ... ...."], ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", ".. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "... ...-..-..", 0, ["310", "311", "312", "313", "315", "318", "321", "324", "325", "326", "327", "336", "7172", "73622"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kosovo", ["europe", "ex-yugos"], "xk", "383"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"], ["Luxembourg", ["europe", "eu-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe", "ex-yugos"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "eu-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52", "... ... ....", 0, ["33", "55", "81", "229", "656", "664", "774", "998"]], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe", "ex-yugos"], "me", "382"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["North Korea", ["asia"], "kp", "850"], ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", ".... ......."], ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."], ["Portugal", ["europe", "eu-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "eu-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 1], ["Rwanda", ["africa"], "rw", "250"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe", "ex-yugos"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "....-...."], ["Slovakia", ["europe", "eu-union"], "sk", "421"], ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."], ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Tuvalu", ["asia"], "tv", "688"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"], ["United States", ["america", "north-america"], "us", "1", "(...) ...-....", 0, ["201", "202", "203", "205", "206", "207", "208", "209", "210", "212", "213", "214", "215", "216", "217", "218", "219", "225", "228", "229", "231", "239", "248", "251", "252", "253", "254", "256", "260", "262", "269", "270", "276", "281", "301", "302", "303", "304", "305", "307", "308", "309", "310", "312", "313", "314", "315", "316", "317", "318", "319", "320", "321", "323", "325", "330", "334", "336", "337", "352", "360", "361", "386", "401", "402", "404", "405", "406", "407", "408", "409", "410", "412", "413", "414", "415", "417", "419", "423", "425", "432", "434", "435", "440", "478", "479", "480", "501", "502", "503", "504", "505", "507", "508", "509", "510", "512", "513", "515", "516", "517", "518", "520", "530", "540", "541", "559", "561", "562", "563", "570", "573", "574", "575", "580", "585", "586", "601", "602", "603", "605", "606", "607", "608", "609", "610", "612", "614", "615", "616", "617", "618", "619", "620", "623", "626", "630", "631", "636", "641", "650", "651", "660", "661", "662", "701", "702", "703", "704", "706", "707", "708", "712", "713", "714", "715", "716", "717", "718", "719", "724", "727", "731", "732", "734", "740", "757", "760", "763", "765", "770", "772", "773", "775", "781", "785", "801", "802", "803", "804", "805", "806", "808", "810", "812", "813", "814", "815", "816", "817", "818", "828", "830", "831", "843", "845", "847", "850", "856", "858", "859", "860", "863", "864", "865", "870", "901", "903", "904", "906", "907", "908", "909", "910", "912", "913", "914", "915", "916", "918", "919", "920", "925", "928", "931", "936", "937", "940", "941", "949", "951", "952", "954", "956", "970", "972", "973", "978", "979", "985", "989"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]];}, 11: function (e, a, r) {var t = this && this.__assign || function () {return t = Object.assign || function (e) {for (var a, r = 1, t = arguments.length; r < t; r++) for (var n in a = arguments[r]) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);return e;}, t.apply(this, arguments);},n = this && this.__spreadArray || function (e, a, r) {if (r || 2 === arguments.length) for (var t, n = 0, o = a.length; n < o; n++) !t && n in a || (t || (t = Array.prototype.slice.call(a, 0, n)), t[n] = a[n]);return e.concat(t || Array.prototype.slice.call(a));};Object.defineProperty(a, "__esModule", { value: !0 }), a.useHistoryState = void 0;var o = r(156),i = { size: 20 };a.useHistoryState = function (e, a) {var r = t(t({}, i), a).size,u = (0, o.useState)(e),l = u[0],s = u[1],c = (0, o.useState)([e]),d = c[0],f = c[1],p = (0, o.useState)(0),y = p[0],h = p[1],v = (0, o.useCallback)(function (e, a) {if (e !== l) {if (null == a ? void 0 : a.overrideLastHistoryItem) f(function (a) {return n(n([], a.slice(0, y), !0), [e], !1);});else {var t = d.length >= r;f(function (a) {return n(n([], a.slice(t ? 1 : 0, y + 1), !0), [e], !1);}), t || h(function (e) {return e + 1;});}s(e);}}, [l, y, d.length, r]),m = (0, o.useCallback)(function () {return !(y <= 0 || (s(d[y - 1]), h(function (e) {return e - 1;}), 0));}, [d, y]),b = (0, o.useCallback)(function () {return !(y + 1 >= d.length || (s(d[y + 1]), h(function (e) {return e + 1;}), 0));}, [d, y]);return [l, v, m, b];};}, 452: function (e, a, r) {var t = this && this.__assign || function () {return t = Object.assign || function (e) {for (var a, r = 1, t = arguments.length; r < t; r++) for (var n in a = arguments[r]) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);return e;}, t.apply(this, arguments);};Object.defineProperty(a, "__esModule", { value: !0 }), a.usePhone = a.defaultPhoneConfig = a.MASK_CHAR = void 0;var n = r(156),o = r(946),i = r(332),u = r(11),l = r(795);a.MASK_CHAR = ".", a.defaultPhoneConfig = { prefix: "+", defaultMask: "............", charAfterDialCode: " ", historySaveDebounceMS: 200, disableCountryGuess: !1, disableDialCodePrefill: !1, forceDialCode: !1, disableDialCodeAndPrefix: !1, countries: o.defaultCountries }, a.usePhone = function (e, r) {var o = t(t({}, a.defaultPhoneConfig), r),s = o.country,c = o.countries,d = o.prefix,f = o.defaultMask,p = o.charAfterDialCode,y = o.historySaveDebounceMS,h = o.disableCountryGuess,v = o.disableDialCodePrefill,m = o.forceDialCode,b = o.disableDialCodeAndPrefix,C = o.onCountryGuess,g = o.onPhoneUpdate,P = !b && !h,_ = (0, l.useTimer)(),O = (0, n.useMemo)(function () {if (s) return (0, i.getCountry)({ value: s, field: "iso2", countries: c });}, [s, c]),w = function (e, r) {var t,n = void 0 === r ? {} : r,o = n.trimNonDigitsEnd,u = n.insertDialCodeOnEmpty,l = n.forceDisableCountryGuess,s = n.forcedCountry,y = l || !P || s ? void 0 : (0, i.guessCountryByPartialNumber)({ phone: e, countries: c, currentCountryIso2: null == O ? void 0 : O.iso2 }),h = null !== (t = null != s ? s : null == y ? void 0 : y.country) && void 0 !== t ? t : O;return { phone: h ? (0, i.formatPhone)(e, { prefix: d, mask: h.format || f, maskChar: a.MASK_CHAR, dialCode: h.dialCode, trimNonDigitsEnd: o, charAfterDialCode: p, forceDialCode: m, insertDialCodeOnEmpty: u, disableDialCodeAndPrefix: b }) : e, countryGuessResult: y, formatCountry: h };},j = (0, u.useHistoryState)(w(e, { insertDialCodeOnEmpty: !v }).phone),D = j[0],S = j[1],x = j[2],M = j[3],N = (0, n.useState)(!1),k = N[0],A = N[1],E = function (e, a) {var r,t = void 0 === a ? {} : a,n = t.deletion,o = t.cursorPosition,u = t.insertDialCodeOnEmpty,l = t.inserted,c = t.forcedCountry,f = e,p = o;m && !b && O && !(0, i.removeNonDigits)(e).startsWith(O.dialCode) && e && (l && e.startsWith(d) && e.length - (null != o ? o : 0) == 0 ? f = e : (f = D, p = 0));var h = w(f, { trimNonDigitsEnd: "backward" === n, insertDialCodeOnEmpty: u || !k && !v, forceDisableCountryGuess: m && !!n && (0, i.removeNonDigits)(f).length < (null !== (r = null == O ? void 0 : O.dialCode.length) && void 0 !== r ? r : 0), forcedCountry: c }),j = h.phone,x = h.countryGuessResult,M = h.formatCountry,N = _.check();return S(j, { overrideLastHistoryItem: !(!N || N > y) }), null == g || g(j, { formatCountry: M, unformattedValue: f, cursorPosition: null != p ? p : 0, deletion: n }), P && (null == x ? void 0 : x.country) && x.country.name !== s && (null == C || C(x)), k || A(!0), j;};return (0, n.useEffect)(function () {k && e === D || E(e);}, [e]), { phone: D, initialized: k, undo: x, redo: M, handleValueChange: E };};}, 882: function (e, a, r) {var t = this && this.__assign || function () {return t = Object.assign || function (e) {for (var a, r = 1, t = arguments.length; r < t; r++) for (var n in a = arguments[r]) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);return e;}, t.apply(this, arguments);},n = this && this.__rest || function (e, a) {var r = {};for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && a.indexOf(t) < 0 && (r[t] = e[t]);if (null != e && "function" == typeof Object.getOwnPropertySymbols) {var n = 0;for (t = Object.getOwnPropertySymbols(e); n < t.length; n++) a.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[n]) && (r[t[n]] = e[t[n]]);}return r;};Object.defineProperty(a, "__esModule", { value: !0 }), a.usePhoneInput = void 0;var o = r(156),i = r(946),u = r(332),l = r(452);a.usePhoneInput = function (e) {var a,r,s,c = e.initialCountry,d = e.value,f = void 0 === d ? "" : d,p = e.prefix,y = void 0 === p ? "+" : p,h = e.countries,v = void 0 === h ? i.defaultCountries : h,m = e.disableDialCodeAndPrefix,b = e.hideSpaceAfterDialCode,C = e.onCountryChange,g = n(e, ["initialCountry", "value", "prefix", "countries", "disableDialCodeAndPrefix", "hideSpaceAfterDialCode", "onCountryChange"]),P = (0, o.useRef)(null),_ = (0, o.useRef)({ shouldFocus: !1, shouldSetCursorToEnd: !1 }),O = (0, o.useState)(null !== (r = null === (a = (0, u.guessCountryByPartialNumber)({ phone: f, countries: v, currentCountryIso2: c }).country) || void 0 === a ? void 0 : a.iso2) && void 0 !== r ? r : c),w = O[0],j = O[1],D = (0, o.useMemo)(function () {if (w) return (0, u.getCountry)({ value: w, field: "iso2", countries: v });}, [v, w]),S = b ? "" : " ",x = null !== (s = null == D ? void 0 : D.dialCode) && void 0 !== s ? s : "",M = m ? (0, u.removeDialCode)({ phone: f, dialCode: x, charAfterDialCode: S, prefix: y }) : f,N = (0, l.usePhone)(M, t({ country: w, countries: v, prefix: y, disableDialCodeAndPrefix: m, charAfterDialCode: S, onCountryGuess: function (e) {var a = e.country;e.fullDialCodeMatch && j(a.iso2);}, onPhoneUpdate: function (e, a) {var r,t,n = a.formatCountry,o = a.unformattedValue,i = a.cursorPosition,l = a.deletion,s = A && !_.current.shouldSetCursorToEnd ? (0, u.getCursorPosition)({ cursorPositionAfterInput: i, phoneBeforeInput: k, phoneAfterInput: o, phoneAfterFormatted: e, leftOffset: g.forceDialCode ? y.length + (null !== (t = null === (r = null == n ? void 0 : n.dialCode) || void 0 === r ? void 0 : r.length) && void 0 !== t ? t : 0) + S.length : 0, deletion: l }) : e.length;Promise.resolve().then(function () {var e, a;null === (e = P.current) || void 0 === e || e.setSelectionRange(s, s), _.current.shouldFocus && (null === (a = P.current) || void 0 === a || a.focus()), _.current = { shouldFocus: !1, shouldSetCursorToEnd: !1 };});} }, g)),k = N.phone,A = N.initialized,E = N.undo,I = N.redo,B = N.handleValueChange;return (0, o.useEffect)(function () {var e = P.current;if (e) {var a = function (e) {if (e.key) {var a = e.ctrlKey,r = e.shiftKey,t = "z" === e.key.toLowerCase();if (a && t) return r ? I() : E();}};return e.addEventListener("keydown", a), function () {e.removeEventListener("keydown", a);};}}, [P, E, I]), { phone: k, handlePhoneValueChange: function (e) {var a;e.preventDefault();var r = e.nativeEvent.inputType,t = null == r ? void 0 : r.startsWith("insertFrom"),n = B(e.target.value, { deletion: function () {var e;if (null !== (e = null == r ? void 0 : r.toLocaleLowerCase().includes("delete")) && void 0 !== e && e) return (null == r ? void 0 : r.toLocaleLowerCase().includes("forward")) ? "forward" : "backward";}(), inserted: t, cursorPosition: null !== (a = e.target.selectionStart) && void 0 !== a ? a : 0 });return m ? (0, u.addDialCode)({ phone: n, dialCode: x, charAfterDialCode: S, prefix: y }) : n;}, inputRef: P, country: w, setCountry: function (e) {var a = (0, u.getCountry)({ value: e, field: "iso2", countries: v });if (a) {_.current = { shouldFocus: !0, shouldSetCursorToEnd: !0 };var r = B(m ? "" : "".concat(y).concat(S).concat(a.dialCode), { forcedCountry: a });j(a.iso2), null == C || C(r);}} };};}, 393: (e, a, r) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.usePhoneValidation = void 0;var t = r(332);a.usePhoneValidation = function (e, a) {return (0, t.validatePhone)(e, a);};}, 795: (e, a, r) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.useTimer = void 0;var t = r(156);a.useTimer = function () {var e = (0, t.useState)(),a = e[0],r = e[1],n = (0, t.useState)(Date.now()),o = n[0],i = n[1];return { check: function () {var e = Date.now(),t = a ? e - o : void 0;return r(o), i(e), t;} };};}, 515: function (e, a) {var r = this && this.__spreadArray || function (e, a, r) {if (r || 2 === arguments.length) for (var t, n = 0, o = a.length; n < o; n++) !t && n in a || (t || (t = Array.prototype.slice.call(a, 0, n)), t[n] = a[n]);return e.concat(t || Array.prototype.slice.call(a));};Object.defineProperty(a, "__esModule", { value: !0 }), a.buildClassNames = a.classNamesWithPrefix = a.joinClasses = a.classPrefix = void 0, a.classPrefix = "react-international-phone-", a.joinClasses = function () {for (var e = [], a = 0; a < arguments.length; a++) e[a] = arguments[a];return e.filter(function (e) {return !!e;}).join(" ").trim();}, a.classNamesWithPrefix = function () {for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];return a.joinClasses.apply(void 0, e).split(" ").map(function (e) {return "".concat(a.classPrefix).concat(e);}).join(" ");}, a.buildClassNames = function (e) {var t = e.addPrefix,n = e.rawClassNames;return a.joinClasses.apply(void 0, r([a.classNamesWithPrefix.apply(void 0, t)], n, !1));};}, 62: (e, a) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.applyMask = void 0, a.applyMask = function (e) {var a = e.value,r = e.mask,t = e.maskSymbol,n = e.offset,o = void 0 === n ? 0 : n,i = e.trimNonMaskCharsLeftover,u = void 0 !== i && i;if (a.length < o) return a;for (var l = a.slice(0, o), s = a.slice(o), c = l, d = 0, f = 0, p = r.split(""); f < p.length; f++) {var y = p[f];if (d >= s.length) {if (!u && y !== t) {c += y;continue;}break;}y === t ? (c += s[d], d += 1) : c += y;}return c;};}, 239: function (e, a, r) {var t = this && this.__createBinding || (Object.create ? function (e, a, r, t) {void 0 === t && (t = r);var n = Object.getOwnPropertyDescriptor(a, r);n && !("get" in n ? !a.__esModule : n.writable || n.configurable) || (n = { enumerable: !0, get: function () {return a[r];} }), Object.defineProperty(e, t, n);} : function (e, a, r, t) {void 0 === t && (t = r), e[t] = a[r];}),n = this && this.__exportStar || function (e, a) {for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(a, r) || t(a, e, r);};Object.defineProperty(a, "__esModule", { value: !0 }), n(r(62), a), n(r(939), a), n(r(222), a);}, 939: (e, a) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.removeNonDigits = void 0, a.removeNonDigits = function (e) {return e.replace(/\D/g, "");};}, 222: (e, a) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.scrollToChild = void 0, a.scrollToChild = function (e, a) {var r = e.style.display;"block" !== r && (e.style.display = "block");var t = e.getBoundingClientRect(),n = a.getBoundingClientRect(),o = n.top - t.top,i = t.bottom - n.bottom;o >= 0 && i >= 0 || (Math.abs(o) < Math.abs(i) ? e.scrollTop += o : e.scrollTop -= i), e.style.display = r;};}, 298: (e, a) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.buildCountryData = void 0, a.buildCountryData = function (e) {return [e.name, e.regions, e.iso2, e.dialCode, e.format, e.priority, e.areaCodes].filter(Boolean);};}, 891: (e, a, r) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.getCountry = void 0;var t = r(300);a.getCountry = function (e) {var a = e.value,r = e.field,n = e.countries;if (["regions", "priority"].includes(r)) throw new Error(function (e) {return 'Field "'.concat(e, '" is not supported');}(r));var o = n.find(function (e) {var n = (0, t.parseCountry)(e);return a === n[r];});if (o) return (0, t.parseCountry)(o);};}, 4: (e, a, r) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.guessCountryByPartialNumber = void 0;var t = r(239),n = r(891),o = r(300);a.guessCountryByPartialNumber = function (e) {var a,r = e.phone,i = e.countries,u = e.currentCountryIso2,l = { country: void 0, fullDialCodeMatch: !1, areaCodeMatch: void 0 };if (!r) return l;var s = (0, t.removeNonDigits)(r);if (!s) return l;for (var c = l, d = function (e) {var a,r,t,n,o = e.country,i = e.fullDialCodeMatch,u = e.areaCodeMatch,l = o.dialCode === (null === (a = c.country) || void 0 === a ? void 0 : a.dialCode),s = (null !== (r = o.priority) && void 0 !== r ? r : 0) < (null !== (n = null === (t = c.country) || void 0 === t ? void 0 : t.priority) && void 0 !== n ? n : 0);l && !s || (c = { country: o, fullDialCodeMatch: i, areaCodeMatch: u });}, f = 0, p = i; f < p.length; f++) {var y = p[f],h = (0, o.parseCountry)(y),v = h.dialCode,m = h.areaCodes;if (s.startsWith(v)) {var b = !c.country || Number(v) >= Number(c.country.dialCode);if (m) for (var C = s.substring(v.length), g = 0, P = m; g < P.length; g++) {var _ = P[g];if (C.startsWith(_)) return { country: h, fullDialCodeMatch: !0, areaCodeMatch: !0 };}!b && v !== s && c.fullDialCodeMatch || d({ country: h, fullDialCodeMatch: !0, areaCodeMatch: m ? !m : void 0 });}c.fullDialCodeMatch || s.length < v.length && v.startsWith(s) && (!c.country || Number(v) <= Number(c.country.dialCode)) && d({ country: h, fullDialCodeMatch: !1 });}if (u) {var O = (0, n.getCountry)({ value: u, field: "iso2", countries: i });c && O && (null === (a = c.country) || void 0 === a ? void 0 : a.dialCode) === O.dialCode && c.country !== O && c.fullDialCodeMatch && !c.areaCodeMatch && (c.country = O);}return c;};}, 88: function (e, a, r) {var t = this && this.__createBinding || (Object.create ? function (e, a, r, t) {void 0 === t && (t = r);var n = Object.getOwnPropertyDescriptor(a, r);n && !("get" in n ? !a.__esModule : n.writable || n.configurable) || (n = { enumerable: !0, get: function () {return a[r];} }), Object.defineProperty(e, t, n);} : function (e, a, r, t) {void 0 === t && (t = r), e[t] = a[r];}),n = this && this.__exportStar || function (e, a) {for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(a, r) || t(a, e, r);};Object.defineProperty(a, "__esModule", { value: !0 }), n(r(298), a), n(r(891), a), n(r(4), a), n(r(300), a);}, 300: (e, a) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.parseCountry = void 0, a.parseCountry = function (e) {return { name: e[0], regions: e[1], iso2: e[2], dialCode: e[3], format: e[4], priority: e[5], areaCodes: e[6] };};}, 332: function (e, a, r) {var t = this && this.__createBinding || (Object.create ? function (e, a, r, t) {void 0 === t && (t = r);var n = Object.getOwnPropertyDescriptor(a, r);n && !("get" in n ? !a.__esModule : n.writable || n.configurable) || (n = { enumerable: !0, get: function () {return a[r];} }), Object.defineProperty(e, t, n);} : function (e, a, r, t) {void 0 === t && (t = r), e[t] = a[r];}),n = this && this.__exportStar || function (e, a) {for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(a, r) || t(a, e, r);};Object.defineProperty(a, "__esModule", { value: !0 }), n(r(239), a), n(r(88), a), n(r(165), a);}, 820: (e, a, r) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.addDialCode = void 0;var t = r(214);a.addDialCode = function (e) {var a = e.phone,r = e.dialCode,n = e.prefix,o = void 0 === n ? "+" : n,i = e.charAfterDialCode,u = void 0 === i ? " " : i;return "".concat(o).concat(r).concat(u).concat((0, t.removeDialCode)({ phone: a, dialCode: r, charAfterDialCode: u, prefix: o }));};}, 380: (e, a, r) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.formatPhone = void 0;var t = r(239);a.formatPhone = function (e, a) {var r = !a.disableDialCodeAndPrefix && a.forceDialCode,n = !a.disableDialCodeAndPrefix && a.insertDialCodeOnEmpty,o = e,i = function (e) {return a.trimNonDigitsEnd ? e.trim() : e;};if (!o) return n && !o.length || r ? i("".concat(a.prefix).concat(a.dialCode).concat(a.charAfterDialCode)) : i(o);if ((o = (0, t.removeNonDigits)(o)) === a.dialCode && !a.disableDialCodeAndPrefix) return i("".concat(a.prefix).concat(a.dialCode).concat(a.charAfterDialCode));if (a.dialCode.startsWith(o) && !a.disableDialCodeAndPrefix) return i(r ? "".concat(a.prefix).concat(a.dialCode).concat(a.charAfterDialCode) : "".concat(a.prefix).concat(o));if (!o.startsWith(a.dialCode) && !a.disableDialCodeAndPrefix) {if (r) return i("".concat(a.prefix).concat(a.dialCode).concat(a.charAfterDialCode));if (o.length < a.dialCode.length) return i("".concat(a.prefix).concat(o));}var u,l = (u = a.dialCode.length, a.disableDialCodeAndPrefix && (u = 0), { phoneLeftSide: o.slice(0, u), phoneRightSide: o.slice(u) }),s = l.phoneLeftSide,c = l.phoneRightSide;return s = "".concat(a.prefix).concat(s).concat(a.charAfterDialCode), c = (0, t.applyMask)({ value: c, mask: a.mask, maskSymbol: a.maskChar, trimNonMaskCharsLeftover: a.trimNonDigitsEnd }), a.disableDialCodeAndPrefix && (s = ""), i("".concat(s).concat(c));};}, 775: (e, a) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.getCursorPosition = void 0;var r = function (e) {return /\d/.test(e);};a.getCursorPosition = function (e) {var a = e.phoneBeforeInput,t = e.phoneAfterInput,n = e.phoneAfterFormatted,o = e.cursorPositionAfterInput,i = e.leftOffset,u = void 0 === i ? 0 : i,l = e.deletion;if (o < u) return u;if (!a) return n.length;var s = "backward" === l;if (0 === o && t.length > 0 && n.length > 0) {if (s) return 0;for (var c = 0; c < n.length; c += 1) if (r(n[c])) return c;return n.length;}if (t.length < a.length && 1 === t.length) return n.length;var d = null;for (c = o - 1; c >= 0; c -= 1) if (r(t[c])) {d = c;break;}if (null === d) return 0 !== o ? o : n.length;var f = 0;for (c = 0; c < d; c += 1) r(t[c]) && (f += 1);s && (f -= 1);var p = 0,y = 0;for (c = 0; c < n.length && (p += 1, r(n[c]) && (y += 1), y !== f + 1); c += 1);for (; !r(n[p]) && p < n.length;) p += 1;return s && (p += 1), p;};}, 165: function (e, a, r) {var t = this && this.__createBinding || (Object.create ? function (e, a, r, t) {void 0 === t && (t = r);var n = Object.getOwnPropertyDescriptor(a, r);n && !("get" in n ? !a.__esModule : n.writable || n.configurable) || (n = { enumerable: !0, get: function () {return a[r];} }), Object.defineProperty(e, t, n);} : function (e, a, r, t) {void 0 === t && (t = r), e[t] = a[r];}),n = this && this.__exportStar || function (e, a) {for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(a, r) || t(a, e, r);};Object.defineProperty(a, "__esModule", { value: !0 }), n(r(820), a), n(r(380), a), n(r(775), a), n(r(214), a), n(r(684), a);}, 214: (e, a) => {Object.defineProperty(a, "__esModule", { value: !0 }), a.removeDialCode = void 0, a.removeDialCode = function (e) {var a = e.phone,r = e.dialCode,t = e.prefix,n = void 0 === t ? "+" : t,o = e.charAfterDialCode,i = void 0 === o ? " " : o;if (!a || !r) return a;var u = a;return u.startsWith(n) && (u = u.replace(n, "")), u.startsWith(r) ? ((u = u.replace(r, "")).startsWith(i) && (u = u.replace(i, "")), u) : a;};}, 684: function (e, a, r) {var t = this && this.__assign || function () {return t = Object.assign || function (e) {for (var a, r = 1, t = arguments.length; r < t; r++) for (var n in a = arguments[r]) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);return e;}, t.apply(this, arguments);};Object.defineProperty(a, "__esModule", { value: !0 }), a.validatePhone = void 0;var n = r(452),o = r(239),i = r(88);a.validatePhone = function (e, a) {var r = t(t({}, n.defaultPhoneConfig), a),u = r.countries,l = r.defaultMask,s = r.defaultMaskMinPhoneLength,c = void 0 === s ? 10 : s,d = r.prefix,f = r.charAfterDialCode,p = (0, i.guessCountryByPartialNumber)({ phone: e, countries: u }),y = p.country,h = p.fullDialCodeMatch,v = p.areaCodeMatch;if (!y || !h) return { country: void 0, lengthMatch: !1, areaCodeMatch: v, isValid: !1 };var m = "".concat(d).concat(y.dialCode).concat(f);if (!e.startsWith(m)) return { country: y, lengthMatch: !1, areaCodeMatch: v, isValid: !1 };var b = e.substring(m.length),C = !y.format,g = C ? l : y.format;if (C && (0, o.removeNonDigits)(e).length < c) return { country: y, lengthMatch: !1, areaCodeMatch: v, isValid: !1 };if (!C && b.length !== g.length) return { country: y, lengthMatch: !1, areaCodeMatch: v, isValid: !1 };for (var P = 0; P < b.length; P += 1) if (b[P] !== g[P] && g[P] !== n.MASK_CHAR) return { country: y, lengthMatch: !1, areaCodeMatch: v, isValid: !1 };return { country: y, lengthMatch: !0, areaCodeMatch: v, isValid: null == v || v };};}, 156: (a) => {a.exports = e;} },r = {};function t(e) {var n = r[e];if (void 0 !== n) return n.exports;var o = r[e] = { exports: {} };return a[e].call(o.exports, o, o.exports, t), o.exports;}t.r = (e) => {"undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });};var n = {};return (() => {var e = n;Object.defineProperty(e, "__esModule", { value: !0 }), e.validatePhone = e.parseCountry = e.buildCountryData = e.usePhoneValidation = e.usePhoneInput = e.usePhone = e.defaultCountries = e.PhoneInput = e.FlagEmoji = e.DialCodePreview = e.CountrySelectorDropdown = e.CountrySelector = void 0;var a = t(153);Object.defineProperty(e, "CountrySelector", { enumerable: !0, get: function () {return a.CountrySelector;} });var r = t(60);Object.defineProperty(e, "CountrySelectorDropdown", { enumerable: !0, get: function () {return r.CountrySelectorDropdown;} });var o = t(7);Object.defineProperty(e, "DialCodePreview", { enumerable: !0, get: function () {return o.DialCodePreview;} });var i = t(425);Object.defineProperty(e, "FlagEmoji", { enumerable: !0, get: function () {return i.FlagEmoji;} });var u = t(28);Object.defineProperty(e, "PhoneInput", { enumerable: !0, get: function () {return u.PhoneInput;} });var l = t(946);Object.defineProperty(e, "defaultCountries", { enumerable: !0, get: function () {return l.defaultCountries;} });var s = t(452);Object.defineProperty(e, "usePhone", { enumerable: !0, get: function () {return s.usePhone;} });var c = t(882);Object.defineProperty(e, "usePhoneInput", { enumerable: !0, get: function () {return c.usePhoneInput;} });var d = t(393);Object.defineProperty(e, "usePhoneValidation", { enumerable: !0, get: function () {return d.usePhoneValidation;} });var f = t(332);Object.defineProperty(e, "buildCountryData", { enumerable: !0, get: function () {return f.buildCountryData;} }), Object.defineProperty(e, "parseCountry", { enumerable: !0, get: function () {return f.parseCountry;} }), Object.defineProperty(e, "validatePhone", { enumerable: !0, get: function () {return f.validatePhone;} });})(), n;})());
    })(build);

    var lodash = {exports: {}};

    /**
     * @license
     * Lodash <https://lodash.com/>
     * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
     * Released under MIT license <https://lodash.com/license>
     * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
     * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
     */

    (function(module,exports){
    (function(){

    /** Used as a safe reference for `undefined` in pre-ES5 environments. */
    var undefined$1;

    /** Used as the semantic version number. */
    var VERSION='4.17.21';

    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE=200;

    /** Error message constants. */
    var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
    FUNC_ERROR_TEXT='Expected a function',
    INVALID_TEMPL_VAR_ERROR_TEXT='Invalid `variable` option passed into `_.template`';

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED='__lodash_hash_undefined__';

    /** Used as the maximum memoize cache size. */
    var MAX_MEMOIZE_SIZE=500;

    /** Used as the internal argument placeholder. */
    var PLACEHOLDER='__lodash_placeholder__';

    /** Used to compose bitmasks for cloning. */
    var CLONE_DEEP_FLAG=1,
    CLONE_FLAT_FLAG=2,
    CLONE_SYMBOLS_FLAG=4;

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG=1,
    COMPARE_UNORDERED_FLAG=2;

    /** Used to compose bitmasks for function metadata. */
    var WRAP_BIND_FLAG=1,
    WRAP_BIND_KEY_FLAG=2,
    WRAP_CURRY_BOUND_FLAG=4,
    WRAP_CURRY_FLAG=8,
    WRAP_CURRY_RIGHT_FLAG=16,
    WRAP_PARTIAL_FLAG=32,
    WRAP_PARTIAL_RIGHT_FLAG=64,
    WRAP_ARY_FLAG=128,
    WRAP_REARG_FLAG=256,
    WRAP_FLIP_FLAG=512;

    /** Used as default options for `_.truncate`. */
    var DEFAULT_TRUNC_LENGTH=30,
    DEFAULT_TRUNC_OMISSION='...';

    /** Used to detect hot functions by number of calls within a span of milliseconds. */
    var HOT_COUNT=800,
    HOT_SPAN=16;

    /** Used to indicate the type of lazy iteratees. */
    var LAZY_FILTER_FLAG=1,
    LAZY_MAP_FLAG=2,
    LAZY_WHILE_FLAG=3;

    /** Used as references for various `Number` constants. */
    var INFINITY=1/0,
    MAX_SAFE_INTEGER=9007199254740991,
    MAX_INTEGER=1.7976931348623157e+308,
    NAN=0/0;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH=4294967295,
    MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,
    HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;

    /** Used to associate wrap methods with their bit flags. */
    var wrapFlags=[
    ['ary',WRAP_ARY_FLAG],
    ['bind',WRAP_BIND_FLAG],
    ['bindKey',WRAP_BIND_KEY_FLAG],
    ['curry',WRAP_CURRY_FLAG],
    ['curryRight',WRAP_CURRY_RIGHT_FLAG],
    ['flip',WRAP_FLIP_FLAG],
    ['partial',WRAP_PARTIAL_FLAG],
    ['partialRight',WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg',WRAP_REARG_FLAG]];


    /** `Object#toString` result references. */
    var argsTag='[object Arguments]',
    arrayTag='[object Array]',
    asyncTag='[object AsyncFunction]',
    boolTag='[object Boolean]',
    dateTag='[object Date]',
    domExcTag='[object DOMException]',
    errorTag='[object Error]',
    funcTag='[object Function]',
    genTag='[object GeneratorFunction]',
    mapTag='[object Map]',
    numberTag='[object Number]',
    nullTag='[object Null]',
    objectTag='[object Object]',
    promiseTag='[object Promise]',
    proxyTag='[object Proxy]',
    regexpTag='[object RegExp]',
    setTag='[object Set]',
    stringTag='[object String]',
    symbolTag='[object Symbol]',
    undefinedTag='[object Undefined]',
    weakMapTag='[object WeakMap]',
    weakSetTag='[object WeakSet]';

    var arrayBufferTag='[object ArrayBuffer]',
    dataViewTag='[object DataView]',
    float32Tag='[object Float32Array]',
    float64Tag='[object Float64Array]',
    int8Tag='[object Int8Array]',
    int16Tag='[object Int16Array]',
    int32Tag='[object Int32Array]',
    uint8Tag='[object Uint8Array]',
    uint8ClampedTag='[object Uint8ClampedArray]',
    uint16Tag='[object Uint16Array]',
    uint32Tag='[object Uint32Array]';

    /** Used to match empty string literals in compiled template source. */
    var reEmptyStringLeading=/\b__p \+= '';/g,
    reEmptyStringMiddle=/\b(__p \+=) '' \+/g,
    reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;

    /** Used to match HTML entities and HTML characters. */
    var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,
    reUnescapedHtml=/[&<>"']/g,
    reHasEscapedHtml=RegExp(reEscapedHtml.source),
    reHasUnescapedHtml=RegExp(reUnescapedHtml.source);

    /** Used to match template delimiters. */
    var reEscape=/<%-([\s\S]+?)%>/g,
    reEvaluate=/<%([\s\S]+?)%>/g,
    reInterpolate=/<%=([\s\S]+?)%>/g;

    /** Used to match property names within property paths. */
    var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp=/^\w*$/,
    rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

    /**
    	   * Used to match `RegExp`
    	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
    	   */
    var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar=RegExp(reRegExpChar.source);

    /** Used to match leading whitespace. */
    var reTrimStart=/^\s+/;

    /** Used to match a single whitespace character. */
    var reWhitespace=/\s/;

    /** Used to match wrap detail comments. */
    var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
    reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails=/,? & /;

    /** Used to match words composed of alphanumeric characters. */
    var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

    /**
    	   * Used to validate the `validate` option in `_.template` variable.
    	   *
    	   * Forbids characters which could potentially change the meaning of the function argument definition:
    	   * - "()," (modification of function parameters)
    	   * - "=" (default value)
    	   * - "[]{}" (destructuring of function parameters)
    	   * - "/" (beginning of a comment)
    	   * - whitespace
    	   */
    var reForbiddenIdentifierChars=/[()=,{}\[\]\/\s]/;

    /** Used to match backslashes in property paths. */
    var reEscapeChar=/\\(\\)?/g;

    /**
    	   * Used to match
    	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
    	   */
    var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

    /** Used to match `RegExp` flags from their coerced string values. */
    var reFlags=/\w*$/;

    /** Used to detect bad signed hexadecimal string values. */
    var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;

    /** Used to detect binary string values. */
    var reIsBinary=/^0b[01]+$/i;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor=/^\[object .+?Constructor\]$/;

    /** Used to detect octal string values. */
    var reIsOctal=/^0o[0-7]+$/i;

    /** Used to detect unsigned integer values. */
    var reIsUint=/^(?:0|[1-9]\d*)$/;

    /** Used to match Latin Unicode letters (excluding mathematical operators). */
    var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

    /** Used to ensure capturing order of template delimiters. */
    var reNoMatch=/($^)/;

    /** Used to match unescaped characters in compiled string literals. */
    var reUnescapedString=/['\n\r\u2028\u2029\\]/g;

    /** Used to compose unicode character classes. */
    var rsAstralRange='\\ud800-\\udfff',
    rsComboMarksRange='\\u0300-\\u036f',
    reComboHalfMarksRange='\\ufe20-\\ufe2f',
    rsComboSymbolsRange='\\u20d0-\\u20ff',
    rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,
    rsDingbatRange='\\u2700-\\u27bf',
    rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange='\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange='\\u2000-\\u206f',
    rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange='\\ufe0e\\ufe0f',
    rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;

    /** Used to compose unicode capture groups. */
    var rsApos="['\u2019]",
    rsAstral='['+rsAstralRange+']',
    rsBreak='['+rsBreakRange+']',
    rsCombo='['+rsComboRange+']',
    rsDigits='\\d+',
    rsDingbat='['+rsDingbatRange+']',
    rsLower='['+rsLowerRange+']',
    rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',
    rsFitz='\\ud83c[\\udffb-\\udfff]',
    rsModifier='(?:'+rsCombo+'|'+rsFitz+')',
    rsNonAstral='[^'+rsAstralRange+']',
    rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper='['+rsUpperRange+']',
    rsZWJ='\\u200d';

    /** Used to compose unicode regexes. */
    var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',
    rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',
    rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',
    reOptMod=rsModifier+'?',
    rsOptVar='['+rsVarRange+']?',
    rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',
    rsOrdLower='\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper='\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq=rsOptVar+reOptMod+rsOptJoin,
    rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,
    rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';

    /** Used to match apostrophes. */
    var reApos=RegExp(rsApos,'g');

    /**
    	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
    	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
    	   */
    var reComboMark=RegExp(rsCombo,'g');

    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
    var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');

    /** Used to match complex or compound words. */
    var reUnicodeWord=RegExp([
    rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',
    rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',
    rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,
    rsUpper+'+'+rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji].
    join('|'),'g');

    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
    var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');

    /** Used to detect strings that need a more robust regexp to match words. */
    var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

    /** Used to assign default `context` object properties. */
    var contextProps=[
    'Array','Buffer','DataView','Date','Error','Float32Array','Float64Array',
    'Function','Int8Array','Int16Array','Int32Array','Map','Math','Object',
    'Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array',
    'Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap',
    '_','clearTimeout','isFinite','parseInt','setTimeout'];


    /** Used to make template sourceURLs easier to identify. */
    var templateCounter=-1;

    /** Used to identify `toStringTag` values of typed arrays. */
    var typedArrayTags={};
    typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=
    typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=
    typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=
    typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=
    typedArrayTags[uint32Tag]=true;
    typedArrayTags[argsTag]=typedArrayTags[arrayTag]=
    typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=
    typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=
    typedArrayTags[errorTag]=typedArrayTags[funcTag]=
    typedArrayTags[mapTag]=typedArrayTags[numberTag]=
    typedArrayTags[objectTag]=typedArrayTags[regexpTag]=
    typedArrayTags[setTag]=typedArrayTags[stringTag]=
    typedArrayTags[weakMapTag]=false;

    /** Used to identify `toStringTag` values supported by `_.clone`. */
    var cloneableTags={};
    cloneableTags[argsTag]=cloneableTags[arrayTag]=
    cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=
    cloneableTags[boolTag]=cloneableTags[dateTag]=
    cloneableTags[float32Tag]=cloneableTags[float64Tag]=
    cloneableTags[int8Tag]=cloneableTags[int16Tag]=
    cloneableTags[int32Tag]=cloneableTags[mapTag]=
    cloneableTags[numberTag]=cloneableTags[objectTag]=
    cloneableTags[regexpTag]=cloneableTags[setTag]=
    cloneableTags[stringTag]=cloneableTags[symbolTag]=
    cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=
    cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;
    cloneableTags[errorTag]=cloneableTags[funcTag]=
    cloneableTags[weakMapTag]=false;

    /** Used to map Latin Unicode letters to basic Latin letters. */
    var deburredLetters={
    // Latin-1 Supplement block.
    '\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A',
    '\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a',
    '\xc7':'C','\xe7':'c',
    '\xd0':'D','\xf0':'d',
    '\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E',
    '\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e',
    '\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I',
    '\xec':'i','\xed':'i','\xee':'i','\xef':'i',
    '\xd1':'N','\xf1':'n',
    '\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O',
    '\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o',
    '\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U',
    '\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u',
    '\xdd':'Y','\xfd':'y','\xff':'y',
    '\xc6':'Ae','\xe6':'ae',
    '\xde':'Th','\xfe':'th',
    '\xdf':'ss',
    // Latin Extended-A block.
    '\u0100':'A','\u0102':'A','\u0104':'A',
    '\u0101':'a','\u0103':'a','\u0105':'a',
    '\u0106':'C','\u0108':'C','\u010a':'C','\u010c':'C',
    '\u0107':'c','\u0109':'c','\u010b':'c','\u010d':'c',
    '\u010e':'D','\u0110':'D','\u010f':'d','\u0111':'d',
    '\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011a':'E',
    '\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011b':'e',
    '\u011c':'G','\u011e':'G','\u0120':'G','\u0122':'G',
    '\u011d':'g','\u011f':'g','\u0121':'g','\u0123':'g',
    '\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h',
    '\u0128':'I','\u012a':'I','\u012c':'I','\u012e':'I','\u0130':'I',
    '\u0129':'i','\u012b':'i','\u012d':'i','\u012f':'i','\u0131':'i',
    '\u0134':'J','\u0135':'j',
    '\u0136':'K','\u0137':'k','\u0138':'k',
    '\u0139':'L','\u013b':'L','\u013d':'L','\u013f':'L','\u0141':'L',
    '\u013a':'l','\u013c':'l','\u013e':'l','\u0140':'l','\u0142':'l',
    '\u0143':'N','\u0145':'N','\u0147':'N','\u014a':'N',
    '\u0144':'n','\u0146':'n','\u0148':'n','\u014b':'n',
    '\u014c':'O','\u014e':'O','\u0150':'O',
    '\u014d':'o','\u014f':'o','\u0151':'o',
    '\u0154':'R','\u0156':'R','\u0158':'R',
    '\u0155':'r','\u0157':'r','\u0159':'r',
    '\u015a':'S','\u015c':'S','\u015e':'S','\u0160':'S',
    '\u015b':'s','\u015d':'s','\u015f':'s','\u0161':'s',
    '\u0162':'T','\u0164':'T','\u0166':'T',
    '\u0163':'t','\u0165':'t','\u0167':'t',
    '\u0168':'U','\u016a':'U','\u016c':'U','\u016e':'U','\u0170':'U','\u0172':'U',
    '\u0169':'u','\u016b':'u','\u016d':'u','\u016f':'u','\u0171':'u','\u0173':'u',
    '\u0174':'W','\u0175':'w',
    '\u0176':'Y','\u0177':'y','\u0178':'Y',
    '\u0179':'Z','\u017b':'Z','\u017d':'Z',
    '\u017a':'z','\u017c':'z','\u017e':'z',
    '\u0132':'IJ','\u0133':'ij',
    '\u0152':'Oe','\u0153':'oe',
    '\u0149':"'n",'\u017f':'s'};


    /** Used to map characters to HTML entities. */
    var htmlEscapes={
    '&':'&amp;',
    '<':'&lt;',
    '>':'&gt;',
    '"':'&quot;',
    "'":'&#39;'};


    /** Used to map HTML entities to characters. */
    var htmlUnescapes={
    '&amp;':'&',
    '&lt;':'<',
    '&gt;':'>',
    '&quot;':'"',
    '&#39;':"'"};


    /** Used to escape characters for inclusion in compiled string literals. */
    var stringEscapes={
    '\\':'\\',
    "'":"'",
    '\n':'n',
    '\r':'r',
    '\u2028':'u2028',
    '\u2029':'u2029'};


    /** Built-in method references without a dependency on `root`. */
    var freeParseFloat=parseFloat,
    freeParseInt=parseInt;

    /** Detect free variable `global` from Node.js. */
    var freeGlobal=typeof commonjsGlobal=='object'&&commonjsGlobal&&commonjsGlobal.Object===Object&&commonjsGlobal;

    /** Detect free variable `self`. */
    var freeSelf=typeof self=='object'&&self&&self.Object===Object&&self;

    /** Used as a reference to the global object. */
    var root=freeGlobal||freeSelf||Function('return this')();

    /** Detect free variable `exports`. */
    var freeExports=exports&&!exports.nodeType&&exports;

    /** Detect free variable `module`. */
    var freeModule=freeExports&&'object'=='object'&&module&&!module.nodeType&&module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports=freeModule&&freeModule.exports===freeExports;

    /** Detect free variable `process` from Node.js. */
    var freeProcess=moduleExports&&freeGlobal.process;

    /** Used to access faster Node.js helpers. */
    var nodeUtil=function(){
    try{
    // Use `util.types` for Node.js 10+.
    var types=freeModule&&freeModule.require&&freeModule.require('util').types;

    if(types){
    return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess&&freeProcess.binding&&freeProcess.binding('util');
    }catch(e){}
    }();

    /* Node.js helper references. */
    var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,
    nodeIsDate=nodeUtil&&nodeUtil.isDate,
    nodeIsMap=nodeUtil&&nodeUtil.isMap,
    nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,
    nodeIsSet=nodeUtil&&nodeUtil.isSet,
    nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;

    /*--------------------------------------------------------------------------*/

    /**
    	   * A faster alternative to `Function#apply`, this function invokes `func`
    	   * with the `this` binding of `thisArg` and the arguments of `args`.
    	   *
    	   * @private
    	   * @param {Function} func The function to invoke.
    	   * @param {*} thisArg The `this` binding of `func`.
    	   * @param {Array} args The arguments to invoke `func` with.
    	   * @returns {*} Returns the result of `func`.
    	   */
    function apply(func,thisArg,args){
    switch(args.length){
    case 0:return func.call(thisArg);
    case 1:return func.call(thisArg,args[0]);
    case 2:return func.call(thisArg,args[0],args[1]);
    case 3:return func.call(thisArg,args[0],args[1],args[2]);}

    return func.apply(thisArg,args);
    }

    /**
    	   * A specialized version of `baseAggregator` for arrays.
    	   *
    	   * @private
    	   * @param {Array} [array] The array to iterate over.
    	   * @param {Function} setter The function to set `accumulator` values.
    	   * @param {Function} iteratee The iteratee to transform keys.
    	   * @param {Object} accumulator The initial aggregated object.
    	   * @returns {Function} Returns `accumulator`.
    	   */
    function arrayAggregator(array,setter,iteratee,accumulator){
    var index=-1,
    length=array==null?0:array.length;

    while(++index<length){
    var value=array[index];
    setter(accumulator,value,iteratee(value),array);
    }
    return accumulator;
    }

    /**
    	   * A specialized version of `_.forEach` for arrays without support for
    	   * iteratee shorthands.
    	   *
    	   * @private
    	   * @param {Array} [array] The array to iterate over.
    	   * @param {Function} iteratee The function invoked per iteration.
    	   * @returns {Array} Returns `array`.
    	   */
    function arrayEach(array,iteratee){
    var index=-1,
    length=array==null?0:array.length;

    while(++index<length){
    if(iteratee(array[index],index,array)===false){
    break;
    }
    }
    return array;
    }

    /**
    	   * A specialized version of `_.forEachRight` for arrays without support for
    	   * iteratee shorthands.
    	   *
    	   * @private
    	   * @param {Array} [array] The array to iterate over.
    	   * @param {Function} iteratee The function invoked per iteration.
    	   * @returns {Array} Returns `array`.
    	   */
    function arrayEachRight(array,iteratee){
    var length=array==null?0:array.length;

    while(length--){
    if(iteratee(array[length],length,array)===false){
    break;
    }
    }
    return array;
    }

    /**
    	   * A specialized version of `_.every` for arrays without support for
    	   * iteratee shorthands.
    	   *
    	   * @private
    	   * @param {Array} [array] The array to iterate over.
    	   * @param {Function} predicate The function invoked per iteration.
    	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
    	   *  else `false`.
    	   */
    function arrayEvery(array,predicate){
    var index=-1,
    length=array==null?0:array.length;

    while(++index<length){
    if(!predicate(array[index],index,array)){
    return false;
    }
    }
    return true;
    }

    /**
    	   * A specialized version of `_.filter` for arrays without support for
    	   * iteratee shorthands.
    	   *
    	   * @private
    	   * @param {Array} [array] The array to iterate over.
    	   * @param {Function} predicate The function invoked per iteration.
    	   * @returns {Array} Returns the new filtered array.
    	   */
    function arrayFilter(array,predicate){
    var index=-1,
    length=array==null?0:array.length,
    resIndex=0,
    result=[];

    while(++index<length){
    var value=array[index];
    if(predicate(value,index,array)){
    result[resIndex++]=value;
    }
    }
    return result;
    }

    /**
    	   * A specialized version of `_.includes` for arrays without support for
    	   * specifying an index to search from.
    	   *
    	   * @private
    	   * @param {Array} [array] The array to inspect.
    	   * @param {*} target The value to search for.
    	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
    	   */
    function arrayIncludes(array,value){
    var length=array==null?0:array.length;
    return !!length&&baseIndexOf(array,value,0)>-1;
    }

    /**
    	   * This function is like `arrayIncludes` except that it accepts a comparator.
    	   *
    	   * @private
    	   * @param {Array} [array] The array to inspect.
    	   * @param {*} target The value to search for.
    	   * @param {Function} comparator The comparator invoked per element.
    	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
    	   */
    function arrayIncludesWith(array,value,comparator){
    var index=-1,
    length=array==null?0:array.length;

    while(++index<length){
    if(comparator(value,array[index])){
    return true;
    }
    }
    return false;
    }

    /**
    	   * A specialized version of `_.map` for arrays without support for iteratee
    	   * shorthands.
    	   *
    	   * @private
    	   * @param {Array} [array] The array to iterate over.
    	   * @param {Function} iteratee The function invoked per iteration.
    	   * @returns {Array} Returns the new mapped array.
    	   */
    function arrayMap(array,iteratee){
    var index=-1,
    length=array==null?0:array.length,
    result=Array(length);

    while(++index<length){
    result[index]=iteratee(array[index],index,array);
    }
    return result;
    }

    /**
    	   * Appends the elements of `values` to `array`.
    	   *
    	   * @private
    	   * @param {Array} array The array to modify.
    	   * @param {Array} values The values to append.
    	   * @returns {Array} Returns `array`.
    	   */
    function arrayPush(array,values){
    var index=-1,
    length=values.length,
    offset=array.length;

    while(++index<length){
    array[offset+index]=values[index];
    }
    return array;
    }

    /**
    	   * A specialized version of `_.reduce` for arrays without support for
    	   * iteratee shorthands.
    	   *
    	   * @private
    	   * @param {Array} [array] The array to iterate over.
    	   * @param {Function} iteratee The function invoked per iteration.
    	   * @param {*} [accumulator] The initial value.
    	   * @param {boolean} [initAccum] Specify using the first element of `array` as
    	   *  the initial value.
    	   * @returns {*} Returns the accumulated value.
    	   */
    function arrayReduce(array,iteratee,accumulator,initAccum){
    var index=-1,
    length=array==null?0:array.length;

    if(initAccum&&length){
    accumulator=array[++index];
    }
    while(++index<length){
    accumulator=iteratee(accumulator,array[index],index,array);
    }
    return accumulator;
    }

    /**
    	   * A specialized version of `_.reduceRight` for arrays without support for
    	   * iteratee shorthands.
    	   *
    	   * @private
    	   * @param {Array} [array] The array to iterate over.
    	   * @param {Function} iteratee The function invoked per iteration.
    	   * @param {*} [accumulator] The initial value.
    	   * @param {boolean} [initAccum] Specify using the last element of `array` as
    	   *  the initial value.
    	   * @returns {*} Returns the accumulated value.
    	   */
    function arrayReduceRight(array,iteratee,accumulator,initAccum){
    var length=array==null?0:array.length;
    if(initAccum&&length){
    accumulator=array[--length];
    }
    while(length--){
    accumulator=iteratee(accumulator,array[length],length,array);
    }
    return accumulator;
    }

    /**
    	   * A specialized version of `_.some` for arrays without support for iteratee
    	   * shorthands.
    	   *
    	   * @private
    	   * @param {Array} [array] The array to iterate over.
    	   * @param {Function} predicate The function invoked per iteration.
    	   * @returns {boolean} Returns `true` if any element passes the predicate check,
    	   *  else `false`.
    	   */
    function arraySome(array,predicate){
    var index=-1,
    length=array==null?0:array.length;

    while(++index<length){
    if(predicate(array[index],index,array)){
    return true;
    }
    }
    return false;
    }

    /**
    	   * Gets the size of an ASCII `string`.
    	   *
    	   * @private
    	   * @param {string} string The string inspect.
    	   * @returns {number} Returns the string size.
    	   */
    var asciiSize=baseProperty('length');

    /**
    	   * Converts an ASCII `string` to an array.
    	   *
    	   * @private
    	   * @param {string} string The string to convert.
    	   * @returns {Array} Returns the converted array.
    	   */
    function asciiToArray(string){
    return string.split('');
    }

    /**
    	   * Splits an ASCII `string` into an array of its words.
    	   *
    	   * @private
    	   * @param {string} The string to inspect.
    	   * @returns {Array} Returns the words of `string`.
    	   */
    function asciiWords(string){
    return string.match(reAsciiWord)||[];
    }

    /**
    	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
    	   * without support for iteratee shorthands, which iterates over `collection`
    	   * using `eachFunc`.
    	   *
    	   * @private
    	   * @param {Array|Object} collection The collection to inspect.
    	   * @param {Function} predicate The function invoked per iteration.
    	   * @param {Function} eachFunc The function to iterate over `collection`.
    	   * @returns {*} Returns the found element or its key, else `undefined`.
    	   */
    function baseFindKey(collection,predicate,eachFunc){
    var result;
    eachFunc(collection,function(value,key,collection){
    if(predicate(value,key,collection)){
    result=key;
    return false;
    }
    });
    return result;
    }

    /**
    	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
    	   * support for iteratee shorthands.
    	   *
    	   * @private
    	   * @param {Array} array The array to inspect.
    	   * @param {Function} predicate The function invoked per iteration.
    	   * @param {number} fromIndex The index to search from.
    	   * @param {boolean} [fromRight] Specify iterating from right to left.
    	   * @returns {number} Returns the index of the matched value, else `-1`.
    	   */
    function baseFindIndex(array,predicate,fromIndex,fromRight){
    var length=array.length,
    index=fromIndex+(fromRight?1:-1);

    while(fromRight?index--:++index<length){
    if(predicate(array[index],index,array)){
    return index;
    }
    }
    return -1;
    }

    /**
    	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
    	   *
    	   * @private
    	   * @param {Array} array The array to inspect.
    	   * @param {*} value The value to search for.
    	   * @param {number} fromIndex The index to search from.
    	   * @returns {number} Returns the index of the matched value, else `-1`.
    	   */
    function baseIndexOf(array,value,fromIndex){
    return value===value?
    strictIndexOf(array,value,fromIndex):
    baseFindIndex(array,baseIsNaN,fromIndex);
    }

    /**
    	   * This function is like `baseIndexOf` except that it accepts a comparator.
    	   *
    	   * @private
    	   * @param {Array} array The array to inspect.
    	   * @param {*} value The value to search for.
    	   * @param {number} fromIndex The index to search from.
    	   * @param {Function} comparator The comparator invoked per element.
    	   * @returns {number} Returns the index of the matched value, else `-1`.
    	   */
    function baseIndexOfWith(array,value,fromIndex,comparator){
    var index=fromIndex-1,
    length=array.length;

    while(++index<length){
    if(comparator(array[index],value)){
    return index;
    }
    }
    return -1;
    }

    /**
    	   * The base implementation of `_.isNaN` without support for number objects.
    	   *
    	   * @private
    	   * @param {*} value The value to check.
    	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
    	   */
    function baseIsNaN(value){
    return value!==value;
    }

    /**
    	   * The base implementation of `_.mean` and `_.meanBy` without support for
    	   * iteratee shorthands.
    	   *
    	   * @private
    	   * @param {Array} array The array to iterate over.
    	   * @param {Function} iteratee The function invoked per iteration.
    	   * @returns {number} Returns the mean.
    	   */
    function baseMean(array,iteratee){
    var length=array==null?0:array.length;
    return length?baseSum(array,iteratee)/length:NAN;
    }

    /**
    	   * The base implementation of `_.property` without support for deep paths.
    	   *
    	   * @private
    	   * @param {string} key The key of the property to get.
    	   * @returns {Function} Returns the new accessor function.
    	   */
    function baseProperty(key){
    return function(object){
    return object==null?undefined$1:object[key];
    };
    }

    /**
    	   * The base implementation of `_.propertyOf` without support for deep paths.
    	   *
    	   * @private
    	   * @param {Object} object The object to query.
    	   * @returns {Function} Returns the new accessor function.
    	   */
    function basePropertyOf(object){
    return function(key){
    return object==null?undefined$1:object[key];
    };
    }

    /**
    	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
    	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
    	   *
    	   * @private
    	   * @param {Array|Object} collection The collection to iterate over.
    	   * @param {Function} iteratee The function invoked per iteration.
    	   * @param {*} accumulator The initial value.
    	   * @param {boolean} initAccum Specify using the first or last element of
    	   *  `collection` as the initial value.
    	   * @param {Function} eachFunc The function to iterate over `collection`.
    	   * @returns {*} Returns the accumulated value.
    	   */
    function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){
    eachFunc(collection,function(value,index,collection){
    accumulator=initAccum?(
    initAccum=false,value):
    iteratee(accumulator,value,index,collection);
    });
    return accumulator;
    }

    /**
    	   * The base implementation of `_.sortBy` which uses `comparer` to define the
    	   * sort order of `array` and replaces criteria objects with their corresponding
    	   * values.
    	   *
    	   * @private
    	   * @param {Array} array The array to sort.
    	   * @param {Function} comparer The function to define sort order.
    	   * @returns {Array} Returns `array`.
    	   */
    function baseSortBy(array,comparer){
    var length=array.length;

    array.sort(comparer);
    while(length--){
    array[length]=array[length].value;
    }
    return array;
    }

    /**
    	   * The base implementation of `_.sum` and `_.sumBy` without support for
    	   * iteratee shorthands.
    	   *
    	   * @private
    	   * @param {Array} array The array to iterate over.
    	   * @param {Function} iteratee The function invoked per iteration.
    	   * @returns {number} Returns the sum.
    	   */
    function baseSum(array,iteratee){
    var result,
    index=-1,
    length=array.length;

    while(++index<length){
    var current=iteratee(array[index]);
    if(current!==undefined$1){
    result=result===undefined$1?current:result+current;
    }
    }
    return result;
    }

    /**
    	   * The base implementation of `_.times` without support for iteratee shorthands
    	   * or max array length checks.
    	   *
    	   * @private
    	   * @param {number} n The number of times to invoke `iteratee`.
    	   * @param {Function} iteratee The function invoked per iteration.
    	   * @returns {Array} Returns the array of results.
    	   */
    function baseTimes(n,iteratee){
    var index=-1,
    result=Array(n);

    while(++index<n){
    result[index]=iteratee(index);
    }
    return result;
    }

    /**
    	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
    	   * of key-value pairs for `object` corresponding to the property names of `props`.
    	   *
    	   * @private
    	   * @param {Object} object The object to query.
    	   * @param {Array} props The property names to get values for.
    	   * @returns {Object} Returns the key-value pairs.
    	   */
    function baseToPairs(object,props){
    return arrayMap(props,function(key){
    return [key,object[key]];
    });
    }

    /**
    	   * The base implementation of `_.trim`.
    	   *
    	   * @private
    	   * @param {string} string The string to trim.
    	   * @returns {string} Returns the trimmed string.
    	   */
    function baseTrim(string){
    return string?
    string.slice(0,trimmedEndIndex(string)+1).replace(reTrimStart,''):
    string;
    }

    /**
    	   * The base implementation of `_.unary` without support for storing metadata.
    	   *
    	   * @private
    	   * @param {Function} func The function to cap arguments for.
    	   * @returns {Function} Returns the new capped function.
    	   */
    function baseUnary(func){
    return function(value){
    return func(value);
    };
    }

    /**
    	   * The base implementation of `_.values` and `_.valuesIn` which creates an
    	   * array of `object` property values corresponding to the property names
    	   * of `props`.
    	   *
    	   * @private
    	   * @param {Object} object The object to query.
    	   * @param {Array} props The property names to get values for.
    	   * @returns {Object} Returns the array of property values.
    	   */
    function baseValues(object,props){
    return arrayMap(props,function(key){
    return object[key];
    });
    }

    /**
    	   * Checks if a `cache` value for `key` exists.
    	   *
    	   * @private
    	   * @param {Object} cache The cache to query.
    	   * @param {string} key The key of the entry to check.
    	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
    	   */
    function cacheHas(cache,key){
    return cache.has(key);
    }

    /**
    	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
    	   * that is not found in the character symbols.
    	   *
    	   * @private
    	   * @param {Array} strSymbols The string symbols to inspect.
    	   * @param {Array} chrSymbols The character symbols to find.
    	   * @returns {number} Returns the index of the first unmatched string symbol.
    	   */
    function charsStartIndex(strSymbols,chrSymbols){
    var index=-1,
    length=strSymbols.length;

    while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}
    return index;
    }

    /**
    	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
    	   * that is not found in the character symbols.
    	   *
    	   * @private
    	   * @param {Array} strSymbols The string symbols to inspect.
    	   * @param {Array} chrSymbols The character symbols to find.
    	   * @returns {number} Returns the index of the last unmatched string symbol.
    	   */
    function charsEndIndex(strSymbols,chrSymbols){
    var index=strSymbols.length;

    while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}
    return index;
    }

    /**
    	   * Gets the number of `placeholder` occurrences in `array`.
    	   *
    	   * @private
    	   * @param {Array} array The array to inspect.
    	   * @param {*} placeholder The placeholder to search for.
    	   * @returns {number} Returns the placeholder count.
    	   */
    function countHolders(array,placeholder){
    var length=array.length,
    result=0;

    while(length--){
    if(array[length]===placeholder){
    ++result;
    }
    }
    return result;
    }

    /**
    	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
    	   * letters to basic Latin letters.
    	   *
    	   * @private
    	   * @param {string} letter The matched letter to deburr.
    	   * @returns {string} Returns the deburred letter.
    	   */
    var deburrLetter=basePropertyOf(deburredLetters);

    /**
    	   * Used by `_.escape` to convert characters to HTML entities.
    	   *
    	   * @private
    	   * @param {string} chr The matched character to escape.
    	   * @returns {string} Returns the escaped character.
    	   */
    var escapeHtmlChar=basePropertyOf(htmlEscapes);

    /**
    	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
    	   *
    	   * @private
    	   * @param {string} chr The matched character to escape.
    	   * @returns {string} Returns the escaped character.
    	   */
    function escapeStringChar(chr){
    return '\\'+stringEscapes[chr];
    }

    /**
    	   * Gets the value at `key` of `object`.
    	   *
    	   * @private
    	   * @param {Object} [object] The object to query.
    	   * @param {string} key The key of the property to get.
    	   * @returns {*} Returns the property value.
    	   */
    function getValue(object,key){
    return object==null?undefined$1:object[key];
    }

    /**
    	   * Checks if `string` contains Unicode symbols.
    	   *
    	   * @private
    	   * @param {string} string The string to inspect.
    	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
    	   */
    function hasUnicode(string){
    return reHasUnicode.test(string);
    }

    /**
    	   * Checks if `string` contains a word composed of Unicode symbols.
    	   *
    	   * @private
    	   * @param {string} string The string to inspect.
    	   * @returns {boolean} Returns `true` if a word is found, else `false`.
    	   */
    function hasUnicodeWord(string){
    return reHasUnicodeWord.test(string);
    }

    /**
    	   * Converts `iterator` to an array.
    	   *
    	   * @private
    	   * @param {Object} iterator The iterator to convert.
    	   * @returns {Array} Returns the converted array.
    	   */
    function iteratorToArray(iterator){
    var data,
    result=[];

    while(!(data=iterator.next()).done){
    result.push(data.value);
    }
    return result;
    }

    /**
    	   * Converts `map` to its key-value pairs.
    	   *
    	   * @private
    	   * @param {Object} map The map to convert.
    	   * @returns {Array} Returns the key-value pairs.
    	   */
    function mapToArray(map){
    var index=-1,
    result=Array(map.size);

    map.forEach(function(value,key){
    result[++index]=[key,value];
    });
    return result;
    }

    /**
    	   * Creates a unary function that invokes `func` with its argument transformed.
    	   *
    	   * @private
    	   * @param {Function} func The function to wrap.
    	   * @param {Function} transform The argument transform.
    	   * @returns {Function} Returns the new function.
    	   */
    function overArg(func,transform){
    return function(arg){
    return func(transform(arg));
    };
    }

    /**
    	   * Replaces all `placeholder` elements in `array` with an internal placeholder
    	   * and returns an array of their indexes.
    	   *
    	   * @private
    	   * @param {Array} array The array to modify.
    	   * @param {*} placeholder The placeholder to replace.
    	   * @returns {Array} Returns the new array of placeholder indexes.
    	   */
    function replaceHolders(array,placeholder){
    var index=-1,
    length=array.length,
    resIndex=0,
    result=[];

    while(++index<length){
    var value=array[index];
    if(value===placeholder||value===PLACEHOLDER){
    array[index]=PLACEHOLDER;
    result[resIndex++]=index;
    }
    }
    return result;
    }

    /**
    	   * Converts `set` to an array of its values.
    	   *
    	   * @private
    	   * @param {Object} set The set to convert.
    	   * @returns {Array} Returns the values.
    	   */
    function setToArray(set){
    var index=-1,
    result=Array(set.size);

    set.forEach(function(value){
    result[++index]=value;
    });
    return result;
    }

    /**
    	   * Converts `set` to its value-value pairs.
    	   *
    	   * @private
    	   * @param {Object} set The set to convert.
    	   * @returns {Array} Returns the value-value pairs.
    	   */
    function setToPairs(set){
    var index=-1,
    result=Array(set.size);

    set.forEach(function(value){
    result[++index]=[value,value];
    });
    return result;
    }

    /**
    	   * A specialized version of `_.indexOf` which performs strict equality
    	   * comparisons of values, i.e. `===`.
    	   *
    	   * @private
    	   * @param {Array} array The array to inspect.
    	   * @param {*} value The value to search for.
    	   * @param {number} fromIndex The index to search from.
    	   * @returns {number} Returns the index of the matched value, else `-1`.
    	   */
    function strictIndexOf(array,value,fromIndex){
    var index=fromIndex-1,
    length=array.length;

    while(++index<length){
    if(array[index]===value){
    return index;
    }
    }
    return -1;
    }

    /**
    	   * A specialized version of `_.lastIndexOf` which performs strict equality
    	   * comparisons of values, i.e. `===`.
    	   *
    	   * @private
    	   * @param {Array} array The array to inspect.
    	   * @param {*} value The value to search for.
    	   * @param {number} fromIndex The index to search from.
    	   * @returns {number} Returns the index of the matched value, else `-1`.
    	   */
    function strictLastIndexOf(array,value,fromIndex){
    var index=fromIndex+1;
    while(index--){
    if(array[index]===value){
    return index;
    }
    }
    return index;
    }

    /**
    	   * Gets the number of symbols in `string`.
    	   *
    	   * @private
    	   * @param {string} string The string to inspect.
    	   * @returns {number} Returns the string size.
    	   */
    function stringSize(string){
    return hasUnicode(string)?
    unicodeSize(string):
    asciiSize(string);
    }

    /**
    	   * Converts `string` to an array.
    	   *
    	   * @private
    	   * @param {string} string The string to convert.
    	   * @returns {Array} Returns the converted array.
    	   */
    function stringToArray(string){
    return hasUnicode(string)?
    unicodeToArray(string):
    asciiToArray(string);
    }

    /**
    	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
    	   * character of `string`.
    	   *
    	   * @private
    	   * @param {string} string The string to inspect.
    	   * @returns {number} Returns the index of the last non-whitespace character.
    	   */
    function trimmedEndIndex(string){
    var index=string.length;

    while(index--&&reWhitespace.test(string.charAt(index))){}
    return index;
    }

    /**
    	   * Used by `_.unescape` to convert HTML entities to characters.
    	   *
    	   * @private
    	   * @param {string} chr The matched character to unescape.
    	   * @returns {string} Returns the unescaped character.
    	   */
    var unescapeHtmlChar=basePropertyOf(htmlUnescapes);

    /**
    	   * Gets the size of a Unicode `string`.
    	   *
    	   * @private
    	   * @param {string} string The string inspect.
    	   * @returns {number} Returns the string size.
    	   */
    function unicodeSize(string){
    var result=reUnicode.lastIndex=0;
    while(reUnicode.test(string)){
    ++result;
    }
    return result;
    }

    /**
    	   * Converts a Unicode `string` to an array.
    	   *
    	   * @private
    	   * @param {string} string The string to convert.
    	   * @returns {Array} Returns the converted array.
    	   */
    function unicodeToArray(string){
    return string.match(reUnicode)||[];
    }

    /**
    	   * Splits a Unicode `string` into an array of its words.
    	   *
    	   * @private
    	   * @param {string} The string to inspect.
    	   * @returns {Array} Returns the words of `string`.
    	   */
    function unicodeWords(string){
    return string.match(reUnicodeWord)||[];
    }

    /*--------------------------------------------------------------------------*/

    /**
    	   * Create a new pristine `lodash` function using the `context` object.
    	   *
    	   * @static
    	   * @memberOf _
    	   * @since 1.1.0
    	   * @category Util
    	   * @param {Object} [context=root] The context object.
    	   * @returns {Function} Returns a new `lodash` function.
    	   * @example
    	   *
    	   * _.mixin({ 'foo': _.constant('foo') });
    	   *
    	   * var lodash = _.runInContext();
    	   * lodash.mixin({ 'bar': lodash.constant('bar') });
    	   *
    	   * _.isFunction(_.foo);
    	   * // => true
    	   * _.isFunction(_.bar);
    	   * // => false
    	   *
    	   * lodash.isFunction(lodash.foo);
    	   * // => false
    	   * lodash.isFunction(lodash.bar);
    	   * // => true
    	   *
    	   * // Create a suped-up `defer` in Node.js.
    	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
    	   */
    var runInContext=function runInContext(context){
    context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));

    /** Built-in constructor references. */
    var Array=context.Array,
    Date=context.Date,
    Error=context.Error,
    Function=context.Function,
    Math=context.Math,
    Object=context.Object,
    RegExp=context.RegExp,
    String=context.String,
    TypeError=context.TypeError;

    /** Used for built-in method references. */
    var arrayProto=Array.prototype,
    funcProto=Function.prototype,
    objectProto=Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData=context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString=funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty=objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter=0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey=function(){
    var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');
    return uid?'Symbol(src)_1.'+uid:'';
    }();

    /**
    	     * Used to resolve the
    	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
    	     * of values.
    	     */
    var nativeObjectToString=objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString=funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash=root._;

    /** Used to detect if a method is native. */
    var reIsNative=RegExp('^'+
    funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').
    replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');


    /** Built-in value references. */
    var Buffer=moduleExports?context.Buffer:undefined$1,
    Symbol=context.Symbol,
    Uint8Array=context.Uint8Array,
    allocUnsafe=Buffer?Buffer.allocUnsafe:undefined$1,
    getPrototype=overArg(Object.getPrototypeOf,Object),
    objectCreate=Object.create,
    propertyIsEnumerable=objectProto.propertyIsEnumerable,
    splice=arrayProto.splice,
    spreadableSymbol=Symbol?Symbol.isConcatSpreadable:undefined$1,
    symIterator=Symbol?Symbol.iterator:undefined$1,
    symToStringTag=Symbol?Symbol.toStringTag:undefined$1;

    var defineProperty=function(){
    try{
    var func=getNative(Object,'defineProperty');
    func({},'',{});
    return func;
    }catch(e){}
    }();

    /** Mocked built-ins. */
    var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,
    ctxNow=Date&&Date.now!==root.Date.now&&Date.now,
    ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil=Math.ceil,
    nativeFloor=Math.floor,
    nativeGetSymbols=Object.getOwnPropertySymbols,
    nativeIsBuffer=Buffer?Buffer.isBuffer:undefined$1,
    nativeIsFinite=context.isFinite,
    nativeJoin=arrayProto.join,
    nativeKeys=overArg(Object.keys,Object),
    nativeMax=Math.max,
    nativeMin=Math.min,
    nativeNow=Date.now,
    nativeParseInt=context.parseInt,
    nativeRandom=Math.random,
    nativeReverse=arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView=getNative(context,'DataView'),
    Map=getNative(context,'Map'),
    Promise=getNative(context,'Promise'),
    Set=getNative(context,'Set'),
    WeakMap=getNative(context,'WeakMap'),
    nativeCreate=getNative(Object,'create');

    /** Used to store function metadata. */
    var metaMap=WeakMap&&new WeakMap();

    /** Used to lookup unminified function names. */
    var realNames={};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString=toSource(DataView),
    mapCtorString=toSource(Map),
    promiseCtorString=toSource(Promise),
    setCtorString=toSource(Set),
    weakMapCtorString=toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto=Symbol?Symbol.prototype:undefined$1,
    symbolValueOf=symbolProto?symbolProto.valueOf:undefined$1,
    symbolToString=symbolProto?symbolProto.toString:undefined$1;

    /*------------------------------------------------------------------------*/

    /**
    	     * Creates a `lodash` object which wraps `value` to enable implicit method
    	     * chain sequences. Methods that operate on and return arrays, collections,
    	     * and functions can be chained together. Methods that retrieve a single value
    	     * or may return a primitive value will automatically end the chain sequence
    	     * and return the unwrapped value. Otherwise, the value must be unwrapped
    	     * with `_#value`.
    	     *
    	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
    	     * enabled using `_.chain`.
    	     *
    	     * The execution of chained methods is lazy, that is, it's deferred until
    	     * `_#value` is implicitly or explicitly called.
    	     *
    	     * Lazy evaluation allows several methods to support shortcut fusion.
    	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
    	     * the creation of intermediate arrays and can greatly reduce the number of
    	     * iteratee executions. Sections of a chain sequence qualify for shortcut
    	     * fusion if the section is applied to an array and iteratees accept only
    	     * one argument. The heuristic for whether a section qualifies for shortcut
    	     * fusion is subject to change.
    	     *
    	     * Chaining is supported in custom builds as long as the `_#value` method is
    	     * directly or indirectly included in the build.
    	     *
    	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
    	     *
    	     * The wrapper `Array` methods are:
    	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
    	     *
    	     * The wrapper `String` methods are:
    	     * `replace` and `split`
    	     *
    	     * The wrapper methods that support shortcut fusion are:
    	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
    	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
    	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
    	     *
    	     * The chainable wrapper methods are:
    	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
    	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
    	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
    	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
    	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
    	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
    	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
    	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
    	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
    	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
    	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
    	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
    	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
    	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
    	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
    	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
    	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
    	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
    	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
    	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
    	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
    	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
    	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
    	     * `zipObject`, `zipObjectDeep`, and `zipWith`
    	     *
    	     * The wrapper methods that are **not** chainable by default are:
    	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
    	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
    	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
    	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
    	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
    	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
    	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
    	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
    	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
    	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
    	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
    	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
    	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
    	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
    	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
    	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
    	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
    	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
    	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
    	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
    	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
    	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
    	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
    	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
    	     * `upperFirst`, `value`, and `words`
    	     *
    	     * @name _
    	     * @constructor
    	     * @category Seq
    	     * @param {*} value The value to wrap in a `lodash` instance.
    	     * @returns {Object} Returns the new `lodash` wrapper instance.
    	     * @example
    	     *
    	     * function square(n) {
    	     *   return n * n;
    	     * }
    	     *
    	     * var wrapped = _([1, 2, 3]);
    	     *
    	     * // Returns an unwrapped value.
    	     * wrapped.reduce(_.add);
    	     * // => 6
    	     *
    	     * // Returns a wrapped value.
    	     * var squares = wrapped.map(square);
    	     *
    	     * _.isArray(squares);
    	     * // => false
    	     *
    	     * _.isArray(squares.value());
    	     * // => true
    	     */
    function lodash(value){
    if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){
    if(value instanceof LodashWrapper){
    return value;
    }
    if(hasOwnProperty.call(value,'__wrapped__')){
    return wrapperClone(value);
    }
    }
    return new LodashWrapper(value);
    }

    /**
    	     * The base implementation of `_.create` without support for assigning
    	     * properties to the created object.
    	     *
    	     * @private
    	     * @param {Object} proto The object to inherit from.
    	     * @returns {Object} Returns the new object.
    	     */
    var baseCreate=function(){
    function object(){}
    return function(proto){
    if(!isObject(proto)){
    return {};
    }
    if(objectCreate){
    return objectCreate(proto);
    }
    object.prototype=proto;
    var result=new object();
    object.prototype=undefined$1;
    return result;
    };
    }();

    /**
    	     * The function whose prototype chain sequence wrappers inherit from.
    	     *
    	     * @private
    	     */
    function baseLodash(){
    // No operation performed.
    }

    /**
    	     * The base constructor for creating `lodash` wrapper objects.
    	     *
    	     * @private
    	     * @param {*} value The value to wrap.
    	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
    	     */
    function LodashWrapper(value,chainAll){
    this.__wrapped__=value;
    this.__actions__=[];
    this.__chain__=!!chainAll;
    this.__index__=0;
    this.__values__=undefined$1;
    }

    /**
    	     * By default, the template delimiters used by lodash are like those in
    	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
    	     * following template settings to use alternative delimiters.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @type {Object}
    	     */
    lodash.templateSettings={

    /**
    	       * Used to detect `data` property values to be HTML-escaped.
    	       *
    	       * @memberOf _.templateSettings
    	       * @type {RegExp}
    	       */
    'escape':reEscape,

    /**
    	       * Used to detect code to be evaluated.
    	       *
    	       * @memberOf _.templateSettings
    	       * @type {RegExp}
    	       */
    'evaluate':reEvaluate,

    /**
    	       * Used to detect `data` property values to inject.
    	       *
    	       * @memberOf _.templateSettings
    	       * @type {RegExp}
    	       */
    'interpolate':reInterpolate,

    /**
    	       * Used to reference the data object in the template text.
    	       *
    	       * @memberOf _.templateSettings
    	       * @type {string}
    	       */
    'variable':'',

    /**
    	       * Used to import variables into the compiled template.
    	       *
    	       * @memberOf _.templateSettings
    	       * @type {Object}
    	       */
    'imports':{

    /**
    	         * A reference to the `lodash` function.
    	         *
    	         * @memberOf _.templateSettings.imports
    	         * @type {Function}
    	         */
    '_':lodash}};



    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype=baseLodash.prototype;
    lodash.prototype.constructor=lodash;

    LodashWrapper.prototype=baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor=LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
    	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
    	     *
    	     * @private
    	     * @constructor
    	     * @param {*} value The value to wrap.
    	     */
    function LazyWrapper(value){
    this.__wrapped__=value;
    this.__actions__=[];
    this.__dir__=1;
    this.__filtered__=false;
    this.__iteratees__=[];
    this.__takeCount__=MAX_ARRAY_LENGTH;
    this.__views__=[];
    }

    /**
    	     * Creates a clone of the lazy wrapper object.
    	     *
    	     * @private
    	     * @name clone
    	     * @memberOf LazyWrapper
    	     * @returns {Object} Returns the cloned `LazyWrapper` object.
    	     */
    function lazyClone(){
    var result=new LazyWrapper(this.__wrapped__);
    result.__actions__=copyArray(this.__actions__);
    result.__dir__=this.__dir__;
    result.__filtered__=this.__filtered__;
    result.__iteratees__=copyArray(this.__iteratees__);
    result.__takeCount__=this.__takeCount__;
    result.__views__=copyArray(this.__views__);
    return result;
    }

    /**
    	     * Reverses the direction of lazy iteration.
    	     *
    	     * @private
    	     * @name reverse
    	     * @memberOf LazyWrapper
    	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
    	     */
    function lazyReverse(){
    if(this.__filtered__){
    var result=new LazyWrapper(this);
    result.__dir__=-1;
    result.__filtered__=true;
    }else {
    result=this.clone();
    result.__dir__*=-1;
    }
    return result;
    }

    /**
    	     * Extracts the unwrapped value from its lazy wrapper.
    	     *
    	     * @private
    	     * @name value
    	     * @memberOf LazyWrapper
    	     * @returns {*} Returns the unwrapped value.
    	     */
    function lazyValue(){
    var array=this.__wrapped__.value(),
    dir=this.__dir__,
    isArr=isArray(array),
    isRight=dir<0,
    arrLength=isArr?array.length:0,
    view=getView(0,arrLength,this.__views__),
    start=view.start,
    end=view.end,
    length=end-start,
    index=isRight?end:start-1,
    iteratees=this.__iteratees__,
    iterLength=iteratees.length,
    resIndex=0,
    takeCount=nativeMin(length,this.__takeCount__);

    if(!isArr||!isRight&&arrLength==length&&takeCount==length){
    return baseWrapperValue(array,this.__actions__);
    }
    var result=[];

    outer:
    while(length--&&resIndex<takeCount){
    index+=dir;

    var iterIndex=-1,
    value=array[index];

    while(++iterIndex<iterLength){
    var data=iteratees[iterIndex],
    iteratee=data.iteratee,
    type=data.type,
    computed=iteratee(value);

    if(type==LAZY_MAP_FLAG){
    value=computed;
    }else if(!computed){
    if(type==LAZY_FILTER_FLAG){
    continue outer;
    }else {
    break outer;
    }
    }
    }
    result[resIndex++]=value;
    }
    return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype=baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor=LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
    	     * Creates a hash object.
    	     *
    	     * @private
    	     * @constructor
    	     * @param {Array} [entries] The key-value pairs to cache.
    	     */
    function Hash(entries){
    var index=-1,
    length=entries==null?0:entries.length;

    this.clear();
    while(++index<length){
    var entry=entries[index];
    this.set(entry[0],entry[1]);
    }
    }

    /**
    	     * Removes all key-value entries from the hash.
    	     *
    	     * @private
    	     * @name clear
    	     * @memberOf Hash
    	     */
    function hashClear(){
    this.__data__=nativeCreate?nativeCreate(null):{};
    this.size=0;
    }

    /**
    	     * Removes `key` and its value from the hash.
    	     *
    	     * @private
    	     * @name delete
    	     * @memberOf Hash
    	     * @param {Object} hash The hash to modify.
    	     * @param {string} key The key of the value to remove.
    	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
    	     */
    function hashDelete(key){
    var result=this.has(key)&&delete this.__data__[key];
    this.size-=result?1:0;
    return result;
    }

    /**
    	     * Gets the hash value for `key`.
    	     *
    	     * @private
    	     * @name get
    	     * @memberOf Hash
    	     * @param {string} key The key of the value to get.
    	     * @returns {*} Returns the entry value.
    	     */
    function hashGet(key){
    var data=this.__data__;
    if(nativeCreate){
    var result=data[key];
    return result===HASH_UNDEFINED?undefined$1:result;
    }
    return hasOwnProperty.call(data,key)?data[key]:undefined$1;
    }

    /**
    	     * Checks if a hash value for `key` exists.
    	     *
    	     * @private
    	     * @name has
    	     * @memberOf Hash
    	     * @param {string} key The key of the entry to check.
    	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
    	     */
    function hashHas(key){
    var data=this.__data__;
    return nativeCreate?data[key]!==undefined$1:hasOwnProperty.call(data,key);
    }

    /**
    	     * Sets the hash `key` to `value`.
    	     *
    	     * @private
    	     * @name set
    	     * @memberOf Hash
    	     * @param {string} key The key of the value to set.
    	     * @param {*} value The value to set.
    	     * @returns {Object} Returns the hash instance.
    	     */
    function hashSet(key,value){
    var data=this.__data__;
    this.size+=this.has(key)?0:1;
    data[key]=nativeCreate&&value===undefined$1?HASH_UNDEFINED:value;
    return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear=hashClear;
    Hash.prototype['delete']=hashDelete;
    Hash.prototype.get=hashGet;
    Hash.prototype.has=hashHas;
    Hash.prototype.set=hashSet;

    /*------------------------------------------------------------------------*/

    /**
    	     * Creates an list cache object.
    	     *
    	     * @private
    	     * @constructor
    	     * @param {Array} [entries] The key-value pairs to cache.
    	     */
    function ListCache(entries){
    var index=-1,
    length=entries==null?0:entries.length;

    this.clear();
    while(++index<length){
    var entry=entries[index];
    this.set(entry[0],entry[1]);
    }
    }

    /**
    	     * Removes all key-value entries from the list cache.
    	     *
    	     * @private
    	     * @name clear
    	     * @memberOf ListCache
    	     */
    function listCacheClear(){
    this.__data__=[];
    this.size=0;
    }

    /**
    	     * Removes `key` and its value from the list cache.
    	     *
    	     * @private
    	     * @name delete
    	     * @memberOf ListCache
    	     * @param {string} key The key of the value to remove.
    	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
    	     */
    function listCacheDelete(key){
    var data=this.__data__,
    index=assocIndexOf(data,key);

    if(index<0){
    return false;
    }
    var lastIndex=data.length-1;
    if(index==lastIndex){
    data.pop();
    }else {
    splice.call(data,index,1);
    }
    --this.size;
    return true;
    }

    /**
    	     * Gets the list cache value for `key`.
    	     *
    	     * @private
    	     * @name get
    	     * @memberOf ListCache
    	     * @param {string} key The key of the value to get.
    	     * @returns {*} Returns the entry value.
    	     */
    function listCacheGet(key){
    var data=this.__data__,
    index=assocIndexOf(data,key);

    return index<0?undefined$1:data[index][1];
    }

    /**
    	     * Checks if a list cache value for `key` exists.
    	     *
    	     * @private
    	     * @name has
    	     * @memberOf ListCache
    	     * @param {string} key The key of the entry to check.
    	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
    	     */
    function listCacheHas(key){
    return assocIndexOf(this.__data__,key)>-1;
    }

    /**
    	     * Sets the list cache `key` to `value`.
    	     *
    	     * @private
    	     * @name set
    	     * @memberOf ListCache
    	     * @param {string} key The key of the value to set.
    	     * @param {*} value The value to set.
    	     * @returns {Object} Returns the list cache instance.
    	     */
    function listCacheSet(key,value){
    var data=this.__data__,
    index=assocIndexOf(data,key);

    if(index<0){
    ++this.size;
    data.push([key,value]);
    }else {
    data[index][1]=value;
    }
    return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear=listCacheClear;
    ListCache.prototype['delete']=listCacheDelete;
    ListCache.prototype.get=listCacheGet;
    ListCache.prototype.has=listCacheHas;
    ListCache.prototype.set=listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
    	     * Creates a map cache object to store key-value pairs.
    	     *
    	     * @private
    	     * @constructor
    	     * @param {Array} [entries] The key-value pairs to cache.
    	     */
    function MapCache(entries){
    var index=-1,
    length=entries==null?0:entries.length;

    this.clear();
    while(++index<length){
    var entry=entries[index];
    this.set(entry[0],entry[1]);
    }
    }

    /**
    	     * Removes all key-value entries from the map.
    	     *
    	     * @private
    	     * @name clear
    	     * @memberOf MapCache
    	     */
    function mapCacheClear(){
    this.size=0;
    this.__data__={
    'hash':new Hash(),
    'map':new(Map||ListCache)(),
    'string':new Hash()};

    }

    /**
    	     * Removes `key` and its value from the map.
    	     *
    	     * @private
    	     * @name delete
    	     * @memberOf MapCache
    	     * @param {string} key The key of the value to remove.
    	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
    	     */
    function mapCacheDelete(key){
    var result=getMapData(this,key)['delete'](key);
    this.size-=result?1:0;
    return result;
    }

    /**
    	     * Gets the map value for `key`.
    	     *
    	     * @private
    	     * @name get
    	     * @memberOf MapCache
    	     * @param {string} key The key of the value to get.
    	     * @returns {*} Returns the entry value.
    	     */
    function mapCacheGet(key){
    return getMapData(this,key).get(key);
    }

    /**
    	     * Checks if a map value for `key` exists.
    	     *
    	     * @private
    	     * @name has
    	     * @memberOf MapCache
    	     * @param {string} key The key of the entry to check.
    	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
    	     */
    function mapCacheHas(key){
    return getMapData(this,key).has(key);
    }

    /**
    	     * Sets the map `key` to `value`.
    	     *
    	     * @private
    	     * @name set
    	     * @memberOf MapCache
    	     * @param {string} key The key of the value to set.
    	     * @param {*} value The value to set.
    	     * @returns {Object} Returns the map cache instance.
    	     */
    function mapCacheSet(key,value){
    var data=getMapData(this,key),
    size=data.size;

    data.set(key,value);
    this.size+=data.size==size?0:1;
    return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear=mapCacheClear;
    MapCache.prototype['delete']=mapCacheDelete;
    MapCache.prototype.get=mapCacheGet;
    MapCache.prototype.has=mapCacheHas;
    MapCache.prototype.set=mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
    	     *
    	     * Creates an array cache object to store unique values.
    	     *
    	     * @private
    	     * @constructor
    	     * @param {Array} [values] The values to cache.
    	     */
    function SetCache(values){
    var index=-1,
    length=values==null?0:values.length;

    this.__data__=new MapCache();
    while(++index<length){
    this.add(values[index]);
    }
    }

    /**
    	     * Adds `value` to the array cache.
    	     *
    	     * @private
    	     * @name add
    	     * @memberOf SetCache
    	     * @alias push
    	     * @param {*} value The value to cache.
    	     * @returns {Object} Returns the cache instance.
    	     */
    function setCacheAdd(value){
    this.__data__.set(value,HASH_UNDEFINED);
    return this;
    }

    /**
    	     * Checks if `value` is in the array cache.
    	     *
    	     * @private
    	     * @name has
    	     * @memberOf SetCache
    	     * @param {*} value The value to search for.
    	     * @returns {number} Returns `true` if `value` is found, else `false`.
    	     */
    function setCacheHas(value){
    return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;
    SetCache.prototype.has=setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
    	     * Creates a stack cache object to store key-value pairs.
    	     *
    	     * @private
    	     * @constructor
    	     * @param {Array} [entries] The key-value pairs to cache.
    	     */
    function Stack(entries){
    var data=this.__data__=new ListCache(entries);
    this.size=data.size;
    }

    /**
    	     * Removes all key-value entries from the stack.
    	     *
    	     * @private
    	     * @name clear
    	     * @memberOf Stack
    	     */
    function stackClear(){
    this.__data__=new ListCache();
    this.size=0;
    }

    /**
    	     * Removes `key` and its value from the stack.
    	     *
    	     * @private
    	     * @name delete
    	     * @memberOf Stack
    	     * @param {string} key The key of the value to remove.
    	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
    	     */
    function stackDelete(key){
    var data=this.__data__,
    result=data['delete'](key);

    this.size=data.size;
    return result;
    }

    /**
    	     * Gets the stack value for `key`.
    	     *
    	     * @private
    	     * @name get
    	     * @memberOf Stack
    	     * @param {string} key The key of the value to get.
    	     * @returns {*} Returns the entry value.
    	     */
    function stackGet(key){
    return this.__data__.get(key);
    }

    /**
    	     * Checks if a stack value for `key` exists.
    	     *
    	     * @private
    	     * @name has
    	     * @memberOf Stack
    	     * @param {string} key The key of the entry to check.
    	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
    	     */
    function stackHas(key){
    return this.__data__.has(key);
    }

    /**
    	     * Sets the stack `key` to `value`.
    	     *
    	     * @private
    	     * @name set
    	     * @memberOf Stack
    	     * @param {string} key The key of the value to set.
    	     * @param {*} value The value to set.
    	     * @returns {Object} Returns the stack cache instance.
    	     */
    function stackSet(key,value){
    var data=this.__data__;
    if(data instanceof ListCache){
    var pairs=data.__data__;
    if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){
    pairs.push([key,value]);
    this.size=++data.size;
    return this;
    }
    data=this.__data__=new MapCache(pairs);
    }
    data.set(key,value);
    this.size=data.size;
    return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear=stackClear;
    Stack.prototype['delete']=stackDelete;
    Stack.prototype.get=stackGet;
    Stack.prototype.has=stackHas;
    Stack.prototype.set=stackSet;

    /*------------------------------------------------------------------------*/

    /**
    	     * Creates an array of the enumerable property names of the array-like `value`.
    	     *
    	     * @private
    	     * @param {*} value The value to query.
    	     * @param {boolean} inherited Specify returning inherited property names.
    	     * @returns {Array} Returns the array of property names.
    	     */
    function arrayLikeKeys(value,inherited){
    var isArr=isArray(value),
    isArg=!isArr&&isArguments(value),
    isBuff=!isArr&&!isArg&&isBuffer(value),
    isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),
    skipIndexes=isArr||isArg||isBuff||isType,
    result=skipIndexes?baseTimes(value.length,String):[],
    length=result.length;

    for(var key in value){
    if((inherited||hasOwnProperty.call(value,key))&&
    !(skipIndexes&&(
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key=='length'||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff&&(key=='offset'||key=='parent')||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||
    // Skip index properties.
    isIndex(key,length))))
    {
    result.push(key);
    }
    }
    return result;
    }

    /**
    	     * A specialized version of `_.sample` for arrays.
    	     *
    	     * @private
    	     * @param {Array} array The array to sample.
    	     * @returns {*} Returns the random element.
    	     */
    function arraySample(array){
    var length=array.length;
    return length?array[baseRandom(0,length-1)]:undefined$1;
    }

    /**
    	     * A specialized version of `_.sampleSize` for arrays.
    	     *
    	     * @private
    	     * @param {Array} array The array to sample.
    	     * @param {number} n The number of elements to sample.
    	     * @returns {Array} Returns the random elements.
    	     */
    function arraySampleSize(array,n){
    return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));
    }

    /**
    	     * A specialized version of `_.shuffle` for arrays.
    	     *
    	     * @private
    	     * @param {Array} array The array to shuffle.
    	     * @returns {Array} Returns the new shuffled array.
    	     */
    function arrayShuffle(array){
    return shuffleSelf(copyArray(array));
    }

    /**
    	     * This function is like `assignValue` except that it doesn't assign
    	     * `undefined` values.
    	     *
    	     * @private
    	     * @param {Object} object The object to modify.
    	     * @param {string} key The key of the property to assign.
    	     * @param {*} value The value to assign.
    	     */
    function assignMergeValue(object,key,value){
    if(value!==undefined$1&&!eq(object[key],value)||
    value===undefined$1&&!(key in object)){
    baseAssignValue(object,key,value);
    }
    }

    /**
    	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
    	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    	     * for equality comparisons.
    	     *
    	     * @private
    	     * @param {Object} object The object to modify.
    	     * @param {string} key The key of the property to assign.
    	     * @param {*} value The value to assign.
    	     */
    function assignValue(object,key,value){
    var objValue=object[key];
    if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||
    value===undefined$1&&!(key in object)){
    baseAssignValue(object,key,value);
    }
    }

    /**
    	     * Gets the index at which the `key` is found in `array` of key-value pairs.
    	     *
    	     * @private
    	     * @param {Array} array The array to inspect.
    	     * @param {*} key The key to search for.
    	     * @returns {number} Returns the index of the matched value, else `-1`.
    	     */
    function assocIndexOf(array,key){
    var length=array.length;
    while(length--){
    if(eq(array[length][0],key)){
    return length;
    }
    }
    return -1;
    }

    /**
    	     * Aggregates elements of `collection` on `accumulator` with keys transformed
    	     * by `iteratee` and values set by `setter`.
    	     *
    	     * @private
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} setter The function to set `accumulator` values.
    	     * @param {Function} iteratee The iteratee to transform keys.
    	     * @param {Object} accumulator The initial aggregated object.
    	     * @returns {Function} Returns `accumulator`.
    	     */
    function baseAggregator(collection,setter,iteratee,accumulator){
    baseEach(collection,function(value,key,collection){
    setter(accumulator,value,iteratee(value),collection);
    });
    return accumulator;
    }

    /**
    	     * The base implementation of `_.assign` without support for multiple sources
    	     * or `customizer` functions.
    	     *
    	     * @private
    	     * @param {Object} object The destination object.
    	     * @param {Object} source The source object.
    	     * @returns {Object} Returns `object`.
    	     */
    function baseAssign(object,source){
    return object&&copyObject(source,keys(source),object);
    }

    /**
    	     * The base implementation of `_.assignIn` without support for multiple sources
    	     * or `customizer` functions.
    	     *
    	     * @private
    	     * @param {Object} object The destination object.
    	     * @param {Object} source The source object.
    	     * @returns {Object} Returns `object`.
    	     */
    function baseAssignIn(object,source){
    return object&&copyObject(source,keysIn(source),object);
    }

    /**
    	     * The base implementation of `assignValue` and `assignMergeValue` without
    	     * value checks.
    	     *
    	     * @private
    	     * @param {Object} object The object to modify.
    	     * @param {string} key The key of the property to assign.
    	     * @param {*} value The value to assign.
    	     */
    function baseAssignValue(object,key,value){
    if(key=='__proto__'&&defineProperty){
    defineProperty(object,key,{
    'configurable':true,
    'enumerable':true,
    'value':value,
    'writable':true});

    }else {
    object[key]=value;
    }
    }

    /**
    	     * The base implementation of `_.at` without support for individual paths.
    	     *
    	     * @private
    	     * @param {Object} object The object to iterate over.
    	     * @param {string[]} paths The property paths to pick.
    	     * @returns {Array} Returns the picked elements.
    	     */
    function baseAt(object,paths){
    var index=-1,
    length=paths.length,
    result=Array(length),
    skip=object==null;

    while(++index<length){
    result[index]=skip?undefined$1:get(object,paths[index]);
    }
    return result;
    }

    /**
    	     * The base implementation of `_.clamp` which doesn't coerce arguments.
    	     *
    	     * @private
    	     * @param {number} number The number to clamp.
    	     * @param {number} [lower] The lower bound.
    	     * @param {number} upper The upper bound.
    	     * @returns {number} Returns the clamped number.
    	     */
    function baseClamp(number,lower,upper){
    if(number===number){
    if(upper!==undefined$1){
    number=number<=upper?number:upper;
    }
    if(lower!==undefined$1){
    number=number>=lower?number:lower;
    }
    }
    return number;
    }

    /**
    	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
    	     * traversed objects.
    	     *
    	     * @private
    	     * @param {*} value The value to clone.
    	     * @param {boolean} bitmask The bitmask flags.
    	     *  1 - Deep clone
    	     *  2 - Flatten inherited properties
    	     *  4 - Clone symbols
    	     * @param {Function} [customizer] The function to customize cloning.
    	     * @param {string} [key] The key of `value`.
    	     * @param {Object} [object] The parent object of `value`.
    	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
    	     * @returns {*} Returns the cloned value.
    	     */
    function baseClone(value,bitmask,customizer,key,object,stack){
    var result,
    isDeep=bitmask&CLONE_DEEP_FLAG,
    isFlat=bitmask&CLONE_FLAT_FLAG,
    isFull=bitmask&CLONE_SYMBOLS_FLAG;

    if(customizer){
    result=object?customizer(value,key,object,stack):customizer(value);
    }
    if(result!==undefined$1){
    return result;
    }
    if(!isObject(value)){
    return value;
    }
    var isArr=isArray(value);
    if(isArr){
    result=initCloneArray(value);
    if(!isDeep){
    return copyArray(value,result);
    }
    }else {
    var tag=getTag(value),
    isFunc=tag==funcTag||tag==genTag;

    if(isBuffer(value)){
    return cloneBuffer(value,isDeep);
    }
    if(tag==objectTag||tag==argsTag||isFunc&&!object){
    result=isFlat||isFunc?{}:initCloneObject(value);
    if(!isDeep){
    return isFlat?
    copySymbolsIn(value,baseAssignIn(result,value)):
    copySymbols(value,baseAssign(result,value));
    }
    }else {
    if(!cloneableTags[tag]){
    return object?value:{};
    }
    result=initCloneByTag(value,tag,isDeep);
    }
    }
    // Check for circular references and return its corresponding clone.
    stack||(stack=new Stack());
    var stacked=stack.get(value);
    if(stacked){
    return stacked;
    }
    stack.set(value,result);

    if(isSet(value)){
    value.forEach(function(subValue){
    result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));
    });
    }else if(isMap(value)){
    value.forEach(function(subValue,key){
    result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));
    });
    }

    var keysFunc=isFull?
    isFlat?getAllKeysIn:getAllKeys:
    isFlat?keysIn:keys;

    var props=isArr?undefined$1:keysFunc(value);
    arrayEach(props||value,function(subValue,key){
    if(props){
    key=subValue;
    subValue=value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));
    });
    return result;
    }

    /**
    	     * The base implementation of `_.conforms` which doesn't clone `source`.
    	     *
    	     * @private
    	     * @param {Object} source The object of property predicates to conform to.
    	     * @returns {Function} Returns the new spec function.
    	     */
    function baseConforms(source){
    var props=keys(source);
    return function(object){
    return baseConformsTo(object,source,props);
    };
    }

    /**
    	     * The base implementation of `_.conformsTo` which accepts `props` to check.
    	     *
    	     * @private
    	     * @param {Object} object The object to inspect.
    	     * @param {Object} source The object of property predicates to conform to.
    	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
    	     */
    function baseConformsTo(object,source,props){
    var length=props.length;
    if(object==null){
    return !length;
    }
    object=Object(object);
    while(length--){
    var key=props[length],
    predicate=source[key],
    value=object[key];

    if(value===undefined$1&&!(key in object)||!predicate(value)){
    return false;
    }
    }
    return true;
    }

    /**
    	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
    	     * to provide to `func`.
    	     *
    	     * @private
    	     * @param {Function} func The function to delay.
    	     * @param {number} wait The number of milliseconds to delay invocation.
    	     * @param {Array} args The arguments to provide to `func`.
    	     * @returns {number|Object} Returns the timer id or timeout object.
    	     */
    function baseDelay(func,wait,args){
    if(typeof func!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    return setTimeout(function(){func.apply(undefined$1,args);},wait);
    }

    /**
    	     * The base implementation of methods like `_.difference` without support
    	     * for excluding multiple arrays or iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Array} array The array to inspect.
    	     * @param {Array} values The values to exclude.
    	     * @param {Function} [iteratee] The iteratee invoked per element.
    	     * @param {Function} [comparator] The comparator invoked per element.
    	     * @returns {Array} Returns the new array of filtered values.
    	     */
    function baseDifference(array,values,iteratee,comparator){
    var index=-1,
    includes=arrayIncludes,
    isCommon=true,
    length=array.length,
    result=[],
    valuesLength=values.length;

    if(!length){
    return result;
    }
    if(iteratee){
    values=arrayMap(values,baseUnary(iteratee));
    }
    if(comparator){
    includes=arrayIncludesWith;
    isCommon=false;
    }else
    if(values.length>=LARGE_ARRAY_SIZE){
    includes=cacheHas;
    isCommon=false;
    values=new SetCache(values);
    }
    outer:
    while(++index<length){
    var value=array[index],
    computed=iteratee==null?value:iteratee(value);

    value=comparator||value!==0?value:0;
    if(isCommon&&computed===computed){
    var valuesIndex=valuesLength;
    while(valuesIndex--){
    if(values[valuesIndex]===computed){
    continue outer;
    }
    }
    result.push(value);
    }else
    if(!includes(values,computed,comparator)){
    result.push(value);
    }
    }
    return result;
    }

    /**
    	     * The base implementation of `_.forEach` without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} iteratee The function invoked per iteration.
    	     * @returns {Array|Object} Returns `collection`.
    	     */
    var baseEach=createBaseEach(baseForOwn);

    /**
    	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} iteratee The function invoked per iteration.
    	     * @returns {Array|Object} Returns `collection`.
    	     */
    var baseEachRight=createBaseEach(baseForOwnRight,true);

    /**
    	     * The base implementation of `_.every` without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} predicate The function invoked per iteration.
    	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
    	     *  else `false`
    	     */
    function baseEvery(collection,predicate){
    var result=true;
    baseEach(collection,function(value,index,collection){
    result=!!predicate(value,index,collection);
    return result;
    });
    return result;
    }

    /**
    	     * The base implementation of methods like `_.max` and `_.min` which accepts a
    	     * `comparator` to determine the extremum value.
    	     *
    	     * @private
    	     * @param {Array} array The array to iterate over.
    	     * @param {Function} iteratee The iteratee invoked per iteration.
    	     * @param {Function} comparator The comparator used to compare values.
    	     * @returns {*} Returns the extremum value.
    	     */
    function baseExtremum(array,iteratee,comparator){
    var index=-1,
    length=array.length;

    while(++index<length){
    var value=array[index],
    current=iteratee(value);

    if(current!=null&&(computed===undefined$1?
    current===current&&!isSymbol(current):
    comparator(current,computed)))
    {
    var computed=current,
    result=value;
    }
    }
    return result;
    }

    /**
    	     * The base implementation of `_.fill` without an iteratee call guard.
    	     *
    	     * @private
    	     * @param {Array} array The array to fill.
    	     * @param {*} value The value to fill `array` with.
    	     * @param {number} [start=0] The start position.
    	     * @param {number} [end=array.length] The end position.
    	     * @returns {Array} Returns `array`.
    	     */
    function baseFill(array,value,start,end){
    var length=array.length;

    start=toInteger(start);
    if(start<0){
    start=-start>length?0:length+start;
    }
    end=end===undefined$1||end>length?length:toInteger(end);
    if(end<0){
    end+=length;
    }
    end=start>end?0:toLength(end);
    while(start<end){
    array[start++]=value;
    }
    return array;
    }

    /**
    	     * The base implementation of `_.filter` without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} predicate The function invoked per iteration.
    	     * @returns {Array} Returns the new filtered array.
    	     */
    function baseFilter(collection,predicate){
    var result=[];
    baseEach(collection,function(value,index,collection){
    if(predicate(value,index,collection)){
    result.push(value);
    }
    });
    return result;
    }

    /**
    	     * The base implementation of `_.flatten` with support for restricting flattening.
    	     *
    	     * @private
    	     * @param {Array} array The array to flatten.
    	     * @param {number} depth The maximum recursion depth.
    	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
    	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
    	     * @param {Array} [result=[]] The initial result value.
    	     * @returns {Array} Returns the new flattened array.
    	     */
    function baseFlatten(array,depth,predicate,isStrict,result){
    var index=-1,
    length=array.length;

    predicate||(predicate=isFlattenable);
    result||(result=[]);

    while(++index<length){
    var value=array[index];
    if(depth>0&&predicate(value)){
    if(depth>1){
    // Recursively flatten arrays (susceptible to call stack limits).
    baseFlatten(value,depth-1,predicate,isStrict,result);
    }else {
    arrayPush(result,value);
    }
    }else if(!isStrict){
    result[result.length]=value;
    }
    }
    return result;
    }

    /**
    	     * The base implementation of `baseForOwn` which iterates over `object`
    	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
    	     * Iteratee functions may exit iteration early by explicitly returning `false`.
    	     *
    	     * @private
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} iteratee The function invoked per iteration.
    	     * @param {Function} keysFunc The function to get the keys of `object`.
    	     * @returns {Object} Returns `object`.
    	     */
    var baseFor=createBaseFor();

    /**
    	     * This function is like `baseFor` except that it iterates over properties
    	     * in the opposite order.
    	     *
    	     * @private
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} iteratee The function invoked per iteration.
    	     * @param {Function} keysFunc The function to get the keys of `object`.
    	     * @returns {Object} Returns `object`.
    	     */
    var baseForRight=createBaseFor(true);

    /**
    	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} iteratee The function invoked per iteration.
    	     * @returns {Object} Returns `object`.
    	     */
    function baseForOwn(object,iteratee){
    return object&&baseFor(object,iteratee,keys);
    }

    /**
    	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} iteratee The function invoked per iteration.
    	     * @returns {Object} Returns `object`.
    	     */
    function baseForOwnRight(object,iteratee){
    return object&&baseForRight(object,iteratee,keys);
    }

    /**
    	     * The base implementation of `_.functions` which creates an array of
    	     * `object` function property names filtered from `props`.
    	     *
    	     * @private
    	     * @param {Object} object The object to inspect.
    	     * @param {Array} props The property names to filter.
    	     * @returns {Array} Returns the function names.
    	     */
    function baseFunctions(object,props){
    return arrayFilter(props,function(key){
    return isFunction(object[key]);
    });
    }

    /**
    	     * The base implementation of `_.get` without support for default values.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @param {Array|string} path The path of the property to get.
    	     * @returns {*} Returns the resolved value.
    	     */
    function baseGet(object,path){
    path=castPath(path,object);

    var index=0,
    length=path.length;

    while(object!=null&&index<length){
    object=object[toKey(path[index++])];
    }
    return index&&index==length?object:undefined$1;
    }

    /**
    	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
    	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
    	     * symbols of `object`.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @param {Function} keysFunc The function to get the keys of `object`.
    	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
    	     * @returns {Array} Returns the array of property names and symbols.
    	     */
    function baseGetAllKeys(object,keysFunc,symbolsFunc){
    var result=keysFunc(object);
    return isArray(object)?result:arrayPush(result,symbolsFunc(object));
    }

    /**
    	     * The base implementation of `getTag` without fallbacks for buggy environments.
    	     *
    	     * @private
    	     * @param {*} value The value to query.
    	     * @returns {string} Returns the `toStringTag`.
    	     */
    function baseGetTag(value){
    if(value==null){
    return value===undefined$1?undefinedTag:nullTag;
    }
    return symToStringTag&&symToStringTag in Object(value)?
    getRawTag(value):
    objectToString(value);
    }

    /**
    	     * The base implementation of `_.gt` which doesn't coerce arguments.
    	     *
    	     * @private
    	     * @param {*} value The value to compare.
    	     * @param {*} other The other value to compare.
    	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
    	     *  else `false`.
    	     */
    function baseGt(value,other){
    return value>other;
    }

    /**
    	     * The base implementation of `_.has` without support for deep paths.
    	     *
    	     * @private
    	     * @param {Object} [object] The object to query.
    	     * @param {Array|string} key The key to check.
    	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
    	     */
    function baseHas(object,key){
    return object!=null&&hasOwnProperty.call(object,key);
    }

    /**
    	     * The base implementation of `_.hasIn` without support for deep paths.
    	     *
    	     * @private
    	     * @param {Object} [object] The object to query.
    	     * @param {Array|string} key The key to check.
    	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
    	     */
    function baseHasIn(object,key){
    return object!=null&&key in Object(object);
    }

    /**
    	     * The base implementation of `_.inRange` which doesn't coerce arguments.
    	     *
    	     * @private
    	     * @param {number} number The number to check.
    	     * @param {number} start The start of the range.
    	     * @param {number} end The end of the range.
    	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
    	     */
    function baseInRange(number,start,end){
    return number>=nativeMin(start,end)&&number<nativeMax(start,end);
    }

    /**
    	     * The base implementation of methods like `_.intersection`, without support
    	     * for iteratee shorthands, that accepts an array of arrays to inspect.
    	     *
    	     * @private
    	     * @param {Array} arrays The arrays to inspect.
    	     * @param {Function} [iteratee] The iteratee invoked per element.
    	     * @param {Function} [comparator] The comparator invoked per element.
    	     * @returns {Array} Returns the new array of shared values.
    	     */
    function baseIntersection(arrays,iteratee,comparator){
    var includes=comparator?arrayIncludesWith:arrayIncludes,
    length=arrays[0].length,
    othLength=arrays.length,
    othIndex=othLength,
    caches=Array(othLength),
    maxLength=Infinity,
    result=[];

    while(othIndex--){
    var array=arrays[othIndex];
    if(othIndex&&iteratee){
    array=arrayMap(array,baseUnary(iteratee));
    }
    maxLength=nativeMin(array.length,maxLength);
    caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?
    new SetCache(othIndex&&array):
    undefined$1;
    }
    array=arrays[0];

    var index=-1,
    seen=caches[0];

    outer:
    while(++index<length&&result.length<maxLength){
    var value=array[index],
    computed=iteratee?iteratee(value):value;

    value=comparator||value!==0?value:0;
    if(!(seen?
    cacheHas(seen,computed):
    includes(result,computed,comparator)))
    {
    othIndex=othLength;
    while(--othIndex){
    var cache=caches[othIndex];
    if(!(cache?
    cacheHas(cache,computed):
    includes(arrays[othIndex],computed,comparator)))
    {
    continue outer;
    }
    }
    if(seen){
    seen.push(computed);
    }
    result.push(value);
    }
    }
    return result;
    }

    /**
    	     * The base implementation of `_.invert` and `_.invertBy` which inverts
    	     * `object` with values transformed by `iteratee` and set by `setter`.
    	     *
    	     * @private
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} setter The function to set `accumulator` values.
    	     * @param {Function} iteratee The iteratee to transform values.
    	     * @param {Object} accumulator The initial inverted object.
    	     * @returns {Function} Returns `accumulator`.
    	     */
    function baseInverter(object,setter,iteratee,accumulator){
    baseForOwn(object,function(value,key,object){
    setter(accumulator,iteratee(value),key,object);
    });
    return accumulator;
    }

    /**
    	     * The base implementation of `_.invoke` without support for individual
    	     * method arguments.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @param {Array|string} path The path of the method to invoke.
    	     * @param {Array} args The arguments to invoke the method with.
    	     * @returns {*} Returns the result of the invoked method.
    	     */
    function baseInvoke(object,path,args){
    path=castPath(path,object);
    object=parent(object,path);
    var func=object==null?object:object[toKey(last(path))];
    return func==null?undefined$1:apply(func,object,args);
    }

    /**
    	     * The base implementation of `_.isArguments`.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
    	     */
    function baseIsArguments(value){
    return isObjectLike(value)&&baseGetTag(value)==argsTag;
    }

    /**
    	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
    	     */
    function baseIsArrayBuffer(value){
    return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;
    }

    /**
    	     * The base implementation of `_.isDate` without Node.js optimizations.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
    	     */
    function baseIsDate(value){
    return isObjectLike(value)&&baseGetTag(value)==dateTag;
    }

    /**
    	     * The base implementation of `_.isEqual` which supports partial comparisons
    	     * and tracks traversed objects.
    	     *
    	     * @private
    	     * @param {*} value The value to compare.
    	     * @param {*} other The other value to compare.
    	     * @param {boolean} bitmask The bitmask flags.
    	     *  1 - Unordered comparison
    	     *  2 - Partial comparison
    	     * @param {Function} [customizer] The function to customize comparisons.
    	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
    	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
    	     */
    function baseIsEqual(value,other,bitmask,customizer,stack){
    if(value===other){
    return true;
    }
    if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){
    return value!==value&&other!==other;
    }
    return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);
    }

    /**
    	     * A specialized version of `baseIsEqual` for arrays and objects which performs
    	     * deep comparisons and tracks traversed objects enabling objects with circular
    	     * references to be compared.
    	     *
    	     * @private
    	     * @param {Object} object The object to compare.
    	     * @param {Object} other The other object to compare.
    	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
    	     * @param {Function} customizer The function to customize comparisons.
    	     * @param {Function} equalFunc The function to determine equivalents of values.
    	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
    	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
    	     */
    function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){
    var objIsArr=isArray(object),
    othIsArr=isArray(other),
    objTag=objIsArr?arrayTag:getTag(object),
    othTag=othIsArr?arrayTag:getTag(other);

    objTag=objTag==argsTag?objectTag:objTag;
    othTag=othTag==argsTag?objectTag:othTag;

    var objIsObj=objTag==objectTag,
    othIsObj=othTag==objectTag,
    isSameTag=objTag==othTag;

    if(isSameTag&&isBuffer(object)){
    if(!isBuffer(other)){
    return false;
    }
    objIsArr=true;
    objIsObj=false;
    }
    if(isSameTag&&!objIsObj){
    stack||(stack=new Stack());
    return objIsArr||isTypedArray(object)?
    equalArrays(object,other,bitmask,customizer,equalFunc,stack):
    equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);
    }
    if(!(bitmask&COMPARE_PARTIAL_FLAG)){
    var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),
    othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');

    if(objIsWrapped||othIsWrapped){
    var objUnwrapped=objIsWrapped?object.value():object,
    othUnwrapped=othIsWrapped?other.value():other;

    stack||(stack=new Stack());
    return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);
    }
    }
    if(!isSameTag){
    return false;
    }
    stack||(stack=new Stack());
    return equalObjects(object,other,bitmask,customizer,equalFunc,stack);
    }

    /**
    	     * The base implementation of `_.isMap` without Node.js optimizations.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
    	     */
    function baseIsMap(value){
    return isObjectLike(value)&&getTag(value)==mapTag;
    }

    /**
    	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Object} object The object to inspect.
    	     * @param {Object} source The object of property values to match.
    	     * @param {Array} matchData The property names, values, and compare flags to match.
    	     * @param {Function} [customizer] The function to customize comparisons.
    	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
    	     */
    function baseIsMatch(object,source,matchData,customizer){
    var index=matchData.length,
    length=index,
    noCustomizer=!customizer;

    if(object==null){
    return !length;
    }
    object=Object(object);
    while(index--){
    var data=matchData[index];
    if(noCustomizer&&data[2]?
    data[1]!==object[data[0]]:
    !(data[0]in object))
    {
    return false;
    }
    }
    while(++index<length){
    data=matchData[index];
    var key=data[0],
    objValue=object[key],
    srcValue=data[1];

    if(noCustomizer&&data[2]){
    if(objValue===undefined$1&&!(key in object)){
    return false;
    }
    }else {
    var stack=new Stack();
    if(customizer){
    var result=customizer(objValue,srcValue,key,object,source,stack);
    }
    if(!(result===undefined$1?
    baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):
    result))
    {
    return false;
    }
    }
    }
    return true;
    }

    /**
    	     * The base implementation of `_.isNative` without bad shim checks.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a native function,
    	     *  else `false`.
    	     */
    function baseIsNative(value){
    if(!isObject(value)||isMasked(value)){
    return false;
    }
    var pattern=isFunction(value)?reIsNative:reIsHostCtor;
    return pattern.test(toSource(value));
    }

    /**
    	     * The base implementation of `_.isRegExp` without Node.js optimizations.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
    	     */
    function baseIsRegExp(value){
    return isObjectLike(value)&&baseGetTag(value)==regexpTag;
    }

    /**
    	     * The base implementation of `_.isSet` without Node.js optimizations.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
    	     */
    function baseIsSet(value){
    return isObjectLike(value)&&getTag(value)==setTag;
    }

    /**
    	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
    	     */
    function baseIsTypedArray(value){
    return isObjectLike(value)&&
    isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];
    }

    /**
    	     * The base implementation of `_.iteratee`.
    	     *
    	     * @private
    	     * @param {*} [value=_.identity] The value to convert to an iteratee.
    	     * @returns {Function} Returns the iteratee.
    	     */
    function baseIteratee(value){
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if(typeof value=='function'){
    return value;
    }
    if(value==null){
    return identity;
    }
    if(typeof value=='object'){
    return isArray(value)?
    baseMatchesProperty(value[0],value[1]):
    baseMatches(value);
    }
    return property(value);
    }

    /**
    	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the array of property names.
    	     */
    function baseKeys(object){
    if(!isPrototype(object)){
    return nativeKeys(object);
    }
    var result=[];
    for(var key in Object(object)){
    if(hasOwnProperty.call(object,key)&&key!='constructor'){
    result.push(key);
    }
    }
    return result;
    }

    /**
    	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the array of property names.
    	     */
    function baseKeysIn(object){
    if(!isObject(object)){
    return nativeKeysIn(object);
    }
    var isProto=isPrototype(object),
    result=[];

    for(var key in object){
    if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){
    result.push(key);
    }
    }
    return result;
    }

    /**
    	     * The base implementation of `_.lt` which doesn't coerce arguments.
    	     *
    	     * @private
    	     * @param {*} value The value to compare.
    	     * @param {*} other The other value to compare.
    	     * @returns {boolean} Returns `true` if `value` is less than `other`,
    	     *  else `false`.
    	     */
    function baseLt(value,other){
    return value<other;
    }

    /**
    	     * The base implementation of `_.map` without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} iteratee The function invoked per iteration.
    	     * @returns {Array} Returns the new mapped array.
    	     */
    function baseMap(collection,iteratee){
    var index=-1,
    result=isArrayLike(collection)?Array(collection.length):[];

    baseEach(collection,function(value,key,collection){
    result[++index]=iteratee(value,key,collection);
    });
    return result;
    }

    /**
    	     * The base implementation of `_.matches` which doesn't clone `source`.
    	     *
    	     * @private
    	     * @param {Object} source The object of property values to match.
    	     * @returns {Function} Returns the new spec function.
    	     */
    function baseMatches(source){
    var matchData=getMatchData(source);
    if(matchData.length==1&&matchData[0][2]){
    return matchesStrictComparable(matchData[0][0],matchData[0][1]);
    }
    return function(object){
    return object===source||baseIsMatch(object,source,matchData);
    };
    }

    /**
    	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
    	     *
    	     * @private
    	     * @param {string} path The path of the property to get.
    	     * @param {*} srcValue The value to match.
    	     * @returns {Function} Returns the new spec function.
    	     */
    function baseMatchesProperty(path,srcValue){
    if(isKey(path)&&isStrictComparable(srcValue)){
    return matchesStrictComparable(toKey(path),srcValue);
    }
    return function(object){
    var objValue=get(object,path);
    return objValue===undefined$1&&objValue===srcValue?
    hasIn(object,path):
    baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);
    };
    }

    /**
    	     * The base implementation of `_.merge` without support for multiple sources.
    	     *
    	     * @private
    	     * @param {Object} object The destination object.
    	     * @param {Object} source The source object.
    	     * @param {number} srcIndex The index of `source`.
    	     * @param {Function} [customizer] The function to customize merged values.
    	     * @param {Object} [stack] Tracks traversed source values and their merged
    	     *  counterparts.
    	     */
    function baseMerge(object,source,srcIndex,customizer,stack){
    if(object===source){
    return;
    }
    baseFor(source,function(srcValue,key){
    stack||(stack=new Stack());
    if(isObject(srcValue)){
    baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);
    }else
    {
    var newValue=customizer?
    customizer(safeGet(object,key),srcValue,key+'',object,source,stack):
    undefined$1;

    if(newValue===undefined$1){
    newValue=srcValue;
    }
    assignMergeValue(object,key,newValue);
    }
    },keysIn);
    }

    /**
    	     * A specialized version of `baseMerge` for arrays and objects which performs
    	     * deep merges and tracks traversed objects enabling objects with circular
    	     * references to be merged.
    	     *
    	     * @private
    	     * @param {Object} object The destination object.
    	     * @param {Object} source The source object.
    	     * @param {string} key The key of the value to merge.
    	     * @param {number} srcIndex The index of `source`.
    	     * @param {Function} mergeFunc The function to merge values.
    	     * @param {Function} [customizer] The function to customize assigned values.
    	     * @param {Object} [stack] Tracks traversed source values and their merged
    	     *  counterparts.
    	     */
    function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){
    var objValue=safeGet(object,key),
    srcValue=safeGet(source,key),
    stacked=stack.get(srcValue);

    if(stacked){
    assignMergeValue(object,key,stacked);
    return;
    }
    var newValue=customizer?
    customizer(objValue,srcValue,key+'',object,source,stack):
    undefined$1;

    var isCommon=newValue===undefined$1;

    if(isCommon){
    var isArr=isArray(srcValue),
    isBuff=!isArr&&isBuffer(srcValue),
    isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);

    newValue=srcValue;
    if(isArr||isBuff||isTyped){
    if(isArray(objValue)){
    newValue=objValue;
    }else
    if(isArrayLikeObject(objValue)){
    newValue=copyArray(objValue);
    }else
    if(isBuff){
    isCommon=false;
    newValue=cloneBuffer(srcValue,true);
    }else
    if(isTyped){
    isCommon=false;
    newValue=cloneTypedArray(srcValue,true);
    }else
    {
    newValue=[];
    }
    }else
    if(isPlainObject(srcValue)||isArguments(srcValue)){
    newValue=objValue;
    if(isArguments(objValue)){
    newValue=toPlainObject(objValue);
    }else
    if(!isObject(objValue)||isFunction(objValue)){
    newValue=initCloneObject(srcValue);
    }
    }else
    {
    isCommon=false;
    }
    }
    if(isCommon){
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue,newValue);
    mergeFunc(newValue,srcValue,srcIndex,customizer,stack);
    stack['delete'](srcValue);
    }
    assignMergeValue(object,key,newValue);
    }

    /**
    	     * The base implementation of `_.nth` which doesn't coerce arguments.
    	     *
    	     * @private
    	     * @param {Array} array The array to query.
    	     * @param {number} n The index of the element to return.
    	     * @returns {*} Returns the nth element of `array`.
    	     */
    function baseNth(array,n){
    var length=array.length;
    if(!length){
    return;
    }
    n+=n<0?length:0;
    return isIndex(n,length)?array[n]:undefined$1;
    }

    /**
    	     * The base implementation of `_.orderBy` without param guards.
    	     *
    	     * @private
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
    	     * @param {string[]} orders The sort orders of `iteratees`.
    	     * @returns {Array} Returns the new sorted array.
    	     */
    function baseOrderBy(collection,iteratees,orders){
    if(iteratees.length){
    iteratees=arrayMap(iteratees,function(iteratee){
    if(isArray(iteratee)){
    return function(value){
    return baseGet(value,iteratee.length===1?iteratee[0]:iteratee);
    };
    }
    return iteratee;
    });
    }else {
    iteratees=[identity];
    }

    var index=-1;
    iteratees=arrayMap(iteratees,baseUnary(getIteratee()));

    var result=baseMap(collection,function(value,key,collection){
    var criteria=arrayMap(iteratees,function(iteratee){
    return iteratee(value);
    });
    return {'criteria':criteria,'index':++index,'value':value};
    });

    return baseSortBy(result,function(object,other){
    return compareMultiple(object,other,orders);
    });
    }

    /**
    	     * The base implementation of `_.pick` without support for individual
    	     * property identifiers.
    	     *
    	     * @private
    	     * @param {Object} object The source object.
    	     * @param {string[]} paths The property paths to pick.
    	     * @returns {Object} Returns the new object.
    	     */
    function basePick(object,paths){
    return basePickBy(object,paths,function(value,path){
    return hasIn(object,path);
    });
    }

    /**
    	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Object} object The source object.
    	     * @param {string[]} paths The property paths to pick.
    	     * @param {Function} predicate The function invoked per property.
    	     * @returns {Object} Returns the new object.
    	     */
    function basePickBy(object,paths,predicate){
    var index=-1,
    length=paths.length,
    result={};

    while(++index<length){
    var path=paths[index],
    value=baseGet(object,path);

    if(predicate(value,path)){
    baseSet(result,castPath(path,object),value);
    }
    }
    return result;
    }

    /**
    	     * A specialized version of `baseProperty` which supports deep paths.
    	     *
    	     * @private
    	     * @param {Array|string} path The path of the property to get.
    	     * @returns {Function} Returns the new accessor function.
    	     */
    function basePropertyDeep(path){
    return function(object){
    return baseGet(object,path);
    };
    }

    /**
    	     * The base implementation of `_.pullAllBy` without support for iteratee
    	     * shorthands.
    	     *
    	     * @private
    	     * @param {Array} array The array to modify.
    	     * @param {Array} values The values to remove.
    	     * @param {Function} [iteratee] The iteratee invoked per element.
    	     * @param {Function} [comparator] The comparator invoked per element.
    	     * @returns {Array} Returns `array`.
    	     */
    function basePullAll(array,values,iteratee,comparator){
    var indexOf=comparator?baseIndexOfWith:baseIndexOf,
    index=-1,
    length=values.length,
    seen=array;

    if(array===values){
    values=copyArray(values);
    }
    if(iteratee){
    seen=arrayMap(array,baseUnary(iteratee));
    }
    while(++index<length){
    var fromIndex=0,
    value=values[index],
    computed=iteratee?iteratee(value):value;

    while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){
    if(seen!==array){
    splice.call(seen,fromIndex,1);
    }
    splice.call(array,fromIndex,1);
    }
    }
    return array;
    }

    /**
    	     * The base implementation of `_.pullAt` without support for individual
    	     * indexes or capturing the removed elements.
    	     *
    	     * @private
    	     * @param {Array} array The array to modify.
    	     * @param {number[]} indexes The indexes of elements to remove.
    	     * @returns {Array} Returns `array`.
    	     */
    function basePullAt(array,indexes){
    var length=array?indexes.length:0,
    lastIndex=length-1;

    while(length--){
    var index=indexes[length];
    if(length==lastIndex||index!==previous){
    var previous=index;
    if(isIndex(index)){
    splice.call(array,index,1);
    }else {
    baseUnset(array,index);
    }
    }
    }
    return array;
    }

    /**
    	     * The base implementation of `_.random` without support for returning
    	     * floating-point numbers.
    	     *
    	     * @private
    	     * @param {number} lower The lower bound.
    	     * @param {number} upper The upper bound.
    	     * @returns {number} Returns the random number.
    	     */
    function baseRandom(lower,upper){
    return lower+nativeFloor(nativeRandom()*(upper-lower+1));
    }

    /**
    	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
    	     * coerce arguments.
    	     *
    	     * @private
    	     * @param {number} start The start of the range.
    	     * @param {number} end The end of the range.
    	     * @param {number} step The value to increment or decrement by.
    	     * @param {boolean} [fromRight] Specify iterating from right to left.
    	     * @returns {Array} Returns the range of numbers.
    	     */
    function baseRange(start,end,step,fromRight){
    var index=-1,
    length=nativeMax(nativeCeil((end-start)/(step||1)),0),
    result=Array(length);

    while(length--){
    result[fromRight?length:++index]=start;
    start+=step;
    }
    return result;
    }

    /**
    	     * The base implementation of `_.repeat` which doesn't coerce arguments.
    	     *
    	     * @private
    	     * @param {string} string The string to repeat.
    	     * @param {number} n The number of times to repeat the string.
    	     * @returns {string} Returns the repeated string.
    	     */
    function baseRepeat(string,n){
    var result='';
    if(!string||n<1||n>MAX_SAFE_INTEGER){
    return result;
    }
    // Leverage the exponentiation by squaring algorithm for a faster repeat.
    // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
    do{
    if(n%2){
    result+=string;
    }
    n=nativeFloor(n/2);
    if(n){
    string+=string;
    }
    }while(n);

    return result;
    }

    /**
    	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
    	     *
    	     * @private
    	     * @param {Function} func The function to apply a rest parameter to.
    	     * @param {number} [start=func.length-1] The start position of the rest parameter.
    	     * @returns {Function} Returns the new function.
    	     */
    function baseRest(func,start){
    return setToString(overRest(func,start,identity),func+'');
    }

    /**
    	     * The base implementation of `_.sample`.
    	     *
    	     * @private
    	     * @param {Array|Object} collection The collection to sample.
    	     * @returns {*} Returns the random element.
    	     */
    function baseSample(collection){
    return arraySample(values(collection));
    }

    /**
    	     * The base implementation of `_.sampleSize` without param guards.
    	     *
    	     * @private
    	     * @param {Array|Object} collection The collection to sample.
    	     * @param {number} n The number of elements to sample.
    	     * @returns {Array} Returns the random elements.
    	     */
    function baseSampleSize(collection,n){
    var array=values(collection);
    return shuffleSelf(array,baseClamp(n,0,array.length));
    }

    /**
    	     * The base implementation of `_.set`.
    	     *
    	     * @private
    	     * @param {Object} object The object to modify.
    	     * @param {Array|string} path The path of the property to set.
    	     * @param {*} value The value to set.
    	     * @param {Function} [customizer] The function to customize path creation.
    	     * @returns {Object} Returns `object`.
    	     */
    function baseSet(object,path,value,customizer){
    if(!isObject(object)){
    return object;
    }
    path=castPath(path,object);

    var index=-1,
    length=path.length,
    lastIndex=length-1,
    nested=object;

    while(nested!=null&&++index<length){
    var key=toKey(path[index]),
    newValue=value;

    if(key==='__proto__'||key==='constructor'||key==='prototype'){
    return object;
    }

    if(index!=lastIndex){
    var objValue=nested[key];
    newValue=customizer?customizer(objValue,key,nested):undefined$1;
    if(newValue===undefined$1){
    newValue=isObject(objValue)?
    objValue:
    isIndex(path[index+1])?[]:{};
    }
    }
    assignValue(nested,key,newValue);
    nested=nested[key];
    }
    return object;
    }

    /**
    	     * The base implementation of `setData` without support for hot loop shorting.
    	     *
    	     * @private
    	     * @param {Function} func The function to associate metadata with.
    	     * @param {*} data The metadata.
    	     * @returns {Function} Returns `func`.
    	     */
    var baseSetData=!metaMap?identity:function(func,data){
    metaMap.set(func,data);
    return func;
    };

    /**
    	     * The base implementation of `setToString` without support for hot loop shorting.
    	     *
    	     * @private
    	     * @param {Function} func The function to modify.
    	     * @param {Function} string The `toString` result.
    	     * @returns {Function} Returns `func`.
    	     */
    var baseSetToString=!defineProperty?identity:function(func,string){
    return defineProperty(func,'toString',{
    'configurable':true,
    'enumerable':false,
    'value':constant(string),
    'writable':true});

    };

    /**
    	     * The base implementation of `_.shuffle`.
    	     *
    	     * @private
    	     * @param {Array|Object} collection The collection to shuffle.
    	     * @returns {Array} Returns the new shuffled array.
    	     */
    function baseShuffle(collection){
    return shuffleSelf(values(collection));
    }

    /**
    	     * The base implementation of `_.slice` without an iteratee call guard.
    	     *
    	     * @private
    	     * @param {Array} array The array to slice.
    	     * @param {number} [start=0] The start position.
    	     * @param {number} [end=array.length] The end position.
    	     * @returns {Array} Returns the slice of `array`.
    	     */
    function baseSlice(array,start,end){
    var index=-1,
    length=array.length;

    if(start<0){
    start=-start>length?0:length+start;
    }
    end=end>length?length:end;
    if(end<0){
    end+=length;
    }
    length=start>end?0:end-start>>>0;
    start>>>=0;

    var result=Array(length);
    while(++index<length){
    result[index]=array[index+start];
    }
    return result;
    }

    /**
    	     * The base implementation of `_.some` without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} predicate The function invoked per iteration.
    	     * @returns {boolean} Returns `true` if any element passes the predicate check,
    	     *  else `false`.
    	     */
    function baseSome(collection,predicate){
    var result;

    baseEach(collection,function(value,index,collection){
    result=predicate(value,index,collection);
    return !result;
    });
    return !!result;
    }

    /**
    	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
    	     * performs a binary search of `array` to determine the index at which `value`
    	     * should be inserted into `array` in order to maintain its sort order.
    	     *
    	     * @private
    	     * @param {Array} array The sorted array to inspect.
    	     * @param {*} value The value to evaluate.
    	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
    	     * @returns {number} Returns the index at which `value` should be inserted
    	     *  into `array`.
    	     */
    function baseSortedIndex(array,value,retHighest){
    var low=0,
    high=array==null?low:array.length;

    if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){
    while(low<high){
    var mid=low+high>>>1,
    computed=array[mid];

    if(computed!==null&&!isSymbol(computed)&&(
    retHighest?computed<=value:computed<value)){
    low=mid+1;
    }else {
    high=mid;
    }
    }
    return high;
    }
    return baseSortedIndexBy(array,value,identity,retHighest);
    }

    /**
    	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
    	     * which invokes `iteratee` for `value` and each element of `array` to compute
    	     * their sort ranking. The iteratee is invoked with one argument; (value).
    	     *
    	     * @private
    	     * @param {Array} array The sorted array to inspect.
    	     * @param {*} value The value to evaluate.
    	     * @param {Function} iteratee The iteratee invoked per element.
    	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
    	     * @returns {number} Returns the index at which `value` should be inserted
    	     *  into `array`.
    	     */
    function baseSortedIndexBy(array,value,iteratee,retHighest){
    var low=0,
    high=array==null?0:array.length;
    if(high===0){
    return 0;
    }

    value=iteratee(value);
    var valIsNaN=value!==value,
    valIsNull=value===null,
    valIsSymbol=isSymbol(value),
    valIsUndefined=value===undefined$1;

    while(low<high){
    var mid=nativeFloor((low+high)/2),
    computed=iteratee(array[mid]),
    othIsDefined=computed!==undefined$1,
    othIsNull=computed===null,
    othIsReflexive=computed===computed,
    othIsSymbol=isSymbol(computed);

    if(valIsNaN){
    var setLow=retHighest||othIsReflexive;
    }else if(valIsUndefined){
    setLow=othIsReflexive&&(retHighest||othIsDefined);
    }else if(valIsNull){
    setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);
    }else if(valIsSymbol){
    setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);
    }else if(othIsNull||othIsSymbol){
    setLow=false;
    }else {
    setLow=retHighest?computed<=value:computed<value;
    }
    if(setLow){
    low=mid+1;
    }else {
    high=mid;
    }
    }
    return nativeMin(high,MAX_ARRAY_INDEX);
    }

    /**
    	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
    	     * support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Array} array The array to inspect.
    	     * @param {Function} [iteratee] The iteratee invoked per element.
    	     * @returns {Array} Returns the new duplicate free array.
    	     */
    function baseSortedUniq(array,iteratee){
    var index=-1,
    length=array.length,
    resIndex=0,
    result=[];

    while(++index<length){
    var value=array[index],
    computed=iteratee?iteratee(value):value;

    if(!index||!eq(computed,seen)){
    var seen=computed;
    result[resIndex++]=value===0?0:value;
    }
    }
    return result;
    }

    /**
    	     * The base implementation of `_.toNumber` which doesn't ensure correct
    	     * conversions of binary, hexadecimal, or octal string values.
    	     *
    	     * @private
    	     * @param {*} value The value to process.
    	     * @returns {number} Returns the number.
    	     */
    function baseToNumber(value){
    if(typeof value=='number'){
    return value;
    }
    if(isSymbol(value)){
    return NAN;
    }
    return +value;
    }

    /**
    	     * The base implementation of `_.toString` which doesn't convert nullish
    	     * values to empty strings.
    	     *
    	     * @private
    	     * @param {*} value The value to process.
    	     * @returns {string} Returns the string.
    	     */
    function baseToString(value){
    // Exit early for strings to avoid a performance hit in some environments.
    if(typeof value=='string'){
    return value;
    }
    if(isArray(value)){
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value,baseToString)+'';
    }
    if(isSymbol(value)){
    return symbolToString?symbolToString.call(value):'';
    }
    var result=value+'';
    return result=='0'&&1/value==-INFINITY?'-0':result;
    }

    /**
    	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Array} array The array to inspect.
    	     * @param {Function} [iteratee] The iteratee invoked per element.
    	     * @param {Function} [comparator] The comparator invoked per element.
    	     * @returns {Array} Returns the new duplicate free array.
    	     */
    function baseUniq(array,iteratee,comparator){
    var index=-1,
    includes=arrayIncludes,
    length=array.length,
    isCommon=true,
    result=[],
    seen=result;

    if(comparator){
    isCommon=false;
    includes=arrayIncludesWith;
    }else
    if(length>=LARGE_ARRAY_SIZE){
    var set=iteratee?null:createSet(array);
    if(set){
    return setToArray(set);
    }
    isCommon=false;
    includes=cacheHas;
    seen=new SetCache();
    }else
    {
    seen=iteratee?[]:result;
    }
    outer:
    while(++index<length){
    var value=array[index],
    computed=iteratee?iteratee(value):value;

    value=comparator||value!==0?value:0;
    if(isCommon&&computed===computed){
    var seenIndex=seen.length;
    while(seenIndex--){
    if(seen[seenIndex]===computed){
    continue outer;
    }
    }
    if(iteratee){
    seen.push(computed);
    }
    result.push(value);
    }else
    if(!includes(seen,computed,comparator)){
    if(seen!==result){
    seen.push(computed);
    }
    result.push(value);
    }
    }
    return result;
    }

    /**
    	     * The base implementation of `_.unset`.
    	     *
    	     * @private
    	     * @param {Object} object The object to modify.
    	     * @param {Array|string} path The property path to unset.
    	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
    	     */
    function baseUnset(object,path){
    path=castPath(path,object);
    object=parent(object,path);
    return object==null||delete object[toKey(last(path))];
    }

    /**
    	     * The base implementation of `_.update`.
    	     *
    	     * @private
    	     * @param {Object} object The object to modify.
    	     * @param {Array|string} path The path of the property to update.
    	     * @param {Function} updater The function to produce the updated value.
    	     * @param {Function} [customizer] The function to customize path creation.
    	     * @returns {Object} Returns `object`.
    	     */
    function baseUpdate(object,path,updater,customizer){
    return baseSet(object,path,updater(baseGet(object,path)),customizer);
    }

    /**
    	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
    	     * without support for iteratee shorthands.
    	     *
    	     * @private
    	     * @param {Array} array The array to query.
    	     * @param {Function} predicate The function invoked per iteration.
    	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
    	     * @param {boolean} [fromRight] Specify iterating from right to left.
    	     * @returns {Array} Returns the slice of `array`.
    	     */
    function baseWhile(array,predicate,isDrop,fromRight){
    var length=array.length,
    index=fromRight?length:-1;

    while((fromRight?index--:++index<length)&&
    predicate(array[index],index,array)){}

    return isDrop?
    baseSlice(array,fromRight?0:index,fromRight?index+1:length):
    baseSlice(array,fromRight?index+1:0,fromRight?length:index);
    }

    /**
    	     * The base implementation of `wrapperValue` which returns the result of
    	     * performing a sequence of actions on the unwrapped `value`, where each
    	     * successive action is supplied the return value of the previous.
    	     *
    	     * @private
    	     * @param {*} value The unwrapped value.
    	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
    	     * @returns {*} Returns the resolved value.
    	     */
    function baseWrapperValue(value,actions){
    var result=value;
    if(result instanceof LazyWrapper){
    result=result.value();
    }
    return arrayReduce(actions,function(result,action){
    return action.func.apply(action.thisArg,arrayPush([result],action.args));
    },result);
    }

    /**
    	     * The base implementation of methods like `_.xor`, without support for
    	     * iteratee shorthands, that accepts an array of arrays to inspect.
    	     *
    	     * @private
    	     * @param {Array} arrays The arrays to inspect.
    	     * @param {Function} [iteratee] The iteratee invoked per element.
    	     * @param {Function} [comparator] The comparator invoked per element.
    	     * @returns {Array} Returns the new array of values.
    	     */
    function baseXor(arrays,iteratee,comparator){
    var length=arrays.length;
    if(length<2){
    return length?baseUniq(arrays[0]):[];
    }
    var index=-1,
    result=Array(length);

    while(++index<length){
    var array=arrays[index],
    othIndex=-1;

    while(++othIndex<length){
    if(othIndex!=index){
    result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);
    }
    }
    }
    return baseUniq(baseFlatten(result,1),iteratee,comparator);
    }

    /**
    	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
    	     *
    	     * @private
    	     * @param {Array} props The property identifiers.
    	     * @param {Array} values The property values.
    	     * @param {Function} assignFunc The function to assign values.
    	     * @returns {Object} Returns the new object.
    	     */
    function baseZipObject(props,values,assignFunc){
    var index=-1,
    length=props.length,
    valsLength=values.length,
    result={};

    while(++index<length){
    var value=index<valsLength?values[index]:undefined$1;
    assignFunc(result,props[index],value);
    }
    return result;
    }

    /**
    	     * Casts `value` to an empty array if it's not an array like object.
    	     *
    	     * @private
    	     * @param {*} value The value to inspect.
    	     * @returns {Array|Object} Returns the cast array-like object.
    	     */
    function castArrayLikeObject(value){
    return isArrayLikeObject(value)?value:[];
    }

    /**
    	     * Casts `value` to `identity` if it's not a function.
    	     *
    	     * @private
    	     * @param {*} value The value to inspect.
    	     * @returns {Function} Returns cast function.
    	     */
    function castFunction(value){
    return typeof value=='function'?value:identity;
    }

    /**
    	     * Casts `value` to a path array if it's not one.
    	     *
    	     * @private
    	     * @param {*} value The value to inspect.
    	     * @param {Object} [object] The object to query keys on.
    	     * @returns {Array} Returns the cast property path array.
    	     */
    function castPath(value,object){
    if(isArray(value)){
    return value;
    }
    return isKey(value,object)?[value]:stringToPath(toString(value));
    }

    /**
    	     * A `baseRest` alias which can be replaced with `identity` by module
    	     * replacement plugins.
    	     *
    	     * @private
    	     * @type {Function}
    	     * @param {Function} func The function to apply a rest parameter to.
    	     * @returns {Function} Returns the new function.
    	     */
    var castRest=baseRest;

    /**
    	     * Casts `array` to a slice if it's needed.
    	     *
    	     * @private
    	     * @param {Array} array The array to inspect.
    	     * @param {number} start The start position.
    	     * @param {number} [end=array.length] The end position.
    	     * @returns {Array} Returns the cast slice.
    	     */
    function castSlice(array,start,end){
    var length=array.length;
    end=end===undefined$1?length:end;
    return !start&&end>=length?array:baseSlice(array,start,end);
    }

    /**
    	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
    	     *
    	     * @private
    	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
    	     */
    var clearTimeout=ctxClearTimeout||function(id){
    return root.clearTimeout(id);
    };

    /**
    	     * Creates a clone of  `buffer`.
    	     *
    	     * @private
    	     * @param {Buffer} buffer The buffer to clone.
    	     * @param {boolean} [isDeep] Specify a deep clone.
    	     * @returns {Buffer} Returns the cloned buffer.
    	     */
    function cloneBuffer(buffer,isDeep){
    if(isDeep){
    return buffer.slice();
    }
    var length=buffer.length,
    result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);

    buffer.copy(result);
    return result;
    }

    /**
    	     * Creates a clone of `arrayBuffer`.
    	     *
    	     * @private
    	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
    	     * @returns {ArrayBuffer} Returns the cloned array buffer.
    	     */
    function cloneArrayBuffer(arrayBuffer){
    var result=new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
    }

    /**
    	     * Creates a clone of `dataView`.
    	     *
    	     * @private
    	     * @param {Object} dataView The data view to clone.
    	     * @param {boolean} [isDeep] Specify a deep clone.
    	     * @returns {Object} Returns the cloned data view.
    	     */
    function cloneDataView(dataView,isDeep){
    var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;
    return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);
    }

    /**
    	     * Creates a clone of `regexp`.
    	     *
    	     * @private
    	     * @param {Object} regexp The regexp to clone.
    	     * @returns {Object} Returns the cloned regexp.
    	     */
    function cloneRegExp(regexp){
    var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));
    result.lastIndex=regexp.lastIndex;
    return result;
    }

    /**
    	     * Creates a clone of the `symbol` object.
    	     *
    	     * @private
    	     * @param {Object} symbol The symbol object to clone.
    	     * @returns {Object} Returns the cloned symbol object.
    	     */
    function cloneSymbol(symbol){
    return symbolValueOf?Object(symbolValueOf.call(symbol)):{};
    }

    /**
    	     * Creates a clone of `typedArray`.
    	     *
    	     * @private
    	     * @param {Object} typedArray The typed array to clone.
    	     * @param {boolean} [isDeep] Specify a deep clone.
    	     * @returns {Object} Returns the cloned typed array.
    	     */
    function cloneTypedArray(typedArray,isDeep){
    var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;
    return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);
    }

    /**
    	     * Compares values to sort them in ascending order.
    	     *
    	     * @private
    	     * @param {*} value The value to compare.
    	     * @param {*} other The other value to compare.
    	     * @returns {number} Returns the sort order indicator for `value`.
    	     */
    function compareAscending(value,other){
    if(value!==other){
    var valIsDefined=value!==undefined$1,
    valIsNull=value===null,
    valIsReflexive=value===value,
    valIsSymbol=isSymbol(value);

    var othIsDefined=other!==undefined$1,
    othIsNull=other===null,
    othIsReflexive=other===other,
    othIsSymbol=isSymbol(other);

    if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||
    valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||
    valIsNull&&othIsDefined&&othIsReflexive||
    !valIsDefined&&othIsReflexive||
    !valIsReflexive){
    return 1;
    }
    if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||
    othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||
    othIsNull&&valIsDefined&&valIsReflexive||
    !othIsDefined&&valIsReflexive||
    !othIsReflexive){
    return -1;
    }
    }
    return 0;
    }

    /**
    	     * Used by `_.orderBy` to compare multiple properties of a value to another
    	     * and stable sort them.
    	     *
    	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
    	     * specify an order of "desc" for descending or "asc" for ascending sort order
    	     * of corresponding values.
    	     *
    	     * @private
    	     * @param {Object} object The object to compare.
    	     * @param {Object} other The other object to compare.
    	     * @param {boolean[]|string[]} orders The order to sort by for each property.
    	     * @returns {number} Returns the sort order indicator for `object`.
    	     */
    function compareMultiple(object,other,orders){
    var index=-1,
    objCriteria=object.criteria,
    othCriteria=other.criteria,
    length=objCriteria.length,
    ordersLength=orders.length;

    while(++index<length){
    var result=compareAscending(objCriteria[index],othCriteria[index]);
    if(result){
    if(index>=ordersLength){
    return result;
    }
    var order=orders[index];
    return result*(order=='desc'?-1:1);
    }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index-other.index;
    }

    /**
    	     * Creates an array that is the composition of partially applied arguments,
    	     * placeholders, and provided arguments into a single array of arguments.
    	     *
    	     * @private
    	     * @param {Array} args The provided arguments.
    	     * @param {Array} partials The arguments to prepend to those provided.
    	     * @param {Array} holders The `partials` placeholder indexes.
    	     * @params {boolean} [isCurried] Specify composing for a curried function.
    	     * @returns {Array} Returns the new array of composed arguments.
    	     */
    function composeArgs(args,partials,holders,isCurried){
    var argsIndex=-1,
    argsLength=args.length,
    holdersLength=holders.length,
    leftIndex=-1,
    leftLength=partials.length,
    rangeLength=nativeMax(argsLength-holdersLength,0),
    result=Array(leftLength+rangeLength),
    isUncurried=!isCurried;

    while(++leftIndex<leftLength){
    result[leftIndex]=partials[leftIndex];
    }
    while(++argsIndex<holdersLength){
    if(isUncurried||argsIndex<argsLength){
    result[holders[argsIndex]]=args[argsIndex];
    }
    }
    while(rangeLength--){
    result[leftIndex++]=args[argsIndex++];
    }
    return result;
    }

    /**
    	     * This function is like `composeArgs` except that the arguments composition
    	     * is tailored for `_.partialRight`.
    	     *
    	     * @private
    	     * @param {Array} args The provided arguments.
    	     * @param {Array} partials The arguments to append to those provided.
    	     * @param {Array} holders The `partials` placeholder indexes.
    	     * @params {boolean} [isCurried] Specify composing for a curried function.
    	     * @returns {Array} Returns the new array of composed arguments.
    	     */
    function composeArgsRight(args,partials,holders,isCurried){
    var argsIndex=-1,
    argsLength=args.length,
    holdersIndex=-1,
    holdersLength=holders.length,
    rightIndex=-1,
    rightLength=partials.length,
    rangeLength=nativeMax(argsLength-holdersLength,0),
    result=Array(rangeLength+rightLength),
    isUncurried=!isCurried;

    while(++argsIndex<rangeLength){
    result[argsIndex]=args[argsIndex];
    }
    var offset=argsIndex;
    while(++rightIndex<rightLength){
    result[offset+rightIndex]=partials[rightIndex];
    }
    while(++holdersIndex<holdersLength){
    if(isUncurried||argsIndex<argsLength){
    result[offset+holders[holdersIndex]]=args[argsIndex++];
    }
    }
    return result;
    }

    /**
    	     * Copies the values of `source` to `array`.
    	     *
    	     * @private
    	     * @param {Array} source The array to copy values from.
    	     * @param {Array} [array=[]] The array to copy values to.
    	     * @returns {Array} Returns `array`.
    	     */
    function copyArray(source,array){
    var index=-1,
    length=source.length;

    array||(array=Array(length));
    while(++index<length){
    array[index]=source[index];
    }
    return array;
    }

    /**
    	     * Copies properties of `source` to `object`.
    	     *
    	     * @private
    	     * @param {Object} source The object to copy properties from.
    	     * @param {Array} props The property identifiers to copy.
    	     * @param {Object} [object={}] The object to copy properties to.
    	     * @param {Function} [customizer] The function to customize copied values.
    	     * @returns {Object} Returns `object`.
    	     */
    function copyObject(source,props,object,customizer){
    var isNew=!object;
    object||(object={});

    var index=-1,
    length=props.length;

    while(++index<length){
    var key=props[index];

    var newValue=customizer?
    customizer(object[key],source[key],key,object,source):
    undefined$1;

    if(newValue===undefined$1){
    newValue=source[key];
    }
    if(isNew){
    baseAssignValue(object,key,newValue);
    }else {
    assignValue(object,key,newValue);
    }
    }
    return object;
    }

    /**
    	     * Copies own symbols of `source` to `object`.
    	     *
    	     * @private
    	     * @param {Object} source The object to copy symbols from.
    	     * @param {Object} [object={}] The object to copy symbols to.
    	     * @returns {Object} Returns `object`.
    	     */
    function copySymbols(source,object){
    return copyObject(source,getSymbols(source),object);
    }

    /**
    	     * Copies own and inherited symbols of `source` to `object`.
    	     *
    	     * @private
    	     * @param {Object} source The object to copy symbols from.
    	     * @param {Object} [object={}] The object to copy symbols to.
    	     * @returns {Object} Returns `object`.
    	     */
    function copySymbolsIn(source,object){
    return copyObject(source,getSymbolsIn(source),object);
    }

    /**
    	     * Creates a function like `_.groupBy`.
    	     *
    	     * @private
    	     * @param {Function} setter The function to set accumulator values.
    	     * @param {Function} [initializer] The accumulator object initializer.
    	     * @returns {Function} Returns the new aggregator function.
    	     */
    function createAggregator(setter,initializer){
    return function(collection,iteratee){
    var func=isArray(collection)?arrayAggregator:baseAggregator,
    accumulator=initializer?initializer():{};

    return func(collection,setter,getIteratee(iteratee,2),accumulator);
    };
    }

    /**
    	     * Creates a function like `_.assign`.
    	     *
    	     * @private
    	     * @param {Function} assigner The function to assign values.
    	     * @returns {Function} Returns the new assigner function.
    	     */
    function createAssigner(assigner){
    return baseRest(function(object,sources){
    var index=-1,
    length=sources.length,
    customizer=length>1?sources[length-1]:undefined$1,
    guard=length>2?sources[2]:undefined$1;

    customizer=assigner.length>3&&typeof customizer=='function'?(
    length--,customizer):
    undefined$1;

    if(guard&&isIterateeCall(sources[0],sources[1],guard)){
    customizer=length<3?undefined$1:customizer;
    length=1;
    }
    object=Object(object);
    while(++index<length){
    var source=sources[index];
    if(source){
    assigner(object,source,index,customizer);
    }
    }
    return object;
    });
    }

    /**
    	     * Creates a `baseEach` or `baseEachRight` function.
    	     *
    	     * @private
    	     * @param {Function} eachFunc The function to iterate over a collection.
    	     * @param {boolean} [fromRight] Specify iterating from right to left.
    	     * @returns {Function} Returns the new base function.
    	     */
    function createBaseEach(eachFunc,fromRight){
    return function(collection,iteratee){
    if(collection==null){
    return collection;
    }
    if(!isArrayLike(collection)){
    return eachFunc(collection,iteratee);
    }
    var length=collection.length,
    index=fromRight?length:-1,
    iterable=Object(collection);

    while(fromRight?index--:++index<length){
    if(iteratee(iterable[index],index,iterable)===false){
    break;
    }
    }
    return collection;
    };
    }

    /**
    	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
    	     *
    	     * @private
    	     * @param {boolean} [fromRight] Specify iterating from right to left.
    	     * @returns {Function} Returns the new base function.
    	     */
    function createBaseFor(fromRight){
    return function(object,iteratee,keysFunc){
    var index=-1,
    iterable=Object(object),
    props=keysFunc(object),
    length=props.length;

    while(length--){
    var key=props[fromRight?length:++index];
    if(iteratee(iterable[key],key,iterable)===false){
    break;
    }
    }
    return object;
    };
    }

    /**
    	     * Creates a function that wraps `func` to invoke it with the optional `this`
    	     * binding of `thisArg`.
    	     *
    	     * @private
    	     * @param {Function} func The function to wrap.
    	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
    	     * @param {*} [thisArg] The `this` binding of `func`.
    	     * @returns {Function} Returns the new wrapped function.
    	     */
    function createBind(func,bitmask,thisArg){
    var isBind=bitmask&WRAP_BIND_FLAG,
    Ctor=createCtor(func);

    function wrapper(){
    var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;
    return fn.apply(isBind?thisArg:this,arguments);
    }
    return wrapper;
    }

    /**
    	     * Creates a function like `_.lowerFirst`.
    	     *
    	     * @private
    	     * @param {string} methodName The name of the `String` case method to use.
    	     * @returns {Function} Returns the new case function.
    	     */
    function createCaseFirst(methodName){
    return function(string){
    string=toString(string);

    var strSymbols=hasUnicode(string)?
    stringToArray(string):
    undefined$1;

    var chr=strSymbols?
    strSymbols[0]:
    string.charAt(0);

    var trailing=strSymbols?
    castSlice(strSymbols,1).join(''):
    string.slice(1);

    return chr[methodName]()+trailing;
    };
    }

    /**
    	     * Creates a function like `_.camelCase`.
    	     *
    	     * @private
    	     * @param {Function} callback The function to combine each word.
    	     * @returns {Function} Returns the new compounder function.
    	     */
    function createCompounder(callback){
    return function(string){
    return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');
    };
    }

    /**
    	     * Creates a function that produces an instance of `Ctor` regardless of
    	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
    	     *
    	     * @private
    	     * @param {Function} Ctor The constructor to wrap.
    	     * @returns {Function} Returns the new wrapped function.
    	     */
    function createCtor(Ctor){
    return function(){
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args=arguments;
    switch(args.length){
    case 0:return new Ctor();
    case 1:return new Ctor(args[0]);
    case 2:return new Ctor(args[0],args[1]);
    case 3:return new Ctor(args[0],args[1],args[2]);
    case 4:return new Ctor(args[0],args[1],args[2],args[3]);
    case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);
    case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);
    case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}

    var thisBinding=baseCreate(Ctor.prototype),
    result=Ctor.apply(thisBinding,args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result)?result:thisBinding;
    };
    }

    /**
    	     * Creates a function that wraps `func` to enable currying.
    	     *
    	     * @private
    	     * @param {Function} func The function to wrap.
    	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
    	     * @param {number} arity The arity of `func`.
    	     * @returns {Function} Returns the new wrapped function.
    	     */
    function createCurry(func,bitmask,arity){
    var Ctor=createCtor(func);

    function wrapper(){
    var length=arguments.length,
    args=Array(length),
    index=length,
    placeholder=getHolder(wrapper);

    while(index--){
    args[index]=arguments[index];
    }
    var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?
    []:
    replaceHolders(args,placeholder);

    length-=holders.length;
    if(length<arity){
    return createRecurry(
    func,bitmask,createHybrid,wrapper.placeholder,undefined$1,
    args,holders,undefined$1,undefined$1,arity-length);
    }
    var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;
    return apply(fn,this,args);
    }
    return wrapper;
    }

    /**
    	     * Creates a `_.find` or `_.findLast` function.
    	     *
    	     * @private
    	     * @param {Function} findIndexFunc The function to find the collection index.
    	     * @returns {Function} Returns the new find function.
    	     */
    function createFind(findIndexFunc){
    return function(collection,predicate,fromIndex){
    var iterable=Object(collection);
    if(!isArrayLike(collection)){
    var iteratee=getIteratee(predicate,3);
    collection=keys(collection);
    predicate=function(key){return iteratee(iterable[key],key,iterable);};
    }
    var index=findIndexFunc(collection,predicate,fromIndex);
    return index>-1?iterable[iteratee?collection[index]:index]:undefined$1;
    };
    }

    /**
    	     * Creates a `_.flow` or `_.flowRight` function.
    	     *
    	     * @private
    	     * @param {boolean} [fromRight] Specify iterating from right to left.
    	     * @returns {Function} Returns the new flow function.
    	     */
    function createFlow(fromRight){
    return flatRest(function(funcs){
    var length=funcs.length,
    index=length,
    prereq=LodashWrapper.prototype.thru;

    if(fromRight){
    funcs.reverse();
    }
    while(index--){
    var func=funcs[index];
    if(typeof func!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){
    var wrapper=new LodashWrapper([],true);
    }
    }
    index=wrapper?index:length;
    while(++index<length){
    func=funcs[index];

    var funcName=getFuncName(func),
    data=funcName=='wrapper'?getData(func):undefined$1;

    if(data&&isLaziable(data[0])&&
    data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&
    !data[4].length&&data[9]==1)
    {
    wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);
    }else {
    wrapper=func.length==1&&isLaziable(func)?
    wrapper[funcName]():
    wrapper.thru(func);
    }
    }
    return function(){
    var args=arguments,
    value=args[0];

    if(wrapper&&args.length==1&&isArray(value)){
    return wrapper.plant(value).value();
    }
    var index=0,
    result=length?funcs[index].apply(this,args):value;

    while(++index<length){
    result=funcs[index].call(this,result);
    }
    return result;
    };
    });
    }

    /**
    	     * Creates a function that wraps `func` to invoke it with optional `this`
    	     * binding of `thisArg`, partial application, and currying.
    	     *
    	     * @private
    	     * @param {Function|string} func The function or method name to wrap.
    	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
    	     * @param {*} [thisArg] The `this` binding of `func`.
    	     * @param {Array} [partials] The arguments to prepend to those provided to
    	     *  the new function.
    	     * @param {Array} [holders] The `partials` placeholder indexes.
    	     * @param {Array} [partialsRight] The arguments to append to those provided
    	     *  to the new function.
    	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
    	     * @param {Array} [argPos] The argument positions of the new function.
    	     * @param {number} [ary] The arity cap of `func`.
    	     * @param {number} [arity] The arity of `func`.
    	     * @returns {Function} Returns the new wrapped function.
    	     */
    function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){
    var isAry=bitmask&WRAP_ARY_FLAG,
    isBind=bitmask&WRAP_BIND_FLAG,
    isBindKey=bitmask&WRAP_BIND_KEY_FLAG,
    isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),
    isFlip=bitmask&WRAP_FLIP_FLAG,
    Ctor=isBindKey?undefined$1:createCtor(func);

    function wrapper(){
    var length=arguments.length,
    args=Array(length),
    index=length;

    while(index--){
    args[index]=arguments[index];
    }
    if(isCurried){
    var placeholder=getHolder(wrapper),
    holdersCount=countHolders(args,placeholder);
    }
    if(partials){
    args=composeArgs(args,partials,holders,isCurried);
    }
    if(partialsRight){
    args=composeArgsRight(args,partialsRight,holdersRight,isCurried);
    }
    length-=holdersCount;
    if(isCurried&&length<arity){
    var newHolders=replaceHolders(args,placeholder);
    return createRecurry(
    func,bitmask,createHybrid,wrapper.placeholder,thisArg,
    args,newHolders,argPos,ary,arity-length);

    }
    var thisBinding=isBind?thisArg:this,
    fn=isBindKey?thisBinding[func]:func;

    length=args.length;
    if(argPos){
    args=reorder(args,argPos);
    }else if(isFlip&&length>1){
    args.reverse();
    }
    if(isAry&&ary<length){
    args.length=ary;
    }
    if(this&&this!==root&&this instanceof wrapper){
    fn=Ctor||createCtor(fn);
    }
    return fn.apply(thisBinding,args);
    }
    return wrapper;
    }

    /**
    	     * Creates a function like `_.invertBy`.
    	     *
    	     * @private
    	     * @param {Function} setter The function to set accumulator values.
    	     * @param {Function} toIteratee The function to resolve iteratees.
    	     * @returns {Function} Returns the new inverter function.
    	     */
    function createInverter(setter,toIteratee){
    return function(object,iteratee){
    return baseInverter(object,setter,toIteratee(iteratee),{});
    };
    }

    /**
    	     * Creates a function that performs a mathematical operation on two values.
    	     *
    	     * @private
    	     * @param {Function} operator The function to perform the operation.
    	     * @param {number} [defaultValue] The value used for `undefined` arguments.
    	     * @returns {Function} Returns the new mathematical operation function.
    	     */
    function createMathOperation(operator,defaultValue){
    return function(value,other){
    var result;
    if(value===undefined$1&&other===undefined$1){
    return defaultValue;
    }
    if(value!==undefined$1){
    result=value;
    }
    if(other!==undefined$1){
    if(result===undefined$1){
    return other;
    }
    if(typeof value=='string'||typeof other=='string'){
    value=baseToString(value);
    other=baseToString(other);
    }else {
    value=baseToNumber(value);
    other=baseToNumber(other);
    }
    result=operator(value,other);
    }
    return result;
    };
    }

    /**
    	     * Creates a function like `_.over`.
    	     *
    	     * @private
    	     * @param {Function} arrayFunc The function to iterate over iteratees.
    	     * @returns {Function} Returns the new over function.
    	     */
    function createOver(arrayFunc){
    return flatRest(function(iteratees){
    iteratees=arrayMap(iteratees,baseUnary(getIteratee()));
    return baseRest(function(args){
    var thisArg=this;
    return arrayFunc(iteratees,function(iteratee){
    return apply(iteratee,thisArg,args);
    });
    });
    });
    }

    /**
    	     * Creates the padding for `string` based on `length`. The `chars` string
    	     * is truncated if the number of characters exceeds `length`.
    	     *
    	     * @private
    	     * @param {number} length The padding length.
    	     * @param {string} [chars=' '] The string used as padding.
    	     * @returns {string} Returns the padding for `string`.
    	     */
    function createPadding(length,chars){
    chars=chars===undefined$1?' ':baseToString(chars);

    var charsLength=chars.length;
    if(charsLength<2){
    return charsLength?baseRepeat(chars,length):chars;
    }
    var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));
    return hasUnicode(chars)?
    castSlice(stringToArray(result),0,length).join(''):
    result.slice(0,length);
    }

    /**
    	     * Creates a function that wraps `func` to invoke it with the `this` binding
    	     * of `thisArg` and `partials` prepended to the arguments it receives.
    	     *
    	     * @private
    	     * @param {Function} func The function to wrap.
    	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
    	     * @param {*} thisArg The `this` binding of `func`.
    	     * @param {Array} partials The arguments to prepend to those provided to
    	     *  the new function.
    	     * @returns {Function} Returns the new wrapped function.
    	     */
    function createPartial(func,bitmask,thisArg,partials){
    var isBind=bitmask&WRAP_BIND_FLAG,
    Ctor=createCtor(func);

    function wrapper(){
    var argsIndex=-1,
    argsLength=arguments.length,
    leftIndex=-1,
    leftLength=partials.length,
    args=Array(leftLength+argsLength),
    fn=this&&this!==root&&this instanceof wrapper?Ctor:func;

    while(++leftIndex<leftLength){
    args[leftIndex]=partials[leftIndex];
    }
    while(argsLength--){
    args[leftIndex++]=arguments[++argsIndex];
    }
    return apply(fn,isBind?thisArg:this,args);
    }
    return wrapper;
    }

    /**
    	     * Creates a `_.range` or `_.rangeRight` function.
    	     *
    	     * @private
    	     * @param {boolean} [fromRight] Specify iterating from right to left.
    	     * @returns {Function} Returns the new range function.
    	     */
    function createRange(fromRight){
    return function(start,end,step){
    if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){
    end=step=undefined$1;
    }
    // Ensure the sign of `-0` is preserved.
    start=toFinite(start);
    if(end===undefined$1){
    end=start;
    start=0;
    }else {
    end=toFinite(end);
    }
    step=step===undefined$1?start<end?1:-1:toFinite(step);
    return baseRange(start,end,step,fromRight);
    };
    }

    /**
    	     * Creates a function that performs a relational operation on two values.
    	     *
    	     * @private
    	     * @param {Function} operator The function to perform the operation.
    	     * @returns {Function} Returns the new relational operation function.
    	     */
    function createRelationalOperation(operator){
    return function(value,other){
    if(!(typeof value=='string'&&typeof other=='string')){
    value=toNumber(value);
    other=toNumber(other);
    }
    return operator(value,other);
    };
    }

    /**
    	     * Creates a function that wraps `func` to continue currying.
    	     *
    	     * @private
    	     * @param {Function} func The function to wrap.
    	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
    	     * @param {Function} wrapFunc The function to create the `func` wrapper.
    	     * @param {*} placeholder The placeholder value.
    	     * @param {*} [thisArg] The `this` binding of `func`.
    	     * @param {Array} [partials] The arguments to prepend to those provided to
    	     *  the new function.
    	     * @param {Array} [holders] The `partials` placeholder indexes.
    	     * @param {Array} [argPos] The argument positions of the new function.
    	     * @param {number} [ary] The arity cap of `func`.
    	     * @param {number} [arity] The arity of `func`.
    	     * @returns {Function} Returns the new wrapped function.
    	     */
    function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){
    var isCurry=bitmask&WRAP_CURRY_FLAG,
    newHolders=isCurry?holders:undefined$1,
    newHoldersRight=isCurry?undefined$1:holders,
    newPartials=isCurry?partials:undefined$1,
    newPartialsRight=isCurry?undefined$1:partials;

    bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;
    bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);

    if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){
    bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);
    }
    var newData=[
    func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,
    newHoldersRight,argPos,ary,arity];


    var result=wrapFunc.apply(undefined$1,newData);
    if(isLaziable(func)){
    setData(result,newData);
    }
    result.placeholder=placeholder;
    return setWrapToString(result,func,bitmask);
    }

    /**
    	     * Creates a function like `_.round`.
    	     *
    	     * @private
    	     * @param {string} methodName The name of the `Math` method to use when rounding.
    	     * @returns {Function} Returns the new round function.
    	     */
    function createRound(methodName){
    var func=Math[methodName];
    return function(number,precision){
    number=toNumber(number);
    precision=precision==null?0:nativeMin(toInteger(precision),292);
    if(precision&&nativeIsFinite(number)){
    // Shift with exponential notation to avoid floating-point issues.
    // See [MDN](https://mdn.io/round#Examples) for more details.
    var pair=(toString(number)+'e').split('e'),
    value=func(pair[0]+'e'+(+pair[1]+precision));

    pair=(toString(value)+'e').split('e');
    return +(pair[0]+'e'+(+pair[1]-precision));
    }
    return func(number);
    };
    }

    /**
    	     * Creates a set object of `values`.
    	     *
    	     * @private
    	     * @param {Array} values The values to add to the set.
    	     * @returns {Object} Returns the new set.
    	     */
    var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){
    return new Set(values);
    };

    /**
    	     * Creates a `_.toPairs` or `_.toPairsIn` function.
    	     *
    	     * @private
    	     * @param {Function} keysFunc The function to get the keys of a given object.
    	     * @returns {Function} Returns the new pairs function.
    	     */
    function createToPairs(keysFunc){
    return function(object){
    var tag=getTag(object);
    if(tag==mapTag){
    return mapToArray(object);
    }
    if(tag==setTag){
    return setToPairs(object);
    }
    return baseToPairs(object,keysFunc(object));
    };
    }

    /**
    	     * Creates a function that either curries or invokes `func` with optional
    	     * `this` binding and partially applied arguments.
    	     *
    	     * @private
    	     * @param {Function|string} func The function or method name to wrap.
    	     * @param {number} bitmask The bitmask flags.
    	     *    1 - `_.bind`
    	     *    2 - `_.bindKey`
    	     *    4 - `_.curry` or `_.curryRight` of a bound function
    	     *    8 - `_.curry`
    	     *   16 - `_.curryRight`
    	     *   32 - `_.partial`
    	     *   64 - `_.partialRight`
    	     *  128 - `_.rearg`
    	     *  256 - `_.ary`
    	     *  512 - `_.flip`
    	     * @param {*} [thisArg] The `this` binding of `func`.
    	     * @param {Array} [partials] The arguments to be partially applied.
    	     * @param {Array} [holders] The `partials` placeholder indexes.
    	     * @param {Array} [argPos] The argument positions of the new function.
    	     * @param {number} [ary] The arity cap of `func`.
    	     * @param {number} [arity] The arity of `func`.
    	     * @returns {Function} Returns the new wrapped function.
    	     */
    function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){
    var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;
    if(!isBindKey&&typeof func!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    var length=partials?partials.length:0;
    if(!length){
    bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);
    partials=holders=undefined$1;
    }
    ary=ary===undefined$1?ary:nativeMax(toInteger(ary),0);
    arity=arity===undefined$1?arity:toInteger(arity);
    length-=holders?holders.length:0;

    if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){
    var partialsRight=partials,
    holdersRight=holders;

    partials=holders=undefined$1;
    }
    var data=isBindKey?undefined$1:getData(func);

    var newData=[
    func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,
    argPos,ary,arity];


    if(data){
    mergeData(newData,data);
    }
    func=newData[0];
    bitmask=newData[1];
    thisArg=newData[2];
    partials=newData[3];
    holders=newData[4];
    arity=newData[9]=newData[9]===undefined$1?
    isBindKey?0:func.length:
    nativeMax(newData[9]-length,0);

    if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){
    bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);
    }
    if(!bitmask||bitmask==WRAP_BIND_FLAG){
    var result=createBind(func,bitmask,thisArg);
    }else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){
    result=createCurry(func,bitmask,arity);
    }else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){
    result=createPartial(func,bitmask,thisArg,partials);
    }else {
    result=createHybrid.apply(undefined$1,newData);
    }
    var setter=data?baseSetData:setData;
    return setWrapToString(setter(result,newData),func,bitmask);
    }

    /**
    	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
    	     * of source objects to the destination object for all destination properties
    	     * that resolve to `undefined`.
    	     *
    	     * @private
    	     * @param {*} objValue The destination value.
    	     * @param {*} srcValue The source value.
    	     * @param {string} key The key of the property to assign.
    	     * @param {Object} object The parent object of `objValue`.
    	     * @returns {*} Returns the value to assign.
    	     */
    function customDefaultsAssignIn(objValue,srcValue,key,object){
    if(objValue===undefined$1||
    eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){
    return srcValue;
    }
    return objValue;
    }

    /**
    	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
    	     * objects into destination objects that are passed thru.
    	     *
    	     * @private
    	     * @param {*} objValue The destination value.
    	     * @param {*} srcValue The source value.
    	     * @param {string} key The key of the property to merge.
    	     * @param {Object} object The parent object of `objValue`.
    	     * @param {Object} source The parent object of `srcValue`.
    	     * @param {Object} [stack] Tracks traversed source values and their merged
    	     *  counterparts.
    	     * @returns {*} Returns the value to assign.
    	     */
    function customDefaultsMerge(objValue,srcValue,key,object,source,stack){
    if(isObject(objValue)&&isObject(srcValue)){
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue,objValue);
    baseMerge(objValue,srcValue,undefined$1,customDefaultsMerge,stack);
    stack['delete'](srcValue);
    }
    return objValue;
    }

    /**
    	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
    	     * objects.
    	     *
    	     * @private
    	     * @param {*} value The value to inspect.
    	     * @param {string} key The key of the property to inspect.
    	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
    	     */
    function customOmitClone(value){
    return isPlainObject(value)?undefined$1:value;
    }

    /**
    	     * A specialized version of `baseIsEqualDeep` for arrays with support for
    	     * partial deep comparisons.
    	     *
    	     * @private
    	     * @param {Array} array The array to compare.
    	     * @param {Array} other The other array to compare.
    	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
    	     * @param {Function} customizer The function to customize comparisons.
    	     * @param {Function} equalFunc The function to determine equivalents of values.
    	     * @param {Object} stack Tracks traversed `array` and `other` objects.
    	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
    	     */
    function equalArrays(array,other,bitmask,customizer,equalFunc,stack){
    var isPartial=bitmask&COMPARE_PARTIAL_FLAG,
    arrLength=array.length,
    othLength=other.length;

    if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){
    return false;
    }
    // Check that cyclic values are equal.
    var arrStacked=stack.get(array);
    var othStacked=stack.get(other);
    if(arrStacked&&othStacked){
    return arrStacked==other&&othStacked==array;
    }
    var index=-1,
    result=true,
    seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined$1;

    stack.set(array,other);
    stack.set(other,array);

    // Ignore non-index properties.
    while(++index<arrLength){
    var arrValue=array[index],
    othValue=other[index];

    if(customizer){
    var compared=isPartial?
    customizer(othValue,arrValue,index,other,array,stack):
    customizer(arrValue,othValue,index,array,other,stack);
    }
    if(compared!==undefined$1){
    if(compared){
    continue;
    }
    result=false;
    break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if(seen){
    if(!arraySome(other,function(othValue,othIndex){
    if(!cacheHas(seen,othIndex)&&(
    arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){
    return seen.push(othIndex);
    }
    })){
    result=false;
    break;
    }
    }else if(!(
    arrValue===othValue||
    equalFunc(arrValue,othValue,bitmask,customizer,stack)))
    {
    result=false;
    break;
    }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
    }

    /**
    	     * A specialized version of `baseIsEqualDeep` for comparing objects of
    	     * the same `toStringTag`.
    	     *
    	     * **Note:** This function only supports comparing values with tags of
    	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
    	     *
    	     * @private
    	     * @param {Object} object The object to compare.
    	     * @param {Object} other The other object to compare.
    	     * @param {string} tag The `toStringTag` of the objects to compare.
    	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
    	     * @param {Function} customizer The function to customize comparisons.
    	     * @param {Function} equalFunc The function to determine equivalents of values.
    	     * @param {Object} stack Tracks traversed `object` and `other` objects.
    	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
    	     */
    function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){
    switch(tag){
    case dataViewTag:
    if(object.byteLength!=other.byteLength||
    object.byteOffset!=other.byteOffset){
    return false;
    }
    object=object.buffer;
    other=other.buffer;

    case arrayBufferTag:
    if(object.byteLength!=other.byteLength||
    !equalFunc(new Uint8Array(object),new Uint8Array(other))){
    return false;
    }
    return true;

    case boolTag:
    case dateTag:
    case numberTag:
    // Coerce booleans to `1` or `0` and dates to milliseconds.
    // Invalid dates are coerced to `NaN`.
    return eq(+object,+other);

    case errorTag:
    return object.name==other.name&&object.message==other.message;

    case regexpTag:
    case stringTag:
    // Coerce regexes to strings and treat strings, primitives and objects,
    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
    // for more details.
    return object==other+'';

    case mapTag:
    var convert=mapToArray;

    case setTag:
    var isPartial=bitmask&COMPARE_PARTIAL_FLAG;
    convert||(convert=setToArray);

    if(object.size!=other.size&&!isPartial){
    return false;
    }
    // Assume cyclic values are equal.
    var stacked=stack.get(object);
    if(stacked){
    return stacked==other;
    }
    bitmask|=COMPARE_UNORDERED_FLAG;

    // Recursively compare objects (susceptible to call stack limits).
    stack.set(object,other);
    var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);
    stack['delete'](object);
    return result;

    case symbolTag:
    if(symbolValueOf){
    return symbolValueOf.call(object)==symbolValueOf.call(other);
    }}

    return false;
    }

    /**
    	     * A specialized version of `baseIsEqualDeep` for objects with support for
    	     * partial deep comparisons.
    	     *
    	     * @private
    	     * @param {Object} object The object to compare.
    	     * @param {Object} other The other object to compare.
    	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
    	     * @param {Function} customizer The function to customize comparisons.
    	     * @param {Function} equalFunc The function to determine equivalents of values.
    	     * @param {Object} stack Tracks traversed `object` and `other` objects.
    	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
    	     */
    function equalObjects(object,other,bitmask,customizer,equalFunc,stack){
    var isPartial=bitmask&COMPARE_PARTIAL_FLAG,
    objProps=getAllKeys(object),
    objLength=objProps.length,
    othProps=getAllKeys(other),
    othLength=othProps.length;

    if(objLength!=othLength&&!isPartial){
    return false;
    }
    var index=objLength;
    while(index--){
    var key=objProps[index];
    if(!(isPartial?key in other:hasOwnProperty.call(other,key))){
    return false;
    }
    }
    // Check that cyclic values are equal.
    var objStacked=stack.get(object);
    var othStacked=stack.get(other);
    if(objStacked&&othStacked){
    return objStacked==other&&othStacked==object;
    }
    var result=true;
    stack.set(object,other);
    stack.set(other,object);

    var skipCtor=isPartial;
    while(++index<objLength){
    key=objProps[index];
    var objValue=object[key],
    othValue=other[key];

    if(customizer){
    var compared=isPartial?
    customizer(othValue,objValue,key,other,object,stack):
    customizer(objValue,othValue,key,object,other,stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if(!(compared===undefined$1?
    objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):
    compared))
    {
    result=false;
    break;
    }
    skipCtor||(skipCtor=key=='constructor');
    }
    if(result&&!skipCtor){
    var objCtor=object.constructor,
    othCtor=other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if(objCtor!=othCtor&&
    'constructor'in object&&'constructor'in other&&
    !(typeof objCtor=='function'&&objCtor instanceof objCtor&&
    typeof othCtor=='function'&&othCtor instanceof othCtor)){
    result=false;
    }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
    }

    /**
    	     * A specialized version of `baseRest` which flattens the rest array.
    	     *
    	     * @private
    	     * @param {Function} func The function to apply a rest parameter to.
    	     * @returns {Function} Returns the new function.
    	     */
    function flatRest(func){
    return setToString(overRest(func,undefined$1,flatten),func+'');
    }

    /**
    	     * Creates an array of own enumerable property names and symbols of `object`.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the array of property names and symbols.
    	     */
    function getAllKeys(object){
    return baseGetAllKeys(object,keys,getSymbols);
    }

    /**
    	     * Creates an array of own and inherited enumerable property names and
    	     * symbols of `object`.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the array of property names and symbols.
    	     */
    function getAllKeysIn(object){
    return baseGetAllKeys(object,keysIn,getSymbolsIn);
    }

    /**
    	     * Gets metadata for `func`.
    	     *
    	     * @private
    	     * @param {Function} func The function to query.
    	     * @returns {*} Returns the metadata for `func`.
    	     */
    var getData=!metaMap?noop:function(func){
    return metaMap.get(func);
    };

    /**
    	     * Gets the name of `func`.
    	     *
    	     * @private
    	     * @param {Function} func The function to query.
    	     * @returns {string} Returns the function name.
    	     */
    function getFuncName(func){
    var result=func.name+'',
    array=realNames[result],
    length=hasOwnProperty.call(realNames,result)?array.length:0;

    while(length--){
    var data=array[length],
    otherFunc=data.func;
    if(otherFunc==null||otherFunc==func){
    return data.name;
    }
    }
    return result;
    }

    /**
    	     * Gets the argument placeholder value for `func`.
    	     *
    	     * @private
    	     * @param {Function} func The function to inspect.
    	     * @returns {*} Returns the placeholder value.
    	     */
    function getHolder(func){
    var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;
    return object.placeholder;
    }

    /**
    	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
    	     * this function returns the custom method, otherwise it returns `baseIteratee`.
    	     * If arguments are provided, the chosen function is invoked with them and
    	     * its result is returned.
    	     *
    	     * @private
    	     * @param {*} [value] The value to convert to an iteratee.
    	     * @param {number} [arity] The arity of the created iteratee.
    	     * @returns {Function} Returns the chosen function or its result.
    	     */
    function getIteratee(){
    var result=lodash.iteratee||iteratee;
    result=result===iteratee?baseIteratee:result;
    return arguments.length?result(arguments[0],arguments[1]):result;
    }

    /**
    	     * Gets the data for `map`.
    	     *
    	     * @private
    	     * @param {Object} map The map to query.
    	     * @param {string} key The reference key.
    	     * @returns {*} Returns the map data.
    	     */
    function getMapData(map,key){
    var data=map.__data__;
    return isKeyable(key)?
    data[typeof key=='string'?'string':'hash']:
    data.map;
    }

    /**
    	     * Gets the property names, values, and compare flags of `object`.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the match data of `object`.
    	     */
    function getMatchData(object){
    var result=keys(object),
    length=result.length;

    while(length--){
    var key=result[length],
    value=object[key];

    result[length]=[key,value,isStrictComparable(value)];
    }
    return result;
    }

    /**
    	     * Gets the native function at `key` of `object`.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @param {string} key The key of the method to get.
    	     * @returns {*} Returns the function if it's native, else `undefined`.
    	     */
    function getNative(object,key){
    var value=getValue(object,key);
    return baseIsNative(value)?value:undefined$1;
    }

    /**
    	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
    	     *
    	     * @private
    	     * @param {*} value The value to query.
    	     * @returns {string} Returns the raw `toStringTag`.
    	     */
    function getRawTag(value){
    var isOwn=hasOwnProperty.call(value,symToStringTag),
    tag=value[symToStringTag];

    try{
    value[symToStringTag]=undefined$1;
    var unmasked=true;
    }catch(e){}

    var result=nativeObjectToString.call(value);
    if(unmasked){
    if(isOwn){
    value[symToStringTag]=tag;
    }else {
    delete value[symToStringTag];
    }
    }
    return result;
    }

    /**
    	     * Creates an array of the own enumerable symbols of `object`.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the array of symbols.
    	     */
    var getSymbols=!nativeGetSymbols?stubArray:function(object){
    if(object==null){
    return [];
    }
    object=Object(object);
    return arrayFilter(nativeGetSymbols(object),function(symbol){
    return propertyIsEnumerable.call(object,symbol);
    });
    };

    /**
    	     * Creates an array of the own and inherited enumerable symbols of `object`.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the array of symbols.
    	     */
    var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){
    var result=[];
    while(object){
    arrayPush(result,getSymbols(object));
    object=getPrototype(object);
    }
    return result;
    };

    /**
    	     * Gets the `toStringTag` of `value`.
    	     *
    	     * @private
    	     * @param {*} value The value to query.
    	     * @returns {string} Returns the `toStringTag`.
    	     */
    var getTag=baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||
    Map&&getTag(new Map())!=mapTag||
    Promise&&getTag(Promise.resolve())!=promiseTag||
    Set&&getTag(new Set())!=setTag||
    WeakMap&&getTag(new WeakMap())!=weakMapTag){
    getTag=function(value){
    var result=baseGetTag(value),
    Ctor=result==objectTag?value.constructor:undefined$1,
    ctorString=Ctor?toSource(Ctor):'';

    if(ctorString){
    switch(ctorString){
    case dataViewCtorString:return dataViewTag;
    case mapCtorString:return mapTag;
    case promiseCtorString:return promiseTag;
    case setCtorString:return setTag;
    case weakMapCtorString:return weakMapTag;}

    }
    return result;
    };
    }

    /**
    	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
    	     *
    	     * @private
    	     * @param {number} start The start of the view.
    	     * @param {number} end The end of the view.
    	     * @param {Array} transforms The transformations to apply to the view.
    	     * @returns {Object} Returns an object containing the `start` and `end`
    	     *  positions of the view.
    	     */
    function getView(start,end,transforms){
    var index=-1,
    length=transforms.length;

    while(++index<length){
    var data=transforms[index],
    size=data.size;

    switch(data.type){
    case'drop':start+=size;break;
    case'dropRight':end-=size;break;
    case'take':end=nativeMin(end,start+size);break;
    case'takeRight':start=nativeMax(start,end-size);break;}

    }
    return {'start':start,'end':end};
    }

    /**
    	     * Extracts wrapper details from the `source` body comment.
    	     *
    	     * @private
    	     * @param {string} source The source to inspect.
    	     * @returns {Array} Returns the wrapper details.
    	     */
    function getWrapDetails(source){
    var match=source.match(reWrapDetails);
    return match?match[1].split(reSplitDetails):[];
    }

    /**
    	     * Checks if `path` exists on `object`.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @param {Array|string} path The path to check.
    	     * @param {Function} hasFunc The function to check properties.
    	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
    	     */
    function hasPath(object,path,hasFunc){
    path=castPath(path,object);

    var index=-1,
    length=path.length,
    result=false;

    while(++index<length){
    var key=toKey(path[index]);
    if(!(result=object!=null&&hasFunc(object,key))){
    break;
    }
    object=object[key];
    }
    if(result||++index!=length){
    return result;
    }
    length=object==null?0:object.length;
    return !!length&&isLength(length)&&isIndex(key,length)&&(
    isArray(object)||isArguments(object));
    }

    /**
    	     * Initializes an array clone.
    	     *
    	     * @private
    	     * @param {Array} array The array to clone.
    	     * @returns {Array} Returns the initialized clone.
    	     */
    function initCloneArray(array){
    var length=array.length,
    result=new array.constructor(length);

    // Add properties assigned by `RegExp#exec`.
    if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){
    result.index=array.index;
    result.input=array.input;
    }
    return result;
    }

    /**
    	     * Initializes an object clone.
    	     *
    	     * @private
    	     * @param {Object} object The object to clone.
    	     * @returns {Object} Returns the initialized clone.
    	     */
    function initCloneObject(object){
    return typeof object.constructor=='function'&&!isPrototype(object)?
    baseCreate(getPrototype(object)):
    {};
    }

    /**
    	     * Initializes an object clone based on its `toStringTag`.
    	     *
    	     * **Note:** This function only supports cloning values with tags of
    	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
    	     *
    	     * @private
    	     * @param {Object} object The object to clone.
    	     * @param {string} tag The `toStringTag` of the object to clone.
    	     * @param {boolean} [isDeep] Specify a deep clone.
    	     * @returns {Object} Returns the initialized clone.
    	     */
    function initCloneByTag(object,tag,isDeep){
    var Ctor=object.constructor;
    switch(tag){
    case arrayBufferTag:
    return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
    return new Ctor(+object);

    case dataViewTag:
    return cloneDataView(object,isDeep);

    case float32Tag:case float64Tag:
    case int8Tag:case int16Tag:case int32Tag:
    case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:
    return cloneTypedArray(object,isDeep);

    case mapTag:
    return new Ctor();

    case numberTag:
    case stringTag:
    return new Ctor(object);

    case regexpTag:
    return cloneRegExp(object);

    case setTag:
    return new Ctor();

    case symbolTag:
    return cloneSymbol(object);}

    }

    /**
    	     * Inserts wrapper `details` in a comment at the top of the `source` body.
    	     *
    	     * @private
    	     * @param {string} source The source to modify.
    	     * @returns {Array} details The details to insert.
    	     * @returns {string} Returns the modified source.
    	     */
    function insertWrapDetails(source,details){
    var length=details.length;
    if(!length){
    return source;
    }
    var lastIndex=length-1;
    details[lastIndex]=(length>1?'& ':'')+details[lastIndex];
    details=details.join(length>2?', ':' ');
    return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');
    }

    /**
    	     * Checks if `value` is a flattenable `arguments` object or array.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
    	     */
    function isFlattenable(value){
    return isArray(value)||isArguments(value)||
    !!(spreadableSymbol&&value&&value[spreadableSymbol]);
    }

    /**
    	     * Checks if `value` is a valid array-like index.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
    	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
    	     */
    function isIndex(value,length){
    var type=typeof value;
    length=length==null?MAX_SAFE_INTEGER:length;

    return !!length&&(
    type=='number'||
    type!='symbol'&&reIsUint.test(value))&&
    value>-1&&value%1==0&&value<length;
    }

    /**
    	     * Checks if the given arguments are from an iteratee call.
    	     *
    	     * @private
    	     * @param {*} value The potential iteratee value argument.
    	     * @param {*} index The potential iteratee index or key argument.
    	     * @param {*} object The potential iteratee object argument.
    	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
    	     *  else `false`.
    	     */
    function isIterateeCall(value,index,object){
    if(!isObject(object)){
    return false;
    }
    var type=typeof index;
    if(type=='number'?
    isArrayLike(object)&&isIndex(index,object.length):
    type=='string'&&index in object)
    {
    return eq(object[index],value);
    }
    return false;
    }

    /**
    	     * Checks if `value` is a property name and not a property path.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @param {Object} [object] The object to query keys on.
    	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
    	     */
    function isKey(value,object){
    if(isArray(value)){
    return false;
    }
    var type=typeof value;
    if(type=='number'||type=='symbol'||type=='boolean'||
    value==null||isSymbol(value)){
    return true;
    }
    return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||
    object!=null&&value in Object(object);
    }

    /**
    	     * Checks if `value` is suitable for use as unique object key.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
    	     */
    function isKeyable(value){
    var type=typeof value;
    return type=='string'||type=='number'||type=='symbol'||type=='boolean'?
    value!=='__proto__':
    value===null;
    }

    /**
    	     * Checks if `func` has a lazy counterpart.
    	     *
    	     * @private
    	     * @param {Function} func The function to check.
    	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
    	     *  else `false`.
    	     */
    function isLaziable(func){
    var funcName=getFuncName(func),
    other=lodash[funcName];

    if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){
    return false;
    }
    if(func===other){
    return true;
    }
    var data=getData(other);
    return !!data&&func===data[0];
    }

    /**
    	     * Checks if `func` has its source masked.
    	     *
    	     * @private
    	     * @param {Function} func The function to check.
    	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
    	     */
    function isMasked(func){
    return !!maskSrcKey&&maskSrcKey in func;
    }

    /**
    	     * Checks if `func` is capable of being masked.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
    	     */
    var isMaskable=coreJsData?isFunction:stubFalse;

    /**
    	     * Checks if `value` is likely a prototype object.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
    	     */
    function isPrototype(value){
    var Ctor=value&&value.constructor,
    proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;

    return value===proto;
    }

    /**
    	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
    	     *
    	     * @private
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` if suitable for strict
    	     *  equality comparisons, else `false`.
    	     */
    function isStrictComparable(value){
    return value===value&&!isObject(value);
    }

    /**
    	     * A specialized version of `matchesProperty` for source values suitable
    	     * for strict equality comparisons, i.e. `===`.
    	     *
    	     * @private
    	     * @param {string} key The key of the property to get.
    	     * @param {*} srcValue The value to match.
    	     * @returns {Function} Returns the new spec function.
    	     */
    function matchesStrictComparable(key,srcValue){
    return function(object){
    if(object==null){
    return false;
    }
    return object[key]===srcValue&&(
    srcValue!==undefined$1||key in Object(object));
    };
    }

    /**
    	     * A specialized version of `_.memoize` which clears the memoized function's
    	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
    	     *
    	     * @private
    	     * @param {Function} func The function to have its output memoized.
    	     * @returns {Function} Returns the new memoized function.
    	     */
    function memoizeCapped(func){
    var result=memoize(func,function(key){
    if(cache.size===MAX_MEMOIZE_SIZE){
    cache.clear();
    }
    return key;
    });

    var cache=result.cache;
    return result;
    }

    /**
    	     * Merges the function metadata of `source` into `data`.
    	     *
    	     * Merging metadata reduces the number of wrappers used to invoke a function.
    	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
    	     * may be applied regardless of execution order. Methods like `_.ary` and
    	     * `_.rearg` modify function arguments, making the order in which they are
    	     * executed important, preventing the merging of metadata. However, we make
    	     * an exception for a safe combined case where curried functions have `_.ary`
    	     * and or `_.rearg` applied.
    	     *
    	     * @private
    	     * @param {Array} data The destination metadata.
    	     * @param {Array} source The source metadata.
    	     * @returns {Array} Returns `data`.
    	     */
    function mergeData(data,source){
    var bitmask=data[1],
    srcBitmask=source[1],
    newBitmask=bitmask|srcBitmask,
    isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);

    var isCombo=
    srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||
    srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||
    srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;

    // Exit early if metadata can't be merged.
    if(!(isCommon||isCombo)){
    return data;
    }
    // Use source `thisArg` if available.
    if(srcBitmask&WRAP_BIND_FLAG){
    data[2]=source[2];
    // Set when currying a bound function.
    newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value=source[3];
    if(value){
    var partials=data[3];
    data[3]=partials?composeArgs(partials,value,source[4]):value;
    data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];
    }
    // Compose partial right arguments.
    value=source[5];
    if(value){
    partials=data[5];
    data[5]=partials?composeArgsRight(partials,value,source[6]):value;
    data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];
    }
    // Use source `argPos` if available.
    value=source[7];
    if(value){
    data[7]=value;
    }
    // Use source `ary` if it's smaller.
    if(srcBitmask&WRAP_ARY_FLAG){
    data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);
    }
    // Use source `arity` if one is not provided.
    if(data[9]==null){
    data[9]=source[9];
    }
    // Use source `func` and merge bitmasks.
    data[0]=source[0];
    data[1]=newBitmask;

    return data;
    }

    /**
    	     * This function is like
    	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
    	     * except that it includes inherited enumerable properties.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the array of property names.
    	     */
    function nativeKeysIn(object){
    var result=[];
    if(object!=null){
    for(var key in Object(object)){
    result.push(key);
    }
    }
    return result;
    }

    /**
    	     * Converts `value` to a string using `Object.prototype.toString`.
    	     *
    	     * @private
    	     * @param {*} value The value to convert.
    	     * @returns {string} Returns the converted string.
    	     */
    function objectToString(value){
    return nativeObjectToString.call(value);
    }

    /**
    	     * A specialized version of `baseRest` which transforms the rest array.
    	     *
    	     * @private
    	     * @param {Function} func The function to apply a rest parameter to.
    	     * @param {number} [start=func.length-1] The start position of the rest parameter.
    	     * @param {Function} transform The rest array transform.
    	     * @returns {Function} Returns the new function.
    	     */
    function overRest(func,start,transform){
    start=nativeMax(start===undefined$1?func.length-1:start,0);
    return function(){
    var args=arguments,
    index=-1,
    length=nativeMax(args.length-start,0),
    array=Array(length);

    while(++index<length){
    array[index]=args[start+index];
    }
    index=-1;
    var otherArgs=Array(start+1);
    while(++index<start){
    otherArgs[index]=args[index];
    }
    otherArgs[start]=transform(array);
    return apply(func,this,otherArgs);
    };
    }

    /**
    	     * Gets the parent value at `path` of `object`.
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @param {Array} path The path to get the parent value of.
    	     * @returns {*} Returns the parent value.
    	     */
    function parent(object,path){
    return path.length<2?object:baseGet(object,baseSlice(path,0,-1));
    }

    /**
    	     * Reorder `array` according to the specified indexes where the element at
    	     * the first index is assigned as the first element, the element at
    	     * the second index is assigned as the second element, and so on.
    	     *
    	     * @private
    	     * @param {Array} array The array to reorder.
    	     * @param {Array} indexes The arranged array indexes.
    	     * @returns {Array} Returns `array`.
    	     */
    function reorder(array,indexes){
    var arrLength=array.length,
    length=nativeMin(indexes.length,arrLength),
    oldArray=copyArray(array);

    while(length--){
    var index=indexes[length];
    array[length]=isIndex(index,arrLength)?oldArray[index]:undefined$1;
    }
    return array;
    }

    /**
    	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
    	     *
    	     * @private
    	     * @param {Object} object The object to query.
    	     * @param {string} key The key of the property to get.
    	     * @returns {*} Returns the property value.
    	     */
    function safeGet(object,key){
    if(key==='constructor'&&typeof object[key]==='function'){
    return;
    }

    if(key=='__proto__'){
    return;
    }

    return object[key];
    }

    /**
    	     * Sets metadata for `func`.
    	     *
    	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
    	     * period of time, it will trip its breaker and transition to an identity
    	     * function to avoid garbage collection pauses in V8. See
    	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
    	     * for more details.
    	     *
    	     * @private
    	     * @param {Function} func The function to associate metadata with.
    	     * @param {*} data The metadata.
    	     * @returns {Function} Returns `func`.
    	     */
    var setData=shortOut(baseSetData);

    /**
    	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
    	     *
    	     * @private
    	     * @param {Function} func The function to delay.
    	     * @param {number} wait The number of milliseconds to delay invocation.
    	     * @returns {number|Object} Returns the timer id or timeout object.
    	     */
    var setTimeout=ctxSetTimeout||function(func,wait){
    return root.setTimeout(func,wait);
    };

    /**
    	     * Sets the `toString` method of `func` to return `string`.
    	     *
    	     * @private
    	     * @param {Function} func The function to modify.
    	     * @param {Function} string The `toString` result.
    	     * @returns {Function} Returns `func`.
    	     */
    var setToString=shortOut(baseSetToString);

    /**
    	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
    	     * with wrapper details in a comment at the top of the source body.
    	     *
    	     * @private
    	     * @param {Function} wrapper The function to modify.
    	     * @param {Function} reference The reference function.
    	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
    	     * @returns {Function} Returns `wrapper`.
    	     */
    function setWrapToString(wrapper,reference,bitmask){
    var source=reference+'';
    return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));
    }

    /**
    	     * Creates a function that'll short out and invoke `identity` instead
    	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
    	     * milliseconds.
    	     *
    	     * @private
    	     * @param {Function} func The function to restrict.
    	     * @returns {Function} Returns the new shortable function.
    	     */
    function shortOut(func){
    var count=0,
    lastCalled=0;

    return function(){
    var stamp=nativeNow(),
    remaining=HOT_SPAN-(stamp-lastCalled);

    lastCalled=stamp;
    if(remaining>0){
    if(++count>=HOT_COUNT){
    return arguments[0];
    }
    }else {
    count=0;
    }
    return func.apply(undefined$1,arguments);
    };
    }

    /**
    	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
    	     *
    	     * @private
    	     * @param {Array} array The array to shuffle.
    	     * @param {number} [size=array.length] The size of `array`.
    	     * @returns {Array} Returns `array`.
    	     */
    function shuffleSelf(array,size){
    var index=-1,
    length=array.length,
    lastIndex=length-1;

    size=size===undefined$1?length:size;
    while(++index<size){
    var rand=baseRandom(index,lastIndex),
    value=array[rand];

    array[rand]=array[index];
    array[index]=value;
    }
    array.length=size;
    return array;
    }

    /**
    	     * Converts `string` to a property path array.
    	     *
    	     * @private
    	     * @param {string} string The string to convert.
    	     * @returns {Array} Returns the property path array.
    	     */
    var stringToPath=memoizeCapped(function(string){
    var result=[];
    if(string.charCodeAt(0)===46/* . */){
    result.push('');
    }
    string.replace(rePropName,function(match,number,quote,subString){
    result.push(quote?subString.replace(reEscapeChar,'$1'):number||match);
    });
    return result;
    });

    /**
    	     * Converts `value` to a string key if it's not a string or symbol.
    	     *
    	     * @private
    	     * @param {*} value The value to inspect.
    	     * @returns {string|symbol} Returns the key.
    	     */
    function toKey(value){
    if(typeof value=='string'||isSymbol(value)){
    return value;
    }
    var result=value+'';
    return result=='0'&&1/value==-INFINITY?'-0':result;
    }

    /**
    	     * Converts `func` to its source code.
    	     *
    	     * @private
    	     * @param {Function} func The function to convert.
    	     * @returns {string} Returns the source code.
    	     */
    function toSource(func){
    if(func!=null){
    try{
    return funcToString.call(func);
    }catch(e){}
    try{
    return func+'';
    }catch(e){}
    }
    return '';
    }

    /**
    	     * Updates wrapper `details` based on `bitmask` flags.
    	     *
    	     * @private
    	     * @returns {Array} details The details to modify.
    	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
    	     * @returns {Array} Returns `details`.
    	     */
    function updateWrapDetails(details,bitmask){
    arrayEach(wrapFlags,function(pair){
    var value='_.'+pair[0];
    if(bitmask&pair[1]&&!arrayIncludes(details,value)){
    details.push(value);
    }
    });
    return details.sort();
    }

    /**
    	     * Creates a clone of `wrapper`.
    	     *
    	     * @private
    	     * @param {Object} wrapper The wrapper to clone.
    	     * @returns {Object} Returns the cloned wrapper.
    	     */
    function wrapperClone(wrapper){
    if(wrapper instanceof LazyWrapper){
    return wrapper.clone();
    }
    var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);
    result.__actions__=copyArray(wrapper.__actions__);
    result.__index__=wrapper.__index__;
    result.__values__=wrapper.__values__;
    return result;
    }

    /*------------------------------------------------------------------------*/

    /**
    	     * Creates an array of elements split into groups the length of `size`.
    	     * If `array` can't be split evenly, the final chunk will be the remaining
    	     * elements.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Array
    	     * @param {Array} array The array to process.
    	     * @param {number} [size=1] The length of each chunk
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {Array} Returns the new array of chunks.
    	     * @example
    	     *
    	     * _.chunk(['a', 'b', 'c', 'd'], 2);
    	     * // => [['a', 'b'], ['c', 'd']]
    	     *
    	     * _.chunk(['a', 'b', 'c', 'd'], 3);
    	     * // => [['a', 'b', 'c'], ['d']]
    	     */
    function chunk(array,size,guard){
    if(guard?isIterateeCall(array,size,guard):size===undefined$1){
    size=1;
    }else {
    size=nativeMax(toInteger(size),0);
    }
    var length=array==null?0:array.length;
    if(!length||size<1){
    return [];
    }
    var index=0,
    resIndex=0,
    result=Array(nativeCeil(length/size));

    while(index<length){
    result[resIndex++]=baseSlice(array,index,index+=size);
    }
    return result;
    }

    /**
    	     * Creates an array with all falsey values removed. The values `false`, `null`,
    	     * `0`, `""`, `undefined`, and `NaN` are falsey.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {Array} array The array to compact.
    	     * @returns {Array} Returns the new array of filtered values.
    	     * @example
    	     *
    	     * _.compact([0, 1, false, 2, '', 3]);
    	     * // => [1, 2, 3]
    	     */
    function compact(array){
    var index=-1,
    length=array==null?0:array.length,
    resIndex=0,
    result=[];

    while(++index<length){
    var value=array[index];
    if(value){
    result[resIndex++]=value;
    }
    }
    return result;
    }

    /**
    	     * Creates a new array concatenating `array` with any additional arrays
    	     * and/or values.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to concatenate.
    	     * @param {...*} [values] The values to concatenate.
    	     * @returns {Array} Returns the new concatenated array.
    	     * @example
    	     *
    	     * var array = [1];
    	     * var other = _.concat(array, 2, [3], [[4]]);
    	     *
    	     * console.log(other);
    	     * // => [1, 2, 3, [4]]
    	     *
    	     * console.log(array);
    	     * // => [1]
    	     */
    function concat(){
    var length=arguments.length;
    if(!length){
    return [];
    }
    var args=Array(length-1),
    array=arguments[0],
    index=length;

    while(index--){
    args[index-1]=arguments[index];
    }
    return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));
    }

    /**
    	     * Creates an array of `array` values not included in the other given arrays
    	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    	     * for equality comparisons. The order and references of result values are
    	     * determined by the first array.
    	     *
    	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {...Array} [values] The values to exclude.
    	     * @returns {Array} Returns the new array of filtered values.
    	     * @see _.without, _.xor
    	     * @example
    	     *
    	     * _.difference([2, 1], [2, 3]);
    	     * // => [1]
    	     */
    var difference=baseRest(function(array,values){
    return isArrayLikeObject(array)?
    baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):
    [];
    });

    /**
    	     * This method is like `_.difference` except that it accepts `iteratee` which
    	     * is invoked for each element of `array` and `values` to generate the criterion
    	     * by which they're compared. The order and references of result values are
    	     * determined by the first array. The iteratee is invoked with one argument:
    	     * (value).
    	     *
    	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {...Array} [values] The values to exclude.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {Array} Returns the new array of filtered values.
    	     * @example
    	     *
    	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
    	     * // => [1.2]
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
    	     * // => [{ 'x': 2 }]
    	     */
    var differenceBy=baseRest(function(array,values){
    var iteratee=last(values);
    if(isArrayLikeObject(iteratee)){
    iteratee=undefined$1;
    }
    return isArrayLikeObject(array)?
    baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):
    [];
    });

    /**
    	     * This method is like `_.difference` except that it accepts `comparator`
    	     * which is invoked to compare elements of `array` to `values`. The order and
    	     * references of result values are determined by the first array. The comparator
    	     * is invoked with two arguments: (arrVal, othVal).
    	     *
    	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {...Array} [values] The values to exclude.
    	     * @param {Function} [comparator] The comparator invoked per element.
    	     * @returns {Array} Returns the new array of filtered values.
    	     * @example
    	     *
    	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
    	     *
    	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
    	     * // => [{ 'x': 2, 'y': 1 }]
    	     */
    var differenceWith=baseRest(function(array,values){
    var comparator=last(values);
    if(isArrayLikeObject(comparator)){
    comparator=undefined$1;
    }
    return isArrayLikeObject(array)?
    baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined$1,comparator):
    [];
    });

    /**
    	     * Creates a slice of `array` with `n` elements dropped from the beginning.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.5.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @param {number} [n=1] The number of elements to drop.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {Array} Returns the slice of `array`.
    	     * @example
    	     *
    	     * _.drop([1, 2, 3]);
    	     * // => [2, 3]
    	     *
    	     * _.drop([1, 2, 3], 2);
    	     * // => [3]
    	     *
    	     * _.drop([1, 2, 3], 5);
    	     * // => []
    	     *
    	     * _.drop([1, 2, 3], 0);
    	     * // => [1, 2, 3]
    	     */
    function drop(array,n,guard){
    var length=array==null?0:array.length;
    if(!length){
    return [];
    }
    n=guard||n===undefined$1?1:toInteger(n);
    return baseSlice(array,n<0?0:n,length);
    }

    /**
    	     * Creates a slice of `array` with `n` elements dropped from the end.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @param {number} [n=1] The number of elements to drop.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {Array} Returns the slice of `array`.
    	     * @example
    	     *
    	     * _.dropRight([1, 2, 3]);
    	     * // => [1, 2]
    	     *
    	     * _.dropRight([1, 2, 3], 2);
    	     * // => [1]
    	     *
    	     * _.dropRight([1, 2, 3], 5);
    	     * // => []
    	     *
    	     * _.dropRight([1, 2, 3], 0);
    	     * // => [1, 2, 3]
    	     */
    function dropRight(array,n,guard){
    var length=array==null?0:array.length;
    if(!length){
    return [];
    }
    n=guard||n===undefined$1?1:toInteger(n);
    n=length-n;
    return baseSlice(array,0,n<0?0:n);
    }

    /**
    	     * Creates a slice of `array` excluding elements dropped from the end.
    	     * Elements are dropped until `predicate` returns falsey. The predicate is
    	     * invoked with three arguments: (value, index, array).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the slice of `array`.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney',  'active': true },
    	     *   { 'user': 'fred',    'active': false },
    	     *   { 'user': 'pebbles', 'active': false }
    	     * ];
    	     *
    	     * _.dropRightWhile(users, function(o) { return !o.active; });
    	     * // => objects for ['barney']
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
    	     * // => objects for ['barney', 'fred']
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.dropRightWhile(users, ['active', false]);
    	     * // => objects for ['barney']
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.dropRightWhile(users, 'active');
    	     * // => objects for ['barney', 'fred', 'pebbles']
    	     */
    function dropRightWhile(array,predicate){
    return array&&array.length?
    baseWhile(array,getIteratee(predicate,3),true,true):
    [];
    }

    /**
    	     * Creates a slice of `array` excluding elements dropped from the beginning.
    	     * Elements are dropped until `predicate` returns falsey. The predicate is
    	     * invoked with three arguments: (value, index, array).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the slice of `array`.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney',  'active': false },
    	     *   { 'user': 'fred',    'active': false },
    	     *   { 'user': 'pebbles', 'active': true }
    	     * ];
    	     *
    	     * _.dropWhile(users, function(o) { return !o.active; });
    	     * // => objects for ['pebbles']
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
    	     * // => objects for ['fred', 'pebbles']
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.dropWhile(users, ['active', false]);
    	     * // => objects for ['pebbles']
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.dropWhile(users, 'active');
    	     * // => objects for ['barney', 'fred', 'pebbles']
    	     */
    function dropWhile(array,predicate){
    return array&&array.length?
    baseWhile(array,getIteratee(predicate,3),true):
    [];
    }

    /**
    	     * Fills elements of `array` with `value` from `start` up to, but not
    	     * including, `end`.
    	     *
    	     * **Note:** This method mutates `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.2.0
    	     * @category Array
    	     * @param {Array} array The array to fill.
    	     * @param {*} value The value to fill `array` with.
    	     * @param {number} [start=0] The start position.
    	     * @param {number} [end=array.length] The end position.
    	     * @returns {Array} Returns `array`.
    	     * @example
    	     *
    	     * var array = [1, 2, 3];
    	     *
    	     * _.fill(array, 'a');
    	     * console.log(array);
    	     * // => ['a', 'a', 'a']
    	     *
    	     * _.fill(Array(3), 2);
    	     * // => [2, 2, 2]
    	     *
    	     * _.fill([4, 6, 8, 10], '*', 1, 3);
    	     * // => [4, '*', '*', 10]
    	     */
    function fill(array,value,start,end){
    var length=array==null?0:array.length;
    if(!length){
    return [];
    }
    if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){
    start=0;
    end=length;
    }
    return baseFill(array,value,start,end);
    }

    /**
    	     * This method is like `_.find` except that it returns the index of the first
    	     * element `predicate` returns truthy for instead of the element itself.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 1.1.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @param {number} [fromIndex=0] The index to search from.
    	     * @returns {number} Returns the index of the found element, else `-1`.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney',  'active': false },
    	     *   { 'user': 'fred',    'active': false },
    	     *   { 'user': 'pebbles', 'active': true }
    	     * ];
    	     *
    	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
    	     * // => 0
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.findIndex(users, { 'user': 'fred', 'active': false });
    	     * // => 1
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.findIndex(users, ['active', false]);
    	     * // => 0
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.findIndex(users, 'active');
    	     * // => 2
    	     */
    function findIndex(array,predicate,fromIndex){
    var length=array==null?0:array.length;
    if(!length){
    return -1;
    }
    var index=fromIndex==null?0:toInteger(fromIndex);
    if(index<0){
    index=nativeMax(length+index,0);
    }
    return baseFindIndex(array,getIteratee(predicate,3),index);
    }

    /**
    	     * This method is like `_.findIndex` except that it iterates over elements
    	     * of `collection` from right to left.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.0.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @param {number} [fromIndex=array.length-1] The index to search from.
    	     * @returns {number} Returns the index of the found element, else `-1`.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney',  'active': true },
    	     *   { 'user': 'fred',    'active': false },
    	     *   { 'user': 'pebbles', 'active': false }
    	     * ];
    	     *
    	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
    	     * // => 2
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
    	     * // => 0
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.findLastIndex(users, ['active', false]);
    	     * // => 2
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.findLastIndex(users, 'active');
    	     * // => 0
    	     */
    function findLastIndex(array,predicate,fromIndex){
    var length=array==null?0:array.length;
    if(!length){
    return -1;
    }
    var index=length-1;
    if(fromIndex!==undefined$1){
    index=toInteger(fromIndex);
    index=fromIndex<0?
    nativeMax(length+index,0):
    nativeMin(index,length-1);
    }
    return baseFindIndex(array,getIteratee(predicate,3),index,true);
    }

    /**
    	     * Flattens `array` a single level deep.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {Array} array The array to flatten.
    	     * @returns {Array} Returns the new flattened array.
    	     * @example
    	     *
    	     * _.flatten([1, [2, [3, [4]], 5]]);
    	     * // => [1, 2, [3, [4]], 5]
    	     */
    function flatten(array){
    var length=array==null?0:array.length;
    return length?baseFlatten(array,1):[];
    }

    /**
    	     * Recursively flattens `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Array
    	     * @param {Array} array The array to flatten.
    	     * @returns {Array} Returns the new flattened array.
    	     * @example
    	     *
    	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
    	     * // => [1, 2, 3, 4, 5]
    	     */
    function flattenDeep(array){
    var length=array==null?0:array.length;
    return length?baseFlatten(array,INFINITY):[];
    }

    /**
    	     * Recursively flatten `array` up to `depth` times.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.4.0
    	     * @category Array
    	     * @param {Array} array The array to flatten.
    	     * @param {number} [depth=1] The maximum recursion depth.
    	     * @returns {Array} Returns the new flattened array.
    	     * @example
    	     *
    	     * var array = [1, [2, [3, [4]], 5]];
    	     *
    	     * _.flattenDepth(array, 1);
    	     * // => [1, 2, [3, [4]], 5]
    	     *
    	     * _.flattenDepth(array, 2);
    	     * // => [1, 2, 3, [4], 5]
    	     */
    function flattenDepth(array,depth){
    var length=array==null?0:array.length;
    if(!length){
    return [];
    }
    depth=depth===undefined$1?1:toInteger(depth);
    return baseFlatten(array,depth);
    }

    /**
    	     * The inverse of `_.toPairs`; this method returns an object composed
    	     * from key-value `pairs`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} pairs The key-value pairs.
    	     * @returns {Object} Returns the new object.
    	     * @example
    	     *
    	     * _.fromPairs([['a', 1], ['b', 2]]);
    	     * // => { 'a': 1, 'b': 2 }
    	     */
    function fromPairs(pairs){
    var index=-1,
    length=pairs==null?0:pairs.length,
    result={};

    while(++index<length){
    var pair=pairs[index];
    result[pair[0]]=pair[1];
    }
    return result;
    }

    /**
    	     * Gets the first element of `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @alias first
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @returns {*} Returns the first element of `array`.
    	     * @example
    	     *
    	     * _.head([1, 2, 3]);
    	     * // => 1
    	     *
    	     * _.head([]);
    	     * // => undefined
    	     */
    function head(array){
    return array&&array.length?array[0]:undefined$1;
    }

    /**
    	     * Gets the index at which the first occurrence of `value` is found in `array`
    	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    	     * for equality comparisons. If `fromIndex` is negative, it's used as the
    	     * offset from the end of `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {*} value The value to search for.
    	     * @param {number} [fromIndex=0] The index to search from.
    	     * @returns {number} Returns the index of the matched value, else `-1`.
    	     * @example
    	     *
    	     * _.indexOf([1, 2, 1, 2], 2);
    	     * // => 1
    	     *
    	     * // Search from the `fromIndex`.
    	     * _.indexOf([1, 2, 1, 2], 2, 2);
    	     * // => 3
    	     */
    function indexOf(array,value,fromIndex){
    var length=array==null?0:array.length;
    if(!length){
    return -1;
    }
    var index=fromIndex==null?0:toInteger(fromIndex);
    if(index<0){
    index=nativeMax(length+index,0);
    }
    return baseIndexOf(array,value,index);
    }

    /**
    	     * Gets all but the last element of `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @returns {Array} Returns the slice of `array`.
    	     * @example
    	     *
    	     * _.initial([1, 2, 3]);
    	     * // => [1, 2]
    	     */
    function initial(array){
    var length=array==null?0:array.length;
    return length?baseSlice(array,0,-1):[];
    }

    /**
    	     * Creates an array of unique values that are included in all given arrays
    	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    	     * for equality comparisons. The order and references of result values are
    	     * determined by the first array.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {...Array} [arrays] The arrays to inspect.
    	     * @returns {Array} Returns the new array of intersecting values.
    	     * @example
    	     *
    	     * _.intersection([2, 1], [2, 3]);
    	     * // => [2]
    	     */
    var intersection=baseRest(function(arrays){
    var mapped=arrayMap(arrays,castArrayLikeObject);
    return mapped.length&&mapped[0]===arrays[0]?
    baseIntersection(mapped):
    [];
    });

    /**
    	     * This method is like `_.intersection` except that it accepts `iteratee`
    	     * which is invoked for each element of each `arrays` to generate the criterion
    	     * by which they're compared. The order and references of result values are
    	     * determined by the first array. The iteratee is invoked with one argument:
    	     * (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {...Array} [arrays] The arrays to inspect.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {Array} Returns the new array of intersecting values.
    	     * @example
    	     *
    	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
    	     * // => [2.1]
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
    	     * // => [{ 'x': 1 }]
    	     */
    var intersectionBy=baseRest(function(arrays){
    var iteratee=last(arrays),
    mapped=arrayMap(arrays,castArrayLikeObject);

    if(iteratee===last(mapped)){
    iteratee=undefined$1;
    }else {
    mapped.pop();
    }
    return mapped.length&&mapped[0]===arrays[0]?
    baseIntersection(mapped,getIteratee(iteratee,2)):
    [];
    });

    /**
    	     * This method is like `_.intersection` except that it accepts `comparator`
    	     * which is invoked to compare elements of `arrays`. The order and references
    	     * of result values are determined by the first array. The comparator is
    	     * invoked with two arguments: (arrVal, othVal).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {...Array} [arrays] The arrays to inspect.
    	     * @param {Function} [comparator] The comparator invoked per element.
    	     * @returns {Array} Returns the new array of intersecting values.
    	     * @example
    	     *
    	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
    	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
    	     *
    	     * _.intersectionWith(objects, others, _.isEqual);
    	     * // => [{ 'x': 1, 'y': 2 }]
    	     */
    var intersectionWith=baseRest(function(arrays){
    var comparator=last(arrays),
    mapped=arrayMap(arrays,castArrayLikeObject);

    comparator=typeof comparator=='function'?comparator:undefined$1;
    if(comparator){
    mapped.pop();
    }
    return mapped.length&&mapped[0]===arrays[0]?
    baseIntersection(mapped,undefined$1,comparator):
    [];
    });

    /**
    	     * Converts all elements in `array` into a string separated by `separator`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to convert.
    	     * @param {string} [separator=','] The element separator.
    	     * @returns {string} Returns the joined string.
    	     * @example
    	     *
    	     * _.join(['a', 'b', 'c'], '~');
    	     * // => 'a~b~c'
    	     */
    function join(array,separator){
    return array==null?'':nativeJoin.call(array,separator);
    }

    /**
    	     * Gets the last element of `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @returns {*} Returns the last element of `array`.
    	     * @example
    	     *
    	     * _.last([1, 2, 3]);
    	     * // => 3
    	     */
    function last(array){
    var length=array==null?0:array.length;
    return length?array[length-1]:undefined$1;
    }

    /**
    	     * This method is like `_.indexOf` except that it iterates over elements of
    	     * `array` from right to left.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {*} value The value to search for.
    	     * @param {number} [fromIndex=array.length-1] The index to search from.
    	     * @returns {number} Returns the index of the matched value, else `-1`.
    	     * @example
    	     *
    	     * _.lastIndexOf([1, 2, 1, 2], 2);
    	     * // => 3
    	     *
    	     * // Search from the `fromIndex`.
    	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
    	     * // => 1
    	     */
    function lastIndexOf(array,value,fromIndex){
    var length=array==null?0:array.length;
    if(!length){
    return -1;
    }
    var index=length;
    if(fromIndex!==undefined$1){
    index=toInteger(fromIndex);
    index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);
    }
    return value===value?
    strictLastIndexOf(array,value,index):
    baseFindIndex(array,baseIsNaN,index,true);
    }

    /**
    	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
    	     * element from the end is returned.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.11.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @param {number} [n=0] The index of the element to return.
    	     * @returns {*} Returns the nth element of `array`.
    	     * @example
    	     *
    	     * var array = ['a', 'b', 'c', 'd'];
    	     *
    	     * _.nth(array, 1);
    	     * // => 'b'
    	     *
    	     * _.nth(array, -2);
    	     * // => 'c';
    	     */
    function nth(array,n){
    return array&&array.length?baseNth(array,toInteger(n)):undefined$1;
    }

    /**
    	     * Removes all given values from `array` using
    	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    	     * for equality comparisons.
    	     *
    	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
    	     * to remove elements from an array by predicate.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.0.0
    	     * @category Array
    	     * @param {Array} array The array to modify.
    	     * @param {...*} [values] The values to remove.
    	     * @returns {Array} Returns `array`.
    	     * @example
    	     *
    	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
    	     *
    	     * _.pull(array, 'a', 'c');
    	     * console.log(array);
    	     * // => ['b', 'b']
    	     */
    var pull=baseRest(pullAll);

    /**
    	     * This method is like `_.pull` except that it accepts an array of values to remove.
    	     *
    	     * **Note:** Unlike `_.difference`, this method mutates `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to modify.
    	     * @param {Array} values The values to remove.
    	     * @returns {Array} Returns `array`.
    	     * @example
    	     *
    	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
    	     *
    	     * _.pullAll(array, ['a', 'c']);
    	     * console.log(array);
    	     * // => ['b', 'b']
    	     */
    function pullAll(array,values){
    return array&&array.length&&values&&values.length?
    basePullAll(array,values):
    array;
    }

    /**
    	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
    	     * invoked for each element of `array` and `values` to generate the criterion
    	     * by which they're compared. The iteratee is invoked with one argument: (value).
    	     *
    	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to modify.
    	     * @param {Array} values The values to remove.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {Array} Returns `array`.
    	     * @example
    	     *
    	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
    	     *
    	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
    	     * console.log(array);
    	     * // => [{ 'x': 2 }]
    	     */
    function pullAllBy(array,values,iteratee){
    return array&&array.length&&values&&values.length?
    basePullAll(array,values,getIteratee(iteratee,2)):
    array;
    }

    /**
    	     * This method is like `_.pullAll` except that it accepts `comparator` which
    	     * is invoked to compare elements of `array` to `values`. The comparator is
    	     * invoked with two arguments: (arrVal, othVal).
    	     *
    	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.6.0
    	     * @category Array
    	     * @param {Array} array The array to modify.
    	     * @param {Array} values The values to remove.
    	     * @param {Function} [comparator] The comparator invoked per element.
    	     * @returns {Array} Returns `array`.
    	     * @example
    	     *
    	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
    	     *
    	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
    	     * console.log(array);
    	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
    	     */
    function pullAllWith(array,values,comparator){
    return array&&array.length&&values&&values.length?
    basePullAll(array,values,undefined$1,comparator):
    array;
    }

    /**
    	     * Removes elements from `array` corresponding to `indexes` and returns an
    	     * array of removed elements.
    	     *
    	     * **Note:** Unlike `_.at`, this method mutates `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Array
    	     * @param {Array} array The array to modify.
    	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
    	     * @returns {Array} Returns the new array of removed elements.
    	     * @example
    	     *
    	     * var array = ['a', 'b', 'c', 'd'];
    	     * var pulled = _.pullAt(array, [1, 3]);
    	     *
    	     * console.log(array);
    	     * // => ['a', 'c']
    	     *
    	     * console.log(pulled);
    	     * // => ['b', 'd']
    	     */
    var pullAt=flatRest(function(array,indexes){
    var length=array==null?0:array.length,
    result=baseAt(array,indexes);

    basePullAt(array,arrayMap(indexes,function(index){
    return isIndex(index,length)?+index:index;
    }).sort(compareAscending));

    return result;
    });

    /**
    	     * Removes all elements from `array` that `predicate` returns truthy for
    	     * and returns an array of the removed elements. The predicate is invoked
    	     * with three arguments: (value, index, array).
    	     *
    	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
    	     * to pull elements from an array by value.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.0.0
    	     * @category Array
    	     * @param {Array} array The array to modify.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the new array of removed elements.
    	     * @example
    	     *
    	     * var array = [1, 2, 3, 4];
    	     * var evens = _.remove(array, function(n) {
    	     *   return n % 2 == 0;
    	     * });
    	     *
    	     * console.log(array);
    	     * // => [1, 3]
    	     *
    	     * console.log(evens);
    	     * // => [2, 4]
    	     */
    function remove(array,predicate){
    var result=[];
    if(!(array&&array.length)){
    return result;
    }
    var index=-1,
    indexes=[],
    length=array.length;

    predicate=getIteratee(predicate,3);
    while(++index<length){
    var value=array[index];
    if(predicate(value,index,array)){
    result.push(value);
    indexes.push(index);
    }
    }
    basePullAt(array,indexes);
    return result;
    }

    /**
    	     * Reverses `array` so that the first element becomes the last, the second
    	     * element becomes the second to last, and so on.
    	     *
    	     * **Note:** This method mutates `array` and is based on
    	     * [`Array#reverse`](https://mdn.io/Array/reverse).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to modify.
    	     * @returns {Array} Returns `array`.
    	     * @example
    	     *
    	     * var array = [1, 2, 3];
    	     *
    	     * _.reverse(array);
    	     * // => [3, 2, 1]
    	     *
    	     * console.log(array);
    	     * // => [3, 2, 1]
    	     */
    function reverse(array){
    return array==null?array:nativeReverse.call(array);
    }

    /**
    	     * Creates a slice of `array` from `start` up to, but not including, `end`.
    	     *
    	     * **Note:** This method is used instead of
    	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
    	     * returned.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Array
    	     * @param {Array} array The array to slice.
    	     * @param {number} [start=0] The start position.
    	     * @param {number} [end=array.length] The end position.
    	     * @returns {Array} Returns the slice of `array`.
    	     */
    function slice(array,start,end){
    var length=array==null?0:array.length;
    if(!length){
    return [];
    }
    if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){
    start=0;
    end=length;
    }else
    {
    start=start==null?0:toInteger(start);
    end=end===undefined$1?length:toInteger(end);
    }
    return baseSlice(array,start,end);
    }

    /**
    	     * Uses a binary search to determine the lowest index at which `value`
    	     * should be inserted into `array` in order to maintain its sort order.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {Array} array The sorted array to inspect.
    	     * @param {*} value The value to evaluate.
    	     * @returns {number} Returns the index at which `value` should be inserted
    	     *  into `array`.
    	     * @example
    	     *
    	     * _.sortedIndex([30, 50], 40);
    	     * // => 1
    	     */
    function sortedIndex(array,value){
    return baseSortedIndex(array,value);
    }

    /**
    	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
    	     * which is invoked for `value` and each element of `array` to compute their
    	     * sort ranking. The iteratee is invoked with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The sorted array to inspect.
    	     * @param {*} value The value to evaluate.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {number} Returns the index at which `value` should be inserted
    	     *  into `array`.
    	     * @example
    	     *
    	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
    	     *
    	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
    	     * // => 0
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
    	     * // => 0
    	     */
    function sortedIndexBy(array,value,iteratee){
    return baseSortedIndexBy(array,value,getIteratee(iteratee,2));
    }

    /**
    	     * This method is like `_.indexOf` except that it performs a binary
    	     * search on a sorted `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {*} value The value to search for.
    	     * @returns {number} Returns the index of the matched value, else `-1`.
    	     * @example
    	     *
    	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
    	     * // => 1
    	     */
    function sortedIndexOf(array,value){
    var length=array==null?0:array.length;
    if(length){
    var index=baseSortedIndex(array,value);
    if(index<length&&eq(array[index],value)){
    return index;
    }
    }
    return -1;
    }

    /**
    	     * This method is like `_.sortedIndex` except that it returns the highest
    	     * index at which `value` should be inserted into `array` in order to
    	     * maintain its sort order.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Array
    	     * @param {Array} array The sorted array to inspect.
    	     * @param {*} value The value to evaluate.
    	     * @returns {number} Returns the index at which `value` should be inserted
    	     *  into `array`.
    	     * @example
    	     *
    	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
    	     * // => 4
    	     */
    function sortedLastIndex(array,value){
    return baseSortedIndex(array,value,true);
    }

    /**
    	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
    	     * which is invoked for `value` and each element of `array` to compute their
    	     * sort ranking. The iteratee is invoked with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The sorted array to inspect.
    	     * @param {*} value The value to evaluate.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {number} Returns the index at which `value` should be inserted
    	     *  into `array`.
    	     * @example
    	     *
    	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
    	     *
    	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
    	     * // => 1
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
    	     * // => 1
    	     */
    function sortedLastIndexBy(array,value,iteratee){
    return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);
    }

    /**
    	     * This method is like `_.lastIndexOf` except that it performs a binary
    	     * search on a sorted `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {*} value The value to search for.
    	     * @returns {number} Returns the index of the matched value, else `-1`.
    	     * @example
    	     *
    	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
    	     * // => 3
    	     */
    function sortedLastIndexOf(array,value){
    var length=array==null?0:array.length;
    if(length){
    var index=baseSortedIndex(array,value,true)-1;
    if(eq(array[index],value)){
    return index;
    }
    }
    return -1;
    }

    /**
    	     * This method is like `_.uniq` except that it's designed and optimized
    	     * for sorted arrays.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @returns {Array} Returns the new duplicate free array.
    	     * @example
    	     *
    	     * _.sortedUniq([1, 1, 2]);
    	     * // => [1, 2]
    	     */
    function sortedUniq(array){
    return array&&array.length?
    baseSortedUniq(array):
    [];
    }

    /**
    	     * This method is like `_.uniqBy` except that it's designed and optimized
    	     * for sorted arrays.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {Function} [iteratee] The iteratee invoked per element.
    	     * @returns {Array} Returns the new duplicate free array.
    	     * @example
    	     *
    	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
    	     * // => [1.1, 2.3]
    	     */
    function sortedUniqBy(array,iteratee){
    return array&&array.length?
    baseSortedUniq(array,getIteratee(iteratee,2)):
    [];
    }

    /**
    	     * Gets all but the first element of `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @returns {Array} Returns the slice of `array`.
    	     * @example
    	     *
    	     * _.tail([1, 2, 3]);
    	     * // => [2, 3]
    	     */
    function tail(array){
    var length=array==null?0:array.length;
    return length?baseSlice(array,1,length):[];
    }

    /**
    	     * Creates a slice of `array` with `n` elements taken from the beginning.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @param {number} [n=1] The number of elements to take.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {Array} Returns the slice of `array`.
    	     * @example
    	     *
    	     * _.take([1, 2, 3]);
    	     * // => [1]
    	     *
    	     * _.take([1, 2, 3], 2);
    	     * // => [1, 2]
    	     *
    	     * _.take([1, 2, 3], 5);
    	     * // => [1, 2, 3]
    	     *
    	     * _.take([1, 2, 3], 0);
    	     * // => []
    	     */
    function take(array,n,guard){
    if(!(array&&array.length)){
    return [];
    }
    n=guard||n===undefined$1?1:toInteger(n);
    return baseSlice(array,0,n<0?0:n);
    }

    /**
    	     * Creates a slice of `array` with `n` elements taken from the end.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @param {number} [n=1] The number of elements to take.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {Array} Returns the slice of `array`.
    	     * @example
    	     *
    	     * _.takeRight([1, 2, 3]);
    	     * // => [3]
    	     *
    	     * _.takeRight([1, 2, 3], 2);
    	     * // => [2, 3]
    	     *
    	     * _.takeRight([1, 2, 3], 5);
    	     * // => [1, 2, 3]
    	     *
    	     * _.takeRight([1, 2, 3], 0);
    	     * // => []
    	     */
    function takeRight(array,n,guard){
    var length=array==null?0:array.length;
    if(!length){
    return [];
    }
    n=guard||n===undefined$1?1:toInteger(n);
    n=length-n;
    return baseSlice(array,n<0?0:n,length);
    }

    /**
    	     * Creates a slice of `array` with elements taken from the end. Elements are
    	     * taken until `predicate` returns falsey. The predicate is invoked with
    	     * three arguments: (value, index, array).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the slice of `array`.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney',  'active': true },
    	     *   { 'user': 'fred',    'active': false },
    	     *   { 'user': 'pebbles', 'active': false }
    	     * ];
    	     *
    	     * _.takeRightWhile(users, function(o) { return !o.active; });
    	     * // => objects for ['fred', 'pebbles']
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
    	     * // => objects for ['pebbles']
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.takeRightWhile(users, ['active', false]);
    	     * // => objects for ['fred', 'pebbles']
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.takeRightWhile(users, 'active');
    	     * // => []
    	     */
    function takeRightWhile(array,predicate){
    return array&&array.length?
    baseWhile(array,getIteratee(predicate,3),false,true):
    [];
    }

    /**
    	     * Creates a slice of `array` with elements taken from the beginning. Elements
    	     * are taken until `predicate` returns falsey. The predicate is invoked with
    	     * three arguments: (value, index, array).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Array
    	     * @param {Array} array The array to query.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the slice of `array`.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney',  'active': false },
    	     *   { 'user': 'fred',    'active': false },
    	     *   { 'user': 'pebbles', 'active': true }
    	     * ];
    	     *
    	     * _.takeWhile(users, function(o) { return !o.active; });
    	     * // => objects for ['barney', 'fred']
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
    	     * // => objects for ['barney']
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.takeWhile(users, ['active', false]);
    	     * // => objects for ['barney', 'fred']
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.takeWhile(users, 'active');
    	     * // => []
    	     */
    function takeWhile(array,predicate){
    return array&&array.length?
    baseWhile(array,getIteratee(predicate,3)):
    [];
    }

    /**
    	     * Creates an array of unique values, in order, from all given arrays using
    	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    	     * for equality comparisons.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {...Array} [arrays] The arrays to inspect.
    	     * @returns {Array} Returns the new array of combined values.
    	     * @example
    	     *
    	     * _.union([2], [1, 2]);
    	     * // => [2, 1]
    	     */
    var union=baseRest(function(arrays){
    return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));
    });

    /**
    	     * This method is like `_.union` except that it accepts `iteratee` which is
    	     * invoked for each element of each `arrays` to generate the criterion by
    	     * which uniqueness is computed. Result values are chosen from the first
    	     * array in which the value occurs. The iteratee is invoked with one argument:
    	     * (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {...Array} [arrays] The arrays to inspect.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {Array} Returns the new array of combined values.
    	     * @example
    	     *
    	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
    	     * // => [2.1, 1.2]
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
    	     * // => [{ 'x': 1 }, { 'x': 2 }]
    	     */
    var unionBy=baseRest(function(arrays){
    var iteratee=last(arrays);
    if(isArrayLikeObject(iteratee)){
    iteratee=undefined$1;
    }
    return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));
    });

    /**
    	     * This method is like `_.union` except that it accepts `comparator` which
    	     * is invoked to compare elements of `arrays`. Result values are chosen from
    	     * the first array in which the value occurs. The comparator is invoked
    	     * with two arguments: (arrVal, othVal).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {...Array} [arrays] The arrays to inspect.
    	     * @param {Function} [comparator] The comparator invoked per element.
    	     * @returns {Array} Returns the new array of combined values.
    	     * @example
    	     *
    	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
    	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
    	     *
    	     * _.unionWith(objects, others, _.isEqual);
    	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
    	     */
    var unionWith=baseRest(function(arrays){
    var comparator=last(arrays);
    comparator=typeof comparator=='function'?comparator:undefined$1;
    return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined$1,comparator);
    });

    /**
    	     * Creates a duplicate-free version of an array, using
    	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    	     * for equality comparisons, in which only the first occurrence of each element
    	     * is kept. The order of result values is determined by the order they occur
    	     * in the array.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @returns {Array} Returns the new duplicate free array.
    	     * @example
    	     *
    	     * _.uniq([2, 1, 2]);
    	     * // => [2, 1]
    	     */
    function uniq(array){
    return array&&array.length?baseUniq(array):[];
    }

    /**
    	     * This method is like `_.uniq` except that it accepts `iteratee` which is
    	     * invoked for each element in `array` to generate the criterion by which
    	     * uniqueness is computed. The order of result values is determined by the
    	     * order they occur in the array. The iteratee is invoked with one argument:
    	     * (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {Array} Returns the new duplicate free array.
    	     * @example
    	     *
    	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
    	     * // => [2.1, 1.2]
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
    	     * // => [{ 'x': 1 }, { 'x': 2 }]
    	     */
    function uniqBy(array,iteratee){
    return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];
    }

    /**
    	     * This method is like `_.uniq` except that it accepts `comparator` which
    	     * is invoked to compare elements of `array`. The order of result values is
    	     * determined by the order they occur in the array.The comparator is invoked
    	     * with two arguments: (arrVal, othVal).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {Function} [comparator] The comparator invoked per element.
    	     * @returns {Array} Returns the new duplicate free array.
    	     * @example
    	     *
    	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
    	     *
    	     * _.uniqWith(objects, _.isEqual);
    	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
    	     */
    function uniqWith(array,comparator){
    comparator=typeof comparator=='function'?comparator:undefined$1;
    return array&&array.length?baseUniq(array,undefined$1,comparator):[];
    }

    /**
    	     * This method is like `_.zip` except that it accepts an array of grouped
    	     * elements and creates an array regrouping the elements to their pre-zip
    	     * configuration.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 1.2.0
    	     * @category Array
    	     * @param {Array} array The array of grouped elements to process.
    	     * @returns {Array} Returns the new array of regrouped elements.
    	     * @example
    	     *
    	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
    	     * // => [['a', 1, true], ['b', 2, false]]
    	     *
    	     * _.unzip(zipped);
    	     * // => [['a', 'b'], [1, 2], [true, false]]
    	     */
    function unzip(array){
    if(!(array&&array.length)){
    return [];
    }
    var length=0;
    array=arrayFilter(array,function(group){
    if(isArrayLikeObject(group)){
    length=nativeMax(group.length,length);
    return true;
    }
    });
    return baseTimes(length,function(index){
    return arrayMap(array,baseProperty(index));
    });
    }

    /**
    	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
    	     * how regrouped values should be combined. The iteratee is invoked with the
    	     * elements of each group: (...group).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.8.0
    	     * @category Array
    	     * @param {Array} array The array of grouped elements to process.
    	     * @param {Function} [iteratee=_.identity] The function to combine
    	     *  regrouped values.
    	     * @returns {Array} Returns the new array of regrouped elements.
    	     * @example
    	     *
    	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
    	     * // => [[1, 10, 100], [2, 20, 200]]
    	     *
    	     * _.unzipWith(zipped, _.add);
    	     * // => [3, 30, 300]
    	     */
    function unzipWith(array,iteratee){
    if(!(array&&array.length)){
    return [];
    }
    var result=unzip(array);
    if(iteratee==null){
    return result;
    }
    return arrayMap(result,function(group){
    return apply(iteratee,undefined$1,group);
    });
    }

    /**
    	     * Creates an array excluding all given values using
    	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    	     * for equality comparisons.
    	     *
    	     * **Note:** Unlike `_.pull`, this method returns a new array.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {Array} array The array to inspect.
    	     * @param {...*} [values] The values to exclude.
    	     * @returns {Array} Returns the new array of filtered values.
    	     * @see _.difference, _.xor
    	     * @example
    	     *
    	     * _.without([2, 1, 2, 3], 1, 2);
    	     * // => [3]
    	     */
    var without=baseRest(function(array,values){
    return isArrayLikeObject(array)?
    baseDifference(array,values):
    [];
    });

    /**
    	     * Creates an array of unique values that is the
    	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
    	     * of the given arrays. The order of result values is determined by the order
    	     * they occur in the arrays.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.4.0
    	     * @category Array
    	     * @param {...Array} [arrays] The arrays to inspect.
    	     * @returns {Array} Returns the new array of filtered values.
    	     * @see _.difference, _.without
    	     * @example
    	     *
    	     * _.xor([2, 1], [2, 3]);
    	     * // => [1, 3]
    	     */
    var xor=baseRest(function(arrays){
    return baseXor(arrayFilter(arrays,isArrayLikeObject));
    });

    /**
    	     * This method is like `_.xor` except that it accepts `iteratee` which is
    	     * invoked for each element of each `arrays` to generate the criterion by
    	     * which by which they're compared. The order of result values is determined
    	     * by the order they occur in the arrays. The iteratee is invoked with one
    	     * argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {...Array} [arrays] The arrays to inspect.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {Array} Returns the new array of filtered values.
    	     * @example
    	     *
    	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
    	     * // => [1.2, 3.4]
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
    	     * // => [{ 'x': 2 }]
    	     */
    var xorBy=baseRest(function(arrays){
    var iteratee=last(arrays);
    if(isArrayLikeObject(iteratee)){
    iteratee=undefined$1;
    }
    return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));
    });

    /**
    	     * This method is like `_.xor` except that it accepts `comparator` which is
    	     * invoked to compare elements of `arrays`. The order of result values is
    	     * determined by the order they occur in the arrays. The comparator is invoked
    	     * with two arguments: (arrVal, othVal).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Array
    	     * @param {...Array} [arrays] The arrays to inspect.
    	     * @param {Function} [comparator] The comparator invoked per element.
    	     * @returns {Array} Returns the new array of filtered values.
    	     * @example
    	     *
    	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
    	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
    	     *
    	     * _.xorWith(objects, others, _.isEqual);
    	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
    	     */
    var xorWith=baseRest(function(arrays){
    var comparator=last(arrays);
    comparator=typeof comparator=='function'?comparator:undefined$1;
    return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined$1,comparator);
    });

    /**
    	     * Creates an array of grouped elements, the first of which contains the
    	     * first elements of the given arrays, the second of which contains the
    	     * second elements of the given arrays, and so on.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Array
    	     * @param {...Array} [arrays] The arrays to process.
    	     * @returns {Array} Returns the new array of grouped elements.
    	     * @example
    	     *
    	     * _.zip(['a', 'b'], [1, 2], [true, false]);
    	     * // => [['a', 1, true], ['b', 2, false]]
    	     */
    var zip=baseRest(unzip);

    /**
    	     * This method is like `_.fromPairs` except that it accepts two arrays,
    	     * one of property identifiers and one of corresponding values.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.4.0
    	     * @category Array
    	     * @param {Array} [props=[]] The property identifiers.
    	     * @param {Array} [values=[]] The property values.
    	     * @returns {Object} Returns the new object.
    	     * @example
    	     *
    	     * _.zipObject(['a', 'b'], [1, 2]);
    	     * // => { 'a': 1, 'b': 2 }
    	     */
    function zipObject(props,values){
    return baseZipObject(props||[],values||[],assignValue);
    }

    /**
    	     * This method is like `_.zipObject` except that it supports property paths.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.1.0
    	     * @category Array
    	     * @param {Array} [props=[]] The property identifiers.
    	     * @param {Array} [values=[]] The property values.
    	     * @returns {Object} Returns the new object.
    	     * @example
    	     *
    	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
    	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
    	     */
    function zipObjectDeep(props,values){
    return baseZipObject(props||[],values||[],baseSet);
    }

    /**
    	     * This method is like `_.zip` except that it accepts `iteratee` to specify
    	     * how grouped values should be combined. The iteratee is invoked with the
    	     * elements of each group: (...group).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.8.0
    	     * @category Array
    	     * @param {...Array} [arrays] The arrays to process.
    	     * @param {Function} [iteratee=_.identity] The function to combine
    	     *  grouped values.
    	     * @returns {Array} Returns the new array of grouped elements.
    	     * @example
    	     *
    	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
    	     *   return a + b + c;
    	     * });
    	     * // => [111, 222]
    	     */
    var zipWith=baseRest(function(arrays){
    var length=arrays.length,
    iteratee=length>1?arrays[length-1]:undefined$1;

    iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined$1;
    return unzipWith(arrays,iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
    	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
    	     * chain sequences enabled. The result of such sequences must be unwrapped
    	     * with `_#value`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 1.3.0
    	     * @category Seq
    	     * @param {*} value The value to wrap.
    	     * @returns {Object} Returns the new `lodash` wrapper instance.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney',  'age': 36 },
    	     *   { 'user': 'fred',    'age': 40 },
    	     *   { 'user': 'pebbles', 'age': 1 }
    	     * ];
    	     *
    	     * var youngest = _
    	     *   .chain(users)
    	     *   .sortBy('age')
    	     *   .map(function(o) {
    	     *     return o.user + ' is ' + o.age;
    	     *   })
    	     *   .head()
    	     *   .value();
    	     * // => 'pebbles is 1'
    	     */
    function chain(value){
    var result=lodash(value);
    result.__chain__=true;
    return result;
    }

    /**
    	     * This method invokes `interceptor` and returns `value`. The interceptor
    	     * is invoked with one argument; (value). The purpose of this method is to
    	     * "tap into" a method chain sequence in order to modify intermediate results.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Seq
    	     * @param {*} value The value to provide to `interceptor`.
    	     * @param {Function} interceptor The function to invoke.
    	     * @returns {*} Returns `value`.
    	     * @example
    	     *
    	     * _([1, 2, 3])
    	     *  .tap(function(array) {
    	     *    // Mutate input array.
    	     *    array.pop();
    	     *  })
    	     *  .reverse()
    	     *  .value();
    	     * // => [2, 1]
    	     */
    function tap(value,interceptor){
    interceptor(value);
    return value;
    }

    /**
    	     * This method is like `_.tap` except that it returns the result of `interceptor`.
    	     * The purpose of this method is to "pass thru" values replacing intermediate
    	     * results in a method chain sequence.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Seq
    	     * @param {*} value The value to provide to `interceptor`.
    	     * @param {Function} interceptor The function to invoke.
    	     * @returns {*} Returns the result of `interceptor`.
    	     * @example
    	     *
    	     * _('  abc  ')
    	     *  .chain()
    	     *  .trim()
    	     *  .thru(function(value) {
    	     *    return [value];
    	     *  })
    	     *  .value();
    	     * // => ['abc']
    	     */
    function thru(value,interceptor){
    return interceptor(value);
    }

    /**
    	     * This method is the wrapper version of `_.at`.
    	     *
    	     * @name at
    	     * @memberOf _
    	     * @since 1.0.0
    	     * @category Seq
    	     * @param {...(string|string[])} [paths] The property paths to pick.
    	     * @returns {Object} Returns the new `lodash` wrapper instance.
    	     * @example
    	     *
    	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
    	     *
    	     * _(object).at(['a[0].b.c', 'a[1]']).value();
    	     * // => [3, 4]
    	     */
    var wrapperAt=flatRest(function(paths){
    var length=paths.length,
    start=length?paths[0]:0,
    value=this.__wrapped__,
    interceptor=function(object){return baseAt(object,paths);};

    if(length>1||this.__actions__.length||
    !(value instanceof LazyWrapper)||!isIndex(start)){
    return this.thru(interceptor);
    }
    value=value.slice(start,+start+(length?1:0));
    value.__actions__.push({
    'func':thru,
    'args':[interceptor],
    'thisArg':undefined$1});

    return new LodashWrapper(value,this.__chain__).thru(function(array){
    if(length&&!array.length){
    array.push(undefined$1);
    }
    return array;
    });
    });

    /**
    	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
    	     *
    	     * @name chain
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Seq
    	     * @returns {Object} Returns the new `lodash` wrapper instance.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney', 'age': 36 },
    	     *   { 'user': 'fred',   'age': 40 }
    	     * ];
    	     *
    	     * // A sequence without explicit chaining.
    	     * _(users).head();
    	     * // => { 'user': 'barney', 'age': 36 }
    	     *
    	     * // A sequence with explicit chaining.
    	     * _(users)
    	     *   .chain()
    	     *   .head()
    	     *   .pick('user')
    	     *   .value();
    	     * // => { 'user': 'barney' }
    	     */
    function wrapperChain(){
    return chain(this);
    }

    /**
    	     * Executes the chain sequence and returns the wrapped result.
    	     *
    	     * @name commit
    	     * @memberOf _
    	     * @since 3.2.0
    	     * @category Seq
    	     * @returns {Object} Returns the new `lodash` wrapper instance.
    	     * @example
    	     *
    	     * var array = [1, 2];
    	     * var wrapped = _(array).push(3);
    	     *
    	     * console.log(array);
    	     * // => [1, 2]
    	     *
    	     * wrapped = wrapped.commit();
    	     * console.log(array);
    	     * // => [1, 2, 3]
    	     *
    	     * wrapped.last();
    	     * // => 3
    	     *
    	     * console.log(array);
    	     * // => [1, 2, 3]
    	     */
    function wrapperCommit(){
    return new LodashWrapper(this.value(),this.__chain__);
    }

    /**
    	     * Gets the next value on a wrapped object following the
    	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
    	     *
    	     * @name next
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Seq
    	     * @returns {Object} Returns the next iterator value.
    	     * @example
    	     *
    	     * var wrapped = _([1, 2]);
    	     *
    	     * wrapped.next();
    	     * // => { 'done': false, 'value': 1 }
    	     *
    	     * wrapped.next();
    	     * // => { 'done': false, 'value': 2 }
    	     *
    	     * wrapped.next();
    	     * // => { 'done': true, 'value': undefined }
    	     */
    function wrapperNext(){
    if(this.__values__===undefined$1){
    this.__values__=toArray(this.value());
    }
    var done=this.__index__>=this.__values__.length,
    value=done?undefined$1:this.__values__[this.__index__++];

    return {'done':done,'value':value};
    }

    /**
    	     * Enables the wrapper to be iterable.
    	     *
    	     * @name Symbol.iterator
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Seq
    	     * @returns {Object} Returns the wrapper object.
    	     * @example
    	     *
    	     * var wrapped = _([1, 2]);
    	     *
    	     * wrapped[Symbol.iterator]() === wrapped;
    	     * // => true
    	     *
    	     * Array.from(wrapped);
    	     * // => [1, 2]
    	     */
    function wrapperToIterator(){
    return this;
    }

    /**
    	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
    	     *
    	     * @name plant
    	     * @memberOf _
    	     * @since 3.2.0
    	     * @category Seq
    	     * @param {*} value The value to plant.
    	     * @returns {Object} Returns the new `lodash` wrapper instance.
    	     * @example
    	     *
    	     * function square(n) {
    	     *   return n * n;
    	     * }
    	     *
    	     * var wrapped = _([1, 2]).map(square);
    	     * var other = wrapped.plant([3, 4]);
    	     *
    	     * other.value();
    	     * // => [9, 16]
    	     *
    	     * wrapped.value();
    	     * // => [1, 4]
    	     */
    function wrapperPlant(value){
    var result,
    parent=this;

    while(parent instanceof baseLodash){
    var clone=wrapperClone(parent);
    clone.__index__=0;
    clone.__values__=undefined$1;
    if(result){
    previous.__wrapped__=clone;
    }else {
    result=clone;
    }
    var previous=clone;
    parent=parent.__wrapped__;
    }
    previous.__wrapped__=value;
    return result;
    }

    /**
    	     * This method is the wrapper version of `_.reverse`.
    	     *
    	     * **Note:** This method mutates the wrapped array.
    	     *
    	     * @name reverse
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Seq
    	     * @returns {Object} Returns the new `lodash` wrapper instance.
    	     * @example
    	     *
    	     * var array = [1, 2, 3];
    	     *
    	     * _(array).reverse().value()
    	     * // => [3, 2, 1]
    	     *
    	     * console.log(array);
    	     * // => [3, 2, 1]
    	     */
    function wrapperReverse(){
    var value=this.__wrapped__;
    if(value instanceof LazyWrapper){
    var wrapped=value;
    if(this.__actions__.length){
    wrapped=new LazyWrapper(this);
    }
    wrapped=wrapped.reverse();
    wrapped.__actions__.push({
    'func':thru,
    'args':[reverse],
    'thisArg':undefined$1});

    return new LodashWrapper(wrapped,this.__chain__);
    }
    return this.thru(reverse);
    }

    /**
    	     * Executes the chain sequence to resolve the unwrapped value.
    	     *
    	     * @name value
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @alias toJSON, valueOf
    	     * @category Seq
    	     * @returns {*} Returns the resolved unwrapped value.
    	     * @example
    	     *
    	     * _([1, 2, 3]).value();
    	     * // => [1, 2, 3]
    	     */
    function wrapperValue(){
    return baseWrapperValue(this.__wrapped__,this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
    	     * Creates an object composed of keys generated from the results of running
    	     * each element of `collection` thru `iteratee`. The corresponding value of
    	     * each key is the number of times the key was returned by `iteratee`. The
    	     * iteratee is invoked with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.5.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
    	     * @returns {Object} Returns the composed aggregate object.
    	     * @example
    	     *
    	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
    	     * // => { '4': 1, '6': 2 }
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.countBy(['one', 'two', 'three'], 'length');
    	     * // => { '3': 2, '5': 1 }
    	     */
    var countBy=createAggregator(function(result,value,key){
    if(hasOwnProperty.call(result,key)){
    ++result[key];
    }else {
    baseAssignValue(result,key,1);
    }
    });

    /**
    	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
    	     * Iteration is stopped once `predicate` returns falsey. The predicate is
    	     * invoked with three arguments: (value, index|key, collection).
    	     *
    	     * **Note:** This method returns `true` for
    	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
    	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
    	     * elements of empty collections.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
    	     *  else `false`.
    	     * @example
    	     *
    	     * _.every([true, 1, null, 'yes'], Boolean);
    	     * // => false
    	     *
    	     * var users = [
    	     *   { 'user': 'barney', 'age': 36, 'active': false },
    	     *   { 'user': 'fred',   'age': 40, 'active': false }
    	     * ];
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.every(users, { 'user': 'barney', 'active': false });
    	     * // => false
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.every(users, ['active', false]);
    	     * // => true
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.every(users, 'active');
    	     * // => false
    	     */
    function every(collection,predicate,guard){
    var func=isArray(collection)?arrayEvery:baseEvery;
    if(guard&&isIterateeCall(collection,predicate,guard)){
    predicate=undefined$1;
    }
    return func(collection,getIteratee(predicate,3));
    }

    /**
    	     * Iterates over elements of `collection`, returning an array of all elements
    	     * `predicate` returns truthy for. The predicate is invoked with three
    	     * arguments: (value, index|key, collection).
    	     *
    	     * **Note:** Unlike `_.remove`, this method returns a new array.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the new filtered array.
    	     * @see _.reject
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney', 'age': 36, 'active': true },
    	     *   { 'user': 'fred',   'age': 40, 'active': false }
    	     * ];
    	     *
    	     * _.filter(users, function(o) { return !o.active; });
    	     * // => objects for ['fred']
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.filter(users, { 'age': 36, 'active': true });
    	     * // => objects for ['barney']
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.filter(users, ['active', false]);
    	     * // => objects for ['fred']
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.filter(users, 'active');
    	     * // => objects for ['barney']
    	     *
    	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
    	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
    	     * // => objects for ['fred', 'barney']
    	     */
    function filter(collection,predicate){
    var func=isArray(collection)?arrayFilter:baseFilter;
    return func(collection,getIteratee(predicate,3));
    }

    /**
    	     * Iterates over elements of `collection`, returning the first element
    	     * `predicate` returns truthy for. The predicate is invoked with three
    	     * arguments: (value, index|key, collection).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to inspect.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @param {number} [fromIndex=0] The index to search from.
    	     * @returns {*} Returns the matched element, else `undefined`.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney',  'age': 36, 'active': true },
    	     *   { 'user': 'fred',    'age': 40, 'active': false },
    	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
    	     * ];
    	     *
    	     * _.find(users, function(o) { return o.age < 40; });
    	     * // => object for 'barney'
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.find(users, { 'age': 1, 'active': true });
    	     * // => object for 'pebbles'
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.find(users, ['active', false]);
    	     * // => object for 'fred'
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.find(users, 'active');
    	     * // => object for 'barney'
    	     */
    var find=createFind(findIndex);

    /**
    	     * This method is like `_.find` except that it iterates over elements of
    	     * `collection` from right to left.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.0.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to inspect.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @param {number} [fromIndex=collection.length-1] The index to search from.
    	     * @returns {*} Returns the matched element, else `undefined`.
    	     * @example
    	     *
    	     * _.findLast([1, 2, 3, 4], function(n) {
    	     *   return n % 2 == 1;
    	     * });
    	     * // => 3
    	     */
    var findLast=createFind(findLastIndex);

    /**
    	     * Creates a flattened array of values by running each element in `collection`
    	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
    	     * with three arguments: (value, index|key, collection).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the new flattened array.
    	     * @example
    	     *
    	     * function duplicate(n) {
    	     *   return [n, n];
    	     * }
    	     *
    	     * _.flatMap([1, 2], duplicate);
    	     * // => [1, 1, 2, 2]
    	     */
    function flatMap(collection,iteratee){
    return baseFlatten(map(collection,iteratee),1);
    }

    /**
    	     * This method is like `_.flatMap` except that it recursively flattens the
    	     * mapped results.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.7.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the new flattened array.
    	     * @example
    	     *
    	     * function duplicate(n) {
    	     *   return [[[n, n]]];
    	     * }
    	     *
    	     * _.flatMapDeep([1, 2], duplicate);
    	     * // => [1, 1, 2, 2]
    	     */
    function flatMapDeep(collection,iteratee){
    return baseFlatten(map(collection,iteratee),INFINITY);
    }

    /**
    	     * This method is like `_.flatMap` except that it recursively flattens the
    	     * mapped results up to `depth` times.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.7.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @param {number} [depth=1] The maximum recursion depth.
    	     * @returns {Array} Returns the new flattened array.
    	     * @example
    	     *
    	     * function duplicate(n) {
    	     *   return [[[n, n]]];
    	     * }
    	     *
    	     * _.flatMapDepth([1, 2], duplicate, 2);
    	     * // => [[1, 1], [2, 2]]
    	     */
    function flatMapDepth(collection,iteratee,depth){
    depth=depth===undefined$1?1:toInteger(depth);
    return baseFlatten(map(collection,iteratee),depth);
    }

    /**
    	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
    	     * The iteratee is invoked with three arguments: (value, index|key, collection).
    	     * Iteratee functions may exit iteration early by explicitly returning `false`.
    	     *
    	     * **Note:** As with other "Collections" methods, objects with a "length"
    	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
    	     * or `_.forOwn` for object iteration.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @alias each
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Array|Object} Returns `collection`.
    	     * @see _.forEachRight
    	     * @example
    	     *
    	     * _.forEach([1, 2], function(value) {
    	     *   console.log(value);
    	     * });
    	     * // => Logs `1` then `2`.
    	     *
    	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
    	     *   console.log(key);
    	     * });
    	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
    	     */
    function forEach(collection,iteratee){
    var func=isArray(collection)?arrayEach:baseEach;
    return func(collection,getIteratee(iteratee,3));
    }

    /**
    	     * This method is like `_.forEach` except that it iterates over elements of
    	     * `collection` from right to left.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.0.0
    	     * @alias eachRight
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Array|Object} Returns `collection`.
    	     * @see _.forEach
    	     * @example
    	     *
    	     * _.forEachRight([1, 2], function(value) {
    	     *   console.log(value);
    	     * });
    	     * // => Logs `2` then `1`.
    	     */
    function forEachRight(collection,iteratee){
    var func=isArray(collection)?arrayEachRight:baseEachRight;
    return func(collection,getIteratee(iteratee,3));
    }

    /**
    	     * Creates an object composed of keys generated from the results of running
    	     * each element of `collection` thru `iteratee`. The order of grouped values
    	     * is determined by the order they occur in `collection`. The corresponding
    	     * value of each key is an array of elements responsible for generating the
    	     * key. The iteratee is invoked with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
    	     * @returns {Object} Returns the composed aggregate object.
    	     * @example
    	     *
    	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
    	     * // => { '4': [4.2], '6': [6.1, 6.3] }
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.groupBy(['one', 'two', 'three'], 'length');
    	     * // => { '3': ['one', 'two'], '5': ['three'] }
    	     */
    var groupBy=createAggregator(function(result,value,key){
    if(hasOwnProperty.call(result,key)){
    result[key].push(value);
    }else {
    baseAssignValue(result,key,[value]);
    }
    });

    /**
    	     * Checks if `value` is in `collection`. If `collection` is a string, it's
    	     * checked for a substring of `value`, otherwise
    	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
    	     * the offset from the end of `collection`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object|string} collection The collection to inspect.
    	     * @param {*} value The value to search for.
    	     * @param {number} [fromIndex=0] The index to search from.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
    	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
    	     * @example
    	     *
    	     * _.includes([1, 2, 3], 1);
    	     * // => true
    	     *
    	     * _.includes([1, 2, 3], 1, 2);
    	     * // => false
    	     *
    	     * _.includes({ 'a': 1, 'b': 2 }, 1);
    	     * // => true
    	     *
    	     * _.includes('abcd', 'bc');
    	     * // => true
    	     */
    function includes(collection,value,fromIndex,guard){
    collection=isArrayLike(collection)?collection:values(collection);
    fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;

    var length=collection.length;
    if(fromIndex<0){
    fromIndex=nativeMax(length+fromIndex,0);
    }
    return isString(collection)?
    fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:
    !!length&&baseIndexOf(collection,value,fromIndex)>-1;
    }

    /**
    	     * Invokes the method at `path` of each element in `collection`, returning
    	     * an array of the results of each invoked method. Any additional arguments
    	     * are provided to each invoked method. If `path` is a function, it's invoked
    	     * for, and `this` bound to, each element in `collection`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Array|Function|string} path The path of the method to invoke or
    	     *  the function invoked per iteration.
    	     * @param {...*} [args] The arguments to invoke each method with.
    	     * @returns {Array} Returns the array of results.
    	     * @example
    	     *
    	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
    	     * // => [[1, 5, 7], [1, 2, 3]]
    	     *
    	     * _.invokeMap([123, 456], String.prototype.split, '');
    	     * // => [['1', '2', '3'], ['4', '5', '6']]
    	     */
    var invokeMap=baseRest(function(collection,path,args){
    var index=-1,
    isFunc=typeof path=='function',
    result=isArrayLike(collection)?Array(collection.length):[];

    baseEach(collection,function(value){
    result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);
    });
    return result;
    });

    /**
    	     * Creates an object composed of keys generated from the results of running
    	     * each element of `collection` thru `iteratee`. The corresponding value of
    	     * each key is the last element responsible for generating the key. The
    	     * iteratee is invoked with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
    	     * @returns {Object} Returns the composed aggregate object.
    	     * @example
    	     *
    	     * var array = [
    	     *   { 'dir': 'left', 'code': 97 },
    	     *   { 'dir': 'right', 'code': 100 }
    	     * ];
    	     *
    	     * _.keyBy(array, function(o) {
    	     *   return String.fromCharCode(o.code);
    	     * });
    	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
    	     *
    	     * _.keyBy(array, 'dir');
    	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
    	     */
    var keyBy=createAggregator(function(result,value,key){
    baseAssignValue(result,key,value);
    });

    /**
    	     * Creates an array of values by running each element in `collection` thru
    	     * `iteratee`. The iteratee is invoked with three arguments:
    	     * (value, index|key, collection).
    	     *
    	     * Many lodash methods are guarded to work as iteratees for methods like
    	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
    	     *
    	     * The guarded methods are:
    	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
    	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
    	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
    	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the new mapped array.
    	     * @example
    	     *
    	     * function square(n) {
    	     *   return n * n;
    	     * }
    	     *
    	     * _.map([4, 8], square);
    	     * // => [16, 64]
    	     *
    	     * _.map({ 'a': 4, 'b': 8 }, square);
    	     * // => [16, 64] (iteration order is not guaranteed)
    	     *
    	     * var users = [
    	     *   { 'user': 'barney' },
    	     *   { 'user': 'fred' }
    	     * ];
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.map(users, 'user');
    	     * // => ['barney', 'fred']
    	     */
    function map(collection,iteratee){
    var func=isArray(collection)?arrayMap:baseMap;
    return func(collection,getIteratee(iteratee,3));
    }

    /**
    	     * This method is like `_.sortBy` except that it allows specifying the sort
    	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
    	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
    	     * descending or "asc" for ascending sort order of corresponding values.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
    	     *  The iteratees to sort by.
    	     * @param {string[]} [orders] The sort orders of `iteratees`.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
    	     * @returns {Array} Returns the new sorted array.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'fred',   'age': 48 },
    	     *   { 'user': 'barney', 'age': 34 },
    	     *   { 'user': 'fred',   'age': 40 },
    	     *   { 'user': 'barney', 'age': 36 }
    	     * ];
    	     *
    	     * // Sort by `user` in ascending order and by `age` in descending order.
    	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
    	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
    	     */
    function orderBy(collection,iteratees,orders,guard){
    if(collection==null){
    return [];
    }
    if(!isArray(iteratees)){
    iteratees=iteratees==null?[]:[iteratees];
    }
    orders=guard?undefined$1:orders;
    if(!isArray(orders)){
    orders=orders==null?[]:[orders];
    }
    return baseOrderBy(collection,iteratees,orders);
    }

    /**
    	     * Creates an array of elements split into two groups, the first of which
    	     * contains elements `predicate` returns truthy for, the second of which
    	     * contains elements `predicate` returns falsey for. The predicate is
    	     * invoked with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the array of grouped elements.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney',  'age': 36, 'active': false },
    	     *   { 'user': 'fred',    'age': 40, 'active': true },
    	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
    	     * ];
    	     *
    	     * _.partition(users, function(o) { return o.active; });
    	     * // => objects for [['fred'], ['barney', 'pebbles']]
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.partition(users, { 'age': 1, 'active': false });
    	     * // => objects for [['pebbles'], ['barney', 'fred']]
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.partition(users, ['active', false]);
    	     * // => objects for [['barney', 'pebbles'], ['fred']]
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.partition(users, 'active');
    	     * // => objects for [['fred'], ['barney', 'pebbles']]
    	     */
    var partition=createAggregator(function(result,value,key){
    result[key?0:1].push(value);
    },function(){return [[],[]];});

    /**
    	     * Reduces `collection` to a value which is the accumulated result of running
    	     * each element in `collection` thru `iteratee`, where each successive
    	     * invocation is supplied the return value of the previous. If `accumulator`
    	     * is not given, the first element of `collection` is used as the initial
    	     * value. The iteratee is invoked with four arguments:
    	     * (accumulator, value, index|key, collection).
    	     *
    	     * Many lodash methods are guarded to work as iteratees for methods like
    	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
    	     *
    	     * The guarded methods are:
    	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
    	     * and `sortBy`
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @param {*} [accumulator] The initial value.
    	     * @returns {*} Returns the accumulated value.
    	     * @see _.reduceRight
    	     * @example
    	     *
    	     * _.reduce([1, 2], function(sum, n) {
    	     *   return sum + n;
    	     * }, 0);
    	     * // => 3
    	     *
    	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
    	     *   (result[value] || (result[value] = [])).push(key);
    	     *   return result;
    	     * }, {});
    	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
    	     */
    function reduce(collection,iteratee,accumulator){
    var func=isArray(collection)?arrayReduce:baseReduce,
    initAccum=arguments.length<3;

    return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);
    }

    /**
    	     * This method is like `_.reduce` except that it iterates over elements of
    	     * `collection` from right to left.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @param {*} [accumulator] The initial value.
    	     * @returns {*} Returns the accumulated value.
    	     * @see _.reduce
    	     * @example
    	     *
    	     * var array = [[0, 1], [2, 3], [4, 5]];
    	     *
    	     * _.reduceRight(array, function(flattened, other) {
    	     *   return flattened.concat(other);
    	     * }, []);
    	     * // => [4, 5, 2, 3, 0, 1]
    	     */
    function reduceRight(collection,iteratee,accumulator){
    var func=isArray(collection)?arrayReduceRight:baseReduce,
    initAccum=arguments.length<3;

    return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);
    }

    /**
    	     * The opposite of `_.filter`; this method returns the elements of `collection`
    	     * that `predicate` does **not** return truthy for.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the new filtered array.
    	     * @see _.filter
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney', 'age': 36, 'active': false },
    	     *   { 'user': 'fred',   'age': 40, 'active': true }
    	     * ];
    	     *
    	     * _.reject(users, function(o) { return !o.active; });
    	     * // => objects for ['fred']
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.reject(users, { 'age': 40, 'active': true });
    	     * // => objects for ['barney']
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.reject(users, ['active', false]);
    	     * // => objects for ['fred']
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.reject(users, 'active');
    	     * // => objects for ['barney']
    	     */
    function reject(collection,predicate){
    var func=isArray(collection)?arrayFilter:baseFilter;
    return func(collection,negate(getIteratee(predicate,3)));
    }

    /**
    	     * Gets a random element from `collection`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.0.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to sample.
    	     * @returns {*} Returns the random element.
    	     * @example
    	     *
    	     * _.sample([1, 2, 3, 4]);
    	     * // => 2
    	     */
    function sample(collection){
    var func=isArray(collection)?arraySample:baseSample;
    return func(collection);
    }

    /**
    	     * Gets `n` random elements at unique keys from `collection` up to the
    	     * size of `collection`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to sample.
    	     * @param {number} [n=1] The number of elements to sample.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {Array} Returns the random elements.
    	     * @example
    	     *
    	     * _.sampleSize([1, 2, 3], 2);
    	     * // => [3, 1]
    	     *
    	     * _.sampleSize([1, 2, 3], 4);
    	     * // => [2, 3, 1]
    	     */
    function sampleSize(collection,n,guard){
    if(guard?isIterateeCall(collection,n,guard):n===undefined$1){
    n=1;
    }else {
    n=toInteger(n);
    }
    var func=isArray(collection)?arraySampleSize:baseSampleSize;
    return func(collection,n);
    }

    /**
    	     * Creates an array of shuffled values, using a version of the
    	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to shuffle.
    	     * @returns {Array} Returns the new shuffled array.
    	     * @example
    	     *
    	     * _.shuffle([1, 2, 3, 4]);
    	     * // => [4, 1, 3, 2]
    	     */
    function shuffle(collection){
    var func=isArray(collection)?arrayShuffle:baseShuffle;
    return func(collection);
    }

    /**
    	     * Gets the size of `collection` by returning its length for array-like
    	     * values or the number of own enumerable string keyed properties for objects.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object|string} collection The collection to inspect.
    	     * @returns {number} Returns the collection size.
    	     * @example
    	     *
    	     * _.size([1, 2, 3]);
    	     * // => 3
    	     *
    	     * _.size({ 'a': 1, 'b': 2 });
    	     * // => 2
    	     *
    	     * _.size('pebbles');
    	     * // => 7
    	     */
    function size(collection){
    if(collection==null){
    return 0;
    }
    if(isArrayLike(collection)){
    return isString(collection)?stringSize(collection):collection.length;
    }
    var tag=getTag(collection);
    if(tag==mapTag||tag==setTag){
    return collection.size;
    }
    return baseKeys(collection).length;
    }

    /**
    	     * Checks if `predicate` returns truthy for **any** element of `collection`.
    	     * Iteration is stopped once `predicate` returns truthy. The predicate is
    	     * invoked with three arguments: (value, index|key, collection).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {boolean} Returns `true` if any element passes the predicate check,
    	     *  else `false`.
    	     * @example
    	     *
    	     * _.some([null, 0, 'yes', false], Boolean);
    	     * // => true
    	     *
    	     * var users = [
    	     *   { 'user': 'barney', 'active': true },
    	     *   { 'user': 'fred',   'active': false }
    	     * ];
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.some(users, { 'user': 'barney', 'active': false });
    	     * // => false
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.some(users, ['active', false]);
    	     * // => true
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.some(users, 'active');
    	     * // => true
    	     */
    function some(collection,predicate,guard){
    var func=isArray(collection)?arraySome:baseSome;
    if(guard&&isIterateeCall(collection,predicate,guard)){
    predicate=undefined$1;
    }
    return func(collection,getIteratee(predicate,3));
    }

    /**
    	     * Creates an array of elements, sorted in ascending order by the results of
    	     * running each element in a collection thru each iteratee. This method
    	     * performs a stable sort, that is, it preserves the original sort order of
    	     * equal elements. The iteratees are invoked with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Collection
    	     * @param {Array|Object} collection The collection to iterate over.
    	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
    	     *  The iteratees to sort by.
    	     * @returns {Array} Returns the new sorted array.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'fred',   'age': 48 },
    	     *   { 'user': 'barney', 'age': 36 },
    	     *   { 'user': 'fred',   'age': 30 },
    	     *   { 'user': 'barney', 'age': 34 }
    	     * ];
    	     *
    	     * _.sortBy(users, [function(o) { return o.user; }]);
    	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
    	     *
    	     * _.sortBy(users, ['user', 'age']);
    	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
    	     */
    var sortBy=baseRest(function(collection,iteratees){
    if(collection==null){
    return [];
    }
    var length=iteratees.length;
    if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){
    iteratees=[];
    }else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){
    iteratees=[iteratees[0]];
    }
    return baseOrderBy(collection,baseFlatten(iteratees,1),[]);
    });

    /*------------------------------------------------------------------------*/

    /**
    	     * Gets the timestamp of the number of milliseconds that have elapsed since
    	     * the Unix epoch (1 January 1970 00:00:00 UTC).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.4.0
    	     * @category Date
    	     * @returns {number} Returns the timestamp.
    	     * @example
    	     *
    	     * _.defer(function(stamp) {
    	     *   console.log(_.now() - stamp);
    	     * }, _.now());
    	     * // => Logs the number of milliseconds it took for the deferred invocation.
    	     */
    var now=ctxNow||function(){
    return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
    	     * The opposite of `_.before`; this method creates a function that invokes
    	     * `func` once it's called `n` or more times.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Function
    	     * @param {number} n The number of calls before `func` is invoked.
    	     * @param {Function} func The function to restrict.
    	     * @returns {Function} Returns the new restricted function.
    	     * @example
    	     *
    	     * var saves = ['profile', 'settings'];
    	     *
    	     * var done = _.after(saves.length, function() {
    	     *   console.log('done saving!');
    	     * });
    	     *
    	     * _.forEach(saves, function(type) {
    	     *   asyncSave({ 'type': type, 'complete': done });
    	     * });
    	     * // => Logs 'done saving!' after the two async saves have completed.
    	     */
    function after(n,func){
    if(typeof func!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    n=toInteger(n);
    return function(){
    if(--n<1){
    return func.apply(this,arguments);
    }
    };
    }

    /**
    	     * Creates a function that invokes `func`, with up to `n` arguments,
    	     * ignoring any additional arguments.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Function
    	     * @param {Function} func The function to cap arguments for.
    	     * @param {number} [n=func.length] The arity cap.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {Function} Returns the new capped function.
    	     * @example
    	     *
    	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
    	     * // => [6, 8, 10]
    	     */
    function ary(func,n,guard){
    n=guard?undefined$1:n;
    n=func&&n==null?func.length:n;
    return createWrap(func,WRAP_ARY_FLAG,undefined$1,undefined$1,undefined$1,undefined$1,n);
    }

    /**
    	     * Creates a function that invokes `func`, with the `this` binding and arguments
    	     * of the created function, while it's called less than `n` times. Subsequent
    	     * calls to the created function return the result of the last `func` invocation.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Function
    	     * @param {number} n The number of calls at which `func` is no longer invoked.
    	     * @param {Function} func The function to restrict.
    	     * @returns {Function} Returns the new restricted function.
    	     * @example
    	     *
    	     * jQuery(element).on('click', _.before(5, addContactToList));
    	     * // => Allows adding up to 4 contacts to the list.
    	     */
    function before(n,func){
    var result;
    if(typeof func!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    n=toInteger(n);
    return function(){
    if(--n>0){
    result=func.apply(this,arguments);
    }
    if(n<=1){
    func=undefined$1;
    }
    return result;
    };
    }

    /**
    	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
    	     * and `partials` prepended to the arguments it receives.
    	     *
    	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
    	     * may be used as a placeholder for partially applied arguments.
    	     *
    	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
    	     * property of bound functions.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Function
    	     * @param {Function} func The function to bind.
    	     * @param {*} thisArg The `this` binding of `func`.
    	     * @param {...*} [partials] The arguments to be partially applied.
    	     * @returns {Function} Returns the new bound function.
    	     * @example
    	     *
    	     * function greet(greeting, punctuation) {
    	     *   return greeting + ' ' + this.user + punctuation;
    	     * }
    	     *
    	     * var object = { 'user': 'fred' };
    	     *
    	     * var bound = _.bind(greet, object, 'hi');
    	     * bound('!');
    	     * // => 'hi fred!'
    	     *
    	     * // Bound with placeholders.
    	     * var bound = _.bind(greet, object, _, '!');
    	     * bound('hi');
    	     * // => 'hi fred!'
    	     */
    var bind=baseRest(function(func,thisArg,partials){
    var bitmask=WRAP_BIND_FLAG;
    if(partials.length){
    var holders=replaceHolders(partials,getHolder(bind));
    bitmask|=WRAP_PARTIAL_FLAG;
    }
    return createWrap(func,bitmask,thisArg,partials,holders);
    });

    /**
    	     * Creates a function that invokes the method at `object[key]` with `partials`
    	     * prepended to the arguments it receives.
    	     *
    	     * This method differs from `_.bind` by allowing bound functions to reference
    	     * methods that may be redefined or don't yet exist. See
    	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
    	     * for more details.
    	     *
    	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
    	     * builds, may be used as a placeholder for partially applied arguments.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.10.0
    	     * @category Function
    	     * @param {Object} object The object to invoke the method on.
    	     * @param {string} key The key of the method.
    	     * @param {...*} [partials] The arguments to be partially applied.
    	     * @returns {Function} Returns the new bound function.
    	     * @example
    	     *
    	     * var object = {
    	     *   'user': 'fred',
    	     *   'greet': function(greeting, punctuation) {
    	     *     return greeting + ' ' + this.user + punctuation;
    	     *   }
    	     * };
    	     *
    	     * var bound = _.bindKey(object, 'greet', 'hi');
    	     * bound('!');
    	     * // => 'hi fred!'
    	     *
    	     * object.greet = function(greeting, punctuation) {
    	     *   return greeting + 'ya ' + this.user + punctuation;
    	     * };
    	     *
    	     * bound('!');
    	     * // => 'hiya fred!'
    	     *
    	     * // Bound with placeholders.
    	     * var bound = _.bindKey(object, 'greet', _, '!');
    	     * bound('hi');
    	     * // => 'hiya fred!'
    	     */
    var bindKey=baseRest(function(object,key,partials){
    var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;
    if(partials.length){
    var holders=replaceHolders(partials,getHolder(bindKey));
    bitmask|=WRAP_PARTIAL_FLAG;
    }
    return createWrap(key,bitmask,object,partials,holders);
    });

    /**
    	     * Creates a function that accepts arguments of `func` and either invokes
    	     * `func` returning its result, if at least `arity` number of arguments have
    	     * been provided, or returns a function that accepts the remaining `func`
    	     * arguments, and so on. The arity of `func` may be specified if `func.length`
    	     * is not sufficient.
    	     *
    	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
    	     * may be used as a placeholder for provided arguments.
    	     *
    	     * **Note:** This method doesn't set the "length" property of curried functions.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.0.0
    	     * @category Function
    	     * @param {Function} func The function to curry.
    	     * @param {number} [arity=func.length] The arity of `func`.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {Function} Returns the new curried function.
    	     * @example
    	     *
    	     * var abc = function(a, b, c) {
    	     *   return [a, b, c];
    	     * };
    	     *
    	     * var curried = _.curry(abc);
    	     *
    	     * curried(1)(2)(3);
    	     * // => [1, 2, 3]
    	     *
    	     * curried(1, 2)(3);
    	     * // => [1, 2, 3]
    	     *
    	     * curried(1, 2, 3);
    	     * // => [1, 2, 3]
    	     *
    	     * // Curried with placeholders.
    	     * curried(1)(_, 3)(2);
    	     * // => [1, 2, 3]
    	     */
    function curry(func,arity,guard){
    arity=guard?undefined$1:arity;
    var result=createWrap(func,WRAP_CURRY_FLAG,undefined$1,undefined$1,undefined$1,undefined$1,undefined$1,arity);
    result.placeholder=curry.placeholder;
    return result;
    }

    /**
    	     * This method is like `_.curry` except that arguments are applied to `func`
    	     * in the manner of `_.partialRight` instead of `_.partial`.
    	     *
    	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
    	     * builds, may be used as a placeholder for provided arguments.
    	     *
    	     * **Note:** This method doesn't set the "length" property of curried functions.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Function
    	     * @param {Function} func The function to curry.
    	     * @param {number} [arity=func.length] The arity of `func`.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {Function} Returns the new curried function.
    	     * @example
    	     *
    	     * var abc = function(a, b, c) {
    	     *   return [a, b, c];
    	     * };
    	     *
    	     * var curried = _.curryRight(abc);
    	     *
    	     * curried(3)(2)(1);
    	     * // => [1, 2, 3]
    	     *
    	     * curried(2, 3)(1);
    	     * // => [1, 2, 3]
    	     *
    	     * curried(1, 2, 3);
    	     * // => [1, 2, 3]
    	     *
    	     * // Curried with placeholders.
    	     * curried(3)(1, _)(2);
    	     * // => [1, 2, 3]
    	     */
    function curryRight(func,arity,guard){
    arity=guard?undefined$1:arity;
    var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined$1,undefined$1,undefined$1,undefined$1,undefined$1,arity);
    result.placeholder=curryRight.placeholder;
    return result;
    }

    /**
    	     * Creates a debounced function that delays invoking `func` until after `wait`
    	     * milliseconds have elapsed since the last time the debounced function was
    	     * invoked. The debounced function comes with a `cancel` method to cancel
    	     * delayed `func` invocations and a `flush` method to immediately invoke them.
    	     * Provide `options` to indicate whether `func` should be invoked on the
    	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
    	     * with the last arguments provided to the debounced function. Subsequent
    	     * calls to the debounced function return the result of the last `func`
    	     * invocation.
    	     *
    	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
    	     * invoked on the trailing edge of the timeout only if the debounced function
    	     * is invoked more than once during the `wait` timeout.
    	     *
    	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
    	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
    	     *
    	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
    	     * for details over the differences between `_.debounce` and `_.throttle`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Function
    	     * @param {Function} func The function to debounce.
    	     * @param {number} [wait=0] The number of milliseconds to delay.
    	     * @param {Object} [options={}] The options object.
    	     * @param {boolean} [options.leading=false]
    	     *  Specify invoking on the leading edge of the timeout.
    	     * @param {number} [options.maxWait]
    	     *  The maximum time `func` is allowed to be delayed before it's invoked.
    	     * @param {boolean} [options.trailing=true]
    	     *  Specify invoking on the trailing edge of the timeout.
    	     * @returns {Function} Returns the new debounced function.
    	     * @example
    	     *
    	     * // Avoid costly calculations while the window size is in flux.
    	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
    	     *
    	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
    	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
    	     *   'leading': true,
    	     *   'trailing': false
    	     * }));
    	     *
    	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
    	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
    	     * var source = new EventSource('/stream');
    	     * jQuery(source).on('message', debounced);
    	     *
    	     * // Cancel the trailing debounced invocation.
    	     * jQuery(window).on('popstate', debounced.cancel);
    	     */
    function debounce(func,wait,options){
    var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime=0,
    leading=false,
    maxing=false,
    trailing=true;

    if(typeof func!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    wait=toNumber(wait)||0;
    if(isObject(options)){
    leading=!!options.leading;
    maxing='maxWait'in options;
    maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;
    trailing='trailing'in options?!!options.trailing:trailing;
    }

    function invokeFunc(time){
    var args=lastArgs,
    thisArg=lastThis;

    lastArgs=lastThis=undefined$1;
    lastInvokeTime=time;
    result=func.apply(thisArg,args);
    return result;
    }

    function leadingEdge(time){
    // Reset any `maxWait` timer.
    lastInvokeTime=time;
    // Start the timer for the trailing edge.
    timerId=setTimeout(timerExpired,wait);
    // Invoke the leading edge.
    return leading?invokeFunc(time):result;
    }

    function remainingWait(time){
    var timeSinceLastCall=time-lastCallTime,
    timeSinceLastInvoke=time-lastInvokeTime,
    timeWaiting=wait-timeSinceLastCall;

    return maxing?
    nativeMin(timeWaiting,maxWait-timeSinceLastInvoke):
    timeWaiting;
    }

    function shouldInvoke(time){
    var timeSinceLastCall=time-lastCallTime,
    timeSinceLastInvoke=time-lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime===undefined$1||timeSinceLastCall>=wait||
    timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;
    }

    function timerExpired(){
    var time=now();
    if(shouldInvoke(time)){
    return trailingEdge(time);
    }
    // Restart the timer.
    timerId=setTimeout(timerExpired,remainingWait(time));
    }

    function trailingEdge(time){
    timerId=undefined$1;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if(trailing&&lastArgs){
    return invokeFunc(time);
    }
    lastArgs=lastThis=undefined$1;
    return result;
    }

    function cancel(){
    if(timerId!==undefined$1){
    clearTimeout(timerId);
    }
    lastInvokeTime=0;
    lastArgs=lastCallTime=lastThis=timerId=undefined$1;
    }

    function flush(){
    return timerId===undefined$1?result:trailingEdge(now());
    }

    function debounced(){
    var time=now(),
    isInvoking=shouldInvoke(time);

    lastArgs=arguments;
    lastThis=this;
    lastCallTime=time;

    if(isInvoking){
    if(timerId===undefined$1){
    return leadingEdge(lastCallTime);
    }
    if(maxing){
    // Handle invocations in a tight loop.
    clearTimeout(timerId);
    timerId=setTimeout(timerExpired,wait);
    return invokeFunc(lastCallTime);
    }
    }
    if(timerId===undefined$1){
    timerId=setTimeout(timerExpired,wait);
    }
    return result;
    }
    debounced.cancel=cancel;
    debounced.flush=flush;
    return debounced;
    }

    /**
    	     * Defers invoking the `func` until the current call stack has cleared. Any
    	     * additional arguments are provided to `func` when it's invoked.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Function
    	     * @param {Function} func The function to defer.
    	     * @param {...*} [args] The arguments to invoke `func` with.
    	     * @returns {number} Returns the timer id.
    	     * @example
    	     *
    	     * _.defer(function(text) {
    	     *   console.log(text);
    	     * }, 'deferred');
    	     * // => Logs 'deferred' after one millisecond.
    	     */
    var defer=baseRest(function(func,args){
    return baseDelay(func,1,args);
    });

    /**
    	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
    	     * provided to `func` when it's invoked.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Function
    	     * @param {Function} func The function to delay.
    	     * @param {number} wait The number of milliseconds to delay invocation.
    	     * @param {...*} [args] The arguments to invoke `func` with.
    	     * @returns {number} Returns the timer id.
    	     * @example
    	     *
    	     * _.delay(function(text) {
    	     *   console.log(text);
    	     * }, 1000, 'later');
    	     * // => Logs 'later' after one second.
    	     */
    var delay=baseRest(function(func,wait,args){
    return baseDelay(func,toNumber(wait)||0,args);
    });

    /**
    	     * Creates a function that invokes `func` with arguments reversed.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Function
    	     * @param {Function} func The function to flip arguments for.
    	     * @returns {Function} Returns the new flipped function.
    	     * @example
    	     *
    	     * var flipped = _.flip(function() {
    	     *   return _.toArray(arguments);
    	     * });
    	     *
    	     * flipped('a', 'b', 'c', 'd');
    	     * // => ['d', 'c', 'b', 'a']
    	     */
    function flip(func){
    return createWrap(func,WRAP_FLIP_FLAG);
    }

    /**
    	     * Creates a function that memoizes the result of `func`. If `resolver` is
    	     * provided, it determines the cache key for storing the result based on the
    	     * arguments provided to the memoized function. By default, the first argument
    	     * provided to the memoized function is used as the map cache key. The `func`
    	     * is invoked with the `this` binding of the memoized function.
    	     *
    	     * **Note:** The cache is exposed as the `cache` property on the memoized
    	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
    	     * constructor with one whose instances implement the
    	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
    	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Function
    	     * @param {Function} func The function to have its output memoized.
    	     * @param {Function} [resolver] The function to resolve the cache key.
    	     * @returns {Function} Returns the new memoized function.
    	     * @example
    	     *
    	     * var object = { 'a': 1, 'b': 2 };
    	     * var other = { 'c': 3, 'd': 4 };
    	     *
    	     * var values = _.memoize(_.values);
    	     * values(object);
    	     * // => [1, 2]
    	     *
    	     * values(other);
    	     * // => [3, 4]
    	     *
    	     * object.a = 2;
    	     * values(object);
    	     * // => [1, 2]
    	     *
    	     * // Modify the result cache.
    	     * values.cache.set(object, ['a', 'b']);
    	     * values(object);
    	     * // => ['a', 'b']
    	     *
    	     * // Replace `_.memoize.Cache`.
    	     * _.memoize.Cache = WeakMap;
    	     */
    function memoize(func,resolver){
    if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized=function(){
    var args=arguments,
    key=resolver?resolver.apply(this,args):args[0],
    cache=memoized.cache;

    if(cache.has(key)){
    return cache.get(key);
    }
    var result=func.apply(this,args);
    memoized.cache=cache.set(key,result)||cache;
    return result;
    };
    memoized.cache=new(memoize.Cache||MapCache)();
    return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache=MapCache;

    /**
    	     * Creates a function that negates the result of the predicate `func`. The
    	     * `func` predicate is invoked with the `this` binding and arguments of the
    	     * created function.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Function
    	     * @param {Function} predicate The predicate to negate.
    	     * @returns {Function} Returns the new negated function.
    	     * @example
    	     *
    	     * function isEven(n) {
    	     *   return n % 2 == 0;
    	     * }
    	     *
    	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
    	     * // => [1, 3, 5]
    	     */
    function negate(predicate){
    if(typeof predicate!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    return function(){
    var args=arguments;
    switch(args.length){
    case 0:return !predicate.call(this);
    case 1:return !predicate.call(this,args[0]);
    case 2:return !predicate.call(this,args[0],args[1]);
    case 3:return !predicate.call(this,args[0],args[1],args[2]);}

    return !predicate.apply(this,args);
    };
    }

    /**
    	     * Creates a function that is restricted to invoking `func` once. Repeat calls
    	     * to the function return the value of the first invocation. The `func` is
    	     * invoked with the `this` binding and arguments of the created function.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Function
    	     * @param {Function} func The function to restrict.
    	     * @returns {Function} Returns the new restricted function.
    	     * @example
    	     *
    	     * var initialize = _.once(createApplication);
    	     * initialize();
    	     * initialize();
    	     * // => `createApplication` is invoked once
    	     */
    function once(func){
    return before(2,func);
    }

    /**
    	     * Creates a function that invokes `func` with its arguments transformed.
    	     *
    	     * @static
    	     * @since 4.0.0
    	     * @memberOf _
    	     * @category Function
    	     * @param {Function} func The function to wrap.
    	     * @param {...(Function|Function[])} [transforms=[_.identity]]
    	     *  The argument transforms.
    	     * @returns {Function} Returns the new function.
    	     * @example
    	     *
    	     * function doubled(n) {
    	     *   return n * 2;
    	     * }
    	     *
    	     * function square(n) {
    	     *   return n * n;
    	     * }
    	     *
    	     * var func = _.overArgs(function(x, y) {
    	     *   return [x, y];
    	     * }, [square, doubled]);
    	     *
    	     * func(9, 3);
    	     * // => [81, 6]
    	     *
    	     * func(10, 5);
    	     * // => [100, 10]
    	     */
    var overArgs=castRest(function(func,transforms){
    transforms=transforms.length==1&&isArray(transforms[0])?
    arrayMap(transforms[0],baseUnary(getIteratee())):
    arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));

    var funcsLength=transforms.length;
    return baseRest(function(args){
    var index=-1,
    length=nativeMin(args.length,funcsLength);

    while(++index<length){
    args[index]=transforms[index].call(this,args[index]);
    }
    return apply(func,this,args);
    });
    });

    /**
    	     * Creates a function that invokes `func` with `partials` prepended to the
    	     * arguments it receives. This method is like `_.bind` except it does **not**
    	     * alter the `this` binding.
    	     *
    	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
    	     * builds, may be used as a placeholder for partially applied arguments.
    	     *
    	     * **Note:** This method doesn't set the "length" property of partially
    	     * applied functions.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.2.0
    	     * @category Function
    	     * @param {Function} func The function to partially apply arguments to.
    	     * @param {...*} [partials] The arguments to be partially applied.
    	     * @returns {Function} Returns the new partially applied function.
    	     * @example
    	     *
    	     * function greet(greeting, name) {
    	     *   return greeting + ' ' + name;
    	     * }
    	     *
    	     * var sayHelloTo = _.partial(greet, 'hello');
    	     * sayHelloTo('fred');
    	     * // => 'hello fred'
    	     *
    	     * // Partially applied with placeholders.
    	     * var greetFred = _.partial(greet, _, 'fred');
    	     * greetFred('hi');
    	     * // => 'hi fred'
    	     */
    var partial=baseRest(function(func,partials){
    var holders=replaceHolders(partials,getHolder(partial));
    return createWrap(func,WRAP_PARTIAL_FLAG,undefined$1,partials,holders);
    });

    /**
    	     * This method is like `_.partial` except that partially applied arguments
    	     * are appended to the arguments it receives.
    	     *
    	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
    	     * builds, may be used as a placeholder for partially applied arguments.
    	     *
    	     * **Note:** This method doesn't set the "length" property of partially
    	     * applied functions.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 1.0.0
    	     * @category Function
    	     * @param {Function} func The function to partially apply arguments to.
    	     * @param {...*} [partials] The arguments to be partially applied.
    	     * @returns {Function} Returns the new partially applied function.
    	     * @example
    	     *
    	     * function greet(greeting, name) {
    	     *   return greeting + ' ' + name;
    	     * }
    	     *
    	     * var greetFred = _.partialRight(greet, 'fred');
    	     * greetFred('hi');
    	     * // => 'hi fred'
    	     *
    	     * // Partially applied with placeholders.
    	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
    	     * sayHelloTo('fred');
    	     * // => 'hello fred'
    	     */
    var partialRight=baseRest(function(func,partials){
    var holders=replaceHolders(partials,getHolder(partialRight));
    return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined$1,partials,holders);
    });

    /**
    	     * Creates a function that invokes `func` with arguments arranged according
    	     * to the specified `indexes` where the argument value at the first index is
    	     * provided as the first argument, the argument value at the second index is
    	     * provided as the second argument, and so on.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Function
    	     * @param {Function} func The function to rearrange arguments for.
    	     * @param {...(number|number[])} indexes The arranged argument indexes.
    	     * @returns {Function} Returns the new function.
    	     * @example
    	     *
    	     * var rearged = _.rearg(function(a, b, c) {
    	     *   return [a, b, c];
    	     * }, [2, 0, 1]);
    	     *
    	     * rearged('b', 'c', 'a')
    	     * // => ['a', 'b', 'c']
    	     */
    var rearg=flatRest(function(func,indexes){
    return createWrap(func,WRAP_REARG_FLAG,undefined$1,undefined$1,undefined$1,indexes);
    });

    /**
    	     * Creates a function that invokes `func` with the `this` binding of the
    	     * created function and arguments from `start` and beyond provided as
    	     * an array.
    	     *
    	     * **Note:** This method is based on the
    	     * [rest parameter](https://mdn.io/rest_parameters).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Function
    	     * @param {Function} func The function to apply a rest parameter to.
    	     * @param {number} [start=func.length-1] The start position of the rest parameter.
    	     * @returns {Function} Returns the new function.
    	     * @example
    	     *
    	     * var say = _.rest(function(what, names) {
    	     *   return what + ' ' + _.initial(names).join(', ') +
    	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
    	     * });
    	     *
    	     * say('hello', 'fred', 'barney', 'pebbles');
    	     * // => 'hello fred, barney, & pebbles'
    	     */
    function rest(func,start){
    if(typeof func!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    start=start===undefined$1?start:toInteger(start);
    return baseRest(func,start);
    }

    /**
    	     * Creates a function that invokes `func` with the `this` binding of the
    	     * create function and an array of arguments much like
    	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
    	     *
    	     * **Note:** This method is based on the
    	     * [spread operator](https://mdn.io/spread_operator).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.2.0
    	     * @category Function
    	     * @param {Function} func The function to spread arguments over.
    	     * @param {number} [start=0] The start position of the spread.
    	     * @returns {Function} Returns the new function.
    	     * @example
    	     *
    	     * var say = _.spread(function(who, what) {
    	     *   return who + ' says ' + what;
    	     * });
    	     *
    	     * say(['fred', 'hello']);
    	     * // => 'fred says hello'
    	     *
    	     * var numbers = Promise.all([
    	     *   Promise.resolve(40),
    	     *   Promise.resolve(36)
    	     * ]);
    	     *
    	     * numbers.then(_.spread(function(x, y) {
    	     *   return x + y;
    	     * }));
    	     * // => a Promise of 76
    	     */
    function spread(func,start){
    if(typeof func!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    start=start==null?0:nativeMax(toInteger(start),0);
    return baseRest(function(args){
    var array=args[start],
    otherArgs=castSlice(args,0,start);

    if(array){
    arrayPush(otherArgs,array);
    }
    return apply(func,this,otherArgs);
    });
    }

    /**
    	     * Creates a throttled function that only invokes `func` at most once per
    	     * every `wait` milliseconds. The throttled function comes with a `cancel`
    	     * method to cancel delayed `func` invocations and a `flush` method to
    	     * immediately invoke them. Provide `options` to indicate whether `func`
    	     * should be invoked on the leading and/or trailing edge of the `wait`
    	     * timeout. The `func` is invoked with the last arguments provided to the
    	     * throttled function. Subsequent calls to the throttled function return the
    	     * result of the last `func` invocation.
    	     *
    	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
    	     * invoked on the trailing edge of the timeout only if the throttled function
    	     * is invoked more than once during the `wait` timeout.
    	     *
    	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
    	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
    	     *
    	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
    	     * for details over the differences between `_.throttle` and `_.debounce`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Function
    	     * @param {Function} func The function to throttle.
    	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
    	     * @param {Object} [options={}] The options object.
    	     * @param {boolean} [options.leading=true]
    	     *  Specify invoking on the leading edge of the timeout.
    	     * @param {boolean} [options.trailing=true]
    	     *  Specify invoking on the trailing edge of the timeout.
    	     * @returns {Function} Returns the new throttled function.
    	     * @example
    	     *
    	     * // Avoid excessively updating the position while scrolling.
    	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
    	     *
    	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
    	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
    	     * jQuery(element).on('click', throttled);
    	     *
    	     * // Cancel the trailing throttled invocation.
    	     * jQuery(window).on('popstate', throttled.cancel);
    	     */
    function throttle(func,wait,options){
    var leading=true,
    trailing=true;

    if(typeof func!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    if(isObject(options)){
    leading='leading'in options?!!options.leading:leading;
    trailing='trailing'in options?!!options.trailing:trailing;
    }
    return debounce(func,wait,{
    'leading':leading,
    'maxWait':wait,
    'trailing':trailing});

    }

    /**
    	     * Creates a function that accepts up to one argument, ignoring any
    	     * additional arguments.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Function
    	     * @param {Function} func The function to cap arguments for.
    	     * @returns {Function} Returns the new capped function.
    	     * @example
    	     *
    	     * _.map(['6', '8', '10'], _.unary(parseInt));
    	     * // => [6, 8, 10]
    	     */
    function unary(func){
    return ary(func,1);
    }

    /**
    	     * Creates a function that provides `value` to `wrapper` as its first
    	     * argument. Any additional arguments provided to the function are appended
    	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
    	     * binding of the created function.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Function
    	     * @param {*} value The value to wrap.
    	     * @param {Function} [wrapper=identity] The wrapper function.
    	     * @returns {Function} Returns the new function.
    	     * @example
    	     *
    	     * var p = _.wrap(_.escape, function(func, text) {
    	     *   return '<p>' + func(text) + '</p>';
    	     * });
    	     *
    	     * p('fred, barney, & pebbles');
    	     * // => '<p>fred, barney, &amp; pebbles</p>'
    	     */
    function wrap(value,wrapper){
    return partial(castFunction(wrapper),value);
    }

    /*------------------------------------------------------------------------*/

    /**
    	     * Casts `value` as an array if it's not one.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.4.0
    	     * @category Lang
    	     * @param {*} value The value to inspect.
    	     * @returns {Array} Returns the cast array.
    	     * @example
    	     *
    	     * _.castArray(1);
    	     * // => [1]
    	     *
    	     * _.castArray({ 'a': 1 });
    	     * // => [{ 'a': 1 }]
    	     *
    	     * _.castArray('abc');
    	     * // => ['abc']
    	     *
    	     * _.castArray(null);
    	     * // => [null]
    	     *
    	     * _.castArray(undefined);
    	     * // => [undefined]
    	     *
    	     * _.castArray();
    	     * // => []
    	     *
    	     * var array = [1, 2, 3];
    	     * console.log(_.castArray(array) === array);
    	     * // => true
    	     */
    function castArray(){
    if(!arguments.length){
    return [];
    }
    var value=arguments[0];
    return isArray(value)?value:[value];
    }

    /**
    	     * Creates a shallow clone of `value`.
    	     *
    	     * **Note:** This method is loosely based on the
    	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
    	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
    	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
    	     * arrays. The own enumerable properties of `arguments` objects are cloned
    	     * as plain objects. An empty object is returned for uncloneable values such
    	     * as error objects, functions, DOM nodes, and WeakMaps.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to clone.
    	     * @returns {*} Returns the cloned value.
    	     * @see _.cloneDeep
    	     * @example
    	     *
    	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
    	     *
    	     * var shallow = _.clone(objects);
    	     * console.log(shallow[0] === objects[0]);
    	     * // => true
    	     */
    function clone(value){
    return baseClone(value,CLONE_SYMBOLS_FLAG);
    }

    /**
    	     * This method is like `_.clone` except that it accepts `customizer` which
    	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
    	     * cloning is handled by the method instead. The `customizer` is invoked with
    	     * up to four arguments; (value [, index|key, object, stack]).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to clone.
    	     * @param {Function} [customizer] The function to customize cloning.
    	     * @returns {*} Returns the cloned value.
    	     * @see _.cloneDeepWith
    	     * @example
    	     *
    	     * function customizer(value) {
    	     *   if (_.isElement(value)) {
    	     *     return value.cloneNode(false);
    	     *   }
    	     * }
    	     *
    	     * var el = _.cloneWith(document.body, customizer);
    	     *
    	     * console.log(el === document.body);
    	     * // => false
    	     * console.log(el.nodeName);
    	     * // => 'BODY'
    	     * console.log(el.childNodes.length);
    	     * // => 0
    	     */
    function cloneWith(value,customizer){
    customizer=typeof customizer=='function'?customizer:undefined$1;
    return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);
    }

    /**
    	     * This method is like `_.clone` except that it recursively clones `value`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 1.0.0
    	     * @category Lang
    	     * @param {*} value The value to recursively clone.
    	     * @returns {*} Returns the deep cloned value.
    	     * @see _.clone
    	     * @example
    	     *
    	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
    	     *
    	     * var deep = _.cloneDeep(objects);
    	     * console.log(deep[0] === objects[0]);
    	     * // => false
    	     */
    function cloneDeep(value){
    return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);
    }

    /**
    	     * This method is like `_.cloneWith` except that it recursively clones `value`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to recursively clone.
    	     * @param {Function} [customizer] The function to customize cloning.
    	     * @returns {*} Returns the deep cloned value.
    	     * @see _.cloneWith
    	     * @example
    	     *
    	     * function customizer(value) {
    	     *   if (_.isElement(value)) {
    	     *     return value.cloneNode(true);
    	     *   }
    	     * }
    	     *
    	     * var el = _.cloneDeepWith(document.body, customizer);
    	     *
    	     * console.log(el === document.body);
    	     * // => false
    	     * console.log(el.nodeName);
    	     * // => 'BODY'
    	     * console.log(el.childNodes.length);
    	     * // => 20
    	     */
    function cloneDeepWith(value,customizer){
    customizer=typeof customizer=='function'?customizer:undefined$1;
    return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);
    }

    /**
    	     * Checks if `object` conforms to `source` by invoking the predicate
    	     * properties of `source` with the corresponding property values of `object`.
    	     *
    	     * **Note:** This method is equivalent to `_.conforms` when `source` is
    	     * partially applied.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.14.0
    	     * @category Lang
    	     * @param {Object} object The object to inspect.
    	     * @param {Object} source The object of property predicates to conform to.
    	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
    	     * @example
    	     *
    	     * var object = { 'a': 1, 'b': 2 };
    	     *
    	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
    	     * // => true
    	     *
    	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
    	     * // => false
    	     */
    function conformsTo(object,source){
    return source==null||baseConformsTo(object,source,keys(source));
    }

    /**
    	     * Performs a
    	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
    	     * comparison between two values to determine if they are equivalent.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to compare.
    	     * @param {*} other The other value to compare.
    	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
    	     * @example
    	     *
    	     * var object = { 'a': 1 };
    	     * var other = { 'a': 1 };
    	     *
    	     * _.eq(object, object);
    	     * // => true
    	     *
    	     * _.eq(object, other);
    	     * // => false
    	     *
    	     * _.eq('a', 'a');
    	     * // => true
    	     *
    	     * _.eq('a', Object('a'));
    	     * // => false
    	     *
    	     * _.eq(NaN, NaN);
    	     * // => true
    	     */
    function eq(value,other){
    return value===other||value!==value&&other!==other;
    }

    /**
    	     * Checks if `value` is greater than `other`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.9.0
    	     * @category Lang
    	     * @param {*} value The value to compare.
    	     * @param {*} other The other value to compare.
    	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
    	     *  else `false`.
    	     * @see _.lt
    	     * @example
    	     *
    	     * _.gt(3, 1);
    	     * // => true
    	     *
    	     * _.gt(3, 3);
    	     * // => false
    	     *
    	     * _.gt(1, 3);
    	     * // => false
    	     */
    var gt=createRelationalOperation(baseGt);

    /**
    	     * Checks if `value` is greater than or equal to `other`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.9.0
    	     * @category Lang
    	     * @param {*} value The value to compare.
    	     * @param {*} other The other value to compare.
    	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
    	     *  `other`, else `false`.
    	     * @see _.lte
    	     * @example
    	     *
    	     * _.gte(3, 1);
    	     * // => true
    	     *
    	     * _.gte(3, 3);
    	     * // => true
    	     *
    	     * _.gte(1, 3);
    	     * // => false
    	     */
    var gte=createRelationalOperation(function(value,other){
    return value>=other;
    });

    /**
    	     * Checks if `value` is likely an `arguments` object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
    	     *  else `false`.
    	     * @example
    	     *
    	     * _.isArguments(function() { return arguments; }());
    	     * // => true
    	     *
    	     * _.isArguments([1, 2, 3]);
    	     * // => false
    	     */
    var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){
    return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&
    !propertyIsEnumerable.call(value,'callee');
    };

    /**
    	     * Checks if `value` is classified as an `Array` object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
    	     * @example
    	     *
    	     * _.isArray([1, 2, 3]);
    	     * // => true
    	     *
    	     * _.isArray(document.body.children);
    	     * // => false
    	     *
    	     * _.isArray('abc');
    	     * // => false
    	     *
    	     * _.isArray(_.noop);
    	     * // => false
    	     */
    var isArray=Array.isArray;

    /**
    	     * Checks if `value` is classified as an `ArrayBuffer` object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.3.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
    	     * @example
    	     *
    	     * _.isArrayBuffer(new ArrayBuffer(2));
    	     * // => true
    	     *
    	     * _.isArrayBuffer(new Array(2));
    	     * // => false
    	     */
    var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;

    /**
    	     * Checks if `value` is array-like. A value is considered array-like if it's
    	     * not a function and has a `value.length` that's an integer greater than or
    	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
    	     * @example
    	     *
    	     * _.isArrayLike([1, 2, 3]);
    	     * // => true
    	     *
    	     * _.isArrayLike(document.body.children);
    	     * // => true
    	     *
    	     * _.isArrayLike('abc');
    	     * // => true
    	     *
    	     * _.isArrayLike(_.noop);
    	     * // => false
    	     */
    function isArrayLike(value){
    return value!=null&&isLength(value.length)&&!isFunction(value);
    }

    /**
    	     * This method is like `_.isArrayLike` except that it also checks if `value`
    	     * is an object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is an array-like object,
    	     *  else `false`.
    	     * @example
    	     *
    	     * _.isArrayLikeObject([1, 2, 3]);
    	     * // => true
    	     *
    	     * _.isArrayLikeObject(document.body.children);
    	     * // => true
    	     *
    	     * _.isArrayLikeObject('abc');
    	     * // => false
    	     *
    	     * _.isArrayLikeObject(_.noop);
    	     * // => false
    	     */
    function isArrayLikeObject(value){
    return isObjectLike(value)&&isArrayLike(value);
    }

    /**
    	     * Checks if `value` is classified as a boolean primitive or object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
    	     * @example
    	     *
    	     * _.isBoolean(false);
    	     * // => true
    	     *
    	     * _.isBoolean(null);
    	     * // => false
    	     */
    function isBoolean(value){
    return value===true||value===false||
    isObjectLike(value)&&baseGetTag(value)==boolTag;
    }

    /**
    	     * Checks if `value` is a buffer.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.3.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
    	     * @example
    	     *
    	     * _.isBuffer(new Buffer(2));
    	     * // => true
    	     *
    	     * _.isBuffer(new Uint8Array(2));
    	     * // => false
    	     */
    var isBuffer=nativeIsBuffer||stubFalse;

    /**
    	     * Checks if `value` is classified as a `Date` object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
    	     * @example
    	     *
    	     * _.isDate(new Date);
    	     * // => true
    	     *
    	     * _.isDate('Mon April 23 2012');
    	     * // => false
    	     */
    var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;

    /**
    	     * Checks if `value` is likely a DOM element.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
    	     * @example
    	     *
    	     * _.isElement(document.body);
    	     * // => true
    	     *
    	     * _.isElement('<body>');
    	     * // => false
    	     */
    function isElement(value){
    return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);
    }

    /**
    	     * Checks if `value` is an empty object, collection, map, or set.
    	     *
    	     * Objects are considered empty if they have no own enumerable string keyed
    	     * properties.
    	     *
    	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
    	     * jQuery-like collections are considered empty if they have a `length` of `0`.
    	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
    	     * @example
    	     *
    	     * _.isEmpty(null);
    	     * // => true
    	     *
    	     * _.isEmpty(true);
    	     * // => true
    	     *
    	     * _.isEmpty(1);
    	     * // => true
    	     *
    	     * _.isEmpty([1, 2, 3]);
    	     * // => false
    	     *
    	     * _.isEmpty({ 'a': 1 });
    	     * // => false
    	     */
    function isEmpty(value){
    if(value==null){
    return true;
    }
    if(isArrayLike(value)&&(
    isArray(value)||typeof value=='string'||typeof value.splice=='function'||
    isBuffer(value)||isTypedArray(value)||isArguments(value))){
    return !value.length;
    }
    var tag=getTag(value);
    if(tag==mapTag||tag==setTag){
    return !value.size;
    }
    if(isPrototype(value)){
    return !baseKeys(value).length;
    }
    for(var key in value){
    if(hasOwnProperty.call(value,key)){
    return false;
    }
    }
    return true;
    }

    /**
    	     * Performs a deep comparison between two values to determine if they are
    	     * equivalent.
    	     *
    	     * **Note:** This method supports comparing arrays, array buffers, booleans,
    	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
    	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
    	     * by their own, not inherited, enumerable properties. Functions and DOM
    	     * nodes are compared by strict equality, i.e. `===`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to compare.
    	     * @param {*} other The other value to compare.
    	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
    	     * @example
    	     *
    	     * var object = { 'a': 1 };
    	     * var other = { 'a': 1 };
    	     *
    	     * _.isEqual(object, other);
    	     * // => true
    	     *
    	     * object === other;
    	     * // => false
    	     */
    function isEqual(value,other){
    return baseIsEqual(value,other);
    }

    /**
    	     * This method is like `_.isEqual` except that it accepts `customizer` which
    	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
    	     * are handled by the method instead. The `customizer` is invoked with up to
    	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to compare.
    	     * @param {*} other The other value to compare.
    	     * @param {Function} [customizer] The function to customize comparisons.
    	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
    	     * @example
    	     *
    	     * function isGreeting(value) {
    	     *   return /^h(?:i|ello)$/.test(value);
    	     * }
    	     *
    	     * function customizer(objValue, othValue) {
    	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
    	     *     return true;
    	     *   }
    	     * }
    	     *
    	     * var array = ['hello', 'goodbye'];
    	     * var other = ['hi', 'goodbye'];
    	     *
    	     * _.isEqualWith(array, other, customizer);
    	     * // => true
    	     */
    function isEqualWith(value,other,customizer){
    customizer=typeof customizer=='function'?customizer:undefined$1;
    var result=customizer?customizer(value,other):undefined$1;
    return result===undefined$1?baseIsEqual(value,other,undefined$1,customizer):!!result;
    }

    /**
    	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
    	     * `SyntaxError`, `TypeError`, or `URIError` object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
    	     * @example
    	     *
    	     * _.isError(new Error);
    	     * // => true
    	     *
    	     * _.isError(Error);
    	     * // => false
    	     */
    function isError(value){
    if(!isObjectLike(value)){
    return false;
    }
    var tag=baseGetTag(value);
    return tag==errorTag||tag==domExcTag||
    typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);
    }

    /**
    	     * Checks if `value` is a finite primitive number.
    	     *
    	     * **Note:** This method is based on
    	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
    	     * @example
    	     *
    	     * _.isFinite(3);
    	     * // => true
    	     *
    	     * _.isFinite(Number.MIN_VALUE);
    	     * // => true
    	     *
    	     * _.isFinite(Infinity);
    	     * // => false
    	     *
    	     * _.isFinite('3');
    	     * // => false
    	     */
    function isFinite(value){
    return typeof value=='number'&&nativeIsFinite(value);
    }

    /**
    	     * Checks if `value` is classified as a `Function` object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
    	     * @example
    	     *
    	     * _.isFunction(_);
    	     * // => true
    	     *
    	     * _.isFunction(/abc/);
    	     * // => false
    	     */
    function isFunction(value){
    if(!isObject(value)){
    return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag=baseGetTag(value);
    return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;
    }

    /**
    	     * Checks if `value` is an integer.
    	     *
    	     * **Note:** This method is based on
    	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
    	     * @example
    	     *
    	     * _.isInteger(3);
    	     * // => true
    	     *
    	     * _.isInteger(Number.MIN_VALUE);
    	     * // => false
    	     *
    	     * _.isInteger(Infinity);
    	     * // => false
    	     *
    	     * _.isInteger('3');
    	     * // => false
    	     */
    function isInteger(value){
    return typeof value=='number'&&value==toInteger(value);
    }

    /**
    	     * Checks if `value` is a valid array-like length.
    	     *
    	     * **Note:** This method is loosely based on
    	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
    	     * @example
    	     *
    	     * _.isLength(3);
    	     * // => true
    	     *
    	     * _.isLength(Number.MIN_VALUE);
    	     * // => false
    	     *
    	     * _.isLength(Infinity);
    	     * // => false
    	     *
    	     * _.isLength('3');
    	     * // => false
    	     */
    function isLength(value){
    return typeof value=='number'&&
    value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;
    }

    /**
    	     * Checks if `value` is the
    	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
    	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
    	     * @example
    	     *
    	     * _.isObject({});
    	     * // => true
    	     *
    	     * _.isObject([1, 2, 3]);
    	     * // => true
    	     *
    	     * _.isObject(_.noop);
    	     * // => true
    	     *
    	     * _.isObject(null);
    	     * // => false
    	     */
    function isObject(value){
    var type=typeof value;
    return value!=null&&(type=='object'||type=='function');
    }

    /**
    	     * Checks if `value` is object-like. A value is object-like if it's not `null`
    	     * and has a `typeof` result of "object".
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
    	     * @example
    	     *
    	     * _.isObjectLike({});
    	     * // => true
    	     *
    	     * _.isObjectLike([1, 2, 3]);
    	     * // => true
    	     *
    	     * _.isObjectLike(_.noop);
    	     * // => false
    	     *
    	     * _.isObjectLike(null);
    	     * // => false
    	     */
    function isObjectLike(value){
    return value!=null&&typeof value=='object';
    }

    /**
    	     * Checks if `value` is classified as a `Map` object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.3.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
    	     * @example
    	     *
    	     * _.isMap(new Map);
    	     * // => true
    	     *
    	     * _.isMap(new WeakMap);
    	     * // => false
    	     */
    var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;

    /**
    	     * Performs a partial deep comparison between `object` and `source` to
    	     * determine if `object` contains equivalent property values.
    	     *
    	     * **Note:** This method is equivalent to `_.matches` when `source` is
    	     * partially applied.
    	     *
    	     * Partial comparisons will match empty array and empty object `source`
    	     * values against any array or object value, respectively. See `_.isEqual`
    	     * for a list of supported value comparisons.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Lang
    	     * @param {Object} object The object to inspect.
    	     * @param {Object} source The object of property values to match.
    	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
    	     * @example
    	     *
    	     * var object = { 'a': 1, 'b': 2 };
    	     *
    	     * _.isMatch(object, { 'b': 2 });
    	     * // => true
    	     *
    	     * _.isMatch(object, { 'b': 1 });
    	     * // => false
    	     */
    function isMatch(object,source){
    return object===source||baseIsMatch(object,source,getMatchData(source));
    }

    /**
    	     * This method is like `_.isMatch` except that it accepts `customizer` which
    	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
    	     * are handled by the method instead. The `customizer` is invoked with five
    	     * arguments: (objValue, srcValue, index|key, object, source).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {Object} object The object to inspect.
    	     * @param {Object} source The object of property values to match.
    	     * @param {Function} [customizer] The function to customize comparisons.
    	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
    	     * @example
    	     *
    	     * function isGreeting(value) {
    	     *   return /^h(?:i|ello)$/.test(value);
    	     * }
    	     *
    	     * function customizer(objValue, srcValue) {
    	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
    	     *     return true;
    	     *   }
    	     * }
    	     *
    	     * var object = { 'greeting': 'hello' };
    	     * var source = { 'greeting': 'hi' };
    	     *
    	     * _.isMatchWith(object, source, customizer);
    	     * // => true
    	     */
    function isMatchWith(object,source,customizer){
    customizer=typeof customizer=='function'?customizer:undefined$1;
    return baseIsMatch(object,source,getMatchData(source),customizer);
    }

    /**
    	     * Checks if `value` is `NaN`.
    	     *
    	     * **Note:** This method is based on
    	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
    	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
    	     * `undefined` and other non-number values.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
    	     * @example
    	     *
    	     * _.isNaN(NaN);
    	     * // => true
    	     *
    	     * _.isNaN(new Number(NaN));
    	     * // => true
    	     *
    	     * isNaN(undefined);
    	     * // => true
    	     *
    	     * _.isNaN(undefined);
    	     * // => false
    	     */
    function isNaN(value){
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return isNumber(value)&&value!=+value;
    }

    /**
    	     * Checks if `value` is a pristine native function.
    	     *
    	     * **Note:** This method can't reliably detect native functions in the presence
    	     * of the core-js package because core-js circumvents this kind of detection.
    	     * Despite multiple requests, the core-js maintainer has made it clear: any
    	     * attempt to fix the detection will be obstructed. As a result, we're left
    	     * with little choice but to throw an error. Unfortunately, this also affects
    	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
    	     * which rely on core-js.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a native function,
    	     *  else `false`.
    	     * @example
    	     *
    	     * _.isNative(Array.prototype.push);
    	     * // => true
    	     *
    	     * _.isNative(_);
    	     * // => false
    	     */
    function isNative(value){
    if(isMaskable(value)){
    throw new Error(CORE_ERROR_TEXT);
    }
    return baseIsNative(value);
    }

    /**
    	     * Checks if `value` is `null`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
    	     * @example
    	     *
    	     * _.isNull(null);
    	     * // => true
    	     *
    	     * _.isNull(void 0);
    	     * // => false
    	     */
    function isNull(value){
    return value===null;
    }

    /**
    	     * Checks if `value` is `null` or `undefined`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
    	     * @example
    	     *
    	     * _.isNil(null);
    	     * // => true
    	     *
    	     * _.isNil(void 0);
    	     * // => true
    	     *
    	     * _.isNil(NaN);
    	     * // => false
    	     */
    function isNil(value){
    return value==null;
    }

    /**
    	     * Checks if `value` is classified as a `Number` primitive or object.
    	     *
    	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
    	     * classified as numbers, use the `_.isFinite` method.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
    	     * @example
    	     *
    	     * _.isNumber(3);
    	     * // => true
    	     *
    	     * _.isNumber(Number.MIN_VALUE);
    	     * // => true
    	     *
    	     * _.isNumber(Infinity);
    	     * // => true
    	     *
    	     * _.isNumber('3');
    	     * // => false
    	     */
    function isNumber(value){
    return typeof value=='number'||
    isObjectLike(value)&&baseGetTag(value)==numberTag;
    }

    /**
    	     * Checks if `value` is a plain object, that is, an object created by the
    	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.8.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     * }
    	     *
    	     * _.isPlainObject(new Foo);
    	     * // => false
    	     *
    	     * _.isPlainObject([1, 2, 3]);
    	     * // => false
    	     *
    	     * _.isPlainObject({ 'x': 0, 'y': 0 });
    	     * // => true
    	     *
    	     * _.isPlainObject(Object.create(null));
    	     * // => true
    	     */
    function isPlainObject(value){
    if(!isObjectLike(value)||baseGetTag(value)!=objectTag){
    return false;
    }
    var proto=getPrototype(value);
    if(proto===null){
    return true;
    }
    var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;
    return typeof Ctor=='function'&&Ctor instanceof Ctor&&
    funcToString.call(Ctor)==objectCtorString;
    }

    /**
    	     * Checks if `value` is classified as a `RegExp` object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.1.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
    	     * @example
    	     *
    	     * _.isRegExp(/abc/);
    	     * // => true
    	     *
    	     * _.isRegExp('/abc/');
    	     * // => false
    	     */
    var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;

    /**
    	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
    	     * double precision number which isn't the result of a rounded unsafe integer.
    	     *
    	     * **Note:** This method is based on
    	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
    	     * @example
    	     *
    	     * _.isSafeInteger(3);
    	     * // => true
    	     *
    	     * _.isSafeInteger(Number.MIN_VALUE);
    	     * // => false
    	     *
    	     * _.isSafeInteger(Infinity);
    	     * // => false
    	     *
    	     * _.isSafeInteger('3');
    	     * // => false
    	     */
    function isSafeInteger(value){
    return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;
    }

    /**
    	     * Checks if `value` is classified as a `Set` object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.3.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
    	     * @example
    	     *
    	     * _.isSet(new Set);
    	     * // => true
    	     *
    	     * _.isSet(new WeakSet);
    	     * // => false
    	     */
    var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;

    /**
    	     * Checks if `value` is classified as a `String` primitive or object.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
    	     * @example
    	     *
    	     * _.isString('abc');
    	     * // => true
    	     *
    	     * _.isString(1);
    	     * // => false
    	     */
    function isString(value){
    return typeof value=='string'||
    !isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;
    }

    /**
    	     * Checks if `value` is classified as a `Symbol` primitive or object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
    	     * @example
    	     *
    	     * _.isSymbol(Symbol.iterator);
    	     * // => true
    	     *
    	     * _.isSymbol('abc');
    	     * // => false
    	     */
    function isSymbol(value){
    return typeof value=='symbol'||
    isObjectLike(value)&&baseGetTag(value)==symbolTag;
    }

    /**
    	     * Checks if `value` is classified as a typed array.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
    	     * @example
    	     *
    	     * _.isTypedArray(new Uint8Array);
    	     * // => true
    	     *
    	     * _.isTypedArray([]);
    	     * // => false
    	     */
    var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;

    /**
    	     * Checks if `value` is `undefined`.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
    	     * @example
    	     *
    	     * _.isUndefined(void 0);
    	     * // => true
    	     *
    	     * _.isUndefined(null);
    	     * // => false
    	     */
    function isUndefined(value){
    return value===undefined$1;
    }

    /**
    	     * Checks if `value` is classified as a `WeakMap` object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.3.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
    	     * @example
    	     *
    	     * _.isWeakMap(new WeakMap);
    	     * // => true
    	     *
    	     * _.isWeakMap(new Map);
    	     * // => false
    	     */
    function isWeakMap(value){
    return isObjectLike(value)&&getTag(value)==weakMapTag;
    }

    /**
    	     * Checks if `value` is classified as a `WeakSet` object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.3.0
    	     * @category Lang
    	     * @param {*} value The value to check.
    	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
    	     * @example
    	     *
    	     * _.isWeakSet(new WeakSet);
    	     * // => true
    	     *
    	     * _.isWeakSet(new Set);
    	     * // => false
    	     */
    function isWeakSet(value){
    return isObjectLike(value)&&baseGetTag(value)==weakSetTag;
    }

    /**
    	     * Checks if `value` is less than `other`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.9.0
    	     * @category Lang
    	     * @param {*} value The value to compare.
    	     * @param {*} other The other value to compare.
    	     * @returns {boolean} Returns `true` if `value` is less than `other`,
    	     *  else `false`.
    	     * @see _.gt
    	     * @example
    	     *
    	     * _.lt(1, 3);
    	     * // => true
    	     *
    	     * _.lt(3, 3);
    	     * // => false
    	     *
    	     * _.lt(3, 1);
    	     * // => false
    	     */
    var lt=createRelationalOperation(baseLt);

    /**
    	     * Checks if `value` is less than or equal to `other`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.9.0
    	     * @category Lang
    	     * @param {*} value The value to compare.
    	     * @param {*} other The other value to compare.
    	     * @returns {boolean} Returns `true` if `value` is less than or equal to
    	     *  `other`, else `false`.
    	     * @see _.gte
    	     * @example
    	     *
    	     * _.lte(1, 3);
    	     * // => true
    	     *
    	     * _.lte(3, 3);
    	     * // => true
    	     *
    	     * _.lte(3, 1);
    	     * // => false
    	     */
    var lte=createRelationalOperation(function(value,other){
    return value<=other;
    });

    /**
    	     * Converts `value` to an array.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Lang
    	     * @param {*} value The value to convert.
    	     * @returns {Array} Returns the converted array.
    	     * @example
    	     *
    	     * _.toArray({ 'a': 1, 'b': 2 });
    	     * // => [1, 2]
    	     *
    	     * _.toArray('abc');
    	     * // => ['a', 'b', 'c']
    	     *
    	     * _.toArray(1);
    	     * // => []
    	     *
    	     * _.toArray(null);
    	     * // => []
    	     */
    function toArray(value){
    if(!value){
    return [];
    }
    if(isArrayLike(value)){
    return isString(value)?stringToArray(value):copyArray(value);
    }
    if(symIterator&&value[symIterator]){
    return iteratorToArray(value[symIterator]());
    }
    var tag=getTag(value),
    func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;

    return func(value);
    }

    /**
    	     * Converts `value` to a finite number.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.12.0
    	     * @category Lang
    	     * @param {*} value The value to convert.
    	     * @returns {number} Returns the converted number.
    	     * @example
    	     *
    	     * _.toFinite(3.2);
    	     * // => 3.2
    	     *
    	     * _.toFinite(Number.MIN_VALUE);
    	     * // => 5e-324
    	     *
    	     * _.toFinite(Infinity);
    	     * // => 1.7976931348623157e+308
    	     *
    	     * _.toFinite('3.2');
    	     * // => 3.2
    	     */
    function toFinite(value){
    if(!value){
    return value===0?value:0;
    }
    value=toNumber(value);
    if(value===INFINITY||value===-INFINITY){
    var sign=value<0?-1:1;
    return sign*MAX_INTEGER;
    }
    return value===value?value:0;
    }

    /**
    	     * Converts `value` to an integer.
    	     *
    	     * **Note:** This method is loosely based on
    	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to convert.
    	     * @returns {number} Returns the converted integer.
    	     * @example
    	     *
    	     * _.toInteger(3.2);
    	     * // => 3
    	     *
    	     * _.toInteger(Number.MIN_VALUE);
    	     * // => 0
    	     *
    	     * _.toInteger(Infinity);
    	     * // => 1.7976931348623157e+308
    	     *
    	     * _.toInteger('3.2');
    	     * // => 3
    	     */
    function toInteger(value){
    var result=toFinite(value),
    remainder=result%1;

    return result===result?remainder?result-remainder:result:0;
    }

    /**
    	     * Converts `value` to an integer suitable for use as the length of an
    	     * array-like object.
    	     *
    	     * **Note:** This method is based on
    	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to convert.
    	     * @returns {number} Returns the converted integer.
    	     * @example
    	     *
    	     * _.toLength(3.2);
    	     * // => 3
    	     *
    	     * _.toLength(Number.MIN_VALUE);
    	     * // => 0
    	     *
    	     * _.toLength(Infinity);
    	     * // => 4294967295
    	     *
    	     * _.toLength('3.2');
    	     * // => 3
    	     */
    function toLength(value){
    return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;
    }

    /**
    	     * Converts `value` to a number.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to process.
    	     * @returns {number} Returns the number.
    	     * @example
    	     *
    	     * _.toNumber(3.2);
    	     * // => 3.2
    	     *
    	     * _.toNumber(Number.MIN_VALUE);
    	     * // => 5e-324
    	     *
    	     * _.toNumber(Infinity);
    	     * // => Infinity
    	     *
    	     * _.toNumber('3.2');
    	     * // => 3.2
    	     */
    function toNumber(value){
    if(typeof value=='number'){
    return value;
    }
    if(isSymbol(value)){
    return NAN;
    }
    if(isObject(value)){
    var other=typeof value.valueOf=='function'?value.valueOf():value;
    value=isObject(other)?other+'':other;
    }
    if(typeof value!='string'){
    return value===0?value:+value;
    }
    value=baseTrim(value);
    var isBinary=reIsBinary.test(value);
    return isBinary||reIsOctal.test(value)?
    freeParseInt(value.slice(2),isBinary?2:8):
    reIsBadHex.test(value)?NAN:+value;
    }

    /**
    	     * Converts `value` to a plain object flattening inherited enumerable string
    	     * keyed properties of `value` to own properties of the plain object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Lang
    	     * @param {*} value The value to convert.
    	     * @returns {Object} Returns the converted plain object.
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.b = 2;
    	     * }
    	     *
    	     * Foo.prototype.c = 3;
    	     *
    	     * _.assign({ 'a': 1 }, new Foo);
    	     * // => { 'a': 1, 'b': 2 }
    	     *
    	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
    	     * // => { 'a': 1, 'b': 2, 'c': 3 }
    	     */
    function toPlainObject(value){
    return copyObject(value,keysIn(value));
    }

    /**
    	     * Converts `value` to a safe integer. A safe integer can be compared and
    	     * represented correctly.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to convert.
    	     * @returns {number} Returns the converted integer.
    	     * @example
    	     *
    	     * _.toSafeInteger(3.2);
    	     * // => 3
    	     *
    	     * _.toSafeInteger(Number.MIN_VALUE);
    	     * // => 0
    	     *
    	     * _.toSafeInteger(Infinity);
    	     * // => 9007199254740991
    	     *
    	     * _.toSafeInteger('3.2');
    	     * // => 3
    	     */
    function toSafeInteger(value){
    return value?
    baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):
    value===0?value:0;
    }

    /**
    	     * Converts `value` to a string. An empty string is returned for `null`
    	     * and `undefined` values. The sign of `-0` is preserved.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Lang
    	     * @param {*} value The value to convert.
    	     * @returns {string} Returns the converted string.
    	     * @example
    	     *
    	     * _.toString(null);
    	     * // => ''
    	     *
    	     * _.toString(-0);
    	     * // => '-0'
    	     *
    	     * _.toString([1, 2, 3]);
    	     * // => '1,2,3'
    	     */
    function toString(value){
    return value==null?'':baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
    	     * Assigns own enumerable string keyed properties of source objects to the
    	     * destination object. Source objects are applied from left to right.
    	     * Subsequent sources overwrite property assignments of previous sources.
    	     *
    	     * **Note:** This method mutates `object` and is loosely based on
    	     * [`Object.assign`](https://mdn.io/Object/assign).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.10.0
    	     * @category Object
    	     * @param {Object} object The destination object.
    	     * @param {...Object} [sources] The source objects.
    	     * @returns {Object} Returns `object`.
    	     * @see _.assignIn
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     * }
    	     *
    	     * function Bar() {
    	     *   this.c = 3;
    	     * }
    	     *
    	     * Foo.prototype.b = 2;
    	     * Bar.prototype.d = 4;
    	     *
    	     * _.assign({ 'a': 0 }, new Foo, new Bar);
    	     * // => { 'a': 1, 'c': 3 }
    	     */
    var assign=createAssigner(function(object,source){
    if(isPrototype(source)||isArrayLike(source)){
    copyObject(source,keys(source),object);
    return;
    }
    for(var key in source){
    if(hasOwnProperty.call(source,key)){
    assignValue(object,key,source[key]);
    }
    }
    });

    /**
    	     * This method is like `_.assign` except that it iterates over own and
    	     * inherited source properties.
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @alias extend
    	     * @category Object
    	     * @param {Object} object The destination object.
    	     * @param {...Object} [sources] The source objects.
    	     * @returns {Object} Returns `object`.
    	     * @see _.assign
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     * }
    	     *
    	     * function Bar() {
    	     *   this.c = 3;
    	     * }
    	     *
    	     * Foo.prototype.b = 2;
    	     * Bar.prototype.d = 4;
    	     *
    	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
    	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
    	     */
    var assignIn=createAssigner(function(object,source){
    copyObject(source,keysIn(source),object);
    });

    /**
    	     * This method is like `_.assignIn` except that it accepts `customizer`
    	     * which is invoked to produce the assigned values. If `customizer` returns
    	     * `undefined`, assignment is handled by the method instead. The `customizer`
    	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @alias extendWith
    	     * @category Object
    	     * @param {Object} object The destination object.
    	     * @param {...Object} sources The source objects.
    	     * @param {Function} [customizer] The function to customize assigned values.
    	     * @returns {Object} Returns `object`.
    	     * @see _.assignWith
    	     * @example
    	     *
    	     * function customizer(objValue, srcValue) {
    	     *   return _.isUndefined(objValue) ? srcValue : objValue;
    	     * }
    	     *
    	     * var defaults = _.partialRight(_.assignInWith, customizer);
    	     *
    	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
    	     * // => { 'a': 1, 'b': 2 }
    	     */
    var assignInWith=createAssigner(function(object,source,srcIndex,customizer){
    copyObject(source,keysIn(source),object,customizer);
    });

    /**
    	     * This method is like `_.assign` except that it accepts `customizer`
    	     * which is invoked to produce the assigned values. If `customizer` returns
    	     * `undefined`, assignment is handled by the method instead. The `customizer`
    	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Object
    	     * @param {Object} object The destination object.
    	     * @param {...Object} sources The source objects.
    	     * @param {Function} [customizer] The function to customize assigned values.
    	     * @returns {Object} Returns `object`.
    	     * @see _.assignInWith
    	     * @example
    	     *
    	     * function customizer(objValue, srcValue) {
    	     *   return _.isUndefined(objValue) ? srcValue : objValue;
    	     * }
    	     *
    	     * var defaults = _.partialRight(_.assignWith, customizer);
    	     *
    	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
    	     * // => { 'a': 1, 'b': 2 }
    	     */
    var assignWith=createAssigner(function(object,source,srcIndex,customizer){
    copyObject(source,keys(source),object,customizer);
    });

    /**
    	     * Creates an array of values corresponding to `paths` of `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 1.0.0
    	     * @category Object
    	     * @param {Object} object The object to iterate over.
    	     * @param {...(string|string[])} [paths] The property paths to pick.
    	     * @returns {Array} Returns the picked values.
    	     * @example
    	     *
    	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
    	     *
    	     * _.at(object, ['a[0].b.c', 'a[1]']);
    	     * // => [3, 4]
    	     */
    var at=flatRest(baseAt);

    /**
    	     * Creates an object that inherits from the `prototype` object. If a
    	     * `properties` object is given, its own enumerable string keyed properties
    	     * are assigned to the created object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.3.0
    	     * @category Object
    	     * @param {Object} prototype The object to inherit from.
    	     * @param {Object} [properties] The properties to assign to the object.
    	     * @returns {Object} Returns the new object.
    	     * @example
    	     *
    	     * function Shape() {
    	     *   this.x = 0;
    	     *   this.y = 0;
    	     * }
    	     *
    	     * function Circle() {
    	     *   Shape.call(this);
    	     * }
    	     *
    	     * Circle.prototype = _.create(Shape.prototype, {
    	     *   'constructor': Circle
    	     * });
    	     *
    	     * var circle = new Circle;
    	     * circle instanceof Circle;
    	     * // => true
    	     *
    	     * circle instanceof Shape;
    	     * // => true
    	     */
    function create(prototype,properties){
    var result=baseCreate(prototype);
    return properties==null?result:baseAssign(result,properties);
    }

    /**
    	     * Assigns own and inherited enumerable string keyed properties of source
    	     * objects to the destination object for all destination properties that
    	     * resolve to `undefined`. Source objects are applied from left to right.
    	     * Once a property is set, additional values of the same property are ignored.
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Object
    	     * @param {Object} object The destination object.
    	     * @param {...Object} [sources] The source objects.
    	     * @returns {Object} Returns `object`.
    	     * @see _.defaultsDeep
    	     * @example
    	     *
    	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
    	     * // => { 'a': 1, 'b': 2 }
    	     */
    var defaults=baseRest(function(object,sources){
    object=Object(object);

    var index=-1;
    var length=sources.length;
    var guard=length>2?sources[2]:undefined$1;

    if(guard&&isIterateeCall(sources[0],sources[1],guard)){
    length=1;
    }

    while(++index<length){
    var source=sources[index];
    var props=keysIn(source);
    var propsIndex=-1;
    var propsLength=props.length;

    while(++propsIndex<propsLength){
    var key=props[propsIndex];
    var value=object[key];

    if(value===undefined$1||
    eq(value,objectProto[key])&&!hasOwnProperty.call(object,key)){
    object[key]=source[key];
    }
    }
    }

    return object;
    });

    /**
    	     * This method is like `_.defaults` except that it recursively assigns
    	     * default properties.
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.10.0
    	     * @category Object
    	     * @param {Object} object The destination object.
    	     * @param {...Object} [sources] The source objects.
    	     * @returns {Object} Returns `object`.
    	     * @see _.defaults
    	     * @example
    	     *
    	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
    	     * // => { 'a': { 'b': 2, 'c': 3 } }
    	     */
    var defaultsDeep=baseRest(function(args){
    args.push(undefined$1,customDefaultsMerge);
    return apply(mergeWith,undefined$1,args);
    });

    /**
    	     * This method is like `_.find` except that it returns the key of the first
    	     * element `predicate` returns truthy for instead of the element itself.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 1.1.0
    	     * @category Object
    	     * @param {Object} object The object to inspect.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @returns {string|undefined} Returns the key of the matched element,
    	     *  else `undefined`.
    	     * @example
    	     *
    	     * var users = {
    	     *   'barney':  { 'age': 36, 'active': true },
    	     *   'fred':    { 'age': 40, 'active': false },
    	     *   'pebbles': { 'age': 1,  'active': true }
    	     * };
    	     *
    	     * _.findKey(users, function(o) { return o.age < 40; });
    	     * // => 'barney' (iteration order is not guaranteed)
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.findKey(users, { 'age': 1, 'active': true });
    	     * // => 'pebbles'
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.findKey(users, ['active', false]);
    	     * // => 'fred'
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.findKey(users, 'active');
    	     * // => 'barney'
    	     */
    function findKey(object,predicate){
    return baseFindKey(object,getIteratee(predicate,3),baseForOwn);
    }

    /**
    	     * This method is like `_.findKey` except that it iterates over elements of
    	     * a collection in the opposite order.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.0.0
    	     * @category Object
    	     * @param {Object} object The object to inspect.
    	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
    	     * @returns {string|undefined} Returns the key of the matched element,
    	     *  else `undefined`.
    	     * @example
    	     *
    	     * var users = {
    	     *   'barney':  { 'age': 36, 'active': true },
    	     *   'fred':    { 'age': 40, 'active': false },
    	     *   'pebbles': { 'age': 1,  'active': true }
    	     * };
    	     *
    	     * _.findLastKey(users, function(o) { return o.age < 40; });
    	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.findLastKey(users, { 'age': 36, 'active': true });
    	     * // => 'barney'
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.findLastKey(users, ['active', false]);
    	     * // => 'fred'
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.findLastKey(users, 'active');
    	     * // => 'pebbles'
    	     */
    function findLastKey(object,predicate){
    return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);
    }

    /**
    	     * Iterates over own and inherited enumerable string keyed properties of an
    	     * object and invokes `iteratee` for each property. The iteratee is invoked
    	     * with three arguments: (value, key, object). Iteratee functions may exit
    	     * iteration early by explicitly returning `false`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.3.0
    	     * @category Object
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Object} Returns `object`.
    	     * @see _.forInRight
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     *   this.b = 2;
    	     * }
    	     *
    	     * Foo.prototype.c = 3;
    	     *
    	     * _.forIn(new Foo, function(value, key) {
    	     *   console.log(key);
    	     * });
    	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
    	     */
    function forIn(object,iteratee){
    return object==null?
    object:
    baseFor(object,getIteratee(iteratee,3),keysIn);
    }

    /**
    	     * This method is like `_.forIn` except that it iterates over properties of
    	     * `object` in the opposite order.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.0.0
    	     * @category Object
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Object} Returns `object`.
    	     * @see _.forIn
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     *   this.b = 2;
    	     * }
    	     *
    	     * Foo.prototype.c = 3;
    	     *
    	     * _.forInRight(new Foo, function(value, key) {
    	     *   console.log(key);
    	     * });
    	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
    	     */
    function forInRight(object,iteratee){
    return object==null?
    object:
    baseForRight(object,getIteratee(iteratee,3),keysIn);
    }

    /**
    	     * Iterates over own enumerable string keyed properties of an object and
    	     * invokes `iteratee` for each property. The iteratee is invoked with three
    	     * arguments: (value, key, object). Iteratee functions may exit iteration
    	     * early by explicitly returning `false`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.3.0
    	     * @category Object
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Object} Returns `object`.
    	     * @see _.forOwnRight
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     *   this.b = 2;
    	     * }
    	     *
    	     * Foo.prototype.c = 3;
    	     *
    	     * _.forOwn(new Foo, function(value, key) {
    	     *   console.log(key);
    	     * });
    	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
    	     */
    function forOwn(object,iteratee){
    return object&&baseForOwn(object,getIteratee(iteratee,3));
    }

    /**
    	     * This method is like `_.forOwn` except that it iterates over properties of
    	     * `object` in the opposite order.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.0.0
    	     * @category Object
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Object} Returns `object`.
    	     * @see _.forOwn
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     *   this.b = 2;
    	     * }
    	     *
    	     * Foo.prototype.c = 3;
    	     *
    	     * _.forOwnRight(new Foo, function(value, key) {
    	     *   console.log(key);
    	     * });
    	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
    	     */
    function forOwnRight(object,iteratee){
    return object&&baseForOwnRight(object,getIteratee(iteratee,3));
    }

    /**
    	     * Creates an array of function property names from own enumerable properties
    	     * of `object`.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Object
    	     * @param {Object} object The object to inspect.
    	     * @returns {Array} Returns the function names.
    	     * @see _.functionsIn
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = _.constant('a');
    	     *   this.b = _.constant('b');
    	     * }
    	     *
    	     * Foo.prototype.c = _.constant('c');
    	     *
    	     * _.functions(new Foo);
    	     * // => ['a', 'b']
    	     */
    function functions(object){
    return object==null?[]:baseFunctions(object,keys(object));
    }

    /**
    	     * Creates an array of function property names from own and inherited
    	     * enumerable properties of `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Object
    	     * @param {Object} object The object to inspect.
    	     * @returns {Array} Returns the function names.
    	     * @see _.functions
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = _.constant('a');
    	     *   this.b = _.constant('b');
    	     * }
    	     *
    	     * Foo.prototype.c = _.constant('c');
    	     *
    	     * _.functionsIn(new Foo);
    	     * // => ['a', 'b', 'c']
    	     */
    function functionsIn(object){
    return object==null?[]:baseFunctions(object,keysIn(object));
    }

    /**
    	     * Gets the value at `path` of `object`. If the resolved value is
    	     * `undefined`, the `defaultValue` is returned in its place.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.7.0
    	     * @category Object
    	     * @param {Object} object The object to query.
    	     * @param {Array|string} path The path of the property to get.
    	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
    	     * @returns {*} Returns the resolved value.
    	     * @example
    	     *
    	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
    	     *
    	     * _.get(object, 'a[0].b.c');
    	     * // => 3
    	     *
    	     * _.get(object, ['a', '0', 'b', 'c']);
    	     * // => 3
    	     *
    	     * _.get(object, 'a.b.c', 'default');
    	     * // => 'default'
    	     */
    function get(object,path,defaultValue){
    var result=object==null?undefined$1:baseGet(object,path);
    return result===undefined$1?defaultValue:result;
    }

    /**
    	     * Checks if `path` is a direct property of `object`.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Object
    	     * @param {Object} object The object to query.
    	     * @param {Array|string} path The path to check.
    	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
    	     * @example
    	     *
    	     * var object = { 'a': { 'b': 2 } };
    	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
    	     *
    	     * _.has(object, 'a');
    	     * // => true
    	     *
    	     * _.has(object, 'a.b');
    	     * // => true
    	     *
    	     * _.has(object, ['a', 'b']);
    	     * // => true
    	     *
    	     * _.has(other, 'a');
    	     * // => false
    	     */
    function has(object,path){
    return object!=null&&hasPath(object,path,baseHas);
    }

    /**
    	     * Checks if `path` is a direct or inherited property of `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Object
    	     * @param {Object} object The object to query.
    	     * @param {Array|string} path The path to check.
    	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
    	     * @example
    	     *
    	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
    	     *
    	     * _.hasIn(object, 'a');
    	     * // => true
    	     *
    	     * _.hasIn(object, 'a.b');
    	     * // => true
    	     *
    	     * _.hasIn(object, ['a', 'b']);
    	     * // => true
    	     *
    	     * _.hasIn(object, 'b');
    	     * // => false
    	     */
    function hasIn(object,path){
    return object!=null&&hasPath(object,path,baseHasIn);
    }

    /**
    	     * Creates an object composed of the inverted keys and values of `object`.
    	     * If `object` contains duplicate values, subsequent values overwrite
    	     * property assignments of previous values.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.7.0
    	     * @category Object
    	     * @param {Object} object The object to invert.
    	     * @returns {Object} Returns the new inverted object.
    	     * @example
    	     *
    	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
    	     *
    	     * _.invert(object);
    	     * // => { '1': 'c', '2': 'b' }
    	     */
    var invert=createInverter(function(result,value,key){
    if(value!=null&&
    typeof value.toString!='function'){
    value=nativeObjectToString.call(value);
    }

    result[value]=key;
    },constant(identity));

    /**
    	     * This method is like `_.invert` except that the inverted object is generated
    	     * from the results of running each element of `object` thru `iteratee`. The
    	     * corresponding inverted value of each inverted key is an array of keys
    	     * responsible for generating the inverted value. The iteratee is invoked
    	     * with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.1.0
    	     * @category Object
    	     * @param {Object} object The object to invert.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {Object} Returns the new inverted object.
    	     * @example
    	     *
    	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
    	     *
    	     * _.invertBy(object);
    	     * // => { '1': ['a', 'c'], '2': ['b'] }
    	     *
    	     * _.invertBy(object, function(value) {
    	     *   return 'group' + value;
    	     * });
    	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
    	     */
    var invertBy=createInverter(function(result,value,key){
    if(value!=null&&
    typeof value.toString!='function'){
    value=nativeObjectToString.call(value);
    }

    if(hasOwnProperty.call(result,value)){
    result[value].push(key);
    }else {
    result[value]=[key];
    }
    },getIteratee);

    /**
    	     * Invokes the method at `path` of `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Object
    	     * @param {Object} object The object to query.
    	     * @param {Array|string} path The path of the method to invoke.
    	     * @param {...*} [args] The arguments to invoke the method with.
    	     * @returns {*} Returns the result of the invoked method.
    	     * @example
    	     *
    	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
    	     *
    	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
    	     * // => [2, 3]
    	     */
    var invoke=baseRest(baseInvoke);

    /**
    	     * Creates an array of the own enumerable property names of `object`.
    	     *
    	     * **Note:** Non-object values are coerced to objects. See the
    	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
    	     * for more details.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Object
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the array of property names.
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     *   this.b = 2;
    	     * }
    	     *
    	     * Foo.prototype.c = 3;
    	     *
    	     * _.keys(new Foo);
    	     * // => ['a', 'b'] (iteration order is not guaranteed)
    	     *
    	     * _.keys('hi');
    	     * // => ['0', '1']
    	     */
    function keys(object){
    return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);
    }

    /**
    	     * Creates an array of the own and inherited enumerable property names of `object`.
    	     *
    	     * **Note:** Non-object values are coerced to objects.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Object
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the array of property names.
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     *   this.b = 2;
    	     * }
    	     *
    	     * Foo.prototype.c = 3;
    	     *
    	     * _.keysIn(new Foo);
    	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
    	     */
    function keysIn(object){
    return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);
    }

    /**
    	     * The opposite of `_.mapValues`; this method creates an object with the
    	     * same values as `object` and keys generated by running each own enumerable
    	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
    	     * with three arguments: (value, key, object).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.8.0
    	     * @category Object
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Object} Returns the new mapped object.
    	     * @see _.mapValues
    	     * @example
    	     *
    	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
    	     *   return key + value;
    	     * });
    	     * // => { 'a1': 1, 'b2': 2 }
    	     */
    function mapKeys(object,iteratee){
    var result={};
    iteratee=getIteratee(iteratee,3);

    baseForOwn(object,function(value,key,object){
    baseAssignValue(result,iteratee(value,key,object),value);
    });
    return result;
    }

    /**
    	     * Creates an object with the same keys as `object` and values generated
    	     * by running each own enumerable string keyed property of `object` thru
    	     * `iteratee`. The iteratee is invoked with three arguments:
    	     * (value, key, object).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.4.0
    	     * @category Object
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Object} Returns the new mapped object.
    	     * @see _.mapKeys
    	     * @example
    	     *
    	     * var users = {
    	     *   'fred':    { 'user': 'fred',    'age': 40 },
    	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
    	     * };
    	     *
    	     * _.mapValues(users, function(o) { return o.age; });
    	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.mapValues(users, 'age');
    	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
    	     */
    function mapValues(object,iteratee){
    var result={};
    iteratee=getIteratee(iteratee,3);

    baseForOwn(object,function(value,key,object){
    baseAssignValue(result,key,iteratee(value,key,object));
    });
    return result;
    }

    /**
    	     * This method is like `_.assign` except that it recursively merges own and
    	     * inherited enumerable string keyed properties of source objects into the
    	     * destination object. Source properties that resolve to `undefined` are
    	     * skipped if a destination value exists. Array and plain object properties
    	     * are merged recursively. Other objects and value types are overridden by
    	     * assignment. Source objects are applied from left to right. Subsequent
    	     * sources overwrite property assignments of previous sources.
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.5.0
    	     * @category Object
    	     * @param {Object} object The destination object.
    	     * @param {...Object} [sources] The source objects.
    	     * @returns {Object} Returns `object`.
    	     * @example
    	     *
    	     * var object = {
    	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
    	     * };
    	     *
    	     * var other = {
    	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
    	     * };
    	     *
    	     * _.merge(object, other);
    	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
    	     */
    var merge=createAssigner(function(object,source,srcIndex){
    baseMerge(object,source,srcIndex);
    });

    /**
    	     * This method is like `_.merge` except that it accepts `customizer` which
    	     * is invoked to produce the merged values of the destination and source
    	     * properties. If `customizer` returns `undefined`, merging is handled by the
    	     * method instead. The `customizer` is invoked with six arguments:
    	     * (objValue, srcValue, key, object, source, stack).
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Object
    	     * @param {Object} object The destination object.
    	     * @param {...Object} sources The source objects.
    	     * @param {Function} customizer The function to customize assigned values.
    	     * @returns {Object} Returns `object`.
    	     * @example
    	     *
    	     * function customizer(objValue, srcValue) {
    	     *   if (_.isArray(objValue)) {
    	     *     return objValue.concat(srcValue);
    	     *   }
    	     * }
    	     *
    	     * var object = { 'a': [1], 'b': [2] };
    	     * var other = { 'a': [3], 'b': [4] };
    	     *
    	     * _.mergeWith(object, other, customizer);
    	     * // => { 'a': [1, 3], 'b': [2, 4] }
    	     */
    var mergeWith=createAssigner(function(object,source,srcIndex,customizer){
    baseMerge(object,source,srcIndex,customizer);
    });

    /**
    	     * The opposite of `_.pick`; this method creates an object composed of the
    	     * own and inherited enumerable property paths of `object` that are not omitted.
    	     *
    	     * **Note:** This method is considerably slower than `_.pick`.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Object
    	     * @param {Object} object The source object.
    	     * @param {...(string|string[])} [paths] The property paths to omit.
    	     * @returns {Object} Returns the new object.
    	     * @example
    	     *
    	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
    	     *
    	     * _.omit(object, ['a', 'c']);
    	     * // => { 'b': '2' }
    	     */
    var omit=flatRest(function(object,paths){
    var result={};
    if(object==null){
    return result;
    }
    var isDeep=false;
    paths=arrayMap(paths,function(path){
    path=castPath(path,object);
    isDeep||(isDeep=path.length>1);
    return path;
    });
    copyObject(object,getAllKeysIn(object),result);
    if(isDeep){
    result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);
    }
    var length=paths.length;
    while(length--){
    baseUnset(result,paths[length]);
    }
    return result;
    });

    /**
    	     * The opposite of `_.pickBy`; this method creates an object composed of
    	     * the own and inherited enumerable string keyed properties of `object` that
    	     * `predicate` doesn't return truthy for. The predicate is invoked with two
    	     * arguments: (value, key).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Object
    	     * @param {Object} object The source object.
    	     * @param {Function} [predicate=_.identity] The function invoked per property.
    	     * @returns {Object} Returns the new object.
    	     * @example
    	     *
    	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
    	     *
    	     * _.omitBy(object, _.isNumber);
    	     * // => { 'b': '2' }
    	     */
    function omitBy(object,predicate){
    return pickBy(object,negate(getIteratee(predicate)));
    }

    /**
    	     * Creates an object composed of the picked `object` properties.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Object
    	     * @param {Object} object The source object.
    	     * @param {...(string|string[])} [paths] The property paths to pick.
    	     * @returns {Object} Returns the new object.
    	     * @example
    	     *
    	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
    	     *
    	     * _.pick(object, ['a', 'c']);
    	     * // => { 'a': 1, 'c': 3 }
    	     */
    var pick=flatRest(function(object,paths){
    return object==null?{}:basePick(object,paths);
    });

    /**
    	     * Creates an object composed of the `object` properties `predicate` returns
    	     * truthy for. The predicate is invoked with two arguments: (value, key).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Object
    	     * @param {Object} object The source object.
    	     * @param {Function} [predicate=_.identity] The function invoked per property.
    	     * @returns {Object} Returns the new object.
    	     * @example
    	     *
    	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
    	     *
    	     * _.pickBy(object, _.isNumber);
    	     * // => { 'a': 1, 'c': 3 }
    	     */
    function pickBy(object,predicate){
    if(object==null){
    return {};
    }
    var props=arrayMap(getAllKeysIn(object),function(prop){
    return [prop];
    });
    predicate=getIteratee(predicate);
    return basePickBy(object,props,function(value,path){
    return predicate(value,path[0]);
    });
    }

    /**
    	     * This method is like `_.get` except that if the resolved value is a
    	     * function it's invoked with the `this` binding of its parent object and
    	     * its result is returned.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Object
    	     * @param {Object} object The object to query.
    	     * @param {Array|string} path The path of the property to resolve.
    	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
    	     * @returns {*} Returns the resolved value.
    	     * @example
    	     *
    	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
    	     *
    	     * _.result(object, 'a[0].b.c1');
    	     * // => 3
    	     *
    	     * _.result(object, 'a[0].b.c2');
    	     * // => 4
    	     *
    	     * _.result(object, 'a[0].b.c3', 'default');
    	     * // => 'default'
    	     *
    	     * _.result(object, 'a[0].b.c3', _.constant('default'));
    	     * // => 'default'
    	     */
    function result(object,path,defaultValue){
    path=castPath(path,object);

    var index=-1,
    length=path.length;

    // Ensure the loop is entered when path is empty.
    if(!length){
    length=1;
    object=undefined$1;
    }
    while(++index<length){
    var value=object==null?undefined$1:object[toKey(path[index])];
    if(value===undefined$1){
    index=length;
    value=defaultValue;
    }
    object=isFunction(value)?value.call(object):value;
    }
    return object;
    }

    /**
    	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
    	     * it's created. Arrays are created for missing index properties while objects
    	     * are created for all other missing properties. Use `_.setWith` to customize
    	     * `path` creation.
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.7.0
    	     * @category Object
    	     * @param {Object} object The object to modify.
    	     * @param {Array|string} path The path of the property to set.
    	     * @param {*} value The value to set.
    	     * @returns {Object} Returns `object`.
    	     * @example
    	     *
    	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
    	     *
    	     * _.set(object, 'a[0].b.c', 4);
    	     * console.log(object.a[0].b.c);
    	     * // => 4
    	     *
    	     * _.set(object, ['x', '0', 'y', 'z'], 5);
    	     * console.log(object.x[0].y.z);
    	     * // => 5
    	     */
    function set(object,path,value){
    return object==null?object:baseSet(object,path,value);
    }

    /**
    	     * This method is like `_.set` except that it accepts `customizer` which is
    	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
    	     * path creation is handled by the method instead. The `customizer` is invoked
    	     * with three arguments: (nsValue, key, nsObject).
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Object
    	     * @param {Object} object The object to modify.
    	     * @param {Array|string} path The path of the property to set.
    	     * @param {*} value The value to set.
    	     * @param {Function} [customizer] The function to customize assigned values.
    	     * @returns {Object} Returns `object`.
    	     * @example
    	     *
    	     * var object = {};
    	     *
    	     * _.setWith(object, '[0][1]', 'a', Object);
    	     * // => { '0': { '1': 'a' } }
    	     */
    function setWith(object,path,value,customizer){
    customizer=typeof customizer=='function'?customizer:undefined$1;
    return object==null?object:baseSet(object,path,value,customizer);
    }

    /**
    	     * Creates an array of own enumerable string keyed-value pairs for `object`
    	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
    	     * entries are returned.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @alias entries
    	     * @category Object
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the key-value pairs.
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     *   this.b = 2;
    	     * }
    	     *
    	     * Foo.prototype.c = 3;
    	     *
    	     * _.toPairs(new Foo);
    	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
    	     */
    var toPairs=createToPairs(keys);

    /**
    	     * Creates an array of own and inherited enumerable string keyed-value pairs
    	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
    	     * or set, its entries are returned.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @alias entriesIn
    	     * @category Object
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the key-value pairs.
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     *   this.b = 2;
    	     * }
    	     *
    	     * Foo.prototype.c = 3;
    	     *
    	     * _.toPairsIn(new Foo);
    	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
    	     */
    var toPairsIn=createToPairs(keysIn);

    /**
    	     * An alternative to `_.reduce`; this method transforms `object` to a new
    	     * `accumulator` object which is the result of running each of its own
    	     * enumerable string keyed properties thru `iteratee`, with each invocation
    	     * potentially mutating the `accumulator` object. If `accumulator` is not
    	     * provided, a new object with the same `[[Prototype]]` will be used. The
    	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
    	     * Iteratee functions may exit iteration early by explicitly returning `false`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 1.3.0
    	     * @category Object
    	     * @param {Object} object The object to iterate over.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @param {*} [accumulator] The custom accumulator value.
    	     * @returns {*} Returns the accumulated value.
    	     * @example
    	     *
    	     * _.transform([2, 3, 4], function(result, n) {
    	     *   result.push(n *= n);
    	     *   return n % 2 == 0;
    	     * }, []);
    	     * // => [4, 9]
    	     *
    	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
    	     *   (result[value] || (result[value] = [])).push(key);
    	     * }, {});
    	     * // => { '1': ['a', 'c'], '2': ['b'] }
    	     */
    function transform(object,iteratee,accumulator){
    var isArr=isArray(object),
    isArrLike=isArr||isBuffer(object)||isTypedArray(object);

    iteratee=getIteratee(iteratee,4);
    if(accumulator==null){
    var Ctor=object&&object.constructor;
    if(isArrLike){
    accumulator=isArr?new Ctor():[];
    }else
    if(isObject(object)){
    accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};
    }else
    {
    accumulator={};
    }
    }
    (isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){
    return iteratee(accumulator,value,index,object);
    });
    return accumulator;
    }

    /**
    	     * Removes the property at `path` of `object`.
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Object
    	     * @param {Object} object The object to modify.
    	     * @param {Array|string} path The path of the property to unset.
    	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
    	     * @example
    	     *
    	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
    	     * _.unset(object, 'a[0].b.c');
    	     * // => true
    	     *
    	     * console.log(object);
    	     * // => { 'a': [{ 'b': {} }] };
    	     *
    	     * _.unset(object, ['a', '0', 'b', 'c']);
    	     * // => true
    	     *
    	     * console.log(object);
    	     * // => { 'a': [{ 'b': {} }] };
    	     */
    function unset(object,path){
    return object==null?true:baseUnset(object,path);
    }

    /**
    	     * This method is like `_.set` except that accepts `updater` to produce the
    	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
    	     * is invoked with one argument: (value).
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.6.0
    	     * @category Object
    	     * @param {Object} object The object to modify.
    	     * @param {Array|string} path The path of the property to set.
    	     * @param {Function} updater The function to produce the updated value.
    	     * @returns {Object} Returns `object`.
    	     * @example
    	     *
    	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
    	     *
    	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
    	     * console.log(object.a[0].b.c);
    	     * // => 9
    	     *
    	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
    	     * console.log(object.x[0].y.z);
    	     * // => 0
    	     */
    function update(object,path,updater){
    return object==null?object:baseUpdate(object,path,castFunction(updater));
    }

    /**
    	     * This method is like `_.update` except that it accepts `customizer` which is
    	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
    	     * path creation is handled by the method instead. The `customizer` is invoked
    	     * with three arguments: (nsValue, key, nsObject).
    	     *
    	     * **Note:** This method mutates `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.6.0
    	     * @category Object
    	     * @param {Object} object The object to modify.
    	     * @param {Array|string} path The path of the property to set.
    	     * @param {Function} updater The function to produce the updated value.
    	     * @param {Function} [customizer] The function to customize assigned values.
    	     * @returns {Object} Returns `object`.
    	     * @example
    	     *
    	     * var object = {};
    	     *
    	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
    	     * // => { '0': { '1': 'a' } }
    	     */
    function updateWith(object,path,updater,customizer){
    customizer=typeof customizer=='function'?customizer:undefined$1;
    return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);
    }

    /**
    	     * Creates an array of the own enumerable string keyed property values of `object`.
    	     *
    	     * **Note:** Non-object values are coerced to objects.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Object
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the array of property values.
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     *   this.b = 2;
    	     * }
    	     *
    	     * Foo.prototype.c = 3;
    	     *
    	     * _.values(new Foo);
    	     * // => [1, 2] (iteration order is not guaranteed)
    	     *
    	     * _.values('hi');
    	     * // => ['h', 'i']
    	     */
    function values(object){
    return object==null?[]:baseValues(object,keys(object));
    }

    /**
    	     * Creates an array of the own and inherited enumerable string keyed property
    	     * values of `object`.
    	     *
    	     * **Note:** Non-object values are coerced to objects.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Object
    	     * @param {Object} object The object to query.
    	     * @returns {Array} Returns the array of property values.
    	     * @example
    	     *
    	     * function Foo() {
    	     *   this.a = 1;
    	     *   this.b = 2;
    	     * }
    	     *
    	     * Foo.prototype.c = 3;
    	     *
    	     * _.valuesIn(new Foo);
    	     * // => [1, 2, 3] (iteration order is not guaranteed)
    	     */
    function valuesIn(object){
    return object==null?[]:baseValues(object,keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
    	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Number
    	     * @param {number} number The number to clamp.
    	     * @param {number} [lower] The lower bound.
    	     * @param {number} upper The upper bound.
    	     * @returns {number} Returns the clamped number.
    	     * @example
    	     *
    	     * _.clamp(-10, -5, 5);
    	     * // => -5
    	     *
    	     * _.clamp(10, -5, 5);
    	     * // => 5
    	     */
    function clamp(number,lower,upper){
    if(upper===undefined$1){
    upper=lower;
    lower=undefined$1;
    }
    if(upper!==undefined$1){
    upper=toNumber(upper);
    upper=upper===upper?upper:0;
    }
    if(lower!==undefined$1){
    lower=toNumber(lower);
    lower=lower===lower?lower:0;
    }
    return baseClamp(toNumber(number),lower,upper);
    }

    /**
    	     * Checks if `n` is between `start` and up to, but not including, `end`. If
    	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
    	     * If `start` is greater than `end` the params are swapped to support
    	     * negative ranges.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.3.0
    	     * @category Number
    	     * @param {number} number The number to check.
    	     * @param {number} [start=0] The start of the range.
    	     * @param {number} end The end of the range.
    	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
    	     * @see _.range, _.rangeRight
    	     * @example
    	     *
    	     * _.inRange(3, 2, 4);
    	     * // => true
    	     *
    	     * _.inRange(4, 8);
    	     * // => true
    	     *
    	     * _.inRange(4, 2);
    	     * // => false
    	     *
    	     * _.inRange(2, 2);
    	     * // => false
    	     *
    	     * _.inRange(1.2, 2);
    	     * // => true
    	     *
    	     * _.inRange(5.2, 4);
    	     * // => false
    	     *
    	     * _.inRange(-3, -2, -6);
    	     * // => true
    	     */
    function inRange(number,start,end){
    start=toFinite(start);
    if(end===undefined$1){
    end=start;
    start=0;
    }else {
    end=toFinite(end);
    }
    number=toNumber(number);
    return baseInRange(number,start,end);
    }

    /**
    	     * Produces a random number between the inclusive `lower` and `upper` bounds.
    	     * If only one argument is provided a number between `0` and the given number
    	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
    	     * floats, a floating-point number is returned instead of an integer.
    	     *
    	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
    	     * floating-point values which can produce unexpected results.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.7.0
    	     * @category Number
    	     * @param {number} [lower=0] The lower bound.
    	     * @param {number} [upper=1] The upper bound.
    	     * @param {boolean} [floating] Specify returning a floating-point number.
    	     * @returns {number} Returns the random number.
    	     * @example
    	     *
    	     * _.random(0, 5);
    	     * // => an integer between 0 and 5
    	     *
    	     * _.random(5);
    	     * // => also an integer between 0 and 5
    	     *
    	     * _.random(5, true);
    	     * // => a floating-point number between 0 and 5
    	     *
    	     * _.random(1.2, 5.2);
    	     * // => a floating-point number between 1.2 and 5.2
    	     */
    function random(lower,upper,floating){
    if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){
    upper=floating=undefined$1;
    }
    if(floating===undefined$1){
    if(typeof upper=='boolean'){
    floating=upper;
    upper=undefined$1;
    }else
    if(typeof lower=='boolean'){
    floating=lower;
    lower=undefined$1;
    }
    }
    if(lower===undefined$1&&upper===undefined$1){
    lower=0;
    upper=1;
    }else
    {
    lower=toFinite(lower);
    if(upper===undefined$1){
    upper=lower;
    lower=0;
    }else {
    upper=toFinite(upper);
    }
    }
    if(lower>upper){
    var temp=lower;
    lower=upper;
    upper=temp;
    }
    if(floating||lower%1||upper%1){
    var rand=nativeRandom();
    return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);
    }
    return baseRandom(lower,upper);
    }

    /*------------------------------------------------------------------------*/

    /**
    	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to convert.
    	     * @returns {string} Returns the camel cased string.
    	     * @example
    	     *
    	     * _.camelCase('Foo Bar');
    	     * // => 'fooBar'
    	     *
    	     * _.camelCase('--foo-bar--');
    	     * // => 'fooBar'
    	     *
    	     * _.camelCase('__FOO_BAR__');
    	     * // => 'fooBar'
    	     */
    var camelCase=createCompounder(function(result,word,index){
    word=word.toLowerCase();
    return result+(index?capitalize(word):word);
    });

    /**
    	     * Converts the first character of `string` to upper case and the remaining
    	     * to lower case.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to capitalize.
    	     * @returns {string} Returns the capitalized string.
    	     * @example
    	     *
    	     * _.capitalize('FRED');
    	     * // => 'Fred'
    	     */
    function capitalize(string){
    return upperFirst(toString(string).toLowerCase());
    }

    /**
    	     * Deburrs `string` by converting
    	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
    	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
    	     * letters to basic Latin letters and removing
    	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to deburr.
    	     * @returns {string} Returns the deburred string.
    	     * @example
    	     *
    	     * _.deburr('déjà vu');
    	     * // => 'deja vu'
    	     */
    function deburr(string){
    string=toString(string);
    return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');
    }

    /**
    	     * Checks if `string` ends with the given target string.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to inspect.
    	     * @param {string} [target] The string to search for.
    	     * @param {number} [position=string.length] The position to search up to.
    	     * @returns {boolean} Returns `true` if `string` ends with `target`,
    	     *  else `false`.
    	     * @example
    	     *
    	     * _.endsWith('abc', 'c');
    	     * // => true
    	     *
    	     * _.endsWith('abc', 'b');
    	     * // => false
    	     *
    	     * _.endsWith('abc', 'b', 2);
    	     * // => true
    	     */
    function endsWith(string,target,position){
    string=toString(string);
    target=baseToString(target);

    var length=string.length;
    position=position===undefined$1?
    length:
    baseClamp(toInteger(position),0,length);

    var end=position;
    position-=target.length;
    return position>=0&&string.slice(position,end)==target;
    }

    /**
    	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
    	     * corresponding HTML entities.
    	     *
    	     * **Note:** No other characters are escaped. To escape additional
    	     * characters use a third-party library like [_he_](https://mths.be/he).
    	     *
    	     * Though the ">" character is escaped for symmetry, characters like
    	     * ">" and "/" don't need escaping in HTML and have no special meaning
    	     * unless they're part of a tag or unquoted attribute value. See
    	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
    	     * (under "semi-related fun fact") for more details.
    	     *
    	     * When working with HTML you should always
    	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
    	     * XSS vectors.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category String
    	     * @param {string} [string=''] The string to escape.
    	     * @returns {string} Returns the escaped string.
    	     * @example
    	     *
    	     * _.escape('fred, barney, & pebbles');
    	     * // => 'fred, barney, &amp; pebbles'
    	     */
    function escape(string){
    string=toString(string);
    return string&&reHasUnescapedHtml.test(string)?
    string.replace(reUnescapedHtml,escapeHtmlChar):
    string;
    }

    /**
    	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
    	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to escape.
    	     * @returns {string} Returns the escaped string.
    	     * @example
    	     *
    	     * _.escapeRegExp('[lodash](https://lodash.com/)');
    	     * // => '\[lodash\]\(https://lodash\.com/\)'
    	     */
    function escapeRegExp(string){
    string=toString(string);
    return string&&reHasRegExpChar.test(string)?
    string.replace(reRegExpChar,'\\$&'):
    string;
    }

    /**
    	     * Converts `string` to
    	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to convert.
    	     * @returns {string} Returns the kebab cased string.
    	     * @example
    	     *
    	     * _.kebabCase('Foo Bar');
    	     * // => 'foo-bar'
    	     *
    	     * _.kebabCase('fooBar');
    	     * // => 'foo-bar'
    	     *
    	     * _.kebabCase('__FOO_BAR__');
    	     * // => 'foo-bar'
    	     */
    var kebabCase=createCompounder(function(result,word,index){
    return result+(index?'-':'')+word.toLowerCase();
    });

    /**
    	     * Converts `string`, as space separated words, to lower case.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to convert.
    	     * @returns {string} Returns the lower cased string.
    	     * @example
    	     *
    	     * _.lowerCase('--Foo-Bar--');
    	     * // => 'foo bar'
    	     *
    	     * _.lowerCase('fooBar');
    	     * // => 'foo bar'
    	     *
    	     * _.lowerCase('__FOO_BAR__');
    	     * // => 'foo bar'
    	     */
    var lowerCase=createCompounder(function(result,word,index){
    return result+(index?' ':'')+word.toLowerCase();
    });

    /**
    	     * Converts the first character of `string` to lower case.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to convert.
    	     * @returns {string} Returns the converted string.
    	     * @example
    	     *
    	     * _.lowerFirst('Fred');
    	     * // => 'fred'
    	     *
    	     * _.lowerFirst('FRED');
    	     * // => 'fRED'
    	     */
    var lowerFirst=createCaseFirst('toLowerCase');

    /**
    	     * Pads `string` on the left and right sides if it's shorter than `length`.
    	     * Padding characters are truncated if they can't be evenly divided by `length`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to pad.
    	     * @param {number} [length=0] The padding length.
    	     * @param {string} [chars=' '] The string used as padding.
    	     * @returns {string} Returns the padded string.
    	     * @example
    	     *
    	     * _.pad('abc', 8);
    	     * // => '  abc   '
    	     *
    	     * _.pad('abc', 8, '_-');
    	     * // => '_-abc_-_'
    	     *
    	     * _.pad('abc', 3);
    	     * // => 'abc'
    	     */
    function pad(string,length,chars){
    string=toString(string);
    length=toInteger(length);

    var strLength=length?stringSize(string):0;
    if(!length||strLength>=length){
    return string;
    }
    var mid=(length-strLength)/2;
    return(
    createPadding(nativeFloor(mid),chars)+
    string+
    createPadding(nativeCeil(mid),chars));

    }

    /**
    	     * Pads `string` on the right side if it's shorter than `length`. Padding
    	     * characters are truncated if they exceed `length`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to pad.
    	     * @param {number} [length=0] The padding length.
    	     * @param {string} [chars=' '] The string used as padding.
    	     * @returns {string} Returns the padded string.
    	     * @example
    	     *
    	     * _.padEnd('abc', 6);
    	     * // => 'abc   '
    	     *
    	     * _.padEnd('abc', 6, '_-');
    	     * // => 'abc_-_'
    	     *
    	     * _.padEnd('abc', 3);
    	     * // => 'abc'
    	     */
    function padEnd(string,length,chars){
    string=toString(string);
    length=toInteger(length);

    var strLength=length?stringSize(string):0;
    return length&&strLength<length?
    string+createPadding(length-strLength,chars):
    string;
    }

    /**
    	     * Pads `string` on the left side if it's shorter than `length`. Padding
    	     * characters are truncated if they exceed `length`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to pad.
    	     * @param {number} [length=0] The padding length.
    	     * @param {string} [chars=' '] The string used as padding.
    	     * @returns {string} Returns the padded string.
    	     * @example
    	     *
    	     * _.padStart('abc', 6);
    	     * // => '   abc'
    	     *
    	     * _.padStart('abc', 6, '_-');
    	     * // => '_-_abc'
    	     *
    	     * _.padStart('abc', 3);
    	     * // => 'abc'
    	     */
    function padStart(string,length,chars){
    string=toString(string);
    length=toInteger(length);

    var strLength=length?stringSize(string):0;
    return length&&strLength<length?
    createPadding(length-strLength,chars)+string:
    string;
    }

    /**
    	     * Converts `string` to an integer of the specified radix. If `radix` is
    	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
    	     * hexadecimal, in which case a `radix` of `16` is used.
    	     *
    	     * **Note:** This method aligns with the
    	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 1.1.0
    	     * @category String
    	     * @param {string} string The string to convert.
    	     * @param {number} [radix=10] The radix to interpret `value` by.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {number} Returns the converted integer.
    	     * @example
    	     *
    	     * _.parseInt('08');
    	     * // => 8
    	     *
    	     * _.map(['6', '08', '10'], _.parseInt);
    	     * // => [6, 8, 10]
    	     */
    function parseInt(string,radix,guard){
    if(guard||radix==null){
    radix=0;
    }else if(radix){
    radix=+radix;
    }
    return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);
    }

    /**
    	     * Repeats the given string `n` times.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to repeat.
    	     * @param {number} [n=1] The number of times to repeat the string.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {string} Returns the repeated string.
    	     * @example
    	     *
    	     * _.repeat('*', 3);
    	     * // => '***'
    	     *
    	     * _.repeat('abc', 2);
    	     * // => 'abcabc'
    	     *
    	     * _.repeat('abc', 0);
    	     * // => ''
    	     */
    function repeat(string,n,guard){
    if(guard?isIterateeCall(string,n,guard):n===undefined$1){
    n=1;
    }else {
    n=toInteger(n);
    }
    return baseRepeat(toString(string),n);
    }

    /**
    	     * Replaces matches for `pattern` in `string` with `replacement`.
    	     *
    	     * **Note:** This method is based on
    	     * [`String#replace`](https://mdn.io/String/replace).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to modify.
    	     * @param {RegExp|string} pattern The pattern to replace.
    	     * @param {Function|string} replacement The match replacement.
    	     * @returns {string} Returns the modified string.
    	     * @example
    	     *
    	     * _.replace('Hi Fred', 'Fred', 'Barney');
    	     * // => 'Hi Barney'
    	     */
    function replace(){
    var args=arguments,
    string=toString(args[0]);

    return args.length<3?string:string.replace(args[1],args[2]);
    }

    /**
    	     * Converts `string` to
    	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to convert.
    	     * @returns {string} Returns the snake cased string.
    	     * @example
    	     *
    	     * _.snakeCase('Foo Bar');
    	     * // => 'foo_bar'
    	     *
    	     * _.snakeCase('fooBar');
    	     * // => 'foo_bar'
    	     *
    	     * _.snakeCase('--FOO-BAR--');
    	     * // => 'foo_bar'
    	     */
    var snakeCase=createCompounder(function(result,word,index){
    return result+(index?'_':'')+word.toLowerCase();
    });

    /**
    	     * Splits `string` by `separator`.
    	     *
    	     * **Note:** This method is based on
    	     * [`String#split`](https://mdn.io/String/split).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to split.
    	     * @param {RegExp|string} separator The separator pattern to split by.
    	     * @param {number} [limit] The length to truncate results to.
    	     * @returns {Array} Returns the string segments.
    	     * @example
    	     *
    	     * _.split('a-b-c', '-', 2);
    	     * // => ['a', 'b']
    	     */
    function split(string,separator,limit){
    if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){
    separator=limit=undefined$1;
    }
    limit=limit===undefined$1?MAX_ARRAY_LENGTH:limit>>>0;
    if(!limit){
    return [];
    }
    string=toString(string);
    if(string&&(
    typeof separator=='string'||
    separator!=null&&!isRegExp(separator)))
    {
    separator=baseToString(separator);
    if(!separator&&hasUnicode(string)){
    return castSlice(stringToArray(string),0,limit);
    }
    }
    return string.split(separator,limit);
    }

    /**
    	     * Converts `string` to
    	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.1.0
    	     * @category String
    	     * @param {string} [string=''] The string to convert.
    	     * @returns {string} Returns the start cased string.
    	     * @example
    	     *
    	     * _.startCase('--foo-bar--');
    	     * // => 'Foo Bar'
    	     *
    	     * _.startCase('fooBar');
    	     * // => 'Foo Bar'
    	     *
    	     * _.startCase('__FOO_BAR__');
    	     * // => 'FOO BAR'
    	     */
    var startCase=createCompounder(function(result,word,index){
    return result+(index?' ':'')+upperFirst(word);
    });

    /**
    	     * Checks if `string` starts with the given target string.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to inspect.
    	     * @param {string} [target] The string to search for.
    	     * @param {number} [position=0] The position to search from.
    	     * @returns {boolean} Returns `true` if `string` starts with `target`,
    	     *  else `false`.
    	     * @example
    	     *
    	     * _.startsWith('abc', 'a');
    	     * // => true
    	     *
    	     * _.startsWith('abc', 'b');
    	     * // => false
    	     *
    	     * _.startsWith('abc', 'b', 1);
    	     * // => true
    	     */
    function startsWith(string,target,position){
    string=toString(string);
    position=position==null?
    0:
    baseClamp(toInteger(position),0,string.length);

    target=baseToString(target);
    return string.slice(position,position+target.length)==target;
    }

    /**
    	     * Creates a compiled template function that can interpolate data properties
    	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
    	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
    	     * properties may be accessed as free variables in the template. If a setting
    	     * object is given, it takes precedence over `_.templateSettings` values.
    	     *
    	     * **Note:** In the development build `_.template` utilizes
    	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
    	     * for easier debugging.
    	     *
    	     * For more information on precompiling templates see
    	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
    	     *
    	     * For more information on Chrome extension sandboxes see
    	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category String
    	     * @param {string} [string=''] The template string.
    	     * @param {Object} [options={}] The options object.
    	     * @param {RegExp} [options.escape=_.templateSettings.escape]
    	     *  The HTML "escape" delimiter.
    	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
    	     *  The "evaluate" delimiter.
    	     * @param {Object} [options.imports=_.templateSettings.imports]
    	     *  An object to import into the template as free variables.
    	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
    	     *  The "interpolate" delimiter.
    	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
    	     *  The sourceURL of the compiled template.
    	     * @param {string} [options.variable='obj']
    	     *  The data object variable name.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {Function} Returns the compiled template function.
    	     * @example
    	     *
    	     * // Use the "interpolate" delimiter to create a compiled template.
    	     * var compiled = _.template('hello <%= user %>!');
    	     * compiled({ 'user': 'fred' });
    	     * // => 'hello fred!'
    	     *
    	     * // Use the HTML "escape" delimiter to escape data property values.
    	     * var compiled = _.template('<b><%- value %></b>');
    	     * compiled({ 'value': '<script>' });
    	     * // => '<b>&lt;script&gt;</b>'
    	     *
    	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
    	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
    	     * compiled({ 'users': ['fred', 'barney'] });
    	     * // => '<li>fred</li><li>barney</li>'
    	     *
    	     * // Use the internal `print` function in "evaluate" delimiters.
    	     * var compiled = _.template('<% print("hello " + user); %>!');
    	     * compiled({ 'user': 'barney' });
    	     * // => 'hello barney!'
    	     *
    	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
    	     * // Disable support by replacing the "interpolate" delimiter.
    	     * var compiled = _.template('hello ${ user }!');
    	     * compiled({ 'user': 'pebbles' });
    	     * // => 'hello pebbles!'
    	     *
    	     * // Use backslashes to treat delimiters as plain text.
    	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
    	     * compiled({ 'value': 'ignored' });
    	     * // => '<%- value %>'
    	     *
    	     * // Use the `imports` option to import `jQuery` as `jq`.
    	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
    	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
    	     * compiled({ 'users': ['fred', 'barney'] });
    	     * // => '<li>fred</li><li>barney</li>'
    	     *
    	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
    	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
    	     * compiled(data);
    	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
    	     *
    	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
    	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
    	     * compiled.source;
    	     * // => function(data) {
    	     * //   var __t, __p = '';
    	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
    	     * //   return __p;
    	     * // }
    	     *
    	     * // Use custom template delimiters.
    	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
    	     * var compiled = _.template('hello {{ user }}!');
    	     * compiled({ 'user': 'mustache' });
    	     * // => 'hello mustache!'
    	     *
    	     * // Use the `source` property to inline compiled templates for meaningful
    	     * // line numbers in error messages and stack traces.
    	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
    	     *   var JST = {\
    	     *     "main": ' + _.template(mainText).source + '\
    	     *   };\
    	     * ');
    	     */
    function template(string,options,guard){
    // Based on John Resig's `tmpl` implementation
    // (http://ejohn.org/blog/javascript-micro-templating/)
    // and Laura Doktorova's doT.js (https://github.com/olado/doT).
    var settings=lodash.templateSettings;

    if(guard&&isIterateeCall(string,options,guard)){
    options=undefined$1;
    }
    string=toString(string);
    options=assignInWith({},options,settings,customDefaultsAssignIn);

    var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),
    importsKeys=keys(imports),
    importsValues=baseValues(imports,importsKeys);

    var isEscaping,
    isEvaluating,
    index=0,
    interpolate=options.interpolate||reNoMatch,
    source="__p += '";

    // Compile the regexp to match each delimiter.
    var reDelimiters=RegExp(
    (options.escape||reNoMatch).source+'|'+
    interpolate.source+'|'+
    (interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+
    (options.evaluate||reNoMatch).source+'|$',
    'g');

    // Use a sourceURL for easier debugging.
    // The sourceURL gets injected into the source that's eval-ed, so be careful
    // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
    // and escape the comment, thus injecting code that gets evaled.
    var sourceURL='//# sourceURL='+(
    hasOwnProperty.call(options,'sourceURL')?
    (options.sourceURL+'').replace(/\s/g,' '):
    'lodash.templateSources['+ ++templateCounter+']')+
    '\n';

    string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){
    interpolateValue||(interpolateValue=esTemplateValue);

    // Escape characters that can't be included in string literals.
    source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);

    // Replace delimiters with snippets.
    if(escapeValue){
    isEscaping=true;
    source+="' +\n__e("+escapeValue+") +\n'";
    }
    if(evaluateValue){
    isEvaluating=true;
    source+="';\n"+evaluateValue+";\n__p += '";
    }
    if(interpolateValue){
    source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";
    }
    index=offset+match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
    });

    source+="';\n";

    // If `variable` is not specified wrap a with-statement around the generated
    // code to add the data object to the top of the scope chain.
    var variable=hasOwnProperty.call(options,'variable')&&options.variable;
    if(!variable){
    source='with (obj) {\n'+source+'\n}\n';
    }
    // Throw an error if a forbidden character was found in `variable`, to prevent
    // potential command injection attacks.
    else if(reForbiddenIdentifierChars.test(variable)){
    throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
    }

    // Cleanup code by stripping empty strings.
    source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).
    replace(reEmptyStringMiddle,'$1').
    replace(reEmptyStringTrailing,'$1;');

    // Frame code as the function body.
    source='function('+(variable||'obj')+') {\n'+(
    variable?
    '':
    'obj || (obj = {});\n')+

    "var __t, __p = ''"+(
    isEscaping?
    ', __e = _.escape':
    '')+(

    isEvaluating?
    ', __j = Array.prototype.join;\n'+
    "function print() { __p += __j.call(arguments, '') }\n":
    ';\n')+

    source+
    'return __p\n}';

    var result=attempt(function(){
    return Function(importsKeys,sourceURL+'return '+source).
    apply(undefined$1,importsValues);
    });

    // Provide the compiled function's source by its `toString` method or
    // the `source` property as a convenience for inlining compiled templates.
    result.source=source;
    if(isError(result)){
    throw result;
    }
    return result;
    }

    /**
    	     * Converts `string`, as a whole, to lower case just like
    	     * [String#toLowerCase](https://mdn.io/toLowerCase).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to convert.
    	     * @returns {string} Returns the lower cased string.
    	     * @example
    	     *
    	     * _.toLower('--Foo-Bar--');
    	     * // => '--foo-bar--'
    	     *
    	     * _.toLower('fooBar');
    	     * // => 'foobar'
    	     *
    	     * _.toLower('__FOO_BAR__');
    	     * // => '__foo_bar__'
    	     */
    function toLower(value){
    return toString(value).toLowerCase();
    }

    /**
    	     * Converts `string`, as a whole, to upper case just like
    	     * [String#toUpperCase](https://mdn.io/toUpperCase).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to convert.
    	     * @returns {string} Returns the upper cased string.
    	     * @example
    	     *
    	     * _.toUpper('--foo-bar--');
    	     * // => '--FOO-BAR--'
    	     *
    	     * _.toUpper('fooBar');
    	     * // => 'FOOBAR'
    	     *
    	     * _.toUpper('__foo_bar__');
    	     * // => '__FOO_BAR__'
    	     */
    function toUpper(value){
    return toString(value).toUpperCase();
    }

    /**
    	     * Removes leading and trailing whitespace or specified characters from `string`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to trim.
    	     * @param {string} [chars=whitespace] The characters to trim.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {string} Returns the trimmed string.
    	     * @example
    	     *
    	     * _.trim('  abc  ');
    	     * // => 'abc'
    	     *
    	     * _.trim('-_-abc-_-', '_-');
    	     * // => 'abc'
    	     *
    	     * _.map(['  foo  ', '  bar  '], _.trim);
    	     * // => ['foo', 'bar']
    	     */
    function trim(string,chars,guard){
    string=toString(string);
    if(string&&(guard||chars===undefined$1)){
    return baseTrim(string);
    }
    if(!string||!(chars=baseToString(chars))){
    return string;
    }
    var strSymbols=stringToArray(string),
    chrSymbols=stringToArray(chars),
    start=charsStartIndex(strSymbols,chrSymbols),
    end=charsEndIndex(strSymbols,chrSymbols)+1;

    return castSlice(strSymbols,start,end).join('');
    }

    /**
    	     * Removes trailing whitespace or specified characters from `string`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to trim.
    	     * @param {string} [chars=whitespace] The characters to trim.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {string} Returns the trimmed string.
    	     * @example
    	     *
    	     * _.trimEnd('  abc  ');
    	     * // => '  abc'
    	     *
    	     * _.trimEnd('-_-abc-_-', '_-');
    	     * // => '-_-abc'
    	     */
    function trimEnd(string,chars,guard){
    string=toString(string);
    if(string&&(guard||chars===undefined$1)){
    return string.slice(0,trimmedEndIndex(string)+1);
    }
    if(!string||!(chars=baseToString(chars))){
    return string;
    }
    var strSymbols=stringToArray(string),
    end=charsEndIndex(strSymbols,stringToArray(chars))+1;

    return castSlice(strSymbols,0,end).join('');
    }

    /**
    	     * Removes leading whitespace or specified characters from `string`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to trim.
    	     * @param {string} [chars=whitespace] The characters to trim.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {string} Returns the trimmed string.
    	     * @example
    	     *
    	     * _.trimStart('  abc  ');
    	     * // => 'abc  '
    	     *
    	     * _.trimStart('-_-abc-_-', '_-');
    	     * // => 'abc-_-'
    	     */
    function trimStart(string,chars,guard){
    string=toString(string);
    if(string&&(guard||chars===undefined$1)){
    return string.replace(reTrimStart,'');
    }
    if(!string||!(chars=baseToString(chars))){
    return string;
    }
    var strSymbols=stringToArray(string),
    start=charsStartIndex(strSymbols,stringToArray(chars));

    return castSlice(strSymbols,start).join('');
    }

    /**
    	     * Truncates `string` if it's longer than the given maximum string length.
    	     * The last characters of the truncated string are replaced with the omission
    	     * string which defaults to "...".
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to truncate.
    	     * @param {Object} [options={}] The options object.
    	     * @param {number} [options.length=30] The maximum string length.
    	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
    	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
    	     * @returns {string} Returns the truncated string.
    	     * @example
    	     *
    	     * _.truncate('hi-diddly-ho there, neighborino');
    	     * // => 'hi-diddly-ho there, neighbo...'
    	     *
    	     * _.truncate('hi-diddly-ho there, neighborino', {
    	     *   'length': 24,
    	     *   'separator': ' '
    	     * });
    	     * // => 'hi-diddly-ho there,...'
    	     *
    	     * _.truncate('hi-diddly-ho there, neighborino', {
    	     *   'length': 24,
    	     *   'separator': /,? +/
    	     * });
    	     * // => 'hi-diddly-ho there...'
    	     *
    	     * _.truncate('hi-diddly-ho there, neighborino', {
    	     *   'omission': ' [...]'
    	     * });
    	     * // => 'hi-diddly-ho there, neig [...]'
    	     */
    function truncate(string,options){
    var length=DEFAULT_TRUNC_LENGTH,
    omission=DEFAULT_TRUNC_OMISSION;

    if(isObject(options)){
    var separator='separator'in options?options.separator:separator;
    length='length'in options?toInteger(options.length):length;
    omission='omission'in options?baseToString(options.omission):omission;
    }
    string=toString(string);

    var strLength=string.length;
    if(hasUnicode(string)){
    var strSymbols=stringToArray(string);
    strLength=strSymbols.length;
    }
    if(length>=strLength){
    return string;
    }
    var end=length-stringSize(omission);
    if(end<1){
    return omission;
    }
    var result=strSymbols?
    castSlice(strSymbols,0,end).join(''):
    string.slice(0,end);

    if(separator===undefined$1){
    return result+omission;
    }
    if(strSymbols){
    end+=result.length-end;
    }
    if(isRegExp(separator)){
    if(string.slice(end).search(separator)){
    var match,
    substring=result;

    if(!separator.global){
    separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');
    }
    separator.lastIndex=0;
    while(match=separator.exec(substring)){
    var newEnd=match.index;
    }
    result=result.slice(0,newEnd===undefined$1?end:newEnd);
    }
    }else if(string.indexOf(baseToString(separator),end)!=end){
    var index=result.lastIndexOf(separator);
    if(index>-1){
    result=result.slice(0,index);
    }
    }
    return result+omission;
    }

    /**
    	     * The inverse of `_.escape`; this method converts the HTML entities
    	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
    	     * their corresponding characters.
    	     *
    	     * **Note:** No other HTML entities are unescaped. To unescape additional
    	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 0.6.0
    	     * @category String
    	     * @param {string} [string=''] The string to unescape.
    	     * @returns {string} Returns the unescaped string.
    	     * @example
    	     *
    	     * _.unescape('fred, barney, &amp; pebbles');
    	     * // => 'fred, barney, & pebbles'
    	     */
    function unescape(string){
    string=toString(string);
    return string&&reHasEscapedHtml.test(string)?
    string.replace(reEscapedHtml,unescapeHtmlChar):
    string;
    }

    /**
    	     * Converts `string`, as space separated words, to upper case.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to convert.
    	     * @returns {string} Returns the upper cased string.
    	     * @example
    	     *
    	     * _.upperCase('--foo-bar');
    	     * // => 'FOO BAR'
    	     *
    	     * _.upperCase('fooBar');
    	     * // => 'FOO BAR'
    	     *
    	     * _.upperCase('__foo_bar__');
    	     * // => 'FOO BAR'
    	     */
    var upperCase=createCompounder(function(result,word,index){
    return result+(index?' ':'')+word.toUpperCase();
    });

    /**
    	     * Converts the first character of `string` to upper case.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to convert.
    	     * @returns {string} Returns the converted string.
    	     * @example
    	     *
    	     * _.upperFirst('fred');
    	     * // => 'Fred'
    	     *
    	     * _.upperFirst('FRED');
    	     * // => 'FRED'
    	     */
    var upperFirst=createCaseFirst('toUpperCase');

    /**
    	     * Splits `string` into an array of its words.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category String
    	     * @param {string} [string=''] The string to inspect.
    	     * @param {RegExp|string} [pattern] The pattern to match words.
    	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
    	     * @returns {Array} Returns the words of `string`.
    	     * @example
    	     *
    	     * _.words('fred, barney, & pebbles');
    	     * // => ['fred', 'barney', 'pebbles']
    	     *
    	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
    	     * // => ['fred', 'barney', '&', 'pebbles']
    	     */
    function words(string,pattern,guard){
    string=toString(string);
    pattern=guard?undefined$1:pattern;

    if(pattern===undefined$1){
    return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);
    }
    return string.match(pattern)||[];
    }

    /*------------------------------------------------------------------------*/

    /**
    	     * Attempts to invoke `func`, returning either the result or the caught error
    	     * object. Any additional arguments are provided to `func` when it's invoked.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Util
    	     * @param {Function} func The function to attempt.
    	     * @param {...*} [args] The arguments to invoke `func` with.
    	     * @returns {*} Returns the `func` result or error object.
    	     * @example
    	     *
    	     * // Avoid throwing errors for invalid selectors.
    	     * var elements = _.attempt(function(selector) {
    	     *   return document.querySelectorAll(selector);
    	     * }, '>_>');
    	     *
    	     * if (_.isError(elements)) {
    	     *   elements = [];
    	     * }
    	     */
    var attempt=baseRest(function(func,args){
    try{
    return apply(func,undefined$1,args);
    }catch(e){
    return isError(e)?e:new Error(e);
    }
    });

    /**
    	     * Binds methods of an object to the object itself, overwriting the existing
    	     * method.
    	     *
    	     * **Note:** This method doesn't set the "length" property of bound functions.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Util
    	     * @param {Object} object The object to bind and assign the bound methods to.
    	     * @param {...(string|string[])} methodNames The object method names to bind.
    	     * @returns {Object} Returns `object`.
    	     * @example
    	     *
    	     * var view = {
    	     *   'label': 'docs',
    	     *   'click': function() {
    	     *     console.log('clicked ' + this.label);
    	     *   }
    	     * };
    	     *
    	     * _.bindAll(view, ['click']);
    	     * jQuery(element).on('click', view.click);
    	     * // => Logs 'clicked docs' when clicked.
    	     */
    var bindAll=flatRest(function(object,methodNames){
    arrayEach(methodNames,function(key){
    key=toKey(key);
    baseAssignValue(object,key,bind(object[key],object));
    });
    return object;
    });

    /**
    	     * Creates a function that iterates over `pairs` and invokes the corresponding
    	     * function of the first predicate to return truthy. The predicate-function
    	     * pairs are invoked with the `this` binding and arguments of the created
    	     * function.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Util
    	     * @param {Array} pairs The predicate-function pairs.
    	     * @returns {Function} Returns the new composite function.
    	     * @example
    	     *
    	     * var func = _.cond([
    	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
    	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
    	     *   [_.stubTrue,                      _.constant('no match')]
    	     * ]);
    	     *
    	     * func({ 'a': 1, 'b': 2 });
    	     * // => 'matches A'
    	     *
    	     * func({ 'a': 0, 'b': 1 });
    	     * // => 'matches B'
    	     *
    	     * func({ 'a': '1', 'b': '2' });
    	     * // => 'no match'
    	     */
    function cond(pairs){
    var length=pairs==null?0:pairs.length,
    toIteratee=getIteratee();

    pairs=!length?[]:arrayMap(pairs,function(pair){
    if(typeof pair[1]!='function'){
    throw new TypeError(FUNC_ERROR_TEXT);
    }
    return [toIteratee(pair[0]),pair[1]];
    });

    return baseRest(function(args){
    var index=-1;
    while(++index<length){
    var pair=pairs[index];
    if(apply(pair[0],this,args)){
    return apply(pair[1],this,args);
    }
    }
    });
    }

    /**
    	     * Creates a function that invokes the predicate properties of `source` with
    	     * the corresponding property values of a given object, returning `true` if
    	     * all predicates return truthy, else `false`.
    	     *
    	     * **Note:** The created function is equivalent to `_.conformsTo` with
    	     * `source` partially applied.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Util
    	     * @param {Object} source The object of property predicates to conform to.
    	     * @returns {Function} Returns the new spec function.
    	     * @example
    	     *
    	     * var objects = [
    	     *   { 'a': 2, 'b': 1 },
    	     *   { 'a': 1, 'b': 2 }
    	     * ];
    	     *
    	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
    	     * // => [{ 'a': 1, 'b': 2 }]
    	     */
    function conforms(source){
    return baseConforms(baseClone(source,CLONE_DEEP_FLAG));
    }

    /**
    	     * Creates a function that returns `value`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.4.0
    	     * @category Util
    	     * @param {*} value The value to return from the new function.
    	     * @returns {Function} Returns the new constant function.
    	     * @example
    	     *
    	     * var objects = _.times(2, _.constant({ 'a': 1 }));
    	     *
    	     * console.log(objects);
    	     * // => [{ 'a': 1 }, { 'a': 1 }]
    	     *
    	     * console.log(objects[0] === objects[1]);
    	     * // => true
    	     */
    function constant(value){
    return function(){
    return value;
    };
    }

    /**
    	     * Checks `value` to determine whether a default value should be returned in
    	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
    	     * or `undefined`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.14.0
    	     * @category Util
    	     * @param {*} value The value to check.
    	     * @param {*} defaultValue The default value.
    	     * @returns {*} Returns the resolved value.
    	     * @example
    	     *
    	     * _.defaultTo(1, 10);
    	     * // => 1
    	     *
    	     * _.defaultTo(undefined, 10);
    	     * // => 10
    	     */
    function defaultTo(value,defaultValue){
    return value==null||value!==value?defaultValue:value;
    }

    /**
    	     * Creates a function that returns the result of invoking the given functions
    	     * with the `this` binding of the created function, where each successive
    	     * invocation is supplied the return value of the previous.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Util
    	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
    	     * @returns {Function} Returns the new composite function.
    	     * @see _.flowRight
    	     * @example
    	     *
    	     * function square(n) {
    	     *   return n * n;
    	     * }
    	     *
    	     * var addSquare = _.flow([_.add, square]);
    	     * addSquare(1, 2);
    	     * // => 9
    	     */
    var flow=createFlow();

    /**
    	     * This method is like `_.flow` except that it creates a function that
    	     * invokes the given functions from right to left.
    	     *
    	     * @static
    	     * @since 3.0.0
    	     * @memberOf _
    	     * @category Util
    	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
    	     * @returns {Function} Returns the new composite function.
    	     * @see _.flow
    	     * @example
    	     *
    	     * function square(n) {
    	     *   return n * n;
    	     * }
    	     *
    	     * var addSquare = _.flowRight([square, _.add]);
    	     * addSquare(1, 2);
    	     * // => 9
    	     */
    var flowRight=createFlow(true);

    /**
    	     * This method returns the first argument it receives.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Util
    	     * @param {*} value Any value.
    	     * @returns {*} Returns `value`.
    	     * @example
    	     *
    	     * var object = { 'a': 1 };
    	     *
    	     * console.log(_.identity(object) === object);
    	     * // => true
    	     */
    function identity(value){
    return value;
    }

    /**
    	     * Creates a function that invokes `func` with the arguments of the created
    	     * function. If `func` is a property name, the created function returns the
    	     * property value for a given element. If `func` is an array or object, the
    	     * created function returns `true` for elements that contain the equivalent
    	     * source properties, otherwise it returns `false`.
    	     *
    	     * @static
    	     * @since 4.0.0
    	     * @memberOf _
    	     * @category Util
    	     * @param {*} [func=_.identity] The value to convert to a callback.
    	     * @returns {Function} Returns the callback.
    	     * @example
    	     *
    	     * var users = [
    	     *   { 'user': 'barney', 'age': 36, 'active': true },
    	     *   { 'user': 'fred',   'age': 40, 'active': false }
    	     * ];
    	     *
    	     * // The `_.matches` iteratee shorthand.
    	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
    	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
    	     *
    	     * // The `_.matchesProperty` iteratee shorthand.
    	     * _.filter(users, _.iteratee(['user', 'fred']));
    	     * // => [{ 'user': 'fred', 'age': 40 }]
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.map(users, _.iteratee('user'));
    	     * // => ['barney', 'fred']
    	     *
    	     * // Create custom iteratee shorthands.
    	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
    	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
    	     *     return func.test(string);
    	     *   };
    	     * });
    	     *
    	     * _.filter(['abc', 'def'], /ef/);
    	     * // => ['def']
    	     */
    function iteratee(func){
    return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));
    }

    /**
    	     * Creates a function that performs a partial deep comparison between a given
    	     * object and `source`, returning `true` if the given object has equivalent
    	     * property values, else `false`.
    	     *
    	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
    	     * partially applied.
    	     *
    	     * Partial comparisons will match empty array and empty object `source`
    	     * values against any array or object value, respectively. See `_.isEqual`
    	     * for a list of supported value comparisons.
    	     *
    	     * **Note:** Multiple values can be checked by combining several matchers
    	     * using `_.overSome`
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Util
    	     * @param {Object} source The object of property values to match.
    	     * @returns {Function} Returns the new spec function.
    	     * @example
    	     *
    	     * var objects = [
    	     *   { 'a': 1, 'b': 2, 'c': 3 },
    	     *   { 'a': 4, 'b': 5, 'c': 6 }
    	     * ];
    	     *
    	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
    	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
    	     *
    	     * // Checking for several possible values
    	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
    	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
    	     */
    function matches(source){
    return baseMatches(baseClone(source,CLONE_DEEP_FLAG));
    }

    /**
    	     * Creates a function that performs a partial deep comparison between the
    	     * value at `path` of a given object to `srcValue`, returning `true` if the
    	     * object value is equivalent, else `false`.
    	     *
    	     * **Note:** Partial comparisons will match empty array and empty object
    	     * `srcValue` values against any array or object value, respectively. See
    	     * `_.isEqual` for a list of supported value comparisons.
    	     *
    	     * **Note:** Multiple values can be checked by combining several matchers
    	     * using `_.overSome`
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.2.0
    	     * @category Util
    	     * @param {Array|string} path The path of the property to get.
    	     * @param {*} srcValue The value to match.
    	     * @returns {Function} Returns the new spec function.
    	     * @example
    	     *
    	     * var objects = [
    	     *   { 'a': 1, 'b': 2, 'c': 3 },
    	     *   { 'a': 4, 'b': 5, 'c': 6 }
    	     * ];
    	     *
    	     * _.find(objects, _.matchesProperty('a', 4));
    	     * // => { 'a': 4, 'b': 5, 'c': 6 }
    	     *
    	     * // Checking for several possible values
    	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
    	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
    	     */
    function matchesProperty(path,srcValue){
    return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));
    }

    /**
    	     * Creates a function that invokes the method at `path` of a given object.
    	     * Any additional arguments are provided to the invoked method.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.7.0
    	     * @category Util
    	     * @param {Array|string} path The path of the method to invoke.
    	     * @param {...*} [args] The arguments to invoke the method with.
    	     * @returns {Function} Returns the new invoker function.
    	     * @example
    	     *
    	     * var objects = [
    	     *   { 'a': { 'b': _.constant(2) } },
    	     *   { 'a': { 'b': _.constant(1) } }
    	     * ];
    	     *
    	     * _.map(objects, _.method('a.b'));
    	     * // => [2, 1]
    	     *
    	     * _.map(objects, _.method(['a', 'b']));
    	     * // => [2, 1]
    	     */
    var method=baseRest(function(path,args){
    return function(object){
    return baseInvoke(object,path,args);
    };
    });

    /**
    	     * The opposite of `_.method`; this method creates a function that invokes
    	     * the method at a given path of `object`. Any additional arguments are
    	     * provided to the invoked method.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.7.0
    	     * @category Util
    	     * @param {Object} object The object to query.
    	     * @param {...*} [args] The arguments to invoke the method with.
    	     * @returns {Function} Returns the new invoker function.
    	     * @example
    	     *
    	     * var array = _.times(3, _.constant),
    	     *     object = { 'a': array, 'b': array, 'c': array };
    	     *
    	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
    	     * // => [2, 0]
    	     *
    	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
    	     * // => [2, 0]
    	     */
    var methodOf=baseRest(function(object,args){
    return function(path){
    return baseInvoke(object,path,args);
    };
    });

    /**
    	     * Adds all own enumerable string keyed function properties of a source
    	     * object to the destination object. If `object` is a function, then methods
    	     * are added to its prototype as well.
    	     *
    	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
    	     * avoid conflicts caused by modifying the original.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Util
    	     * @param {Function|Object} [object=lodash] The destination object.
    	     * @param {Object} source The object of functions to add.
    	     * @param {Object} [options={}] The options object.
    	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
    	     * @returns {Function|Object} Returns `object`.
    	     * @example
    	     *
    	     * function vowels(string) {
    	     *   return _.filter(string, function(v) {
    	     *     return /[aeiou]/i.test(v);
    	     *   });
    	     * }
    	     *
    	     * _.mixin({ 'vowels': vowels });
    	     * _.vowels('fred');
    	     * // => ['e']
    	     *
    	     * _('fred').vowels().value();
    	     * // => ['e']
    	     *
    	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
    	     * _('fred').vowels();
    	     * // => ['e']
    	     */
    function mixin(object,source,options){
    var props=keys(source),
    methodNames=baseFunctions(source,props);

    if(options==null&&
    !(isObject(source)&&(methodNames.length||!props.length))){
    options=source;
    source=object;
    object=this;
    methodNames=baseFunctions(source,keys(source));
    }
    var chain=!(isObject(options)&&'chain'in options)||!!options.chain,
    isFunc=isFunction(object);

    arrayEach(methodNames,function(methodName){
    var func=source[methodName];
    object[methodName]=func;
    if(isFunc){
    object.prototype[methodName]=function(){
    var chainAll=this.__chain__;
    if(chain||chainAll){
    var result=object(this.__wrapped__),
    actions=result.__actions__=copyArray(this.__actions__);

    actions.push({'func':func,'args':arguments,'thisArg':object});
    result.__chain__=chainAll;
    return result;
    }
    return func.apply(object,arrayPush([this.value()],arguments));
    };
    }
    });

    return object;
    }

    /**
    	     * Reverts the `_` variable to its previous value and returns a reference to
    	     * the `lodash` function.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Util
    	     * @returns {Function} Returns the `lodash` function.
    	     * @example
    	     *
    	     * var lodash = _.noConflict();
    	     */
    function noConflict(){
    if(root._===this){
    root._=oldDash;
    }
    return this;
    }

    /**
    	     * This method returns `undefined`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.3.0
    	     * @category Util
    	     * @example
    	     *
    	     * _.times(2, _.noop);
    	     * // => [undefined, undefined]
    	     */
    function noop(){
    // No operation performed.
    }

    /**
    	     * Creates a function that gets the argument at index `n`. If `n` is negative,
    	     * the nth argument from the end is returned.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Util
    	     * @param {number} [n=0] The index of the argument to return.
    	     * @returns {Function} Returns the new pass-thru function.
    	     * @example
    	     *
    	     * var func = _.nthArg(1);
    	     * func('a', 'b', 'c', 'd');
    	     * // => 'b'
    	     *
    	     * var func = _.nthArg(-2);
    	     * func('a', 'b', 'c', 'd');
    	     * // => 'c'
    	     */
    function nthArg(n){
    n=toInteger(n);
    return baseRest(function(args){
    return baseNth(args,n);
    });
    }

    /**
    	     * Creates a function that invokes `iteratees` with the arguments it receives
    	     * and returns their results.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Util
    	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
    	     *  The iteratees to invoke.
    	     * @returns {Function} Returns the new function.
    	     * @example
    	     *
    	     * var func = _.over([Math.max, Math.min]);
    	     *
    	     * func(1, 2, 3, 4);
    	     * // => [4, 1]
    	     */
    var over=createOver(arrayMap);

    /**
    	     * Creates a function that checks if **all** of the `predicates` return
    	     * truthy when invoked with the arguments it receives.
    	     *
    	     * Following shorthands are possible for providing predicates.
    	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
    	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Util
    	     * @param {...(Function|Function[])} [predicates=[_.identity]]
    	     *  The predicates to check.
    	     * @returns {Function} Returns the new function.
    	     * @example
    	     *
    	     * var func = _.overEvery([Boolean, isFinite]);
    	     *
    	     * func('1');
    	     * // => true
    	     *
    	     * func(null);
    	     * // => false
    	     *
    	     * func(NaN);
    	     * // => false
    	     */
    var overEvery=createOver(arrayEvery);

    /**
    	     * Creates a function that checks if **any** of the `predicates` return
    	     * truthy when invoked with the arguments it receives.
    	     *
    	     * Following shorthands are possible for providing predicates.
    	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
    	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Util
    	     * @param {...(Function|Function[])} [predicates=[_.identity]]
    	     *  The predicates to check.
    	     * @returns {Function} Returns the new function.
    	     * @example
    	     *
    	     * var func = _.overSome([Boolean, isFinite]);
    	     *
    	     * func('1');
    	     * // => true
    	     *
    	     * func(null);
    	     * // => true
    	     *
    	     * func(NaN);
    	     * // => false
    	     *
    	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
    	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
    	     */
    var overSome=createOver(arraySome);

    /**
    	     * Creates a function that returns the value at `path` of a given object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 2.4.0
    	     * @category Util
    	     * @param {Array|string} path The path of the property to get.
    	     * @returns {Function} Returns the new accessor function.
    	     * @example
    	     *
    	     * var objects = [
    	     *   { 'a': { 'b': 2 } },
    	     *   { 'a': { 'b': 1 } }
    	     * ];
    	     *
    	     * _.map(objects, _.property('a.b'));
    	     * // => [2, 1]
    	     *
    	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
    	     * // => [1, 2]
    	     */
    function property(path){
    return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);
    }

    /**
    	     * The opposite of `_.property`; this method creates a function that returns
    	     * the value at a given path of `object`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.0.0
    	     * @category Util
    	     * @param {Object} object The object to query.
    	     * @returns {Function} Returns the new accessor function.
    	     * @example
    	     *
    	     * var array = [0, 1, 2],
    	     *     object = { 'a': array, 'b': array, 'c': array };
    	     *
    	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
    	     * // => [2, 0]
    	     *
    	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
    	     * // => [2, 0]
    	     */
    function propertyOf(object){
    return function(path){
    return object==null?undefined$1:baseGet(object,path);
    };
    }

    /**
    	     * Creates an array of numbers (positive and/or negative) progressing from
    	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
    	     * `start` is specified without an `end` or `step`. If `end` is not specified,
    	     * it's set to `start` with `start` then set to `0`.
    	     *
    	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
    	     * floating-point values which can produce unexpected results.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Util
    	     * @param {number} [start=0] The start of the range.
    	     * @param {number} end The end of the range.
    	     * @param {number} [step=1] The value to increment or decrement by.
    	     * @returns {Array} Returns the range of numbers.
    	     * @see _.inRange, _.rangeRight
    	     * @example
    	     *
    	     * _.range(4);
    	     * // => [0, 1, 2, 3]
    	     *
    	     * _.range(-4);
    	     * // => [0, -1, -2, -3]
    	     *
    	     * _.range(1, 5);
    	     * // => [1, 2, 3, 4]
    	     *
    	     * _.range(0, 20, 5);
    	     * // => [0, 5, 10, 15]
    	     *
    	     * _.range(0, -4, -1);
    	     * // => [0, -1, -2, -3]
    	     *
    	     * _.range(1, 4, 0);
    	     * // => [1, 1, 1]
    	     *
    	     * _.range(0);
    	     * // => []
    	     */
    var range=createRange();

    /**
    	     * This method is like `_.range` except that it populates values in
    	     * descending order.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Util
    	     * @param {number} [start=0] The start of the range.
    	     * @param {number} end The end of the range.
    	     * @param {number} [step=1] The value to increment or decrement by.
    	     * @returns {Array} Returns the range of numbers.
    	     * @see _.inRange, _.range
    	     * @example
    	     *
    	     * _.rangeRight(4);
    	     * // => [3, 2, 1, 0]
    	     *
    	     * _.rangeRight(-4);
    	     * // => [-3, -2, -1, 0]
    	     *
    	     * _.rangeRight(1, 5);
    	     * // => [4, 3, 2, 1]
    	     *
    	     * _.rangeRight(0, 20, 5);
    	     * // => [15, 10, 5, 0]
    	     *
    	     * _.rangeRight(0, -4, -1);
    	     * // => [-3, -2, -1, 0]
    	     *
    	     * _.rangeRight(1, 4, 0);
    	     * // => [1, 1, 1]
    	     *
    	     * _.rangeRight(0);
    	     * // => []
    	     */
    var rangeRight=createRange(true);

    /**
    	     * This method returns a new empty array.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.13.0
    	     * @category Util
    	     * @returns {Array} Returns the new empty array.
    	     * @example
    	     *
    	     * var arrays = _.times(2, _.stubArray);
    	     *
    	     * console.log(arrays);
    	     * // => [[], []]
    	     *
    	     * console.log(arrays[0] === arrays[1]);
    	     * // => false
    	     */
    function stubArray(){
    return [];
    }

    /**
    	     * This method returns `false`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.13.0
    	     * @category Util
    	     * @returns {boolean} Returns `false`.
    	     * @example
    	     *
    	     * _.times(2, _.stubFalse);
    	     * // => [false, false]
    	     */
    function stubFalse(){
    return false;
    }

    /**
    	     * This method returns a new empty object.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.13.0
    	     * @category Util
    	     * @returns {Object} Returns the new empty object.
    	     * @example
    	     *
    	     * var objects = _.times(2, _.stubObject);
    	     *
    	     * console.log(objects);
    	     * // => [{}, {}]
    	     *
    	     * console.log(objects[0] === objects[1]);
    	     * // => false
    	     */
    function stubObject(){
    return {};
    }

    /**
    	     * This method returns an empty string.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.13.0
    	     * @category Util
    	     * @returns {string} Returns the empty string.
    	     * @example
    	     *
    	     * _.times(2, _.stubString);
    	     * // => ['', '']
    	     */
    function stubString(){
    return '';
    }

    /**
    	     * This method returns `true`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.13.0
    	     * @category Util
    	     * @returns {boolean} Returns `true`.
    	     * @example
    	     *
    	     * _.times(2, _.stubTrue);
    	     * // => [true, true]
    	     */
    function stubTrue(){
    return true;
    }

    /**
    	     * Invokes the iteratee `n` times, returning an array of the results of
    	     * each invocation. The iteratee is invoked with one argument; (index).
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Util
    	     * @param {number} n The number of times to invoke `iteratee`.
    	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
    	     * @returns {Array} Returns the array of results.
    	     * @example
    	     *
    	     * _.times(3, String);
    	     * // => ['0', '1', '2']
    	     *
    	     *  _.times(4, _.constant(0));
    	     * // => [0, 0, 0, 0]
    	     */
    function times(n,iteratee){
    n=toInteger(n);
    if(n<1||n>MAX_SAFE_INTEGER){
    return [];
    }
    var index=MAX_ARRAY_LENGTH,
    length=nativeMin(n,MAX_ARRAY_LENGTH);

    iteratee=getIteratee(iteratee);
    n-=MAX_ARRAY_LENGTH;

    var result=baseTimes(length,iteratee);
    while(++index<n){
    iteratee(index);
    }
    return result;
    }

    /**
    	     * Converts `value` to a property path array.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Util
    	     * @param {*} value The value to convert.
    	     * @returns {Array} Returns the new property path array.
    	     * @example
    	     *
    	     * _.toPath('a.b.c');
    	     * // => ['a', 'b', 'c']
    	     *
    	     * _.toPath('a[0].b.c');
    	     * // => ['a', '0', 'b', 'c']
    	     */
    function toPath(value){
    if(isArray(value)){
    return arrayMap(value,toKey);
    }
    return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));
    }

    /**
    	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Util
    	     * @param {string} [prefix=''] The value to prefix the ID with.
    	     * @returns {string} Returns the unique ID.
    	     * @example
    	     *
    	     * _.uniqueId('contact_');
    	     * // => 'contact_104'
    	     *
    	     * _.uniqueId();
    	     * // => '105'
    	     */
    function uniqueId(prefix){
    var id=++idCounter;
    return toString(prefix)+id;
    }

    /*------------------------------------------------------------------------*/

    /**
    	     * Adds two numbers.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.4.0
    	     * @category Math
    	     * @param {number} augend The first number in an addition.
    	     * @param {number} addend The second number in an addition.
    	     * @returns {number} Returns the total.
    	     * @example
    	     *
    	     * _.add(6, 4);
    	     * // => 10
    	     */
    var add=createMathOperation(function(augend,addend){
    return augend+addend;
    },0);

    /**
    	     * Computes `number` rounded up to `precision`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.10.0
    	     * @category Math
    	     * @param {number} number The number to round up.
    	     * @param {number} [precision=0] The precision to round up to.
    	     * @returns {number} Returns the rounded up number.
    	     * @example
    	     *
    	     * _.ceil(4.006);
    	     * // => 5
    	     *
    	     * _.ceil(6.004, 2);
    	     * // => 6.01
    	     *
    	     * _.ceil(6040, -2);
    	     * // => 6100
    	     */
    var ceil=createRound('ceil');

    /**
    	     * Divide two numbers.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.7.0
    	     * @category Math
    	     * @param {number} dividend The first number in a division.
    	     * @param {number} divisor The second number in a division.
    	     * @returns {number} Returns the quotient.
    	     * @example
    	     *
    	     * _.divide(6, 4);
    	     * // => 1.5
    	     */
    var divide=createMathOperation(function(dividend,divisor){
    return dividend/divisor;
    },1);

    /**
    	     * Computes `number` rounded down to `precision`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.10.0
    	     * @category Math
    	     * @param {number} number The number to round down.
    	     * @param {number} [precision=0] The precision to round down to.
    	     * @returns {number} Returns the rounded down number.
    	     * @example
    	     *
    	     * _.floor(4.006);
    	     * // => 4
    	     *
    	     * _.floor(0.046, 2);
    	     * // => 0.04
    	     *
    	     * _.floor(4060, -2);
    	     * // => 4000
    	     */
    var floor=createRound('floor');

    /**
    	     * Computes the maximum value of `array`. If `array` is empty or falsey,
    	     * `undefined` is returned.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Math
    	     * @param {Array} array The array to iterate over.
    	     * @returns {*} Returns the maximum value.
    	     * @example
    	     *
    	     * _.max([4, 2, 8, 6]);
    	     * // => 8
    	     *
    	     * _.max([]);
    	     * // => undefined
    	     */
    function max(array){
    return array&&array.length?
    baseExtremum(array,identity,baseGt):
    undefined$1;
    }

    /**
    	     * This method is like `_.max` except that it accepts `iteratee` which is
    	     * invoked for each element in `array` to generate the criterion by which
    	     * the value is ranked. The iteratee is invoked with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Math
    	     * @param {Array} array The array to iterate over.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {*} Returns the maximum value.
    	     * @example
    	     *
    	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
    	     *
    	     * _.maxBy(objects, function(o) { return o.n; });
    	     * // => { 'n': 2 }
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.maxBy(objects, 'n');
    	     * // => { 'n': 2 }
    	     */
    function maxBy(array,iteratee){
    return array&&array.length?
    baseExtremum(array,getIteratee(iteratee,2),baseGt):
    undefined$1;
    }

    /**
    	     * Computes the mean of the values in `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Math
    	     * @param {Array} array The array to iterate over.
    	     * @returns {number} Returns the mean.
    	     * @example
    	     *
    	     * _.mean([4, 2, 8, 6]);
    	     * // => 5
    	     */
    function mean(array){
    return baseMean(array,identity);
    }

    /**
    	     * This method is like `_.mean` except that it accepts `iteratee` which is
    	     * invoked for each element in `array` to generate the value to be averaged.
    	     * The iteratee is invoked with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.7.0
    	     * @category Math
    	     * @param {Array} array The array to iterate over.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {number} Returns the mean.
    	     * @example
    	     *
    	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
    	     *
    	     * _.meanBy(objects, function(o) { return o.n; });
    	     * // => 5
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.meanBy(objects, 'n');
    	     * // => 5
    	     */
    function meanBy(array,iteratee){
    return baseMean(array,getIteratee(iteratee,2));
    }

    /**
    	     * Computes the minimum value of `array`. If `array` is empty or falsey,
    	     * `undefined` is returned.
    	     *
    	     * @static
    	     * @since 0.1.0
    	     * @memberOf _
    	     * @category Math
    	     * @param {Array} array The array to iterate over.
    	     * @returns {*} Returns the minimum value.
    	     * @example
    	     *
    	     * _.min([4, 2, 8, 6]);
    	     * // => 2
    	     *
    	     * _.min([]);
    	     * // => undefined
    	     */
    function min(array){
    return array&&array.length?
    baseExtremum(array,identity,baseLt):
    undefined$1;
    }

    /**
    	     * This method is like `_.min` except that it accepts `iteratee` which is
    	     * invoked for each element in `array` to generate the criterion by which
    	     * the value is ranked. The iteratee is invoked with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Math
    	     * @param {Array} array The array to iterate over.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {*} Returns the minimum value.
    	     * @example
    	     *
    	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
    	     *
    	     * _.minBy(objects, function(o) { return o.n; });
    	     * // => { 'n': 1 }
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.minBy(objects, 'n');
    	     * // => { 'n': 1 }
    	     */
    function minBy(array,iteratee){
    return array&&array.length?
    baseExtremum(array,getIteratee(iteratee,2),baseLt):
    undefined$1;
    }

    /**
    	     * Multiply two numbers.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.7.0
    	     * @category Math
    	     * @param {number} multiplier The first number in a multiplication.
    	     * @param {number} multiplicand The second number in a multiplication.
    	     * @returns {number} Returns the product.
    	     * @example
    	     *
    	     * _.multiply(6, 4);
    	     * // => 24
    	     */
    var multiply=createMathOperation(function(multiplier,multiplicand){
    return multiplier*multiplicand;
    },1);

    /**
    	     * Computes `number` rounded to `precision`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.10.0
    	     * @category Math
    	     * @param {number} number The number to round.
    	     * @param {number} [precision=0] The precision to round to.
    	     * @returns {number} Returns the rounded number.
    	     * @example
    	     *
    	     * _.round(4.006);
    	     * // => 4
    	     *
    	     * _.round(4.006, 2);
    	     * // => 4.01
    	     *
    	     * _.round(4060, -2);
    	     * // => 4100
    	     */
    var round=createRound('round');

    /**
    	     * Subtract two numbers.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Math
    	     * @param {number} minuend The first number in a subtraction.
    	     * @param {number} subtrahend The second number in a subtraction.
    	     * @returns {number} Returns the difference.
    	     * @example
    	     *
    	     * _.subtract(6, 4);
    	     * // => 2
    	     */
    var subtract=createMathOperation(function(minuend,subtrahend){
    return minuend-subtrahend;
    },0);

    /**
    	     * Computes the sum of the values in `array`.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 3.4.0
    	     * @category Math
    	     * @param {Array} array The array to iterate over.
    	     * @returns {number} Returns the sum.
    	     * @example
    	     *
    	     * _.sum([4, 2, 8, 6]);
    	     * // => 20
    	     */
    function sum(array){
    return array&&array.length?
    baseSum(array,identity):
    0;
    }

    /**
    	     * This method is like `_.sum` except that it accepts `iteratee` which is
    	     * invoked for each element in `array` to generate the value to be summed.
    	     * The iteratee is invoked with one argument: (value).
    	     *
    	     * @static
    	     * @memberOf _
    	     * @since 4.0.0
    	     * @category Math
    	     * @param {Array} array The array to iterate over.
    	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
    	     * @returns {number} Returns the sum.
    	     * @example
    	     *
    	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
    	     *
    	     * _.sumBy(objects, function(o) { return o.n; });
    	     * // => 20
    	     *
    	     * // The `_.property` iteratee shorthand.
    	     * _.sumBy(objects, 'n');
    	     * // => 20
    	     */
    function sumBy(array,iteratee){
    return array&&array.length?
    baseSum(array,getIteratee(iteratee,2)):
    0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after=after;
    lodash.ary=ary;
    lodash.assign=assign;
    lodash.assignIn=assignIn;
    lodash.assignInWith=assignInWith;
    lodash.assignWith=assignWith;
    lodash.at=at;
    lodash.before=before;
    lodash.bind=bind;
    lodash.bindAll=bindAll;
    lodash.bindKey=bindKey;
    lodash.castArray=castArray;
    lodash.chain=chain;
    lodash.chunk=chunk;
    lodash.compact=compact;
    lodash.concat=concat;
    lodash.cond=cond;
    lodash.conforms=conforms;
    lodash.constant=constant;
    lodash.countBy=countBy;
    lodash.create=create;
    lodash.curry=curry;
    lodash.curryRight=curryRight;
    lodash.debounce=debounce;
    lodash.defaults=defaults;
    lodash.defaultsDeep=defaultsDeep;
    lodash.defer=defer;
    lodash.delay=delay;
    lodash.difference=difference;
    lodash.differenceBy=differenceBy;
    lodash.differenceWith=differenceWith;
    lodash.drop=drop;
    lodash.dropRight=dropRight;
    lodash.dropRightWhile=dropRightWhile;
    lodash.dropWhile=dropWhile;
    lodash.fill=fill;
    lodash.filter=filter;
    lodash.flatMap=flatMap;
    lodash.flatMapDeep=flatMapDeep;
    lodash.flatMapDepth=flatMapDepth;
    lodash.flatten=flatten;
    lodash.flattenDeep=flattenDeep;
    lodash.flattenDepth=flattenDepth;
    lodash.flip=flip;
    lodash.flow=flow;
    lodash.flowRight=flowRight;
    lodash.fromPairs=fromPairs;
    lodash.functions=functions;
    lodash.functionsIn=functionsIn;
    lodash.groupBy=groupBy;
    lodash.initial=initial;
    lodash.intersection=intersection;
    lodash.intersectionBy=intersectionBy;
    lodash.intersectionWith=intersectionWith;
    lodash.invert=invert;
    lodash.invertBy=invertBy;
    lodash.invokeMap=invokeMap;
    lodash.iteratee=iteratee;
    lodash.keyBy=keyBy;
    lodash.keys=keys;
    lodash.keysIn=keysIn;
    lodash.map=map;
    lodash.mapKeys=mapKeys;
    lodash.mapValues=mapValues;
    lodash.matches=matches;
    lodash.matchesProperty=matchesProperty;
    lodash.memoize=memoize;
    lodash.merge=merge;
    lodash.mergeWith=mergeWith;
    lodash.method=method;
    lodash.methodOf=methodOf;
    lodash.mixin=mixin;
    lodash.negate=negate;
    lodash.nthArg=nthArg;
    lodash.omit=omit;
    lodash.omitBy=omitBy;
    lodash.once=once;
    lodash.orderBy=orderBy;
    lodash.over=over;
    lodash.overArgs=overArgs;
    lodash.overEvery=overEvery;
    lodash.overSome=overSome;
    lodash.partial=partial;
    lodash.partialRight=partialRight;
    lodash.partition=partition;
    lodash.pick=pick;
    lodash.pickBy=pickBy;
    lodash.property=property;
    lodash.propertyOf=propertyOf;
    lodash.pull=pull;
    lodash.pullAll=pullAll;
    lodash.pullAllBy=pullAllBy;
    lodash.pullAllWith=pullAllWith;
    lodash.pullAt=pullAt;
    lodash.range=range;
    lodash.rangeRight=rangeRight;
    lodash.rearg=rearg;
    lodash.reject=reject;
    lodash.remove=remove;
    lodash.rest=rest;
    lodash.reverse=reverse;
    lodash.sampleSize=sampleSize;
    lodash.set=set;
    lodash.setWith=setWith;
    lodash.shuffle=shuffle;
    lodash.slice=slice;
    lodash.sortBy=sortBy;
    lodash.sortedUniq=sortedUniq;
    lodash.sortedUniqBy=sortedUniqBy;
    lodash.split=split;
    lodash.spread=spread;
    lodash.tail=tail;
    lodash.take=take;
    lodash.takeRight=takeRight;
    lodash.takeRightWhile=takeRightWhile;
    lodash.takeWhile=takeWhile;
    lodash.tap=tap;
    lodash.throttle=throttle;
    lodash.thru=thru;
    lodash.toArray=toArray;
    lodash.toPairs=toPairs;
    lodash.toPairsIn=toPairsIn;
    lodash.toPath=toPath;
    lodash.toPlainObject=toPlainObject;
    lodash.transform=transform;
    lodash.unary=unary;
    lodash.union=union;
    lodash.unionBy=unionBy;
    lodash.unionWith=unionWith;
    lodash.uniq=uniq;
    lodash.uniqBy=uniqBy;
    lodash.uniqWith=uniqWith;
    lodash.unset=unset;
    lodash.unzip=unzip;
    lodash.unzipWith=unzipWith;
    lodash.update=update;
    lodash.updateWith=updateWith;
    lodash.values=values;
    lodash.valuesIn=valuesIn;
    lodash.without=without;
    lodash.words=words;
    lodash.wrap=wrap;
    lodash.xor=xor;
    lodash.xorBy=xorBy;
    lodash.xorWith=xorWith;
    lodash.zip=zip;
    lodash.zipObject=zipObject;
    lodash.zipObjectDeep=zipObjectDeep;
    lodash.zipWith=zipWith;

    // Add aliases.
    lodash.entries=toPairs;
    lodash.entriesIn=toPairsIn;
    lodash.extend=assignIn;
    lodash.extendWith=assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash,lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add=add;
    lodash.attempt=attempt;
    lodash.camelCase=camelCase;
    lodash.capitalize=capitalize;
    lodash.ceil=ceil;
    lodash.clamp=clamp;
    lodash.clone=clone;
    lodash.cloneDeep=cloneDeep;
    lodash.cloneDeepWith=cloneDeepWith;
    lodash.cloneWith=cloneWith;
    lodash.conformsTo=conformsTo;
    lodash.deburr=deburr;
    lodash.defaultTo=defaultTo;
    lodash.divide=divide;
    lodash.endsWith=endsWith;
    lodash.eq=eq;
    lodash.escape=escape;
    lodash.escapeRegExp=escapeRegExp;
    lodash.every=every;
    lodash.find=find;
    lodash.findIndex=findIndex;
    lodash.findKey=findKey;
    lodash.findLast=findLast;
    lodash.findLastIndex=findLastIndex;
    lodash.findLastKey=findLastKey;
    lodash.floor=floor;
    lodash.forEach=forEach;
    lodash.forEachRight=forEachRight;
    lodash.forIn=forIn;
    lodash.forInRight=forInRight;
    lodash.forOwn=forOwn;
    lodash.forOwnRight=forOwnRight;
    lodash.get=get;
    lodash.gt=gt;
    lodash.gte=gte;
    lodash.has=has;
    lodash.hasIn=hasIn;
    lodash.head=head;
    lodash.identity=identity;
    lodash.includes=includes;
    lodash.indexOf=indexOf;
    lodash.inRange=inRange;
    lodash.invoke=invoke;
    lodash.isArguments=isArguments;
    lodash.isArray=isArray;
    lodash.isArrayBuffer=isArrayBuffer;
    lodash.isArrayLike=isArrayLike;
    lodash.isArrayLikeObject=isArrayLikeObject;
    lodash.isBoolean=isBoolean;
    lodash.isBuffer=isBuffer;
    lodash.isDate=isDate;
    lodash.isElement=isElement;
    lodash.isEmpty=isEmpty;
    lodash.isEqual=isEqual;
    lodash.isEqualWith=isEqualWith;
    lodash.isError=isError;
    lodash.isFinite=isFinite;
    lodash.isFunction=isFunction;
    lodash.isInteger=isInteger;
    lodash.isLength=isLength;
    lodash.isMap=isMap;
    lodash.isMatch=isMatch;
    lodash.isMatchWith=isMatchWith;
    lodash.isNaN=isNaN;
    lodash.isNative=isNative;
    lodash.isNil=isNil;
    lodash.isNull=isNull;
    lodash.isNumber=isNumber;
    lodash.isObject=isObject;
    lodash.isObjectLike=isObjectLike;
    lodash.isPlainObject=isPlainObject;
    lodash.isRegExp=isRegExp;
    lodash.isSafeInteger=isSafeInteger;
    lodash.isSet=isSet;
    lodash.isString=isString;
    lodash.isSymbol=isSymbol;
    lodash.isTypedArray=isTypedArray;
    lodash.isUndefined=isUndefined;
    lodash.isWeakMap=isWeakMap;
    lodash.isWeakSet=isWeakSet;
    lodash.join=join;
    lodash.kebabCase=kebabCase;
    lodash.last=last;
    lodash.lastIndexOf=lastIndexOf;
    lodash.lowerCase=lowerCase;
    lodash.lowerFirst=lowerFirst;
    lodash.lt=lt;
    lodash.lte=lte;
    lodash.max=max;
    lodash.maxBy=maxBy;
    lodash.mean=mean;
    lodash.meanBy=meanBy;
    lodash.min=min;
    lodash.minBy=minBy;
    lodash.stubArray=stubArray;
    lodash.stubFalse=stubFalse;
    lodash.stubObject=stubObject;
    lodash.stubString=stubString;
    lodash.stubTrue=stubTrue;
    lodash.multiply=multiply;
    lodash.nth=nth;
    lodash.noConflict=noConflict;
    lodash.noop=noop;
    lodash.now=now;
    lodash.pad=pad;
    lodash.padEnd=padEnd;
    lodash.padStart=padStart;
    lodash.parseInt=parseInt;
    lodash.random=random;
    lodash.reduce=reduce;
    lodash.reduceRight=reduceRight;
    lodash.repeat=repeat;
    lodash.replace=replace;
    lodash.result=result;
    lodash.round=round;
    lodash.runInContext=runInContext;
    lodash.sample=sample;
    lodash.size=size;
    lodash.snakeCase=snakeCase;
    lodash.some=some;
    lodash.sortedIndex=sortedIndex;
    lodash.sortedIndexBy=sortedIndexBy;
    lodash.sortedIndexOf=sortedIndexOf;
    lodash.sortedLastIndex=sortedLastIndex;
    lodash.sortedLastIndexBy=sortedLastIndexBy;
    lodash.sortedLastIndexOf=sortedLastIndexOf;
    lodash.startCase=startCase;
    lodash.startsWith=startsWith;
    lodash.subtract=subtract;
    lodash.sum=sum;
    lodash.sumBy=sumBy;
    lodash.template=template;
    lodash.times=times;
    lodash.toFinite=toFinite;
    lodash.toInteger=toInteger;
    lodash.toLength=toLength;
    lodash.toLower=toLower;
    lodash.toNumber=toNumber;
    lodash.toSafeInteger=toSafeInteger;
    lodash.toString=toString;
    lodash.toUpper=toUpper;
    lodash.trim=trim;
    lodash.trimEnd=trimEnd;
    lodash.trimStart=trimStart;
    lodash.truncate=truncate;
    lodash.unescape=unescape;
    lodash.uniqueId=uniqueId;
    lodash.upperCase=upperCase;
    lodash.upperFirst=upperFirst;

    // Add aliases.
    lodash.each=forEach;
    lodash.eachRight=forEachRight;
    lodash.first=head;

    mixin(lodash,function(){
    var source={};
    baseForOwn(lodash,function(func,methodName){
    if(!hasOwnProperty.call(lodash.prototype,methodName)){
    source[methodName]=func;
    }
    });
    return source;
    }(),{'chain':false});

    /*------------------------------------------------------------------------*/

    /**
    	     * The semantic version number.
    	     *
    	     * @static
    	     * @memberOf _
    	     * @type {string}
    	     */
    lodash.VERSION=VERSION;

    // Assign default placeholders.
    arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){
    lodash[methodName].placeholder=lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop','take'],function(methodName,index){
    LazyWrapper.prototype[methodName]=function(n){
    n=n===undefined$1?1:nativeMax(toInteger(n),0);

    var result=this.__filtered__&&!index?
    new LazyWrapper(this):
    this.clone();

    if(result.__filtered__){
    result.__takeCount__=nativeMin(n,result.__takeCount__);
    }else {
    result.__views__.push({
    'size':nativeMin(n,MAX_ARRAY_LENGTH),
    'type':methodName+(result.__dir__<0?'Right':'')});

    }
    return result;
    };

    LazyWrapper.prototype[methodName+'Right']=function(n){
    return this.reverse()[methodName](n).reverse();
    };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter','map','takeWhile'],function(methodName,index){
    var type=index+1,
    isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;

    LazyWrapper.prototype[methodName]=function(iteratee){
    var result=this.clone();
    result.__iteratees__.push({
    'iteratee':getIteratee(iteratee,3),
    'type':type});

    result.__filtered__=result.__filtered__||isFilter;
    return result;
    };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head','last'],function(methodName,index){
    var takeName='take'+(index?'Right':'');

    LazyWrapper.prototype[methodName]=function(){
    return this[takeName](1).value()[0];
    };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial','tail'],function(methodName,index){
    var dropName='drop'+(index?'':'Right');

    LazyWrapper.prototype[methodName]=function(){
    return this.__filtered__?new LazyWrapper(this):this[dropName](1);
    };
    });

    LazyWrapper.prototype.compact=function(){
    return this.filter(identity);
    };

    LazyWrapper.prototype.find=function(predicate){
    return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast=function(predicate){
    return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap=baseRest(function(path,args){
    if(typeof path=='function'){
    return new LazyWrapper(this);
    }
    return this.map(function(value){
    return baseInvoke(value,path,args);
    });
    });

    LazyWrapper.prototype.reject=function(predicate){
    return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice=function(start,end){
    start=toInteger(start);

    var result=this;
    if(result.__filtered__&&(start>0||end<0)){
    return new LazyWrapper(result);
    }
    if(start<0){
    result=result.takeRight(-start);
    }else if(start){
    result=result.drop(start);
    }
    if(end!==undefined$1){
    end=toInteger(end);
    result=end<0?result.dropRight(-end):result.take(end-start);
    }
    return result;
    };

    LazyWrapper.prototype.takeRightWhile=function(predicate){
    return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray=function(){
    return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype,function(func,methodName){
    var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),
    isTaker=/^(?:head|last)$/.test(methodName),
    lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],
    retUnwrapped=isTaker||/^find/.test(methodName);

    if(!lodashFunc){
    return;
    }
    lodash.prototype[methodName]=function(){
    var value=this.__wrapped__,
    args=isTaker?[1]:arguments,
    isLazy=value instanceof LazyWrapper,
    iteratee=args[0],
    useLazy=isLazy||isArray(value);

    var interceptor=function(value){
    var result=lodashFunc.apply(lodash,arrayPush([value],args));
    return isTaker&&chainAll?result[0]:result;
    };

    if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){
    // Avoid lazy use if the iteratee has a "length" value other than `1`.
    isLazy=useLazy=false;
    }
    var chainAll=this.__chain__,
    isHybrid=!!this.__actions__.length,
    isUnwrapped=retUnwrapped&&!chainAll,
    onlyLazy=isLazy&&!isHybrid;

    if(!retUnwrapped&&useLazy){
    value=onlyLazy?value:new LazyWrapper(this);
    var result=func.apply(value,args);
    result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined$1});
    return new LodashWrapper(result,chainAll);
    }
    if(isUnwrapped&&onlyLazy){
    return func.apply(this,args);
    }
    result=this.thru(interceptor);
    return isUnwrapped?isTaker?result.value()[0]:result.value():result;
    };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){
    var func=arrayProto[methodName],
    chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',
    retUnwrapped=/^(?:pop|shift)$/.test(methodName);

    lodash.prototype[methodName]=function(){
    var args=arguments;
    if(retUnwrapped&&!this.__chain__){
    var value=this.value();
    return func.apply(isArray(value)?value:[],args);
    }
    return this[chainName](function(value){
    return func.apply(isArray(value)?value:[],args);
    });
    };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype,function(func,methodName){
    var lodashFunc=lodash[methodName];
    if(lodashFunc){
    var key=lodashFunc.name+'';
    if(!hasOwnProperty.call(realNames,key)){
    realNames[key]=[];
    }
    realNames[key].push({'name':methodName,'func':lodashFunc});
    }
    });

    realNames[createHybrid(undefined$1,WRAP_BIND_KEY_FLAG).name]=[{
    'name':'wrapper',
    'func':undefined$1}];


    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone=lazyClone;
    LazyWrapper.prototype.reverse=lazyReverse;
    LazyWrapper.prototype.value=lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at=wrapperAt;
    lodash.prototype.chain=wrapperChain;
    lodash.prototype.commit=wrapperCommit;
    lodash.prototype.next=wrapperNext;
    lodash.prototype.plant=wrapperPlant;
    lodash.prototype.reverse=wrapperReverse;
    lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first=lodash.prototype.head;

    if(symIterator){
    lodash.prototype[symIterator]=wrapperToIterator;
    }
    return lodash;
    };

    /*--------------------------------------------------------------------------*/

    // Export lodash.
    var _=runInContext();

    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if(freeModule){
    // Export for Node.js.
    (freeModule.exports=_)._=_;
    // Export for CommonJS support.
    freeExports._=_;
    }else
    {
    // Export to the global object.
    root._=_;
    }
    }).call(commonjsGlobal);
    })(lodash,lodash.exports);

    var getDefaultCountries = function (availableCountries) {
      var countries = build.exports.defaultCountries.map(function (country) {
        var parsedCountry = build.exports.parseCountry(country);
        if (lodash.exports.isNil(parsedCountry.format))
        return country;
        var newFormatMask = parsedCountry.format.replace(/[^\\.]*/g, '');
        var fallbackFormatMask = '...............';
        return build.exports.buildCountryData(__assign(__assign({}, parsedCountry), { format: newFormatMask === '' ? fallbackFormatMask : newFormatMask }));
      });
      if (!lodash.exports.isNil(availableCountries) &&
      lodash.exports.isArray(availableCountries) &&
      availableCountries.length > 0) {
        countries = countries.filter(function (c) {
          return availableCountries.map(function (c) {return c.toLowerCase();}).includes(c[2]);
        });
      }
      var usIndex = countries.findIndex(function (c) {return c[2] === 'us';});
      var ukIndex = countries.findIndex(function (c) {return c[2] === 'gb';});
      var beIndex = countries.findIndex(function (c) {return c[2] === 'be';});
      var us = countries.splice(usIndex, 1);
      var uk = countries.splice(ukIndex, 1);
      var be = countries.splice(beIndex, 1);
      countries.unshift.apply(countries, __spreadArray(__spreadArray(__spreadArray([], us, false), uk, false), be, false));
      return countries;
    };

    var PhoneInputField = function (_a) {
      var onChange = _a.onChange,id = _a.id,label = _a.label,mandatory = _a.mandatory,value = _a.value,placeholder = _a.placeholder,_b = _a.initialCountry,initialCountry = _b === void 0 ? 'us' : _b,availableCountries = _a.availableCountries,props = __rest(_a, ["onChange", "id", "label", "mandatory", "value", "placeholder", "initialCountry", "availableCountries"]);
      var countries = getDefaultCountries(availableCountries);
      var _c = build.exports.usePhoneInput({
        initialCountry: initialCountry,
        value: value,
        hideSpaceAfterDialCode: true,
        countries: countries }),
      phone = _c.phone,handlePhoneValueChange = _c.handlePhoneValueChange,inputRef = _c.inputRef,country = _c.country,setCountry = _c.setCountry;
      var handleInputChange = function (e) {
        handlePhoneValueChange(e);
        onChange(e);
      };
      var handleCountrySelect = function (_a) {
        var iso2 = _a.iso2;
        setCountry(iso2);
      };
      return jsxRuntime.exports.jsxs("div", __assign({ className: classes$8.awell_input_field_wrapper }, { children: [jsxRuntime.exports.jsx(QuestionLabel, { htmlFor: id, label: label, mandatory: mandatory }), jsxRuntime.exports.jsxs("div", __assign({ className: classes$8.awell_phone_input_field_container }, { children: [jsxRuntime.exports.jsx(build.exports.CountrySelector, { countries: countries, selectedCountry: country, onSelect: handleCountrySelect, buttonStyle: {
              border: 0,
              height: 42,
              marginRight: 2,
              backgroundColor: 'transparent' } }),
          jsxRuntime.exports.jsx("input", __assign({}, props, { type: "tel", id: id, ref: inputRef, className: classes$8.awell_input_field, placeholder: placeholder, onChange: handleInputChange, "data-1p-ignore": true, value: phone, "data-testid": "input-".concat(id), dir: "ltr" }))] }))] }));
    };
    PhoneInputField.displayName = 'PhoneInputField';

    var AUTO_PROGRESS_DELAY = 850;
    var QuestionData = function (_a) {
      var _b, _c, _d, _e, _f, _g;
      var question = _a.question,control = _a.control,getValues = _a.getValues,labels = _a.labels,_h = _a.inputAutoFocus,inputAutoFocus = _h === void 0 ? false : _h,_j = _a.submitAndMoveToNextQuestion,submitAndMoveToNextQuestion = _j === void 0 ? lodash.exports.noop : _j,_k = _a.onAnswerChange,onAnswerChange = _k === void 0 ? lodash.exports.noop : _k,_l = _a.shouldAutoProgress,shouldAutoProgress = _l === void 0 ? function () {return false;} : _l;
      var config = question === null || question === void 0 ? void 0 : question.questionConfig;
      switch (question.userQuestionType) {
        case exports.UserQuestionType.YesNo:
          return jsxRuntime.exports.jsx(Controller, { name: question.id, control: control, defaultValue: "", rules: { required: config === null || config === void 0 ? void 0 : config.mandatory }, render: function (_a) {
              var _b = _a.field,onChange = _b.onChange,value = _b.value;
              return jsxRuntime.exports.jsx(SingleChoiceQuestion, { label: question.title, options: [
                {
                  id: "".concat(question.id, "-yes"),
                  value: 1,
                  label: labels.yes_label },

                { id: "".concat(question.id, "-no"), value: 0, label: labels.no_label }],
                onChange: function (data) {
                  onChange(data);
                  if (value !== data) {
                    onAnswerChange();
                    if (shouldAutoProgress(question)) {
                      setTimeout(function () {return submitAndMoveToNextQuestion();}, AUTO_PROGRESS_DELAY);
                    }
                  }
                }, questionId: question.id, value: value, mandatory: config === null || config === void 0 ? void 0 : config.mandatory, showFlickerOnSelected: shouldAutoProgress(question) });
            } });
        case exports.UserQuestionType.MultipleSelect:
          return jsxRuntime.exports.jsx(Controller, { name: question.id, control: control, defaultValue: [], rules: {
              validate: function () {
                return (config === null || config === void 0 ? void 0 : config.mandatory) ? getValues(question.id).length > 0 : true;
              } },
            render: function (_a) {
              var _b, _c, _d, _e;
              var _f = _a.field,onChange = _f.onChange,value = _f.value;
              if ((config === null || config === void 0 ? void 0 : config.use_select) === true) {
                return jsxRuntime.exports.jsx(Select, { id: question.id, value: value, labels: {
                    questionLabel: question.title,
                    searchPlaceholder: (_b = labels.select) === null || _b === void 0 ? void 0 : _b.search_placeholder,
                    noOptions: (_c = labels.select) === null || _c === void 0 ? void 0 : _c.no_options },
                  onChange: function (data) {
                    onChange(data);
                    if (value !== data) {
                      onAnswerChange();
                    }
                  }, type: "multiple", options: (_d = question.options) !== null && _d !== void 0 ? _d : [], mandatory: config === null || config === void 0 ? void 0 : config.mandatory, showCount: true, filtering: true });
              }
              return jsxRuntime.exports.jsx(MultipleChoiceQuestion, { label: question.title, options: (_e = question.options) !== null && _e !== void 0 ? _e : [], onChange: function (data) {
                  onChange(data);
                  if (value !== data) {
                    onAnswerChange();
                  }
                }, questionId: question.id, values: value, mandatory: config === null || config === void 0 ? void 0 : config.mandatory });
            } });
        case exports.UserQuestionType.MultipleChoice:
          return jsxRuntime.exports.jsx(Controller, { name: question.id, control: control, rules: { required: config === null || config === void 0 ? void 0 : config.mandatory }, render: function (_a) {
              var _b, _c, _d;
              var _e = _a.field,onChange = _e.onChange,value = _e.value;
              if ((config === null || config === void 0 ? void 0 : config.use_select) === true) {
                return jsxRuntime.exports.jsx(Select, { id: question.id, value: value, labels: {
                    questionLabel: question.title,
                    searchPlaceholder: (_b = labels.select) === null || _b === void 0 ? void 0 : _b.search_placeholder,
                    noOptions: (_c = labels.select) === null || _c === void 0 ? void 0 : _c.no_options },
                  onChange: function (data) {
                    onChange(data);
                    onAnswerChange();
                  }, type: "single", options: (_d = question.options) !== null && _d !== void 0 ? _d : [], mandatory: config === null || config === void 0 ? void 0 : config.mandatory, showCount: true, filtering: true });
              }
              return jsxRuntime.exports.jsx(SingleChoiceQuestion, { label: question.title, options: question.options || [], onChange: function (data) {
                  onChange(data);
                  if (value !== data) {
                    onAnswerChange();
                    if (shouldAutoProgress(question)) {
                      setTimeout(function () {return submitAndMoveToNextQuestion();}, AUTO_PROGRESS_DELAY);
                    }
                  }
                }, showFlickerOnSelected: shouldAutoProgress(question), questionId: question.id, value: value, mandatory: config === null || config === void 0 ? void 0 : config.mandatory });
            } });
        case exports.UserQuestionType.LongText:
          return jsxRuntime.exports.jsx(Controller, { name: question.id, control: control, defaultValue: "", rules: { required: config === null || config === void 0 ? void 0 : config.mandatory }, render: function (_a) {
              var _b = _a.field,onChange = _b.onChange,value = _b.value;
              return jsxRuntime.exports.jsx(LongTextField, { autoFocus: inputAutoFocus, onChange: function (e) {
                  onChange(e.target.value);
                  onAnswerChange();
                }, label: question.title, id: question.id, value: value, mandatory: config === null || config === void 0 ? void 0 : config.mandatory });
            } });
        case exports.UserQuestionType.Number:
          return jsxRuntime.exports.jsx(Controller, { name: question.id, control: control, defaultValue: "", rules: { required: config === null || config === void 0 ? void 0 : config.mandatory }, render: function (_a) {
              var _b = _a.field,onChange = _b.onChange,value = _b.value;
              return jsxRuntime.exports.jsx(InputField, { autoFocus: inputAutoFocus, type: "number", onChange: function (e) {
                  onChange(e.target.value);
                  onAnswerChange();
                }, label: question.title, id: question.id, value: value, mandatory: config === null || config === void 0 ? void 0 : config.mandatory });
            } });
        case exports.UserQuestionType.ShortText:
          return jsxRuntime.exports.jsx(Controller, { name: question.id, control: control, defaultValue: "", rules: { required: config === null || config === void 0 ? void 0 : config.mandatory }, render: function (_a) {
              var _b = _a.field,onChange = _b.onChange,value = _b.value;
              return jsxRuntime.exports.jsx(InputField, { autoFocus: inputAutoFocus, type: "text", onChange: function (e) {
                  onChange(e.target.value);
                  onAnswerChange();
                }, label: question.title, id: question.id, value: value, mandatory: config === null || config === void 0 ? void 0 : config.mandatory });
            } });
        case exports.UserQuestionType.Telephone:
          var availableCountries_1 = ((_c = (_b = config === null || config === void 0 ? void 0 : config.phone) === null || _b === void 0 ? void 0 : _b.available_countries) !== null && _c !== void 0 ? _c : []).
          map(function (c) {return c === null || c === void 0 ? void 0 : c.toLocaleLowerCase();}).
          filter(function (x) {return !lodash.exports.isNil(x);});
          var initialCountry_1 = (_f = (_e = (_d = config === null || config === void 0 ? void 0 : config.phone) === null || _d === void 0 ? void 0 : _d.default_country) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase()) !== null && _f !== void 0 ? _f : 'gb';
          return jsxRuntime.exports.jsx(Controller, { name: question.id, control: control, defaultValue: "", render: function (_a) {
              var _b;
              var _c = _a.field,onChange = _c.onChange,value = _c.value;
              return jsxRuntime.exports.jsx(PhoneInputField, { autoFocus: inputAutoFocus, onChange: function (e) {
                  onChange(e.target.value);
                  onAnswerChange();
                }, label: question.title, id: question.id, value: value, mandatory: (_b = question.questionConfig) === null || _b === void 0 ? void 0 : _b.mandatory, availableCountries: availableCountries_1, initialCountry: initialCountry_1 });
            } });
        case exports.UserQuestionType.Slider:
          return jsxRuntime.exports.jsx(Controller, { name: question.id, control: control, defaultValue: (_g = config === null || config === void 0 ? void 0 : config.slider) === null || _g === void 0 ? void 0 : _g.min, rules: { required: config === null || config === void 0 ? void 0 : config.mandatory }, render: function (_a) {
              var _b = _a.field,onChange = _b.onChange,value = _b.value;
              return jsxRuntime.exports.jsx(RangeInput, { label: question.title, onChange: function (e) {
                  onChange(e.target.value);
                  onAnswerChange();
                }, id: question.id, sliderConfig: config === null || config === void 0 ? void 0 : config.slider, value: value, mandatory: config === null || config === void 0 ? void 0 : config.mandatory });
            } });
        case exports.UserQuestionType.Date:
          return jsxRuntime.exports.jsx(Controller, { name: question.id, control: control, rules: { required: config === null || config === void 0 ? void 0 : config.mandatory }, render: function (_a) {
              var _b = _a.field,onChange = _b.onChange,value = _b.value;
              return jsxRuntime.exports.jsx(InputField, { autoFocus: inputAutoFocus, type: "date", label: question.title, onChange: function (e) {
                  onChange(e.target.value);
                  onAnswerChange();
                }, id: question.id, value: value, mandatory: config === null || config === void 0 ? void 0 : config.mandatory });
            } });
        case exports.UserQuestionType.Description:
          return jsxRuntime.exports.jsx(Description, { content: question.title });
        default:
          return jsxRuntime.exports.jsx("div", { children: "Question Type Not Implemented" });}

    };
    var Question = function (_a) {
      var question = _a.question,control = _a.control,getValues = _a.getValues,errors = _a.errors,_b = _a.labels,labels = _b === void 0 ? {
        yes_label: 'Yes',
        no_label: 'No' } :
      _b,_c = _a.inputAutoFocus,inputAutoFocus = _c === void 0 ? false : _c,submitAndMoveToNextQuestion = _a.submitAndMoveToNextQuestion,onAnswerChange = _a.onAnswerChange,shouldAutoProgress = _a.shouldAutoProgress;
      var _d = React.useState(0),isVisible = _d[0],setVisible = _d[1];
      var style = { '--awell-question-opacity': isVisible };
      React.useLayoutEffect(function () {
        setTimeout(function () {
          setVisible(1);
        }, 0);
      }, []);
      var currentError = errors.find(function (_a) {
        var id = _a.id;
        return id === question.id;
      });
      return jsxRuntime.exports.jsxs("div", __assign({ style: style, className: classes$9.awell_question }, { children: [jsxRuntime.exports.jsx(QuestionData, { question: question, control: control, getValues: getValues, labels: labels, inputAutoFocus: inputAutoFocus, submitAndMoveToNextQuestion: submitAndMoveToNextQuestion, onAnswerChange: onAnswerChange, shouldAutoProgress: shouldAutoProgress }), currentError && jsxRuntime.exports.jsx("div", __assign({ className: classes$9.error }, { children: jsxRuntime.exports.jsx(Text, __assign({ variant: "textSmall", color: "var(--awell-signalError100)" }, { children: currentError.error })) }))] }));
    };

    var classes$7 = {"awell_attachment_list":"awell__attachmentList_awell_attachment_list"};

    var AttachmentList = function (_a) {
      var attachments = _a.attachments,labels = _a.labels,icon = _a.icon;
      return jsxRuntime.exports.jsx("div", __assign({ className: classes$7.awell_attachment_list }, { children: attachments.map(function (_a) {
          var url = _a.url,name = _a.name,type = _a.type;
          var typeLowerCase = type.toLowerCase();
          var label = labels[typeLowerCase] || '';
          return jsxRuntime.exports.jsx(MessageAttachment, __assign({ url: url, name: name, label: label }, { children: icon }), "".concat(url, "-").concat(name));
        }) }));
    };

    var useScrollHint = function () {
      var _a = React.useState(false),showScrollHint = _a[0],setShowScrollHint = _a[1];
      var determineShowScrollHint = function () {
        var mainContentEl = document.getElementById('ahp_main_content_with_scroll_hint');
        if (mainContentEl) {
          var isElementTotalHeightHigherThanElementVisibleHeight = mainContentEl.scrollHeight > mainContentEl.offsetHeight;
          var hasUserScrolledToBottomOfEl = Math.ceil(mainContentEl.scrollTop + mainContentEl.offsetHeight) >=
          mainContentEl.scrollHeight - 5;
          if (isElementTotalHeightHigherThanElementVisibleHeight &&
          !hasUserScrolledToBottomOfEl) {
            setShowScrollHint(true);
          } else
          {
            setShowScrollHint(false);
          }
        } else
        {
          setShowScrollHint(false);
        }
      };
      React.useEffect(function () {
        determineShowScrollHint();
      }, [window.document.body.offsetHeight]);
      React.useEffect(function () {
        determineShowScrollHint();
        var mainContentEl = document.getElementById('ahp_main_content_with_scroll_hint');
        window.addEventListener('resize', determineShowScrollHint);
        if (mainContentEl) {
          mainContentEl.addEventListener('scroll', determineShowScrollHint);
        }
        return function () {
          window.removeEventListener('resize', determineShowScrollHint);
          if (mainContentEl) {
            mainContentEl.removeEventListener('scroll', determineShowScrollHint);
          }
        };
      }, []);
      return {
        showScrollHint: showScrollHint,
        determineShowScrollHint: determineShowScrollHint };

    };

    var classes$6 = {"footer":"awell__hostedPageFooter_footer","scrollHint":"awell__hostedPageFooter_scrollHint","visible":"awell__hostedPageFooter_visible","hidden":"awell__hostedPageFooter_hidden"};

    var HostedPageFooter = function (_a) {
      var children = _a.children,_b = _a.showScrollHint,showScrollHint = _b === void 0 ? false : _b;
      return jsxRuntime.exports.jsxs("footer", __assign({ className: classes$6.footer }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: "".concat(classes$6.scrollHint, " ").concat(showScrollHint ? classes$6.visible : classes$6.hidden), id: "awell__form_scrollhint" }, { children: jsxRuntime.exports.jsx(ScrollIndicator, {}) })), children] }));
    };

    var classes$5 = {"container":"awell__checklist_container","awell_checklist":"awell__checklist_awell_checklist","title":"awell__checklist_title","checklist":"awell__checklist_checklist","checkboxListFormControl":"awell__checklist_checkboxListFormControl","button_wrapper":"awell__checklist_button_wrapper"};

    var classes$4 = {"layout_container":"awell__hostedPageLayout_layout_container","main_content":"awell__hostedPageLayout_main_content"};

    var Checklist = function (_a) {
      var title = _a.title,items = _a.items,onSubmit = _a.onSubmit,_b = _a.readOnly,readOnly = _b === void 0 ? false : _b,_c = _a.disabled,disabled = _c === void 0 ? false : _c,submitLabel = _a.submitLabel;
      var _d = React.useState(readOnly ? items : []),checkedItems = _d[0],setCheckedItems = _d[1];
      var showScrollHint = useScrollHint().showScrollHint;
      var handleChange = function (item) {return function (checked) {
          if (checked) {
            setCheckedItems(__spreadArray(__spreadArray([], checkedItems, true), [item], false));
          } else
          {
            setCheckedItems(checkedItems.filter(function (checkedItem) {return checkedItem !== item;}));
          }
        };};
      return jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx("main", __assign({ id: "ahp_main_content_with_scroll_hint", className: classes$4.main_content }, { children: jsxRuntime.exports.jsxs("div", __assign({ className: "".concat(classes$5.awell_checklist, " ").concat(classes$5.container) }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: classes$5.title }, { children: jsxRuntime.exports.jsx(QuestionLabel, { label: title }) })), jsxRuntime.exports.jsx("div", __assign({ className: classes$5.checklist }, { children: items.map(function (item) {return jsxRuntime.exports.jsx(CheckboxButton, { onChange: function (event) {return handleChange(item)(event.target.checked);}, label: item.label, id: item.id, disabled: readOnly, name: "checklist-".concat(title) }, item.id);}) }))] })) })), jsxRuntime.exports.jsx(HostedPageFooter, __assign({ showScrollHint: showScrollHint }, { children: jsxRuntime.exports.jsx("div", __assign({ className: "".concat(classes$5.button_wrapper, " ").concat(classes$5.container) }, { children: jsxRuntime.exports.jsx(Button, __assign({ onClick: onSubmit, disabled: checkedItems.length !== items.length || readOnly || disabled, "data-cy": "submitChecklistButton" }, { children: submitLabel })) })) }))] });
    };

    var classes$3 = {"container":"awell__message_container","awell_message":"awell__message_awell_message","slate-MediaEmbedElement-input":"awell__message_slate-MediaEmbedElement-input","slate-MediaEmbedElement-iframe":"awell__message_slate-MediaEmbedElement-iframe","content":"awell__message_content","message_title":"awell__message_message_title","attachmentList":"awell__message_attachmentList","button_wrapper":"awell__message_button_wrapper"};

    var Message = function (_a) {
      var onMessageRead = _a.onMessageRead,content = _a.content,subject = _a.subject,children = _a.children,attachmentIcon = _a.attachmentIcon,attachmentLabels = _a.attachmentLabels,attachments = _a.attachments,buttonLabels = _a.buttonLabels;
      var showScrollHint = useScrollHint().showScrollHint;
      var cleanContent = generatePureHtml(content);
      return jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx("main", __assign({ id: "ahp_main_content_with_scroll_hint", className: classes$4.main_content }, { children: jsxRuntime.exports.jsxs("article", __assign({ className: "".concat(classes$3.awell_message, " ").concat(classes$3.container) }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: classes$3.message_title }, { children: subject })), jsxRuntime.exports.jsx("div", __assign({ className: classes$3.content }, { children: jsxRuntime.exports.jsx(RichTextViewer, { content: cleanContent }) })), jsxRuntime.exports.jsxs("div", __assign({ className: classes$3.attachmentList }, { children: [jsxRuntime.exports.jsx(AttachmentList, { attachments: attachments, icon: attachmentIcon, labels: attachmentLabels }), children] }))] })) })), jsxRuntime.exports.jsx(HostedPageFooter, __assign({ showScrollHint: showScrollHint }, { children: jsxRuntime.exports.jsx("div", __assign({ className: "".concat(classes$3.button_wrapper, " ").concat(classes$3.container) }, { children: jsxRuntime.exports.jsx(Button, __assign({ "data-cy": "markMessageAsReadButton", variant: "secondary", onClick: onMessageRead }, { children: buttonLabels.readMessage })) })) }))] });
    };

    var classes$2 = {"container":"awell__form_container","awell_wizard_form":"awell__form_awell_wizard_form","form_progress":"awell__form_form_progress","loadingContainer":"awell__form_loadingContainer","title":"awell__form_title","wizard_form":"awell__form_wizard_form","button_wrapper":"awell__form_button_wrapper","traditional_form":"awell__form_traditional_form","traditional_form_question":"awell__form_traditional_form_question","traditional_form_question_slider":"awell__form_traditional_form_question_slider","trademark":"awell__form_trademark","traditional":"awell__form_traditional","conversational":"awell__form_conversational"};

    var useClickOutsideNotifier = function (_a) {
      var ref = _a.ref,clickOutsideHandler = _a.clickOutsideHandler;
      React.useEffect(function () {
        var handleClickOutside = function (event) {
          if ((ref === null || ref === void 0 ? void 0 : ref.current) && !(ref === null || ref === void 0 ? void 0 : ref.current.contains(event.target))) {
            clickOutsideHandler();
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [ref, clickOutsideHandler]);
    };

    var handleUSException = function (number, originalValidation) {
      var _a;
      var areaCodes = (_a = originalValidation.country) === null || _a === void 0 ? void 0 : _a.areaCodes;
      var providedAreaCode = number.slice(2, 5);
      if (providedAreaCode.length === 3 && (areaCodes === null || areaCodes === void 0 ? void 0 : areaCodes.includes(providedAreaCode))) {
        return originalValidation;
      }
      var USValidation = build.exports.validatePhone(number, {
        countries: getDefaultCountries(['us']),
        charAfterDialCode: '',
        prefix: '+' });

      return USValidation;
    };
    var useValidate = function () {
      var validatePhoneNumber = function (number, availableCountries) {
        var validation = build.exports.validatePhone(number, {
          countries: getDefaultCountries(availableCountries),
          charAfterDialCode: '',
          prefix: '+' });

        if (number.startsWith('+1') && validation.isValid === false) {
          return handleUSException(number, validation);
        }
        return validation;
      };
      var isValidE164Number = function (number, availableCountries) {
        var validation = build.exports.validatePhone(number, {
          countries: getDefaultCountries(availableCountries),
          charAfterDialCode: '',
          prefix: '+' });

        if (number.startsWith('+1') && validation.isValid === false) {
          return handleUSException(number, validation).isValid;
        }
        return validation.isValid;
      };
      var numberMatchesAvailableCountries = function (number, availableCountries) {
        var _a;
        try {
          var validation = build.exports.validatePhone(number, {
            countries: getDefaultCountries(availableCountries),
            charAfterDialCode: '',
            prefix: '+' });

          if (number.startsWith('+1') && validation.isValid === false) {
            validation = handleUSException(number, validation);
          }
          if (!validation.country) {
            return false;
          }
          if (typeof availableCountries === 'string') {
            return (_a = availableCountries === validation.country.iso2) !== null && _a !== void 0 ? _a : false;
          }
          return availableCountries.includes(validation.country.iso2);
        }
        catch (_b) {
          return false;
        }
      };
      var isPossibleE164Number = function (number) {
        return /^\+?[1-9]\d{1,14}$/.test(number);
      };
      return {
        isValidE164Number: isValidE164Number,
        isPossibleE164Number: isPossibleE164Number,
        validatePhoneNumber: validatePhoneNumber,
        numberMatchesAvailableCountries: numberMatchesAvailableCountries };

    };

    var getDefaultValue = function (question) {
      var _a, _b, _c;
      switch (question.userQuestionType) {
        case exports.UserQuestionType.MultipleSelect:
          return [];
        case exports.UserQuestionType.Slider:
          return (_c = (_b = (_a = question.questionConfig) === null || _a === void 0 ? void 0 : _a.slider) === null || _b === void 0 ? void 0 : _b.min) !== null && _c !== void 0 ? _c : 0;
        default:
          return '';}

    };
    var getInitialValues = function (questions) {
      return questions.reduce(function (obj, item) {
        var _a;
        return __assign(__assign({}, obj), (_a = {}, _a[item.id] = getDefaultValue(item), _a));
      }, {});
    };
    var getValue = function (answer) {
      if (typeof answer === 'string') {
        return answer;
      }
      if (typeof answer === 'number') {
        return "".concat(answer);
      }
      if (Array.isArray(answer)) {
        return JSON.stringify(answer.map(function (_a) {
          var value = _a.value;
          return value;
        }));
      }
      if (typeof answer.value === 'boolean') {
        return answer.value ? '1' : '0';
      }
      return JSON.stringify(answer === null || answer === void 0 ? void 0 : answer.value);
    };
    var convertToAwellInput = function (formResponse) {
      return Object.keys(formResponse).map(function (question_id) {return {
          question_id: question_id,
          value: getValue(formResponse[question_id]) };
      });
    };
    var convertToFormFormat = function (answersAsString, questions) {
      if (questions == null ||
      answersAsString === undefined ||
      isEmpty(answersAsString)) {
        return {};
      }
      try {
        return JSON.parse(answersAsString);
      }
      catch (e) {
        console.warn('Could not parse answers', e);
        return {};
      }
    };
    var updateVisibility = function (questions, evaluation_results) {
      return questions.map(function (question) {
        var result = evaluation_results.find(function (_a) {
          var question_id = _a.question_id;
          return question_id === question.id;
        });
        var visible = !result ? true : result === null || result === void 0 ? void 0 : result.satisfied;
        return __assign(__assign({}, question), { visible: visible });
      });
    };
    var isEmpty = function (value) {
      return typeof Array.isArray(value) && value.length === 0 ||
      typeof value === 'string' && value.length === 0 ||
      typeof value === 'object' && Object.keys(value).length === 0;
    };
    var calculatePercentageCompleted = function (_a) {
      var currentQuestionId = _a.currentQuestionId,allQuestions = _a.allQuestions;
      var currentQuestionIndex = allQuestions.findIndex(function (q) {return q.id === currentQuestionId;});
      if (currentQuestionIndex === -1) {
        return 0;
      }
      return Math.round((currentQuestionIndex + 1) / allQuestions.length * 100);
    };
    var getErrorsForQuestion = function (currentQuestion, formMethods, errorLabels, isValidE164Number) {
      var _a;
      if ((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.userQuestionType) === exports.UserQuestionType.Description) {
        return [];
      }
      var isQuestionMandatory = (_a = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.questionConfig) === null || _a === void 0 ? void 0 : _a.mandatory;
      var valueOfCurrentQuestion = formMethods.getValues(currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id);
      if (isQuestionMandatory && isEmpty(valueOfCurrentQuestion)) {
        return [{ id: currentQuestion.id, error: errorLabels.required }];
      }
      if ((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.userQuestionType) === exports.UserQuestionType.Telephone) {
        if (valueOfCurrentQuestion !== '') {
          var errorLabel = errorLabels.invalidPhoneNumber;
          try {
            var isValid = isValidE164Number(valueOfCurrentQuestion);
            if (!isValid) {
              return [{ id: currentQuestion.id, error: errorLabel }];
            }
          }
          catch (error) {
            return [{ id: currentQuestion.id, error: errorLabel }];
          }
        }
      }
      return [];
    };

    var useTraditionalForm = function (_a) {
      var questions = _a.questions,evaluateDisplayConditions = _a.evaluateDisplayConditions,onSubmit = _a.onSubmit,errorLabels = _a.errorLabels,storedAnswers = _a.storedAnswers,_b = _a.autosaveAnswers,autosaveAnswers = _b === void 0 ? true : _b,onAnswersChange = _a.onAnswersChange;
      var initialValues = convertToFormFormat(storedAnswers, questions);
      var defaultValues = !isEmpty(initialValues) && autosaveAnswers ?
      initialValues :
      getInitialValues(questions);
      var formMethods = useForm({
        defaultValues: defaultValues,
        shouldUnregister: false,
        shouldFocusError: true,
        mode: 'all' });

      var _c = React.useState([]),visibleQuestions = _c[0],setVisibleQuestions = _c[1];
      var _d = React.useState([]),errors = _d[0],setErrors = _d[1];
      var _e = React.useState(false),formHasErrors = _e[0],setFormHasErrors = _e[1];
      var _f = React.useState(false),isSubmittingForm = _f[0],setIsSubmittingForm = _f[1];
      var isValidE164Number = useValidate().isValidE164Number;
      var updateQuestionVisibility = React.useCallback(function () {return __awaiter(void 0, void 0, void 0, function () {
          var formValuesInput, evaluationResults, updatedQuestions;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                formValuesInput = convertToAwellInput(formMethods.getValues());
                return [4, evaluateDisplayConditions(formValuesInput)];
              case 1:
                evaluationResults = _a.sent();
                updatedQuestions = updateVisibility(questions, evaluationResults).filter(function (e) {return e.visible;});
                setVisibleQuestions(updatedQuestions);
                return [2, updatedQuestions];}

          });
        });}, [questions]);
      React.useEffect(function () {
        var _a;
        if (!formMethods.formState.isDirty ||
        !onAnswersChange ||
        !autosaveAnswers) {
          return;
        }
        onAnswersChange((_a = JSON.stringify(formMethods.getValues())) !== null && _a !== void 0 ? _a : '{}');
      }, [formMethods.watch()]);
      React.useEffect(function () {
        updateQuestionVisibility();
      }, [updateQuestionVisibility]);
      var handleConvertAndSubmitForm = function (formResponse) {return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                setIsSubmittingForm(true);
                return [4, onSubmit(convertToAwellInput(formResponse))];
              case 1:
                _a.sent();
                setIsSubmittingForm(false);
                return [2];}

          });
        });};
      var submitForm = function () {return __awaiter(void 0, void 0, void 0, function () {
          var errors;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:return [4, updateQuestionVisibility()];
              case 1:
                _a.sent();
                errors = visibleQuestions.flatMap(function (vq) {
                  return getErrorsForQuestion(vq, formMethods, errorLabels, isValidE164Number);
                });
                setErrors(errors);
                if (errors.length == 0) {
                  setFormHasErrors(false);
                  formMethods.handleSubmit(handleConvertAndSubmitForm)();
                } else
                {
                  setFormHasErrors(true);
                }
                return [2];}

          });
        });};
      return {
        updateQuestionVisibility: updateQuestionVisibility,
        submitForm: submitForm,
        isSubmittingForm: isSubmittingForm,
        formMethods: formMethods,
        errors: errors,
        questionWithVisiblity: visibleQuestions,
        formHasErrors: formHasErrors };

    };

    var useConversationalForm = function (_a) {
      var questions = _a.questions,evaluateDisplayConditions = _a.evaluateDisplayConditions,onSubmit = _a.onSubmit,errorLabels = _a.errorLabels,storedAnswers = _a.storedAnswers,_b = _a.autosaveAnswers,autosaveAnswers = _b === void 0 ? true : _b,onAnswersChange = _a.onAnswersChange;
      var initialValues = convertToFormFormat(storedAnswers, questions);
      var isValidE164Number = useValidate().isValidE164Number;
      var defaultValues = !isEmpty(initialValues) && autosaveAnswers ?
      initialValues :
      getInitialValues(questions);
      var formMethods = useForm({
        defaultValues: defaultValues,
        shouldUnregister: false,
        shouldFocusError: true,
        mode: 'all' });

      var _c = React.useState([]),visibleQuestions = _c[0],setVisibleQuestions = _c[1];
      var _d = React.useState([]),errors = _d[0],setErrors = _d[1];
      var _e = React.useState(0),current = _e[0],setCurrent = _e[1];
      var _f = React.useState(true),isEvaluatingQuestionVisibility = _f[0],setIsEvaluatingQuestionVisibility = _f[1];
      var _g = React.useState(0),percentageCompleted = _g[0],setPercentageCompleted = _g[1];
      var _h = React.useState(false),isSubmittingForm = _h[0],setIsSubmittingForm = _h[1];
      var updateQuestionVisibility = React.useCallback(function () {return __awaiter(void 0, void 0, void 0, function () {
          var formValuesInput, evaluationResults, updatedQuestions;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                setIsEvaluatingQuestionVisibility(true);
                formValuesInput = convertToAwellInput(formMethods.getValues());
                return [4, evaluateDisplayConditions(formValuesInput)];
              case 1:
                evaluationResults = _a.sent();
                updatedQuestions = updateVisibility(questions, evaluationResults).filter(function (e) {return e.visible;});
                setVisibleQuestions(updatedQuestions);
                setIsEvaluatingQuestionVisibility(false);
                return [2, updatedQuestions];}

          });
        });}, [questions]);
      React.useEffect(function () {
        var _a;
        if (!formMethods.formState.isDirty ||
        !onAnswersChange ||
        !autosaveAnswers) {
          return;
        }
        onAnswersChange((_a = JSON.stringify(formMethods.getValues())) !== null && _a !== void 0 ? _a : '{}');
      }, [formMethods.watch()]);
      React.useEffect(function () {
        var _a;
        var percentageCompletedTemp = calculatePercentageCompleted({
          currentQuestionId: ((_a = visibleQuestions === null || visibleQuestions === void 0 ? void 0 : visibleQuestions[current]) === null || _a === void 0 ? void 0 : _a.id) || '',
          allQuestions: questions });

        setPercentageCompleted(percentageCompletedTemp);
      }, [current, visibleQuestions]);
      React.useEffect(function () {
        updateQuestionVisibility();
      }, [updateQuestionVisibility]);
      var handleCheckForErrors = function (currentQuestion) {
        var errorsWithoutCurrent = errors.filter(function (err) {return err.id !== (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id);});
        var existingErrors = getErrorsForQuestion(currentQuestion, formMethods, errorLabels, isValidE164Number);
        setErrors(__spreadArray(__spreadArray([], errorsWithoutCurrent, true), existingErrors, true));
        return existingErrors.length > 0;
      };
      var handleGoToNextQuestion = function () {return __awaiter(void 0, void 0, void 0, function () {
          var hasErrors, updatedQuestions, isLastVisibleQuestion;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                hasErrors = handleCheckForErrors(visibleQuestions === null || visibleQuestions === void 0 ? void 0 : visibleQuestions[current]);
                if (!!hasErrors) return [3, 4];
                _a.label = 1;
              case 1:
                _a.trys.push([1,, 3, 4]);
                return [4, updateQuestionVisibility()];
              case 2:
                updatedQuestions = _a.sent();
                isLastVisibleQuestion = current === updatedQuestions.length - 1;
                if (isLastVisibleQuestion) {
                  formMethods.handleSubmit(handleConvertAndSubmitForm)();
                  return [2];
                }
                return [3, 4];
              case 3:
                setCurrent(current + 1);
                return [7];
              case 4:
                if (current === -1) {
                  setCurrent(current + 1);
                }
                return [2];}

          });
        });};
      var handleGoToPrevQuestion = function () {return __awaiter(void 0, void 0, void 0, function () {
          var isFirstVisibleQuestion;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                isFirstVisibleQuestion = current === 0;
                _a.label = 1;
              case 1:
                _a.trys.push([1,, 3, 4]);
                return [4, updateQuestionVisibility()];
              case 2:
                _a.sent();
                if (isFirstVisibleQuestion) {
                  return [2];
                }
                return [3, 4];
              case 3:
                if (!isFirstVisibleQuestion) {
                  setCurrent(current - 1);
                }
                return [7];
              case 4:return [2];}

          });
        });};
      var handleConvertAndSubmitForm = function (formResponse) {return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                setIsSubmittingForm(true);
                return [4, onSubmit(convertToAwellInput(formResponse))];
              case 1:
                _a.sent();
                setIsSubmittingForm(false);
                return [2];}

          });
        });};
      var submitForm = function () {return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:return [4, updateQuestionVisibility().then(function (updatedQuestions) {
                  var doNextQuestionExist = current !== updatedQuestions.length - 1;
                  if (doNextQuestionExist) {
                    return handleGoToNextQuestion();
                  }
                  var hasErrors = handleCheckForErrors(visibleQuestions === null || visibleQuestions === void 0 ? void 0 : visibleQuestions[current]);
                  if (!hasErrors) {
                    formMethods.handleSubmit(handleConvertAndSubmitForm)();
                  }
                })];
              case 1:
                _a.sent();
                return [2];}

          });
        });};
      return {
        updateQuestionVisibility: updateQuestionVisibility,
        submitForm: submitForm,
        isSubmittingForm: isSubmittingForm,
        handleGoToNextQuestion: handleGoToNextQuestion,
        handleGoToPrevQuestion: handleGoToPrevQuestion,
        formMethods: formMethods,
        currentQuestion: visibleQuestions === null || visibleQuestions === void 0 ? void 0 : visibleQuestions[current],
        percentageCompleted: percentageCompleted,
        errors: errors,
        isFirstQuestion: current === 0,
        isLastQuestion: current === visibleQuestions.length - 1,
        isEvaluatingQuestionVisibility: isEvaluatingQuestionVisibility };

    };

    var useHtmlScript = function (url) {
      var _a = React.useState(false),isLoaded = _a[0],setIsLoaded = _a[1];
      React.useEffect(function () {
        var script = document.createElement('script');
        script.onload = function () {
          setIsLoaded(true);
        };
        script.src = url;
        script.async = true;
        document.body.appendChild(script);
        return function () {
          document.body.removeChild(script);
          setIsLoaded(false);
        };
      }, [url]);
      return { isLoaded: isLoaded };
    };

    var ConversationalForm = function (_a) {
      var form = _a.form,onSubmit = _a.onSubmit,buttonLabels = _a.buttonLabels,evaluateDisplayConditions = _a.evaluateDisplayConditions,errorLabels = _a.errorLabels,questionLabels = _a.questionLabels,storedAnswers = _a.storedAnswers,onAnswersChange = _a.onAnswersChange,_b = _a.autoProgress,autoProgress = _b === void 0 ? false : _b,_c = _a.autosaveAnswers,autosaveAnswers = _c === void 0 ? true : _c;
      var _d = useConversationalForm({
        questions: form.questions,
        onSubmit: onSubmit,
        evaluateDisplayConditions: evaluateDisplayConditions,
        errorLabels: errorLabels,
        storedAnswers: storedAnswers,
        autosaveAnswers: autosaveAnswers,
        onAnswersChange: onAnswersChange }),
      submitForm = _d.submitForm,isSubmittingForm = _d.isSubmittingForm,handleGoToNextQuestion = _d.handleGoToNextQuestion,handleGoToPrevQuestion = _d.handleGoToPrevQuestion,_e = _d.formMethods,control = _e.control,getValues = _e.getValues,currentQuestion = _d.currentQuestion,percentageCompleted = _d.percentageCompleted,errors = _d.errors,isFirstQuestion = _d.isFirstQuestion,isLastQuestion = _d.isLastQuestion,isEvaluatingQuestionVisibility = _d.isEvaluatingQuestionVisibility;
      var _f = useScrollHint(),showScrollHint = _f.showScrollHint,determineShowScrollHint = _f.determineShowScrollHint;
      var submitAndMoveToNextQuestion = function () {
        if (!isLastQuestion) {
          handleGoToNextQuestion();
        }
      };
      React.useEffect(function () {
        determineShowScrollHint();
      }, [currentQuestion]);
      var shouldAutoProgress = function (question) {
        if (autoProgress === false) {
          return false;
        }
        if (question.userQuestionType) {
          return [exports.UserQuestionType.YesNo, exports.UserQuestionType.MultipleChoice].includes(question.userQuestionType);
        }
        return false;
      };
      return jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx("main", __assign({ id: "ahp_main_content_with_scroll_hint", className: classes$4.main_content }, { children: jsxRuntime.exports.jsxs("div", __assign({ className: "".concat(classes$2.awell_wizard_form, " ").concat(classes$2.container) }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: classes$2.form_progress }, { children: jsxRuntime.exports.jsx(ProgressIndicator, { percentageCompleted: percentageCompleted }) })), isEvaluatingQuestionVisibility ||
            (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id) === undefined ? jsxRuntime.exports.jsx("div", __assign({ className: classes$2.loadingContainer }, { children: jsxRuntime.exports.jsx(CircularSpinner, { size: "sm" }) })) : jsxRuntime.exports.jsxs("div", __assign({ className: classes$2.wizard_form }, { children: [jsxRuntime.exports.jsx(Question, { question: currentQuestion, control: control, getValues: getValues, errors: errors, labels: questionLabels, submitAndMoveToNextQuestion: submitAndMoveToNextQuestion, inputAutoFocus: true, shouldAutoProgress: shouldAutoProgress }, currentQuestion.id), (form === null || form === void 0 ? void 0 : form.trademark) && jsxRuntime.exports.jsx("div", __assign({ className: "".concat(classes$2.trademark, " ").concat(classes$2.conversational) }, { children: form.trademark }))] }))] })) })), jsxRuntime.exports.jsx(HostedPageFooter, __assign({ showScrollHint: showScrollHint }, { children: !isEvaluatingQuestionVisibility && jsxRuntime.exports.jsxs("div", __assign({ className: "".concat(classes$2.button_wrapper, " ").concat(classes$2.container) }, { children: [jsxRuntime.exports.jsx("div", { children: !isFirstQuestion && jsxRuntime.exports.jsx(Button, __assign({ variant: "tertiary", onClick: handleGoToPrevQuestion, "data-cy": "navigateToPrevQuestionButton" }, { children: buttonLabels.prev })) }), isLastQuestion ? jsxRuntime.exports.jsx(Button, __assign({ onClick: submitForm, type: "submit", "data-cy": "submitFormButton", disabled: isSubmittingForm }, { children: buttonLabels.submit })) : jsxRuntime.exports.jsx(Button, __assign({ variant: "secondary", onClick: handleGoToNextQuestion, "data-cy": "navigateToNextQuestionButton" }, { children: buttonLabels.next }))] })) }))] });
    };

    var TraditionalForm = function (_a) {
      var form = _a.form,onSubmit = _a.onSubmit,buttonLabels = _a.buttonLabels,evaluateDisplayConditions = _a.evaluateDisplayConditions,errorLabels = _a.errorLabels,storedAnswers = _a.storedAnswers,onAnswersChange = _a.onAnswersChange,_b = _a.autosaveAnswers,autosaveAnswers = _b === void 0 ? true : _b;
      var _c = useTraditionalForm({
        questions: form.questions,
        onSubmit: onSubmit,
        evaluateDisplayConditions: evaluateDisplayConditions,
        errorLabels: errorLabels,
        storedAnswers: storedAnswers,
        autosaveAnswers: autosaveAnswers,
        onAnswersChange: onAnswersChange }),
      updateQuestionVisibility = _c.updateQuestionVisibility,submitForm = _c.submitForm,isSubmittingForm = _c.isSubmittingForm,_d = _c.formMethods,control = _d.control,getValues = _d.getValues,errors = _c.errors,questionWithVisiblity = _c.questionWithVisiblity,formHasErrors = _c.formHasErrors;
      return jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, { children: jsxRuntime.exports.jsx("main", __assign({ id: "ahp_main_content_with_scroll_hint", className: "".concat(classes$4.main_content, " ").concat(classes$2.traditional_form) }, { children: jsxRuntime.exports.jsxs("div", __assign({ className: "".concat(classes$2.container) }, { children: [!questionWithVisiblity ? jsxRuntime.exports.jsx("div", __assign({ className: classes$2.loadingContainer }, { children: jsxRuntime.exports.jsx(CircularSpinner, { size: "sm" }) })) : jsxRuntime.exports.jsx("div", { children: jsxRuntime.exports.jsx("div", { children: questionWithVisiblity.
                filter(function (vb) {return vb.visible;}).
                map(function (visibleQuestion) {return jsxRuntime.exports.jsx("div", __assign({ className: "".concat(classes$2.traditional_form_question, " ").concat(visibleQuestion.userQuestionType ===
                    exports.UserQuestionType.Slider ?
                    classes$2.traditional_form_question_slider :
                    '') }, { children: jsxRuntime.exports.jsx(Question, { question: visibleQuestion, control: control, getValues: getValues, errors: errors, inputAutoFocus: false, onAnswerChange: updateQuestionVisibility }, visibleQuestion.id) }), visibleQuestion.id);}) }) }), (form === null || form === void 0 ? void 0 : form.trademark) && jsxRuntime.exports.jsx("div", __assign({ className: "".concat(classes$2.trademark, " ").concat(classes$2.conversational) }, { children: form.trademark })), jsxRuntime.exports.jsxs("div", __assign({ className: "".concat(classes$2.button_wrapper) }, { children: [formHasErrors && jsxRuntime.exports.jsx("div", __assign({ className: classes$2.error }, { children: jsxRuntime.exports.jsx(Text, __assign({ variant: "textSmall", color: "var(--awell-signalError100)" }, { children: errorLabels.formHasErrors })) })), jsxRuntime.exports.jsx("div", {}), jsxRuntime.exports.jsx(Button, __assign({ onClick: submitForm, type: "submit", "data-cy": "submitFormButton", disabled: isSubmittingForm }, { children: buttonLabels.submit }))] }))] })) })) });
    };

    var WizardForm = ConversationalForm;

    var cloudinaryCore = {exports: {}};

    /** Detect free variable `global` from Node.js. */

    var _freeGlobal;
    var hasRequired_freeGlobal;

    function require_freeGlobal() {
      if (hasRequired_freeGlobal) return _freeGlobal;
      hasRequired_freeGlobal = 1;
      var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

      _freeGlobal = freeGlobal;
      return _freeGlobal;
    }

    var _root;
    var hasRequired_root;

    function require_root() {
      if (hasRequired_root) return _root;
      hasRequired_root = 1;
      var freeGlobal = require_freeGlobal();

      /** Detect free variable `self`. */
      var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

      /** Used as a reference to the global object. */
      var root = freeGlobal || freeSelf || Function('return this')();

      _root = root;
      return _root;
    }

    var _Symbol;
    var hasRequired_Symbol;

    function require_Symbol() {
      if (hasRequired_Symbol) return _Symbol;
      hasRequired_Symbol = 1;
      var root = require_root();

      /** Built-in value references. */
      var Symbol = root.Symbol;

      _Symbol = Symbol;
      return _Symbol;
    }

    var _getRawTag;
    var hasRequired_getRawTag;

    function require_getRawTag() {
      if (hasRequired_getRawTag) return _getRawTag;
      hasRequired_getRawTag = 1;
      var Symbol = require_Symbol();

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */
      var nativeObjectToString = objectProto.toString;

      /** Built-in value references. */
      var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

      /**
       * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the raw `toStringTag`.
       */
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

        try {
          value[symToStringTag] = undefined;
          var unmasked = true;
        } catch (e) {}

        var result = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result;
      }

      _getRawTag = getRawTag;
      return _getRawTag;
    }

    /** Used for built-in method references. */

    var _objectToString;
    var hasRequired_objectToString;

    function require_objectToString() {
      if (hasRequired_objectToString) return _objectToString;
      hasRequired_objectToString = 1;
      var objectProto = Object.prototype;

      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */
      var nativeObjectToString = objectProto.toString;

      /**
       * Converts `value` to a string using `Object.prototype.toString`.
       *
       * @private
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       */
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }

      _objectToString = objectToString;
      return _objectToString;
    }

    var _baseGetTag;
    var hasRequired_baseGetTag;

    function require_baseGetTag() {
      if (hasRequired_baseGetTag) return _baseGetTag;
      hasRequired_baseGetTag = 1;
      var Symbol = require_Symbol(),
      getRawTag = require_getRawTag(),
      objectToString = require_objectToString();

      /** `Object#toString` result references. */
      var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

      /** Built-in value references. */
      var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

      /**
       * The base implementation of `getTag` without fallbacks for buggy environments.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object(value) ?
        getRawTag(value) :
        objectToString(value);
      }

      _baseGetTag = baseGetTag;
      return _baseGetTag;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */

    var isObject_1;
    var hasRequiredIsObject;

    function requireIsObject() {
      if (hasRequiredIsObject) return isObject_1;
      hasRequiredIsObject = 1;
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
      }

      isObject_1 = isObject;
      return isObject_1;
    }

    var isFunction_1;
    var hasRequiredIsFunction;

    function requireIsFunction() {
      if (hasRequiredIsFunction) return isFunction_1;
      hasRequiredIsFunction = 1;
      var baseGetTag = require_baseGetTag(),
      isObject = requireIsObject();

      /** `Object#toString` result references. */
      var asyncTag = '[object AsyncFunction]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';

      /**
       * Checks if `value` is classified as a `Function` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a function, else `false`.
       * @example
       *
       * _.isFunction(_);
       * // => true
       *
       * _.isFunction(/abc/);
       * // => false
       */
      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 9 which returns 'object' for typed arrays and other constructors.
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }

      isFunction_1 = isFunction;
      return isFunction_1;
    }

    var _coreJsData;
    var hasRequired_coreJsData;

    function require_coreJsData() {
      if (hasRequired_coreJsData) return _coreJsData;
      hasRequired_coreJsData = 1;
      var root = require_root();

      /** Used to detect overreaching core-js shims. */
      var coreJsData = root['__core-js_shared__'];

      _coreJsData = coreJsData;
      return _coreJsData;
    }

    var _isMasked;
    var hasRequired_isMasked;

    function require_isMasked() {
      if (hasRequired_isMasked) return _isMasked;
      hasRequired_isMasked = 1;
      var coreJsData = require_coreJsData();

      /** Used to detect methods masquerading as native. */
      var maskSrcKey = function () {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
      }();

      /**
       * Checks if `func` has its source masked.
       *
       * @private
       * @param {Function} func The function to check.
       * @returns {boolean} Returns `true` if `func` is masked, else `false`.
       */
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }

      _isMasked = isMasked;
      return _isMasked;
    }

    /** Used for built-in method references. */

    var _toSource;
    var hasRequired_toSource;

    function require_toSource() {
      if (hasRequired_toSource) return _toSource;
      hasRequired_toSource = 1;
      var funcProto = Function.prototype;

      /** Used to resolve the decompiled source of functions. */
      var funcToString = funcProto.toString;

      /**
       * Converts `func` to its source code.
       *
       * @private
       * @param {Function} func The function to convert.
       * @returns {string} Returns the source code.
       */
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {}
          try {
            return func + '';
          } catch (e) {}
        }
        return '';
      }

      _toSource = toSource;
      return _toSource;
    }

    var _baseIsNative;
    var hasRequired_baseIsNative;

    function require_baseIsNative() {
      if (hasRequired_baseIsNative) return _baseIsNative;
      hasRequired_baseIsNative = 1;
      var isFunction = requireIsFunction(),
      isMasked = require_isMasked(),
      isObject = requireIsObject(),
      toSource = require_toSource();

      /**
       * Used to match `RegExp`
       * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
       */
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

      /** Used to detect host constructors (Safari). */
      var reIsHostCtor = /^\[object .+?Constructor\]$/;

      /** Used for built-in method references. */
      var funcProto = Function.prototype,
      objectProto = Object.prototype;

      /** Used to resolve the decompiled source of functions. */
      var funcToString = funcProto.toString;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /** Used to detect if a method is native. */
      var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').
      replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');


      /**
       * The base implementation of `_.isNative` without bad shim checks.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a native function,
       *  else `false`.
       */
      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }

      _baseIsNative = baseIsNative;
      return _baseIsNative;
    }

    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */

    var _getValue;
    var hasRequired_getValue;

    function require_getValue() {
      if (hasRequired_getValue) return _getValue;
      hasRequired_getValue = 1;
      function getValue(object, key) {
        return object == null ? undefined : object[key];
      }

      _getValue = getValue;
      return _getValue;
    }

    var _getNative;
    var hasRequired_getNative;

    function require_getNative() {
      if (hasRequired_getNative) return _getNative;
      hasRequired_getNative = 1;
      var baseIsNative = require_baseIsNative(),
      getValue = require_getValue();

      /**
       * Gets the native function at `key` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the method to get.
       * @returns {*} Returns the function if it's native, else `undefined`.
       */
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined;
      }

      _getNative = getNative;
      return _getNative;
    }

    var _defineProperty;
    var hasRequired_defineProperty;

    function require_defineProperty() {
      if (hasRequired_defineProperty) return _defineProperty;
      hasRequired_defineProperty = 1;
      var getNative = require_getNative();

      var defineProperty = function () {
        try {
          var func = getNative(Object, 'defineProperty');
          func({}, '', {});
          return func;
        } catch (e) {}
      }();

      _defineProperty = defineProperty;
      return _defineProperty;
    }

    var _baseAssignValue;
    var hasRequired_baseAssignValue;

    function require_baseAssignValue() {
      if (hasRequired_baseAssignValue) return _baseAssignValue;
      hasRequired_baseAssignValue = 1;
      var defineProperty = require_defineProperty();

      /**
       * The base implementation of `assignValue` and `assignMergeValue` without
       * value checks.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function baseAssignValue(object, key, value) {
        if (key == '__proto__' && defineProperty) {
          defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true });

        } else {
          object[key] = value;
        }
      }

      _baseAssignValue = baseAssignValue;
      return _baseAssignValue;
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */

    var eq_1;
    var hasRequiredEq;

    function requireEq() {
      if (hasRequiredEq) return eq_1;
      hasRequiredEq = 1;
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }

      eq_1 = eq;
      return eq_1;
    }

    var _assignValue;
    var hasRequired_assignValue;

    function require_assignValue() {
      if (hasRequired_assignValue) return _assignValue;
      hasRequired_assignValue = 1;
      var baseAssignValue = require_baseAssignValue(),
      eq = requireEq();

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Assigns `value` to `key` of `object` if the existing value is not equivalent
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
        value === undefined && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }

      _assignValue = assignValue;
      return _assignValue;
    }

    var _copyObject;
    var hasRequired_copyObject;

    function require_copyObject() {
      if (hasRequired_copyObject) return _copyObject;
      hasRequired_copyObject = 1;
      var assignValue = require_assignValue(),
      baseAssignValue = require_baseAssignValue();

      /**
       * Copies properties of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy properties from.
       * @param {Array} props The property identifiers to copy.
       * @param {Object} [object={}] The object to copy properties to.
       * @param {Function} [customizer] The function to customize copied values.
       * @returns {Object} Returns `object`.
       */
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});

        var index = -1,
        length = props.length;

        while (++index < length) {
          var key = props[index];

          var newValue = customizer ?
          customizer(object[key], source[key], key, object, source) :
          undefined;

          if (newValue === undefined) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }

      _copyObject = copyObject;
      return _copyObject;
    }

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */

    var identity_1;
    var hasRequiredIdentity;

    function requireIdentity() {
      if (hasRequiredIdentity) return identity_1;
      hasRequiredIdentity = 1;
      function identity(value) {
        return value;
      }

      identity_1 = identity;
      return identity_1;
    }

    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */

    var _apply;
    var hasRequired_apply;

    function require_apply() {
      if (hasRequired_apply) return _apply;
      hasRequired_apply = 1;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:return func.call(thisArg);
          case 1:return func.call(thisArg, args[0]);
          case 2:return func.call(thisArg, args[0], args[1]);
          case 3:return func.call(thisArg, args[0], args[1], args[2]);}

        return func.apply(thisArg, args);
      }

      _apply = apply;
      return _apply;
    }

    var _overRest;
    var hasRequired_overRest;

    function require_overRest() {
      if (hasRequired_overRest) return _overRest;
      hasRequired_overRest = 1;
      var apply = require_apply();

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeMax = Math.max;

      /**
       * A specialized version of `baseRest` which transforms the rest array.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @param {Function} transform The rest array transform.
       * @returns {Function} Returns the new function.
       */
      function overRest(func, start, transform) {
        start = nativeMax(start === undefined ? func.length - 1 : start, 0);
        return function () {
          var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

          while (++index < length) {
            array[index] = args[start + index];
          }
          index = -1;
          var otherArgs = Array(start + 1);
          while (++index < start) {
            otherArgs[index] = args[index];
          }
          otherArgs[start] = transform(array);
          return apply(func, this, otherArgs);
        };
      }

      _overRest = overRest;
      return _overRest;
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */

    var constant_1;
    var hasRequiredConstant;

    function requireConstant() {
      if (hasRequiredConstant) return constant_1;
      hasRequiredConstant = 1;
      function constant(value) {
        return function () {
          return value;
        };
      }

      constant_1 = constant;
      return constant_1;
    }

    var _baseSetToString;
    var hasRequired_baseSetToString;

    function require_baseSetToString() {
      if (hasRequired_baseSetToString) return _baseSetToString;
      hasRequired_baseSetToString = 1;
      var constant = requireConstant(),
      defineProperty = require_defineProperty(),
      identity = requireIdentity();

      /**
       * The base implementation of `setToString` without support for hot loop shorting.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */
      var baseSetToString = !defineProperty ? identity : function (func, string) {
        return defineProperty(func, 'toString', {
          'configurable': true,
          'enumerable': false,
          'value': constant(string),
          'writable': true });

      };

      _baseSetToString = baseSetToString;
      return _baseSetToString;
    }

    /** Used to detect hot functions by number of calls within a span of milliseconds. */

    var _shortOut;
    var hasRequired_shortOut;

    function require_shortOut() {
      if (hasRequired_shortOut) return _shortOut;
      hasRequired_shortOut = 1;
      var HOT_COUNT = 800,
      HOT_SPAN = 16;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeNow = Date.now;

      /**
       * Creates a function that'll short out and invoke `identity` instead
       * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
       * milliseconds.
       *
       * @private
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new shortable function.
       */
      function shortOut(func) {
        var count = 0,
        lastCalled = 0;

        return function () {
          var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);

          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined, arguments);
        };
      }

      _shortOut = shortOut;
      return _shortOut;
    }

    var _setToString;
    var hasRequired_setToString;

    function require_setToString() {
      if (hasRequired_setToString) return _setToString;
      hasRequired_setToString = 1;
      var baseSetToString = require_baseSetToString(),
      shortOut = require_shortOut();

      /**
       * Sets the `toString` method of `func` to return `string`.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */
      var setToString = shortOut(baseSetToString);

      _setToString = setToString;
      return _setToString;
    }

    var _baseRest;
    var hasRequired_baseRest;

    function require_baseRest() {
      if (hasRequired_baseRest) return _baseRest;
      hasRequired_baseRest = 1;
      var identity = requireIdentity(),
      overRest = require_overRest(),
      setToString = require_setToString();

      /**
       * The base implementation of `_.rest` which doesn't validate or coerce arguments.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @returns {Function} Returns the new function.
       */
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + '');
      }

      _baseRest = baseRest;
      return _baseRest;
    }

    /** Used as references for various `Number` constants. */

    var isLength_1;
    var hasRequiredIsLength;

    function requireIsLength() {
      if (hasRequiredIsLength) return isLength_1;
      hasRequiredIsLength = 1;
      var MAX_SAFE_INTEGER = 9007199254740991;

      /**
       * Checks if `value` is a valid array-like length.
       *
       * **Note:** This method is loosely based on
       * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
       * @example
       *
       * _.isLength(3);
       * // => true
       *
       * _.isLength(Number.MIN_VALUE);
       * // => false
       *
       * _.isLength(Infinity);
       * // => false
       *
       * _.isLength('3');
       * // => false
       */
      function isLength(value) {
        return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }

      isLength_1 = isLength;
      return isLength_1;
    }

    var isArrayLike_1;
    var hasRequiredIsArrayLike;

    function requireIsArrayLike() {
      if (hasRequiredIsArrayLike) return isArrayLike_1;
      hasRequiredIsArrayLike = 1;
      var isFunction = requireIsFunction(),
      isLength = requireIsLength();

      /**
       * Checks if `value` is array-like. A value is considered array-like if it's
       * not a function and has a `value.length` that's an integer greater than or
       * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
       * @example
       *
       * _.isArrayLike([1, 2, 3]);
       * // => true
       *
       * _.isArrayLike(document.body.children);
       * // => true
       *
       * _.isArrayLike('abc');
       * // => true
       *
       * _.isArrayLike(_.noop);
       * // => false
       */
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }

      isArrayLike_1 = isArrayLike;
      return isArrayLike_1;
    }

    /** Used as references for various `Number` constants. */

    var _isIndex;
    var hasRequired_isIndex;

    function require_isIndex() {
      if (hasRequired_isIndex) return _isIndex;
      hasRequired_isIndex = 1;
      var MAX_SAFE_INTEGER = 9007199254740991;

      /** Used to detect unsigned integer values. */
      var reIsUint = /^(?:0|[1-9]\d*)$/;

      /**
       * Checks if `value` is a valid array-like index.
       *
       * @private
       * @param {*} value The value to check.
       * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
       * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
       */
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;

        return !!length && (
        type == 'number' ||
        type != 'symbol' && reIsUint.test(value)) &&
        value > -1 && value % 1 == 0 && value < length;
      }

      _isIndex = isIndex;
      return _isIndex;
    }

    var _isIterateeCall;
    var hasRequired_isIterateeCall;

    function require_isIterateeCall() {
      if (hasRequired_isIterateeCall) return _isIterateeCall;
      hasRequired_isIterateeCall = 1;
      var eq = requireEq(),
      isArrayLike = requireIsArrayLike(),
      isIndex = require_isIndex(),
      isObject = requireIsObject();

      /**
       * Checks if the given arguments are from an iteratee call.
       *
       * @private
       * @param {*} value The potential iteratee value argument.
       * @param {*} index The potential iteratee index or key argument.
       * @param {*} object The potential iteratee object argument.
       * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
       *  else `false`.
       */
      function isIterateeCall(value, index, object) {
        if (!isObject(object)) {
          return false;
        }
        var type = typeof index;
        if (type == 'number' ?
        isArrayLike(object) && isIndex(index, object.length) :
        type == 'string' && index in object)
        {
          return eq(object[index], value);
        }
        return false;
      }

      _isIterateeCall = isIterateeCall;
      return _isIterateeCall;
    }

    var _createAssigner;
    var hasRequired_createAssigner;

    function require_createAssigner() {
      if (hasRequired_createAssigner) return _createAssigner;
      hasRequired_createAssigner = 1;
      var baseRest = require_baseRest(),
      isIterateeCall = require_isIterateeCall();

      /**
       * Creates a function like `_.assign`.
       *
       * @private
       * @param {Function} assigner The function to assign values.
       * @returns {Function} Returns the new assigner function.
       */
      function createAssigner(assigner) {
        return baseRest(function (object, sources) {
          var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;

          customizer = assigner.length > 3 && typeof customizer == 'function' ? (
          length--, customizer) :
          undefined;

          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
          }
          object = Object(object);
          while (++index < length) {
            var source = sources[index];
            if (source) {
              assigner(object, source, index, customizer);
            }
          }
          return object;
        });
      }

      _createAssigner = createAssigner;
      return _createAssigner;
    }

    /** Used for built-in method references. */

    var _isPrototype;
    var hasRequired_isPrototype;

    function require_isPrototype() {
      if (hasRequired_isPrototype) return _isPrototype;
      hasRequired_isPrototype = 1;
      var objectProto = Object.prototype;

      /**
       * Checks if `value` is likely a prototype object.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
       */
      function isPrototype(value) {
        var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

        return value === proto;
      }

      _isPrototype = isPrototype;
      return _isPrototype;
    }

    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */

    var _baseTimes;
    var hasRequired_baseTimes;

    function require_baseTimes() {
      if (hasRequired_baseTimes) return _baseTimes;
      hasRequired_baseTimes = 1;
      function baseTimes(n, iteratee) {
        var index = -1,
        result = Array(n);

        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }

      _baseTimes = baseTimes;
      return _baseTimes;
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */

    var isObjectLike_1;
    var hasRequiredIsObjectLike;

    function requireIsObjectLike() {
      if (hasRequiredIsObjectLike) return isObjectLike_1;
      hasRequiredIsObjectLike = 1;
      function isObjectLike(value) {
        return value != null && typeof value == 'object';
      }

      isObjectLike_1 = isObjectLike;
      return isObjectLike_1;
    }

    var _baseIsArguments;
    var hasRequired_baseIsArguments;

    function require_baseIsArguments() {
      if (hasRequired_baseIsArguments) return _baseIsArguments;
      hasRequired_baseIsArguments = 1;
      var baseGetTag = require_baseGetTag(),
      isObjectLike = requireIsObjectLike();

      /** `Object#toString` result references. */
      var argsTag = '[object Arguments]';

      /**
       * The base implementation of `_.isArguments`.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       */
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }

      _baseIsArguments = baseIsArguments;
      return _baseIsArguments;
    }

    var isArguments_1;
    var hasRequiredIsArguments;

    function requireIsArguments() {
      if (hasRequiredIsArguments) return isArguments_1;
      hasRequiredIsArguments = 1;
      var baseIsArguments = require_baseIsArguments(),
      isObjectLike = requireIsObjectLike();

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /** Built-in value references. */
      var propertyIsEnumerable = objectProto.propertyIsEnumerable;

      /**
       * Checks if `value` is likely an `arguments` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       *  else `false`.
       * @example
       *
       * _.isArguments(function() { return arguments; }());
       * // => true
       *
       * _.isArguments([1, 2, 3]);
       * // => false
       */
      var isArguments = baseIsArguments(function () {return arguments;}()) ? baseIsArguments : function (value) {
        return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
      };

      isArguments_1 = isArguments;
      return isArguments_1;
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */

    var isArray_1;
    var hasRequiredIsArray;

    function requireIsArray() {
      if (hasRequiredIsArray) return isArray_1;
      hasRequiredIsArray = 1;
      var isArray = Array.isArray;

      isArray_1 = isArray;
      return isArray_1;
    }

    var isBuffer = {exports: {}};

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */

    var stubFalse_1;
    var hasRequiredStubFalse;

    function requireStubFalse() {
      if (hasRequiredStubFalse) return stubFalse_1;
      hasRequiredStubFalse = 1;
      function stubFalse() {
        return false;
      }

      stubFalse_1 = stubFalse;
      return stubFalse_1;
    }

    var hasRequiredIsBuffer;

    function requireIsBuffer() {
      if (hasRequiredIsBuffer) return isBuffer.exports;
      hasRequiredIsBuffer = 1;
      (function (module, exports) {
        var root = require_root(),
        stubFalse = requireStubFalse();

        /** Detect free variable `exports`. */
        var freeExports = exports && !exports.nodeType && exports;

        /** Detect free variable `module`. */
        var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

        /** Detect the popular CommonJS extension `module.exports`. */
        var moduleExports = freeModule && freeModule.exports === freeExports;

        /** Built-in value references. */
        var Buffer = moduleExports ? root.Buffer : undefined;

        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

        /**
         * Checks if `value` is a buffer.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
         * @example
         *
         * _.isBuffer(new Buffer(2));
         * // => true
         *
         * _.isBuffer(new Uint8Array(2));
         * // => false
         */
        var isBuffer = nativeIsBuffer || stubFalse;

        module.exports = isBuffer;
      })(isBuffer, isBuffer.exports);
      return isBuffer.exports;
    }

    var _baseIsTypedArray;
    var hasRequired_baseIsTypedArray;

    function require_baseIsTypedArray() {
      if (hasRequired_baseIsTypedArray) return _baseIsTypedArray;
      hasRequired_baseIsTypedArray = 1;
      var baseGetTag = require_baseGetTag(),
      isLength = requireIsLength(),
      isObjectLike = requireIsObjectLike();

      /** `Object#toString` result references. */
      var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

      var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

      /** Used to identify `toStringTag` values of typed arrays. */
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
      typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
      typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
      typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
      typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
      typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
      typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
      typedArrayTags[errorTag] = typedArrayTags[funcTag] =
      typedArrayTags[mapTag] = typedArrayTags[numberTag] =
      typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
      typedArrayTags[setTag] = typedArrayTags[stringTag] =
      typedArrayTags[weakMapTag] = false;

      /**
       * The base implementation of `_.isTypedArray` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       */
      function baseIsTypedArray(value) {
        return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }

      _baseIsTypedArray = baseIsTypedArray;
      return _baseIsTypedArray;
    }

    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */

    var _baseUnary;
    var hasRequired_baseUnary;

    function require_baseUnary() {
      if (hasRequired_baseUnary) return _baseUnary;
      hasRequired_baseUnary = 1;
      function baseUnary(func) {
        return function (value) {
          return func(value);
        };
      }

      _baseUnary = baseUnary;
      return _baseUnary;
    }

    var _nodeUtil = {exports: {}};

    var hasRequired_nodeUtil;

    function require_nodeUtil() {
      if (hasRequired_nodeUtil) return _nodeUtil.exports;
      hasRequired_nodeUtil = 1;
      (function (module, exports) {
        var freeGlobal = require_freeGlobal();

        /** Detect free variable `exports`. */
        var freeExports = exports && !exports.nodeType && exports;

        /** Detect free variable `module`. */
        var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

        /** Detect the popular CommonJS extension `module.exports`. */
        var moduleExports = freeModule && freeModule.exports === freeExports;

        /** Detect free variable `process` from Node.js. */
        var freeProcess = moduleExports && freeGlobal.process;

        /** Used to access faster Node.js helpers. */
        var nodeUtil = function () {
          try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;

            if (types) {
              return types;
            }

            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
          } catch (e) {}
        }();

        module.exports = nodeUtil;
      })(_nodeUtil, _nodeUtil.exports);
      return _nodeUtil.exports;
    }

    var isTypedArray_1;
    var hasRequiredIsTypedArray;

    function requireIsTypedArray() {
      if (hasRequiredIsTypedArray) return isTypedArray_1;
      hasRequiredIsTypedArray = 1;
      var baseIsTypedArray = require_baseIsTypedArray(),
      baseUnary = require_baseUnary(),
      nodeUtil = require_nodeUtil();

      /* Node.js helper references. */
      var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

      /**
       * Checks if `value` is classified as a typed array.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       * @example
       *
       * _.isTypedArray(new Uint8Array);
       * // => true
       *
       * _.isTypedArray([]);
       * // => false
       */
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

      isTypedArray_1 = isTypedArray;
      return isTypedArray_1;
    }

    var _arrayLikeKeys;
    var hasRequired_arrayLikeKeys;

    function require_arrayLikeKeys() {
      if (hasRequired_arrayLikeKeys) return _arrayLikeKeys;
      hasRequired_arrayLikeKeys = 1;
      var baseTimes = require_baseTimes(),
      isArguments = requireIsArguments(),
      isArray = requireIsArray(),
      isBuffer = requireIsBuffer(),
      isIndex = require_isIndex(),
      isTypedArray = requireIsTypedArray();

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Creates an array of the enumerable property names of the array-like `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @param {boolean} inherited Specify returning inherited property names.
       * @returns {Array} Returns the array of property names.
       */
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

        for (var key in value) {
          if ((inherited || hasOwnProperty.call(value, key)) &&
          !(skipIndexes && (
          // Safari 9 has enumerable `arguments.length` in strict mode.
          key == 'length' ||
          // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == 'offset' || key == 'parent') ||
          // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
          // Skip index properties.
          isIndex(key, length))))
          {
            result.push(key);
          }
        }
        return result;
      }

      _arrayLikeKeys = arrayLikeKeys;
      return _arrayLikeKeys;
    }

    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */

    var _overArg;
    var hasRequired_overArg;

    function require_overArg() {
      if (hasRequired_overArg) return _overArg;
      hasRequired_overArg = 1;
      function overArg(func, transform) {
        return function (arg) {
          return func(transform(arg));
        };
      }

      _overArg = overArg;
      return _overArg;
    }

    var _nativeKeys;
    var hasRequired_nativeKeys;

    function require_nativeKeys() {
      if (hasRequired_nativeKeys) return _nativeKeys;
      hasRequired_nativeKeys = 1;
      var overArg = require_overArg();

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeKeys = overArg(Object.keys, Object);

      _nativeKeys = nativeKeys;
      return _nativeKeys;
    }

    var _baseKeys;
    var hasRequired_baseKeys;

    function require_baseKeys() {
      if (hasRequired_baseKeys) return _baseKeys;
      hasRequired_baseKeys = 1;
      var isPrototype = require_isPrototype(),
      nativeKeys = require_nativeKeys();

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result = [];
        for (var key in Object(object)) {
          if (hasOwnProperty.call(object, key) && key != 'constructor') {
            result.push(key);
          }
        }
        return result;
      }

      _baseKeys = baseKeys;
      return _baseKeys;
    }

    var keys_1;
    var hasRequiredKeys;

    function requireKeys() {
      if (hasRequiredKeys) return keys_1;
      hasRequiredKeys = 1;
      var arrayLikeKeys = require_arrayLikeKeys(),
      baseKeys = require_baseKeys(),
      isArrayLike = requireIsArrayLike();

      /**
       * Creates an array of the own enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects. See the
       * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * for more details.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keys(new Foo);
       * // => ['a', 'b'] (iteration order is not guaranteed)
       *
       * _.keys('hi');
       * // => ['0', '1']
       */
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }

      keys_1 = keys;
      return keys_1;
    }

    var assign_1;
    var hasRequiredAssign;

    function requireAssign() {
      if (hasRequiredAssign) return assign_1;
      hasRequiredAssign = 1;
      var assignValue = require_assignValue(),
      copyObject = require_copyObject(),
      createAssigner = require_createAssigner(),
      isArrayLike = requireIsArrayLike(),
      isPrototype = require_isPrototype(),
      keys = requireKeys();

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Assigns own enumerable string keyed properties of source objects to the
       * destination object. Source objects are applied from left to right.
       * Subsequent sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object` and is loosely based on
       * [`Object.assign`](https://mdn.io/Object/assign).
       *
       * @static
       * @memberOf _
       * @since 0.10.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.assignIn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * function Bar() {
       *   this.c = 3;
       * }
       *
       * Foo.prototype.b = 2;
       * Bar.prototype.d = 4;
       *
       * _.assign({ 'a': 0 }, new Foo, new Bar);
       * // => { 'a': 1, 'c': 3 }
       */
      var assign = createAssigner(function (object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });

      assign_1 = assign;
      return assign_1;
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */

    var _listCacheClear;
    var hasRequired_listCacheClear;

    function require_listCacheClear() {
      if (hasRequired_listCacheClear) return _listCacheClear;
      hasRequired_listCacheClear = 1;
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }

      _listCacheClear = listCacheClear;
      return _listCacheClear;
    }

    var _assocIndexOf;
    var hasRequired_assocIndexOf;

    function require_assocIndexOf() {
      if (hasRequired_assocIndexOf) return _assocIndexOf;
      hasRequired_assocIndexOf = 1;
      var eq = requireEq();

      /**
       * Gets the index at which the `key` is found in `array` of key-value pairs.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} key The key to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }

      _assocIndexOf = assocIndexOf;
      return _assocIndexOf;
    }

    var _listCacheDelete;
    var hasRequired_listCacheDelete;

    function require_listCacheDelete() {
      if (hasRequired_listCacheDelete) return _listCacheDelete;
      hasRequired_listCacheDelete = 1;
      var assocIndexOf = require_assocIndexOf();

      /** Used for built-in method references. */
      var arrayProto = Array.prototype;

      /** Built-in value references. */
      var splice = arrayProto.splice;

      /**
       * Removes `key` and its value from the list cache.
       *
       * @private
       * @name delete
       * @memberOf ListCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function listCacheDelete(key) {
        var data = this.__data__,
        index = assocIndexOf(data, key);

        if (index < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }
        --this.size;
        return true;
      }

      _listCacheDelete = listCacheDelete;
      return _listCacheDelete;
    }

    var _listCacheGet;
    var hasRequired_listCacheGet;

    function require_listCacheGet() {
      if (hasRequired_listCacheGet) return _listCacheGet;
      hasRequired_listCacheGet = 1;
      var assocIndexOf = require_assocIndexOf();

      /**
       * Gets the list cache value for `key`.
       *
       * @private
       * @name get
       * @memberOf ListCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function listCacheGet(key) {
        var data = this.__data__,
        index = assocIndexOf(data, key);

        return index < 0 ? undefined : data[index][1];
      }

      _listCacheGet = listCacheGet;
      return _listCacheGet;
    }

    var _listCacheHas;
    var hasRequired_listCacheHas;

    function require_listCacheHas() {
      if (hasRequired_listCacheHas) return _listCacheHas;
      hasRequired_listCacheHas = 1;
      var assocIndexOf = require_assocIndexOf();

      /**
       * Checks if a list cache value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf ListCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }

      _listCacheHas = listCacheHas;
      return _listCacheHas;
    }

    var _listCacheSet;
    var hasRequired_listCacheSet;

    function require_listCacheSet() {
      if (hasRequired_listCacheSet) return _listCacheSet;
      hasRequired_listCacheSet = 1;
      var assocIndexOf = require_assocIndexOf();

      /**
       * Sets the list cache `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf ListCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the list cache instance.
       */
      function listCacheSet(key, value) {
        var data = this.__data__,
        index = assocIndexOf(data, key);

        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }
        return this;
      }

      _listCacheSet = listCacheSet;
      return _listCacheSet;
    }

    var _ListCache;
    var hasRequired_ListCache;

    function require_ListCache() {
      if (hasRequired_ListCache) return _ListCache;
      hasRequired_ListCache = 1;
      var listCacheClear = require_listCacheClear(),
      listCacheDelete = require_listCacheDelete(),
      listCacheGet = require_listCacheGet(),
      listCacheHas = require_listCacheHas(),
      listCacheSet = require_listCacheSet();

      /**
       * Creates an list cache object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function ListCache(entries) {
        var index = -1,
        length = entries == null ? 0 : entries.length;

        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      // Add methods to `ListCache`.
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype['delete'] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;

      _ListCache = ListCache;
      return _ListCache;
    }

    var _stackClear;
    var hasRequired_stackClear;

    function require_stackClear() {
      if (hasRequired_stackClear) return _stackClear;
      hasRequired_stackClear = 1;
      var ListCache = require_ListCache();

      /**
       * Removes all key-value entries from the stack.
       *
       * @private
       * @name clear
       * @memberOf Stack
       */
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }

      _stackClear = stackClear;
      return _stackClear;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */

    var _stackDelete;
    var hasRequired_stackDelete;

    function require_stackDelete() {
      if (hasRequired_stackDelete) return _stackDelete;
      hasRequired_stackDelete = 1;
      function stackDelete(key) {
        var data = this.__data__,
        result = data['delete'](key);

        this.size = data.size;
        return result;
      }

      _stackDelete = stackDelete;
      return _stackDelete;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */

    var _stackGet;
    var hasRequired_stackGet;

    function require_stackGet() {
      if (hasRequired_stackGet) return _stackGet;
      hasRequired_stackGet = 1;
      function stackGet(key) {
        return this.__data__.get(key);
      }

      _stackGet = stackGet;
      return _stackGet;
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */

    var _stackHas;
    var hasRequired_stackHas;

    function require_stackHas() {
      if (hasRequired_stackHas) return _stackHas;
      hasRequired_stackHas = 1;
      function stackHas(key) {
        return this.__data__.has(key);
      }

      _stackHas = stackHas;
      return _stackHas;
    }

    var _Map;
    var hasRequired_Map;

    function require_Map() {
      if (hasRequired_Map) return _Map;
      hasRequired_Map = 1;
      var getNative = require_getNative(),
      root = require_root();

      /* Built-in method references that are verified to be native. */
      var Map = getNative(root, 'Map');

      _Map = Map;
      return _Map;
    }

    var _nativeCreate;
    var hasRequired_nativeCreate;

    function require_nativeCreate() {
      if (hasRequired_nativeCreate) return _nativeCreate;
      hasRequired_nativeCreate = 1;
      var getNative = require_getNative();

      /* Built-in method references that are verified to be native. */
      var nativeCreate = getNative(Object, 'create');

      _nativeCreate = nativeCreate;
      return _nativeCreate;
    }

    var _hashClear;
    var hasRequired_hashClear;

    function require_hashClear() {
      if (hasRequired_hashClear) return _hashClear;
      hasRequired_hashClear = 1;
      var nativeCreate = require_nativeCreate();

      /**
       * Removes all key-value entries from the hash.
       *
       * @private
       * @name clear
       * @memberOf Hash
       */
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }

      _hashClear = hashClear;
      return _hashClear;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */

    var _hashDelete;
    var hasRequired_hashDelete;

    function require_hashDelete() {
      if (hasRequired_hashDelete) return _hashDelete;
      hasRequired_hashDelete = 1;
      function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
      }

      _hashDelete = hashDelete;
      return _hashDelete;
    }

    var _hashGet;
    var hasRequired_hashGet;

    function require_hashGet() {
      if (hasRequired_hashGet) return _hashGet;
      hasRequired_hashGet = 1;
      var nativeCreate = require_nativeCreate();

      /** Used to stand-in for `undefined` hash values. */
      var HASH_UNDEFINED = '__lodash_hash_undefined__';

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Gets the hash value for `key`.
       *
       * @private
       * @name get
       * @memberOf Hash
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result = data[key];
          return result === HASH_UNDEFINED ? undefined : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined;
      }

      _hashGet = hashGet;
      return _hashGet;
    }

    var _hashHas;
    var hasRequired_hashHas;

    function require_hashHas() {
      if (hasRequired_hashHas) return _hashHas;
      hasRequired_hashHas = 1;
      var nativeCreate = require_nativeCreate();

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Checks if a hash value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf Hash
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
      }

      _hashHas = hashHas;
      return _hashHas;
    }

    var _hashSet;
    var hasRequired_hashSet;

    function require_hashSet() {
      if (hasRequired_hashSet) return _hashSet;
      hasRequired_hashSet = 1;
      var nativeCreate = require_nativeCreate();

      /** Used to stand-in for `undefined` hash values. */
      var HASH_UNDEFINED = '__lodash_hash_undefined__';

      /**
       * Sets the hash `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Hash
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the hash instance.
       */
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
        return this;
      }

      _hashSet = hashSet;
      return _hashSet;
    }

    var _Hash;
    var hasRequired_Hash;

    function require_Hash() {
      if (hasRequired_Hash) return _Hash;
      hasRequired_Hash = 1;
      var hashClear = require_hashClear(),
      hashDelete = require_hashDelete(),
      hashGet = require_hashGet(),
      hashHas = require_hashHas(),
      hashSet = require_hashSet();

      /**
       * Creates a hash object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function Hash(entries) {
        var index = -1,
        length = entries == null ? 0 : entries.length;

        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      // Add methods to `Hash`.
      Hash.prototype.clear = hashClear;
      Hash.prototype['delete'] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;

      _Hash = Hash;
      return _Hash;
    }

    var _mapCacheClear;
    var hasRequired_mapCacheClear;

    function require_mapCacheClear() {
      if (hasRequired_mapCacheClear) return _mapCacheClear;
      hasRequired_mapCacheClear = 1;
      var Hash = require_Hash(),
      ListCache = require_ListCache(),
      Map = require_Map();

      /**
       * Removes all key-value entries from the map.
       *
       * @private
       * @name clear
       * @memberOf MapCache
       */
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          'hash': new Hash(),
          'map': new (Map || ListCache)(),
          'string': new Hash() };

      }

      _mapCacheClear = mapCacheClear;
      return _mapCacheClear;
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */

    var _isKeyable;
    var hasRequired_isKeyable;

    function require_isKeyable() {
      if (hasRequired_isKeyable) return _isKeyable;
      hasRequired_isKeyable = 1;
      function isKeyable(value) {
        var type = typeof value;
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ?
        value !== '__proto__' :
        value === null;
      }

      _isKeyable = isKeyable;
      return _isKeyable;
    }

    var _getMapData;
    var hasRequired_getMapData;

    function require_getMapData() {
      if (hasRequired_getMapData) return _getMapData;
      hasRequired_getMapData = 1;
      var isKeyable = require_isKeyable();

      /**
       * Gets the data for `map`.
       *
       * @private
       * @param {Object} map The map to query.
       * @param {string} key The reference key.
       * @returns {*} Returns the map data.
       */
      function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ?
        data[typeof key == 'string' ? 'string' : 'hash'] :
        data.map;
      }

      _getMapData = getMapData;
      return _getMapData;
    }

    var _mapCacheDelete;
    var hasRequired_mapCacheDelete;

    function require_mapCacheDelete() {
      if (hasRequired_mapCacheDelete) return _mapCacheDelete;
      hasRequired_mapCacheDelete = 1;
      var getMapData = require_getMapData();

      /**
       * Removes `key` and its value from the map.
       *
       * @private
       * @name delete
       * @memberOf MapCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function mapCacheDelete(key) {
        var result = getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
      }

      _mapCacheDelete = mapCacheDelete;
      return _mapCacheDelete;
    }

    var _mapCacheGet;
    var hasRequired_mapCacheGet;

    function require_mapCacheGet() {
      if (hasRequired_mapCacheGet) return _mapCacheGet;
      hasRequired_mapCacheGet = 1;
      var getMapData = require_getMapData();

      /**
       * Gets the map value for `key`.
       *
       * @private
       * @name get
       * @memberOf MapCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }

      _mapCacheGet = mapCacheGet;
      return _mapCacheGet;
    }

    var _mapCacheHas;
    var hasRequired_mapCacheHas;

    function require_mapCacheHas() {
      if (hasRequired_mapCacheHas) return _mapCacheHas;
      hasRequired_mapCacheHas = 1;
      var getMapData = require_getMapData();

      /**
       * Checks if a map value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf MapCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }

      _mapCacheHas = mapCacheHas;
      return _mapCacheHas;
    }

    var _mapCacheSet;
    var hasRequired_mapCacheSet;

    function require_mapCacheSet() {
      if (hasRequired_mapCacheSet) return _mapCacheSet;
      hasRequired_mapCacheSet = 1;
      var getMapData = require_getMapData();

      /**
       * Sets the map `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf MapCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the map cache instance.
       */
      function mapCacheSet(key, value) {
        var data = getMapData(this, key),
        size = data.size;

        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
      }

      _mapCacheSet = mapCacheSet;
      return _mapCacheSet;
    }

    var _MapCache;
    var hasRequired_MapCache;

    function require_MapCache() {
      if (hasRequired_MapCache) return _MapCache;
      hasRequired_MapCache = 1;
      var mapCacheClear = require_mapCacheClear(),
      mapCacheDelete = require_mapCacheDelete(),
      mapCacheGet = require_mapCacheGet(),
      mapCacheHas = require_mapCacheHas(),
      mapCacheSet = require_mapCacheSet();

      /**
       * Creates a map cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function MapCache(entries) {
        var index = -1,
        length = entries == null ? 0 : entries.length;

        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      // Add methods to `MapCache`.
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype['delete'] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;

      _MapCache = MapCache;
      return _MapCache;
    }

    var _stackSet;
    var hasRequired_stackSet;

    function require_stackSet() {
      if (hasRequired_stackSet) return _stackSet;
      hasRequired_stackSet = 1;
      var ListCache = require_ListCache(),
      Map = require_Map(),
      MapCache = require_MapCache();

      /** Used as the size to enable large array optimizations. */
      var LARGE_ARRAY_SIZE = 200;

      /**
       * Sets the stack `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Stack
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the stack cache instance.
       */
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }

      _stackSet = stackSet;
      return _stackSet;
    }

    var _Stack;
    var hasRequired_Stack;

    function require_Stack() {
      if (hasRequired_Stack) return _Stack;
      hasRequired_Stack = 1;
      var ListCache = require_ListCache(),
      stackClear = require_stackClear(),
      stackDelete = require_stackDelete(),
      stackGet = require_stackGet(),
      stackHas = require_stackHas(),
      stackSet = require_stackSet();

      /**
       * Creates a stack cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }

      // Add methods to `Stack`.
      Stack.prototype.clear = stackClear;
      Stack.prototype['delete'] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;

      _Stack = Stack;
      return _Stack;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */

    var _arrayEach;
    var hasRequired_arrayEach;

    function require_arrayEach() {
      if (hasRequired_arrayEach) return _arrayEach;
      hasRequired_arrayEach = 1;
      function arrayEach(array, iteratee) {
        var index = -1,
        length = array == null ? 0 : array.length;

        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }

      _arrayEach = arrayEach;
      return _arrayEach;
    }

    var _baseAssign;
    var hasRequired_baseAssign;

    function require_baseAssign() {
      if (hasRequired_baseAssign) return _baseAssign;
      hasRequired_baseAssign = 1;
      var copyObject = require_copyObject(),
      keys = requireKeys();

      /**
       * The base implementation of `_.assign` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }

      _baseAssign = baseAssign;
      return _baseAssign;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */

    var _nativeKeysIn;
    var hasRequired_nativeKeysIn;

    function require_nativeKeysIn() {
      if (hasRequired_nativeKeysIn) return _nativeKeysIn;
      hasRequired_nativeKeysIn = 1;
      function nativeKeysIn(object) {
        var result = [];
        if (object != null) {
          for (var key in Object(object)) {
            result.push(key);
          }
        }
        return result;
      }

      _nativeKeysIn = nativeKeysIn;
      return _nativeKeysIn;
    }

    var _baseKeysIn;
    var hasRequired_baseKeysIn;

    function require_baseKeysIn() {
      if (hasRequired_baseKeysIn) return _baseKeysIn;
      hasRequired_baseKeysIn = 1;
      var isObject = requireIsObject(),
      isPrototype = require_isPrototype(),
      nativeKeysIn = require_nativeKeysIn();

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object),
        result = [];

        for (var key in object) {
          if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
            result.push(key);
          }
        }
        return result;
      }

      _baseKeysIn = baseKeysIn;
      return _baseKeysIn;
    }

    var keysIn_1;
    var hasRequiredKeysIn;

    function requireKeysIn() {
      if (hasRequiredKeysIn) return keysIn_1;
      hasRequiredKeysIn = 1;
      var arrayLikeKeys = require_arrayLikeKeys(),
      baseKeysIn = require_baseKeysIn(),
      isArrayLike = requireIsArrayLike();

      /**
       * Creates an array of the own and inherited enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keysIn(new Foo);
       * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
       */
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }

      keysIn_1 = keysIn;
      return keysIn_1;
    }

    var _baseAssignIn;
    var hasRequired_baseAssignIn;

    function require_baseAssignIn() {
      if (hasRequired_baseAssignIn) return _baseAssignIn;
      hasRequired_baseAssignIn = 1;
      var copyObject = require_copyObject(),
      keysIn = requireKeysIn();

      /**
       * The base implementation of `_.assignIn` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }

      _baseAssignIn = baseAssignIn;
      return _baseAssignIn;
    }

    var _cloneBuffer = {exports: {}};

    var hasRequired_cloneBuffer;

    function require_cloneBuffer() {
      if (hasRequired_cloneBuffer) return _cloneBuffer.exports;
      hasRequired_cloneBuffer = 1;
      (function (module, exports) {
        var root = require_root();

        /** Detect free variable `exports`. */
        var freeExports = exports && !exports.nodeType && exports;

        /** Detect free variable `module`. */
        var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

        /** Detect the popular CommonJS extension `module.exports`. */
        var moduleExports = freeModule && freeModule.exports === freeExports;

        /** Built-in value references. */
        var Buffer = moduleExports ? root.Buffer : undefined,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

        /**
         * Creates a clone of  `buffer`.
         *
         * @private
         * @param {Buffer} buffer The buffer to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Buffer} Returns the cloned buffer.
         */
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

          buffer.copy(result);
          return result;
        }

        module.exports = cloneBuffer;
      })(_cloneBuffer, _cloneBuffer.exports);
      return _cloneBuffer.exports;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */

    var _copyArray;
    var hasRequired_copyArray;

    function require_copyArray() {
      if (hasRequired_copyArray) return _copyArray;
      hasRequired_copyArray = 1;
      function copyArray(source, array) {
        var index = -1,
        length = source.length;

        array || (array = Array(length));
        while (++index < length) {
          array[index] = source[index];
        }
        return array;
      }

      _copyArray = copyArray;
      return _copyArray;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */

    var _arrayFilter;
    var hasRequired_arrayFilter;

    function require_arrayFilter() {
      if (hasRequired_arrayFilter) return _arrayFilter;
      hasRequired_arrayFilter = 1;
      function arrayFilter(array, predicate) {
        var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }

      _arrayFilter = arrayFilter;
      return _arrayFilter;
    }

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */

    var stubArray_1;
    var hasRequiredStubArray;

    function requireStubArray() {
      if (hasRequiredStubArray) return stubArray_1;
      hasRequiredStubArray = 1;
      function stubArray() {
        return [];
      }

      stubArray_1 = stubArray;
      return stubArray_1;
    }

    var _getSymbols;
    var hasRequired_getSymbols;

    function require_getSymbols() {
      if (hasRequired_getSymbols) return _getSymbols;
      hasRequired_getSymbols = 1;
      var arrayFilter = require_arrayFilter(),
      stubArray = requireStubArray();

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Built-in value references. */
      var propertyIsEnumerable = objectProto.propertyIsEnumerable;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeGetSymbols = Object.getOwnPropertySymbols;

      /**
       * Creates an array of the own enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */
      var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
        if (object == null) {
          return [];
        }
        object = Object(object);
        return arrayFilter(nativeGetSymbols(object), function (symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };

      _getSymbols = getSymbols;
      return _getSymbols;
    }

    var _copySymbols;
    var hasRequired_copySymbols;

    function require_copySymbols() {
      if (hasRequired_copySymbols) return _copySymbols;
      hasRequired_copySymbols = 1;
      var copyObject = require_copyObject(),
      getSymbols = require_getSymbols();

      /**
       * Copies own symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }

      _copySymbols = copySymbols;
      return _copySymbols;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */

    var _arrayPush;
    var hasRequired_arrayPush;

    function require_arrayPush() {
      if (hasRequired_arrayPush) return _arrayPush;
      hasRequired_arrayPush = 1;
      function arrayPush(array, values) {
        var index = -1,
        length = values.length,
        offset = array.length;

        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }

      _arrayPush = arrayPush;
      return _arrayPush;
    }

    var _getPrototype;
    var hasRequired_getPrototype;

    function require_getPrototype() {
      if (hasRequired_getPrototype) return _getPrototype;
      hasRequired_getPrototype = 1;
      var overArg = require_overArg();

      /** Built-in value references. */
      var getPrototype = overArg(Object.getPrototypeOf, Object);

      _getPrototype = getPrototype;
      return _getPrototype;
    }

    var _getSymbolsIn;
    var hasRequired_getSymbolsIn;

    function require_getSymbolsIn() {
      if (hasRequired_getSymbolsIn) return _getSymbolsIn;
      hasRequired_getSymbolsIn = 1;
      var arrayPush = require_arrayPush(),
      getPrototype = require_getPrototype(),
      getSymbols = require_getSymbols(),
      stubArray = requireStubArray();

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeGetSymbols = Object.getOwnPropertySymbols;

      /**
       * Creates an array of the own and inherited enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
        var result = [];
        while (object) {
          arrayPush(result, getSymbols(object));
          object = getPrototype(object);
        }
        return result;
      };

      _getSymbolsIn = getSymbolsIn;
      return _getSymbolsIn;
    }

    var _copySymbolsIn;
    var hasRequired_copySymbolsIn;

    function require_copySymbolsIn() {
      if (hasRequired_copySymbolsIn) return _copySymbolsIn;
      hasRequired_copySymbolsIn = 1;
      var copyObject = require_copyObject(),
      getSymbolsIn = require_getSymbolsIn();

      /**
       * Copies own and inherited symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }

      _copySymbolsIn = copySymbolsIn;
      return _copySymbolsIn;
    }

    var _baseGetAllKeys;
    var hasRequired_baseGetAllKeys;

    function require_baseGetAllKeys() {
      if (hasRequired_baseGetAllKeys) return _baseGetAllKeys;
      hasRequired_baseGetAllKeys = 1;
      var arrayPush = require_arrayPush(),
      isArray = requireIsArray();

      /**
       * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
       * `keysFunc` and `symbolsFunc` to get the enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @param {Function} symbolsFunc The function to get the symbols of `object`.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
      }

      _baseGetAllKeys = baseGetAllKeys;
      return _baseGetAllKeys;
    }

    var _getAllKeys;
    var hasRequired_getAllKeys;

    function require_getAllKeys() {
      if (hasRequired_getAllKeys) return _getAllKeys;
      hasRequired_getAllKeys = 1;
      var baseGetAllKeys = require_baseGetAllKeys(),
      getSymbols = require_getSymbols(),
      keys = requireKeys();

      /**
       * Creates an array of own enumerable property names and symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }

      _getAllKeys = getAllKeys;
      return _getAllKeys;
    }

    var _getAllKeysIn;
    var hasRequired_getAllKeysIn;

    function require_getAllKeysIn() {
      if (hasRequired_getAllKeysIn) return _getAllKeysIn;
      hasRequired_getAllKeysIn = 1;
      var baseGetAllKeys = require_baseGetAllKeys(),
      getSymbolsIn = require_getSymbolsIn(),
      keysIn = requireKeysIn();

      /**
       * Creates an array of own and inherited enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }

      _getAllKeysIn = getAllKeysIn;
      return _getAllKeysIn;
    }

    var _DataView;
    var hasRequired_DataView;

    function require_DataView() {
      if (hasRequired_DataView) return _DataView;
      hasRequired_DataView = 1;
      var getNative = require_getNative(),
      root = require_root();

      /* Built-in method references that are verified to be native. */
      var DataView = getNative(root, 'DataView');

      _DataView = DataView;
      return _DataView;
    }

    var _Promise;
    var hasRequired_Promise;

    function require_Promise() {
      if (hasRequired_Promise) return _Promise;
      hasRequired_Promise = 1;
      var getNative = require_getNative(),
      root = require_root();

      /* Built-in method references that are verified to be native. */
      var Promise = getNative(root, 'Promise');

      _Promise = Promise;
      return _Promise;
    }

    var _Set;
    var hasRequired_Set;

    function require_Set() {
      if (hasRequired_Set) return _Set;
      hasRequired_Set = 1;
      var getNative = require_getNative(),
      root = require_root();

      /* Built-in method references that are verified to be native. */
      var Set = getNative(root, 'Set');

      _Set = Set;
      return _Set;
    }

    var _WeakMap;
    var hasRequired_WeakMap;

    function require_WeakMap() {
      if (hasRequired_WeakMap) return _WeakMap;
      hasRequired_WeakMap = 1;
      var getNative = require_getNative(),
      root = require_root();

      /* Built-in method references that are verified to be native. */
      var WeakMap = getNative(root, 'WeakMap');

      _WeakMap = WeakMap;
      return _WeakMap;
    }

    var _getTag;
    var hasRequired_getTag;

    function require_getTag() {
      if (hasRequired_getTag) return _getTag;
      hasRequired_getTag = 1;
      var DataView = require_DataView(),
      Map = require_Map(),
      Promise = require_Promise(),
      Set = require_Set(),
      WeakMap = require_WeakMap(),
      baseGetTag = require_baseGetTag(),
      toSource = require_toSource();

      /** `Object#toString` result references. */
      var mapTag = '[object Map]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      setTag = '[object Set]',
      weakMapTag = '[object WeakMap]';

      var dataViewTag = '[object DataView]';

      /** Used to detect maps, sets, and weakmaps. */
      var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);

      /**
       * Gets the `toStringTag` of `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */
      var getTag = baseGetTag;

      // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag ||
      Map && getTag(new Map()) != mapTag ||
      Promise && getTag(Promise.resolve()) != promiseTag ||
      Set && getTag(new Set()) != setTag ||
      WeakMap && getTag(new WeakMap()) != weakMapTag) {
        getTag = function (value) {
          var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';

          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:return dataViewTag;
              case mapCtorString:return mapTag;
              case promiseCtorString:return promiseTag;
              case setCtorString:return setTag;
              case weakMapCtorString:return weakMapTag;}

          }
          return result;
        };
      }

      _getTag = getTag;
      return _getTag;
    }

    /** Used for built-in method references. */

    var _initCloneArray;
    var hasRequired_initCloneArray;

    function require_initCloneArray() {
      if (hasRequired_initCloneArray) return _initCloneArray;
      hasRequired_initCloneArray = 1;
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Initializes an array clone.
       *
       * @private
       * @param {Array} array The array to clone.
       * @returns {Array} Returns the initialized clone.
       */
      function initCloneArray(array) {
        var length = array.length,
        result = new array.constructor(length);

        // Add properties assigned by `RegExp#exec`.
        if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
          result.index = array.index;
          result.input = array.input;
        }
        return result;
      }

      _initCloneArray = initCloneArray;
      return _initCloneArray;
    }

    var _Uint8Array;
    var hasRequired_Uint8Array;

    function require_Uint8Array() {
      if (hasRequired_Uint8Array) return _Uint8Array;
      hasRequired_Uint8Array = 1;
      var root = require_root();

      /** Built-in value references. */
      var Uint8Array = root.Uint8Array;

      _Uint8Array = Uint8Array;
      return _Uint8Array;
    }

    var _cloneArrayBuffer;
    var hasRequired_cloneArrayBuffer;

    function require_cloneArrayBuffer() {
      if (hasRequired_cloneArrayBuffer) return _cloneArrayBuffer;
      hasRequired_cloneArrayBuffer = 1;
      var Uint8Array = require_Uint8Array();

      /**
       * Creates a clone of `arrayBuffer`.
       *
       * @private
       * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
       * @returns {ArrayBuffer} Returns the cloned array buffer.
       */
      function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array(result).set(new Uint8Array(arrayBuffer));
        return result;
      }

      _cloneArrayBuffer = cloneArrayBuffer;
      return _cloneArrayBuffer;
    }

    var _cloneDataView;
    var hasRequired_cloneDataView;

    function require_cloneDataView() {
      if (hasRequired_cloneDataView) return _cloneDataView;
      hasRequired_cloneDataView = 1;
      var cloneArrayBuffer = require_cloneArrayBuffer();

      /**
       * Creates a clone of `dataView`.
       *
       * @private
       * @param {Object} dataView The data view to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned data view.
       */
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }

      _cloneDataView = cloneDataView;
      return _cloneDataView;
    }

    /** Used to match `RegExp` flags from their coerced string values. */

    var _cloneRegExp;
    var hasRequired_cloneRegExp;

    function require_cloneRegExp() {
      if (hasRequired_cloneRegExp) return _cloneRegExp;
      hasRequired_cloneRegExp = 1;
      var reFlags = /\w*$/;

      /**
       * Creates a clone of `regexp`.
       *
       * @private
       * @param {Object} regexp The regexp to clone.
       * @returns {Object} Returns the cloned regexp.
       */
      function cloneRegExp(regexp) {
        var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result.lastIndex = regexp.lastIndex;
        return result;
      }

      _cloneRegExp = cloneRegExp;
      return _cloneRegExp;
    }

    var _cloneSymbol;
    var hasRequired_cloneSymbol;

    function require_cloneSymbol() {
      if (hasRequired_cloneSymbol) return _cloneSymbol;
      hasRequired_cloneSymbol = 1;
      var Symbol = require_Symbol();

      /** Used to convert symbols to primitives and strings. */
      var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

      /**
       * Creates a clone of the `symbol` object.
       *
       * @private
       * @param {Object} symbol The symbol object to clone.
       * @returns {Object} Returns the cloned symbol object.
       */
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
      }

      _cloneSymbol = cloneSymbol;
      return _cloneSymbol;
    }

    var _cloneTypedArray;
    var hasRequired_cloneTypedArray;

    function require_cloneTypedArray() {
      if (hasRequired_cloneTypedArray) return _cloneTypedArray;
      hasRequired_cloneTypedArray = 1;
      var cloneArrayBuffer = require_cloneArrayBuffer();

      /**
       * Creates a clone of `typedArray`.
       *
       * @private
       * @param {Object} typedArray The typed array to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned typed array.
       */
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }

      _cloneTypedArray = cloneTypedArray;
      return _cloneTypedArray;
    }

    var _initCloneByTag;
    var hasRequired_initCloneByTag;

    function require_initCloneByTag() {
      if (hasRequired_initCloneByTag) return _initCloneByTag;
      hasRequired_initCloneByTag = 1;
      var cloneArrayBuffer = require_cloneArrayBuffer(),
      cloneDataView = require_cloneDataView(),
      cloneRegExp = require_cloneRegExp(),
      cloneSymbol = require_cloneSymbol(),
      cloneTypedArray = require_cloneTypedArray();

      /** `Object#toString` result references. */
      var boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]';

      var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

      /**
       * Initializes an object clone based on its `toStringTag`.
       *
       * **Note:** This function only supports cloning values with tags of
       * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
       *
       * @private
       * @param {Object} object The object to clone.
       * @param {string} tag The `toStringTag` of the object to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the initialized clone.
       */
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);

          case boolTag:
          case dateTag:
            return new Ctor(+object);

          case dataViewTag:
            return cloneDataView(object, isDeep);

          case float32Tag:case float64Tag:
          case int8Tag:case int16Tag:case int32Tag:
          case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:
            return cloneTypedArray(object, isDeep);

          case mapTag:
            return new Ctor();

          case numberTag:
          case stringTag:
            return new Ctor(object);

          case regexpTag:
            return cloneRegExp(object);

          case setTag:
            return new Ctor();

          case symbolTag:
            return cloneSymbol(object);}

      }

      _initCloneByTag = initCloneByTag;
      return _initCloneByTag;
    }

    var _baseCreate;
    var hasRequired_baseCreate;

    function require_baseCreate() {
      if (hasRequired_baseCreate) return _baseCreate;
      hasRequired_baseCreate = 1;
      var isObject = requireIsObject();

      /** Built-in value references. */
      var objectCreate = Object.create;

      /**
       * The base implementation of `_.create` without support for assigning
       * properties to the created object.
       *
       * @private
       * @param {Object} proto The object to inherit from.
       * @returns {Object} Returns the new object.
       */
      var baseCreate = function () {
        function object() {}
        return function (proto) {
          if (!isObject(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result = new object();
          object.prototype = undefined;
          return result;
        };
      }();

      _baseCreate = baseCreate;
      return _baseCreate;
    }

    var _initCloneObject;
    var hasRequired_initCloneObject;

    function require_initCloneObject() {
      if (hasRequired_initCloneObject) return _initCloneObject;
      hasRequired_initCloneObject = 1;
      var baseCreate = require_baseCreate(),
      getPrototype = require_getPrototype(),
      isPrototype = require_isPrototype();

      /**
       * Initializes an object clone.
       *
       * @private
       * @param {Object} object The object to clone.
       * @returns {Object} Returns the initialized clone.
       */
      function initCloneObject(object) {
        return typeof object.constructor == 'function' && !isPrototype(object) ?
        baseCreate(getPrototype(object)) :
        {};
      }

      _initCloneObject = initCloneObject;
      return _initCloneObject;
    }

    var _baseIsMap;
    var hasRequired_baseIsMap;

    function require_baseIsMap() {
      if (hasRequired_baseIsMap) return _baseIsMap;
      hasRequired_baseIsMap = 1;
      var getTag = require_getTag(),
      isObjectLike = requireIsObjectLike();

      /** `Object#toString` result references. */
      var mapTag = '[object Map]';

      /**
       * The base implementation of `_.isMap` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       */
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }

      _baseIsMap = baseIsMap;
      return _baseIsMap;
    }

    var isMap_1;
    var hasRequiredIsMap;

    function requireIsMap() {
      if (hasRequiredIsMap) return isMap_1;
      hasRequiredIsMap = 1;
      var baseIsMap = require_baseIsMap(),
      baseUnary = require_baseUnary(),
      nodeUtil = require_nodeUtil();

      /* Node.js helper references. */
      var nodeIsMap = nodeUtil && nodeUtil.isMap;

      /**
       * Checks if `value` is classified as a `Map` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       * @example
       *
       * _.isMap(new Map);
       * // => true
       *
       * _.isMap(new WeakMap);
       * // => false
       */
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

      isMap_1 = isMap;
      return isMap_1;
    }

    var _baseIsSet;
    var hasRequired_baseIsSet;

    function require_baseIsSet() {
      if (hasRequired_baseIsSet) return _baseIsSet;
      hasRequired_baseIsSet = 1;
      var getTag = require_getTag(),
      isObjectLike = requireIsObjectLike();

      /** `Object#toString` result references. */
      var setTag = '[object Set]';

      /**
       * The base implementation of `_.isSet` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       */
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }

      _baseIsSet = baseIsSet;
      return _baseIsSet;
    }

    var isSet_1;
    var hasRequiredIsSet;

    function requireIsSet() {
      if (hasRequiredIsSet) return isSet_1;
      hasRequiredIsSet = 1;
      var baseIsSet = require_baseIsSet(),
      baseUnary = require_baseUnary(),
      nodeUtil = require_nodeUtil();

      /* Node.js helper references. */
      var nodeIsSet = nodeUtil && nodeUtil.isSet;

      /**
       * Checks if `value` is classified as a `Set` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       * @example
       *
       * _.isSet(new Set);
       * // => true
       *
       * _.isSet(new WeakSet);
       * // => false
       */
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

      isSet_1 = isSet;
      return isSet_1;
    }

    var _baseClone;
    var hasRequired_baseClone;

    function require_baseClone() {
      if (hasRequired_baseClone) return _baseClone;
      hasRequired_baseClone = 1;
      var Stack = require_Stack(),
      arrayEach = require_arrayEach(),
      assignValue = require_assignValue(),
      baseAssign = require_baseAssign(),
      baseAssignIn = require_baseAssignIn(),
      cloneBuffer = require_cloneBuffer(),
      copyArray = require_copyArray(),
      copySymbols = require_copySymbols(),
      copySymbolsIn = require_copySymbolsIn(),
      getAllKeys = require_getAllKeys(),
      getAllKeysIn = require_getAllKeysIn(),
      getTag = require_getTag(),
      initCloneArray = require_initCloneArray(),
      initCloneByTag = require_initCloneByTag(),
      initCloneObject = require_initCloneObject(),
      isArray = requireIsArray(),
      isBuffer = requireIsBuffer(),
      isMap = requireIsMap(),
      isObject = requireIsObject(),
      isSet = requireIsSet(),
      keys = requireKeys(),
      keysIn = requireKeysIn();

      /** Used to compose bitmasks for cloning. */
      var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

      /** `Object#toString` result references. */
      var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      weakMapTag = '[object WeakMap]';

      var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

      /** Used to identify `toStringTag` values supported by `_.clone`. */
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] =
      cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
      cloneableTags[boolTag] = cloneableTags[dateTag] =
      cloneableTags[float32Tag] = cloneableTags[float64Tag] =
      cloneableTags[int8Tag] = cloneableTags[int16Tag] =
      cloneableTags[int32Tag] = cloneableTags[mapTag] =
      cloneableTags[numberTag] = cloneableTags[objectTag] =
      cloneableTags[regexpTag] = cloneableTags[setTag] =
      cloneableTags[stringTag] = cloneableTags[symbolTag] =
      cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
      cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] =
      cloneableTags[weakMapTag] = false;

      /**
       * The base implementation of `_.clone` and `_.cloneDeep` which tracks
       * traversed objects.
       *
       * @private
       * @param {*} value The value to clone.
       * @param {boolean} bitmask The bitmask flags.
       *  1 - Deep clone
       *  2 - Flatten inherited properties
       *  4 - Clone symbols
       * @param {Function} [customizer] The function to customize cloning.
       * @param {string} [key] The key of `value`.
       * @param {Object} [object] The parent object of `value`.
       * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
       * @returns {*} Returns the cloned value.
       */
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result,
        isDeep = bitmask & CLONE_DEEP_FLAG,
        isFlat = bitmask & CLONE_FLAT_FLAG,
        isFull = bitmask & CLONE_SYMBOLS_FLAG;

        if (customizer) {
          result = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result !== undefined) {
          return result;
        }
        if (!isObject(value)) {
          return value;
        }
        var isArr = isArray(value);
        if (isArr) {
          result = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result);
          }
        } else {
          var tag = getTag(value),
          isFunc = tag == funcTag || tag == genTag;

          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ?
              copySymbolsIn(value, baseAssignIn(result, value)) :
              copySymbols(value, baseAssign(result, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result = initCloneByTag(value, tag, isDeep);
          }
        }
        // Check for circular references and return its corresponding clone.
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result);

        if (isSet(value)) {
          value.forEach(function (subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function (subValue, key) {
            result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
          });
        }

        var keysFunc = isFull ?
        isFlat ? getAllKeysIn : getAllKeys :
        isFlat ? keysIn : keys;

        var props = isArr ? undefined : keysFunc(value);
        arrayEach(props || value, function (subValue, key) {
          if (props) {
            key = subValue;
            subValue = value[key];
          }
          // Recursively populate clone (susceptible to call stack limits).
          assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
        return result;
      }

      _baseClone = baseClone;
      return _baseClone;
    }

    var cloneDeep_1;
    var hasRequiredCloneDeep;

    function requireCloneDeep() {
      if (hasRequiredCloneDeep) return cloneDeep_1;
      hasRequiredCloneDeep = 1;
      var baseClone = require_baseClone();

      /** Used to compose bitmasks for cloning. */
      var CLONE_DEEP_FLAG = 1,
      CLONE_SYMBOLS_FLAG = 4;

      /**
       * This method is like `_.clone` except that it recursively clones `value`.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Lang
       * @param {*} value The value to recursively clone.
       * @returns {*} Returns the deep cloned value.
       * @see _.clone
       * @example
       *
       * var objects = [{ 'a': 1 }, { 'b': 2 }];
       *
       * var deep = _.cloneDeep(objects);
       * console.log(deep[0] === objects[0]);
       * // => false
       */
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }

      cloneDeep_1 = cloneDeep;
      return cloneDeep_1;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */

    var compact_1;
    var hasRequiredCompact;

    function requireCompact() {
      if (hasRequiredCompact) return compact_1;
      hasRequiredCompact = 1;
      function compact(array) {
        var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }

      compact_1 = compact;
      return compact_1;
    }

    /** Used to stand-in for `undefined` hash values. */

    var _setCacheAdd;
    var hasRequired_setCacheAdd;

    function require_setCacheAdd() {
      if (hasRequired_setCacheAdd) return _setCacheAdd;
      hasRequired_setCacheAdd = 1;
      var HASH_UNDEFINED = '__lodash_hash_undefined__';

      /**
       * Adds `value` to the array cache.
       *
       * @private
       * @name add
       * @memberOf SetCache
       * @alias push
       * @param {*} value The value to cache.
       * @returns {Object} Returns the cache instance.
       */
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }

      _setCacheAdd = setCacheAdd;
      return _setCacheAdd;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */

    var _setCacheHas;
    var hasRequired_setCacheHas;

    function require_setCacheHas() {
      if (hasRequired_setCacheHas) return _setCacheHas;
      hasRequired_setCacheHas = 1;
      function setCacheHas(value) {
        return this.__data__.has(value);
      }

      _setCacheHas = setCacheHas;
      return _setCacheHas;
    }

    var _SetCache;
    var hasRequired_SetCache;

    function require_SetCache() {
      if (hasRequired_SetCache) return _SetCache;
      hasRequired_SetCache = 1;
      var MapCache = require_MapCache(),
      setCacheAdd = require_setCacheAdd(),
      setCacheHas = require_setCacheHas();

      /**
       *
       * Creates an array cache object to store unique values.
       *
       * @private
       * @constructor
       * @param {Array} [values] The values to cache.
       */
      function SetCache(values) {
        var index = -1,
        length = values == null ? 0 : values.length;

        this.__data__ = new MapCache();
        while (++index < length) {
          this.add(values[index]);
        }
      }

      // Add methods to `SetCache`.
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;

      _SetCache = SetCache;
      return _SetCache;
    }

    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */

    var _baseFindIndex;
    var hasRequired_baseFindIndex;

    function require_baseFindIndex() {
      if (hasRequired_baseFindIndex) return _baseFindIndex;
      hasRequired_baseFindIndex = 1;
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }

      _baseFindIndex = baseFindIndex;
      return _baseFindIndex;
    }

    /**
     * The base implementation of `_.isNaN` without support for number objects.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     */

    var _baseIsNaN;
    var hasRequired_baseIsNaN;

    function require_baseIsNaN() {
      if (hasRequired_baseIsNaN) return _baseIsNaN;
      hasRequired_baseIsNaN = 1;
      function baseIsNaN(value) {
        return value !== value;
      }

      _baseIsNaN = baseIsNaN;
      return _baseIsNaN;
    }

    /**
     * A specialized version of `_.indexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */

    var _strictIndexOf;
    var hasRequired_strictIndexOf;

    function require_strictIndexOf() {
      if (hasRequired_strictIndexOf) return _strictIndexOf;
      hasRequired_strictIndexOf = 1;
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1,
        length = array.length;

        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }

      _strictIndexOf = strictIndexOf;
      return _strictIndexOf;
    }

    var _baseIndexOf;
    var hasRequired_baseIndexOf;

    function require_baseIndexOf() {
      if (hasRequired_baseIndexOf) return _baseIndexOf;
      hasRequired_baseIndexOf = 1;
      var baseFindIndex = require_baseFindIndex(),
      baseIsNaN = require_baseIsNaN(),
      strictIndexOf = require_strictIndexOf();

      /**
       * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function baseIndexOf(array, value, fromIndex) {
        return value === value ?
        strictIndexOf(array, value, fromIndex) :
        baseFindIndex(array, baseIsNaN, fromIndex);
      }

      _baseIndexOf = baseIndexOf;
      return _baseIndexOf;
    }

    var _arrayIncludes;
    var hasRequired_arrayIncludes;

    function require_arrayIncludes() {
      if (hasRequired_arrayIncludes) return _arrayIncludes;
      hasRequired_arrayIncludes = 1;
      var baseIndexOf = require_baseIndexOf();

      /**
       * A specialized version of `_.includes` for arrays without support for
       * specifying an index to search from.
       *
       * @private
       * @param {Array} [array] The array to inspect.
       * @param {*} target The value to search for.
       * @returns {boolean} Returns `true` if `target` is found, else `false`.
       */
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }

      _arrayIncludes = arrayIncludes;
      return _arrayIncludes;
    }

    /**
     * This function is like `arrayIncludes` except that it accepts a comparator.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */

    var _arrayIncludesWith;
    var hasRequired_arrayIncludesWith;

    function require_arrayIncludesWith() {
      if (hasRequired_arrayIncludesWith) return _arrayIncludesWith;
      hasRequired_arrayIncludesWith = 1;
      function arrayIncludesWith(array, value, comparator) {
        var index = -1,
        length = array == null ? 0 : array.length;

        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }

      _arrayIncludesWith = arrayIncludesWith;
      return _arrayIncludesWith;
    }

    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */

    var _arrayMap;
    var hasRequired_arrayMap;

    function require_arrayMap() {
      if (hasRequired_arrayMap) return _arrayMap;
      hasRequired_arrayMap = 1;
      function arrayMap(array, iteratee) {
        var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }

      _arrayMap = arrayMap;
      return _arrayMap;
    }

    /**
     * Checks if a `cache` value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */

    var _cacheHas;
    var hasRequired_cacheHas;

    function require_cacheHas() {
      if (hasRequired_cacheHas) return _cacheHas;
      hasRequired_cacheHas = 1;
      function cacheHas(cache, key) {
        return cache.has(key);
      }

      _cacheHas = cacheHas;
      return _cacheHas;
    }

    var _baseDifference;
    var hasRequired_baseDifference;

    function require_baseDifference() {
      if (hasRequired_baseDifference) return _baseDifference;
      hasRequired_baseDifference = 1;
      var SetCache = require_SetCache(),
      arrayIncludes = require_arrayIncludes(),
      arrayIncludesWith = require_arrayIncludesWith(),
      arrayMap = require_arrayMap(),
      baseUnary = require_baseUnary(),
      cacheHas = require_cacheHas();

      /** Used as the size to enable large array optimizations. */
      var LARGE_ARRAY_SIZE = 200;

      /**
       * The base implementation of methods like `_.difference` without support
       * for excluding multiple arrays or iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Array} values The values to exclude.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       */
      function baseDifference(array, values, iteratee, comparator) {
        var index = -1,
        includes = arrayIncludes,
        isCommon = true,
        length = array.length,
        result = [],
        valuesLength = values.length;

        if (!length) {
          return result;
        }
        if (iteratee) {
          values = arrayMap(values, baseUnary(iteratee));
        }
        if (comparator) {
          includes = arrayIncludesWith;
          isCommon = false;
        } else
        if (values.length >= LARGE_ARRAY_SIZE) {
          includes = cacheHas;
          isCommon = false;
          values = new SetCache(values);
        }
        outer:
        while (++index < length) {
          var value = array[index],
          computed = iteratee == null ? value : iteratee(value);

          value = comparator || value !== 0 ? value : 0;
          if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while (valuesIndex--) {
              if (values[valuesIndex] === computed) {
                continue outer;
              }
            }
            result.push(value);
          } else
          if (!includes(values, computed, comparator)) {
            result.push(value);
          }
        }
        return result;
      }

      _baseDifference = baseDifference;
      return _baseDifference;
    }

    var _isFlattenable;
    var hasRequired_isFlattenable;

    function require_isFlattenable() {
      if (hasRequired_isFlattenable) return _isFlattenable;
      hasRequired_isFlattenable = 1;
      var Symbol = require_Symbol(),
      isArguments = requireIsArguments(),
      isArray = requireIsArray();

      /** Built-in value references. */
      var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

      /**
       * Checks if `value` is a flattenable `arguments` object or array.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
       */
      function isFlattenable(value) {
        return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
      }

      _isFlattenable = isFlattenable;
      return _isFlattenable;
    }

    var _baseFlatten;
    var hasRequired_baseFlatten;

    function require_baseFlatten() {
      if (hasRequired_baseFlatten) return _baseFlatten;
      hasRequired_baseFlatten = 1;
      var arrayPush = require_arrayPush(),
      isFlattenable = require_isFlattenable();

      /**
       * The base implementation of `_.flatten` with support for restricting flattening.
       *
       * @private
       * @param {Array} array The array to flatten.
       * @param {number} depth The maximum recursion depth.
       * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
       * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
       * @param {Array} [result=[]] The initial result value.
       * @returns {Array} Returns the new flattened array.
       */
      function baseFlatten(array, depth, predicate, isStrict, result) {
        var index = -1,
        length = array.length;

        predicate || (predicate = isFlattenable);
        result || (result = []);

        while (++index < length) {
          var value = array[index];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              // Recursively flatten arrays (susceptible to call stack limits).
              baseFlatten(value, depth - 1, predicate, isStrict, result);
            } else {
              arrayPush(result, value);
            }
          } else if (!isStrict) {
            result[result.length] = value;
          }
        }
        return result;
      }

      _baseFlatten = baseFlatten;
      return _baseFlatten;
    }

    var isArrayLikeObject_1;
    var hasRequiredIsArrayLikeObject;

    function requireIsArrayLikeObject() {
      if (hasRequiredIsArrayLikeObject) return isArrayLikeObject_1;
      hasRequiredIsArrayLikeObject = 1;
      var isArrayLike = requireIsArrayLike(),
      isObjectLike = requireIsObjectLike();

      /**
       * This method is like `_.isArrayLike` except that it also checks if `value`
       * is an object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array-like object,
       *  else `false`.
       * @example
       *
       * _.isArrayLikeObject([1, 2, 3]);
       * // => true
       *
       * _.isArrayLikeObject(document.body.children);
       * // => true
       *
       * _.isArrayLikeObject('abc');
       * // => false
       *
       * _.isArrayLikeObject(_.noop);
       * // => false
       */
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }

      isArrayLikeObject_1 = isArrayLikeObject;
      return isArrayLikeObject_1;
    }

    var difference_1;
    var hasRequiredDifference;

    function requireDifference() {
      if (hasRequiredDifference) return difference_1;
      hasRequiredDifference = 1;
      var baseDifference = require_baseDifference(),
      baseFlatten = require_baseFlatten(),
      baseRest = require_baseRest(),
      isArrayLikeObject = requireIsArrayLikeObject();

      /**
       * Creates an array of `array` values not included in the other given arrays
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons. The order and references of result values are
       * determined by the first array.
       *
       * **Note:** Unlike `_.pullAll`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.without, _.xor
       * @example
       *
       * _.difference([2, 1], [2, 3]);
       * // => [1]
       */
      var difference = baseRest(function (array, values) {
        return isArrayLikeObject(array) ?
        baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) :
        [];
      });

      difference_1 = difference;
      return difference_1;
    }

    var _baseFunctions;
    var hasRequired_baseFunctions;

    function require_baseFunctions() {
      if (hasRequired_baseFunctions) return _baseFunctions;
      hasRequired_baseFunctions = 1;
      var arrayFilter = require_arrayFilter(),
      isFunction = requireIsFunction();

      /**
       * The base implementation of `_.functions` which creates an array of
       * `object` function property names filtered from `props`.
       *
       * @private
       * @param {Object} object The object to inspect.
       * @param {Array} props The property names to filter.
       * @returns {Array} Returns the function names.
       */
      function baseFunctions(object, props) {
        return arrayFilter(props, function (key) {
          return isFunction(object[key]);
        });
      }

      _baseFunctions = baseFunctions;
      return _baseFunctions;
    }

    var functions_1;
    var hasRequiredFunctions;

    function requireFunctions() {
      if (hasRequiredFunctions) return functions_1;
      hasRequiredFunctions = 1;
      var baseFunctions = require_baseFunctions(),
      keys = requireKeys();

      /**
       * Creates an array of function property names from own enumerable properties
       * of `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to inspect.
       * @returns {Array} Returns the function names.
       * @see _.functionsIn
       * @example
       *
       * function Foo() {
       *   this.a = _.constant('a');
       *   this.b = _.constant('b');
       * }
       *
       * Foo.prototype.c = _.constant('c');
       *
       * _.functions(new Foo);
       * // => ['a', 'b']
       */
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }

      functions_1 = functions;
      return functions_1;
    }

    var isString_1;
    var hasRequiredIsString;

    function requireIsString() {
      if (hasRequiredIsString) return isString_1;
      hasRequiredIsString = 1;
      var baseGetTag = require_baseGetTag(),
      isArray = requireIsArray(),
      isObjectLike = requireIsObjectLike();

      /** `Object#toString` result references. */
      var stringTag = '[object String]';

      /**
       * Checks if `value` is classified as a `String` primitive or object.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a string, else `false`.
       * @example
       *
       * _.isString('abc');
       * // => true
       *
       * _.isString(1);
       * // => false
       */
      function isString(value) {
        return typeof value == 'string' ||
        !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }

      isString_1 = isString;
      return isString_1;
    }

    /** Used to match a single whitespace character. */

    var _trimmedEndIndex;
    var hasRequired_trimmedEndIndex;

    function require_trimmedEndIndex() {
      if (hasRequired_trimmedEndIndex) return _trimmedEndIndex;
      hasRequired_trimmedEndIndex = 1;
      var reWhitespace = /\s/;

      /**
       * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
       * character of `string`.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {number} Returns the index of the last non-whitespace character.
       */
      function trimmedEndIndex(string) {
        var index = string.length;

        while (index-- && reWhitespace.test(string.charAt(index))) {}
        return index;
      }

      _trimmedEndIndex = trimmedEndIndex;
      return _trimmedEndIndex;
    }

    var _baseTrim;
    var hasRequired_baseTrim;

    function require_baseTrim() {
      if (hasRequired_baseTrim) return _baseTrim;
      hasRequired_baseTrim = 1;
      var trimmedEndIndex = require_trimmedEndIndex();

      /** Used to match leading whitespace. */
      var reTrimStart = /^\s+/;

      /**
       * The base implementation of `_.trim`.
       *
       * @private
       * @param {string} string The string to trim.
       * @returns {string} Returns the trimmed string.
       */
      function baseTrim(string) {
        return string ?
        string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') :
        string;
      }

      _baseTrim = baseTrim;
      return _baseTrim;
    }

    var isSymbol_1;
    var hasRequiredIsSymbol;

    function requireIsSymbol() {
      if (hasRequiredIsSymbol) return isSymbol_1;
      hasRequiredIsSymbol = 1;
      var baseGetTag = require_baseGetTag(),
      isObjectLike = requireIsObjectLike();

      /** `Object#toString` result references. */
      var symbolTag = '[object Symbol]';

      /**
       * Checks if `value` is classified as a `Symbol` primitive or object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
       * @example
       *
       * _.isSymbol(Symbol.iterator);
       * // => true
       *
       * _.isSymbol('abc');
       * // => false
       */
      function isSymbol(value) {
        return typeof value == 'symbol' ||
        isObjectLike(value) && baseGetTag(value) == symbolTag;
      }

      isSymbol_1 = isSymbol;
      return isSymbol_1;
    }

    var toNumber_1;
    var hasRequiredToNumber;

    function requireToNumber() {
      if (hasRequiredToNumber) return toNumber_1;
      hasRequiredToNumber = 1;
      var baseTrim = require_baseTrim(),
      isObject = requireIsObject(),
      isSymbol = requireIsSymbol();

      /** Used as references for various `Number` constants. */
      var NAN = 0 / 0;

      /** Used to detect bad signed hexadecimal string values. */
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

      /** Used to detect binary string values. */
      var reIsBinary = /^0b[01]+$/i;

      /** Used to detect octal string values. */
      var reIsOctal = /^0o[0-7]+$/i;

      /** Built-in method references without a dependency on `root`. */
      var freeParseInt = parseInt;

      /**
       * Converts `value` to a number.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to process.
       * @returns {number} Returns the number.
       * @example
       *
       * _.toNumber(3.2);
       * // => 3.2
       *
       * _.toNumber(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toNumber(Infinity);
       * // => Infinity
       *
       * _.toNumber('3.2');
       * // => 3.2
       */
      function toNumber(value) {
        if (typeof value == 'number') {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
          value = isObject(other) ? other + '' : other;
        }
        if (typeof value != 'string') {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ?
        freeParseInt(value.slice(2), isBinary ? 2 : 8) :
        reIsBadHex.test(value) ? NAN : +value;
      }

      toNumber_1 = toNumber;
      return toNumber_1;
    }

    var toFinite_1;
    var hasRequiredToFinite;

    function requireToFinite() {
      if (hasRequiredToFinite) return toFinite_1;
      hasRequiredToFinite = 1;
      var toNumber = requireToNumber();

      /** Used as references for various `Number` constants. */
      var INFINITY = 1 / 0,
      MAX_INTEGER = 1.7976931348623157e+308;

      /**
       * Converts `value` to a finite number.
       *
       * @static
       * @memberOf _
       * @since 4.12.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted number.
       * @example
       *
       * _.toFinite(3.2);
       * // => 3.2
       *
       * _.toFinite(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toFinite(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toFinite('3.2');
       * // => 3.2
       */
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }

      toFinite_1 = toFinite;
      return toFinite_1;
    }

    var toInteger_1;
    var hasRequiredToInteger;

    function requireToInteger() {
      if (hasRequiredToInteger) return toInteger_1;
      hasRequiredToInteger = 1;
      var toFinite = requireToFinite();

      /**
       * Converts `value` to an integer.
       *
       * **Note:** This method is loosely based on
       * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toInteger(3.2);
       * // => 3
       *
       * _.toInteger(Number.MIN_VALUE);
       * // => 0
       *
       * _.toInteger(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toInteger('3.2');
       * // => 3
       */
      function toInteger(value) {
        var result = toFinite(value),
        remainder = result % 1;

        return result === result ? remainder ? result - remainder : result : 0;
      }

      toInteger_1 = toInteger;
      return toInteger_1;
    }

    var _baseValues;
    var hasRequired_baseValues;

    function require_baseValues() {
      if (hasRequired_baseValues) return _baseValues;
      hasRequired_baseValues = 1;
      var arrayMap = require_arrayMap();

      /**
       * The base implementation of `_.values` and `_.valuesIn` which creates an
       * array of `object` property values corresponding to the property names
       * of `props`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} props The property names to get values for.
       * @returns {Object} Returns the array of property values.
       */
      function baseValues(object, props) {
        return arrayMap(props, function (key) {
          return object[key];
        });
      }

      _baseValues = baseValues;
      return _baseValues;
    }

    var values_1;
    var hasRequiredValues;

    function requireValues() {
      if (hasRequiredValues) return values_1;
      hasRequiredValues = 1;
      var baseValues = require_baseValues(),
      keys = requireKeys();

      /**
       * Creates an array of the own enumerable string keyed property values of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property values.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.values(new Foo);
       * // => [1, 2] (iteration order is not guaranteed)
       *
       * _.values('hi');
       * // => ['h', 'i']
       */
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }

      values_1 = values;
      return values_1;
    }

    var includes_1;
    var hasRequiredIncludes;

    function requireIncludes() {
      if (hasRequiredIncludes) return includes_1;
      hasRequiredIncludes = 1;
      var baseIndexOf = require_baseIndexOf(),
      isArrayLike = requireIsArrayLike(),
      isString = requireIsString(),
      toInteger = requireToInteger(),
      values = requireValues();

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeMax = Math.max;

      /**
       * Checks if `value` is in `collection`. If `collection` is a string, it's
       * checked for a substring of `value`, otherwise
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * is used for equality comparisons. If `fromIndex` is negative, it's used as
       * the offset from the end of `collection`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object|string} collection The collection to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=0] The index to search from.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
       * @returns {boolean} Returns `true` if `value` is found, else `false`.
       * @example
       *
       * _.includes([1, 2, 3], 1);
       * // => true
       *
       * _.includes([1, 2, 3], 1, 2);
       * // => false
       *
       * _.includes({ 'a': 1, 'b': 2 }, 1);
       * // => true
       *
       * _.includes('abcd', 'bc');
       * // => true
       */
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;

        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString(collection) ?
        fromIndex <= length && collection.indexOf(value, fromIndex) > -1 :
        !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }

      includes_1 = includes;
      return includes_1;
    }

    var isPlainObject_1;
    var hasRequiredIsPlainObject;

    function requireIsPlainObject() {
      if (hasRequiredIsPlainObject) return isPlainObject_1;
      hasRequiredIsPlainObject = 1;
      var baseGetTag = require_baseGetTag(),
      getPrototype = require_getPrototype(),
      isObjectLike = requireIsObjectLike();

      /** `Object#toString` result references. */
      var objectTag = '[object Object]';

      /** Used for built-in method references. */
      var funcProto = Function.prototype,
      objectProto = Object.prototype;

      /** Used to resolve the decompiled source of functions. */
      var funcToString = funcProto.toString;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /** Used to infer the `Object` constructor. */
      var objectCtorString = funcToString.call(Object);

      /**
       * Checks if `value` is a plain object, that is, an object created by the
       * `Object` constructor or one with a `[[Prototype]]` of `null`.
       *
       * @static
       * @memberOf _
       * @since 0.8.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * _.isPlainObject(new Foo);
       * // => false
       *
       * _.isPlainObject([1, 2, 3]);
       * // => false
       *
       * _.isPlainObject({ 'x': 0, 'y': 0 });
       * // => true
       *
       * _.isPlainObject(Object.create(null));
       * // => true
       */
      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
      }

      isPlainObject_1 = isPlainObject;
      return isPlainObject_1;
    }

    var isElement_1;
    var hasRequiredIsElement;

    function requireIsElement() {
      if (hasRequiredIsElement) return isElement_1;
      hasRequiredIsElement = 1;
      var isObjectLike = requireIsObjectLike(),
      isPlainObject = requireIsPlainObject();

      /**
       * Checks if `value` is likely a DOM element.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
       * @example
       *
       * _.isElement(document.body);
       * // => true
       *
       * _.isElement('<body>');
       * // => false
       */
      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
      }

      isElement_1 = isElement;
      return isElement_1;
    }

    var _assignMergeValue;
    var hasRequired_assignMergeValue;

    function require_assignMergeValue() {
      if (hasRequired_assignMergeValue) return _assignMergeValue;
      hasRequired_assignMergeValue = 1;
      var baseAssignValue = require_baseAssignValue(),
      eq = requireEq();

      /**
       * This function is like `assignValue` except that it doesn't assign
       * `undefined` values.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function assignMergeValue(object, key, value) {
        if (value !== undefined && !eq(object[key], value) ||
        value === undefined && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }

      _assignMergeValue = assignMergeValue;
      return _assignMergeValue;
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */

    var _createBaseFor;
    var hasRequired_createBaseFor;

    function require_createBaseFor() {
      if (hasRequired_createBaseFor) return _createBaseFor;
      hasRequired_createBaseFor = 1;
      function createBaseFor(fromRight) {
        return function (object, iteratee, keysFunc) {
          var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

          while (length--) {
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }

      _createBaseFor = createBaseFor;
      return _createBaseFor;
    }

    var _baseFor;
    var hasRequired_baseFor;

    function require_baseFor() {
      if (hasRequired_baseFor) return _baseFor;
      hasRequired_baseFor = 1;
      var createBaseFor = require_createBaseFor();

      /**
       * The base implementation of `baseForOwn` which iterates over `object`
       * properties returned by `keysFunc` and invokes `iteratee` for each property.
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @returns {Object} Returns `object`.
       */
      var baseFor = createBaseFor();

      _baseFor = baseFor;
      return _baseFor;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */

    var _safeGet;
    var hasRequired_safeGet;

    function require_safeGet() {
      if (hasRequired_safeGet) return _safeGet;
      hasRequired_safeGet = 1;
      function safeGet(object, key) {
        if (key === 'constructor' && typeof object[key] === 'function') {
          return;
        }

        if (key == '__proto__') {
          return;
        }

        return object[key];
      }

      _safeGet = safeGet;
      return _safeGet;
    }

    var toPlainObject_1;
    var hasRequiredToPlainObject;

    function requireToPlainObject() {
      if (hasRequiredToPlainObject) return toPlainObject_1;
      hasRequiredToPlainObject = 1;
      var copyObject = require_copyObject(),
      keysIn = requireKeysIn();

      /**
       * Converts `value` to a plain object flattening inherited enumerable string
       * keyed properties of `value` to own properties of the plain object.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {Object} Returns the converted plain object.
       * @example
       *
       * function Foo() {
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.assign({ 'a': 1 }, new Foo);
       * // => { 'a': 1, 'b': 2 }
       *
       * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
       * // => { 'a': 1, 'b': 2, 'c': 3 }
       */
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }

      toPlainObject_1 = toPlainObject;
      return toPlainObject_1;
    }

    var _baseMergeDeep;
    var hasRequired_baseMergeDeep;

    function require_baseMergeDeep() {
      if (hasRequired_baseMergeDeep) return _baseMergeDeep;
      hasRequired_baseMergeDeep = 1;
      var assignMergeValue = require_assignMergeValue(),
      cloneBuffer = require_cloneBuffer(),
      cloneTypedArray = require_cloneTypedArray(),
      copyArray = require_copyArray(),
      initCloneObject = require_initCloneObject(),
      isArguments = requireIsArguments(),
      isArray = requireIsArray(),
      isArrayLikeObject = requireIsArrayLikeObject(),
      isBuffer = requireIsBuffer(),
      isFunction = requireIsFunction(),
      isObject = requireIsObject(),
      isPlainObject = requireIsPlainObject(),
      isTypedArray = requireIsTypedArray(),
      safeGet = require_safeGet(),
      toPlainObject = requireToPlainObject();

      /**
       * A specialized version of `baseMerge` for arrays and objects which performs
       * deep merges and tracks traversed objects enabling objects with circular
       * references to be merged.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {string} key The key of the value to merge.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} mergeFunc The function to merge values.
       * @param {Function} [customizer] The function to customize assigned values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key),
        srcValue = safeGet(source, key),
        stacked = stack.get(srcValue);

        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ?
        customizer(objValue, srcValue, key + '', object, source, stack) :
        undefined;

        var isCommon = newValue === undefined;

        if (isCommon) {
          var isArr = isArray(srcValue),
          isBuff = !isArr && isBuffer(srcValue),
          isTyped = !isArr && !isBuff && isTypedArray(srcValue);

          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            } else
            if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else
            if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else
            if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else
            {
              newValue = [];
            }
          } else
          if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else
            if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else
          {
            isCommon = false;
          }
        }
        if (isCommon) {
          // Recursively merge objects and arrays (susceptible to call stack limits).
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack['delete'](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }

      _baseMergeDeep = baseMergeDeep;
      return _baseMergeDeep;
    }

    var _baseMerge;
    var hasRequired_baseMerge;

    function require_baseMerge() {
      if (hasRequired_baseMerge) return _baseMerge;
      hasRequired_baseMerge = 1;
      var Stack = require_Stack(),
      assignMergeValue = require_assignMergeValue(),
      baseFor = require_baseFor(),
      baseMergeDeep = require_baseMergeDeep(),
      isObject = requireIsObject(),
      keysIn = requireKeysIn(),
      safeGet = require_safeGet();

      /**
       * The base implementation of `_.merge` without support for multiple sources.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} [customizer] The function to customize merged values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function (srcValue, key) {
          stack || (stack = new Stack());
          if (isObject(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else
          {
            var newValue = customizer ?
            customizer(safeGet(object, key), srcValue, key + '', object, source, stack) :
            undefined;

            if (newValue === undefined) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }

      _baseMerge = baseMerge;
      return _baseMerge;
    }

    var merge_1;
    var hasRequiredMerge;

    function requireMerge() {
      if (hasRequiredMerge) return merge_1;
      hasRequiredMerge = 1;
      var baseMerge = require_baseMerge(),
      createAssigner = require_createAssigner();

      /**
       * This method is like `_.assign` except that it recursively merges own and
       * inherited enumerable string keyed properties of source objects into the
       * destination object. Source properties that resolve to `undefined` are
       * skipped if a destination value exists. Array and plain object properties
       * are merged recursively. Other objects and value types are overridden by
       * assignment. Source objects are applied from left to right. Subsequent
       * sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {
       *   'a': [{ 'b': 2 }, { 'd': 4 }]
       * };
       *
       * var other = {
       *   'a': [{ 'c': 3 }, { 'e': 5 }]
       * };
       *
       * _.merge(object, other);
       * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
       */
      var merge = createAssigner(function (object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });

      merge_1 = merge;
      return merge_1;
    }

    var _baseToString;
    var hasRequired_baseToString;

    function require_baseToString() {
      if (hasRequired_baseToString) return _baseToString;
      hasRequired_baseToString = 1;
      var Symbol = require_Symbol(),
      arrayMap = require_arrayMap(),
      isArray = requireIsArray(),
      isSymbol = requireIsSymbol();

      /** Used as references for various `Number` constants. */
      var INFINITY = 1 / 0;

      /** Used to convert symbols to primitives and strings. */
      var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;

      /**
       * The base implementation of `_.toString` which doesn't convert nullish
       * values to empty strings.
       *
       * @private
       * @param {*} value The value to process.
       * @returns {string} Returns the string.
       */
      function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == 'string') {
          return value;
        }
        if (isArray(value)) {
          // Recursively convert values (susceptible to call stack limits).
          return arrayMap(value, baseToString) + '';
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : '';
        }
        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }

      _baseToString = baseToString;
      return _baseToString;
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */

    var _baseSlice;
    var hasRequired_baseSlice;

    function require_baseSlice() {
      if (hasRequired_baseSlice) return _baseSlice;
      hasRequired_baseSlice = 1;
      function baseSlice(array, start, end) {
        var index = -1,
        length = array.length;

        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;

        var result = Array(length);
        while (++index < length) {
          result[index] = array[index + start];
        }
        return result;
      }

      _baseSlice = baseSlice;
      return _baseSlice;
    }

    var _castSlice;
    var hasRequired_castSlice;

    function require_castSlice() {
      if (hasRequired_castSlice) return _castSlice;
      hasRequired_castSlice = 1;
      var baseSlice = require_baseSlice();

      /**
       * Casts `array` to a slice if it's needed.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {number} start The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the cast slice.
       */
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }

      _castSlice = castSlice;
      return _castSlice;
    }

    var _charsEndIndex;
    var hasRequired_charsEndIndex;

    function require_charsEndIndex() {
      if (hasRequired_charsEndIndex) return _charsEndIndex;
      hasRequired_charsEndIndex = 1;
      var baseIndexOf = require_baseIndexOf();

      /**
       * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
       * that is not found in the character symbols.
       *
       * @private
       * @param {Array} strSymbols The string symbols to inspect.
       * @param {Array} chrSymbols The character symbols to find.
       * @returns {number} Returns the index of the last unmatched string symbol.
       */
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;

        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
        return index;
      }

      _charsEndIndex = charsEndIndex;
      return _charsEndIndex;
    }

    var _charsStartIndex;
    var hasRequired_charsStartIndex;

    function require_charsStartIndex() {
      if (hasRequired_charsStartIndex) return _charsStartIndex;
      hasRequired_charsStartIndex = 1;
      var baseIndexOf = require_baseIndexOf();

      /**
       * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
       * that is not found in the character symbols.
       *
       * @private
       * @param {Array} strSymbols The string symbols to inspect.
       * @param {Array} chrSymbols The character symbols to find.
       * @returns {number} Returns the index of the first unmatched string symbol.
       */
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1,
        length = strSymbols.length;

        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
        return index;
      }

      _charsStartIndex = charsStartIndex;
      return _charsStartIndex;
    }

    /**
     * Converts an ASCII `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */

    var _asciiToArray;
    var hasRequired_asciiToArray;

    function require_asciiToArray() {
      if (hasRequired_asciiToArray) return _asciiToArray;
      hasRequired_asciiToArray = 1;
      function asciiToArray(string) {
        return string.split('');
      }

      _asciiToArray = asciiToArray;
      return _asciiToArray;
    }

    /** Used to compose unicode character classes. */

    var _hasUnicode;
    var hasRequired_hasUnicode;

    function require_hasUnicode() {
      if (hasRequired_hasUnicode) return _hasUnicode;
      hasRequired_hasUnicode = 1;
      var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsVarRange = '\\ufe0e\\ufe0f';

      /** Used to compose unicode capture groups. */
      var rsZWJ = '\\u200d';

      /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
      var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

      /**
       * Checks if `string` contains Unicode symbols.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {boolean} Returns `true` if a symbol is found, else `false`.
       */
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }

      _hasUnicode = hasUnicode;
      return _hasUnicode;
    }

    /** Used to compose unicode character classes. */

    var _unicodeToArray;
    var hasRequired_unicodeToArray;

    function require_unicodeToArray() {
      if (hasRequired_unicodeToArray) return _unicodeToArray;
      hasRequired_unicodeToArray = 1;
      var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsVarRange = '\\ufe0e\\ufe0f';

      /** Used to compose unicode capture groups. */
      var rsAstral = '[' + rsAstralRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsZWJ = '\\u200d';

      /** Used to compose unicode regexes. */
      var reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

      /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
      var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

      /**
       * Converts a Unicode `string` to an array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the converted array.
       */
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }

      _unicodeToArray = unicodeToArray;
      return _unicodeToArray;
    }

    var _stringToArray;
    var hasRequired_stringToArray;

    function require_stringToArray() {
      if (hasRequired_stringToArray) return _stringToArray;
      hasRequired_stringToArray = 1;
      var asciiToArray = require_asciiToArray(),
      hasUnicode = require_hasUnicode(),
      unicodeToArray = require_unicodeToArray();

      /**
       * Converts `string` to an array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the converted array.
       */
      function stringToArray(string) {
        return hasUnicode(string) ?
        unicodeToArray(string) :
        asciiToArray(string);
      }

      _stringToArray = stringToArray;
      return _stringToArray;
    }

    var toString_1;
    var hasRequiredToString;

    function requireToString() {
      if (hasRequiredToString) return toString_1;
      hasRequiredToString = 1;
      var baseToString = require_baseToString();

      /**
       * Converts `value` to a string. An empty string is returned for `null`
       * and `undefined` values. The sign of `-0` is preserved.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.toString(null);
       * // => ''
       *
       * _.toString(-0);
       * // => '-0'
       *
       * _.toString([1, 2, 3]);
       * // => '1,2,3'
       */
      function toString(value) {
        return value == null ? '' : baseToString(value);
      }

      toString_1 = toString;
      return toString_1;
    }

    var trim_1;
    var hasRequiredTrim;

    function requireTrim() {
      if (hasRequiredTrim) return trim_1;
      hasRequiredTrim = 1;
      var baseToString = require_baseToString(),
      baseTrim = require_baseTrim(),
      castSlice = require_castSlice(),
      charsEndIndex = require_charsEndIndex(),
      charsStartIndex = require_charsStartIndex(),
      stringToArray = require_stringToArray(),
      toString = requireToString();

      /**
       * Removes leading and trailing whitespace or specified characters from `string`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to trim.
       * @param {string} [chars=whitespace] The characters to trim.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the trimmed string.
       * @example
       *
       * _.trim('  abc  ');
       * // => 'abc'
       *
       * _.trim('-_-abc-_-', '_-');
       * // => 'abc'
       *
       * _.map(['  foo  ', '  bar  '], _.trim);
       * // => ['foo', 'bar']
       */
      function trim(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
        chrSymbols = stringToArray(chars),
        start = charsStartIndex(strSymbols, chrSymbols),
        end = charsEndIndex(strSymbols, chrSymbols) + 1;

        return castSlice(strSymbols, start, end).join('');
      }

      trim_1 = trim;
      return trim_1;
    }

    /**
       * cloudinary-core.js
       * Cloudinary's JavaScript library - Version 2.13.0
       * Copyright Cloudinary
       * see https://github.com/cloudinary/cloudinary_js
       *
       */

    (function (module, exports) {
      (function webpackUniversalModuleDefinition(root, factory) {
        module.exports = factory(requireAssign(), requireCloneDeep(), requireCompact(), requireDifference(), requireFunctions(), requireIdentity(), requireIncludes(), requireIsArray(), requireIsElement(), requireIsFunction(), requireIsPlainObject(), requireIsString(), requireMerge(), requireTrim());
      })(commonjsGlobal, function (__WEBPACK_EXTERNAL_MODULE_lodash_assign__, __WEBPACK_EXTERNAL_MODULE_lodash_cloneDeep__, __WEBPACK_EXTERNAL_MODULE_lodash_compact__, __WEBPACK_EXTERNAL_MODULE_lodash_difference__, __WEBPACK_EXTERNAL_MODULE_lodash_functions__, __WEBPACK_EXTERNAL_MODULE_lodash_identity__, __WEBPACK_EXTERNAL_MODULE_lodash_includes__, __WEBPACK_EXTERNAL_MODULE_lodash_isArray__, __WEBPACK_EXTERNAL_MODULE_lodash_isElement__, __WEBPACK_EXTERNAL_MODULE_lodash_isFunction__, __WEBPACK_EXTERNAL_MODULE_lodash_isPlainObject__, __WEBPACK_EXTERNAL_MODULE_lodash_isString__, __WEBPACK_EXTERNAL_MODULE_lodash_merge__, __WEBPACK_EXTERNAL_MODULE_lodash_trim__) {
        return (/******/function (modules) {// webpackBootstrap
            /******/ // The module cache
            /******/var installedModules = {};
            /******/
            /******/ // The require function
            /******/function __nested_webpack_require_1611584__(moduleId) {
              /******/
              /******/ // Check if module is in cache
              /******/if (installedModules[moduleId]) {
                /******/return installedModules[moduleId].exports;
                /******/}
              /******/ // Create a new module (and put it into the cache)
              /******/var module = installedModules[moduleId] = {
                /******/i: moduleId,
                /******/l: false,
                /******/exports: {}
                /******/ };
              /******/
              /******/ // Execute the module function
              /******/modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_1611584__);
              /******/
              /******/ // Flag the module as loaded
              /******/module.l = true;
              /******/
              /******/ // Return the exports of the module
              /******/return module.exports;
              /******/}
            /******/
            /******/
            /******/ // expose the modules object (__webpack_modules__)
            /******/__nested_webpack_require_1611584__.m = modules;
            /******/
            /******/ // expose the module cache
            /******/__nested_webpack_require_1611584__.c = installedModules;
            /******/
            /******/ // define getter function for harmony exports
            /******/__nested_webpack_require_1611584__.d = function (exports, name, getter) {
              /******/if (!__nested_webpack_require_1611584__.o(exports, name)) {
                /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
                /******/}
              /******/};
            /******/
            /******/ // define __esModule on exports
            /******/__nested_webpack_require_1611584__.r = function (exports) {
              /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
                /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
                /******/}
              /******/Object.defineProperty(exports, '__esModule', { value: true });
              /******/};
            /******/
            /******/ // create a fake namespace object
            /******/ // mode & 1: value is a module id, require it
            /******/ // mode & 2: merge all properties of value into the ns
            /******/ // mode & 4: return value when already ns object
            /******/ // mode & 8|1: behave like require
            /******/__nested_webpack_require_1611584__.t = function (value, mode) {
              /******/if (mode & 1) value = __nested_webpack_require_1611584__(value);
              /******/if (mode & 8) return value;
              /******/if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
              /******/var ns = Object.create(null);
              /******/__nested_webpack_require_1611584__.r(ns);
              /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
              /******/if (mode & 2 && typeof value != 'string') for (var key in value) __nested_webpack_require_1611584__.d(ns, key, function (key) {return value[key];}.bind(null, key));
              /******/return ns;
              /******/};
            /******/
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/__nested_webpack_require_1611584__.n = function (module) {
              /******/var getter = module && module.__esModule ?
              /******/function getDefault() {return module['default'];} :
              /******/function getModuleExports() {return module;};
              /******/__nested_webpack_require_1611584__.d(getter, 'a', getter);
              /******/return getter;
              /******/};
            /******/
            /******/ // Object.prototype.hasOwnProperty.call
            /******/__nested_webpack_require_1611584__.o = function (object, property) {return Object.prototype.hasOwnProperty.call(object, property);};
            /******/
            /******/ // __webpack_public_path__
            /******/__nested_webpack_require_1611584__.p = "";
            /******/
            /******/
            /******/ // Load entry module and return exports
            /******/return __nested_webpack_require_1611584__(__nested_webpack_require_1611584__.s = "./src/namespace/cloudinary-core.js");
            /******/}
          /************************************************************************/
          /******/({

            /***/"./src/namespace/cloudinary-core.js":
            /***/function (module, __webpack_exports__, __nested_webpack_require_1616082__) {
              // ESM COMPAT FLAG
              __nested_webpack_require_1616082__.r(__webpack_exports__);

              // EXPORTS
              __nested_webpack_require_1616082__.d(__webpack_exports__, "ClientHintsMetaTag", function () {return (/* reexport */clienthintsmetatag);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "Cloudinary", function () {return (/* reexport */cloudinary);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "Condition", function () {return (/* reexport */condition);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "Configuration", function () {return (/* reexport */src_configuration);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "crc32", function () {return (/* reexport */src_crc32);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "Expression", function () {return (/* reexport */expression);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "FetchLayer", function () {return (/* reexport */fetchlayer);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "HtmlTag", function () {return (/* reexport */htmltag);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "ImageTag", function () {return (/* reexport */imagetag);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "Layer", function () {return (/* reexport */layer_layer);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "PictureTag", function () {return (/* reexport */picturetag);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "SubtitlesLayer", function () {return (/* reexport */subtitleslayer);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "TextLayer", function () {return (/* reexport */textlayer);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "Transformation", function () {return (/* reexport */src_transformation);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "utf8_encode", function () {return (/* reexport */src_utf8_encode);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "Util", function () {return (/* reexport */lodash_namespaceObject);});
              __nested_webpack_require_1616082__.d(__webpack_exports__, "VideoTag", function () {return (/* reexport */videotag);});

              // NAMESPACE OBJECT: ./src/constants.js
              var constants_namespaceObject = {};
              __nested_webpack_require_1616082__.r(constants_namespaceObject);
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "VERSION", function () {return VERSION;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "CF_SHARED_CDN", function () {return CF_SHARED_CDN;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "OLD_AKAMAI_SHARED_CDN", function () {return OLD_AKAMAI_SHARED_CDN;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "AKAMAI_SHARED_CDN", function () {return AKAMAI_SHARED_CDN;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "SHARED_CDN", function () {return SHARED_CDN;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "DEFAULT_TIMEOUT_MS", function () {return DEFAULT_TIMEOUT_MS;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "DEFAULT_POSTER_OPTIONS", function () {return DEFAULT_POSTER_OPTIONS;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "DEFAULT_VIDEO_SOURCE_TYPES", function () {return DEFAULT_VIDEO_SOURCE_TYPES;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "SEO_TYPES", function () {return SEO_TYPES;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "DEFAULT_IMAGE_PARAMS", function () {return DEFAULT_IMAGE_PARAMS;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "DEFAULT_VIDEO_PARAMS", function () {return DEFAULT_VIDEO_PARAMS;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "DEFAULT_VIDEO_SOURCES", function () {return DEFAULT_VIDEO_SOURCES;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "DEFAULT_EXTERNAL_LIBRARIES", function () {return DEFAULT_EXTERNAL_LIBRARIES;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "PLACEHOLDER_IMAGE_MODES", function () {return PLACEHOLDER_IMAGE_MODES;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "ACCESSIBILITY_MODES", function () {return ACCESSIBILITY_MODES;});
              __nested_webpack_require_1616082__.d(constants_namespaceObject, "URL_KEYS", function () {return URL_KEYS;});

              // NAMESPACE OBJECT: ./src/util/lodash.js
              var lodash_namespaceObject = {};
              __nested_webpack_require_1616082__.r(lodash_namespaceObject);
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "getSDKAnalyticsSignature", function () {return getSDKAnalyticsSignature;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "getAnalyticsOptions", function () {return getAnalyticsOptions;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "assign", function () {return assign_root_assign_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "cloneDeep", function () {return cloneDeep_root_cloneDeep_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "compact", function () {return compact_root_compact_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "difference", function () {return difference_root_difference_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "functions", function () {return functions_root_functions_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "identity", function () {return identity_root_identity_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "includes", function () {return includes_root_includes_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isArray", function () {return isArray_root_isArray_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isPlainObject", function () {return isPlainObject_root_isPlainObject_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isString", function () {return isString_root_isString_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "merge", function () {return merge_root_merge_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "contains", function () {return includes_root_includes_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isIntersectionObserverSupported", function () {return isIntersectionObserverSupported;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isNativeLazyLoadSupported", function () {return isNativeLazyLoadSupported;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "detectIntersection", function () {return detectIntersection;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "omit", function () {return omit;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "allStrings", function () {return baseutil_allStrings;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "without", function () {return without;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isNumberLike", function () {return isNumberLike;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "smartEscape", function () {return smartEscape;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "defaults", function () {return defaults;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "objectProto", function () {return objectProto;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "objToString", function () {return objToString;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isObject", function () {return isObject;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "funcTag", function () {return funcTag;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "reWords", function () {return reWords;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "camelCase", function () {return camelCase;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "snakeCase", function () {return snakeCase;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "convertKeys", function () {return convertKeys;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "withCamelCaseKeys", function () {return withCamelCaseKeys;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "withSnakeCaseKeys", function () {return withSnakeCaseKeys;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "base64Encode", function () {return base64Encode;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "base64EncodeURL", function () {return base64EncodeURL;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "extractUrlParams", function () {return extractUrlParams;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "patchFetchFormat", function () {return patchFetchFormat;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "optionConsume", function () {return optionConsume;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isEmpty", function () {return isEmpty;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isAndroid", function () {return isAndroid;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isEdge", function () {return isEdge;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isChrome", function () {return isChrome;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isSafari", function () {return isSafari;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isElement", function () {return isElement_root_isElement_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "isFunction", function () {return isFunction_root_isFunction_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "trim", function () {return trim_root_trim_default.a;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "getData", function () {return lodash_getData;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "setData", function () {return lodash_setData;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "getAttribute", function () {return lodash_getAttribute;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "setAttribute", function () {return lodash_setAttribute;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "removeAttribute", function () {return lodash_removeAttribute;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "setAttributes", function () {return setAttributes;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "hasClass", function () {return lodash_hasClass;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "addClass", function () {return lodash_addClass;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "getStyles", function () {return getStyles;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "cssExpand", function () {return cssExpand;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "domStyle", function () {return domStyle;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "curCSS", function () {return curCSS;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "cssValue", function () {return cssValue;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "augmentWidthOrHeight", function () {return augmentWidthOrHeight;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "getWidthOrHeight", function () {return getWidthOrHeight;});
              __nested_webpack_require_1616082__.d(lodash_namespaceObject, "width", function () {return lodash_width;});
              /* harmony default export */var src_utf8_encode = function utf8_encode(argString) {
                var c1, enc, end, n, start, string, stringl, utftext; // http://kevin.vanzonneveld.net
                // +   original by: Webtoolkit.info (http://www.webtoolkit.info/)
                // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
                // +   improved by: sowberry
                // +    tweaked by: Jack
                // +   bugfixed by: Onno Marsman
                // +   improved by: Yves Sucaet
                // +   bugfixed by: Onno Marsman
                // +   bugfixed by: Ulrich
                // +   bugfixed by: Rafal Kukawski
                // +   improved by: kirilloid
                // *     example 1: utf8_encode('Kevin van Zonneveld');
                // *     returns 1: 'Kevin van Zonneveld'

                if (argString === null || typeof argString === 'undefined') {
                  return '';
                }

                string = argString + ''; // .replace(/\r\n/g, "\n").replace(/\r/g, "\n");

                utftext = '';
                start = void 0;
                end = void 0;
                stringl = 0;
                start = end = 0;
                stringl = string.length;
                n = 0;

                while (n < stringl) {
                  c1 = string.charCodeAt(n);
                  enc = null;

                  if (c1 < 128) {
                    end++;
                  } else if (c1 > 127 && c1 < 2048) {
                    enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
                  } else {
                    enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
                  }

                  if (enc !== null) {
                    if (end > start) {
                      utftext += string.slice(start, end);
                    }

                    utftext += enc;
                    start = end = n + 1;
                  }

                  n++;
                }

                if (end > start) {
                  utftext += string.slice(start, stringl);
                }

                return utftext;
              };
              // CONCATENATED MODULE: ./src/crc32.js

              /**
               * CRC32 calculator
               * Depends on 'utf8_encode'
               * @private
               * @param {string} str - The string to calculate the CRC32 for.
               * @return {number}
               */

              function crc32(str) {
                var crc, i, iTop, table, x, y; // http://kevin.vanzonneveld.net
                // +   original by: Webtoolkit.info (http://www.webtoolkit.info/)
                // +   improved by: T0bsn
                // +   improved by: http://stackoverflow.com/questions/2647935/javascript-crc32-function-and-php-crc32-not-matching
                // -    depends on: utf8_encode
                // *     example 1: crc32('Kevin van Zonneveld');
                // *     returns 1: 1249991249

                str = src_utf8_encode(str);
                table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
                crc = 0;
                x = 0;
                y = 0;
                crc = crc ^ -1;
                i = 0;
                iTop = str.length;

                while (i < iTop) {
                  y = (crc ^ str.charCodeAt(i)) & 0xFF;
                  x = '0x' + table.substr(y * 9, 8);
                  crc = crc >>> 8 ^ x;
                  i++;
                }

                crc = crc ^ -1; //convert to unsigned 32-bit int if needed

                if (crc < 0) {
                  crc += 4294967296;
                }

                return crc;
              }

              /* harmony default export */var src_crc32 = crc32;
              // CONCATENATED MODULE: ./src/sdkAnalytics/stringPad.js
              function stringPad(value, targetLength, padString) {
                targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;

                padString = String(typeof padString !== 'undefined' ? padString : ' ');

                if (value.length > targetLength) {
                  return String(value);
                } else {
                  targetLength = targetLength - value.length;

                  if (targetLength > padString.length) {
                    padString += repeatStringNumTimes(padString, targetLength / padString.length);
                  }

                  return padString.slice(0, targetLength) + String(value);
                }
              }

              function repeatStringNumTimes(string, times) {
                var repeatedString = "";

                while (times > 0) {
                  repeatedString += string;
                  times--;
                }

                return repeatedString;
              }
              // CONCATENATED MODULE: ./src/sdkAnalytics/base64Map.js
              function _toConsumableArray(arr) {return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();}

              function _nonIterableSpread() {throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

              function _unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);}

              function _iterableToArray(iter) {if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);}

              function _arrayWithoutHoles(arr) {if (Array.isArray(arr)) return _arrayLikeToArray(arr);}

              function _arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}


              var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
              var base64Map_num = 0;
              var map = {};

              _toConsumableArray(chars).forEach(function (_char) {
                var key = base64Map_num.toString(2);
                key = stringPad(key, 6, '0');
                map[key] = _char;
                base64Map_num++;
              });
              /**
               * Map of six-bit binary codes to Base64 characters
               */


              /* harmony default export */var base64Map = map;
              // CONCATENATED MODULE: ./src/sdkAnalytics/reverseVersion.js

              /**
               * @description A semVer like string, x.y.z or x.y is allowed
               *              Reverses the version positions, x.y.z turns to z.y.x
               *              Pads each segment with '0' so they have length of 2
               *              Example: 1.2.3 -> 03.02.01
               * @param {string} semVer Input can be either x.y.z or x.y
               * @return {string} in the form of zz.yy.xx (
               */

              function reverseVersion(semVer) {
                if (semVer.split('.').length < 2) {
                  throw new Error('invalid semVer, must have at least two segments');
                } // Split by '.', reverse, create new array with padded values and concat it together


                return semVer.split('.').reverse().map(function (segment) {
                  return stringPad(segment, 2, '0');
                }).join('.');
              }
              // CONCATENATED MODULE: ./src/sdkAnalytics/encodeVersion.js



              /**
               * @description Encodes a semVer-like version string
               * @param {string} semVer Input can be either x.y.z or x.y
               * @return {string} A string built from 3 characters of the base64 table that encode the semVer
               */

              function encodeVersion(semVer) {
                var strResult = ''; // support x.y or x.y.z by using 'parts' as a variable

                var parts = semVer.split('.').length;
                var paddedStringLength = parts * 6; // we pad to either 12 or 18 characters
                // reverse (but don't mirror) the version. 1.5.15 -> 15.5.1
                // Pad to two spaces, 15.5.1 -> 15.05.01

                var paddedReversedSemver = reverseVersion(semVer); // turn 15.05.01 to a string '150501' then to a number 150501

                var num = parseInt(paddedReversedSemver.split('.').join('')); // Represent as binary, add left padding to 12 or 18 characters.
                // 150,501 -> 100100101111100101

                var paddedBinary = num.toString(2);
                paddedBinary = stringPad(paddedBinary, paddedStringLength, '0'); // Stop in case an invalid version number was provided
                // paddedBinary must be built from sections of 6 bits

                if (paddedBinary.length % 6 !== 0) {
                  throw 'Version must be smaller than 43.21.26)';
                } // turn every 6 bits into a character using the base64Map


                paddedBinary.match(/.{1,6}/g).forEach(function (bitString) {
                  // console.log(bitString);
                  strResult += base64Map[bitString];
                });
                return strResult;
              }
              // CONCATENATED MODULE: ./src/sdkAnalytics/getSDKAnalyticsSignature.js

              /**
               * @description Gets the SDK signature by encoding the SDK version and tech version
               * @param {{
               *    [techVersion]:string,
               *    [sdkSemver]: string,
               *    [sdkCode]: string,
               *    [feature]: string
               * }} analyticsOptions
               * @return {string} sdkAnalyticsSignature
               */

              function getSDKAnalyticsSignature() {
                var analyticsOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                try {
                  var twoPartVersion = removePatchFromSemver(analyticsOptions.techVersion);
                  var encodedSDKVersion = encodeVersion(analyticsOptions.sdkSemver);
                  var encodedTechVersion = encodeVersion(twoPartVersion);
                  var featureCode = analyticsOptions.feature;
                  var SDKCode = analyticsOptions.sdkCode;
                  var algoVersion = 'A'; // The algo version is determined here, it should not be an argument

                  return "".concat(algoVersion).concat(SDKCode).concat(encodedSDKVersion).concat(encodedTechVersion).concat(featureCode);
                } catch (e) {
                  // Either SDK or Node versions were unparsable
                  return 'E';
                }
              }
              /**
               * @description Removes patch version from the semver if it exists
               *              Turns x.y.z OR x.y into x.y
               * @param {'x.y.z' || 'x.y' || string} semVerStr
               */

              function removePatchFromSemver(semVerStr) {
                var parts = semVerStr.split('.');
                return "".concat(parts[0], ".").concat(parts[1]);
              }
              // CONCATENATED MODULE: ./src/sdkAnalytics/getAnalyticsOptions.js
              /**
               * @description Gets the analyticsOptions from options- should include sdkSemver, techVersion, sdkCode, and feature
               * @param options
               * @returns {{sdkSemver: (string), sdkCode, feature: string, techVersion: (string)} || {}}
               */
              function getAnalyticsOptions(options) {
                var analyticsOptions = {
                  sdkSemver: options.sdkSemver,
                  techVersion: options.techVersion,
                  sdkCode: options.sdkCode,
                  feature: '0' };


                if (options.urlAnalytics) {
                  if (options.accessibility) {
                    analyticsOptions.feature = 'D';
                  }

                  if (options.loading === 'lazy') {
                    analyticsOptions.feature = 'C';
                  }

                  if (options.responsive) {
                    analyticsOptions.feature = 'A';
                  }

                  if (options.placeholder) {
                    analyticsOptions.feature = 'B';
                  }

                  return analyticsOptions;
                } else {
                  return {};
                }
              }
              // EXTERNAL MODULE: external {"commonjs":"lodash/assign","commonjs2":"lodash/assign","amd":"lodash/assign","root":["_","assign"]}
              var assign_root_assign_ = __nested_webpack_require_1616082__("lodash/assign");
              var assign_root_assign_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(assign_root_assign_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/cloneDeep","commonjs2":"lodash/cloneDeep","amd":"lodash/cloneDeep","root":["_","cloneDeep"]}
              var cloneDeep_root_cloneDeep_ = __nested_webpack_require_1616082__("lodash/cloneDeep");
              var cloneDeep_root_cloneDeep_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(cloneDeep_root_cloneDeep_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/compact","commonjs2":"lodash/compact","amd":"lodash/compact","root":["_","compact"]}
              var compact_root_compact_ = __nested_webpack_require_1616082__("lodash/compact");
              var compact_root_compact_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(compact_root_compact_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/difference","commonjs2":"lodash/difference","amd":"lodash/difference","root":["_","difference"]}
              var difference_root_difference_ = __nested_webpack_require_1616082__("lodash/difference");
              var difference_root_difference_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(difference_root_difference_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/functions","commonjs2":"lodash/functions","amd":"lodash/functions","root":["_","functions"]}
              var functions_root_functions_ = __nested_webpack_require_1616082__("lodash/functions");
              var functions_root_functions_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(functions_root_functions_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/identity","commonjs2":"lodash/identity","amd":"lodash/identity","root":["_","identity"]}
              var identity_root_identity_ = __nested_webpack_require_1616082__("lodash/identity");
              var identity_root_identity_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(identity_root_identity_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/includes","commonjs2":"lodash/includes","amd":"lodash/includes","root":["_","includes"]}
              var includes_root_includes_ = __nested_webpack_require_1616082__("lodash/includes");
              var includes_root_includes_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(includes_root_includes_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/isArray","commonjs2":"lodash/isArray","amd":"lodash/isArray","root":["_","isArray"]}
              var isArray_root_isArray_ = __nested_webpack_require_1616082__("lodash/isArray");
              var isArray_root_isArray_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(isArray_root_isArray_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/isPlainObject","commonjs2":"lodash/isPlainObject","amd":"lodash/isPlainObject","root":["_","isPlainObject"]}
              var isPlainObject_root_isPlainObject_ = __nested_webpack_require_1616082__("lodash/isPlainObject");
              var isPlainObject_root_isPlainObject_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(isPlainObject_root_isPlainObject_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/isString","commonjs2":"lodash/isString","amd":"lodash/isString","root":["_","isString"]}
              var isString_root_isString_ = __nested_webpack_require_1616082__("lodash/isString");
              var isString_root_isString_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(isString_root_isString_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/merge","commonjs2":"lodash/merge","amd":"lodash/merge","root":["_","merge"]}
              var merge_root_merge_ = __nested_webpack_require_1616082__("lodash/merge");
              var merge_root_merge_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(merge_root_merge_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/isElement","commonjs2":"lodash/isElement","amd":"lodash/isElement","root":["_","isElement"]}
              var isElement_root_isElement_ = __nested_webpack_require_1616082__("lodash/isElement");
              var isElement_root_isElement_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(isElement_root_isElement_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/isFunction","commonjs2":"lodash/isFunction","amd":"lodash/isFunction","root":["_","isFunction"]}
              var isFunction_root_isFunction_ = __nested_webpack_require_1616082__("lodash/isFunction");
              var isFunction_root_isFunction_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(isFunction_root_isFunction_);

              // EXTERNAL MODULE: external {"commonjs":"lodash/trim","commonjs2":"lodash/trim","amd":"lodash/trim","root":["_","trim"]}
              var trim_root_trim_ = __nested_webpack_require_1616082__("lodash/trim");
              var trim_root_trim_default = /*#__PURE__*/__nested_webpack_require_1616082__.n(trim_root_trim_);

              // CONCATENATED MODULE: ./src/util/lazyLoad.js
              function _typeof(obj) {"@babel/helpers - typeof";return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof(obj);}

              /*
               * Includes utility methods for lazy loading media
               */

              /**
               * Check if IntersectionObserver is supported
               * @return {boolean} true if window.IntersectionObserver is defined
               */
              function isIntersectionObserverSupported() {
                // Check that 'IntersectionObserver' property is defined on window
                return (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && window.IntersectionObserver;
              }
              /**
               * Check if native lazy loading is supported
               * @return {boolean} true if 'loading' property is defined for HTMLImageElement
               */

              function isNativeLazyLoadSupported() {
                return (typeof HTMLImageElement === "undefined" ? "undefined" : _typeof(HTMLImageElement)) === "object" && HTMLImageElement.prototype.loading;
              }
              /**
               * Calls onIntersect() when intersection is detected, or when
               * no native lazy loading or when IntersectionObserver isn't supported.
               * @param {Element} el - the element to observe
               * @param {function} onIntersect - called when the given element is in view
               */

              function detectIntersection(el, onIntersect) {
                try {
                  if (isNativeLazyLoadSupported() || !isIntersectionObserverSupported()) {
                    // Return if there's no need or possibility to detect intersection
                    onIntersect();
                    return;
                  } // Detect intersection with given element using IntersectionObserver


                  var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                      if (entry.isIntersecting) {
                        onIntersect();
                        observer.unobserve(entry.target);
                      }
                    });
                  }, {
                    threshold: [0, 0.01] });

                  observer.observe(el);
                } catch (e) {
                  onIntersect();
                }
              }
              // CONCATENATED MODULE: ./src/constants.js
              var VERSION = "2.5.0";
              var CF_SHARED_CDN = "d3jpl91pxevbkh.cloudfront.net";
              var OLD_AKAMAI_SHARED_CDN = "cloudinary-a.akamaihd.net";
              var AKAMAI_SHARED_CDN = "res.cloudinary.com";
              var SHARED_CDN = AKAMAI_SHARED_CDN;
              var DEFAULT_TIMEOUT_MS = 10000;
              var DEFAULT_POSTER_OPTIONS = {
                format: 'jpg',
                resource_type: 'video' };

              var DEFAULT_VIDEO_SOURCE_TYPES = ['webm', 'mp4', 'ogv'];
              var SEO_TYPES = {
                "image/upload": "images",
                "image/private": "private_images",
                "image/authenticated": "authenticated_images",
                "raw/upload": "files",
                "video/upload": "videos" };

              /**
              * @const {Object} Cloudinary.DEFAULT_IMAGE_PARAMS
              * Defaults values for image parameters.
              *
              * (Previously defined using option_consume() )
               */

              var DEFAULT_IMAGE_PARAMS = {
                resource_type: "image",
                transformation: [],
                type: 'upload' };

              /**
              * Defaults values for video parameters.
              * @const {Object} Cloudinary.DEFAULT_VIDEO_PARAMS
              * (Previously defined using option_consume() )
               */

              var DEFAULT_VIDEO_PARAMS = {
                fallback_content: '',
                resource_type: "video",
                source_transformation: {},
                source_types: DEFAULT_VIDEO_SOURCE_TYPES,
                transformation: [],
                type: 'upload' };

              /**
               * Recommended sources for video tag
               * @const {Object} Cloudinary.DEFAULT_VIDEO_SOURCES
               */

              var DEFAULT_VIDEO_SOURCES = [{
                type: "mp4",
                codecs: "hev1",
                transformations: {
                  video_codec: "h265" } },

              {
                type: "webm",
                codecs: "vp9",
                transformations: {
                  video_codec: "vp9" } },

              {
                type: "mp4",
                transformations: {
                  video_codec: "auto" } },

              {
                type: "webm",
                transformations: {
                  video_codec: "auto" } }];


              var DEFAULT_EXTERNAL_LIBRARIES = {
                seeThru: 'https://unpkg.com/seethru@4/dist/seeThru.min.js' };

              /**
               * Predefined placeholder transformations
               * @const {Object} Cloudinary.PLACEHOLDER_IMAGE_MODES
               */

              var PLACEHOLDER_IMAGE_MODES = {
                'blur': [{
                  effect: 'blur:2000',
                  quality: 1,
                  fetch_format: 'auto' }],

                // Default
                'pixelate': [{
                  effect: 'pixelate',
                  quality: 1,
                  fetch_format: 'auto' }],

                // Generates a pixel size image which color is the predominant color of the original image.
                'predominant-color-pixel': [{
                  width: 'iw_div_2',
                  aspect_ratio: 1,
                  crop: 'pad',
                  background: 'auto' },
                {
                  crop: 'crop',
                  width: 1,
                  height: 1,
                  gravity: 'north_east' },
                {
                  fetch_format: 'auto',
                  quality: 'auto' }],

                // Generates an image which color is the predominant color of the original image.
                'predominant-color': [{
                  variables: [['$currWidth', 'w'], ['$currHeight', 'h']] },
                {
                  width: 'iw_div_2',
                  aspect_ratio: 1,
                  crop: 'pad',
                  background: 'auto' },
                {
                  crop: 'crop',
                  width: 10,
                  height: 10,
                  gravity: 'north_east' },
                {
                  width: '$currWidth',
                  height: '$currHeight',
                  crop: 'fill' },
                {
                  fetch_format: 'auto',
                  quality: 'auto' }],

                'vectorize': [{
                  effect: 'vectorize:3:0.1',
                  fetch_format: 'svg' }] };


              /**
               * Predefined accessibility transformations
               * @const {Object} Cloudinary.ACCESSIBILITY_MODES
               */

              var ACCESSIBILITY_MODES = {
                darkmode: 'tint:75:black',
                brightmode: 'tint:50:white',
                monochrome: 'grayscale',
                colorblind: 'assist_colorblind' };

              /**
               * A list of keys used by the url() function.
               * @private
               */

              var URL_KEYS = ['accessibility', 'api_secret', 'auth_token', 'cdn_subdomain', 'cloud_name', 'cname', 'format', 'placeholder', 'private_cdn', 'resource_type', 'secure', 'secure_cdn_subdomain', 'secure_distribution', 'shorten', 'sign_url', 'signature', 'ssl_detected', 'type', 'url_suffix', 'use_root_path', 'version'];
              /**
               * The resource storage type
               * @typedef type
               * @enum {string}
               * @property  {string} 'upload' A resource uploaded directly to Cloudinary
               * @property  {string} 'fetch' A resource fetched by Cloudinary from a 3rd party storage
               * @property  {string} 'private'
               * @property  {string} 'authenticated'
               * @property  {string} 'sprite'
               * @property  {string} 'facebook'
               * @property  {string} 'twitter'
               * @property  {string} 'youtube'
               * @property  {string} 'vimeo'
               *
               */

              /**
               * The resource type
               * @typedef resourceType
               * @enum {string}
               * @property {string} 'image' An image file
               * @property {string} 'video' A video file
               * @property {string} 'raw'   A raw file
               */
              // CONCATENATED MODULE: ./src/util/baseutil.js
              function baseutil_typeof(obj) {"@babel/helpers - typeof";return baseutil_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, baseutil_typeof(obj);}

              /*
               * Includes common utility methods and shims
               */


              function omit(obj, keys) {
                obj = obj || {};
                var srcKeys = Object.keys(obj).filter(function (key) {
                  return !includes_root_includes_default()(keys, key);
                });
                var filtered = {};
                srcKeys.forEach(function (key) {
                  return filtered[key] = obj[key];
                });
                return filtered;
              }
              /**
               * Return true if all items in list are strings
               * @function Util.allString
               * @param {Array} list - an array of items
               */

              var baseutil_allStrings = function allStrings(list) {
                return list.length && list.every(isString_root_isString_default.a);
              };
              /**
              * Creates a new array without the given item.
              * @function Util.without
              * @param {Array} array - original array
              * @param {*} item - the item to exclude from the new array
              * @return {Array} a new array made of the original array's items except for `item`
               */

              var without = function without(array, item) {
                return array.filter(function (v) {
                  return v !== item;
                });
              };
              /**
              * Return true is value is a number or a string representation of a number.
              * @function Util.isNumberLike
              * @param {*} value
              * @returns {boolean} true if value is a number
              * @example
              *    Util.isNumber(0) // true
              *    Util.isNumber("1.3") // true
              *    Util.isNumber("") // false
              *    Util.isNumber(undefined) // false
               */

              var isNumberLike = function isNumberLike(value) {
                return value != null && !isNaN(parseFloat(value));
              };
              /**
               * Escape all characters matching unsafe in the given string
               * @function Util.smartEscape
               * @param {string} string - source string to escape
               * @param {RegExp} unsafe - characters that must be escaped
               * @return {string} escaped string
               */

              var smartEscape = function smartEscape(string) {
                var unsafe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /([^a-zA-Z0-9_.\-\/:]+)/g;
                return string.replace(unsafe, function (match) {
                  return match.split("").map(function (c) {
                    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
                  }).join("");
                });
              };
              /**
               * Assign values from sources if they are not defined in the destination.
               * Once a value is set it does not change
               * @function Util.defaults
               * @param {Object} destination - the object to assign defaults to
               * @param {...Object} source - the source object(s) to assign defaults from
               * @return {Object} destination after it was modified
               */

              var defaults = function defaults(destination) {
                for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  sources[_key - 1] = arguments[_key];
                }

                return sources.reduce(function (dest, source) {
                  var key, value;

                  for (key in source) {
                    value = source[key];

                    if (dest[key] === void 0) {
                      dest[key] = value;
                    }
                  }

                  return dest;
                }, destination);
              };
              /*********** lodash functions */

              var objectProto = Object.prototype;
              /**
               * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
               * of values.
               */

              var objToString = objectProto.toString;
              /**
               * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
               * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
               *
               * @param {*} value The value to check.
               * @returns {boolean} Returns `true` if `value` is an object, else `false`.
               * @example
               *
              #isObject({});
               * // => true
               *
              #isObject([1, 2, 3]);
               * // => true
               *
              #isObject(1);
               * // => false
               */

              var isObject = function isObject(value) {
                var type; // Avoid a V8 JIT bug in Chrome 19-20.
                // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.

                type = baseutil_typeof(value);
                return !!value && (type === 'object' || type === 'function');
              };
              var funcTag = '[object Function]';
              /**
              * Checks if `value` is classified as a `Function` object.
              * @function Util.isFunction
              * @param {*} value The value to check.
              * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
              * @example
              *
              * function Foo(){};
              * isFunction(Foo);
              * // => true
              *
              * isFunction(/abc/);
              * // => false
               */

              var isFunction = function isFunction(value) {
                // The use of `Object#toString` avoids issues with the `typeof` operator
                // in older versions of Chrome and Safari which return 'function' for regexes
                // and Safari 8 which returns 'object' for typed array constructors.
                return isObject(value) && objToString.call(value) === funcTag;
              };
              /*********** lodash functions */

              /** Used to match words to create compound words. */

              var reWords = function () {
                var lower, upper;
                upper = '[A-Z]';
                lower = '[a-z]+';
                return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
              }();
              /**
              * Convert string to camelCase
              * @function Util.camelCase
              * @param {string} source - the string to convert
              * @return {string} in camelCase format
               */

              var camelCase = function camelCase(source) {
                var words = source.match(reWords);
                words = words.map(function (word) {
                  return word.charAt(0).toLocaleUpperCase() + word.slice(1).toLocaleLowerCase();
                });
                words[0] = words[0].toLocaleLowerCase();
                return words.join('');
              };
              /**
               * Convert string to snake_case
               * @function Util.snakeCase
               * @param {string} source - the string to convert
               * @return {string} in snake_case format
               */

              var snakeCase = function snakeCase(source) {
                var words = source.match(reWords);
                words = words.map(function (word) {
                  return word.toLocaleLowerCase();
                });
                return words.join('_');
              };
              /**
               * Creates a new object from source, with the keys transformed using the converter.
               * @param {object} source
               * @param {function|null} converter
               * @returns {object}
               */

              var convertKeys = function convertKeys(source, converter) {
                var result, value;
                result = {};

                for (var key in source) {
                  value = source[key];

                  if (converter) {
                    key = converter(key);
                  }

                  if (!isEmpty(key)) {
                    result[key] = value;
                  }
                }

                return result;
              };
              /**
               * Create a copy of the source object with all keys in camelCase
               * @function Util.withCamelCaseKeys
               * @param {Object} value - the object to copy
               * @return {Object} a new object
               */

              var withCamelCaseKeys = function withCamelCaseKeys(source) {
                return convertKeys(source, camelCase);
              };
              /**
               * Create a copy of the source object with all keys in snake_case
               * @function Util.withSnakeCaseKeys
               * @param {Object} value - the object to copy
               * @return {Object} a new object
               */

              var withSnakeCaseKeys = function withSnakeCaseKeys(source) {
                return convertKeys(source, snakeCase);
              }; // Browser
              // Node.js

              var base64Encode = typeof btoa !== 'undefined' && isFunction(btoa) ? btoa : typeof Buffer !== 'undefined' && isFunction(Buffer) ? function (input) {
                if (!(input instanceof Buffer)) {
                  input = new Buffer.from(String(input), 'binary');
                }

                return input.toString('base64');
              } : function (input) {
                throw new Error("No base64 encoding function found");
              };
              /**
              * Returns the Base64-decoded version of url.<br>
              * This method delegates to `btoa` if present. Otherwise it tries `Buffer`.
              * @function Util.base64EncodeURL
              * @param {string} url - the url to encode. the value is URIdecoded and then re-encoded before converting to base64 representation
              * @return {string} the base64 representation of the URL
               */

              var base64EncodeURL = function base64EncodeURL(url) {
                try {
                  url = decodeURI(url);
                } finally {
                  url = encodeURI(url);
                }

                return base64Encode(url);
              };
              /**
               * Create a new object with only URL parameters
               * @param {object} options The source object
               * @return {Object} An object containing only URL parameters
               */

              function extractUrlParams(options) {
                return URL_KEYS.reduce(function (obj, key) {
                  if (options[key] != null) {
                    obj[key] = options[key];
                  }

                  return obj;
                }, {});
              }
              /**
               * Handle the format parameter for fetch urls
               * @private
               * @param options url and transformation options. This argument may be changed by the function!
               */

              function patchFetchFormat(options) {
                if (options == null) {
                  options = {};
                }

                if (options.type === "fetch") {
                  if (options.fetch_format == null) {
                    options.fetch_format = optionConsume(options, "format");
                  }
                }
              }
              /**
               * Deletes `option_name` from `options` and return the value if present.
               * If `options` doesn't contain `option_name` the default value is returned.
               * @param {Object} options a collection
               * @param {String} option_name the name (key) of the desired value
               * @param {*} [default_value] the value to return is option_name is missing
               */

              function optionConsume(options, option_name, default_value) {
                var result = options[option_name];
                delete options[option_name];

                if (result != null) {
                  return result;
                } else {
                  return default_value;
                }
              }
              /**
               * Returns true if value is empty:
               * <ul>
               *   <li>value is null or undefined</li>
               *   <li>value is an array or string of length 0</li>
               *   <li>value is an object with no keys</li>
               * </ul>
               * @function Util.isEmpty
               * @param value
               * @returns {boolean} true if value is empty
               */

              function isEmpty(value) {
                if (value == null) {
                  return true;
                }

                if (typeof value.length == "number") {
                  return value.length === 0;
                }

                if (typeof value.size == "number") {
                  return value.size === 0;
                }

                if (baseutil_typeof(value) == "object") {
                  for (var key in value) {
                    if (value.hasOwnProperty(key)) {
                      return false;
                    }
                  }

                  return true;
                }

                return true;
              }
              // CONCATENATED MODULE: ./src/util/browser.js
              /**
               * Based on video.js implementation:
               * https://github.com/videojs/video.js/blob/4238f5c1d88890547153e7e1de7bd0d1d8e0b236/src/js/utils/browser.js
               */

              /**
              * Retrieve from the navigator the user agent property.
              * @returns user agent property.
              */
              function getUserAgent() {
                return navigator && navigator.userAgent || '';
              }
              /**
               * Detect if current browser is any Android
               * @returns true if current browser is Android, false otherwise.
               */


              function isAndroid() {
                var userAgent = getUserAgent();
                return /Android/i.test(userAgent);
              }
              /**
               * Detect if current browser is any Edge
               * @returns true if current browser is Edge, false otherwise.
               */

              function isEdge() {
                var userAgent = getUserAgent();
                return /Edg/i.test(userAgent);
              }
              /**
               * Detect if current browser is chrome.
               * @returns true if current browser is Chrome, false otherwise.
               */

              function isChrome() {
                var userAgent = getUserAgent();
                return !isEdge() && (/Chrome/i.test(userAgent) || /CriOS/i.test(userAgent));
              }
              /**
               * Detect if current browser is Safari.
               * @returns true if current browser is Safari, false otherwise.
               */

              function isSafari() {
                // User agents for other browsers might include "Safari" so we must exclude them.
                // For example - this is the chrome user agent on windows 10:
                // Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/96.0.4664.110 Safari/537.36
                var userAgent = getUserAgent();
                return /Safari/i.test(userAgent) && !isChrome() && !isAndroid() && !isEdge();
              }
              // CONCATENATED MODULE: ./src/util/lodash.js
              var nodeContains;






















              /*
               * Includes utility methods and lodash / jQuery shims
               */

              /**
               * Get data from the DOM element.
               *
               * This method will use jQuery's `data()` method if it is available, otherwise it will get the `data-` attribute
               * @param {Element} element - the element to get the data from
               * @param {string} name - the name of the data item
               * @returns the value associated with the `name`
               * @function Util.getData
               */

              var lodash_getData = function getData(element, name) {
                switch (false) {
                  case !(element == null):
                    return void 0;

                  case !isFunction_root_isFunction_default()(element.getAttribute):
                    return element.getAttribute("data-".concat(name));

                  case !isFunction_root_isFunction_default()(element.getAttr):
                    return element.getAttr("data-".concat(name));

                  case !isFunction_root_isFunction_default()(element.data):
                    return element.data(name);

                  case !(isFunction_root_isFunction_default()(typeof jQuery !== "undefined" && jQuery.fn && jQuery.fn.data) && isElement_root_isElement_default()(element)):
                    return jQuery(element).data(name);}

              };
              /**
               * Set data in the DOM element.
               *
               * This method will use jQuery's `data()` method if it is available, otherwise it will set the `data-` attribute
               * @function Util.setData
               * @param {Element} element - the element to set the data in
               * @param {string} name - the name of the data item
               * @param {*} value - the value to be set
               *
               */

              var lodash_setData = function setData(element, name, value) {
                switch (false) {
                  case !(element == null):
                    return void 0;

                  case !isFunction_root_isFunction_default()(element.setAttribute):
                    return element.setAttribute("data-".concat(name), value);

                  case !isFunction_root_isFunction_default()(element.setAttr):
                    return element.setAttr("data-".concat(name), value);

                  case !isFunction_root_isFunction_default()(element.data):
                    return element.data(name, value);

                  case !(isFunction_root_isFunction_default()(typeof jQuery !== "undefined" && jQuery.fn && jQuery.fn.data) && isElement_root_isElement_default()(element)):
                    return jQuery(element).data(name, value);}

              };
              /**
               * Get attribute from the DOM element.
               *
               * @function Util.getAttribute
               * @param {Element} element - the element to set the attribute for
               * @param {string} name - the name of the attribute
               * @returns {*} the value of the attribute
               *
               */

              var lodash_getAttribute = function getAttribute(element, name) {
                switch (false) {
                  case !(element == null):
                    return void 0;

                  case !isFunction_root_isFunction_default()(element.getAttribute):
                    return element.getAttribute(name);

                  case !isFunction_root_isFunction_default()(element.attr):
                    return element.attr(name);

                  case !isFunction_root_isFunction_default()(element.getAttr):
                    return element.getAttr(name);}

              };
              /**
               * Set attribute in the DOM element.
               *
               * @function Util.setAttribute
               * @param {Element} element - the element to set the attribute for
               * @param {string} name - the name of the attribute
               * @param {*} value - the value to be set
               */

              var lodash_setAttribute = function setAttribute(element, name, value) {
                switch (false) {
                  case !(element == null):
                    return void 0;

                  case !isFunction_root_isFunction_default()(element.setAttribute):
                    return element.setAttribute(name, value);

                  case !isFunction_root_isFunction_default()(element.attr):
                    return element.attr(name, value);

                  case !isFunction_root_isFunction_default()(element.setAttr):
                    return element.setAttr(name, value);}

              };
              /**
               * Remove an attribute in the DOM element.
               *
               * @function Util.removeAttribute
               * @param {Element} element - the element to set the attribute for
               * @param {string} name - the name of the attribute
               */

              var lodash_removeAttribute = function removeAttribute(element, name) {
                switch (false) {
                  case !(element == null):
                    return void 0;

                  case !isFunction_root_isFunction_default()(element.removeAttribute):
                    return element.removeAttribute(name);

                  default:
                    return lodash_setAttribute(element, void 0);}

              };
              /**
               * Set a group of attributes to the element
               * @function Util.setAttributes
               * @param {Element} element - the element to set the attributes for
               * @param {Object} attributes - a hash of attribute names and values
               */

              var setAttributes = function setAttributes(element, attributes) {
                var name, results, value;
                results = [];

                for (name in attributes) {
                  value = attributes[name];

                  if (value != null) {
                    results.push(lodash_setAttribute(element, name, value));
                  } else {
                    results.push(lodash_removeAttribute(element, name));
                  }
                }

                return results;
              };
              /**
               * Checks if element has a css class
               * @function Util.hasClass
               * @param {Element} element - the element to check
               * @param {string} name - the class name
               @returns {boolean} true if the element has the class
               */

              var lodash_hasClass = function hasClass(element, name) {
                if (isElement_root_isElement_default()(element)) {
                  return element.className.match(new RegExp("\\b".concat(name, "\\b")));
                }
              };
              /**
               * Add class to the element
               * @function Util.addClass
               * @param {Element} element - the element
               * @param {string} name - the class name to add
               */

              var lodash_addClass = function addClass(element, name) {
                if (!element.className.match(new RegExp("\\b".concat(name, "\\b")))) {
                  return element.className = trim_root_trim_default()("".concat(element.className, " ").concat(name));
                }
              }; // The following code is taken from jQuery

              var getStyles = function getStyles(elem) {
                // Support: IE<=11+, Firefox<=30+ (#15098, #14150)
                // IE throws on elements created in popups
                // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
                if (elem.ownerDocument.defaultView.opener) {
                  return elem.ownerDocument.defaultView.getComputedStyle(elem, null);
                }

                return window.getComputedStyle(elem, null);
              };
              var cssExpand = ["Top", "Right", "Bottom", "Left"];

              nodeContains = function nodeContains(a, b) {
                var adown, bup;
                adown = a.nodeType === 9 ? a.documentElement : a;
                bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && adown.contains(bup));
              }; // Truncated version of jQuery.style(elem, name)


              var domStyle = function domStyle(elem, name) {
                if (!(!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style)) {
                  return elem.style[name];
                }
              };
              var curCSS = function curCSS(elem, name, computed) {
                var maxWidth, minWidth, ret, rmargin, style, width;
                rmargin = /^margin/;
                width = void 0;
                minWidth = void 0;
                maxWidth = void 0;
                ret = void 0;
                style = elem.style;
                computed = computed || getStyles(elem);

                if (computed) {
                  // Support: IE9
                  // getPropertyValue is only needed for .css('filter') (#12537)
                  ret = computed.getPropertyValue(name) || computed[name];
                }

                if (computed) {
                  if (ret === "" && !nodeContains(elem.ownerDocument, elem)) {
                    ret = domStyle(elem, name);
                  } // Support: iOS < 6
                  // A tribute to the "awesome hack by Dean Edwards"
                  // iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
                  // this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values


                  if (rnumnonpx.test(ret) && rmargin.test(name)) {
                    // Remember the original values
                    width = style.width;
                    minWidth = style.minWidth;
                    maxWidth = style.maxWidth; // Put in the new values to get a computed value out

                    style.minWidth = style.maxWidth = style.width = ret;
                    ret = computed.width; // Revert the changed values

                    style.width = width;
                    style.minWidth = minWidth;
                    style.maxWidth = maxWidth;
                  }
                } // Support: IE
                // IE returns zIndex value as an integer.


                if (ret !== undefined) {
                  return ret + "";
                } else {
                  return ret;
                }
              };
              var cssValue = function cssValue(elem, name, convert, styles) {
                var val;
                val = curCSS(elem, name, styles);

                if (convert) {
                  return parseFloat(val);
                } else {
                  return val;
                }
              };
              var augmentWidthOrHeight = function augmentWidthOrHeight(elem, name, extra, isBorderBox, styles) {
                var i, len, side, sides, val; // If we already have the right measurement, avoid augmentation
                // Otherwise initialize for horizontal or vertical properties

                if (extra === (isBorderBox ? "border" : "content")) {
                  return 0;
                } else {
                  sides = name === "width" ? ["Right", "Left"] : ["Top", "Bottom"];
                  val = 0;

                  for (i = 0, len = sides.length; i < len; i++) {
                    side = sides[i];

                    if (extra === "margin") {
                      // Both box models exclude margin, so add it if we want it
                      val += cssValue(elem, extra + side, true, styles);
                    }

                    if (isBorderBox) {
                      if (extra === "content") {
                        // border-box includes padding, so remove it if we want content
                        val -= cssValue(elem, "padding".concat(side), true, styles);
                      }

                      if (extra !== "margin") {
                        // At this point, extra isn't border nor margin, so remove border
                        val -= cssValue(elem, "border".concat(side, "Width"), true, styles);
                      }
                    } else {
                      // At this point, extra isn't content, so add padding
                      val += cssValue(elem, "padding".concat(side), true, styles);

                      if (extra !== "padding") {
                        // At this point, extra isn't content nor padding, so add border
                        val += cssValue(elem, "border".concat(side, "Width"), true, styles);
                      }
                    }
                  }

                  return val;
                }
              };
              var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
              var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
              var getWidthOrHeight = function getWidthOrHeight(elem, name, extra) {
                var isBorderBox, styles, val, valueIsBorderBox; // Start with offset property, which is equivalent to the border-box value

                valueIsBorderBox = true;
                val = name === "width" ? elem.offsetWidth : elem.offsetHeight;
                styles = getStyles(elem);
                isBorderBox = cssValue(elem, "boxSizing", false, styles) === "border-box"; // Some non-html elements return undefined for offsetWidth, so check for null/undefined
                // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
                // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668

                if (val <= 0 || val == null) {
                  // Fall back to computed then uncomputed css if necessary
                  val = curCSS(elem, name, styles);

                  if (val < 0 || val == null) {
                    val = elem.style[name];
                  }

                  if (rnumnonpx.test(val)) {
                    // Computed unit is not pixels. Stop here and return.
                    return val;
                  } // Check for style in case a browser which returns unreliable values
                  // for getComputedStyle silently falls back to the reliable elem.style
                  //    valueIsBorderBox = isBorderBox and (support.boxSizingReliable() or val is elem.style[name])


                  valueIsBorderBox = isBorderBox && val === elem.style[name]; // Normalize "", auto, and prepare for extra

                  val = parseFloat(val) || 0;
                } // Use the active box-sizing model to add/subtract irrelevant styles


                return val + augmentWidthOrHeight(elem, name, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles);
              };
              var lodash_width = function width(element) {
                return getWidthOrHeight(element, "width", "content");
              };
              /**
               * @class Util
               */

              /**
               * Returns true if item is a string
               * @function Util.isString
               * @param item
               * @returns {boolean} true if item is a string
               */

              /**
               * Returns true if item is empty:
               * <ul>
               *   <li>item is null or undefined</li>
               *   <li>item is an array or string of length 0</li>
               *   <li>item is an object with no keys</li>
               * </ul>
               * @function Util.isEmpty
               * @param item
               * @returns {boolean} true if item is empty
               */

              /**
               * Assign source properties to destination.
               * If the property is an object it is assigned as a whole, overriding the destination object.
               * @function Util.assign
               * @param {Object} destination - the object to assign to
               */

              /**
               * Recursively assign source properties to destination
               * @function Util.merge
               * @param {Object} destination - the object to assign to
               * @param {...Object} [sources] The source objects.
               */

              /**
               * Create a new copy of the given object, including all internal objects.
               * @function Util.cloneDeep
               * @param {Object} value - the object to clone
               * @return {Object} a new deep copy of the object
               */

              /**
               * Creates a new array from the parameter with "falsey" values removed
               * @function Util.compact
               * @param {Array} array - the array to remove values from
               * @return {Array} a new array without falsey values
               */

              /**
               * Check if a given item is included in the given array
               * @function Util.contains
               * @param {Array} array - the array to search in
               * @param {*} item - the item to search for
               * @return {boolean} true if the item is included in the array
               */

              /**
               * Returns values in the given array that are not included in the other array
               * @function Util.difference
               * @param {Array} arr - the array to select from
               * @param {Array} values - values to filter from arr
               * @return {Array} the filtered values
               */

              /**
               * Returns a list of all the function names in obj
               * @function Util.functions
               * @param {Object} object - the object to inspect
               * @return {Array} a list of functions of object
               */

              /**
               * Returns the provided value. This functions is used as a default predicate function.
               * @function Util.identity
               * @param {*} value
               * @return {*} the provided value
               */

              /**
               * Remove leading or trailing spaces from text
               * @function Util.trim
               * @param {string} text
               * @return {string} the `text` without leading or trailing spaces
               */
              // CONCATENATED MODULE: ./src/expression.js
              function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              /**
               * Represents a transformation expression.
               * @param {string} expressionStr - An expression in string format.
               * @class Expression
               * Normally this class is not instantiated directly
               */
              var Expression = /*#__PURE__*/function () {
                function Expression(expressionStr) {
                  _classCallCheck(this, Expression);

                  /**
                   * @protected
                   * @inner Expression-expressions
                   */
                  this.expressions = [];

                  if (expressionStr != null) {
                    this.expressions.push(Expression.normalize(expressionStr));
                  }
                }
                /**
                 * Convenience constructor method
                 * @function Expression.new
                 */


                _createClass(Expression, [{
                  key: "serialize",
                  value:
                  /**
                   * Serialize the expression
                   * @return {string} the expression as a string
                   */
                  function serialize() {
                    return Expression.normalize(this.expressions.join("_"));
                  } },
                {
                  key: "toString",
                  value: function toString() {
                    return this.serialize();
                  }
                  /**
                   * Get the parent transformation of this expression
                   * @return Transformation
                   */ },

                {
                  key: "getParent",
                  value: function getParent() {
                    return this.parent;
                  }
                  /**
                   * Set the parent transformation of this expression
                   * @param {Transformation} the parent transformation
                   * @return {Expression} this expression
                   */ },

                {
                  key: "setParent",
                  value: function setParent(parent) {
                    this.parent = parent;
                    return this;
                  }
                  /**
                   * Add a expression
                   * @function Expression#predicate
                   * @internal
                   */ },

                {
                  key: "predicate",
                  value: function predicate(name, operator, value) {
                    if (Expression.OPERATORS[operator] != null) {
                      operator = Expression.OPERATORS[operator];
                    }

                    this.expressions.push("".concat(name, "_").concat(operator, "_").concat(value));
                    return this;
                  }
                  /**
                   * @function Expression#and
                   */ },

                {
                  key: "and",
                  value: function and() {
                    this.expressions.push("and");
                    return this;
                  }
                  /**
                   * @function Expression#or
                   */ },

                {
                  key: "or",
                  value: function or() {
                    this.expressions.push("or");
                    return this;
                  }
                  /**
                   * Conclude expression
                   * @function Expression#then
                   * @return {Transformation} the transformation this expression is defined for
                   */ },

                {
                  key: "then",
                  value: function then() {
                    return this.getParent()["if"](this.toString());
                  }
                  /**
                   * @function Expression#height
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Expression} this expression
                   */ },

                {
                  key: "height",
                  value: function height(operator, value) {
                    return this.predicate("h", operator, value);
                  }
                  /**
                   * @function Expression#width
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Expression} this expression
                   */ },

                {
                  key: "width",
                  value: function width(operator, value) {
                    return this.predicate("w", operator, value);
                  }
                  /**
                   * @function Expression#aspectRatio
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Expression} this expression
                   */ },

                {
                  key: "aspectRatio",
                  value: function aspectRatio(operator, value) {
                    return this.predicate("ar", operator, value);
                  }
                  /**
                   * @function Expression#pages
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Expression} this expression
                   */ },

                {
                  key: "pageCount",
                  value: function pageCount(operator, value) {
                    return this.predicate("pc", operator, value);
                  }
                  /**
                   * @function Expression#faces
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Expression} this expression
                   */ },

                {
                  key: "faceCount",
                  value: function faceCount(operator, value) {
                    return this.predicate("fc", operator, value);
                  } },
                {
                  key: "value",
                  value: function value(_value) {
                    this.expressions.push(_value);
                    return this;
                  }
                  /**
                   */ }],

                [{
                  key: "new",
                  value: function _new(expressionStr) {
                    return new this(expressionStr);
                  }
                  /**
                   * Normalize a string expression
                   * @function Cloudinary#normalize
                   * @param {string} expression a expression, e.g. "w gt 100", "width_gt_100", "width > 100"
                   * @return {string} the normalized form of the value expression, e.g. "w_gt_100"
                   */ },

                {
                  key: "normalize",
                  value: function normalize(expression) {
                    if (expression == null) {
                      return expression;
                    }

                    expression = String(expression);
                    var operators = "\\|\\||>=|<=|&&|!=|>|=|<|/|-|\\+|\\*|\\^"; // operators

                    var operatorsPattern = "((" + operators + ")(?=[ _]))";
                    var operatorsReplaceRE = new RegExp(operatorsPattern, "g");
                    expression = expression.replace(operatorsReplaceRE, function (match) {
                      return Expression.OPERATORS[match];
                    }); // predefined variables
                    // The :${v} part is to prevent normalization of vars with a preceding colon (such as :duration),
                    // It won't be found in PREDEFINED_VARS and so won't be normalized.
                    // It is done like this because ie11 does not support regex lookbehind

                    var predefinedVarsPattern = "(" + Object.keys(Expression.PREDEFINED_VARS).map(function (v) {
                      return ":".concat(v, "|").concat(v);
                    }).join("|") + ")";
                    var userVariablePattern = '(\\$_*[^_ ]+)';
                    var variablesReplaceRE = new RegExp("".concat(userVariablePattern, "|").concat(predefinedVarsPattern), "g");
                    expression = expression.replace(variablesReplaceRE, function (match) {
                      return Expression.PREDEFINED_VARS[match] || match;
                    });
                    return expression.replace(/[ _]+/g, '_');
                  } },
                {
                  key: "variable",
                  value: function variable(name, value) {
                    return new this(name).value(value);
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "width"
                   * @function Expression.width
                   */ },

                {
                  key: "width",
                  value: function width() {
                    return new this("width");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "height"
                   * @function Expression.height
                   */ },

                {
                  key: "height",
                  value: function height() {
                    return new this("height");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "initialWidth"
                   * @function Expression.initialWidth
                   */ },

                {
                  key: "initialWidth",
                  value: function initialWidth() {
                    return new this("initialWidth");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "initialHeight"
                   * @function Expression.initialHeight
                   */ },

                {
                  key: "initialHeight",
                  value: function initialHeight() {
                    return new this("initialHeight");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "aspectRatio"
                   * @function Expression.aspectRatio
                   */ },

                {
                  key: "aspectRatio",
                  value: function aspectRatio() {
                    return new this("aspectRatio");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "initialAspectRatio"
                   * @function Expression.initialAspectRatio
                   */ },

                {
                  key: "initialAspectRatio",
                  value: function initialAspectRatio() {
                    return new this("initialAspectRatio");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "pageCount"
                   * @function Expression.pageCount
                   */ },

                {
                  key: "pageCount",
                  value: function pageCount() {
                    return new this("pageCount");
                  }
                  /**
                   * @returns Expression new expression with the predefined variable "faceCount"
                   * @function Expression.faceCount
                   */ },

                {
                  key: "faceCount",
                  value: function faceCount() {
                    return new this("faceCount");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "currentPage"
                   * @function Expression.currentPage
                   */ },

                {
                  key: "currentPage",
                  value: function currentPage() {
                    return new this("currentPage");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "tags"
                   * @function Expression.tags
                   */ },

                {
                  key: "tags",
                  value: function tags() {
                    return new this("tags");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "pageX"
                   * @function Expression.pageX
                   */ },

                {
                  key: "pageX",
                  value: function pageX() {
                    return new this("pageX");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "pageY"
                   * @function Expression.pageY
                   */ },

                {
                  key: "pageY",
                  value: function pageY() {
                    return new this("pageY");
                  } }]);


                return Expression;
              }();
              /**
               * @internal
               */


              Expression.OPERATORS = {
                "=": 'eq',
                "!=": 'ne',
                "<": 'lt',
                ">": 'gt',
                "<=": 'lte',
                ">=": 'gte',
                "&&": 'and',
                "||": 'or',
                "*": "mul",
                "/": "div",
                "+": "add",
                "-": "sub",
                "^": "pow" };

              /**
               * @internal
               */

              Expression.PREDEFINED_VARS = {
                "aspect_ratio": "ar",
                "aspectRatio": "ar",
                "current_page": "cp",
                "currentPage": "cp",
                "duration": "du",
                "face_count": "fc",
                "faceCount": "fc",
                "height": "h",
                "initial_aspect_ratio": "iar",
                "initial_duration": "idu",
                "initial_height": "ih",
                "initial_width": "iw",
                "initialAspectRatio": "iar",
                "initialDuration": "idu",
                "initialHeight": "ih",
                "initialWidth": "iw",
                "page_count": "pc",
                "page_x": "px",
                "page_y": "py",
                "pageCount": "pc",
                "pageX": "px",
                "pageY": "py",
                "tags": "tags",
                "width": "w" };

              /**
               * @internal
               */

              Expression.BOUNDRY = "[ _]+";
              /* harmony default export */var expression = Expression;
              // CONCATENATED MODULE: ./src/condition.js
              function condition_typeof(obj) {"@babel/helpers - typeof";return condition_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, condition_typeof(obj);}

              function condition_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function condition_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function condition_createClass(Constructor, protoProps, staticProps) {if (protoProps) condition_defineProperties(Constructor.prototype, protoProps);if (staticProps) condition_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) _setPrototypeOf(subClass, superClass);}

              function _setPrototypeOf(o, p) {_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return _setPrototypeOf(o, p);}

              function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = _getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return _possibleConstructorReturn(this, result);};}

              function _possibleConstructorReturn(self, call) {if (call && (condition_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}

              function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

              function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

              function _getPrototypeOf(o) {_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return _getPrototypeOf(o);}


              /**
               * Represents a transformation condition.
               * @param {string} conditionStr - a condition in string format
               * @class Condition
               * @example
               * // normally this class is not instantiated directly
               * var tr = cloudinary.Transformation.new()
               *    .if().width( ">", 1000).and().aspectRatio("<", "3:4").then()
               *      .width(1000)
               *      .crop("scale")
               *    .else()
               *      .width(500)
               *      .crop("scale")
               *
               * var tr = cloudinary.Transformation.new()
               *    .if("w > 1000 and aspectRatio < 3:4")
               *      .width(1000)
               *      .crop("scale")
               *    .else()
               *      .width(500)
               *      .crop("scale")
               *
               */

              var Condition = /*#__PURE__*/function (_Expression) {
                _inherits(Condition, _Expression);

                var _super = _createSuper(Condition);

                function Condition(conditionStr) {
                  condition_classCallCheck(this, Condition);

                  return _super.call(this, conditionStr);
                }
                /**
                 * @function Condition#height
                 * @param {string} operator the comparison operator (e.g. "<", "lt")
                 * @param {string|number} value the right hand side value
                 * @return {Condition} this condition
                 */


                condition_createClass(Condition, [{
                  key: "height",
                  value: function height(operator, value) {
                    return this.predicate("h", operator, value);
                  }
                  /**
                   * @function Condition#width
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */ },

                {
                  key: "width",
                  value: function width(operator, value) {
                    return this.predicate("w", operator, value);
                  }
                  /**
                   * @function Condition#aspectRatio
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */ },

                {
                  key: "aspectRatio",
                  value: function aspectRatio(operator, value) {
                    return this.predicate("ar", operator, value);
                  }
                  /**
                   * @function Condition#pages
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */ },

                {
                  key: "pageCount",
                  value: function pageCount(operator, value) {
                    return this.predicate("pc", operator, value);
                  }
                  /**
                   * @function Condition#faces
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */ },

                {
                  key: "faceCount",
                  value: function faceCount(operator, value) {
                    return this.predicate("fc", operator, value);
                  }
                  /**
                   * @function Condition#duration
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */ },

                {
                  key: "duration",
                  value: function duration(operator, value) {
                    return this.predicate("du", operator, value);
                  }
                  /**
                   * @function Condition#initialDuration
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */ },

                {
                  key: "initialDuration",
                  value: function initialDuration(operator, value) {
                    return this.predicate("idu", operator, value);
                  } }]);


                return Condition;
              }(expression);

              /* harmony default export */var condition = Condition;
              // CONCATENATED MODULE: ./src/configuration.js
              function _slicedToArray(arr, i) {return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || configuration_unsupportedIterableToArray(arr, i) || _nonIterableRest();}

              function _nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

              function configuration_unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return configuration_arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return configuration_arrayLikeToArray(o, minLen);}

              function configuration_arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}

              function _iterableToArrayLimit(arr, i) {var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];if (_i == null) return;var _arr = [];var _n = true;var _d = false;var _s, _e;try {for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}

              function _arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}

              function configuration_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function configuration_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function configuration_createClass(Constructor, protoProps, staticProps) {if (protoProps) configuration_defineProperties(Constructor.prototype, protoProps);if (staticProps) configuration_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              /**
               * Class for defining account configuration options.
               * Depends on 'utils'
               */

              /**
               * Class for defining account configuration options.
               * @constructor Configuration
               * @param {Object} options - The account configuration parameters to set.
               * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
               *  target="_new">Available configuration options</a>
               */

              var configuration_Configuration = /*#__PURE__*/function () {
                function Configuration(options) {
                  configuration_classCallCheck(this, Configuration);

                  this.configuration = options == null ? {} : cloneDeep_root_cloneDeep_default()(options);
                  defaults(this.configuration, DEFAULT_CONFIGURATION_PARAMS);
                }
                /**
                 * Initializes the configuration. This method is a convenience method that invokes both
                 *  {@link Configuration#fromEnvironment|fromEnvironment()} (Node.js environment only)
                 *  and {@link Configuration#fromDocument|fromDocument()}.
                 *  It first tries to retrieve the configuration from the environment variable.
                 *  If not available, it tries from the document meta tags.
                 * @function Configuration#init
                 * @return {Configuration} returns `this` for chaining
                 * @see fromDocument
                 * @see fromEnvironment
                 */


                configuration_createClass(Configuration, [{
                  key: "init",
                  value: function init() {
                    this.fromEnvironment();
                    this.fromDocument();
                    return this;
                  }
                  /**
                   * Set a new configuration item
                   * @function Configuration#set
                   * @param {string} name - the name of the item to set
                   * @param {*} value - the value to be set
                   * @return {Configuration}
                   *
                   */ },

                {
                  key: "set",
                  value: function set(name, value) {
                    this.configuration[name] = value;
                    return this;
                  }
                  /**
                   * Get the value of a configuration item
                   * @function Configuration#get
                   * @param {string} name - the name of the item to set
                   * @return {*} the configuration item
                   */ },

                {
                  key: "get",
                  value: function get(name) {
                    return this.configuration[name];
                  } },
                {
                  key: "merge",
                  value: function merge(config) {
                    assign_root_assign_default()(this.configuration, cloneDeep_root_cloneDeep_default()(config));
                    return this;
                  }
                  /**
                   * Initialize Cloudinary from HTML meta tags.
                   * @function Configuration#fromDocument
                   * @return {Configuration}
                   * @example <meta name="cloudinary_cloud_name" content="mycloud">
                   *
                   */ },

                {
                  key: "fromDocument",
                  value: function fromDocument() {
                    var el, i, len, meta_elements;
                    meta_elements = typeof document !== "undefined" && document !== null ? document.querySelectorAll('meta[name^="cloudinary_"]') : void 0;

                    if (meta_elements) {
                      for (i = 0, len = meta_elements.length; i < len; i++) {
                        el = meta_elements[i];
                        this.configuration[el.getAttribute('name').replace('cloudinary_', '')] = el.getAttribute('content');
                      }
                    }

                    return this;
                  }
                  /**
                   * Initialize Cloudinary from the `CLOUDINARY_URL` environment variable.
                   *
                   * This function will only run under Node.js environment.
                   * @function Configuration#fromEnvironment
                   * @requires Node.js
                   */ },

                {
                  key: "fromEnvironment",
                  value: function fromEnvironment() {
                    var _this = this;

                    var cloudinary_url, query, uri, uriRegex;

                    if (typeof process !== "undefined" && process !== null && process.env && process.env.CLOUDINARY_URL) {
                      cloudinary_url = process.env.CLOUDINARY_URL;
                      uriRegex = /cloudinary:\/\/(?:(\w+)(?:\:([\w-]+))?@)?([\w\.-]+)(?:\/([^?]*))?(?:\?(.+))?/;
                      uri = uriRegex.exec(cloudinary_url);

                      if (uri) {
                        if (uri[3] != null) {
                          this.configuration['cloud_name'] = uri[3];
                        }

                        if (uri[1] != null) {
                          this.configuration['api_key'] = uri[1];
                        }

                        if (uri[2] != null) {
                          this.configuration['api_secret'] = uri[2];
                        }

                        if (uri[4] != null) {
                          this.configuration['private_cdn'] = uri[4] != null;
                        }

                        if (uri[4] != null) {
                          this.configuration['secure_distribution'] = uri[4];
                        }

                        query = uri[5];

                        if (query != null) {
                          query.split('&').forEach(function (value) {
                            var _value$split = value.split('='),
                            _value$split2 = _slicedToArray(_value$split, 2),
                            k = _value$split2[0],
                            v = _value$split2[1];

                            if (v == null) {
                              v = true;
                            }

                            _this.configuration[k] = v;
                          });
                        }
                      }
                    }

                    return this;
                  }
                  /**
                   * Create or modify the Cloudinary client configuration
                   *
                   * Warning: `config()` returns the actual internal configuration object. modifying it will change the configuration.
                   *
                   * This is a backward compatibility method. For new code, use get(), merge() etc.
                   * @function Configuration#config
                   * @param {hash|string|boolean} new_config
                   * @param {string} new_value
                   * @returns {*} configuration, or value
                   *
                   * @see {@link fromEnvironment} for initialization using environment variables
                   * @see {@link fromDocument} for initialization using HTML meta tags
                   */ },

                {
                  key: "config",
                  value: function config(new_config, new_value) {
                    switch (false) {
                      case new_value === void 0:
                        this.set(new_config, new_value);
                        return this.configuration;

                      case !isString_root_isString_default()(new_config):
                        return this.get(new_config);

                      case !isPlainObject_root_isPlainObject_default()(new_config):
                        this.merge(new_config);
                        return this.configuration;

                      default:
                        // Backward compatibility - return the internal object
                        return this.configuration;}

                  }
                  /**
                   * Returns a copy of the configuration parameters
                   * @function Configuration#toOptions
                   * @returns {Object} a key:value collection of the configuration parameters
                   */ },

                {
                  key: "toOptions",
                  value: function toOptions() {
                    return cloneDeep_root_cloneDeep_default()(this.configuration);
                  } }]);


                return Configuration;
              }();

              var DEFAULT_CONFIGURATION_PARAMS = {
                responsive_class: 'cld-responsive',
                responsive_use_breakpoints: true,
                round_dpr: true,
                secure: (typeof window !== "undefined" && window !== null ? window.location ? window.location.protocol : void 0 : void 0) === 'https:' };

              configuration_Configuration.CONFIG_PARAMS = ["api_key", "api_secret", "callback", "cdn_subdomain", "cloud_name", "cname", "private_cdn", "protocol", "resource_type", "responsive", "responsive_class", "responsive_use_breakpoints", "responsive_width", "round_dpr", "secure", "secure_cdn_subdomain", "secure_distribution", "shorten", "type", "upload_preset", "url_suffix", "use_root_path", "version", "externalLibraries", "max_timeout_ms"];
              /* harmony default export */var src_configuration = configuration_Configuration;
              // CONCATENATED MODULE: ./src/layer/layer.js
              function layer_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function layer_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function layer_createClass(Constructor, protoProps, staticProps) {if (protoProps) layer_defineProperties(Constructor.prototype, protoProps);if (staticProps) layer_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}



              var layer_Layer = /*#__PURE__*/function () {
                /**
                 * Layer
                 * @constructor Layer
                 * @param {Object} options - layer parameters
                 */
                function Layer(options) {
                  var _this = this;

                  layer_classCallCheck(this, Layer);

                  this.options = {};

                  if (options != null) {
                    ["resourceType", "type", "publicId", "format"].forEach(function (key) {
                      var ref;
                      return _this.options[key] = (ref = options[key]) != null ? ref : options[snakeCase(key)];
                    });
                  }
                }

                layer_createClass(Layer, [{
                  key: "resourceType",
                  value: function resourceType(value) {
                    this.options.resourceType = value;
                    return this;
                  } },
                {
                  key: "type",
                  value: function type(value) {
                    this.options.type = value;
                    return this;
                  } },
                {
                  key: "publicId",
                  value: function publicId(value) {
                    this.options.publicId = value;
                    return this;
                  }
                  /**
                   * Get the public ID, formatted for layer parameter
                   * @function Layer#getPublicId
                   * @return {String} public ID
                   */ },

                {
                  key: "getPublicId",
                  value: function getPublicId() {
                    var ref;
                    return (ref = this.options.publicId) != null ? ref.replace(/\//g, ":") : void 0;
                  }
                  /**
                   * Get the public ID, with format if present
                   * @function Layer#getFullPublicId
                   * @return {String} public ID
                   */ },

                {
                  key: "getFullPublicId",
                  value: function getFullPublicId() {
                    if (this.options.format != null) {
                      return this.getPublicId() + "." + this.options.format;
                    } else {
                      return this.getPublicId();
                    }
                  } },
                {
                  key: "format",
                  value: function format(value) {
                    this.options.format = value;
                    return this;
                  }
                  /**
                   * generate the string representation of the layer
                   * @function Layer#toString
                   */ },

                {
                  key: "toString",
                  value: function toString() {
                    var components;
                    components = [];

                    if (this.options.publicId == null) {
                      throw "Must supply publicId";
                    }

                    if (!(this.options.resourceType === "image")) {
                      components.push(this.options.resourceType);
                    }

                    if (!(this.options.type === "upload")) {
                      components.push(this.options.type);
                    }

                    components.push(this.getFullPublicId());
                    return compact_root_compact_default()(components).join(":");
                  } },
                {
                  key: "clone",
                  value: function clone() {
                    return new this.constructor(this.options);
                  } }]);


                return Layer;
              }();

              /* harmony default export */var layer_layer = layer_Layer;
              // CONCATENATED MODULE: ./src/layer/textlayer.js
              function textlayer_typeof(obj) {"@babel/helpers - typeof";return textlayer_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, textlayer_typeof(obj);}

              function textlayer_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function textlayer_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function textlayer_createClass(Constructor, protoProps, staticProps) {if (protoProps) textlayer_defineProperties(Constructor.prototype, protoProps);if (staticProps) textlayer_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              function textlayer_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) textlayer_setPrototypeOf(subClass, superClass);}

              function textlayer_setPrototypeOf(o, p) {textlayer_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return textlayer_setPrototypeOf(o, p);}

              function textlayer_createSuper(Derived) {var hasNativeReflectConstruct = textlayer_isNativeReflectConstruct();return function _createSuperInternal() {var Super = textlayer_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = textlayer_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return textlayer_possibleConstructorReturn(this, result);};}

              function textlayer_possibleConstructorReturn(self, call) {if (call && (textlayer_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return textlayer_assertThisInitialized(self);}

              function textlayer_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

              function textlayer_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

              function textlayer_getPrototypeOf(o) {textlayer_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return textlayer_getPrototypeOf(o);}




              var textlayer_TextLayer = /*#__PURE__*/function (_Layer) {
                textlayer_inherits(TextLayer, _Layer);

                var _super = textlayer_createSuper(TextLayer);

                /**
                 * @constructor TextLayer
                 * @param {Object} options - layer parameters
                 */
                function TextLayer(options) {
                  var _this;

                  textlayer_classCallCheck(this, TextLayer);

                  var keys;
                  _this = _super.call(this, options);
                  keys = ["resourceType", "resourceType", "fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlign", "stroke", "letterSpacing", "lineSpacing", "fontHinting", "fontAntialiasing", "text", "textStyle"];

                  if (options != null) {
                    keys.forEach(function (key) {
                      var ref;
                      return _this.options[key] = (ref = options[key]) != null ? ref : options[snakeCase(key)];
                    });
                  }

                  _this.options.resourceType = "text";
                  return _this;
                }

                textlayer_createClass(TextLayer, [{
                  key: "resourceType",
                  value: function resourceType(_resourceType) {
                    throw "Cannot modify resourceType for text layers";
                  } },
                {
                  key: "type",
                  value: function type(_type) {
                    throw "Cannot modify type for text layers";
                  } },
                {
                  key: "format",
                  value: function format(_format) {
                    throw "Cannot modify format for text layers";
                  } },
                {
                  key: "fontFamily",
                  value: function fontFamily(_fontFamily) {
                    this.options.fontFamily = _fontFamily;
                    return this;
                  } },
                {
                  key: "fontSize",
                  value: function fontSize(_fontSize) {
                    this.options.fontSize = _fontSize;
                    return this;
                  } },
                {
                  key: "fontWeight",
                  value: function fontWeight(_fontWeight) {
                    this.options.fontWeight = _fontWeight;
                    return this;
                  } },
                {
                  key: "fontStyle",
                  value: function fontStyle(_fontStyle) {
                    this.options.fontStyle = _fontStyle;
                    return this;
                  } },
                {
                  key: "textDecoration",
                  value: function textDecoration(_textDecoration) {
                    this.options.textDecoration = _textDecoration;
                    return this;
                  } },
                {
                  key: "textAlign",
                  value: function textAlign(_textAlign) {
                    this.options.textAlign = _textAlign;
                    return this;
                  } },
                {
                  key: "stroke",
                  value: function stroke(_stroke) {
                    this.options.stroke = _stroke;
                    return this;
                  } },
                {
                  key: "letterSpacing",
                  value: function letterSpacing(_letterSpacing) {
                    this.options.letterSpacing = _letterSpacing;
                    return this;
                  } },
                {
                  key: "lineSpacing",
                  value: function lineSpacing(_lineSpacing) {
                    this.options.lineSpacing = _lineSpacing;
                    return this;
                  } },
                {
                  key: "fontHinting",
                  value: function fontHinting(_fontHinting) {
                    this.options.fontHinting = _fontHinting;
                    return this;
                  } },
                {
                  key: "fontAntialiasing",
                  value: function fontAntialiasing(_fontAntialiasing) {
                    this.options.fontAntialiasing = _fontAntialiasing;
                    return this;
                  } },
                {
                  key: "text",
                  value: function text(_text) {
                    this.options.text = _text;
                    return this;
                  } },
                {
                  key: "textStyle",
                  value: function textStyle(_textStyle) {
                    this.options.textStyle = _textStyle;
                    return this;
                  }
                  /**
                   * generate the string representation of the layer
                   * @function TextLayer#toString
                   * @return {String}
                   */ },

                {
                  key: "toString",
                  value: function toString() {
                    var components, hasPublicId, hasStyle, publicId, re, res, start, style, text, textSource;
                    style = this.textStyleIdentifier();

                    if (this.options.publicId != null) {
                      publicId = this.getFullPublicId();
                    }

                    if (this.options.text != null) {
                      hasPublicId = !isEmpty(publicId);
                      hasStyle = !isEmpty(style);

                      if (hasPublicId && hasStyle || !hasPublicId && !hasStyle) {
                        throw "Must supply either style parameters or a public_id when providing text parameter in a text overlay/underlay, but not both!";
                      }

                      re = /\$\([a-zA-Z]\w*\)/g;
                      start = 0; //        textSource = text.replace(new RegExp("[,/]", 'g'), (c)-> "%#{c.charCodeAt(0).toString(16).toUpperCase()}")

                      textSource = smartEscape(this.options.text, /[,\/]/g);
                      text = "";

                      while (res = re.exec(textSource)) {
                        text += smartEscape(textSource.slice(start, res.index));
                        text += res[0];
                        start = res.index + res[0].length;
                      }

                      text += smartEscape(textSource.slice(start));
                    }

                    components = [this.options.resourceType, style, publicId, text];
                    return compact_root_compact_default()(components).join(":");
                  } },
                {
                  key: "textStyleIdentifier",
                  value: function textStyleIdentifier() {
                    // Note: if a text-style argument is provided as a whole, it overrides everything else, no mix and match.
                    if (!isEmpty(this.options.textStyle)) {
                      return this.options.textStyle;
                    }

                    var components;
                    components = [];

                    if (this.options.fontWeight !== "normal") {
                      components.push(this.options.fontWeight);
                    }

                    if (this.options.fontStyle !== "normal") {
                      components.push(this.options.fontStyle);
                    }

                    if (this.options.textDecoration !== "none") {
                      components.push(this.options.textDecoration);
                    }

                    components.push(this.options.textAlign);

                    if (this.options.stroke !== "none") {
                      components.push(this.options.stroke);
                    }

                    if (!(isEmpty(this.options.letterSpacing) && !isNumberLike(this.options.letterSpacing))) {
                      components.push("letter_spacing_" + this.options.letterSpacing);
                    }

                    if (!(isEmpty(this.options.lineSpacing) && !isNumberLike(this.options.lineSpacing))) {
                      components.push("line_spacing_" + this.options.lineSpacing);
                    }

                    if (!isEmpty(this.options.fontAntialiasing)) {
                      components.push("antialias_" + this.options.fontAntialiasing);
                    }

                    if (!isEmpty(this.options.fontHinting)) {
                      components.push("hinting_" + this.options.fontHinting);
                    }

                    if (!isEmpty(compact_root_compact_default()(components))) {
                      if (isEmpty(this.options.fontFamily)) {
                        throw "Must supply fontFamily. ".concat(components);
                      }

                      if (isEmpty(this.options.fontSize) && !isNumberLike(this.options.fontSize)) {
                        throw "Must supply fontSize.";
                      }
                    }

                    components.unshift(this.options.fontFamily, this.options.fontSize);
                    components = compact_root_compact_default()(components).join("_");
                    return components;
                  } }]);


                return TextLayer;
              }(layer_layer);
              /* harmony default export */var textlayer = textlayer_TextLayer;
              // CONCATENATED MODULE: ./src/layer/subtitleslayer.js
              function subtitleslayer_typeof(obj) {"@babel/helpers - typeof";return subtitleslayer_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, subtitleslayer_typeof(obj);}

              function subtitleslayer_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function subtitleslayer_createClass(Constructor, protoProps, staticProps) {if (protoProps) subtitleslayer_defineProperties(Constructor.prototype, protoProps);if (staticProps) subtitleslayer_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              function subtitleslayer_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function subtitleslayer_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) subtitleslayer_setPrototypeOf(subClass, superClass);}

              function subtitleslayer_setPrototypeOf(o, p) {subtitleslayer_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return subtitleslayer_setPrototypeOf(o, p);}

              function subtitleslayer_createSuper(Derived) {var hasNativeReflectConstruct = subtitleslayer_isNativeReflectConstruct();return function _createSuperInternal() {var Super = subtitleslayer_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = subtitleslayer_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return subtitleslayer_possibleConstructorReturn(this, result);};}

              function subtitleslayer_possibleConstructorReturn(self, call) {if (call && (subtitleslayer_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return subtitleslayer_assertThisInitialized(self);}

              function subtitleslayer_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

              function subtitleslayer_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

              function subtitleslayer_getPrototypeOf(o) {subtitleslayer_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return subtitleslayer_getPrototypeOf(o);}



              var SubtitlesLayer = /*#__PURE__*/function (_TextLayer) {
                subtitleslayer_inherits(SubtitlesLayer, _TextLayer);

                var _super = subtitleslayer_createSuper(SubtitlesLayer);

                /**
                 * Represent a subtitles layer
                 * @constructor SubtitlesLayer
                 * @param {Object} options - layer parameters
                 */
                function SubtitlesLayer(options) {
                  var _this;

                  subtitleslayer_classCallCheck(this, SubtitlesLayer);

                  _this = _super.call(this, options);
                  _this.options.resourceType = "subtitles";
                  return _this;
                }

                return subtitleslayer_createClass(SubtitlesLayer);
              }(textlayer);

              /* harmony default export */var subtitleslayer = SubtitlesLayer;
              // CONCATENATED MODULE: ./src/layer/fetchlayer.js
              function fetchlayer_typeof(obj) {"@babel/helpers - typeof";return fetchlayer_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, fetchlayer_typeof(obj);}

              function fetchlayer_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function fetchlayer_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function fetchlayer_createClass(Constructor, protoProps, staticProps) {if (protoProps) fetchlayer_defineProperties(Constructor.prototype, protoProps);if (staticProps) fetchlayer_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              function fetchlayer_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) fetchlayer_setPrototypeOf(subClass, superClass);}

              function fetchlayer_setPrototypeOf(o, p) {fetchlayer_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return fetchlayer_setPrototypeOf(o, p);}

              function fetchlayer_createSuper(Derived) {var hasNativeReflectConstruct = fetchlayer_isNativeReflectConstruct();return function _createSuperInternal() {var Super = fetchlayer_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = fetchlayer_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return fetchlayer_possibleConstructorReturn(this, result);};}

              function fetchlayer_possibleConstructorReturn(self, call) {if (call && (fetchlayer_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return fetchlayer_assertThisInitialized(self);}

              function fetchlayer_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

              function fetchlayer_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

              function fetchlayer_getPrototypeOf(o) {fetchlayer_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return fetchlayer_getPrototypeOf(o);}




              var fetchlayer_FetchLayer = /*#__PURE__*/function (_Layer) {
                fetchlayer_inherits(FetchLayer, _Layer);

                var _super = fetchlayer_createSuper(FetchLayer);

                /**
                 * @class FetchLayer
                 * @classdesc Creates an image layer using a remote URL.
                 * @param {Object|string} options - layer parameters or a url
                 * @param {string} options.url the url of the image to fetch
                 */
                function FetchLayer(options) {
                  var _this;

                  fetchlayer_classCallCheck(this, FetchLayer);

                  _this = _super.call(this, options);

                  if (isString_root_isString_default()(options)) {
                    _this.options.url = options;
                  } else if (options != null ? options.url : void 0) {
                    _this.options.url = options.url;
                  }

                  return _this;
                }

                fetchlayer_createClass(FetchLayer, [{
                  key: "url",
                  value: function url(_url) {
                    this.options.url = _url;
                    return this;
                  }
                  /**
                   * generate the string representation of the layer
                   * @function FetchLayer#toString
                   * @return {String}
                   */ },

                {
                  key: "toString",
                  value: function toString() {
                    return "fetch:".concat(base64EncodeURL(this.options.url));
                  } }]);


                return FetchLayer;
              }(layer_layer);

              /* harmony default export */var fetchlayer = fetchlayer_FetchLayer;
              // CONCATENATED MODULE: ./src/parameters.js
              function parameters_typeof(obj) {"@babel/helpers - typeof";return parameters_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, parameters_typeof(obj);}

              function _get() {if (typeof Reflect !== "undefined" && Reflect.get) {_get = Reflect.get.bind();} else {_get = function _get(target, property, receiver) {var base = _superPropBase(target, property);if (!base) return;var desc = Object.getOwnPropertyDescriptor(base, property);if (desc.get) {return desc.get.call(arguments.length < 3 ? target : receiver);}return desc.value;};}return _get.apply(this, arguments);}

              function _superPropBase(object, property) {while (!Object.prototype.hasOwnProperty.call(object, property)) {object = parameters_getPrototypeOf(object);if (object === null) break;}return object;}

              function parameters_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) parameters_setPrototypeOf(subClass, superClass);}

              function parameters_setPrototypeOf(o, p) {parameters_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return parameters_setPrototypeOf(o, p);}

              function parameters_createSuper(Derived) {var hasNativeReflectConstruct = parameters_isNativeReflectConstruct();return function _createSuperInternal() {var Super = parameters_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = parameters_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return parameters_possibleConstructorReturn(this, result);};}

              function parameters_possibleConstructorReturn(self, call) {if (call && (parameters_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return parameters_assertThisInitialized(self);}

              function parameters_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

              function parameters_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

              function parameters_getPrototypeOf(o) {parameters_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return parameters_getPrototypeOf(o);}

              function parameters_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function parameters_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function parameters_createClass(Constructor, protoProps, staticProps) {if (protoProps) parameters_defineProperties(Constructor.prototype, protoProps);if (staticProps) parameters_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}








              /**
               * Transformation parameters
               * Depends on 'util', 'transformation'
               */

              var parameters_Param = /*#__PURE__*/function () {
                /**
                 * Represents a single parameter.
                 * @class Param
                 * @param {string} name - The name of the parameter in snake_case
                 * @param {string} shortName - The name of the serialized form of the parameter.
                 *                         If a value is not provided, the parameter will not be serialized.
                 * @param {function} [process=Util.identity ] - Manipulate origValue when value is called
                 * @ignore
                 */
                function Param(name, shortName) {
                  var process = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity_root_identity_default.a;

                  parameters_classCallCheck(this, Param);

                  /**
                   * The name of the parameter in snake_case
                   * @member {string} Param#name
                   */
                  this.name = name;
                  /**
                   * The name of the serialized form of the parameter
                   * @member {string} Param#shortName
                   */

                  this.shortName = shortName;
                  /**
                   * Manipulate origValue when value is called
                   * @member {function} Param#process
                   */

                  this.process = process;
                }
                /**
                 * Set a (unprocessed) value for this parameter
                 * @function Param#set
                 * @param {*} origValue - the value of the parameter
                 * @return {Param} self for chaining
                 */


                parameters_createClass(Param, [{
                  key: "set",
                  value: function set(origValue) {
                    this.origValue = origValue;
                    return this;
                  }
                  /**
                   * Generate the serialized form of the parameter
                   * @function Param#serialize
                   * @return {string} the serialized form of the parameter
                   */ },

                {
                  key: "serialize",
                  value: function serialize() {
                    var val, valid;
                    val = this.value();
                    valid = isArray_root_isArray_default()(val) || isPlainObject_root_isPlainObject_default()(val) || isString_root_isString_default()(val) ? !isEmpty(val) : val != null;

                    if (this.shortName != null && valid) {
                      return "".concat(this.shortName, "_").concat(val);
                    } else {
                      return '';
                    }
                  }
                  /**
                   * Return the processed value of the parameter
                   * @function Param#value
                   */ },

                {
                  key: "value",
                  value: function value() {
                    return this.process(this.origValue);
                  } }],
                [{
                  key: "norm_color",
                  value: function norm_color(value) {
                    return value != null ? value.replace(/^#/, 'rgb:') : void 0;
                  } },
                {
                  key: "build_array",
                  value: function build_array(arg) {
                    if (arg == null) {
                      return [];
                    } else if (isArray_root_isArray_default()(arg)) {
                      return arg;
                    } else {
                      return [arg];
                    }
                  }
                  /**
                  * Covert value to video codec string.
                  *
                  * If the parameter is an object,
                  * @param {(string|Object)} param - the video codec as either a String or a Hash
                  * @return {string} the video codec string in the format codec:profile:level:b_frames
                  * @example
                  * vc_[ :profile : [level : [b_frames]]]
                  * or
                    { codec: 'h264', profile: 'basic', level: '3.1', b_frames: false }
                  * @ignore
                   */ },

                {
                  key: "process_video_params",
                  value: function process_video_params(param) {
                    var video;

                    switch (param.constructor) {
                      case Object:
                        video = "";

                        if ('codec' in param) {
                          video = param.codec;

                          if ('profile' in param) {
                            video += ":" + param.profile;

                            if ('level' in param) {
                              video += ":" + param.level;

                              if ('b_frames' in param && param.b_frames === false) {
                                video += ":bframes_no";
                              }
                            }
                          }
                        }

                        return video;

                      case String:
                        return param;

                      default:
                        return null;}

                  } }]);


                return Param;
              }();

              var parameters_ArrayParam = /*#__PURE__*/function (_Param) {
                parameters_inherits(ArrayParam, _Param);

                var _super = parameters_createSuper(ArrayParam);

                /**
                 * A parameter that represents an array.
                 * @param {string} name - The name of the parameter in snake_case.
                 * @param {string} shortName - The name of the serialized form of the parameter
                 *                         If a value is not provided, the parameter will not be serialized.
                 * @param {string} [sep='.'] - The separator to use when joining the array elements together
                 * @param {function} [process=Util.identity ] - Manipulate origValue when value is called
                 * @class ArrayParam
                 * @extends Param
                 * @ignore
                 */
                function ArrayParam(name, shortName) {
                  var _this;

                  var sep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
                  var process = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

                  parameters_classCallCheck(this, ArrayParam);

                  _this = _super.call(this, name, shortName, process);
                  _this.sep = sep;
                  return _this;
                }

                parameters_createClass(ArrayParam, [{
                  key: "serialize",
                  value: function serialize() {
                    if (this.shortName != null) {
                      var arrayValue = this.value();

                      if (isEmpty(arrayValue)) {
                        return '';
                      } else if (isString_root_isString_default()(arrayValue)) {
                        return "".concat(this.shortName, "_").concat(arrayValue);
                      } else {
                        var flat = arrayValue.map(function (t) {
                          return isFunction_root_isFunction_default()(t.serialize) ? t.serialize() : t;
                        }).join(this.sep);
                        return "".concat(this.shortName, "_").concat(flat);
                      }
                    } else {
                      return '';
                    }
                  } },
                {
                  key: "value",
                  value: function value() {
                    var _this2 = this;

                    if (isArray_root_isArray_default()(this.origValue)) {
                      return this.origValue.map(function (v) {
                        return _this2.process(v);
                      });
                    } else {
                      return this.process(this.origValue);
                    }
                  } },
                {
                  key: "set",
                  value: function set(origValue) {
                    if (origValue == null || isArray_root_isArray_default()(origValue)) {
                      return _get(parameters_getPrototypeOf(ArrayParam.prototype), "set", this).call(this, origValue);
                    } else {
                      return _get(parameters_getPrototypeOf(ArrayParam.prototype), "set", this).call(this, [origValue]);
                    }
                  } }]);


                return ArrayParam;
              }(parameters_Param);

              var parameters_TransformationParam = /*#__PURE__*/function (_Param2) {
                parameters_inherits(TransformationParam, _Param2);

                var _super2 = parameters_createSuper(TransformationParam);

                /**
                 * A parameter that represents a transformation
                 * @param {string} name - The name of the parameter in snake_case
                 * @param {string} [shortName='t'] - The name of the serialized form of the parameter
                 * @param {string} [sep='.'] - The separator to use when joining the array elements together
                 * @param {function} [process=Util.identity ] - Manipulate origValue when value is called
                 * @class TransformationParam
                 * @extends Param
                 * @ignore
                 */
                function TransformationParam(name) {
                  var _this3;

                  var shortName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "t";
                  var sep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
                  var process = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

                  parameters_classCallCheck(this, TransformationParam);

                  _this3 = _super2.call(this, name, shortName, process);
                  _this3.sep = sep;
                  return _this3;
                }
                /**
                 * Generate string representations of the transformation.
                 * @returns {*} Returns either the transformation as a string, or an array of string representations.
                 */


                parameters_createClass(TransformationParam, [{
                  key: "serialize",
                  value: function serialize() {
                    var _this4 = this;

                    var result = '';
                    var val = this.value();

                    if (isEmpty(val)) {
                      return result;
                    } // val is an array of strings so join them


                    if (baseutil_allStrings(val)) {
                      var joined = val.join(this.sep); // creates t1.t2.t3 in case multiple named transformations were configured

                      if (!isEmpty(joined)) {
                        // in case options.transformation was not set with an empty string (val != ['']);
                        result = "".concat(this.shortName, "_").concat(joined);
                      }
                    } else {
                      // Convert val to an array of strings
                      result = val.map(function (t) {
                        if (isString_root_isString_default()(t) && !isEmpty(t)) {
                          return "".concat(_this4.shortName, "_").concat(t);
                        }

                        if (isFunction_root_isFunction_default()(t.serialize)) {
                          return t.serialize();
                        }

                        if (isPlainObject_root_isPlainObject_default()(t) && !isEmpty(t)) {
                          return new src_transformation(t).serialize();
                        }

                        return undefined;
                      }).filter(function (t) {
                        return t;
                      });
                    }

                    return result;
                  } },
                {
                  key: "set",
                  value: function set(origValue1) {
                    this.origValue = origValue1;

                    if (isArray_root_isArray_default()(this.origValue)) {
                      return _get(parameters_getPrototypeOf(TransformationParam.prototype), "set", this).call(this, this.origValue);
                    } else {
                      return _get(parameters_getPrototypeOf(TransformationParam.prototype), "set", this).call(this, [this.origValue]);
                    }
                  } }]);


                return TransformationParam;
              }(parameters_Param);

              var number_pattern = "([0-9]*)\\.([0-9]+)|([0-9]+)";
              var offset_any_pattern = "(" + number_pattern + ")([%pP])?";

              var parameters_RangeParam = /*#__PURE__*/function (_Param3) {
                parameters_inherits(RangeParam, _Param3);

                var _super3 = parameters_createSuper(RangeParam);

                /**
                 * A parameter that represents a range
                 * @param {string} name - The name of the parameter in snake_case
                 * @param {string} shortName - The name of the serialized form of the parameter
                 *                         If a value is not provided, the parameter will not be serialized.
                 * @param {function} [process=norm_range_value ] - Manipulate origValue when value is called
                 * @class RangeParam
                 * @extends Param
                 * @ignore
                 */
                function RangeParam(name, shortName) {
                  var process = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : RangeParam.norm_range_value;

                  parameters_classCallCheck(this, RangeParam);

                  return _super3.call(this, name, shortName, process);
                }

                parameters_createClass(RangeParam, null, [{
                  key: "norm_range_value",
                  value: function norm_range_value(value) {
                    var offset = String(value).match(new RegExp('^' + offset_any_pattern + '$'));

                    if (offset) {
                      var modifier = offset[5] != null ? 'p' : '';
                      value = (offset[1] || offset[4]) + modifier;
                    }

                    return expression.normalize(value);
                  } }]);


                return RangeParam;
              }(parameters_Param);

              var parameters_RawParam = /*#__PURE__*/function (_Param4) {
                parameters_inherits(RawParam, _Param4);

                var _super4 = parameters_createSuper(RawParam);

                function RawParam(name, shortName) {
                  var process = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity_root_identity_default.a;

                  parameters_classCallCheck(this, RawParam);

                  return _super4.call(this, name, shortName, process);
                }

                parameters_createClass(RawParam, [{
                  key: "serialize",
                  value: function serialize() {
                    return this.value();
                  } }]);


                return RawParam;
              }(parameters_Param);

              var parameters_LayerParam = /*#__PURE__*/function (_Param5) {
                parameters_inherits(LayerParam, _Param5);

                var _super5 = parameters_createSuper(LayerParam);

                function LayerParam() {
                  parameters_classCallCheck(this, LayerParam);

                  return _super5.apply(this, arguments);
                }

                parameters_createClass(LayerParam, [{
                  key: "value",
                  value: // Parse layer options
                  // @return [string] layer transformation string
                  // @private
                  function value() {
                    if (this.origValue == null) {
                      return '';
                    }

                    var result;

                    if (this.origValue instanceof layer_layer) {
                      result = this.origValue;
                    } else if (isPlainObject_root_isPlainObject_default()(this.origValue)) {
                      var layerOptions = withCamelCaseKeys(this.origValue);

                      if (layerOptions.resourceType === "text" || layerOptions.text != null) {
                        result = new textlayer(layerOptions);
                      } else if (layerOptions.resourceType === "subtitles") {
                        result = new subtitleslayer(layerOptions);
                      } else if (layerOptions.resourceType === "fetch" || layerOptions.url != null) {
                        result = new fetchlayer(layerOptions);
                      } else {
                        result = new layer_layer(layerOptions);
                      }
                    } else if (isString_root_isString_default()(this.origValue)) {
                      if (/^fetch:.+/.test(this.origValue)) {
                        result = new fetchlayer(this.origValue.substr(6));
                      } else {
                        result = this.origValue;
                      }
                    } else {
                      result = '';
                    }

                    return result.toString();
                  } }],
                [{
                  key: "textStyle",
                  value: function textStyle(layer) {
                    return new textlayer(layer).textStyleIdentifier();
                  } }]);


                return LayerParam;
              }(parameters_Param);


              // CONCATENATED MODULE: ./src/transformation.js
              function transformation_typeof(obj) {"@babel/helpers - typeof";return transformation_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, transformation_typeof(obj);}

              function transformation_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) transformation_setPrototypeOf(subClass, superClass);}

              function transformation_setPrototypeOf(o, p) {transformation_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return transformation_setPrototypeOf(o, p);}

              function transformation_createSuper(Derived) {var hasNativeReflectConstruct = transformation_isNativeReflectConstruct();return function _createSuperInternal() {var Super = transformation_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = transformation_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return transformation_possibleConstructorReturn(this, result);};}

              function transformation_possibleConstructorReturn(self, call) {if (call && (transformation_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return transformation_assertThisInitialized(self);}

              function transformation_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

              function transformation_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

              function transformation_getPrototypeOf(o) {transformation_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return transformation_getPrototypeOf(o);}

              function transformation_slicedToArray(arr, i) {return transformation_arrayWithHoles(arr) || transformation_iterableToArrayLimit(arr, i) || transformation_unsupportedIterableToArray(arr, i) || transformation_nonIterableRest();}

              function transformation_nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

              function transformation_unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return transformation_arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return transformation_arrayLikeToArray(o, minLen);}

              function transformation_arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}

              function transformation_iterableToArrayLimit(arr, i) {var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];if (_i == null) return;var _arr = [];var _n = true;var _d = false;var _s, _e;try {for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}

              function transformation_arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}

              function transformation_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function transformation_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function transformation_createClass(Constructor, protoProps, staticProps) {if (protoProps) transformation_defineProperties(Constructor.prototype, protoProps);if (staticProps) transformation_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}







              /**
               * Assign key, value to target, when value is not null.<br>
               *   This function mutates the target!
               * @param {object} target the object to assign the values to
               * @param {object} sources one or more objects to get values from
               * @returns {object} the target after the assignment
               */

              function assignNotNull(target) {
                for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  sources[_key - 1] = arguments[_key];
                }

                sources.forEach(function (source) {
                  Object.keys(source).forEach(function (key) {
                    if (source[key] != null) {
                      target[key] = source[key];
                    }
                  });
                });
                return target;
              }
              /**
               * TransformationBase
               * Depends on 'configuration', 'parameters','util'
               * @internal
               */


              var transformation_TransformationBase = /*#__PURE__*/function () {
                /**
                 * The base class for transformations.
                 * Members of this class are documented as belonging to the {@link Transformation} class for convenience.
                 * @class TransformationBase
                 */
                function TransformationBase(options) {
                  transformation_classCallCheck(this, TransformationBase);

                  /** @private */

                  /** @private */
                  var parent, trans;
                  parent = void 0;
                  trans = {};
                  /**
                   * Return an options object that can be used to create an identical Transformation
                   * @function Transformation#toOptions
                   * @return {Object} Returns a plain object representing this transformation
                   */

                  this.toOptions = function (withChain) {
                    var opt = {};

                    if (withChain == null) {
                      withChain = true;
                    }

                    Object.keys(trans).forEach(function (key) {
                      return opt[key] = trans[key].origValue;
                    });
                    assignNotNull(opt, this.otherOptions);

                    if (withChain && !isEmpty(this.chained)) {
                      var list = this.chained.map(function (tr) {
                        return tr.toOptions();
                      });
                      list.push(opt);
                      opt = {};
                      assignNotNull(opt, this.otherOptions);
                      opt.transformation = list;
                    }

                    return opt;
                  };
                  /**
                   * Set a parent for this object for chaining purposes.
                   *
                   * @function Transformation#setParent
                   * @param {Object} object - the parent to be assigned to
                   * @returns {Transformation} Returns this instance for chaining purposes.
                   */


                  this.setParent = function (object) {
                    parent = object;

                    if (object != null) {
                      this.fromOptions(typeof object.toOptions === "function" ? object.toOptions() : void 0);
                    }

                    return this;
                  };
                  /**
                   * Returns the parent of this object in the chain
                   * @function Transformation#getParent
                   * @protected
                   * @return {Object} Returns the parent of this object if there is any
                   */


                  this.getParent = function () {
                    return parent;
                  }; // Helper methods to create parameter methods
                  // These methods are defined here because they access `trans` which is
                  // a private member of `TransformationBase`

                  /** @protected */


                  this.param = function (value, name, abbr, defaultValue, process) {
                    if (process == null) {
                      if (isFunction_root_isFunction_default()(defaultValue)) {
                        process = defaultValue;
                      } else {
                        process = identity_root_identity_default.a;
                      }
                    }

                    trans[name] = new parameters_Param(name, abbr, process).set(value);
                    return this;
                  };
                  /** @protected */


                  this.rawParam = function (value, name, abbr, defaultValue, process) {
                    process = lastArgCallback(arguments);
                    trans[name] = new parameters_RawParam(name, abbr, process).set(value);
                    return this;
                  };
                  /** @protected */


                  this.rangeParam = function (value, name, abbr, defaultValue, process) {
                    process = lastArgCallback(arguments);
                    trans[name] = new parameters_RangeParam(name, abbr, process).set(value);
                    return this;
                  };
                  /** @protected */


                  this.arrayParam = function (value, name, abbr) {
                    var sep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ":";
                    var process = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                    process = lastArgCallback(arguments);
                    trans[name] = new parameters_ArrayParam(name, abbr, sep, process).set(value);
                    return this;
                  };
                  /** @protected */


                  this.transformationParam = function (value, name, abbr) {
                    var sep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
                    var process = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                    process = lastArgCallback(arguments);
                    trans[name] = new parameters_TransformationParam(name, abbr, sep, process).set(value);
                    return this;
                  };

                  this.layerParam = function (value, name, abbr) {
                    trans[name] = new parameters_LayerParam(name, abbr).set(value);
                    return this;
                  }; // End Helper methods

                  /**
                   * Get the value associated with the given name.
                   * @function Transformation#getValue
                   * @param {string} name - the name of the parameter
                   * @return {*} the processed value associated with the given name
                   * @description Use {@link get}.origValue for the value originally provided for the parameter
                   */


                  this.getValue = function (name) {
                    var value = trans[name] && trans[name].value();
                    return value != null ? value : this.otherOptions[name];
                  };
                  /**
                   * Get the parameter object for the given parameter name
                   * @function Transformation#get
                   * @param {string} name the name of the transformation parameter
                   * @returns {Param} the param object for the given name, or undefined
                   */


                  this.get = function (name) {
                    return trans[name];
                  };
                  /**
                   * Remove a transformation option from the transformation.
                   * @function Transformation#remove
                   * @param {string} name - the name of the option to remove
                   * @return {*} Returns the option that was removed or null if no option by that name was found. The type of the
                   *              returned value depends on the value.
                   */


                  this.remove = function (name) {
                    var temp;

                    switch (false) {
                      case trans[name] == null:
                        temp = trans[name];
                        delete trans[name];
                        return temp.origValue;

                      case this.otherOptions[name] == null:
                        temp = this.otherOptions[name];
                        delete this.otherOptions[name];
                        return temp;

                      default:
                        return null;}

                  };
                  /**
                   * Return an array of all the keys (option names) in the transformation.
                   * @return {Array<string>} the keys in snakeCase format
                   */


                  this.keys = function () {
                    var key;
                    return function () {
                      var results;
                      results = [];

                      for (key in trans) {
                        if (key != null) {
                          results.push(key.match(VAR_NAME_RE) ? key : snakeCase(key));
                        }
                      }

                      return results;
                    }().sort();
                  };
                  /**
                   * Returns a plain object representation of the transformation. Values are processed.
                   * @function Transformation#toPlainObject
                   * @return {Object} the transformation options as plain object
                   */


                  this.toPlainObject = function () {
                    var hash, key, list;
                    hash = {};

                    for (key in trans) {
                      hash[key] = trans[key].value();

                      if (isPlainObject_root_isPlainObject_default()(hash[key])) {
                        hash[key] = cloneDeep_root_cloneDeep_default()(hash[key]);
                      }
                    }

                    if (!isEmpty(this.chained)) {
                      list = this.chained.map(function (tr) {
                        return tr.toPlainObject();
                      });
                      list.push(hash);
                      hash = {
                        transformation: list };

                    }

                    return hash;
                  };
                  /**
                   * Complete the current transformation and chain to a new one.
                   * In the URL, transformations are chained together by slashes.
                   * @function Transformation#chain
                   * @return {Transformation} Returns this transformation for chaining
                   * @example
                   * var tr = cloudinary.Transformation.new();
                   * tr.width(10).crop('fit').chain().angle(15).serialize()
                   * // produces "c_fit,w_10/a_15"
                   */


                  this.chain = function () {
                    var names, tr;
                    names = Object.getOwnPropertyNames(trans);

                    if (names.length !== 0) {
                      tr = new this.constructor(this.toOptions(false));
                      this.resetTransformations();
                      this.chained.push(tr);
                    }

                    return this;
                  };

                  this.resetTransformations = function () {
                    trans = {};
                    return this;
                  };

                  this.otherOptions = {};
                  this.chained = [];
                  this.fromOptions(options);
                }
                /**
                 * Merge the provided options with own's options
                 * @param {Object} [options={}] key-value list of options
                 * @returns {Transformation} Returns this instance for chaining
                 */


                transformation_createClass(TransformationBase, [{
                  key: "fromOptions",
                  value: function fromOptions() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                    if (options instanceof TransformationBase) {
                      this.fromTransformation(options);
                    } else {
                      if (isString_root_isString_default()(options) || isArray_root_isArray_default()(options)) {
                        options = {
                          transformation: options };

                      }

                      options = cloneDeep_root_cloneDeep_default()(options, function (value) {
                        if (value instanceof TransformationBase || value instanceof Layer) {
                          return new value.clone();
                        }
                      }); // Handling of "if" statements precedes other options as it creates a chained transformation

                      if (options["if"]) {
                        this.set("if", options["if"]);
                        delete options["if"];
                      }

                      for (var key in options) {
                        var opt = options[key];

                        if (opt != null) {
                          if (key.match(VAR_NAME_RE)) {
                            if (key !== '$attr') {
                              this.set('variable', key, opt);
                            }
                          } else {
                            this.set(key, opt);
                          }
                        }
                      }
                    }

                    return this;
                  } },
                {
                  key: "fromTransformation",
                  value: function fromTransformation(other) {
                    var _this = this;

                    if (other instanceof TransformationBase) {
                      other.keys().forEach(function (key) {
                        return _this.set(key, other.get(key).origValue);
                      });
                    }

                    return this;
                  }
                  /**
                   * Set a parameter.
                   * The parameter name `key` is converted to
                   * @param {string} key - the name of the parameter
                   * @param {*} values - the value of the parameter
                   * @returns {Transformation} Returns this instance for chaining
                   */ },

                {
                  key: "set",
                  value: function set(key) {
                    var camelKey;
                    camelKey = camelCase(key);

                    for (var _len2 = arguments.length, values = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                      values[_key2 - 1] = arguments[_key2];
                    }

                    if (includes_root_includes_default()(transformation_Transformation.methods, camelKey)) {
                      this[camelKey].apply(this, values);
                    } else {
                      this.otherOptions[key] = values[0];
                    }

                    return this;
                  } },
                {
                  key: "hasLayer",
                  value: function hasLayer() {
                    return this.getValue("overlay") || this.getValue("underlay");
                  }
                  /**
                   * Generate a string representation of the transformation.
                   * @function Transformation#serialize
                   * @return {string} Returns the transformation as a string
                   */ },

                {
                  key: "serialize",
                  value: function serialize() {
                    var ifParam, j, len, paramList, ref, ref1, ref2, ref3, ref4, resultArray, t, transformationList, transformationString, transformations, value, variables, vars;
                    resultArray = this.chained.map(function (tr) {
                      return tr.serialize();
                    });
                    paramList = this.keys();
                    transformations = (ref = this.get("transformation")) != null ? ref.serialize() : void 0;
                    ifParam = (ref1 = this.get("if")) != null ? ref1.serialize() : void 0;
                    variables = processVar((ref2 = this.get("variables")) != null ? ref2.value() : void 0);
                    paramList = difference_root_difference_default()(paramList, ["transformation", "if", "variables"]);
                    vars = [];
                    transformationList = [];

                    for (j = 0, len = paramList.length; j < len; j++) {
                      t = paramList[j];

                      if (t.match(VAR_NAME_RE)) {
                        vars.push(t + "_" + expression.normalize((ref3 = this.get(t)) != null ? ref3.value() : void 0));
                      } else {
                        transformationList.push((ref4 = this.get(t)) != null ? ref4.serialize() : void 0);
                      }
                    }

                    switch (false) {
                      case !isString_root_isString_default()(transformations):
                        transformationList.push(transformations);
                        break;

                      case !isArray_root_isArray_default()(transformations):
                        resultArray = resultArray.concat(transformations);}


                    transformationList = function () {
                      var k, len1, results;
                      results = [];

                      for (k = 0, len1 = transformationList.length; k < len1; k++) {
                        value = transformationList[k];

                        if (isArray_root_isArray_default()(value) && !isEmpty(value) || !isArray_root_isArray_default()(value) && value) {
                          results.push(value);
                        }
                      }

                      return results;
                    }();

                    transformationList = vars.sort().concat(variables).concat(transformationList.sort());

                    if (ifParam === "if_end") {
                      transformationList.push(ifParam);
                    } else if (!isEmpty(ifParam)) {
                      transformationList.unshift(ifParam);
                    }

                    transformationString = compact_root_compact_default()(transformationList).join(this.param_separator);

                    if (!isEmpty(transformationString)) {
                      resultArray.push(transformationString);
                    }

                    return compact_root_compact_default()(resultArray).join(this.trans_separator);
                  }
                  /**
                   * Provide a list of all the valid transformation option names
                   * @function Transformation#listNames
                   * @private
                   * @return {Array<string>} a array of all the valid option names
                   */ },

                {
                  key: "toHtmlAttributes",
                  value:
                  /**
                   * Returns the attributes for an HTML tag.
                   * @function Cloudinary.toHtmlAttributes
                   * @return PlainObject
                   */
                  function toHtmlAttributes() {
                    var _this2 = this;

                    var attrName, height, options, ref2, ref3, value, width;
                    options = {};
                    var snakeCaseKey;
                    Object.keys(this.otherOptions).forEach(function (key) {
                      value = _this2.otherOptions[key];
                      snakeCaseKey = snakeCase(key);

                      if (!includes_root_includes_default()(transformation_Transformation.PARAM_NAMES, snakeCaseKey) && !includes_root_includes_default()(URL_KEYS, snakeCaseKey)) {
                        attrName = /^html_/.test(key) ? key.slice(5) : key;
                        options[attrName] = value;
                      }
                    }); // convert all "html_key" to "key" with the same value

                    this.keys().forEach(function (key) {
                      if (/^html_/.test(key)) {
                        options[camelCase(key.slice(5))] = _this2.getValue(key);
                      }
                    });

                    if (!(this.hasLayer() || this.getValue("angle") || includes_root_includes_default()(["fit", "limit", "lfill"], this.getValue("crop")))) {
                      width = (ref2 = this.get("width")) != null ? ref2.origValue : void 0;
                      height = (ref3 = this.get("height")) != null ? ref3.origValue : void 0;

                      if (parseFloat(width) >= 1.0) {
                        if (options.width == null) {
                          options.width = width;
                        }
                      }

                      if (parseFloat(height) >= 1.0) {
                        if (options.height == null) {
                          options.height = height;
                        }
                      }
                    }

                    return options;
                  } },
                {
                  key: "toHtml",
                  value:
                  /**
                   * Delegate to the parent (up the call chain) to produce HTML
                   * @function Transformation#toHtml
                   * @return {string} HTML representation of the parent if possible.
                   * @example
                   * tag = cloudinary.ImageTag.new("sample", {cloud_name: "demo"})
                   * // ImageTag {name: "img", publicId: "sample"}
                   * tag.toHtml()
                   * // <img src="http://res.cloudinary.com/demo/image/upload/sample">
                   * tag.transformation().crop("fit").width(300).toHtml()
                   * // <img src="http://res.cloudinary.com/demo/image/upload/c_fit,w_300/sample">
                   */
                  function toHtml() {
                    var ref;
                    return (ref = this.getParent()) != null ? typeof ref.toHtml === "function" ? ref.toHtml() : void 0 : void 0;
                  } },
                {
                  key: "toString",
                  value: function toString() {
                    return this.serialize();
                  } },
                {
                  key: "clone",
                  value: function clone() {
                    return new this.constructor(this.toOptions(true));
                  } }],
                [{
                  key: "listNames",
                  value: function listNames() {
                    return transformation_Transformation.methods;
                  } },
                {
                  key: "isValidParamName",
                  value: function isValidParamName(name) {
                    return transformation_Transformation.methods.indexOf(camelCase(name)) >= 0;
                  } }]);


                return TransformationBase;
              }();

              var VAR_NAME_RE = /^\$[a-zA-Z0-9]+$/;
              transformation_TransformationBase.prototype.trans_separator = '/';
              transformation_TransformationBase.prototype.param_separator = ',';

              function lastArgCallback(args) {
                var callback;
                callback = args != null ? args[args.length - 1] : void 0;

                if (isFunction_root_isFunction_default()(callback)) {
                  return callback;
                } else {
                  return void 0;
                }
              }

              function processVar(varArray) {
                var j, len, name, results, v;

                if (isArray_root_isArray_default()(varArray)) {
                  results = [];

                  for (j = 0, len = varArray.length; j < len; j++) {
                    var _varArray$j = transformation_slicedToArray(varArray[j], 2);

                    name = _varArray$j[0];
                    v = _varArray$j[1];
                    results.push("".concat(name, "_").concat(expression.normalize(v)));
                  }

                  return results;
                } else {
                  return varArray;
                }
              }

              function processCustomFunction(_ref) {
                var function_type = _ref.function_type,
                source = _ref.source;

                if (function_type === 'remote') {
                  return [function_type, btoa(source)].join(":");
                } else if (function_type === 'wasm') {
                  return [function_type, source].join(":");
                }
              }
              /**
               * Transformation Class methods.
               * This is a list of the parameters defined in Transformation.
               * Values are camelCased.
               * @const Transformation.methods
               * @private
               * @ignore
               * @type {Array<string>}
               */

              /**
               * Parameters that are filtered out before passing the options to an HTML tag.
               *
               * The list of parameters is a combination of `Transformation::methods` and `Configuration::CONFIG_PARAMS`
               * @const {Array<string>} Transformation.PARAM_NAMES
               * @private
               * @ignore
               * @see toHtmlAttributes
               */


              var transformation_Transformation = /*#__PURE__*/function (_TransformationBase) {
                transformation_inherits(Transformation, _TransformationBase);

                var _super = transformation_createSuper(Transformation);

                /**
                 * Represents a single transformation.
                 * @class Transformation
                 * @example
                 * t = new cloudinary.Transformation();
                 * t.angle(20).crop("scale").width("auto");
                 *
                 * // or
                 *
                 * t = new cloudinary.Transformation( {angle: 20, crop: "scale", width: "auto"});
                 * @see <a href="https://cloudinary.com/documentation/image_transformation_reference"
                 *  target="_blank">Available image transformations</a>
                 * @see <a href="https://cloudinary.com/documentation/video_transformation_reference"
                 *  target="_blank">Available video transformations</a>
                 */
                function Transformation(options) {
                  transformation_classCallCheck(this, Transformation);

                  return _super.call(this, options);
                }
                /**
                 * Convenience constructor
                 * @param {Object} options
                 * @return {Transformation}
                 * @example cl = cloudinary.Transformation.new( {angle: 20, crop: "scale", width: "auto"})
                 */


                transformation_createClass(Transformation, [{
                  key: "angle",
                  value:
                  /*
                    Transformation Parameters
                  */
                  function angle(value) {
                    return this.arrayParam(value, "angle", "a", ".", expression.normalize);
                  } },
                {
                  key: "audioCodec",
                  value: function audioCodec(value) {
                    return this.param(value, "audio_codec", "ac");
                  } },
                {
                  key: "audioFrequency",
                  value: function audioFrequency(value) {
                    return this.param(value, "audio_frequency", "af");
                  } },
                {
                  key: "aspectRatio",
                  value: function aspectRatio(value) {
                    return this.param(value, "aspect_ratio", "ar", expression.normalize);
                  } },
                {
                  key: "background",
                  value: function background(value) {
                    return this.param(value, "background", "b", parameters_Param.norm_color);
                  } },
                {
                  key: "bitRate",
                  value: function bitRate(value) {
                    return this.param(value, "bit_rate", "br");
                  } },
                {
                  key: "border",
                  value: function border(value) {
                    return this.param(value, "border", "bo", function (border) {
                      if (isPlainObject_root_isPlainObject_default()(border)) {
                        border = assign_root_assign_default()({}, {
                          color: "black",
                          width: 2 },
                        border);
                        return "".concat(border.width, "px_solid_").concat(parameters_Param.norm_color(border.color));
                      } else {
                        return border;
                      }
                    });
                  } },
                {
                  key: "color",
                  value: function color(value) {
                    return this.param(value, "color", "co", parameters_Param.norm_color);
                  } },
                {
                  key: "colorSpace",
                  value: function colorSpace(value) {
                    return this.param(value, "color_space", "cs");
                  } },
                {
                  key: "crop",
                  value: function crop(value) {
                    return this.param(value, "crop", "c");
                  } },
                {
                  key: "customFunction",
                  value: function customFunction(value) {
                    return this.param(value, "custom_function", "fn", function () {
                      return processCustomFunction(value);
                    });
                  } },
                {
                  key: "customPreFunction",
                  value: function customPreFunction(value) {
                    if (this.get('custom_function')) {
                      return;
                    }

                    return this.rawParam(value, "custom_function", "", function () {
                      value = processCustomFunction(value);
                      return value ? "fn_pre:".concat(value) : value;
                    });
                  } },
                {
                  key: "defaultImage",
                  value: function defaultImage(value) {
                    return this.param(value, "default_image", "d");
                  } },
                {
                  key: "delay",
                  value: function delay(value) {
                    return this.param(value, "delay", "dl");
                  } },
                {
                  key: "density",
                  value: function density(value) {
                    return this.param(value, "density", "dn");
                  } },
                {
                  key: "duration",
                  value: function duration(value) {
                    return this.rangeParam(value, "duration", "du");
                  } },
                {
                  key: "dpr",
                  value: function dpr(value) {
                    return this.param(value, "dpr", "dpr", function (dpr) {
                      dpr = dpr.toString();

                      if (dpr != null ? dpr.match(/^\d+$/) : void 0) {
                        return dpr + ".0";
                      } else {
                        return expression.normalize(dpr);
                      }
                    });
                  } },
                {
                  key: "effect",
                  value: function effect(value) {
                    return this.arrayParam(value, "effect", "e", ":", expression.normalize);
                  } },
                {
                  key: "else",
                  value: function _else() {
                    return this["if"]('else');
                  } },
                {
                  key: "endIf",
                  value: function endIf() {
                    return this["if"]('end');
                  } },
                {
                  key: "endOffset",
                  value: function endOffset(value) {
                    return this.rangeParam(value, "end_offset", "eo");
                  } },
                {
                  key: "fallbackContent",
                  value: function fallbackContent(value) {
                    return this.param(value, "fallback_content");
                  } },
                {
                  key: "fetchFormat",
                  value: function fetchFormat(value) {
                    return this.param(value, "fetch_format", "f");
                  } },
                {
                  key: "format",
                  value: function format(value) {
                    return this.param(value, "format");
                  } },
                {
                  key: "flags",
                  value: function flags(value) {
                    return this.arrayParam(value, "flags", "fl", ".");
                  } },
                {
                  key: "gravity",
                  value: function gravity(value) {
                    return this.param(value, "gravity", "g");
                  } },
                {
                  key: "fps",
                  value: function fps(value) {
                    return this.param(value, "fps", "fps", function (fps) {
                      if (isString_root_isString_default()(fps)) {
                        return fps;
                      } else if (isArray_root_isArray_default()(fps)) {
                        return fps.join("-");
                      } else {
                        return fps;
                      }
                    });
                  } },
                {
                  key: "height",
                  value: function height(value) {
                    var _this3 = this;

                    return this.param(value, "height", "h", function () {
                      if (_this3.getValue("crop") || _this3.getValue("overlay") || _this3.getValue("underlay")) {
                        return expression.normalize(value);
                      } else {
                        return null;
                      }
                    });
                  } },
                {
                  key: "htmlHeight",
                  value: function htmlHeight(value) {
                    return this.param(value, "html_height");
                  } },
                {
                  key: "htmlWidth",
                  value: function htmlWidth(value) {
                    return this.param(value, "html_width");
                  } },
                {
                  key: "if",
                  value: function _if() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                    var i, ifVal, j, trIf, trRest;

                    switch (value) {
                      case "else":
                        this.chain();
                        return this.param(value, "if", "if");

                      case "end":
                        this.chain();

                        for (i = j = this.chained.length - 1; j >= 0; i = j += -1) {
                          ifVal = this.chained[i].getValue("if");

                          if (ifVal === "end") {
                            break;
                          } else if (ifVal != null) {
                            trIf = Transformation["new"]()["if"](ifVal);
                            this.chained[i].remove("if");
                            trRest = this.chained[i];
                            this.chained[i] = Transformation["new"]().transformation([trIf, trRest]);

                            if (ifVal !== "else") {
                              break;
                            }
                          }
                        }

                        return this.param(value, "if", "if");

                      case "":
                        return condition["new"]().setParent(this);

                      default:
                        return this.param(value, "if", "if", function (value) {
                          return condition["new"](value).toString();
                        });}

                  } },
                {
                  key: "keyframeInterval",
                  value: function keyframeInterval(value) {
                    return this.param(value, "keyframe_interval", "ki");
                  } },
                {
                  key: "ocr",
                  value: function ocr(value) {
                    return this.param(value, "ocr", "ocr");
                  } },
                {
                  key: "offset",
                  value: function offset(value) {
                    var end_o, start_o;

                    var _ref2 = isFunction_root_isFunction_default()(value != null ? value.split : void 0) ? value.split('..') : isArray_root_isArray_default()(value) ? value : [null, null];

                    var _ref3 = transformation_slicedToArray(_ref2, 2);

                    start_o = _ref3[0];
                    end_o = _ref3[1];

                    if (start_o != null) {
                      this.startOffset(start_o);
                    }

                    if (end_o != null) {
                      return this.endOffset(end_o);
                    }
                  } },
                {
                  key: "opacity",
                  value: function opacity(value) {
                    return this.param(value, "opacity", "o", expression.normalize);
                  } },
                {
                  key: "overlay",
                  value: function overlay(value) {
                    return this.layerParam(value, "overlay", "l");
                  } },
                {
                  key: "page",
                  value: function page(value) {
                    return this.param(value, "page", "pg");
                  } },
                {
                  key: "poster",
                  value: function poster(value) {
                    return this.param(value, "poster");
                  } },
                {
                  key: "prefix",
                  value: function prefix(value) {
                    return this.param(value, "prefix", "p");
                  } },
                {
                  key: "quality",
                  value: function quality(value) {
                    return this.param(value, "quality", "q", expression.normalize);
                  } },
                {
                  key: "radius",
                  value: function radius(value) {
                    return this.arrayParam(value, "radius", "r", ":", expression.normalize);
                  } },
                {
                  key: "rawTransformation",
                  value: function rawTransformation(value) {
                    return this.rawParam(value, "raw_transformation");
                  } },
                {
                  key: "size",
                  value: function size(value) {
                    var height, width;

                    if (isFunction_root_isFunction_default()(value != null ? value.split : void 0)) {
                      var _value$split = value.split('x');

                      var _value$split2 = transformation_slicedToArray(_value$split, 2);

                      width = _value$split2[0];
                      height = _value$split2[1];
                      this.width(width);
                      return this.height(height);
                    }
                  } },
                {
                  key: "sourceTypes",
                  value: function sourceTypes(value) {
                    return this.param(value, "source_types");
                  } },
                {
                  key: "sourceTransformation",
                  value: function sourceTransformation(value) {
                    return this.param(value, "source_transformation");
                  } },
                {
                  key: "startOffset",
                  value: function startOffset(value) {
                    return this.rangeParam(value, "start_offset", "so");
                  } },
                {
                  key: "streamingProfile",
                  value: function streamingProfile(value) {
                    return this.param(value, "streaming_profile", "sp");
                  } },
                {
                  key: "transformation",
                  value: function transformation(value) {
                    return this.transformationParam(value, "transformation", "t");
                  } },
                {
                  key: "underlay",
                  value: function underlay(value) {
                    return this.layerParam(value, "underlay", "u");
                  } },
                {
                  key: "variable",
                  value: function variable(name, value) {
                    return this.param(value, name, name);
                  } },
                {
                  key: "variables",
                  value: function variables(values) {
                    return this.arrayParam(values, "variables");
                  } },
                {
                  key: "videoCodec",
                  value: function videoCodec(value) {
                    return this.param(value, "video_codec", "vc", parameters_Param.process_video_params);
                  } },
                {
                  key: "videoSampling",
                  value: function videoSampling(value) {
                    return this.param(value, "video_sampling", "vs");
                  } },
                {
                  key: "width",
                  value: function width(value) {
                    var _this4 = this;

                    return this.param(value, "width", "w", function () {
                      if (_this4.getValue("crop") || _this4.getValue("overlay") || _this4.getValue("underlay")) {
                        return expression.normalize(value);
                      } else {
                        return null;
                      }
                    });
                  } },
                {
                  key: "x",
                  value: function x(value) {
                    return this.param(value, "x", "x", expression.normalize);
                  } },
                {
                  key: "y",
                  value: function y(value) {
                    return this.param(value, "y", "y", expression.normalize);
                  } },
                {
                  key: "zoom",
                  value: function zoom(value) {
                    return this.param(value, "zoom", "z", expression.normalize);
                  } }],
                [{
                  key: "new",
                  value: function _new(options) {
                    return new Transformation(options);
                  } }]);


                return Transformation;
              }(transformation_TransformationBase);
              /**
               * Transformation Class methods.
               * This is a list of the parameters defined in Transformation.
               * Values are camelCased.
               */


              transformation_Transformation.methods = ["angle", "audioCodec", "audioFrequency", "aspectRatio", "background", "bitRate", "border", "color", "colorSpace", "crop", "customFunction", "customPreFunction", "defaultImage", "delay", "density", "duration", "dpr", "effect", "else", "endIf", "endOffset", "fallbackContent", "fetchFormat", "format", "flags", "gravity", "fps", "height", "htmlHeight", "htmlWidth", "if", "keyframeInterval", "ocr", "offset", "opacity", "overlay", "page", "poster", "prefix", "quality", "radius", "rawTransformation", "size", "sourceTypes", "sourceTransformation", "startOffset", "streamingProfile", "transformation", "underlay", "variable", "variables", "videoCodec", "videoSampling", "width", "x", "y", "zoom"];
              /**
               * Parameters that are filtered out before passing the options to an HTML tag.
               *
               * The list of parameters is a combination of `Transformation::methods` and `Configuration::CONFIG_PARAMS`
               */

              transformation_Transformation.PARAM_NAMES = transformation_Transformation.methods.map(snakeCase).concat(src_configuration.CONFIG_PARAMS);
              /* harmony default export */var src_transformation = transformation_Transformation;
              // CONCATENATED MODULE: ./src/tags/htmltag.js
              function htmltag_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function htmltag_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function htmltag_createClass(Constructor, protoProps, staticProps) {if (protoProps) htmltag_defineProperties(Constructor.prototype, protoProps);if (staticProps) htmltag_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              /**
               * Generic HTML tag
               * Depends on 'transformation', 'util'
               */


              /**
               * Represents an HTML (DOM) tag
               * @constructor HtmlTag
               * @param {string} name - the name of the tag
               * @param {string} [publicId]
               * @param {Object} options
               * @example tag = new HtmlTag( 'div', { 'width': 10})
               */

              var htmltag_HtmlTag = /*#__PURE__*/function () {
                function HtmlTag(name, publicId, options) {
                  htmltag_classCallCheck(this, HtmlTag);

                  var transformation;
                  this.name = name;
                  this.publicId = publicId;

                  if (options == null) {
                    if (isPlainObject_root_isPlainObject_default()(publicId)) {
                      options = publicId;
                      this.publicId = void 0;
                    } else {
                      options = {};
                    }
                  }

                  transformation = new src_transformation(options);
                  transformation.setParent(this);

                  this.transformation = function () {
                    return transformation;
                  };
                }
                /**
                 * Convenience constructor
                 * Creates a new instance of an HTML (DOM) tag
                 * @function HtmlTag.new
                 * @param {string} name - the name of the tag
                 * @param {string} [publicId]
                 * @param {Object} options
                 * @return {HtmlTag}
                 * @example tag = HtmlTag.new( 'div', { 'width': 10})
                 */


                htmltag_createClass(HtmlTag, [{
                  key: "htmlAttrs",
                  value:
                  /**
                   * combine key and value from the `attr` to generate an HTML tag attributes string.
                   * `Transformation::toHtmlTagOptions` is used to filter out transformation and configuration keys.
                   * @protected
                   * @param {Object} attrs
                   * @return {string} the attributes in the format `'key1="value1" key2="value2"'`
                   * @ignore
                   */
                  function htmlAttrs(attrs) {
                    var key, value;
                    return function () {
                      var results;
                      results = [];

                      for (key in attrs) {
                        value = escapeQuotes(attrs[key]);

                        if (value) {
                          results.push(htmltag_toAttribute(key, value));
                        }
                      }

                      return results;
                    }().sort().join(' ');
                  }
                  /**
                   * Get all options related to this tag.
                   * @function HtmlTag#getOptions
                   * @returns {Object} the options
                   *
                   */ },

                {
                  key: "getOptions",
                  value: function getOptions() {
                    return this.transformation().toOptions();
                  }
                  /**
                   * Get the value of option `name`
                   * @function HtmlTag#getOption
                   * @param {string} name - the name of the option
                   * @returns {*} Returns the value of the option
                   *
                   */ },

                {
                  key: "getOption",
                  value: function getOption(name) {
                    return this.transformation().getValue(name);
                  }
                  /**
                   * Get the attributes of the tag.
                   * @function HtmlTag#attributes
                   * @returns {Object} attributes
                   */ },

                {
                  key: "attributes",
                  value: function attributes() {
                    // The attributes are be computed from the options every time this method is invoked.
                    var htmlAttributes = this.transformation().toHtmlAttributes();
                    Object.keys(htmlAttributes).forEach(function (key) {
                      if (isPlainObject_root_isPlainObject_default()(htmlAttributes[key])) {
                        delete htmlAttributes[key];
                      }
                    });

                    if (htmlAttributes.attributes) {
                      // Currently HTML attributes are defined both at the top level and under 'attributes'
                      merge_root_merge_default()(htmlAttributes, htmlAttributes.attributes);
                      delete htmlAttributes.attributes;
                    }

                    return htmlAttributes;
                  }
                  /**
                   * Set a tag attribute named `name` to `value`
                   * @function HtmlTag#setAttr
                   * @param {string} name - the name of the attribute
                   * @param {string} value - the value of the attribute
                   */ },

                {
                  key: "setAttr",
                  value: function setAttr(name, value) {
                    this.transformation().set("html_".concat(name), value);
                    return this;
                  }
                  /**
                   * Get the value of the tag attribute `name`
                   * @function HtmlTag#getAttr
                   * @param {string} name - the name of the attribute
                   * @returns {*}
                   */ },

                {
                  key: "getAttr",
                  value: function getAttr(name) {
                    return this.attributes()["html_".concat(name)] || this.attributes()[name];
                  }
                  /**
                   * Remove the tag attributed named `name`
                   * @function HtmlTag#removeAttr
                   * @param {string} name - the name of the attribute
                   * @returns {*}
                   */ },

                {
                  key: "removeAttr",
                  value: function removeAttr(name) {
                    var ref;
                    return (ref = this.transformation().remove("html_".concat(name))) != null ? ref : this.transformation().remove(name);
                  }
                  /**
                   * @function HtmlTag#content
                   * @protected
                   * @ignore
                   */ },

                {
                  key: "content",
                  value: function content() {
                    return "";
                  }
                  /**
                   * @function HtmlTag#openTag
                   * @protected
                   * @ignore
                   */ },

                {
                  key: "openTag",
                  value: function openTag() {
                    var tag = "<" + this.name;
                    var htmlAttrs = this.htmlAttrs(this.attributes());

                    if (htmlAttrs && htmlAttrs.length > 0) {
                      tag += " " + htmlAttrs;
                    }

                    return tag + ">";
                  }
                  /**
                   * @function HtmlTag#closeTag
                   * @protected
                   * @ignore
                   */ },

                {
                  key: "closeTag",
                  value: function closeTag() {
                    return "</".concat(this.name, ">");
                  }
                  /**
                   * Generates an HTML representation of the tag.
                   * @function HtmlTag#toHtml
                   * @returns {string} Returns HTML in string format
                   */ },

                {
                  key: "toHtml",
                  value: function toHtml() {
                    return this.openTag() + this.content() + this.closeTag();
                  }
                  /**
                   * Creates a DOM object representing the tag.
                   * @function HtmlTag#toDOM
                   * @returns {Element}
                   */ },

                {
                  key: "toDOM",
                  value: function toDOM() {
                    var element, name, ref, value;

                    if (!isFunction_root_isFunction_default()(typeof document !== "undefined" && document !== null ? document.createElement : void 0)) {
                      throw "Can't create DOM if document is not present!";
                    }

                    element = document.createElement(this.name);
                    ref = this.attributes();

                    for (name in ref) {
                      value = ref[name];
                      element.setAttribute(name, value);
                    }

                    return element;
                  } }],
                [{
                  key: "new",
                  value: function _new(name, publicId, options) {
                    return new this(name, publicId, options);
                  } },
                {
                  key: "isResponsive",
                  value: function isResponsive(tag, responsiveClass) {
                    var dataSrc;
                    dataSrc = lodash_getData(tag, 'src-cache') || lodash_getData(tag, 'src');
                    return lodash_hasClass(tag, responsiveClass) && /\bw_auto\b/.exec(dataSrc);
                  } }]);


                return HtmlTag;
              }();
              /**
               * Represent the given key and value as an HTML attribute.
               * @function toAttribute
               * @protected
               * @param {string} key - attribute name
               * @param {*|boolean} value - the value of the attribute. If the value is boolean `true`, return the key only.
               * @returns {string} the attribute
               *
               */

              function htmltag_toAttribute(key, value) {
                if (!value) {
                  return void 0;
                } else if (value === true) {
                  return key;
                } else {
                  return "".concat(key, "=\"").concat(value, "\"");
                }
              }
              /**
               * If given value is a string, replaces quotes with character entities (&#34;, &#39;)
               * @param value - value to change
               * @returns {*} changed value
               */


              function escapeQuotes(value) {
                return isString_root_isString_default()(value) ? value.replace('"', '&#34;').replace("'", '&#39;') : value;
              }

              /* harmony default export */var htmltag = htmltag_HtmlTag;
              // CONCATENATED MODULE: ./src/url.js
              var _excluded = ["placeholder", "accessibility"];

              function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}

              function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}







              /**
               * Adds protocol, host, pathname prefixes to given string
               * @param str
               * @returns {string}
               */

              function makeUrl(str) {
                var prefix = document.location.protocol + '//' + document.location.host;

                if (str[0] === '?') {
                  prefix += document.location.pathname;
                } else if (str[0] !== '/') {
                  prefix += document.location.pathname.replace(/\/[^\/]*$/, '/');
                }

                return prefix + str;
              }
              /**
               * Check is given string is a url
               * @param str
               * @returns {boolean}
               */


              function isUrl(str) {
                return str ? !!str.match(/^https?:\//) : false;
              } // Produce a number between 1 and 5 to be used for cdn sub domains designation


              function cdnSubdomainNumber(publicId) {
                return src_crc32(publicId) % 5 + 1;
              }
              /**
               * Removes signature from options and returns the signature
               * Makes sure signature is empty or of this format: s--signature--
               * @param {object} options
               * @returns {string} the formatted signature
               */


              function handleSignature(options) {
                var signature = options.signature;
                var isFormatted = !signature || signature.indexOf('s--') === 0 && signature.substr(-2) === '--';
                delete options.signature;
                return isFormatted ? signature : "s--".concat(signature, "--");
              }
              /**
               * Create the URL prefix for Cloudinary resources.
               * @param {string} publicId the resource public ID
               * @param {object} options additional options
               * @param {string} options.cloud_name - the cloud name.
               * @param {boolean} [options.cdn_subdomain=false] - Whether to automatically build URLs with
               *  multiple CDN sub-domains.
               * @param {string} [options.private_cdn] - Boolean (default: false). Should be set to true for Advanced plan's users
               *  that have a private CDN distribution.
               * @param {string} [options.protocol="http://"] - the URI protocol to use. If options.secure is true,
               *  the value is overridden to "https://"
               * @param {string} [options.secure_distribution] - The domain name of the CDN distribution to use for building HTTPS URLs.
               *  Relevant only for Advanced plan's users that have a private CDN distribution.
               * @param {string} [options.cname] - Custom domain name to use for building HTTP URLs.
               *  Relevant only for Advanced plan's users that have a private CDN distribution and a custom CNAME.
               * @param {boolean} [options.secure_cdn_subdomain=true] - When options.secure is true and this parameter is false,
               *  the subdomain is set to "res".
               * @param {boolean} [options.secure=false] - Force HTTPS URLs of images even if embedded in non-secure HTTP pages.
               *  When this value is true, options.secure_distribution will be used as host if provided, and options.protocol is set
               *  to "https://".
               * @returns {string} the URL prefix for the resource.
               * @private
               */


              function handlePrefix(publicId, options) {
                if (options.cloud_name && options.cloud_name[0] === '/') {
                  return '/res' + options.cloud_name;
                } // defaults


                var protocol = "http://";
                var cdnPart = "";
                var subdomain = "res";
                var host = ".cloudinary.com";
                var path = "/" + options.cloud_name; // modifications

                if (options.protocol) {
                  protocol = options.protocol + '//';
                }

                if (options.private_cdn) {
                  cdnPart = options.cloud_name + "-";
                  path = "";
                }

                if (options.cdn_subdomain) {
                  subdomain = "res-" + cdnSubdomainNumber(publicId);
                }

                if (options.secure) {
                  protocol = "https://";

                  if (options.secure_cdn_subdomain === false) {
                    subdomain = "res";
                  }

                  if (options.secure_distribution != null && options.secure_distribution !== OLD_AKAMAI_SHARED_CDN && options.secure_distribution !== SHARED_CDN) {
                    cdnPart = "";
                    subdomain = "";
                    host = options.secure_distribution;
                  }
                } else if (options.cname) {
                  protocol = "http://";
                  cdnPart = "";
                  subdomain = options.cdn_subdomain ? 'a' + (src_crc32(publicId) % 5 + 1) + '.' : '';
                  host = options.cname;
                }

                return [protocol, cdnPart, subdomain, host, path].join("");
              }
              /**
               * Return the resource type and action type based on the given configuration
               * @function Cloudinary#handleResourceType
               * @param {Object|string} resource_type
               * @param {string} [type='upload']
               * @param {string} [url_suffix]
               * @param {boolean} [use_root_path]
               * @param {boolean} [shorten]
               * @returns {string} resource_type/type
               * @ignore
               */


              function handleResourceType(_ref) {
                var _ref$resource_type = _ref.resource_type,
                resource_type = _ref$resource_type === void 0 ? "image" : _ref$resource_type,
                _ref$type = _ref.type,
                type = _ref$type === void 0 ? "upload" : _ref$type,
                url_suffix = _ref.url_suffix,
                use_root_path = _ref.use_root_path,
                shorten = _ref.shorten;
                var options,
                resourceType = resource_type;

                if (isPlainObject_root_isPlainObject_default()(resourceType)) {
                  options = resourceType;
                  resourceType = options.resource_type;
                  type = options.type;
                  shorten = options.shorten;
                }

                if (type == null) {
                  type = 'upload';
                }

                if (url_suffix != null) {
                  resourceType = SEO_TYPES["".concat(resourceType, "/").concat(type)];
                  type = null;

                  if (resourceType == null) {
                    throw new Error("URL Suffix only supported for ".concat(Object.keys(SEO_TYPES).join(', ')));
                  }
                }

                if (use_root_path) {
                  if (resourceType === 'image' && type === 'upload' || resourceType === "images") {
                    resourceType = null;
                    type = null;
                  } else {
                    throw new Error("Root path only supported for image/upload");
                  }
                }

                if (shorten && resourceType === 'image' && type === 'upload') {
                  resourceType = 'iu';
                  type = null;
                }

                return [resourceType, type].join("/");
              }
              /**
               * Encode publicId
               * @param publicId
               * @returns {string} encoded publicId
               */


              function encodePublicId(publicId) {
                return encodeURIComponent(publicId).replace(/%3A/g, ':').replace(/%2F/g, '/');
              }
              /**
               * Encode and format publicId
               * @param publicId
               * @param options
               * @returns {string} publicId
               */


              function formatPublicId(publicId, options) {
                if (isUrl(publicId)) {
                  publicId = encodePublicId(publicId);
                } else {
                  try {
                    // Make sure publicId is URI encoded.
                    publicId = decodeURIComponent(publicId);
                  } catch (error) {}

                  publicId = encodePublicId(publicId);

                  if (options.url_suffix) {
                    publicId = publicId + '/' + options.url_suffix;
                  }

                  if (options.format) {
                    if (!options.trust_public_id) {
                      publicId = publicId.replace(/\.(jpg|png|gif|webp)$/, '');
                    }

                    publicId = publicId + '.' + options.format;
                  }
                }

                return publicId;
              }
              /**
               * Get any error with url options
               * @param options
               * @returns {string} if error, otherwise return undefined
               */


              function validate(options) {
                var cloud_name = options.cloud_name,
                url_suffix = options.url_suffix;

                if (!cloud_name) {
                  return 'Unknown cloud_name';
                }

                if (url_suffix && url_suffix.match(/[\.\/]/)) {
                  return 'url_suffix should not include . or /';
                }
              }
              /**
               * Get version part of the url
               * @param publicId
               * @param options
               * @returns {string}
               */


              function handleVersion(publicId, options) {
                // force_version param means to make sure there is a version in the url (Default is true)
                var isForceVersion = options.force_version || typeof options.force_version === 'undefined'; // Is version included in publicId or in options, or publicId is a url (doesn't need version)

                var isVersionExist = publicId.indexOf('/') < 0 || publicId.match(/^v[0-9]+/) || isUrl(publicId) || options.version;

                if (isForceVersion && !isVersionExist) {
                  options.version = 1;
                }

                return options.version ? "v".concat(options.version) : '';
              }
              /**
               * Get final transformation component for url string
               * @param options
               * @returns {string}
               */


              function handleTransformation(options) {
                var _ref2 = options || {},
                placeholder = _ref2.placeholder,
                accessibility = _ref2.accessibility,
                otherOptions = _objectWithoutProperties(_ref2, _excluded);

                var result = new src_transformation(otherOptions); // Append accessibility transformations

                if (accessibility && ACCESSIBILITY_MODES[accessibility]) {
                  result.chain().effect(ACCESSIBILITY_MODES[accessibility]);
                } // Append placeholder transformations


                if (placeholder) {
                  if (placeholder === "predominant-color" && result.getValue('width') && result.getValue('height')) {
                    placeholder += '-pixel';
                  }

                  var placeholderTransformations = PLACEHOLDER_IMAGE_MODES[placeholder] || PLACEHOLDER_IMAGE_MODES.blur;
                  placeholderTransformations.forEach(function (t) {
                    return result.chain().transformation(t);
                  });
                }

                return result.serialize();
              }
              /**
               * If type is 'fetch', update publicId to be a url
               * @param publicId
               * @param type
               * @returns {string}
               */


              function preparePublicId(publicId, _ref3) {
                var type = _ref3.type;
                return !isUrl(publicId) && type === 'fetch' ? makeUrl(publicId) : publicId;
              }
              /**
               * Generate url string
               * @param publicId
               * @param options
               * @returns {string} final url
               */


              function urlString(publicId, options) {
                if (isUrl(publicId) && (options.type === 'upload' || options.type === 'asset')) {
                  return publicId;
                }

                var version = handleVersion(publicId, options);
                var transformationString = handleTransformation(options);
                var prefix = handlePrefix(publicId, options);
                var signature = handleSignature(options);
                var resourceType = handleResourceType(options);
                publicId = formatPublicId(publicId, options);
                return compact_root_compact_default()([prefix, resourceType, signature, transformationString, version, publicId]).join('/').replace(/([^:])\/+/g, '$1/') // replace '///' with '//'
                .replace(' ', '%20');
              }
              /**
               * Merge options and config with defaults
               * update options fetch_format according to 'type' param
               * @param options
               * @param config
               * @returns {*} updated options
               */


              function prepareOptions(options, config) {
                if (options instanceof src_transformation) {
                  options = options.toOptions();
                }

                options = defaults({}, options, config, DEFAULT_IMAGE_PARAMS);

                if (options.type === 'fetch') {
                  options.fetch_format = options.fetch_format || options.format;
                }

                return options;
              }
              /**
               * Generates a URL for any asset in your Media library.
               * @function url
               * @ignore
               * @param {string} publicId - The public ID of the media asset.
               * @param {Object} [options={}] - The {@link Transformation} parameters to include in the URL.
               * @param {object} [config={}] - URL configuration parameters
               * @param {type} [options.type='upload'] - The asset's storage type.
               *  For details on all fetch types, see
               * <a href="https://cloudinary.com/documentation/image_transformations#fetching_images_from_remote_locations"
               *  target="_blank">Fetch types</a>.
               * @param {Object} [options.resource_type='image'] - The type of asset. <p>Possible values:<br/>
               *  - `image`<br/>
               *  - `video`<br/>
               *  - `raw`
               * @param {signature} [options.signature='s--12345678--'] - The signature component of a
               *  signed delivery URL of the format: /s--SIGNATURE--/.
               *  For details on signatures, see
               * <a href="https://cloudinary.com/documentation/signatures" target="_blank">Signatures</a>.
               * @return {string} The media asset URL.
               * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
               *  Available image transformations</a>
               * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
               *  Available video transformations</a>
               */


              function url_url(publicId) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                if (!publicId) {
                  return publicId;
                }

                options = prepareOptions(options, config);
                publicId = preparePublicId(publicId, options);
                var error = validate(options);

                if (error) {
                  throw error;
                }

                var resultUrl = urlString(publicId, options);

                if (options.urlAnalytics) {
                  var analyticsOptions = getAnalyticsOptions(options);
                  var sdkAnalyticsSignature = getSDKAnalyticsSignature(analyticsOptions); // url might already have a '?' query param

                  var appender = '?';

                  if (resultUrl.indexOf('?') >= 0) {
                    appender = '&';
                  }

                  resultUrl = "".concat(resultUrl).concat(appender, "_a=").concat(sdkAnalyticsSignature);
                }

                if (options.auth_token) {
                  var _appender = resultUrl.indexOf('?') >= 0 ? '&' : '?';

                  resultUrl = "".concat(resultUrl).concat(_appender, "__cld_token__=").concat(options.auth_token);
                }

                return resultUrl;
              }
              // CONCATENATED MODULE: ./src/util/generateBreakpoints.js
              function generateBreakpoints_slicedToArray(arr, i) {return generateBreakpoints_arrayWithHoles(arr) || generateBreakpoints_iterableToArrayLimit(arr, i) || generateBreakpoints_unsupportedIterableToArray(arr, i) || generateBreakpoints_nonIterableRest();}

              function generateBreakpoints_nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

              function generateBreakpoints_unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return generateBreakpoints_arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return generateBreakpoints_arrayLikeToArray(o, minLen);}

              function generateBreakpoints_arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}

              function generateBreakpoints_iterableToArrayLimit(arr, i) {var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];if (_i == null) return;var _arr = [];var _n = true;var _d = false;var _s, _e;try {for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}

              function generateBreakpoints_arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}

              /**
               * Helper function. Gets or populates srcset breakpoints using provided parameters
               * Either the breakpoints or min_width, max_width, max_images must be provided.
               *
               * @private
               * @param {srcset} srcset Options with either `breakpoints` or `min_width`, `max_width`, and `max_images`
               *
               * @return {number[]} Array of breakpoints
               *
               */
              function generateBreakpoints(srcset) {
                var breakpoints = srcset.breakpoints || [];

                if (breakpoints.length) {
                  return breakpoints;
                }

                var _map = [srcset.min_width, srcset.max_width, srcset.max_images].map(Number),
                _map2 = generateBreakpoints_slicedToArray(_map, 3),
                min_width = _map2[0],
                max_width = _map2[1],
                max_images = _map2[2];

                if ([min_width, max_width, max_images].some(isNaN)) {
                  throw 'Either (min_width, max_width, max_images) ' + 'or breakpoints must be provided to the image srcset attribute';
                }

                if (min_width > max_width) {
                  throw 'min_width must be less than max_width';
                }

                if (max_images <= 0) {
                  throw 'max_images must be a positive integer';
                } else if (max_images === 1) {
                  min_width = max_width;
                }

                var stepSize = Math.ceil((max_width - min_width) / Math.max(max_images - 1, 1));

                for (var current = min_width; current < max_width; current += stepSize) {
                  breakpoints.push(current);
                }

                breakpoints.push(max_width);
                return breakpoints;
              }
              // CONCATENATED MODULE: ./src/util/srcsetUtils.js

              var srcsetUtils_isEmpty = isEmpty;



              /**
               * Options used to generate the srcset attribute.
               * @typedef {object} srcset
               * @property {(number[]|string[])}   [breakpoints] An array of breakpoints.
               * @property {number}                [min_width]   Minimal width of the srcset images.
               * @property {number}                [max_width]   Maximal width of the srcset images.
               * @property {number}                [max_images]  Number of srcset images to generate.
               * @property {object|string}         [transformation] The transformation to use in the srcset urls.
               * @property {boolean}               [sizes] Whether to calculate and add the sizes attribute.
               */

              /**
               * Helper function. Generates a single srcset item url
               *
               * @private
               * @param {string} public_id  Public ID of the resource.
               * @param {number} width      Width in pixels of the srcset item.
               * @param {object|string} transformation
               * @param {object} options    Additional options.
               *
               * @return {string} Resulting URL of the item
               */

              function scaledUrl(public_id, width, transformation) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var configParams = extractUrlParams(options);
                transformation = transformation || options;
                configParams.raw_transformation = new src_transformation([merge_root_merge_default.a({}, transformation), {
                  crop: 'scale',
                  width: width }]).
                toString();
                return url_url(public_id, configParams);
              }
              /**
               * If cache is enabled, get the breakpoints from the cache. If the values were not found in the cache,
               * or cache is not enabled, generate the values.
               * @param {srcset} srcset The srcset configuration parameters
               * @param {string} public_id
               * @param {object} options
               * @return {*|Array}
               */

              function getOrGenerateBreakpoints(public_id) {
                var srcset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return generateBreakpoints(srcset);
              }
              /**
               * Helper function. Generates srcset attribute value of the HTML img tag
               * @private
               *
               * @param {string} public_id  Public ID of the resource
               * @param {number[]} breakpoints An array of breakpoints (in pixels)
               * @param {object} transformation The transformation
               * @param {object} options Includes html tag options, transformation options
               * @return {string} Resulting srcset attribute value
               */

              function generateSrcsetAttribute(public_id, breakpoints, transformation, options) {
                options = cloneDeep_root_cloneDeep_default.a(options);
                patchFetchFormat(options);
                return breakpoints.map(function (width) {
                  return "".concat(scaledUrl(public_id, width, transformation, options), " ").concat(width, "w");
                }).join(', ');
              }
              /**
               * Helper function. Generates sizes attribute value of the HTML img tag
               * @private
               * @param {number[]} breakpoints An array of breakpoints.
               * @return {string} Resulting sizes attribute value
               */

              function generateSizesAttribute(breakpoints) {
                if (breakpoints == null) {
                  return '';
                }

                return breakpoints.map(function (width) {
                  return "(max-width: ".concat(width, "px) ").concat(width, "px");
                }).join(', ');
              }
              /**
               * Helper function. Generates srcset and sizes attributes of the image tag
               *
               * Generated attributes are added to attributes argument
               *
               * @private
               * @param {string}    publicId  The public ID of the resource
               * @param {object}    attributes Existing HTML attributes.
               * @param {srcset}    srcsetData
               * @param {object}    options    Additional options.
               *
               * @return array The responsive attributes
               */

              function generateImageResponsiveAttributes(publicId) {
                var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var srcsetData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                // Create both srcset and sizes here to avoid fetching breakpoints twice
                var responsiveAttributes = {};

                if (srcsetUtils_isEmpty(srcsetData)) {
                  return responsiveAttributes;
                }

                var generateSizes = !attributes.sizes && srcsetData.sizes === true;
                var generateSrcset = !attributes.srcset;

                if (generateSrcset || generateSizes) {
                  var breakpoints = getOrGenerateBreakpoints(publicId, srcsetData, options);

                  if (generateSrcset) {
                    var transformation = srcsetData.transformation;
                    var srcsetAttr = generateSrcsetAttribute(publicId, breakpoints, transformation, options);

                    if (!srcsetUtils_isEmpty(srcsetAttr)) {
                      responsiveAttributes.srcset = srcsetAttr;
                    }
                  }

                  if (generateSizes) {
                    var sizesAttr = generateSizesAttribute(breakpoints);

                    if (!srcsetUtils_isEmpty(sizesAttr)) {
                      responsiveAttributes.sizes = sizesAttr;
                    }
                  }
                }

                return responsiveAttributes;
              }
              /**
               * Generate a media query
               *
               * @private
               * @param {object} options configuration options
               * @param {number|string} options.min_width
               * @param {number|string} options.max_width
               * @return {string} a media query string
               */

              function generateMediaAttr(options) {
                var mediaQuery = [];

                if (options != null) {
                  if (options.min_width != null) {
                    mediaQuery.push("(min-width: ".concat(options.min_width, "px)"));
                  }

                  if (options.max_width != null) {
                    mediaQuery.push("(max-width: ".concat(options.max_width, "px)"));
                  }
                }

                return mediaQuery.join(' and ');
              }
              // CONCATENATED MODULE: ./src/tags/imagetag.js
              function imagetag_typeof(obj) {"@babel/helpers - typeof";return imagetag_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, imagetag_typeof(obj);}

              function imagetag_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function imagetag_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function imagetag_createClass(Constructor, protoProps, staticProps) {if (protoProps) imagetag_defineProperties(Constructor.prototype, protoProps);if (staticProps) imagetag_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              function imagetag_get() {if (typeof Reflect !== "undefined" && Reflect.get) {imagetag_get = Reflect.get.bind();} else {imagetag_get = function _get(target, property, receiver) {var base = imagetag_superPropBase(target, property);if (!base) return;var desc = Object.getOwnPropertyDescriptor(base, property);if (desc.get) {return desc.get.call(arguments.length < 3 ? target : receiver);}return desc.value;};}return imagetag_get.apply(this, arguments);}

              function imagetag_superPropBase(object, property) {while (!Object.prototype.hasOwnProperty.call(object, property)) {object = imagetag_getPrototypeOf(object);if (object === null) break;}return object;}

              function imagetag_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) imagetag_setPrototypeOf(subClass, superClass);}

              function imagetag_setPrototypeOf(o, p) {imagetag_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return imagetag_setPrototypeOf(o, p);}

              function imagetag_createSuper(Derived) {var hasNativeReflectConstruct = imagetag_isNativeReflectConstruct();return function _createSuperInternal() {var Super = imagetag_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = imagetag_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return imagetag_possibleConstructorReturn(this, result);};}

              function imagetag_possibleConstructorReturn(self, call) {if (call && (imagetag_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return imagetag_assertThisInitialized(self);}

              function imagetag_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

              function imagetag_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

              function imagetag_getPrototypeOf(o) {imagetag_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return imagetag_getPrototypeOf(o);}

              /**
               * Image Tag
               * Depends on 'tags/htmltag', 'cloudinary'
               */




              /**
               * Creates an HTML (DOM) Image tag using Cloudinary as the source.
               * @constructor ImageTag
               * @extends HtmlTag
               * @param {string} [publicId]
               * @param {Object} [options]
               */

              var imagetag_ImageTag = /*#__PURE__*/function (_HtmlTag) {
                imagetag_inherits(ImageTag, _HtmlTag);

                var _super = imagetag_createSuper(ImageTag);

                function ImageTag(publicId) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                  imagetag_classCallCheck(this, ImageTag);

                  return _super.call(this, "img", publicId, options);
                }
                /** @override */


                imagetag_createClass(ImageTag, [{
                  key: "closeTag",
                  value: function closeTag() {
                    return "";
                  }
                  /** @override */ },

                {
                  key: "attributes",
                  value: function attributes() {
                    var attr, options, srcAttribute;
                    attr = imagetag_get(imagetag_getPrototypeOf(ImageTag.prototype), "attributes", this).call(this) || {};
                    options = this.getOptions();
                    var attributes = this.getOption('attributes') || {};
                    var srcsetParam = this.getOption('srcset') || attributes.srcset;
                    var responsiveAttributes = {};

                    if (isString_root_isString_default()(srcsetParam)) {
                      responsiveAttributes.srcset = srcsetParam;
                    } else {
                      responsiveAttributes = generateImageResponsiveAttributes(this.publicId, attributes, srcsetParam, options);
                    }

                    if (!isEmpty(responsiveAttributes)) {
                      delete attr.width;
                      delete attr.height;
                    }

                    merge_root_merge_default()(attr, responsiveAttributes);
                    srcAttribute = options.responsive && !options.client_hints ? 'data-src' : 'src';

                    if (attr[srcAttribute] == null) {
                      attr[srcAttribute] = url_url(this.publicId, this.getOptions());
                    }

                    return attr;
                  } }]);


                return ImageTag;
              }(htmltag);
              /* harmony default export */var imagetag = imagetag_ImageTag;
              // CONCATENATED MODULE: ./src/tags/sourcetag.js
              function sourcetag_typeof(obj) {"@babel/helpers - typeof";return sourcetag_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, sourcetag_typeof(obj);}

              function sourcetag_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function sourcetag_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function sourcetag_createClass(Constructor, protoProps, staticProps) {if (protoProps) sourcetag_defineProperties(Constructor.prototype, protoProps);if (staticProps) sourcetag_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              function sourcetag_get() {if (typeof Reflect !== "undefined" && Reflect.get) {sourcetag_get = Reflect.get.bind();} else {sourcetag_get = function _get(target, property, receiver) {var base = sourcetag_superPropBase(target, property);if (!base) return;var desc = Object.getOwnPropertyDescriptor(base, property);if (desc.get) {return desc.get.call(arguments.length < 3 ? target : receiver);}return desc.value;};}return sourcetag_get.apply(this, arguments);}

              function sourcetag_superPropBase(object, property) {while (!Object.prototype.hasOwnProperty.call(object, property)) {object = sourcetag_getPrototypeOf(object);if (object === null) break;}return object;}

              function sourcetag_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) sourcetag_setPrototypeOf(subClass, superClass);}

              function sourcetag_setPrototypeOf(o, p) {sourcetag_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return sourcetag_setPrototypeOf(o, p);}

              function sourcetag_createSuper(Derived) {var hasNativeReflectConstruct = sourcetag_isNativeReflectConstruct();return function _createSuperInternal() {var Super = sourcetag_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = sourcetag_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return sourcetag_possibleConstructorReturn(this, result);};}

              function sourcetag_possibleConstructorReturn(self, call) {if (call && (sourcetag_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return sourcetag_assertThisInitialized(self);}

              function sourcetag_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

              function sourcetag_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

              function sourcetag_getPrototypeOf(o) {sourcetag_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return sourcetag_getPrototypeOf(o);}

              /**
               * Image Tag
               * Depends on 'tags/htmltag', 'cloudinary'
               */




              /**
               * Creates an HTML (DOM) Image tag using Cloudinary as the source.
               * @constructor SourceTag
               * @extends HtmlTag
               * @param {string} [publicId]
               * @param {Object} [options]
               */

              var sourcetag_SourceTag = /*#__PURE__*/function (_HtmlTag) {
                sourcetag_inherits(SourceTag, _HtmlTag);

                var _super = sourcetag_createSuper(SourceTag);

                function SourceTag(publicId) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                  sourcetag_classCallCheck(this, SourceTag);

                  return _super.call(this, "source", publicId, options);
                }
                /** @override */


                sourcetag_createClass(SourceTag, [{
                  key: "closeTag",
                  value: function closeTag() {
                    return "";
                  }
                  /** @override */ },

                {
                  key: "attributes",
                  value: function attributes() {
                    var srcsetParam = this.getOption('srcset');
                    var attr = sourcetag_get(sourcetag_getPrototypeOf(SourceTag.prototype), "attributes", this).call(this) || {};
                    var options = this.getOptions();
                    merge_root_merge_default()(attr, generateImageResponsiveAttributes(this.publicId, attr, srcsetParam, options));

                    if (!attr.srcset) {
                      attr.srcset = url_url(this.publicId, options);
                    }

                    if (!attr.media && options.media) {
                      attr.media = generateMediaAttr(options.media);
                    }

                    return attr;
                  } }]);


                return SourceTag;
              }(htmltag);
              /* harmony default export */var sourcetag = sourcetag_SourceTag;
              // CONCATENATED MODULE: ./src/tags/picturetag.js
              function picturetag_typeof(obj) {"@babel/helpers - typeof";return picturetag_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, picturetag_typeof(obj);}

              function picturetag_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function picturetag_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function picturetag_createClass(Constructor, protoProps, staticProps) {if (protoProps) picturetag_defineProperties(Constructor.prototype, protoProps);if (staticProps) picturetag_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              function picturetag_get() {if (typeof Reflect !== "undefined" && Reflect.get) {picturetag_get = Reflect.get.bind();} else {picturetag_get = function _get(target, property, receiver) {var base = picturetag_superPropBase(target, property);if (!base) return;var desc = Object.getOwnPropertyDescriptor(base, property);if (desc.get) {return desc.get.call(arguments.length < 3 ? target : receiver);}return desc.value;};}return picturetag_get.apply(this, arguments);}

              function picturetag_superPropBase(object, property) {while (!Object.prototype.hasOwnProperty.call(object, property)) {object = picturetag_getPrototypeOf(object);if (object === null) break;}return object;}

              function picturetag_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) picturetag_setPrototypeOf(subClass, superClass);}

              function picturetag_setPrototypeOf(o, p) {picturetag_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return picturetag_setPrototypeOf(o, p);}

              function picturetag_createSuper(Derived) {var hasNativeReflectConstruct = picturetag_isNativeReflectConstruct();return function _createSuperInternal() {var Super = picturetag_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = picturetag_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return picturetag_possibleConstructorReturn(this, result);};}

              function picturetag_possibleConstructorReturn(self, call) {if (call && (picturetag_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return picturetag_assertThisInitialized(self);}

              function picturetag_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

              function picturetag_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

              function picturetag_getPrototypeOf(o) {picturetag_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return picturetag_getPrototypeOf(o);}







              var picturetag_PictureTag = /*#__PURE__*/function (_HtmlTag) {
                picturetag_inherits(PictureTag, _HtmlTag);

                var _super = picturetag_createSuper(PictureTag);

                function PictureTag(publicId) {
                  var _this;

                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                  var sources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

                  picturetag_classCallCheck(this, PictureTag);

                  _this = _super.call(this, 'picture', publicId, options);
                  _this.widthList = sources;
                  return _this;
                }
                /** @override */


                picturetag_createClass(PictureTag, [{
                  key: "content",
                  value: function content() {
                    var _this2 = this;

                    return this.widthList.map(function (_ref) {
                      var min_width = _ref.min_width,
                      max_width = _ref.max_width,
                      transformation = _ref.transformation;

                      var options = _this2.getOptions();

                      var sourceTransformation = new src_transformation(options);
                      sourceTransformation.chain().fromOptions(typeof transformation === 'string' ? {
                        raw_transformation: transformation } :
                      transformation);
                      options = extractUrlParams(options);
                      options.media = {
                        min_width: min_width,
                        max_width: max_width };

                      options.transformation = sourceTransformation;
                      return new sourcetag(_this2.publicId, options).toHtml();
                    }).join('') + new imagetag(this.publicId, this.getOptions()).toHtml();
                  }
                  /** @override */ },

                {
                  key: "attributes",
                  value: function attributes() {
                    var attr = picturetag_get(picturetag_getPrototypeOf(PictureTag.prototype), "attributes", this).call(this);

                    delete attr.width;
                    delete attr.height;
                    return attr;
                  }
                  /** @override */ },

                {
                  key: "closeTag",
                  value: function closeTag() {
                    return "</" + this.name + ">";
                  } }]);


                return PictureTag;
              }(htmltag);
              /* harmony default export */var picturetag = picturetag_PictureTag;
              // CONCATENATED MODULE: ./src/tags/videotag.js
              function videotag_typeof(obj) {"@babel/helpers - typeof";return videotag_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, videotag_typeof(obj);}

              function videotag_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function videotag_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function videotag_createClass(Constructor, protoProps, staticProps) {if (protoProps) videotag_defineProperties(Constructor.prototype, protoProps);if (staticProps) videotag_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              function videotag_get() {if (typeof Reflect !== "undefined" && Reflect.get) {videotag_get = Reflect.get.bind();} else {videotag_get = function _get(target, property, receiver) {var base = videotag_superPropBase(target, property);if (!base) return;var desc = Object.getOwnPropertyDescriptor(base, property);if (desc.get) {return desc.get.call(arguments.length < 3 ? target : receiver);}return desc.value;};}return videotag_get.apply(this, arguments);}

              function videotag_superPropBase(object, property) {while (!Object.prototype.hasOwnProperty.call(object, property)) {object = videotag_getPrototypeOf(object);if (object === null) break;}return object;}

              function videotag_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) videotag_setPrototypeOf(subClass, superClass);}

              function videotag_setPrototypeOf(o, p) {videotag_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return videotag_setPrototypeOf(o, p);}

              function videotag_createSuper(Derived) {var hasNativeReflectConstruct = videotag_isNativeReflectConstruct();return function _createSuperInternal() {var Super = videotag_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = videotag_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return videotag_possibleConstructorReturn(this, result);};}

              function videotag_possibleConstructorReturn(self, call) {if (call && (videotag_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return videotag_assertThisInitialized(self);}

              function videotag_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

              function videotag_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

              function videotag_getPrototypeOf(o) {videotag_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return videotag_getPrototypeOf(o);}

              /**
               * Video Tag
               * Depends on 'tags/htmltag', 'util', 'cloudinary'
               */




              var VIDEO_TAG_PARAMS = ['source_types', 'source_transformation', 'fallback_content', 'poster', 'sources'];
              var videotag_DEFAULT_VIDEO_SOURCE_TYPES = ['webm', 'mp4', 'ogv'];
              var videotag_DEFAULT_POSTER_OPTIONS = {
                format: 'jpg',
                resource_type: 'video' };

              /**
               * Creates an HTML (DOM) Video tag using Cloudinary as the source.
               * @constructor VideoTag
               * @extends HtmlTag
               * @param {string} [publicId]
               * @param {Object} [options]
               */

              var videotag_VideoTag = /*#__PURE__*/function (_HtmlTag) {
                videotag_inherits(VideoTag, _HtmlTag);

                var _super = videotag_createSuper(VideoTag);

                function VideoTag(publicId) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                  videotag_classCallCheck(this, VideoTag);

                  options = defaults({}, options, DEFAULT_VIDEO_PARAMS);
                  return _super.call(this, "video", publicId.replace(/\.(mp4|ogv|webm)$/, ''), options);
                }
                /**
                 * Set the transformation to apply on each source
                 * @function VideoTag#setSourceTransformation
                 * @param {Object} an object with pairs of source type and source transformation
                 * @returns {VideoTag} Returns this instance for chaining purposes.
                 */


                videotag_createClass(VideoTag, [{
                  key: "setSourceTransformation",
                  value: function setSourceTransformation(value) {
                    this.transformation().sourceTransformation(value);
                    return this;
                  }
                  /**
                   * Set the source types to include in the video tag
                   * @function VideoTag#setSourceTypes
                   * @param {Array<string>} an array of source types
                   * @returns {VideoTag} Returns this instance for chaining purposes.
                   */ },

                {
                  key: "setSourceTypes",
                  value: function setSourceTypes(value) {
                    this.transformation().sourceTypes(value);
                    return this;
                  }
                  /**
                   * Set the poster to be used in the video tag
                   * @function VideoTag#setPoster
                   * @param {string|Object} value
                   * - string: a URL to use for the poster
                   * - Object: transformation parameters to apply to the poster. May optionally include a public_id to use instead of the video public_id.
                   * @returns {VideoTag} Returns this instance for chaining purposes.
                   */ },

                {
                  key: "setPoster",
                  value: function setPoster(value) {
                    this.transformation().poster(value);
                    return this;
                  }
                  /**
                   * Set the content to use as fallback in the video tag
                   * @function VideoTag#setFallbackContent
                   * @param {string} value - the content to use, in HTML format
                   * @returns {VideoTag} Returns this instance for chaining purposes.
                   */ },

                {
                  key: "setFallbackContent",
                  value: function setFallbackContent(value) {
                    this.transformation().fallbackContent(value);
                    return this;
                  } },
                {
                  key: "content",
                  value: function content() {
                    var _this = this;

                    var sourceTypes = this.transformation().getValue('source_types');
                    var sourceTransformation = this.transformation().getValue('source_transformation');
                    var fallback = this.transformation().getValue('fallback_content');
                    var sources = this.getOption('sources');
                    var innerTags = [];

                    if (isArray_root_isArray_default()(sources) && !isEmpty(sources)) {
                      innerTags = sources.map(function (source) {
                        var src = url_url(_this.publicId, defaults({}, source.transformations || {}, {
                          resource_type: 'video',
                          format: source.type }),
                        _this.getOptions());
                        return _this.createSourceTag(src, source.type, source.codecs);
                      });
                    } else {
                      if (isEmpty(sourceTypes)) {
                        sourceTypes = videotag_DEFAULT_VIDEO_SOURCE_TYPES;
                      }

                      if (isArray_root_isArray_default()(sourceTypes)) {
                        innerTags = sourceTypes.map(function (srcType) {
                          var src = url_url(_this.publicId, defaults({}, sourceTransformation[srcType] || {}, {
                            resource_type: 'video',
                            format: srcType }),
                          _this.getOptions());
                          return _this.createSourceTag(src, srcType);
                        });
                      }
                    }

                    return innerTags.join('') + fallback;
                  } },
                {
                  key: "attributes",
                  value: function attributes() {
                    var sourceTypes = this.getOption('source_types');
                    var poster = this.getOption('poster');

                    if (poster === undefined) {
                      poster = {};
                    }

                    if (isPlainObject_root_isPlainObject_default()(poster)) {
                      var defaultOptions = poster.public_id != null ? DEFAULT_IMAGE_PARAMS : videotag_DEFAULT_POSTER_OPTIONS;
                      poster = url_url(poster.public_id || this.publicId, defaults({}, poster, defaultOptions, this.getOptions()));
                    }

                    var attr = videotag_get(videotag_getPrototypeOf(VideoTag.prototype), "attributes", this).call(this) || {};
                    attr = omit(attr, VIDEO_TAG_PARAMS);
                    var sources = this.getOption('sources'); // In case of empty sourceTypes - fallback to default source types is used.

                    var hasSourceTags = !isEmpty(sources) || isEmpty(sourceTypes) || isArray_root_isArray_default()(sourceTypes);

                    if (!hasSourceTags) {
                      attr["src"] = url_url(this.publicId, this.getOptions(), {
                        resource_type: 'video',
                        format: sourceTypes });

                    }

                    if (poster != null) {
                      attr["poster"] = poster;
                    }

                    return attr;
                  } },
                {
                  key: "createSourceTag",
                  value: function createSourceTag(src, sourceType) {
                    var codecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    var mimeType = null;

                    if (!isEmpty(sourceType)) {
                      var videoType = sourceType === 'ogv' ? 'ogg' : sourceType;
                      mimeType = 'video/' + videoType;

                      if (!isEmpty(codecs)) {
                        var codecsStr = isArray_root_isArray_default()(codecs) ? codecs.join(', ') : codecs;
                        mimeType += '; codecs=' + codecsStr;
                      }
                    }

                    return "<source " + this.htmlAttrs({
                      src: src,
                      type: mimeType }) +
                    ">";
                  } }]);


                return VideoTag;
              }(htmltag);

              /* harmony default export */var videotag = videotag_VideoTag;
              // CONCATENATED MODULE: ./src/tags/clienthintsmetatag.js
              function clienthintsmetatag_typeof(obj) {"@babel/helpers - typeof";return clienthintsmetatag_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, clienthintsmetatag_typeof(obj);}

              function clienthintsmetatag_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function clienthintsmetatag_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function clienthintsmetatag_createClass(Constructor, protoProps, staticProps) {if (protoProps) clienthintsmetatag_defineProperties(Constructor.prototype, protoProps);if (staticProps) clienthintsmetatag_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

              function clienthintsmetatag_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) clienthintsmetatag_setPrototypeOf(subClass, superClass);}

              function clienthintsmetatag_setPrototypeOf(o, p) {clienthintsmetatag_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return clienthintsmetatag_setPrototypeOf(o, p);}

              function clienthintsmetatag_createSuper(Derived) {var hasNativeReflectConstruct = clienthintsmetatag_isNativeReflectConstruct();return function _createSuperInternal() {var Super = clienthintsmetatag_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = clienthintsmetatag_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return clienthintsmetatag_possibleConstructorReturn(this, result);};}

              function clienthintsmetatag_possibleConstructorReturn(self, call) {if (call && (clienthintsmetatag_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return clienthintsmetatag_assertThisInitialized(self);}

              function clienthintsmetatag_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}

              function clienthintsmetatag_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

              function clienthintsmetatag_getPrototypeOf(o) {clienthintsmetatag_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return clienthintsmetatag_getPrototypeOf(o);}

              /**
               * Image Tag
               * Depends on 'tags/htmltag', 'cloudinary'
               */


              /**
               * Creates an HTML (DOM) Meta tag that enables Client-Hints for the HTML page. <br/>
               *  See
               *  <a href="https://cloudinary.com/documentation/responsive_images#automating_responsive_images_with_client_hints"
               *  target="_new">Automating responsive images with Client Hints</a> for more details.
               * @constructor ClientHintsMetaTag
               * @extends HtmlTag
               * @param {object} options
               * @example
               * tag = new ClientHintsMetaTag()
               * //returns: <meta http-equiv="Accept-CH" content="DPR, Viewport-Width, Width">
               */

              var clienthintsmetatag_ClientHintsMetaTag = /*#__PURE__*/function (_HtmlTag) {
                clienthintsmetatag_inherits(ClientHintsMetaTag, _HtmlTag);

                var _super = clienthintsmetatag_createSuper(ClientHintsMetaTag);

                function ClientHintsMetaTag(options) {
                  clienthintsmetatag_classCallCheck(this, ClientHintsMetaTag);

                  return _super.call(this, 'meta', void 0, assign_root_assign_default()({
                    "http-equiv": "Accept-CH",
                    content: "DPR, Viewport-Width, Width" },
                  options));
                }
                /** @override */


                clienthintsmetatag_createClass(ClientHintsMetaTag, [{
                  key: "closeTag",
                  value: function closeTag() {
                    return "";
                  } }]);


                return ClientHintsMetaTag;
              }(htmltag);
              /* harmony default export */var clienthintsmetatag = clienthintsmetatag_ClientHintsMetaTag;
              // CONCATENATED MODULE: ./src/util/parse/normalizeToArray.js
              function normalizeToArray_toConsumableArray(arr) {return normalizeToArray_arrayWithoutHoles(arr) || normalizeToArray_iterableToArray(arr) || normalizeToArray_unsupportedIterableToArray(arr) || normalizeToArray_nonIterableSpread();}

              function normalizeToArray_nonIterableSpread() {throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}

              function normalizeToArray_unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return normalizeToArray_arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return normalizeToArray_arrayLikeToArray(o, minLen);}

              function normalizeToArray_iterableToArray(iter) {if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);}

              function normalizeToArray_arrayWithoutHoles(arr) {if (Array.isArray(arr)) return normalizeToArray_arrayLikeToArray(arr);}

              function normalizeToArray_arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}


              /**
               * @desc normalize elements, support a single element, array or nodelist, always outputs array
               * @param elements<HTMLElement[]>
               * @returns {[]}
               */

              function normalizeToArray(elements) {
                if (isArray_root_isArray_default()(elements)) {
                  return elements;
                } else if (elements.constructor.name === "NodeList") {
                  return normalizeToArray_toConsumableArray(elements); // ensure an array is always returned, even if nodelist
                } else if (isString_root_isString_default()(elements)) {
                  return Array.prototype.slice.call(document.querySelectorAll(elements), 0);
                } else {
                  return [elements];
                }
              }
              // CONCATENATED MODULE: ./src/util/features/transparentVideo/mountCloudinaryVideoTag.js
              /**
               * @param {HTMLElement} htmlElContainer
               * @param {object} clInstance cloudinary instance
               * @param {string} publicId
               * @param {object} options - TransformationOptions
               * @returns Promise<HTMLElement>
               */
              function mountCloudinaryVideoTag(htmlElContainer, clInstance, publicId, options) {
                return new Promise(function (resolve, reject) {
                  htmlElContainer.innerHTML = clInstance.videoTag(publicId, options).toHtml(); // All videos under the html container must have a width of 100%, or they might overflow from the container

                  var cloudinaryVideoElement = htmlElContainer.querySelector('.cld-transparent-video');
                  cloudinaryVideoElement.style.width = '100%';
                  resolve(htmlElContainer);
                });
              }

              /* harmony default export */var transparentVideo_mountCloudinaryVideoTag = mountCloudinaryVideoTag;
              // CONCATENATED MODULE: ./src/util/transformations/addFlag.js
              /**
               * @description - Function will push a flag to incoming options
               * @param {{transformation} | {...transformation}} options - These options are the same options provided to all our SDK methods
               *                           We expect options to either be the transformation itself, or an object containing
               *                           an array of transformations
               *
               * @param {string} flag
               * @returns the mutated options object
               */
              function addFlagToOptions(options, flag) {
                // Do we have transformation
                if (options.transformation) {
                  options.transformation.push({
                    flags: [flag] });

                } else {
                  // no transformation
                  // ensure the flags are extended
                  if (!options.flags) {
                    options.flags = [];
                  }

                  if (typeof options.flags === 'string') {
                    options.flags = [options.flags];
                  }

                  options.flags.push(flag);
                }
              }

              /* harmony default export */var addFlag = addFlagToOptions;
              // CONCATENATED MODULE: ./src/util/features/transparentVideo/enforceOptionsForTransparentVideo.js


              /**
               * @description - Enforce option structure, sets defaults and ensures alpha flag exists
               * @param options {TransformationOptions}
               */

              function enforceOptionsForTransparentVideo(options) {
                options.autoplay = true;
                options.muted = true;
                options.controls = false;
                options.max_timeout_ms = options.max_timeout_ms || DEFAULT_TIMEOUT_MS;
                options["class"] = options["class"] || '';
                options["class"] += ' cld-transparent-video';
                options.externalLibraries = options.externalLibraries || {};

                if (!options.externalLibraries.seeThru) {
                  options.externalLibraries.seeThru = DEFAULT_EXTERNAL_LIBRARIES.seeThru;
                } // ensure there's an alpha transformation present
                // this is a non documented internal flag


                addFlag(options, 'alpha');
              }

              /* harmony default export */var transparentVideo_enforceOptionsForTransparentVideo = enforceOptionsForTransparentVideo;
              // CONCATENATED MODULE: ./src/util/xhr/loadScript.js
              /**
               * @description - Given a string URL, this function will load the script and resolve the promise.
               *                The function doesn't resolve any value,
               *                this is not a UMD loader where you can get your library name back.
               * @param scriptURL {string}
               * @param {number} max_timeout_ms - Time to elapse before promise is rejected
               * @param isAlreadyLoaded {boolean} if true, the loadScript resolves immediately
               *                                  this is used for multiple invocations - prevents the script from being loaded multiple times
               * @return {Promise<any | {status:string, message:string}>}
               */
              function loadScript(scriptURL, max_timeout_ms, isAlreadyLoaded) {
                return new Promise(function (resolve, reject) {
                  if (isAlreadyLoaded) {
                    resolve();
                  } else {
                    var scriptTag = document.createElement('script');
                    scriptTag.src = scriptURL;
                    var timerID = setTimeout(function () {
                      reject({
                        status: 'error',
                        message: "Timeout loading script ".concat(scriptURL) });

                    }, max_timeout_ms); // 10 seconds for timeout

                    scriptTag.onerror = function () {
                      clearTimeout(timerID); // clear timeout reject error

                      reject({
                        status: 'error',
                        message: "Error loading ".concat(scriptURL) });

                    };

                    scriptTag.onload = function () {
                      clearTimeout(timerID); // clear timeout reject error

                      resolve();
                    };

                    document.head.appendChild(scriptTag);
                  }
                });
              }

              /* harmony default export */var xhr_loadScript = loadScript;
              // CONCATENATED MODULE: ./src/util/xhr/getBlobFromURL.js
              /**
               * Reject on timeout
               * @param maxTimeoutMS
               * @param reject
               * @returns {number} timerID
               */
              function rejectOnTimeout(maxTimeoutMS, reject) {
                return setTimeout(function () {
                  reject({
                    status: 'error',
                    message: 'Timeout loading Blob URL' });

                }, maxTimeoutMS);
              }
              /**
               * @description Converts a URL to a BLOB URL
               * @param {string} urlToLoad
               * @param {number} max_timeout_ms - Time to elapse before promise is rejected
               * @return {Promise<{
               *   status: 'success' | 'error'
               *   message?: string,
               *    payload: {
               *      url: string
               *    }
               * }>}
               */


              function getBlobFromURL(urlToLoad, maxTimeoutMS) {
                return new Promise(function (resolve, reject) {
                  var timerID = rejectOnTimeout(maxTimeoutMS, reject); // If fetch exists, use it to fetch blob, otherwise use XHR.
                  // XHR causes issues on safari 14.1 so we prefer fetch

                  var fetchBlob = typeof fetch !== 'undefined' && fetch ? loadUrlUsingFetch : loadUrlUsingXhr;
                  fetchBlob(urlToLoad).then(function (blob) {
                    resolve({
                      status: 'success',
                      payload: {
                        blobURL: URL.createObjectURL(blob) } });


                  })["catch"](function () {
                    reject({
                      status: 'error',
                      message: 'Error loading Blob URL' });

                  })["finally"](function () {
                    // Clear the timeout timer on fail or success.
                    clearTimeout(timerID);
                  });
                });
              }
              /**
               * Use fetch function to fetch file
               * @param urlToLoad
               * @returns {Promise<unknown>}
               */


              function loadUrlUsingFetch(urlToLoad) {
                return new Promise(function (resolve, reject) {
                  fetch(urlToLoad).then(function (response) {
                    response.blob().then(function (blob) {
                      resolve(blob);
                    });
                  })["catch"](function () {
                    reject('error');
                  });
                });
              }
              /**
               * Use XHR to fetch file
               * @param urlToLoad
               * @returns {Promise<unknown>}
               */


              function loadUrlUsingXhr(urlToLoad) {
                return new Promise(function (resolve, reject) {
                  var xhr = new XMLHttpRequest();
                  xhr.responseType = 'blob';

                  xhr.onload = function (response) {
                    resolve(xhr.response);
                  };

                  xhr.onerror = function () {
                    reject('error');
                  };

                  xhr.open('GET', urlToLoad, true);
                  xhr.send();
                });
              }

              /* harmony default export */var xhr_getBlobFromURL = getBlobFromURL;
              // CONCATENATED MODULE: ./src/util/features/transparentVideo/createHiddenVideoTag.js
              /**
               * @description Creates a hidden HTMLVideoElement with the specified videoOptions
               * @param {{autoplay, playsinline, loop, muted, poster, blobURL, videoURL }} videoOptions
               * @param {boolean} videoOptions.autoplay - autoplays the video if true
               * @param {string} videoOptions.blobURL - the blobURL to set as video.src
               * @param {string} videoOptions.videoURL - the original videoURL the user created (with transformations)
               * @return {HTMLVideoElement}
               */
              function createHiddenVideoTag(videoOptions) {
                var autoplay = videoOptions.autoplay,
                playsinline = videoOptions.playsinline,
                loop = videoOptions.loop,
                muted = videoOptions.muted,
                poster = videoOptions.poster,
                blobURL = videoOptions.blobURL,
                videoURL = videoOptions.videoURL;
                var el = document.createElement('video');
                el.style.visibility = 'hidden';
                el.position = 'absolute';
                el.x = 0;
                el.y = 0;
                el.src = blobURL;
                el.setAttribute('data-video-url', videoURL); // for debugging/testing

                autoplay && el.setAttribute('autoplay', autoplay);
                playsinline && el.setAttribute('playsinline', playsinline);
                loop && el.setAttribute('loop', loop);
                muted && el.setAttribute('muted', muted);
                muted && (el.muted = muted); // this is also needed for autoplay, on top of setAttribute

                poster && el.setAttribute('poster', poster); // Free memory at the end of the file loading.

                el.onload = function () {
                  URL.revokeObjectURL(blobURL);
                };

                return el;
              }

              /* harmony default export */var transparentVideo_createHiddenVideoTag = createHiddenVideoTag;
              // CONCATENATED MODULE: ./src/util/features/transparentVideo/instantiateSeeThru.js
              /**
               * @description This function creates a new instanc eof seeThru (seeThru.create()) and returns a promise of the seeThru instance
               * @param {HTMLVideoElement} videoElement
               * @param {number} max_timeout_ms - Time to elapse before promise is rejected
               * @param {string} customClass - A classname to be added to the canvas element created by seeThru
               * @param {boolean} autoPlay
               * @return {Promise<any>} SeeThru instance or rejection error
               */
              function instantiateSeeThru(videoElement, max_timeout_ms, customClass, autoPlay) {
                var _window = window,
                seeThru = _window.seeThru,
                setTimeout = _window.setTimeout,
                clearTimeout = _window.clearTimeout;
                return new Promise(function (resolve, reject) {
                  var timerID = setTimeout(function () {
                    reject({
                      status: 'error',
                      message: 'Timeout instantiating seeThru instance' });

                  }, max_timeout_ms);

                  if (seeThru) {
                    var seeThruInstance = seeThru.create(videoElement).ready(function () {
                      // clear timeout reject error
                      clearTimeout(timerID); // force container width, else the canvas can overflow out

                      var canvasElement = seeThruInstance.getCanvas();
                      canvasElement.style.width = '100%';
                      canvasElement.className += ' ' + customClass; // start the video if autoplay is set

                      if (autoPlay) {
                        seeThruInstance.play();
                      }

                      resolve(seeThruInstance);
                    });
                  } else {
                    reject({
                      status: 'error',
                      message: 'Error instantiating seeThru instance' });

                  }
                });
              }

              /* harmony default export */var transparentVideo_instantiateSeeThru = instantiateSeeThru;
              // CONCATENATED MODULE: ./src/util/features/transparentVideo/mountSeeThruCanvasTag.js




              /**
               *
               * @param {HTMLElement} htmlElContainer
               * @param {string} videoURL
               * @param {TransformationOptions} options
               * @return {Promise<any>}
               */

              function mountSeeThruCanvasTag(htmlElContainer, videoURL, options) {
                var poster = options.poster,
                autoplay = options.autoplay,
                playsinline = options.playsinline,
                loop = options.loop,
                muted = options.muted;
                videoURL = videoURL + '.mp4'; // seeThru always uses mp4

                return new Promise(function (resolve, reject) {
                  xhr_loadScript(options.externalLibraries.seeThru, options.max_timeout_ms, window.seeThru).then(function () {
                    xhr_getBlobFromURL(videoURL, options.max_timeout_ms).then(function (_ref) {
                      var payload = _ref.payload;
                      var videoElement = transparentVideo_createHiddenVideoTag({
                        blobURL: payload.blobURL,
                        videoURL: videoURL,
                        // for debugging/testing
                        poster: poster,
                        autoplay: autoplay,
                        playsinline: playsinline,
                        loop: loop,
                        muted: muted });

                      htmlElContainer.appendChild(videoElement);
                      transparentVideo_instantiateSeeThru(videoElement, options.max_timeout_ms, options["class"], options.autoplay).then(function () {
                        resolve(htmlElContainer);
                      })["catch"](function (err) {
                        reject(err);
                      }); // catch for getBlobFromURL()
                    })["catch"](function (_ref2) {
                      var status = _ref2.status,
                      message = _ref2.message;
                      reject({
                        status: status,
                        message: message });

                    }); // catch for loadScript()
                  })["catch"](function (_ref3) {
                    var status = _ref3.status,
                    message = _ref3.message;
                    reject({
                      status: status,
                      message: message });

                  });
                });
              }

              /* harmony default export */var transparentVideo_mountSeeThruCanvasTag = mountSeeThruCanvasTag;
              // CONCATENATED MODULE: ./src/util/features/transparentVideo/checkSupportForTransparency.js
              /**
               * @return {Promise<boolean>} - Whether the browser supports transparent videos or not
               */


              function checkSupportForTransparency() {
                return new Promise(function (resolve, reject) {
                  // Resolve early for safari.
                  // Currently (29 December 2021) Safari can play webm/vp9,
                  // but it does not support transparent video in the format we're outputting
                  if (isSafari()) {
                    resolve(false);
                  }

                  var video = document.createElement('video');
                  var canPlay = video.canPlayType && video.canPlayType('video/webm; codecs="vp9"');
                  resolve(canPlay === 'maybe' || canPlay === 'probably');
                });
              }

              /* harmony default export */var transparentVideo_checkSupportForTransparency = checkSupportForTransparency;
              // CONCATENATED MODULE: ./src/cloudinary.js
              function cloudinary_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

              function cloudinary_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}

              function cloudinary_createClass(Constructor, protoProps, staticProps) {if (protoProps) cloudinary_defineProperties(Constructor.prototype, protoProps);if (staticProps) cloudinary_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}


              var applyBreakpoints, closestAbove, defaultBreakpoints, cloudinary_findContainerWidth, cloudinary_maxWidth, updateDpr;









              //






              defaultBreakpoints = function defaultBreakpoints(width) {
                var steps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
                return steps * Math.ceil(width / steps);
              };

              closestAbove = function closestAbove(list, value) {
                var i;
                i = list.length - 2;

                while (i >= 0 && list[i] >= value) {
                  i--;
                }

                return list[i + 1];
              };

              applyBreakpoints = function applyBreakpoints(tag, width, steps, options) {
                var ref, ref1, ref2, responsive_use_breakpoints;
                responsive_use_breakpoints = (ref = (ref1 = (ref2 = options['responsive_use_breakpoints']) != null ? ref2 : options['responsive_use_stoppoints']) != null ? ref1 : this.config('responsive_use_breakpoints')) != null ? ref : this.config('responsive_use_stoppoints');

                if (!responsive_use_breakpoints || responsive_use_breakpoints === 'resize' && !options.resizing) {
                  return width;
                } else {
                  return this.calc_breakpoint(tag, width, steps);
                }
              };

              cloudinary_findContainerWidth = function findContainerWidth(element) {
                var containerWidth, style;
                containerWidth = 0;

                while ((element = element != null ? element.parentNode : void 0) instanceof Element && !containerWidth) {
                  style = window.getComputedStyle(element);

                  if (!/^inline/.test(style.display)) {
                    containerWidth = lodash_width(element);
                  }
                }

                return containerWidth;
              };

              updateDpr = function updateDpr(dataSrc, roundDpr) {
                return dataSrc.replace(/\bdpr_(1\.0|auto)\b/g, 'dpr_' + this.device_pixel_ratio(roundDpr));
              };

              cloudinary_maxWidth = function maxWidth(requiredWidth, tag) {
                var imageWidth;
                imageWidth = lodash_getData(tag, 'width') || 0;

                if (requiredWidth > imageWidth) {
                  imageWidth = requiredWidth;
                  lodash_setData(tag, 'width', requiredWidth);
                }

                return imageWidth;
              };

              var cloudinary_Cloudinary = /*#__PURE__*/function () {
                /**
                 * Creates a new Cloudinary instance.
                 * @class Cloudinary
                 * @classdesc Main class for accessing Cloudinary functionality.
                 * @param {Object} options - A {@link Configuration} object for globally configuring Cloudinary account settings.
                 * @example<br/>
                 *  var cl = new cloudinary.Cloudinary( { cloud_name: "mycloud"});<br/>
                 *  var imgTag = cl.image("myPicID");
                 * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters" target="_blank">
                 *  Available configuration options</a>
                 */
                function Cloudinary(options) {
                  cloudinary_classCallCheck(this, Cloudinary);

                  var configuration;
                  this.devicePixelRatioCache = {};
                  this.responsiveConfig = {};
                  this.responsiveResizeInitialized = false;
                  configuration = new src_configuration(options); // Provided for backward compatibility

                  this.config = function (newConfig, newValue) {
                    return configuration.config(newConfig, newValue);
                  };
                  /**
                   * Use \<meta\> tags in the document to configure this `cloudinary` instance.
                   * @return This {Cloudinary} instance for chaining.
                   */


                  this.fromDocument = function () {
                    configuration.fromDocument();
                    return this;
                  };
                  /**
                   * Use environment variables to configure this `cloudinary` instance.
                   * @return This {Cloudinary} instance for chaining.
                   */


                  this.fromEnvironment = function () {
                    configuration.fromEnvironment();
                    return this;
                  };
                  /**
                   * Initializes the configuration of this `cloudinary` instance.
                   *  This is a convenience method that invokes both {@link Configuration#fromEnvironment|fromEnvironment()}
                   *  (Node.js environment only) and {@link Configuration#fromDocument|fromDocument()}.
                   *  It first tries to retrieve the configuration from the environment variable.
                   *  If not available, it tries from the document meta tags.
                   * @function Cloudinary#init
                   * @see Configuration#init
                   * @return This {Cloudinary} instance for chaining.
                   */


                  this.init = function () {
                    configuration.init();
                    return this;
                  };
                }
                /**
                 * Convenience constructor
                 * @param {Object} options
                 * @return {Cloudinary}
                 * @example cl = cloudinary.Cloudinary.new( { cloud_name: "mycloud"})
                 */


                cloudinary_createClass(Cloudinary, [{
                  key: "url",
                  value:
                  /**
                   * Generates a URL for any asset in your Media library.
                   * @function Cloudinary#url
                   * @param {string} publicId - The public ID of the media asset.
                   * @param {Object} [options] - The {@link Transformation} parameters to include in the URL.
                   * @param {type} [options.type='upload'] - The asset's storage type.
                   *  For details on all fetch types, see
                   * <a href="https://cloudinary.com/documentation/image_transformations#fetching_images_from_remote_locations"
                   *  target="_blank">Fetch types</a>.
                   * @param {resourceType} [options.resource_type='image'] - The type of asset. Possible values:<br/>
                   *  - `image`<br/>
                   *  - `video`<br/>
                   *  - `raw`
                   * @return {string} The media asset URL.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                   *  Available video transformations</a>
                   */
                  function url(publicId) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    return url_url(publicId, options, this.config());
                  }
                  /**
                   * Generates a video asset URL.
                   * @function Cloudinary#video_url
                   * @param {string} publicId - The public ID of the video.
                   * @param {Object} [options] - The {@link Transformation} parameters to include in the URL.
                   * @param {type} [options.type='upload'] - The asset's storage type.
                   *  For details on all fetch types, see
                   *  <a href="https://cloudinary.com/documentation/image_transformations#fetching_images_from_remote_locations"
                   *  target="_blank">Fetch types</a>.
                   * @return {string} The video URL.
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference"
                   *  target="_blank">Available video transformations</a>
                   */ },

                {
                  key: "video_url",
                  value: function video_url(publicId, options) {
                    options = assign_root_assign_default()({
                      resource_type: 'video' },
                    options);
                    return this.url(publicId, options);
                  }
                  /**
                   * Generates a URL for an image intended to be used as a thumbnail for the specified video.
                   *  Identical to {@link Cloudinary#url|url}, except that the `resource_type` is `video`
                   *  and the default `format` is `jpg`.
                   * @function Cloudinary#video_thumbnail_url
                   * @param {string} publicId -  The unique identifier of the video from which you want to generate a thumbnail image.
                   * @param {Object} [options] - The image {@link Transformation} parameters to apply to the thumbnail.
                   * In addition to standard image transformations, you can also use the `start_offset` transformation parameter
                   * to instruct Cloudinary to generate the thumbnail from a frame other than the middle frame of the video.
                   * For details, see
                   * <a href="https://cloudinary.com/documentation/video_manipulation_and_delivery#generating_video_thumbnails"
                   * target="_blank">Generating video thumbnails</a> in the Cloudinary documentation.
                   * @param {type} [options.type='upload'] - The asset's storage type.
                   * @return {string} The URL of the video thumbnail image.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   */ },

                {
                  key: "video_thumbnail_url",
                  value: function video_thumbnail_url(publicId, options) {
                    options = assign_root_assign_default()({}, DEFAULT_POSTER_OPTIONS, options);
                    return this.url(publicId, options);
                  }
                  /**
                   * Generates a string representation of the specified transformation options.
                   * @function Cloudinary#transformation_string
                   * @param {Object} options - The {@link Transformation} options.
                   * @returns {string} The transformation string.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                   *  Available video transformations</a>
                   */ },

                {
                  key: "transformation_string",
                  value: function transformation_string(options) {
                    return new src_transformation(options).serialize();
                  }
                  /**
                   * Generates an image tag.
                   * @function Cloudinary#image
                   * @param {string} publicId - The public ID of the image.
                   * @param {Object} options - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag DOM element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */ },

                {
                  key: "image",
                  value: function image(publicId) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var client_hints, img, ref;
                    img = this.imageTag(publicId, options);
                    client_hints = (ref = options.client_hints != null ? options.client_hints : this.config('client_hints')) != null ? ref : false;

                    if (options.src == null && !client_hints) {
                      // src must be removed before creating the DOM element to avoid loading the image
                      img.setAttr("src", '');
                    }

                    img = img.toDOM();

                    if (!client_hints) {
                      // cache the image src
                      lodash_setData(img, 'src-cache', this.url(publicId, options)); // set image src taking responsiveness in account

                      this.cloudinary_update(img, options);
                    }

                    return img;
                  }
                  /**
                   * Creates a new ImageTag instance using the configuration defined for this `cloudinary` instance.
                   * @function Cloudinary#imageTag
                   * @param {string} publicId - The public ID of the image.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {ImageTag} An ImageTag instance that is attached (chained) to this Cloudinary instance.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */ },

                {
                  key: "imageTag",
                  value: function imageTag(publicId, options) {
                    var tag;
                    tag = new imagetag(publicId, this.config());
                    tag.transformation().fromOptions(options);
                    return tag;
                  }
                  /**
                   * Creates a new PictureTag instance, configured using this `cloudinary` instance.
                   * @function Cloudinary#PictureTag
                   * @param {string} publicId - the public ID of the resource
                   * @param {Object} options - additional options to pass to the new ImageTag instance
                   * @param {Array<Object>} sources - the sources definitions
                   * @return {PictureTag} A PictureTag that is attached (chained) to this Cloudinary instance
                   */ },

                {
                  key: "pictureTag",
                  value: function pictureTag(publicId, options, sources) {
                    var tag;
                    tag = new picturetag(publicId, this.config(), sources);
                    tag.transformation().fromOptions(options);
                    return tag;
                  }
                  /**
                   * Creates a new SourceTag instance, configured using this `cloudinary` instance.
                   * @function Cloudinary#SourceTag
                   * @param {string} publicId - the public ID of the resource.
                   * @param {Object} options - additional options to pass to the new instance.
                   * @return {SourceTag} A SourceTag that is attached (chained) to this Cloudinary instance
                   */ },

                {
                  key: "sourceTag",
                  value: function sourceTag(publicId, options) {
                    var tag;
                    tag = new sourcetag(publicId, this.config());
                    tag.transformation().fromOptions(options);
                    return tag;
                  }
                  /**
                   * Generates a video thumbnail URL from the specified remote video and includes it in an image tag.
                   * @function Cloudinary#video_thumbnail
                   * @param {string} publicId - The unique identifier of the video from the relevant video site.
                   *  Additionally, either append the image extension type to the identifier value or set
                   *  the image delivery format in the 'options' parameter using the 'format' transformation option.
                   *  For example, a YouTube video might have the identifier: 'o-urnlaJpOA.jpg'.
                   * @param {Object} [options] - The {@link Transformation} parameters to apply.
                   * @return {HTMLImageElement} An HTML image tag element
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                   *  Available video transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */ },

                {
                  key: "video_thumbnail",
                  value: function video_thumbnail(publicId, options) {
                    return this.image(publicId, merge_root_merge_default()({}, DEFAULT_POSTER_OPTIONS, options));
                  }
                  /**
                   * Fetches a facebook profile image and delivers it in an image tag element.
                   * @function Cloudinary#facebook_profile_image
                   * @param {string} publicId - The Facebook numeric ID. Additionally, either append the image extension type
                   *  to the ID or set the image delivery format in the 'options' parameter using the 'format' transformation option.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */ },

                {
                  key: "facebook_profile_image",
                  value: function facebook_profile_image(publicId, options) {
                    return this.image(publicId, assign_root_assign_default()({
                      type: 'facebook' },
                    options));
                  }
                  /**
                   * Fetches a Twitter profile image by ID and delivers it in an image tag element.
                   * @function Cloudinary#twitter_profile_image
                   * @param {string} publicId - The Twitter numeric ID. Additionally, either append the image extension type
                   *  to the ID or set the image delivery format in the 'options' parameter using the 'format' transformation option.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */ },

                {
                  key: "twitter_profile_image",
                  value: function twitter_profile_image(publicId, options) {
                    return this.image(publicId, assign_root_assign_default()({
                      type: 'twitter' },
                    options));
                  }
                  /**
                   * Fetches a Twitter profile image by name and delivers it in an image tag element.
                   * @function Cloudinary#twitter_name_profile_image
                   * @param {string} publicId - The Twitter screen name. Additionally, either append the image extension type
                   *  to the screen name or set the image delivery format in the 'options' parameter using the 'format' transformation option.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */ },

                {
                  key: "twitter_name_profile_image",
                  value: function twitter_name_profile_image(publicId, options) {
                    return this.image(publicId, assign_root_assign_default()({
                      type: 'twitter_name' },
                    options));
                  }
                  /**
                   * Fetches a Gravatar profile image and delivers it in an image tag element.
                   * @function Cloudinary#gravatar_image
                   * @param {string} publicId - The calculated hash for the Gravatar email address.
                   *  Additionally, either append the image extension type to the screen name or set the image delivery format
                   *  in the 'options' parameter using the 'format' transformation option.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */ },

                {
                  key: "gravatar_image",
                  value: function gravatar_image(publicId, options) {
                    return this.image(publicId, assign_root_assign_default()({
                      type: 'gravatar' },
                    options));
                  }
                  /**
                   * Fetches an image from a remote URL and delivers it in an image tag element.
                   * @function Cloudinary#fetch_image
                   * @param {string} publicId - The full URL of the image to fetch, including the extension.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */ },

                {
                  key: "fetch_image",
                  value: function fetch_image(publicId, options) {
                    return this.image(publicId, assign_root_assign_default()({
                      type: 'fetch' },
                    options));
                  }
                  /**
                   * Generates a video tag.
                   * @function Cloudinary#video
                   * @param {string} publicId - The public ID of the video.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLVideoElement} A video tag DOM element.
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                   *  Available video transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */ },

                {
                  key: "video",
                  value: function video(publicId) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    return this.videoTag(publicId, options).toHtml();
                  }
                  /**
                   * Creates a new VideoTag instance using the configuration defined for this `cloudinary` instance.
                   * @function Cloudinary#videoTag
                   * @param {string} publicId - The public ID of the video.
                   * @param {Object} options - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {VideoTag} A VideoTag that is attached (chained) to this `cloudinary` instance.
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                   *  Available video transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */ },

                {
                  key: "videoTag",
                  value: function videoTag(publicId, options) {
                    options = defaults({}, options, this.config());
                    return new videotag(publicId, options);
                  }
                  /**
                   * Generates a sprite PNG image that contains all images with the specified tag and the corresponding css file.
                   * @function Cloudinary#sprite_css
                   * @param {string} publicId - The tag on which to base the sprite image.
                   * @param {Object} [options] - The {@link Transformation} parameters to include in the URL.
                   * @return {string} The URL of the generated CSS file. The sprite image has the same URL, but with a PNG extension.
                   * @see <a href="https://cloudinary.com/documentation/sprite_generation" target="_blank">
                   *  Sprite generation</a>
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   */ },

                {
                  key: "sprite_css",
                  value: function sprite_css(publicId, options) {
                    options = assign_root_assign_default()({
                      type: 'sprite' },
                    options);

                    if (!publicId.match(/.css$/)) {
                      options.format = 'css';
                    }

                    return this.url(publicId, options);
                  }
                  /**
                   * Initializes responsive image behavior for all image tags with the 'cld-responsive'
                   *  (or other defined {@link Cloudinary#responsive|responsive} class).<br/>
                   *  This method should be invoked after the page has loaded.<br/>
                   *  <b>Note</b>: Calls {@link Cloudinary#cloudinary_update|cloudinary_update} to modify image tags.
                   * @function Cloudinary#responsive
                   * @param {Object} options
                   * @param {String} [options.responsive_class='cld-responsive'] - An alternative class
                   *  to locate the relevant &lt;img&gt; tags.
                   * @param {number} [options.responsive_debounce=100] - The debounce interval in milliseconds.
                   * @param {boolean} [bootstrap=true] If true, processes the &lt;img&gt; tags by calling
                   *  {@link Cloudinary#cloudinary_update|cloudinary_update}. When false, the tags are processed
                   *  only after a resize event.
                   * @see {@link Cloudinary#cloudinary_update|cloudinary_update} for additional configuration parameters
                   * @see <a href="https://cloudinary.com/documentation/responsive_images#automating_responsive_images_with_javascript"
                   *  target="_blank">Automating responsive images with JavaScript</a>
                   * @return {function} that when called, removes the resize EventListener added by this function
                   */ },

                {
                  key: "responsive",
                  value: function responsive(options) {
                    var _this = this;

                    var bootstrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var ref, ref1, ref2, responsiveClass, responsiveResize, timeout;
                    this.responsiveConfig = merge_root_merge_default()(this.responsiveConfig || {}, options);
                    responsiveClass = (ref = this.responsiveConfig.responsive_class) != null ? ref : this.config('responsive_class');

                    if (bootstrap) {
                      this.cloudinary_update("img.".concat(responsiveClass, ", img.cld-hidpi"), this.responsiveConfig);
                    }

                    responsiveResize = (ref1 = (ref2 = this.responsiveConfig.responsive_resize) != null ? ref2 : this.config('responsive_resize')) != null ? ref1 : true;

                    if (responsiveResize && !this.responsiveResizeInitialized) {
                      this.responsiveConfig.resizing = this.responsiveResizeInitialized = true;
                      timeout = null;

                      var makeResponsive = function makeResponsive() {
                        var debounce, ref3, ref4, reset, run, wait, waitFunc;
                        debounce = (ref3 = (ref4 = _this.responsiveConfig.responsive_debounce) != null ? ref4 : _this.config('responsive_debounce')) != null ? ref3 : 100;

                        reset = function reset() {
                          if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                          }
                        };

                        run = function run() {
                          return _this.cloudinary_update("img.".concat(responsiveClass), _this.responsiveConfig);
                        };

                        waitFunc = function waitFunc() {
                          reset();
                          return run();
                        };

                        wait = function wait() {
                          reset();
                          timeout = setTimeout(waitFunc, debounce);
                        };

                        if (debounce) {
                          return wait();
                        } else {
                          return run();
                        }
                      };

                      window.addEventListener('resize', makeResponsive);
                      return function () {
                        return window.removeEventListener('resize', makeResponsive);
                      };
                    }
                  }
                  /**
                   * @function Cloudinary#calc_breakpoint
                   * @private
                   * @ignore
                   */ },

                {
                  key: "calc_breakpoint",
                  value: function calc_breakpoint(element, width, steps) {
                    var breakpoints = lodash_getData(element, 'breakpoints') || lodash_getData(element, 'stoppoints') || this.config('breakpoints') || this.config('stoppoints') || defaultBreakpoints;

                    if (isFunction_root_isFunction_default()(breakpoints)) {
                      return breakpoints(width, steps);
                    } else {
                      if (isString_root_isString_default()(breakpoints)) {
                        breakpoints = breakpoints.split(',').map(function (point) {
                          return parseInt(point);
                        }).sort(function (a, b) {
                          return a - b;
                        });
                      }

                      return closestAbove(breakpoints, width);
                    }
                  }
                  /**
                   * @function Cloudinary#calc_stoppoint
                   * @deprecated Use {@link calc_breakpoint} instead.
                   * @private
                   * @ignore
                   */ },

                {
                  key: "calc_stoppoint",
                  value: function calc_stoppoint(element, width, steps) {
                    return this.calc_breakpoint(element, width, steps);
                  }
                  /**
                   * @function Cloudinary#device_pixel_ratio
                   * @private
                   */ },

                {
                  key: "device_pixel_ratio",
                  value: function device_pixel_ratio(roundDpr) {
                    roundDpr = roundDpr == null ? true : roundDpr;
                    var dpr = (typeof window !== "undefined" && window !== null ? window.devicePixelRatio : void 0) || 1;

                    if (roundDpr) {
                      dpr = Math.ceil(dpr);
                    }

                    if (dpr <= 0 || dpr === 0 / 0) {
                      dpr = 1;
                    }

                    var dprString = dpr.toString();

                    if (dprString.match(/^\d+$/)) {
                      dprString += '.0';
                    }

                    return dprString;
                  }
                  /**
                  * Applies responsiveness to all <code>&lt;img&gt;</code> tags under each relevant node
                  *  (regardless of whether the tag contains the {@link Cloudinary#responsive|responsive} class).
                  * @param {Element[]} nodes The parent nodes where you want to search for &lt;img&gt; tags.
                  * @param {Object} [options] The {@link Cloudinary#cloudinary_update|cloudinary_update} options to apply.
                  * @see <a href="https://cloudinary.com/documentation/image_transformation_reference"
                  *  target="_blank">Available image transformations</a>
                  * @function Cloudinary#processImageTags
                  */ },

                {
                  key: "processImageTags",
                  value: function processImageTags(nodes, options) {
                    if (isEmpty(nodes)) {
                      // similar to `$.fn.cloudinary`
                      return this;
                    }

                    options = defaults({}, options || {}, this.config());
                    var images = nodes.filter(function (node) {
                      return /^img$/i.test(node.tagName);
                    }).map(function (node) {
                      var imgOptions = assign_root_assign_default()({
                        width: node.getAttribute('width'),
                        height: node.getAttribute('height'),
                        src: node.getAttribute('src') },
                      options);
                      var publicId = imgOptions['source'] || imgOptions['src'];
                      delete imgOptions['source'];
                      delete imgOptions['src'];
                      var attr = new src_transformation(imgOptions).toHtmlAttributes();
                      lodash_setData(node, 'src-cache', url_url(publicId, imgOptions));
                      node.setAttribute('width', attr.width);
                      node.setAttribute('height', attr.height);
                      return node;
                    });
                    this.cloudinary_update(images, options);
                    return this;
                  }
                  /**
                  * Updates the dpr (for `dpr_auto`) and responsive (for `w_auto`) fields according to
                  *  the current container size and the device pixel ratio.<br/>
                  *  <b>Note</b>:`w_auto` is updated only for images marked with the `cld-responsive`
                  *  (or other defined {@link Cloudinary#responsive|responsive}) class.
                  * @function Cloudinary#cloudinary_update
                  * @param {(Array|string|NodeList)} elements - The HTML image elements to modify.
                  * @param {Object} options
                  * @param {boolean|string} [options.responsive_use_breakpoints=true]
                  * Possible values:<br/>
                  *  - `true`: Always use breakpoints for width.<br/>
                  *  - `resize`: Use exact width on first render and breakpoints on resize.<br/>
                  *  - `false`: Always use exact width.
                  * @param {boolean} [options.responsive] - If `true`, enable responsive on all specified elements.
                  *  Alternatively, you can define specific HTML elements to modify by adding the `cld-responsive`
                  *  (or other custom-defined {@link Cloudinary#responsive|responsive_class}) class to those elements.
                  * @param {boolean} [options.responsive_preserve_height] - If `true`, original css height is preserved.
                  *  Should be used only if the transformation supports different aspect ratios.
                  */ },

                {
                  key: "cloudinary_update",
                  value: function cloudinary_update(elements, options) {
                    var _this2 = this;

                    var containerWidth, dataSrc, match, requiredWidth;

                    if (elements === null) {
                      return this;
                    }

                    if (options == null) {
                      options = {};
                    }

                    var responsive = options.responsive != null ? options.responsive : this.config('responsive');
                    elements = normalizeToArray(elements);
                    var responsiveClass;

                    if (this.responsiveConfig && this.responsiveConfig.responsive_class != null) {
                      responsiveClass = this.responsiveConfig.responsive_class;
                    } else if (options.responsive_class != null) {
                      responsiveClass = options.responsive_class;
                    } else {
                      responsiveClass = this.config('responsive_class');
                    }

                    var roundDpr = options.round_dpr != null ? options.round_dpr : this.config('round_dpr');
                    elements.forEach(function (tag) {
                      if (/img/i.test(tag.tagName)) {
                        var setUrl = true;

                        if (responsive) {
                          lodash_addClass(tag, responsiveClass);
                        }

                        dataSrc = lodash_getData(tag, 'src-cache') || lodash_getData(tag, 'src');

                        if (!isEmpty(dataSrc)) {
                          // Update dpr according to the device's devicePixelRatio
                          dataSrc = updateDpr.call(_this2, dataSrc, roundDpr);

                          if (htmltag.isResponsive(tag, responsiveClass)) {
                            containerWidth = cloudinary_findContainerWidth(tag);

                            if (containerWidth !== 0) {
                              if (/w_auto:breakpoints/.test(dataSrc)) {
                                requiredWidth = cloudinary_maxWidth(containerWidth, tag);

                                if (requiredWidth) {
                                  dataSrc = dataSrc.replace(/w_auto:breakpoints([_0-9]*)(:[0-9]+)?/, "w_auto:breakpoints$1:".concat(requiredWidth));
                                } else {
                                  setUrl = false;
                                }
                              } else {
                                match = /w_auto(:(\d+))?/.exec(dataSrc);

                                if (match) {
                                  requiredWidth = applyBreakpoints.call(_this2, tag, containerWidth, match[2], options);
                                  requiredWidth = cloudinary_maxWidth(requiredWidth, tag);

                                  if (requiredWidth) {
                                    dataSrc = dataSrc.replace(/w_auto[^,\/]*/g, "w_".concat(requiredWidth));
                                  } else {
                                    setUrl = false;
                                  }
                                }
                              }

                              lodash_removeAttribute(tag, 'width');

                              if (!options.responsive_preserve_height) {
                                lodash_removeAttribute(tag, 'height');
                              }
                            } else {
                              // Container doesn't know the size yet - usually because the image is hidden or outside the DOM.
                              setUrl = false;
                            }
                          }

                          var isLazyLoading = options.loading === 'lazy' && !_this2.isNativeLazyLoadSupported() && _this2.isLazyLoadSupported() && !elements[0].getAttribute('src');

                          if (setUrl || isLazyLoading) {
                            // If data-width exists, set width to be data-width
                            _this2.setAttributeIfExists(elements[0], 'width', 'data-width');
                          }

                          if (setUrl && !isLazyLoading) {
                            lodash_setAttribute(tag, 'src', dataSrc);
                          }
                        }
                      }
                    });
                    return this;
                  }
                  /**
                   * Sets element[toAttribute] = element[fromAttribute] if element[fromAttribute] is set
                   * @param element
                   * @param toAttribute
                   * @param fromAttribute
                   */ },

                {
                  key: "setAttributeIfExists",
                  value: function setAttributeIfExists(element, toAttribute, fromAttribute) {
                    var attributeValue = element.getAttribute(fromAttribute);

                    if (attributeValue != null) {
                      lodash_setAttribute(element, toAttribute, attributeValue);
                    }
                  }
                  /**
                   * Returns true if Intersection Observer API is supported
                   * @returns {boolean}
                   */ },

                {
                  key: "isLazyLoadSupported",
                  value: function isLazyLoadSupported() {
                    return window && 'IntersectionObserver' in window;
                  }
                  /**
                   * Returns true if using Chrome
                   * @returns {boolean}
                   */ },

                {
                  key: "isNativeLazyLoadSupported",
                  value: function isNativeLazyLoadSupported() {
                    return 'loading' in HTMLImageElement.prototype;
                  }
                  /**
                   * Returns a {@link Transformation} object, initialized with the specified options, for chaining purposes.
                   * @function Cloudinary#transformation
                   * @param {Object} options The {@link Transformation} options to apply.
                   * @return {Transformation}
                   * @see Transformation
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                   *  Available video transformations</a>
                   */ },

                {
                  key: "transformation",
                  value: function transformation(options) {
                    return src_transformation["new"](this.config()).fromOptions(options).setParent(this);
                  }
                  /**
                   * @description This function will append a TransparentVideo element to the htmlElContainer passed to it.
                   *              TransparentVideo can either be an HTML Video tag, or an HTML Canvas Tag.
                   * @param {HTMLElement} htmlElContainer
                   * @param {string} publicId
                   * @param {object} options The {@link TransparentVideoOptions} options to apply - Extends TransformationOptions
                   *                 options.playsinline    - HTML Video Tag's native playsinline - passed to video element.
                   *                 options.poster         - HTML Video Tag's native poster - passed to video element.
                   *                 options.loop           - HTML Video Tag's native loop - passed to video element.
                   *                 options?.externalLibraries = { [key: string]: string} - map of external libraries to be loaded
                   * @return {Promise<HTMLElement | {status:string, message:string}>}
                   */ },

                {
                  key: "injectTransparentVideoElement",
                  value: function injectTransparentVideoElement(htmlElContainer, publicId) {
                    var _this3 = this;

                    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    return new Promise(function (resolve, reject) {
                      if (!htmlElContainer) {
                        reject({
                          status: 'error',
                          message: 'Expecting htmlElContainer to be HTMLElement' });

                      }

                      transparentVideo_enforceOptionsForTransparentVideo(options);

                      var videoURL = _this3.video_url(publicId, options);

                      transparentVideo_checkSupportForTransparency().then(function (isNativelyTransparent) {
                        var mountPromise;

                        if (isNativelyTransparent) {
                          mountPromise = transparentVideo_mountCloudinaryVideoTag(htmlElContainer, _this3, publicId, options);
                          resolve(htmlElContainer);
                        } else {
                          mountPromise = transparentVideo_mountSeeThruCanvasTag(htmlElContainer, videoURL, options);
                        }

                        mountPromise.then(function () {
                          resolve(htmlElContainer);
                        })["catch"](function (_ref) {
                          var status = _ref.status,
                          message = _ref.message;
                          reject({
                            status: status,
                            message: message });

                        }); // catch for checkSupportForTransparency()
                      })["catch"](function (_ref2) {
                        var status = _ref2.status,
                        message = _ref2.message;
                        reject({
                          status: status,
                          message: message });

                      });
                    });
                  } }],
                [{
                  key: "new",
                  value: function _new(options) {
                    return new this(options);
                  } }]);


                return Cloudinary;
              }();

              assign_root_assign_default()(cloudinary_Cloudinary, constants_namespaceObject);
              /* harmony default export */var cloudinary = cloudinary_Cloudinary;
              // CONCATENATED MODULE: ./src/namespace/cloudinary-core.js
              /**
               * Creates the namespace for Cloudinary
               */

















              /* harmony default export */__webpack_exports__["default"] = {
                ClientHintsMetaTag: clienthintsmetatag,
                Cloudinary: cloudinary,
                Condition: condition,
                Configuration: src_configuration,
                crc32: src_crc32,
                Expression: expression,
                FetchLayer: fetchlayer,
                HtmlTag: htmltag,
                ImageTag: imagetag,
                Layer: layer_layer,
                PictureTag: picturetag,
                SubtitlesLayer: subtitleslayer,
                TextLayer: textlayer,
                Transformation: src_transformation,
                utf8_encode: src_utf8_encode,
                Util: lodash_namespaceObject,
                VideoTag: videotag };



              /***/},

            /***/"lodash/assign":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_assign__;

              /***/},

            /***/"lodash/cloneDeep":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_cloneDeep__;

              /***/},

            /***/"lodash/compact":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_compact__;

              /***/},

            /***/"lodash/difference":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_difference__;

              /***/},

            /***/"lodash/functions":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_functions__;

              /***/},

            /***/"lodash/identity":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_identity__;

              /***/},

            /***/"lodash/includes":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_includes__;

              /***/},

            /***/"lodash/isArray":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isArray__;

              /***/},

            /***/"lodash/isElement":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isElement__;

              /***/},

            /***/"lodash/isFunction":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isFunction__;

              /***/},

            /***/"lodash/isPlainObject":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isPlainObject__;

              /***/},

            /***/"lodash/isString":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isString__;

              /***/},

            /***/"lodash/merge":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_merge__;

              /***/},

            /***/"lodash/trim":
            /***/function (module, exports) {

              module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_trim__;

              /***/}

            /******/ }));
      });

    })(cloudinaryCore);

    var createUploadWidget = function (options, callback) {
      if ((window === null || window === void 0 ? void 0 : window.cloudinary) === undefined) {
        throw new Error('Cloudinary is not instantiated on window.');
      }
      return window.cloudinary.createUploadWidget(options, callback);
    };

    var CloudinaryUploadWidget = function (_a) {
      var onFileUpload = _a.onFileUpload,text = _a.text,widgetOptions = __rest(_a, ["onFileUpload", "text"]);
      var isLoaded = useHtmlScript('https://widget.cloudinary.com/v2.0/global/all.js').isLoaded;
      var widget = React.useMemo(function () {
        return isLoaded ?
        createUploadWidget(__assign(__assign({}, widgetOptions), { sources: ['local'] }), function (error, result) {
          var _a, _b, _c;
          if (!error && (result === null || result === void 0 ? void 0 : result.event) === 'success') {
            onFileUpload({
              publicId: (_a = result === null || result === void 0 ? void 0 : result.info) === null || _a === void 0 ? void 0 : _a.public_id,
              url: (_b = result === null || result === void 0 ? void 0 : result.info) === null || _b === void 0 ? void 0 : _b.url,
              original_filename: (_c = result === null || result === void 0 ? void 0 : result.info) === null || _c === void 0 ? void 0 : _c.original_filename });

          }
        }) :
        undefined;
      }, [isLoaded, onFileUpload, widgetOptions]);
      var uploadFileWidget = function () {
        widget === null || widget === void 0 ? void 0 : widget.open();
      };
      return jsxRuntime.exports.jsx(Button, __assign({ onClick: uploadFileWidget, disabled: !isLoaded }, { children: text.uploadButton }));
    };

    var classes$1 = {"container":"awell__cloudinary_container","awell_cloudinary":"awell__cloudinary_awell_cloudinary","content":"awell__cloudinary_content","message_title":"awell__cloudinary_message_title","attachmentList":"awell__cloudinary_attachmentList","button_wrapper":"awell__cloudinary_button_wrapper"};

    var ActionKey;
    (function (ActionKey) {
      ActionKey["UPLOAD_FILES"] = "uploadFiles";
    })(ActionKey || (ActionKey = {}));

    var CloudinaryUpload = function (_a) {
      var cloudName = _a.cloudName,uploadPreset = _a.uploadPreset,folder = _a.folder,tags = _a.tags,context = _a.context,onFinish = _a.onFinish,text = _a.text;
      var showScrollHint = useScrollHint().showScrollHint;
      var _b = React.useState([]),uploadedFilesList = _b[0],setUploadedFilesList = _b[1];
      var attachments = React.useMemo(function () {
        return uploadedFilesList.map(function (_a, index) {
          var url = _a.url,original_filename = _a.original_filename;
          return {
            id: "url-".concat(index),
            url: url,
            type: exports.MessageAttachmentType.File,
            name: original_filename };

        });
      }, [uploadedFilesList]);
      var onImageUploadHandler = React.useCallback(function (data) {
        setUploadedFilesList(function (prevState) {return __spreadArray(__spreadArray([], prevState, true), [data], false);});
      }, []);
      var handleOnDone = React.useCallback(function () {
        onFinish(uploadedFilesList);
      }, [onFinish, uploadedFilesList]);
      return jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx("main", __assign({ id: "ahp_main_content_with_scroll_hint", className: classes$4.main_content }, { children: jsxRuntime.exports.jsxs("section", __assign({ className: "".concat(classes$1.awell_cloudinary, " ").concat(classes$1.container) }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: classes$1.message_title }, { children: text.subject })), jsxRuntime.exports.jsxs("div", __assign({ className: classes$1.content }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: "files" }, { children: jsxRuntime.exports.jsx("p", { children: text.fileCountHeader(uploadedFilesList === null || uploadedFilesList === void 0 ? void 0 : uploadedFilesList.length) }) })), !!attachments.length && jsxRuntime.exports.jsx("div", __assign({ className: classes$1.attachmentList }, { children: jsxRuntime.exports.jsx(AttachmentList, { attachments: attachments, icon: text.attachmentIcon, labels: text.attachmentLabels }) })), jsxRuntime.exports.jsx(CloudinaryUploadWidget, { cloudName: cloudName, uploadPreset: uploadPreset, folder: folder, tags: tags, context: context, onFileUpload: onImageUploadHandler, text: { uploadButton: text.buttonLabels.upload } })] }))] })) })), jsxRuntime.exports.jsx(HostedPageFooter, __assign({ showScrollHint: showScrollHint }, { children: jsxRuntime.exports.jsx("div", __assign({ className: "".concat(classes$1.button_wrapper, " ").concat(classes$1.container) }, { children: jsxRuntime.exports.jsx(Button, __assign({ "data-cy": "finishUpload", variant: "secondary", onClick: handleOnDone }, { children: text.buttonLabels.done })) })) }))] });
    };
    CloudinaryUpload.displayName = 'Cloudinary';

    var CloudinarySingleFileUpload = function (_a) {
      var cloudName = _a.cloudName,uploadPreset = _a.uploadPreset,folder = _a.folder,tags = _a.tags,context = _a.context,onFinish = _a.onFinish,text = _a.text;
      var showScrollHint = useScrollHint().showScrollHint;
      var _b = React.useState(undefined),uploadedFile = _b[0],setUploadedFile = _b[1];
      var attachments = React.useMemo(function () {return [
        {
          id: "url-".concat(uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.publicId),
          url: (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.url) || '',
          type: exports.MessageAttachmentType.File,
          name: (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.original_filename) || '' }];

      }, [uploadedFile]);
      var onImageUploadHandler = React.useCallback(function (data) {
        setUploadedFile(data);
      }, []);
      var handleOnDone = React.useCallback(function () {
        onFinish(uploadedFile);
      }, [onFinish, uploadedFile]);
      return jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx("main", __assign({ id: "ahp_main_content_with_scroll_hint", className: classes$4.main_content }, { children: jsxRuntime.exports.jsxs("section", __assign({ className: "".concat(classes$1.awell_cloudinary, " ").concat(classes$1.container) }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: classes$1.message_title }, { children: text.subject })), jsxRuntime.exports.jsxs("div", __assign({ className: classes$1.content }, { children: [jsxRuntime.exports.jsx("div", __assign({ className: "files" }, { children: jsxRuntime.exports.jsx("p", { children: text.fileCountHeader(uploadedFile !== undefined) }) })), uploadedFile && jsxRuntime.exports.jsx("div", __assign({ className: classes$1.attachmentList }, { children: jsxRuntime.exports.jsx(AttachmentList, { attachments: attachments, icon: text.attachmentIcon, labels: text.attachmentLabels }) })), !uploadedFile && jsxRuntime.exports.jsx(CloudinaryUploadWidget, { cloudName: cloudName, uploadPreset: uploadPreset, multiple: false, folder: folder, tags: tags, context: context, onFileUpload: onImageUploadHandler, text: { uploadButton: text.buttonLabels.upload } })] }))] })) })), jsxRuntime.exports.jsx(HostedPageFooter, __assign({ showScrollHint: showScrollHint }, { children: jsxRuntime.exports.jsx("div", __assign({ className: "".concat(classes$1.button_wrapper, " ").concat(classes$1.container) }, { children: jsxRuntime.exports.jsx(Button, __assign({ "data-cy": "finishUpload", variant: "secondary", onClick: handleOnDone }, { children: text.buttonLabels.done })) })) }))] });
    };
    CloudinarySingleFileUpload.displayName = 'CloudinarySingleFileUpload';

    var classes = {"close_button":"awell__CloseButton_close_button","close_button_svg":"awell__CloseButton_close_button_svg"};

    var CloseButton = function (_a) {
      var onClose = _a.onClose;
      return jsxRuntime.exports.jsx("button", __assign({ type: "button", onClick: onClose, className: classes.close_button, id: "awell_close_button" }, { children: jsxRuntime.exports.jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", className: classes.close_button_svg }, { children: jsxRuntime.exports.jsx("path", { d: "M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" }) })) }));
    };

    var HostedPageLayout = function (_a) {
      var children = _a.children,onCloseHostedPage = _a.onCloseHostedPage,logo = _a.logo,_b = _a.hideCloseButton,hideCloseButton = _b === void 0 ? false : _b;
      return jsxRuntime.exports.jsxs("div", __assign({ className: classes$4.layout_container }, { children: [!hideCloseButton && jsxRuntime.exports.jsx(CloseButton, { onClose: onCloseHostedPage }), jsxRuntime.exports.jsx("header", { children: jsxRuntime.exports.jsx(Navbar, { logo: logo }) }), children] }));
    };

    exports.AttachmentList = AttachmentList;
    exports.Button = Button;
    exports.CalDotComScheduling = CalDotComScheduling;
    exports.CheckboxButton = CheckboxButton;
    exports.Checklist = Checklist;
    exports.CircularSpinner = CircularSpinner;
    exports.CloseButton = CloseButton;
    exports.CloudinarySingleFileUpload = CloudinarySingleFileUpload;
    exports.CloudinaryUpload = CloudinaryUpload;
    exports.ConversationalForm = ConversationalForm;
    exports.DatePicker = DatePicker;
    exports.Description = Description;
    exports.ExternalLink = ExternalLink;
    exports.Heading5 = Heading5;
    exports.Heading6 = Heading6;
    exports.HeadingMain = HeadingMain;
    exports.HeadingSecondary = HeadingSecondary;
    exports.HeadingTertiary = HeadingTertiary;
    exports.HorizontalSpinner = HorizontalSpinner;
    exports.HostedPageLayout = HostedPageLayout;
    exports.InlineText = InlineText;
    exports.InnerText = InnerText;
    exports.InputField = InputField;
    exports.Logo = Logo;
    exports.LongTextField = LongTextField;
    exports.Message = Message;
    exports.Modal = Modal;
    exports.MultipleChoiceQuestion = MultipleChoiceQuestion;
    exports.Navbar = Navbar;
    exports.ProgressIndicator = ProgressIndicator;
    exports.Question = Question;
    exports.QuestionLabel = QuestionLabel;
    exports.RadioButton = RadioButton;
    exports.RangeInput = RangeInput;
    exports.RichTextViewer = RichTextViewer;
    exports.ScrollIndicator = ScrollIndicator;
    exports.SingleChoiceQuestion = SingleChoiceQuestion;
    exports.SubHeading = SubHeading;
    exports.Text = Text;
    exports.ThemeProvider = ThemeProvider;
    exports.TraditionalForm = TraditionalForm;
    exports.TypingCaret = TypingCaret;
    exports.WithTypingCaret = WithTypingCaret;
    exports.WizardForm = WizardForm;
    exports.isElement = isElement;
    exports.isText = isText;
    exports.useClickOutsideNotifier = useClickOutsideNotifier;
    exports.useConversationalForm = useConversationalForm;
    exports.useScrollHint = useScrollHint;
    exports.useTraditionalForm = useTraditionalForm;

    Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ })

}]);